export default {
    "en": {
      "ADD": "ADD",

      "AT": "Austria",

      "Ab": "From",

      "BE": "Belgium",

      "BG": "Bulgaria",

      "CH": "Switzerland",

      "CY": "Cyprus",

      "CZ": "Czechia",

      "Camera": "Camera",

      "DE": "Germany",

      "DK": "Denmark",

      "DL.button.text": "Scan your driver's license now",

      "DL.desr": "Get your driver's license confirmed by uploading it now.",

      "DL.issuecountry.placeholder": "Issuing country",

      "DL.paper.country.notvalid": "We only support paper licenses from Germany and Austria.\nPlease try again with a plastic license.",

      "DL.paper.date.notvalid": "Pink driving licenses in paper format for persons born after 1953 cannot be processed digitally. Please try a plastic format driver's license.",

      "DL.paper.stepFour": "Make sure the lighting is proper and take off everything that would hide your face (glasses, hat, etc.).",

      "DL.paper.stepOne": "Valid only if born before 1953.",

      "DL.paper.stepThree": "Take a picture from the front and the back of the license.",

      "DL.paper.stepTwo": "Put your licence fully opened on a surface which colour is different than the license.",

      "DL.stepFour": "Make sure the lighting is proper and take off everything that would hide your face (glasses, hat, etc.).",

      "DL.stepOne": "Have your original driver's license ready (not your ID!)",

      "DL.stepThree": "Place your driver's license on a neutral-colored background.",

      "DL.stepTwo": "Provisional and non-EU driving licenses are not accepted.",

      "DL.title": "Driving licence",

      "Did.you.mean": "Do you mean",

      "EE": "Estonia",

      "EL": "Greece",

      "ES": "Spain",

      "EUR": "€",

      "FI": "Finland",

      "FR": "France",

      "FRM_Franklin_Partner_Fix": "Franklin Partner Fix",

      "GB": "Great Britain",

      "GR": "Greece",

      "HR": "Croatia",

      "HU": "Hungary",

      "ID.button.text": "Scan identity document now",

      "ID.desr": "Choose which ID document you want to use.",

      "ID.id_card.stepFour": "Your ID card needs to be issued in an EU-country.",

      "ID.id_card.stepOne": "Have your original ID card ready (no copy!).",

      "ID.id_card.stepThree": "Make sure that the lighting is good and take off everything that covers your face (glasses, hat, etc.).",

      "ID.id_card.stepTwo": "Put your ID card on a surface that is distinctively different from the document.",

      "ID.manual.option": "I don't have a document with address",

      "ID.passport.stepOne": "Have your original passport ready (no copy!).",

      "ID.passport.stepThree": "Make sure the lighting is good and take off everything that covers your face (glasses, hat, etc.)",

      "ID.passport.stepTwo": "Put your passport on a surface that is distinctively different from the document.",

      "ID.stepOne": "I have an identity document (ID card, passport or resident permit) issued in the EU.",

      "ID.stepThree": "Pay attention to the lighting conditions so that your document is clearly recognizable. Also please remove anything that would obstruct the visibility of your face (hat, glasses, etc..)",

      "ID.stepTwo": "Place your Identity document on a neutral surface that is different in color from the card.",

      "ID.title": "Personal Identity Document",

      "ID.type.card": "Identity card or resident permit",

      "ID.type.label": "Choose document type ",

      "ID.type.passport": "Passport",

      "ID_CARD": "Identity Card",

      "IE": "Ireland",

      "IS": "Iceland",

      "IT": "Italy",

      "LI": "Liechtenstein",

      "LT": "Lithuania",

      "LU": "Luxembourg",

      "LV": "Latvia",

      "MC": "Monaco",

      "MR": "Mr.",

      "MRS": "Mrs.",

      "MT": "Malta",

      "NL": "Netherlands",

      "NO": "Norway",

      "Other": "Other",

      "PASSPORT": "Passport",

      "PL": "Poland",

      "PT": "Portugal",

      "RO": "Romania",

      "SE": "Sweden",

      "SI": "Slovenia",

      "SK": "Slovensky",

      "UK": "United Kingdom",

      "Uhr": "clock",

      "Update.email": "Update",

      "VISA": "Residence Permit",

      "about.dialog": "About GETAWAY",

      "about.url": "https://get-a-way.com/getaway-carsharing?utm_source=app",

      "accepted.invitation": "ACCEPTED INVITATIONS",

      "account-deposit.warning.btn": "Deposit amount",

      "account-deposit.warning.desc": "To activate your user account, please enter the refundable deposit now. <br><br>✓ will be refunded at the end of the contract<br> ✓ with deposit invoice as pdf<br> ✓ secure payment via PayPal, credit card and much more.",

      "account.deposit.description": "To activate your user account, please enter the refundable deposit now. ✓ will be refunded after the end of the contract ✓ with deposit invoice as pdf",

      "account.low.schufa.desc": "The activation of this payment method has failed. The credit check did not result in a match. Unfortunately, we are currently unable to offer you an alternative to complete your registration.\n\nPlease refrain from further attempts to register.",

      "account.org.pending.payment.note": "Payment under review. We’ll email you when there’s an update.",

      "account.payment.blocked.desc": "To activate this payment method, please settle all outstanding debts. If you have any questions, please contact our service team.",

      "account.sepaVerification.mismatch.dialog.message": "Your bank account %s will be replaced by %s.",

      "account.sepaVerification.mismatch.dialog.no": "Cancel",

      "account.sepaVerification.mismatch.dialog.title": "Update bank account?",

      "account.sepaVerification.mismatch.dialog.yes": "Update",

      "account.sepaVerification.warning.btn": "Confirm now",

      "account.sepaVerification.warning.desc": "To confirm this bank account, please complete the 1-euro verification.",

      "accountHolder": "Account holder",

      "action.permission.button.title": "New login",

      "action.permission.details": "We have received an error message and are already working on the solution. Please close the app now and restart it.\n\nIf the problem persists, please contact our Service Team.",

      "action.permission.title": "Something went wrong.",

      "action.permission.yes": "Yes",

      "add": "ADD",

      "add.car.enhancement.wizard.description": "Update your cars features in order to increase its desireability.",

      "add.car.enhancement.wizard.title": "Add your car's features",

      "add.damage.wizard.description": "Listing your current damages helps identify future damages and get imbursed.",

      "add.damage.wizard.footer": "I confirm that the list of damages is complete if anything changes I will update my car profile.",

      "add.damage.wizard.title": "List of damages",

      "add.damage.wizard.update": "APPLY",

      "add.damages.footnote": "If none of the options match, pls contact us by clicking the support icon at the top right.",

      "add.payment.method.success": "Thanks for adding a payment method.",

      "add.tariff": "Add tariff",

      "add.to.apple.calendar": "Add to Apple calendar",

      "add.to.calendar.title": "Calendar",

      "add.to.device.calendar": "Add to device calendar",

      "add.to.google.calendar": "Add to Google calendar",

      "add.to.outlook.calendar": "Add to Outlook calendar",

      "add.to.yahoo.calendar": "Add to Yahoo calendar",

      "addpayment.card.desc": "Add your credit card",

      "addpayment.card.title": "Visa or MasterCard",

      "addpayment.directdebit.desc": "Add Bank Account",

      "addpayment.paypal": "PayPal",

      "addpayment.paypal.desc": "Connect your PayPal account",

      "address": "Registered address",

      "address.austria.streetNum.label": "House/Building/Door",

      "address.required": "To continue, please add your address.",

      "address.unavailable": "Show pick-up zone",

      "addressCheck.dialog.message": "Your Address check was not successful.\n\nPlease contact our customer support.",

      "addressCheck.dialog.title": "Address check",

      "addressCheck.dialog.tryAgain": "TRY AGAIN",

      "addressCheck.dialog.yes": "OK",

      "addressProof.button.text": "Upload document",

      "addressProof.desr": "Get your address confirmed by uploading a document proof.",

      "addressProof.stepOne": "Utility bill, bank note ...",

      "addressProof.stepTwo": "Address and name visible",

      "addressProof.title": "Document with address",

      "addressSearch.cancel.text": "Cancel",

      "addressSearch.current.label": "My location",

      "addressSearch.search.placeholder": "Search address",

      "always.open": "open 24/7",

      "android.update.dialog.message": "There is a new version of our app available, please update to the latest version.",

      "android.update.dialog.no": "Later",

      "android.update.dialog.title": "Update available",

      "android.update.dialog.yes": "Update",

      "api_error.active_invite_not_found": "Invitation code not found or inactive",

      "api_error.block_payment_parameter_missing": "Payment failed. Please try again with an alternative payment method or later.",

      "api_error.block_payment_required": "Payment failed. Please try an alternative payment method or try again later.",

      "api_error.booking.combined_signup_not_allowed": "Signup is blocked",

      "api_error.booking.confirm.blocked_payment_failed": "Problem with blocked payment. Booking was not confirmed.",

      "api_error.booking.confirm.fleet_not_allowed_for_circle": "Car is not accessible from this circle",

      "api_error.booking.confirm.rental_type_not_matching": "Incorrect circle type used for this booking",

      "api_error.booking.payin.from": "Please chose a later starting time to continue",

      "api_error.booking.update.conflicting_booking_for_car": "Car has conflicting booking",

      "api_error.booking.update.conflicting_booking_for_user": "User has conflicting booking",

      "api_error.booking.update.conflicting_rental_for_car": "Car has conflicting rental",

      "api_error.booking.update.conflicting_rental_for_user": "User has conflicting rental",

      "api_error.booking.update.invalid_interval": "Booking extension impossible due to following booking.",

      "api_error.brand.sunset.bookings_restricted": "Bookings restricted because of brand shutdown",

      "api_error.brand.sunset.rentals_restricted": "Rentals restricted because of brand shutdown",

      "api_error.brand.sunset.user_profile_update_restricted": "User profile update restricted because of brand shutdown",

      "api_error.cantamen.invalid_password": "Authentication required: Please enter your current password that you use to log in to the (web) app.",

      "api_error.captcha-check-failed": "We couldn't proof you being a human. Please try again or contact support",

      "api_error.carUnavailable": "Selected car is unavailable for booking please choose another one",

      "api_error.email_code.no_more_attempts": "No more attempts",

      "api_error.invalid_tariff": "Tariff not allowed",

      "api_error.invitation.link_expired": "Invitation link expired or invitations limit exceeded",

      "api_error.invites_disabled_for_circle": "New invites disabled",

      "api_error.not_available": "Action not possible",

      "api_error.not_available_forPayin": "This action is not available for the active payment method",

      "api_error.org.duplicate": "Company with such register number is registered already.",

      "api_error.partners.new_registration.rejected": "Your current tariff does not allow tariff partners. Please contact support for existing customers for more information. We apologize for the inconvenience.",

      "api_error.partners.partners_limit_exceeded": "Max. number of tariff partners has been reached. Please contact support for further information.",

      "api_error.payin_notAllowed": "Please chose a later starting time to continue ",

      "api_error.payment.3ds_required": "Please verify your credit card (merchant \"GETAWAY\") to continue.",

      "api_error.payment.adyen_3ds_response_not_received": "payment provider took too long to respond, please try again",

      "api_error.payment.adyen_rejected_request": "Payment request was rejected",

      "api_error.payment.adyen_response_not_received": "Payment request timed out",

      "api_error.payment.card_validation_attempts_exceeded": "Verification of payment method failed, please contact support",

      "api_error.payment.card_validation_failed": "credit card validation failed",

      "api_error.payment.method_not_allowed": "Your active payment method is not supported in this country, please add a different one.",

      "api_error.payment.paypal_validation_attempts_exceeded": "Paypal validation failed",

      "api_error.payment.paypal_validation_failed": "Paypal validation failed and number of attempts exceeded - please contact customer service",

      "api_error.phoneNumber.isValid": "Entered phone no is not valid. Please enter a new one",

      "api_error.rental.update.cannot_reduce_back_by_if_pay_as_reserved": "Die Rückgabezeit kann nicht verkürzt werden, da die gesamte gebuchte Dauer berechnet wird.",

      "api_error.rental.update.invalid_back_by": "Incorrect return time",

      "api_error.ride.pooling.no_offer": "There are no vehicles near your location",

      "api_error.ride_pooling.no_offer": "There are no vehicles near your location",

      "api_error.ride_pooling.no_offer.has_ongoing_trip": "You have an ongoing trip",

      "api_error.ride_pooling.no_offer.no_seats": "There are no free seats",

      "api_error.ride_pooling.no_offer.resolved_same_stop_for_pickup_and_release": "Pickup and dropoff are identical",

      "api_error.ryd.digital_fuel.car_position_unknown": "The car cannot be located right now, so no station can be suggested.",

      "api_error.ryd.digital_fuel.not_enabled": "Digital refuelling is not available for this vehicle.",

      "api_error.ryd.digital_fuel.session_not_cancellable": "This refuelling can no longer be cancelled.",

      "api_error.ryd.digital_fuel.tank_full": "The tank is already full.",

      "api_error.ryd.digital_fuel.trip_not_started": "Refuelling is available once the car has been picked up.",

      "api_error.user.cw_address_missing": "Please enter your address to continue.",

      "api_error.user.email.change_not_allowed": "This email address can not be used.",

      "api_error.user.iban.duplicate": "This IBAN cannot be registered. It might already be in use. Contact support for further assistance.",

      "api_error.user.id_submission_attempts_exceeded": "No attempts left. Please contact our Service Team.",

      "api_error.user.identityMismatch": "Identity can’t be used for credit check",

      "api_error.user.identity_card_submission_attempts_exceeded": "Maximum number of attempts used up. Please contact support.",

      "api_error.user.invitation_link.max_invites_exceeded": "Number of seats exceeded for this invitation link",

      "api_error.user.invitation_link.wrong_booking_status": "Cannot join because reservation was started or cancelled already",

      "api_error.user.license_submission_attempts_exceeded": "No attempts left. Please contact our Service Team.",

      "api_error.user.password_reset.same_phone_used_in_multiple_accounts": "Cannot proceed because same phone number is used for multiple accounts.",

      "api_error.user.phone_verification.max_attempts": "No attempts left. Please contact our Service Team.",

      "api_error.user.redirectToWeb": "Please continue in your native web browser.",

      "api_error.user.schufaCheck.data_incomplete": "Data incomplete",

      "api_error.user.tariff_missing": "To continue registration, please first choose a Tariff.",

      "api_error.user.too_young": "There is currently no suitable plan available for your current age. Please try again as soon as you turn %s years old",

      "api_error.user.update.synced_with_merchant_system": "User account couldn't be updated. Please try again or contact support",

      "api_error.user.verificationCode.incorrectOrExpired": "Verification code incorrect or expired",

      "api_error.user_not_belong_to_circle_brand": "The user is not a member of the selected group brand",

      "app.old.dialog.description": "We've detected that you still have the old GETAWAY app installed on your device.\n\nPlease Click \"Uninstall\" to remove it.",

      "app.old.dialog.title": "Uninstall the old app",

      "app.privacy.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA-INT_dataprivacy-de.pdf",

      "app.terms.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA-INT_termsandconditions-de.pdf",

      "applink.error": "This link is not valid anymore. Please contact our service team for more information.",

      "apply": "APPLY",

      "area.6195052566acea0d11785b70.name": "Berlin (Neuenhagen)",

      "area.6293587021004a075975ed81.name": "Zhero (Mallorca)",

      "area.632abb191018da079a871065.name": "Berlin Brandenburg",

      "area.636fd246f563af071662cf6c.name": "Lustenau",

      "area.63f3b9000af72c0765aae927.name": "Mallorca (Lindner Hotel)",

      "area.63ff1dcac77ce8071d9dbac1.name": "Dornbirn (Kehlerstraße 6)",

      "area.644bc810935fbb07bb0b902a.name": "Bregenz (Lochau)",

      "area.6697be5570475106e9c17023.name": "Bregenz (Bahnhof)",

      "area.68fe520326116829219fddad.name": "IKEA Klagenfurt",

      "area.68fe520326116829219fddb0.name": "IKEA Innsbruck",

      "area.68fe520326116829219fddb4.name": "IKEA Vösendorf",

      "area.68fe520326116829219fddb7.name": "IKEA Graz",

      "area.68fe520326116829219fddba.name": "IKEA Haid",

      "area.68fe520326116829219fddbd.name": "IKEA Wien (Nord)",

      "area.68fe520326116829219fddc0.name": "Stationsbetrieb Buchbinder",

      "area.68fe520326116829219fddc3.name": "Station Wien (Modecenterstraße)",

      "area.68fe520326116829219fddc6.name": "IKEA Salzburg",

      "area.68fe520326116829219fddca.name": "IKEA Linz",

      "area.68fe520326116829219fddce.name": "IKEA CDC Strebersdorf",

      "area.68fe520326116829219fddd1.name": "IKEA Wiener Neustadt",

      "area.698b458181ab41790a6824ef.name": "OBI Wien (Hadikgasse)",

      "area.698c4d7c1ad7db155a40bd51.name": "Stationsbetrieb Wien (Flughafen)",

      "area.69b95ad89db4e3682c4f0bf7.name": "OBI Wien (Triester Straße)",

      "area.69b95bc89db4e3682c4f10b3.name": "OBI Wien (Haidhofstraße)",

      "area.69b961408393db4678aaa974.name": "OBI Vösendorf (Triester Straße)",

      "area.69e0f2dccb79244ac5c0d10c.name": "Stationsbetrieb Graz (Stadt)",

      "area.69ec8d8b611ea67412f119c6.name": "Transporter Wien (Modecenterstraße)",

      "area.69faec19cb07f61532b93d39.name": "Campingplatz (Berlin)",

      "area.69fb7e4ce24a290cbe584cf8.name": "IKEA Linz (Transporter)",

      "area.6a1ebd0cccaef87a77cd90f9.name": "IKEA Salzburg (Transporter)",

      "area.6a2023e639e0293c43b74e53.name": "IKEA CDC Strebersdorf (Transporter)",

      "area.6a26ce03940743260dc9b94d.name": "Innsbruck",

      "area.6a314e6b2a390664b74ab06c.name": "IKEA Klagenfurt (Transporter)",

      "area.6a7049c957fb440b9e358bef.name": "Innsbruck Flughafen (Transporter)",

      "area.6a7ed7d4eddc5114a270b468.name": "Innsbruck Flughafen",

      "area.brand_not_resolved": "Selected brand was not recognized",

      "area.card.info": "area info",

      "area.card.navigate": "Navigate",

      "area.fleet.brand.not_match": "Selected fleet is not belong to the selected brand",

      "area.fleet_not_resolved": "Selected fleet was not recognized",

      "area.label": "Return area",

      "area.label.outside": "Please mind the return area",

      "area.walkthrough.description": "To end the rental, return the vehicle to the return zone highlighted in color with at least 25% fuel remaining, and lock it using your cell phone.",

      "area.walkthrough.title": "Return and finish rental",

      "auth.failed.alert.body": "You've entered a wrong password. Please try again or click \"Forgot?\" to reset your password.",

      "auth.failed.alert.title": "Incorrect password",

      "backend.error": "Ups..something went wrong. Please try again later.",

      "balance": "Balance",

      "balance.addFunds": "Add Funds",

      "balance.addFunds.description": "Save money with the prepaid plans",

      "balance.addPaymentMethod": "Add payment method",

      "balance.delete.confirm": "Are you sure you want delete this payment method?",

      "balance.getFreeCredit": "Get credit for FREE",

      "balance.getFreeCredit.description": "Get free credit by completing some simple challenges.",

      "balance.invoice.failure": "Sorry, we are unable to send receipt.",

      "balance.invoice.success": "Your receipt will be emailed to you soon!",

      "balance.paymentMethods": "PAYMENT METHODS",

      "balance.payoutFunds": "Payout funds",

      "balance.payoutFunds.addSEPA.dialog.message": "Please enter your bank account details so we can payout your withdrawable balance.",

      "balance.payoutFunds.addSEPA.dialog.title": "Add payout method",

      "balance.payoutFunds.description": "Withdrawal balance",

      "balance.payoutFunds.dialog.message": "Withdrawable balance will be automatically paid out to your bank account at the end of the calendar month.",

      "balance.payoutFunds.dialog.title": "Payout funds",

      "balance.payoutFunds.error.message": "Funds are automatically paid to your account once a month.",

      "balance.send.invoice": "SEND\RECEIPT",

      "balance.transactions": "TRANSACTIONS",

      "bank.select.desr": "Enter your account details now for secure and convenient payments by direct debit.",

      "bank.select.header": "Please choose your bank account",

      "bank.select.title": "Store payment method",

      "bis": "until",

      "bluetooth.dialog.description": "Please enable Bluetooth to unlock the car and start your trip.",

      "bluetooth.dialog.title": "Enable Bluetooth®",

      "bluetooth.disabled.message": "Attention: Enable BlueTooth permission for the app to open and close vehicles.",

      "bluetooth.permission.allow.details": "Attention: Please give BlueTooth permission to the app to open/close vehicles.",

      "bluetooth.permission.allow.title": "Access Bluethooth",

      "bluetooth.permission.details": "Please open the control center by swiping up from the bottom of your screen and enable your bluetooth.",

      "bluetooth.permission.message": "Attention: Please give BlueTooth permission to the app to open/close vehicles.",

      "bluetooth.permission.title": "Enable Bluethooth®",

      "bluetooth.permission.yes": "Allow",

      "bonus.sheet.description.lowAndOut": "The fuel level of the vehicle must be at least 25% when it is returned.\n\nGet a € 5 instant bonus if you finish the rental in the vehicle's return area. Get another 5 € instant bonus if you refuel the vehicle.",

      "bonus.sheet.description.lowFuel": "The tank level of the vehicle must be at least 25% on return.\n\nReceive a €5 instant credit as a thank you when you fill up the vehicle. Payment is free of charge and cashless with the fuel card provided in the glove compartment.",

      "bonus.sheet.description.out&low": "The tank level of the vehicle must be at least 25% on return and the rental must end in the return zone\n\nReceive a €5 instant credit if you end the rental process in the vehicle's return zone.\n\nReceive a further €5 when you fill up the vehicle. Payment is free of charge and cashless with the fuel card provided in the glove compartment.",

      "bonus.sheet.description.outsideArea": "The rental must be terminated in the return zone.\n\nGet a 5€ instant bonus if you finish the rental in the vehicle's return area.",

      "bonus.sheet.ok": "Ok",

      "book.station.cta": "Find at station",

      "booking.1.available.cars": "1 vehicle still available at this price.",

      "booking.2.available.cars": "2 vehicles still available at this price.",

      "booking.BookedCarIsBLOCKED": "Vehicle was unavailable",

      "booking.BookedCarIsRELEASE_READY": "Vehicle was unavailable",

      "booking.BookedCarIsRENTED": "Vehicle was unavailable",

      "booking.BookedCarIsUnavailable": "Vehicle was unavailable",

      "booking.BookingCancelled": "Booking was cancelled",

      "booking.DriverHasOngoingRental": "Another rental was ongoing",

      "booking.OtherReason": "Technical issues",

      "booking.OtherRentalConstraintViolation": "Vehicle was unavailable",

      "booking.RentalCancelled": "Rental was cancelled",

      "booking.RentalExpired": "Rental was expired",

      "booking.accessToken": "Technical issues",

      "booking.add.to.calendar": "Add to calendar",

      "booking.added.to.calendar.success": "Added to calendar",

      "booking.additional.driver.action": "Additional driver",

      "booking.additional.driver.description": "Additional drivers must register via the invitation link following the reservation and be verified before the start of the rental. Novice drivers are not permitted.",

      "booking.additional.driver.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_additionalDriver.png",

      "booking.additional.driver.link.footnote.md": "Additional drivers must register via the invitation link and be verified before the start of the rental. Novice drivers are not permitted.",

      "booking.additional.driver.link.prefix": "Invitation link",

      "booking.additional.driver.link.share": "Share invitation link",

      "booking.additional.driver.price": "9€ + 2€/cal.day",

      "booking.additional.driver.section.title": "Additional driver",

      "booking.additional.driver.share.text": "Join booking %@",

      "booking.additional.driver.title": "Additional driver",

      "booking.backByConflictsWithBooking": "Technical issues",

      "booking.backByExpired": "Technical issues",

      "booking.blockedByUpcomingBooking": "Technical issues",

      "booking.blockedPaymentConfirmed": "Payment failed",

      "booking.button.text": "Show on map",

      "booking.cancel.fee.footnote": "Afterwards a cancellation fee of %s will occur. Die fee can be struck if you start a new reservation until %s.",

      "booking.cancellation.text": "✓ Cancellable free of charge until %s",

      "booking.cancelled": "Cancelled",

      "booking.cancelled.at": "Booking cancelled at %s",

      "booking.car.unavailable": "Car is not yet available",

      "booking.confirm.car.profile": "Vehicle",

      "booking.confirm.cost": "Initial cost",

      "booking.confirm.from": "From",

      "booking.confirm.payin.text": "Please transfer the deposit immediately after confirming the booking, a payment link will be generated after the booking is confirmed.\n\nHint: instead you can add a card payment in your profile by going to your user profile in the menu.",

      "booking.confirm.payin.title": "Deposit",

      "booking.confirm.profile": "Vehicle",

      "booking.confirm.profile.consent": "I understand that I must complete my registration before the scheduled start of the booking—otherwise, it will be canceled in accordance with the terms and conditions governing cancellations due to customer fault.",

      "booking.confirm.to": "To",

      "booking.confirmation.button": "Book for a fee",

      "booking.confirmation.title": "Check the reservation",

      "booking.conformation.no.address": "Display pick-up zone",

      "booking.consent.button": "Confirm reservation",

      "booking.consent.cancel": "Reject",

      "booking.consent.cancel.dialog.message": "If you reject the booking confirmation, the booking will be cancelled. The vehicle can then be booked by other users again.",

      "booking.consent.cancel.dialog.title": "Please confirm your choice.",

      "booking.consent.cancel.dialog.yes": "Reject & Cancel",

      "booking.consent.circle": "User Group",

      "booking.consent.later.dialog.message": "Please check and confirm your booking ahead of time. Otherwise it will automatically be cancelled.",

      "booking.consent.later.dialog.yes": "Ok",

      "booking.cost.footnote": "Additional fees may occur. See %s for more information.\n\nPlease note that in case of ending your planned trip early we may still charge you until the planned ending time of your reservation.",

      "booking.cost.footnote.url": "https://google.com",

      "booking.cost.footnote.url.text": "vehicle profile",

      "booking.cost.includedkm": "included mileage",

      "booking.cost.section": "Costs",

      "booking.create": "Find my GETAWAY",

      "booking.create.success": "Thanks! We've received your booking request. We'll search for your perfect GETAWAY.",

      "booking.created": "Created",

      "booking.date.fake.url": "https://googles.com",

      "booking.deposit.footnote": "An initial deposit of %s is due upon reservation. If the rental costs exceed the deposit, further deposit payments will be due. Please always ensure that you have sufficient cover.\n\nFollowing the rental process, the total deposit will be refunded after offsetting against the rental costs, subject to further possible claims.",

      "booking.deposit.section": "Initial deposit",

      "booking.deposit.title": "Deposit",

      "booking.desktop.start": "Start trip",

      "booking.details.header.descr": "From the scheduled start of the rental period, you start the rental process by unlocking the vehicle with your cell phone.",

      "booking.details.section.title": "Your reservation",

      "booking.driver.accepted.title": "enjoy your GETAWAY!",

      "booking.driver.add": "Driver",

      "booking.driver.cancel": "Cancel booking",

      "booking.driver.cancel.dialog.message": "Cancellation fees may apply.\n\nIf a deposit has been paid, this will be refunded immediately after any fees have been offset.",

      "booking.driver.cancel.dialog.title": "Cancel reservation",

      "booking.driver.cancel.dialog.yes": "Cancel now",

      "booking.driver.cancel.success": "Your reservation has been cancelled.",

      "booking.driver.confirm.dialog.message": "Good choice! With your confirmation, we'll reserve this lovely GETAWAY for you.",

      "booking.driver.confirm.dialog.title": "Reserve that GETAWAY",

      "booking.driver.confirm.dialog.yes": "Reserve now",

      "booking.driver.count.title": "Additional driver",

      "booking.driver.details.description": "As soon as we’ve the right car for you, we’ll contact you.",

      "booking.driver.details.header.description": "Please be lenient with this service. This feature is in testing mode. We look forward to your feedback.",

      "booking.driver.details.header.title": "Find your perfect GETAWAY! [BETA]",

      "booking.driver.details.text": "Pricing (incl. fuel) based on assumed duration and mileage. Final pricing is calculated pay-as-you-drive based on actual duration and mileage.",

      "booking.driver.details.title": "Your Reservation",

      "booking.driver.nooffers": "✨\nAvailable GETAWAYs \nwill be listed here soon.",

      "booking.driver.offer.choose": "Choose",

      "booking.driver.offer.request": "Request",

      "booking.driver.offer.reserve": "Reserve",

      "booking.driver.offer.reserving": "Reserving...",

      "booking.driver.offered.title": "choose your perfect GETAWAY!",

      "booking.driver.section": "Driver",

      "booking.driver.waitingoffer": "Waiting offer",

      "booking.early.start": "Start booking early",

      "booking.end": "Until",

      "booking.fee.fake.url": "https://google.com",

      "booking.fee.title": "Cancellation policy",

      "booking.fee.value": "25€",

      "booking.fix.cancellation.note": "No reimbursement of time-related costs (hourly, daily rates, etc.) in the event of cancellation.\n  \nYou have 30 minutes from the scheduled start of the rental period to start the rental process. After that, your reservation expires without replacement.",

      "booking.fix.option.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_besterPreis.png",

      "booking.flex.cancellation.note": "Cancellation before the scheduled start of the rental period on %s will be refunded. The fee for flexible booking is non-refundable.\n\nCancellations after this time will not be refunded.\n\nYou have up to 24 hours from the scheduled start of the rental period to start the rental process - but no later than the scheduled end of the rental period. After that, your reservation expires without replacement.",

      "booking.flex.option.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_flexibelBleiben.png",

      "booking.free.cancellation.text": "✓ Cancelable free of charge",

      "booking.fuelCardMissing": "Technical issues",

      "booking.guest.confirmation.button": "Signup now",

      "booking.haveBlockedPaymentIfPayInOnly": "A deposit using payment method PayIn must be paid before Rental.",

      "booking.header.in": "In",

      "booking.headline.expired": "Reservation has expired",

      "booking.headline.payment": "Payment data",

      "booking.headline.reservation": "reservation information",

      "booking.headline.started": "Reservation has started",

      "booking.insurance.SB500.popular": "Most chosen",

      "booking.insurance.desc": "In the event of damage, it can quickly become expensive. Limit your liability risk with a reduced excess.",

      "booking.insurance.title": "Reduce your risk",

      "booking.insurance.type": "Type",

      "booking.label.checked": "check-in finished",

      "booking.label.expired": "Expired",

      "booking.label.started": "Started",

      "booking.label.waiting.checkin": "check-in in progress",

      "booking.map.bar.text": "Your next reservation:",

      "booking.map.pre.signup": "Click here to finish your booking.",

      "booking.mileage.placeholder": "I don't know, yet",

      "booking.mileage.title": "Approx. mileage",

      "booking.online": "Technical issues",

      "booking.option.SB500.popular": "Most chosen",

      "booking.option.fix.price": "0€ (included)",

      "booking.option.fix.subtitle": "✓ No refund in the event of cancellation\n✓ Rental must start within 30 minutes of the scheduled start of the rental period",

      "booking.option.fix.title": "Best price",

      "booking.option.flex.price": "0,49 €/hour (4,90 €/cal.day)",

      "booking.option.flexBooking.popular": "Popular",

      "booking.option.flexBooking.subtitle": "✓ Can be canceled free of charge until the scheduled start of the rental period\n✓ 24 hours from scheduled start of rental (max. end of rental) to start rental",

      "booking.option.flexBooking.title": "Stay flexible",

      "booking.option.title": "Select the booking option",

      "booking.payByLink.description": "Complete your payment and return to your account settings.",

      "booking.payin.blockPayment.description": "With the reservation 300,-€ are requested via prepayment. If the rental costs exceed the deposit amount, further payments may be due. Please always ensure that you have sufficient funds.\n\nFollowing the rental process, the deposit will be released after offsetting against the rental costs, subject to further possible claims.",

      "booking.payin.blockPayment.title": "Deposit for advance payment",

      "booking.payin.blockPayment.yes.text": "Continue",

      "booking.payment": "payment method",

      "booking.payment.change": "Change payment method",

      "booking.payment.payIn.title": "Pre Payment",

      "booking.payment.section": "Payment data",

      "booking.places.current": "Current location",

      "booking.places.search": "Enter address",

      "booking.places.title": "From where",

      "booking.pre.signup.clear": "Clear",

      "booking.preferredcar.title": "Car",

      "booking.requestedCar.title": "Vehicle",

      "booking.section.details": "Details",

      "booking.section.timeline": "Timeline",

      "booking.start": "From",

      "booking.start.address": "From where",

      "booking.status": "Status",

      "booking.status.cancelled": "Cancelled",

      "booking.status.expired": "Expired",

      "booking.upsellings.SB500.popular": "Most chosen",

      "booking.userMarkedForFraud": "Payment failed",

      "booking.warning.payin.button": "Pay deposit now",

      "booking.warning.payin.text": "Please transfer the deposit immediately following the link, otherwise the booking will be automatically cancelled in the next 10 minutes.",

      "booking.warning.payin.text.payed": "You've successfully left the deposit. Please wait for your rental to start.",

      "booking.warning.payin.title": "Deposit",

      "booking.warning.payin.title.payed": "Deposit successfully paid",

      "booking.warning.payin.value": "150,00 Euro",

      "booking.warning.profile.button": "Complete profile",

      "booking.warning.profile.text": "⚠️ Please complete your profile before the scheduled booking start date—otherwise, the reservation will be canceled and the terms and conditions for cancellations due to customer fault will apply.",

      "booking.warning.profile.title": "Complete your profile",

      "booking.when": "When?",

      "bookings.headline.booked": "Booked",

      "bookings.headline.reservation": "Reserved",

      "bookings.profile.cancel.text": "Cancel Booking",

      "bookings.profile.title": "My Bookings",

      "bookings.where.desc": "The excact vehicle's location will be shared 30 min before the reservation starts.",

      "brand.bnd.name": "book-n-drive",

      "brand.getaway.name": "GETAWAY",

      "brand.mba.name": "Mietbar",

      "brand.mis.name": "Miet Smart",

      "brand.msi.name": "Miet Smart",

      "brand.rw.name": "Share die Robbe",

      "brand.ubq.name": "ubeeqo",

      "bubPassenger.Buchbinder.pricing.6a7de9e98a03e46ab9d01572": "|||\n| :------------- |------------:|\n|       |  **Stundenpreis**     |\n| Mo-Do    |   3,90 €    |\n| Fr-So      | 4,90 €     |\n\n\n||||\n| :------------- |-------------:|-------------:|\n|       | **Tag 1 bis 3**    | **Ab Tag 4**     |\n| Mo-Do      | 39 €/Kal.Tag     | 29 €/Kal.Tag     |\n| Fr-So      | 49 €/Kal.Tag     | 39 €/Kal.Tag     |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,44 €/km|\n| Ab dem 101. Kilometer | 0,39 €/km|\n\n\n| Selbstbeteiligung (je Schadensfall) | | |\n| :-------- | -------: | -------: |\n| SB bis Fahrzeugwert | | inklusive (0€) |\n| SB 1.500€ | 1€/Std. | 9 €/Kal.Tag |\n| SB 500€ | 2€/Std. | 14 €/Kal.Tag |\n| SB 150€ | 4€/Std. | 19 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/6a7dd88a8a03e46ab9d01559/pdf) zu entnehmen. ",

      "bubPassenger.Buchbinder.pricing.6a7de9fe8a03e46ab9d01574": "|||\n| :------------- |------------:|\n|       |  **Stundenpreis**     |\n| Mo-Do    |   4,90 €    |\n| Fr-So      | 5,90 €     |\n\n\n||||\n| :------------- |-------------:|-------------:|\n|       | **Tag 1 bis 3**    | **Ab Tag 4**     |\n| Mo-Do      | 49 €/Kal.Tag     | 39 €/Kal.Tag     |\n| Fr-So      | 59 €/Kal.Tag     | 49 €/Kal.Tag     |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,44 €/km|\n| Ab dem 101. Kilometer | 0,39 €/km|\n\n\n| Selbstbeteiligung (je Schadensfall) | | |\n| :-------- | -------: | -------: |\n| SB bis Fahrzeugwert | | inklusive (0€) |\n| SB 1.500€ | 1€/Std. | 9 €/Kal.Tag |\n| SB 500€ | 2€/Std. | 14 €/Kal.Tag |\n| SB 150€ | 4€/Std. | 19 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/6a7dd88a8a03e46ab9d01559/pdf) zu entnehmen. ",

      "bubTransporter.Buchbinder.pricing": "**Transporter L1 (Fiat Scudo or similar)**.\n\n||||\n|:----------|-------:|-----:|\n| | **per hour** | **per cal.day** |\n| Mon-Thu | 7,90 €| max. 79 €|\n| Fri-Sun | 9,90 € | max. 99 € |\n\n\n**Transporter L3 (Nissan Interstar or similar)**\n\n||||\n|:----------|-------:|-----:|\n| | **per hour** | **per cal.day** |\n| Mon-Thu | 9,90 € | max. 99 €|\n| Fri-Sun | 11,90 € | max. 119 € |\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,49 €/km|\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| SB up to vehicle value | included (0€) |\n| SB 1.500€ | 14 €/cal.day |\n| SB 500€ | 19 €/cal.day |\n| SB 150€ | 24 €/cal.day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The prices for reducing the excess may differ for new drivers.\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf).",

      "bubTransporter.Buchbinder.pricing.68fe518326116829219fdd7a": "**Transporter L1 (Fiat Scudo or similar)**.\n\n||||\n|:----------|-------:|-----:|\n| | **per hour** | **per cal.day** |\n| Mon-Thu | 7,90 €| max. 79 €|\n| Fri-Sun | 9,90 € | max. 99 € |\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| per kilometer | 0,49 €/km|\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| SB up to vehicle value | included (0€) |\n| SB 1.500€ | 14 €/cal.day |\n| SB 500€ | 19 €/cal.day |\n| SB 150€ | 24 €/cal.day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The prices for reducing the excess may differ for new drivers.\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf).",

      "bubTransporter.Buchbinder.pricing.69aaadf2af5c7b01c5a98c5b": "**Transporter L3 (Nissan Interstar or similar)**.\n\n||||\n|:----------|-------:|-----:|\n| | **per hour** | **per cal.day** |\n| Mon-Thu | 9,90 € | max. 99 €|\n| Fri-Sun | 11,90 € | max. 119 € |\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,49 €/km|\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| SB up to vehicle value | included (0€) |\n| SB 1.500€ | 14 €/cal.day |\n| SB 500€ | 19 €/cal.day |\n| SB 150€ | 24 €/cal.day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The prices for reducing the excess may differ for new drivers.\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf).",

      "business": "business",

      "button.lock": "Lock",

      "button.unlock": "Unlock",

      "calendar.dismiss": "Close",

      "call": "Call",

      "callout.show.availability": "Verfügbarkeit anzeigen",

      "camera.addressProof.upload": "Upload",

      "camera.permission.details": "Please grant GETAWAY access to your camera to allow the app to take photos.",

      "camera.permission.no": "Later",

      "camera.permission.title": "Access Camera",

      "camera.permission.yes": "Allow",

      "cancel": "Cancel",

      "cancel.FirstSteps.dialog.message": "You need only 2 Minutes: Complete your registration and start your first rental.",

      "cancel.FirstSteps.dialog.message.noBonus": "You need only 2 Minutes: Complete your registration and start your first rental.",

      "cancel.FirstSteps.dialog.no": "Cancel",

      "cancel.FirstSteps.dialog.yes": "Not now",

      "cancel.rental.handover": "Do you want to finish the current rental?",

      "car.approximateMileage.gt250k": "above 250.000 km",

      "car.approximateMileage.lt100k": "50.000 - 100.000 km",

      "car.approximateMileage.lt150k": "100.000 - 150.000 km",

      "car.approximateMileage.lt200k": "150.000 - 200.000 km",

      "car.approximateMileage.lt250k": "200.000 - 250.000 km",

      "car.approximateMileage.lt50k": "below 50,000 km",

      "car.available.book": "RENT IT",

      "car.category.name.label": "Price group",

      "car.co2.text": "Kg of saved CO2",

      "car.damage": "Damage",

      "car.damage.categories.title": "What would you like to report?",

      "car.damage.create.dialog.title": "Add Damage",

      "car.damage.edit.notallowed.description": "Editing car damages while car is rented is not allowed, please contact support if needed.",

      "car.damage.edit.notallowed.title": "Editing not possible",

      "car.damage.remove.dialog.remove": "Remove this damage",

      "car.damage.remove.dialog.title": "Are you sure?",

      "car.damages": "Damages",

      "car.damages.photos.dialog.description": "Pleas add at least on photo of this damage in order to report it correctly.",

      "car.damages.photos.dialog.title": "Photo of the damage",

      "car.data.title": "Car Info",

      "car.data.view.btn.continue": "Continue",

      "car.data.view.btn.start": "Start",

      "car.data.view.btn.upload": "Upload",

      "car.data.view.description": "Please make sure that the shown VIN and model/make match before continuing.",

      "car.data.view.document": "Installation Data Photo",

      "car.data.view.document.sample": "see example: ",

      "car.data.view.title": "Vehicle Installation Data",

      "car.demo.unavailable.messege": "Please go the App Store and update your app version to rent this car.",

      "car.demo.unavailable.title": "Car Unavailable",

      "car.details.available.until.placeholder": "Available until",

      "car.details.car.info": "CAR INFO",

      "car.details.carplate.placeholder": "Plate number",

      "car.details.damages": "Damages",

      "car.details.equipment": "EQUIPMENT",

      "car.details.fuel.diesel": "Diesel",

      "car.details.fuel.electric": "Electric",

      "car.details.fuel.hybrid": "Hybrid",

      "car.details.fuel.hybrid_diesel": "Hybrid/Diesel",

      "car.details.fuel.hybrid_unleaded95": "Hybrid/Benzin 95",

      "car.details.fuel.hybrid_unleaded98": "Hybrid/Benzin 98",

      "car.details.fuel.lpg": "LPG",

      "car.details.fuel.other": "Other",

      "car.details.fuel.placeholder": "Fuel",

      "car.details.fuel.unleaded95": "Super",

      "car.details.fuel.unleaded98": "Super Plus",

      "car.details.gear.automatic": "Automatic",

      "car.details.gear.manual": "Manual",

      "car.details.gear.type.placeholder": "Gear",

      "car.details.height": "Loading height",

      "car.details.initial.registration.placeholder": "Initial registration date",

      "car.details.length": "Loading length",

      "car.details.list.damages.placeholder": "Listed Damages",

      "car.details.listofdamages.title": "LIST OF DAMAGES",

      "car.details.loadCapacity": "Payload",

      "car.details.lock.text": "LOCK",

      "car.details.mileage.gt100": "More than 100.000 km",

      "car.details.mileage.lt100": "Less than 100.000 km",

      "car.details.mileage.lt20": "Less than 20.000 km",

      "car.details.mileage.lt50": "Less than 50.000 km",

      "car.details.mileage.placeholder": "Milage",

      "car.details.pickupreturn.placeholder": "Location",

      "car.details.pollution.placeholder": "Pollution Badge",

      "car.details.pos.reviews": "Positive Reviews",

      "car.details.reviews": "reviews",

      "car.details.techincaldata": "Technical Data",

      "car.details.uhr": "Clock",

      "car.details.unlock.text": "Start rental",

      "car.details.unlock.text.brand": "Start rental",

      "car.details.unlocking.text": "Unlocking...",

      "car.details.width": "Loading width",

      "car.device.doors.open": "Please make sure that all doors are closed.",

      "car.device.fuel.card.missing": "Please return the fuel card to the box in the glove compartment.",

      "car.device.keys.missing": "Please make sure the car keys are in the box in the glove compartment.",

      "car.device.view.btn.txt": "Continue",

      "car.device.view.description": "Please choose using serial number",

      "car.device.view.search.label": "Search by SN",

      "car.device.view.title": "Connect the CloudBoxx",

      "car.device.windows.open": "Please make sure that all windows are closed.",

      "car.equipment.abs": "ABS",

      "car.equipment.adaptiveLighting": "Adaptive lighting",

      "car.equipment.airConditioning": "Air conditioning",

      "car.equipment.alloyWheels": "Alloy wheels",

      "car.equipment.auxiliaryHeating": "Auxiliary heating",

      "car.equipment.childSeat": "Child seat",

      "car.equipment.collisionAvoidanceSystem": "Collision avoidance system",

      "car.equipment.cruiseControl": "Cruise control",

      "car.equipment.disabledAccessible": "Disabled accessible",

      "car.equipment.distanceControlAssistSystem": "Distance control assist system",

      "car.equipment.electricHeatedSeats": "Electric heated seats",

      "car.equipment.esp": "ESP",

      "car.equipment.feature": "Features",

      "car.equipment.fourWheelDrive": "Four wheel drive",

      "car.equipment.handsFreeKit": "Hands-free kit",

      "car.equipment.interior": "Interior",

      "car.equipment.laneDepartureWarningSystem": "Lane departure warning system",

      "car.equipment.multifunctionalWheel": "Multifunctional wheel",

      "car.equipment.navigationSystem": "Navigation system",

      "car.equipment.panoramicRoof": "Panoramic roof",

      "car.equipment.parkingAssistSystem": "Parking assist system",

      "car.equipment.powerAssistedSteering": "Power assisted steering",

      "car.equipment.rainSensor": "Rain sensor",

      "car.equipment.roofBars": "Roof bars",

      "car.equipment.safety": "Safety",

      "car.equipment.startStopSystem": "Start-stop system",

      "car.equipment.sunroof": "Sunroof",

      "car.equipment.tractionControl": "Traction control",

      "car.equipment.trailerCoupling": "Trailer coupling",

      "car.feedback.text": "Love your car",

      "car.findNearest.notExist": "no cars available nearby, try another timeframe or change the map zoom.",

      "car.handover.failed.description.unlock": "Unlock the car if necessary and restart the process again.",

      "car.handover.failed.title": "Failed to proceed",

      "car.handover.manual.fuelLevel.description": "Nobody wants to receive a car with an almost empty fuel tank. Please confirm that the car’s fuel level is above 25%.",

      "car.handover.manual.fuelLevel.title": "Fuel level sufficient?",

      "car.handover.nodamages": "No reported damages",

      "car.insurance": "Insurance coverage",

      "car.owner.dialog.rented.message": "Your car is being rented. You will receive an email once the rental is finished.",

      "car.owner.dialog.rented.title": "Car is being rented",

      "car.pollution.green": "Green",

      "car.pollution.nobadge": "Without badge",

      "car.pollution.red": "Red",

      "car.pollution.unknown": "Unknown",

      "car.pollution.yellow": "Yellow",

      "car.price": "%@ € per km",

      "car.price.desc": "This is where you tell us how much you want to earn. You can also adjust this anytime later.",

      "car.price.footer": "*This is a non-binding estimation. Your earnings ultimatively depend on the availability and desirability of your car.",

      "car.price.high": "Too expensive",

      "car.price.low": "Too cheap",

      "car.price.title": "Set a price per km",

      "car.price.update": "SAVE",

      "car.profile.area.name": "Name",

      "car.profile.area.note": "Important notes",

      "car.profile.area.openinghrs": "Access",

      "car.profile.area.title": "return area",

      "car.profile.blockReasons.label": "Downtime reason(s):",

      "car.profile.brand": "Make",

      "car.profile.damages": "Damages And Defects",

      "car.profile.description": "Edit your car profile",

      "car.profile.dimensions.note": "Dimentions can slightly vary, When not sure please pay extra attention to the vehicle dimension and always aim for some extra space.",

      "car.profile.engine": "Engine power",

      "car.profile.equipment": "Equipment",

      "car.profile.history.date.interval.to": "to",

      "car.profile.instructions": "Check out our %@ how to increase your rental earnings.",

      "car.profile.instructions.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "car.profile.instructions.url.text": "help center",

      "car.profile.lastCleaning.label": "Last cleaning:",

      "car.profile.model": "Model",

      "car.profile.price.details": " https://robbe.app/feetable",

      "car.profile.price.message": "Circa %@ € per month*",

      "car.profile.price.per.km": "Your earnings per km",

      "car.profile.rental.description": "Rental History",

      "car.profile.rental.history": "RENTAL HISTORY",

      "car.profile.rented.back": "Returns latest,",

      "car.profile.tab.availability": "Availability",

      "car.profile.tab.info": "Info",

      "car.profile.tab.pricing": "Prices",

      "car.profile.terminate": "TERMINATE CAR PROFILE",

      "car.profile.view": "View your car profile",

      "car.registration.camera.description": "Make sure the fully opened car registration front side is positioned within the frame.",

      "car.registration.photo.description": "(fully opened)",

      "car.registration.photo.title": "front of the car registration license",

      "car.release.ignition.message": "Please turn of the engine to release your car.",

      "car.release.ignition.title": "Cannot release car",

      "car.released": "Your car has been released.",

      "car.released.error": "Releasing car error",

      "car.rental.cancelled": "Your reservation has been cancelled. If you put a deposit it will be refunded automatically.",

      "car.rental.cancelled.time": "Your booking has been cancelled because you haven't unlocked car on time.",

      "car.rental.count": "Rentals",

      "car.rental.rental": "Rental",

      "car.rental.rentals": "Rentals",

      "car.rental.trips": "TRIPS",

      "car.rentals.title": "Rentals",

      "car.rented.back": "Back on",

      "car.rented.backtoday": "Back at",

      "car.rented.backtomorrow": "Back tomorrow at",

      "car.reserve.blockPayment.description": "By reserving this vehicle, a deposit of 100€ will be blocked on your credit card, which will be released after clearing with the rental costs after the rental has been finished.",

      "car.reserve.blockPayment.paypal.description": "By reserving this vehicle, a deposit of 100€ will be blocked on your paypal account, which will be released after clearing with the rental costs after the rental has been finished.",

      "car.reserve.blockPayment.paypal.title": "Deposit for PayPal payment",

      "car.reserve.blockPayment.paypal.yes": "Continue",

      "car.reserve.blockPayment.title": "Deposit for credit card payment",

      "car.reserve.blockPayment.yes.text": "Continue",

      "car.reserve.carBooked.description": "This vehicle has a planned booking and the driver expect to pick it up by then. late return fees might apply.",

      "car.reserve.carBooked.title": "Vehicle Should be returned in %s .",

      "car.reserve.carBooked.yes.text": "Agree",

      "car.review.title": "Reviews",

      "car.search.notExist": "This car does not exist.",

      "car.select.cta": "Let's go!",

      "car.select.search.label": "Search by VIN",

      "car.select.tab.installation": "Installation",

      "car.select.tab.removal": "Deinstallation",

      "car.select.view.description": "Choose the vehicle by selecting the according VIN.",

      "car.select.view.ongoing.label": "Ongoing Installations",

      "car.select.view.title": "Choose vehicle",

      "car.service.count": "Service trips",

      "car.status.battery.voltage": "Battery Voltage",

      "car.status.button.refresh": "Update Status",

      "car.status.fuel.card": "Fuel Card",

      "car.status.fuel.level": "Fuel Level",

      "car.status.key": "Car Key",

      "car.status.mileage": "Mileage",

      "car.status.missing": "Missing",

      "car.status.not.found": "Could not read car status",

      "car.status.not.required": "Not available",

      "car.submit.approximateMileage": "Approximate mileage",

      "car.submit.footer": "I hereby confirm, that this car has a valid vehicle insurance and general inspection certificate.",

      "car.submit.leased": "I am leasing the car",

      "car.submit.legalnotice": "I hereby confirm, that this car has a valid vehicle insurance and general inspection certificate and allow GETAWAY to proceed a credit rating check.",

      "car.submit.legalnotice.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "car.submit.legalnotice.url.text": "credit rating check",

      "car.submit.notowner": "I am not the owner",

      "car.submit.owner": "I am the owner",

      "car.submit.ownership": "Who owns the car?",

      "car.submit.ownership.description": "If you don't own the car, you need to hand in letter of attorney later. A template will be provided.",

      "car.terminate.dialog.message": "Please contact our service team to remove your car's profile.",

      "car.terminate.dialog.title": "Terminate my car",

      "car.title": "YOUR CAR",

      "car.transaction.title": "Rental income %@",

      "car.unlock.bluetooth.disabled": "Enable bluetooth®\nto unlock",

      "car.unlock.bluetooth.disabled.brand": "Enable bluetooth®",

      "car.unlock.bluetooth.searching": "Reduce distance\nto unlock",

      "car.unlock.bluetooth.searching.brand": "Reduce distance",

      "car.unlock.closeToCar.action": "I am at the vehicle - unlock now",

      "car.unlock.locationpermission.dialog.message": "Please grant location permission  through browser settings to be able to unlock the car",

      "car.unlock.locationpermission.dialog.title": "Location permission is disabled",

      "car.unlock.tooFar.message": "Unable to unlock the car from this distance. Please try again once you are closer.\n\nElse please contact our Service Team via the chat icon on the top-right of your screen.",

      "car.unlock.tooFar.title": "Please reduce distance",

      "car.unreleased": "Your car has been unreleased.",

      "car.unreleased.error": "Unreleasing car error. Please try again later.",

      "carCheck.addImage.labelFour": "Back, left",

      "carCheck.addImage.labelOne": "front, left",

      "carCheck.addImage.labelThree": "Back, right",

      "carCheck.addImage.labelTwo": "front, right",

      "card.number": "card number",

      "carprofile.footnote": "Check out our %@ how to increase your rental earnings.",

      "carprofile.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "carprofile.footnote.url.text": "help center",

      "carprofile.troubleshoot.description": "Your car's engine doesn't start? Follow the link to unlock the immobilizer.",

      "carprofile.troubleshoot.title": "Manage immobilizer",

      "cars.carousel.title": "Find your perfect GETAWAY!",

      "challenges.completed.section": "COMPLETED CHALLENGES",

      "challenges.firstSteps.addPayment.text": "To verify your user account",

      "challenges.firstSteps.addPayment.title": "Save a payment method",

      "challenges.firstSteps.bonusTransactionReason": "First Steps",

      "challenges.firstSteps.createAccount.text": "Well done! You've successfully signed up",

      "challenges.firstSteps.createAccount.title": "Signup for GETAWAY",

      "challenges.firstSteps.description": "This is a great way to start your journey with GETAWAY. Complete these first steps and get %s€ bonus from us!",

      "challenges.firstSteps.enterPIN.title": "PIN determined",

      "challenges.firstSteps.firstRental.text": "Take your first ride with GETAWAY",

      "challenges.firstSteps.firstRental.title": "Take a ride",

      "challenges.firstSteps.listCar.text": "Make money with your car!",

      "challenges.firstSteps.listCar.title": "List your car",

      "challenges.firstSteps.manualApproval.title": "Manual Approval",

      "challenges.firstSteps.payDeposit.title": "Pay Deposit",

      "challenges.firstSteps.saveAddress.text": "Easy address saving",

      "challenges.firstSteps.saveAddress.title": "Save your registered address",

      "challenges.firstSteps.selectTariff.title": "Choose Tariff",

      "challenges.firstSteps.title": "First Steps",

      "challenges.firstSteps.verifyAuthorizedRepresentative.title": "Authorization to represent verified",

      "challenges.firstSteps.verifyCompany.title": "Organization verified",

      "challenges.firstSteps.verifyDriversLicense.text": "To get access to the fleet of cars",

      "challenges.firstSteps.verifyDriversLicense.title": "Verify your driving license",

      "challenges.firstSteps.verifyEmail.text": "To confirm your email",

      "challenges.firstSteps.verifyEmail.title": "Verify your email",

      "challenges.firstSteps.verifyIDDocument.text": "To get access to the fleet of cars",

      "challenges.firstSteps.verifyIDDocument.title": "Verify your ID Document",

      "challenges.firstSteps.verifyIban.title": "Verify IBAN",

      "challenges.firstSteps.verifyPhoneNumber.text": "To convert your smartphone into a car key",

      "challenges.firstSteps.verifyPhoneNumber.title": "Confirm your phone number",

      "challenges.inviteFriends.bonusTransactionReason": "User referral",

      "challenges.inviteFriends.description": "Earn 10€ for each invited friend. At the same time your friend will receive 10€ welcome credit upon signing up.",

      "challenges.inviteFriends.title": "Invite 5 friends",

      "challenges.up.to": "Earn up to",

      "change": "Change",

      "change.password.success": "Your password has been successfully updated.",

      "circle.brand_not_resolved": "Cannot resolve circle's brand",

      "circle.emailRequired": "Email required",

      "circles.button.text": "CONFIRM",

      "circles.input.placeholder": "Enter invitation code",

      "circles.join.success.msg": "You have special access in vehicles and prices! ",

      "circles.join.success.title": "You just joined a circle.",

      "claim": "Report",

      "claim.photo.note": "Please add at least one photo.",

      "claim.photo.title": "Add photos",

      "clean.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeDirt_compressed.png",

      "clean.damage.option1": "Yes",

      "clean.damage.option2": "No",

      "clean.damage.option3": "I don't know",

      "clean.damage.picker.holder": "Cleaning needed?",

      "clean.damage.title": "Report pollution",

      "clear.damages": "Clear damages",

      "clear.damages.prompt.text": "You are about to clear all car's damages",

      "clipboard.link.copied": "Invitation link was copied to clipboard.",

      "closed": "closed",

      "confirm": "Confirm",

      "connect.getaway.name": "Getaway Connect",

      "connect.getaway.support.phone": "+49 30 30808441",

      "connect.item.brand.name": "Brand",

      "connect.item.car.install": "Search by VIN",

      "connect.item.car.remove": "Search by VIN",

      "connect.item.chassisNumber": "VIN",

      "connect.item.cloudboxx.number": "CloudBoxx SN",

      "connect.item.device.serialNo": "CloudBoxx SN",

      "connect.item.fuel.card.number": "Fuel Card",

      "connect.item.mobile": "Mobile Number",

      "connect.item.model": "Make/Model",

      "connect.item.plate": "vehicle plate",

      "consents.agb": "Consent",

      "consents.agb.title": "General Terms and Conditions",

      "consents.consent": "Consent",

      "consents.details": "Details",

      "consents.newsletter.desc": "I consent to receive the newsletter.",

      "consents.newsletter.title": "Newsletter",

      "consents.privacy.policy.title": "Privacy policy",

      "consents.schufa.desc": "I consent to the processing of my data for a [creditworthiness check](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_smp/WL_DataPrivacy-DATA_Checks-de+02_2024.pdf).",

      "consents.schufa.title": "Credit check",

      "consents.title": "My consents",

      "contacts.invite.contact": "INVITE %d CONTACT",

      "contacts.invite.contact.many": "INVITE %d CONTACTS",

      "contacts.invite.earn": "You can earn up to %@",

      "contacts.permission.details": "Please grant GETAWAY access to your contacts to allow the app to send invitations.",

      "contacts.permission.no": "Later",

      "contacts.permission.title": "Access contacts",

      "contacts.permission.yes": "Allow",

      "continue": "Continue",

      "countries.phone.list": "Available countries",

      "creditcheck.terms": "By selecting the SEPA direct debit procedure, I consent to the processing of my data for a %s.",

      "creditcheck.terms.highlight": "creditworthiness check",

      "creditcheck.terms.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/WL_DataPrivacy-DATA_Checks-de.pdf",

      "custom.camera.description.car.registration": "Please place your car registration certificate on a neutral surface while making sure its fully in the frame and take a photo.",

      "custom.camera.description.damage": "Please make sure the damage is visible and centered in the frame.",

      "custom.camera.description.license": "Please place your driving license on a neutral surface within the outlined square and take a photo.",

      "custom.camera.description.selfie": "Please hold down the record button for 3 seconds.",

      "custom.camera.holdmessage.selfie": "Hold down the record button for 3 seconds to submit your selfie.",

      "custom.camera.repeat": "Retake",

      "custom.camera.submit": "Apply",

      "custom.camera.title.car.registration": "Car Registration Certificate",

      "custom.camera.title.damage": "Damage Photo",

      "custom.camera.title.license.back": "Driving License back",

      "custom.camera.title.license.front": "Driving License front",

      "custom.camera.title.selfie": "Selfie",

      "customerSupport.call": "Call the ServiceTeam",

      "damage.add.noImages.error": "Please make sure that you added two pictures at least",

      "damage.add.success": "Thank you for reporting a damage! ",

      "damage.clean.description": "Dirt, items left behind, or other things (inside or outside)",

      "damage.clean.title": "Report Pollution",

      "damage.detected.carvaloo_feedback_link": "Damage event detected. Please record vehicle condition: %s",

      "damage.detials.reportedon": "Reported on:",

      "damage.new": "NEW",

      "damage.new.notification.description": "Thanks for updating the damage records!",

      "damage.normal.description": "Scratches, dents, bumps, or more",

      "damage.normal.title": "Report damage",

      "damage.screen.description": "A warning light is on in the cockpit",

      "damage.screen.title": "Report a warning light",

      "damages.add": "Report damage",

      "damages.add.button.text": "Add damage",

      "damages.add.error.noimages": "Please add photos of the damage before submitting",

      "damages.add.image.note": "At least two photos (different angles / distances). The license plate must be recognizable on one photo.",

      "damages.bumper": "Stoßstange",

      "damages.burn": "Brandfleck",

      "damages.call": "To our breakdown hotlines",

      "damages.carRoadworthy": "Is the vehicle roadworthy?",

      "damages.characteristic": "Characteristics",

      "damages.characteristic.freeText": "other",

      "damages.characteristics.burn": "Burn",

      "damages.characteristics.crack": "Crack",

      "damages.characteristics.deepScratch": "Deep scratch",

      "damages.characteristics.deepscratch": "Deep scratch",

      "damages.characteristics.dent": "Dent",

      "damages.characteristics.dirt": "Dirt",

      "damages.characteristics.missing": "Missing",

      "damages.characteristics.other": "Other",

      "damages.characteristics.permanentDirt": "Stubborn dirt",

      "damages.characteristics.scratch": "Scratch",

      "damages.characteristics.stoneChip": "Stone chip",

      "damages.chars.left": "characters left",

      "damages.component": "Component",

      "damages.component.bumper": "Bumper",

      "damages.component.door": "Door",

      "damages.component.engineBonnet": "Engine bonnet",

      "damages.component.exteriorMirror": "Mirror",

      "damages.component.floor": "Floor",

      "damages.component.hubcap": "Hubcap",

      "damages.component.interiorTrim": "Interior trim",

      "damages.component.other": "Other",

      "damages.component.rearWindow": "Window",

      "damages.component.seat": "Seat",

      "damages.component.sill": "Sill",

      "damages.component.slidingDoor": "Sliding door",

      "damages.component.tire": "Tire",

      "damages.component.trunk": "Trunk/ bed",

      "damages.component.wheelRim": "Rim",

      "damages.component.windscreen": "Windscreen",

      "damages.component.wing": "Wing",

      "damages.confirmRecord.button.text": "Confirm damage record",

      "damages.crack": "Riss",

      "damages.damage.desc": "Damage description",

      "damages.deepscratch": "Kratzer",

      "damages.dent": "Delle",

      "damages.description": "Description of damage",

      "damages.dirt": "Verschmutzung",

      "damages.door": "Tür",

      "damages.engine.bonnet": "Motorhaube",

      "damages.exterior": "Außen",

      "damages.exterior.mirror": "Spiegel",

      "damages.floor": "Boden",

      "damages.gt10cm": ">10 cm",

      "damages.hubcap": "Hubcap",

      "damages.interior": "Innen",

      "damages.location": "Location",

      "damages.location.front": "Vorderseite",

      "damages.location.na": "N/A",

      "damages.location.rear": "Rückseite",

      "damages.location.side.center": "Mitte",

      "damages.location.side.codriver": "Beifahrerseite",

      "damages.location.side.driver": "Fahrerseite",

      "damages.lt10cm": "5 - 10cm",

      "damages.lt5cm": "<5 cm",

      "damages.new.photos.add": "Add photos",

      "damages.noRecord.text": "No damge records",

      "damages.other": "Anderes",

      "damages.pernament.dirt": "Dauerhafte Verschmutzung",

      "damages.rear.window": "Fenster",

      "damages.report.areaQ": "Which area?",

      "damages.report.charQ": "What kind of damage?",

      "damages.report.compareSub": "Damage has already been reported in these areas. Is yours among them?",

      "damages.report.compareTitle": "Already recorded?",

      "damages.report.componentQ": "Which component?",

      "damages.report.continue": "Continue",

      "damages.report.continueNew": "Next — Report new damage",

      "damages.report.describe": "Please describe",

      "damages.report.doneBtn": "Done",

      "damages.report.doneSub": "Thanks! The new damage was recorded and will be reviewed.",

      "damages.report.doneTitle": "Damage reported",

      "damages.report.isKnown": "It is already recorded",

      "damages.report.isNew": "No — Report new damage",

      "damages.report.knownSub": "Nothing more to do — the damage is already documented.",

      "damages.report.knownTitle": "All good",

      "damages.report.noneSub": "Nothing recorded here yet — looks like a new damage.",

      "damages.report.noneTitle": "No known damages",

      "damages.report.noteLabel": "Note (optional)",

      "damages.report.notePlaceholder": "e.g., additional details …",

      "damages.report.other": "Other / I don't know",

      "damages.report.photoQ": "Add photos",

      "damages.report.sideQ": "Which side?",

      "damages.report.submit": "Report damage",

      "damages.report.title": "Report new damage",

      "damages.report.whereQ": "Where is the damage?",

      "damages.scratch": "Kratzer",

      "damages.seat": "Sitz",

      "damages.side": "Side",

      "damages.side.center": "Center",

      "damages.side.coDriversSide": "Co-Driver's side",

      "damages.side.driversSide": "Driver's side",

      "damages.sill": "Schweller",

      "damages.size": "Size",

      "damages.size.gt10cm": ">10cm",

      "damages.size.lt10cm": "5 - 10cm",

      "damages.size.lt5cm": "<5cm",

      "damages.stonechip": "Steinschlang",

      "damages.thirdParty": "Third party involment",

      "damages.thirdParty.carRoadworthyDontKnow": "I don‘t know",

      "damages.thirdParty.dontKnow": "I don’t know",

      "damages.thirdParty.isInvolved": "Third-party/ies is/are involved",

      "damages.thirdParty.notInvolved": "Third-party/ies is/are not involved",

      "damages.thirdParty.notRoadworthy": "Not-roadworthy",

      "damages.thirdParty.roadworthy": "Roadworthy",

      "damages.title": "Damage records",

      "damages.toolbar.done": "Done",

      "damages.toolbar.next": "Next",

      "damages.trim": "Innenverkleidung",

      "damages.trunk": "Kofferraum",

      "damages.viewer.damages": "Damages",

      "damages.viewer.detail": "Damage detail",

      "damages.viewer.graphic": "Graphic",

      "damages.viewer.groupByArea": "Group by area",

      "damages.viewer.list": "List",

      "damages.viewer.photo": "Photo",

      "damages.viewer.tapHint": "Tap to view or report damage",

      "damages.viewer.title": "Known damages",

      "damages.viewer.zoomHint": "Use +/− to zoom — pinch on a real device",

      "damages.wheel.rim": "Felge",

      "damages.where": "Where",

      "damages.where.exterior": "Exterior",

      "damages.where.interior": "Interior",

      "damages.windscreen": "Frontscheibe",

      "damages.wing": "Kotflügel",

      "dashboard.about": "About",

      "dashboard.balance": "Payments",

      "dashboard.carprofile": "Car profile",

      "dashboard.dialog": "Imprint",

      "dashboard.dialog.bnd.url": "https://book-n-drive.app/imprint",

      "dashboard.dialog.cookies": "Cookies",

      "dashboard.dialog.getaway": "GETAWAY Imprint",

      "dashboard.dialog.getaway.url": "https://getaway.pro/imprint",

      "dashboard.dialog.interrent.url": "https://www.interrent.com/de/rechtliche-hinweise",

      "dashboard.dialog.licenses": "Copyright info",

      "dashboard.dialog.mba": "Imprint",

      "dashboard.dialog.mba.url": "https://mietbar.app/privacy#datenschutz",

      "dashboard.dialog.msi.url": "https://mietsmart.app/imprint",

      "dashboard.dialog.privacy": "Privacy Policy",

      "dashboard.dialog.rw": "Imprint",

      "dashboard.dialog.rw.url": "https://robbe.app/imprint",

      "dashboard.dialog.terms": "Terms of Service",

      "dashboard.dialog.ubq": "Imprint",

      "dashboard.dialog.ubq.url": "https://ubq.app/imprint",

      "dashboard.freecredit": "Get free balance",

      "dashboard.headline": "Hello 👋\n%@ %@",

      "dashboard.help": "Help Center",

      "dashboard.hi": "Hi",

      "dashboard.list.car": "Check how much your car could earn.",

      "dashboard.list.cars": "List another car",

      "dashboard.logout": "LOGOUT",

      "dashboard.logout.active.rental.prompt": "Please end your rental before logging out.",

      "dashboard.logout.prompt": "Are you sure you want to logout?",

      "dashboard.logout.success": "You have been successfully logged out.",

      "dashboard.menu.profile": "User account",

      "dashboard.myRentals": "Rentals",

      "dashboard.profile": "Your registration",

      "dashboard.releasing": "Releasing...",

      "dashboard.review": "Review this app",

      "dashboard.services": "Services orders",

      "dashboard.settings": "SETTINGS",

      "data.confirm.view.btn.txt": "Confirm",

      "data.confirm.view.description": "Check all data once again for correctness",

      "data.confirm.view.title": "Please confirm!",

      "data.test.view.btn.txt": "Continue",

      "data.test.view.description": "please confirm that the vehicle status is read correctly and it functions correctly too",

      "data.test.view.title": "Connection Test",

      "day": "day",

      "day.ago": "days ago",

      "day.fr": "Friday",

      "day.mo": "Monday",

      "day.sa": "Saturday",

      "day.short": "Day",

      "day.su": "Sunday",

      "day.th": "Thursday",

      "day.tu": "Tuesday",

      "day.we": "Wednesday",

      "days": "days",

      "days.ago": "days ago",

      "days.short": "Days",

      "delete": "delete",

      "deposit.balance.title": "Deposit",

      "deposit.card.desc.md": "✓ will be refunded after the end of the contract<br>✓ with deposit invoice as pdf<br>✓ secure payment via GooglePay, credit card and much more<br>✓",

      "deposit.card.price": "One-time %s",

      "deposit.card.title": "Deposit (refundable)",

      "deposit.cta": "Choose payment method",

      "deposit.desc": "To activate your payment method, please pay the refundable deposit now.",

      "deposit.dialog.receipt": "Show receipt",

      "deposit.dialog.refund": "Claim refund",

      "deposit.dialog.title": "Deposit",

      "deposit.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Why is a security deposit required? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> The deposit serves as security for outstanding claims arising from the use of the vehicle, such as excesses in the event of damage or uncovered fees. It is deposited upon registration and refunded at the end of the contract, provided there are no outstanding amounts. </p> </details><hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> When is the deposit refunded? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> The deposit is usually refunded within 6 weeks of the end of the contract after offsetting against any outstanding claims. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Will I receive a deposit invoice? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Yes, when you complete your registration and activate the car sharing service, you can download the deposit invoice as a PDF. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> How is the deposit amount calculated? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> A deposit is required to activate the user account. The amount is based on the currently valid price list. In the event of negative or failed SCHUFA information (or a comparable credit agency), we reserve the right to demand a higher deposit. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">",

      "deposit.footnote.secure.text": "Secure and encrypted data transmission",

      "deposit.title": "Pay a deposit",

      "description": "Description",

      "desktop.switch.mobile.desc": "To continue, please scan the qr code with your smartphone.",

      "desktop.switch.mobile.title": "Continue with smartphone",

      "dialog.camera.permission.desc": "Please enable camera access from browser settings for this page",

      "dialog.camera.permission.title": "Camera permission denied",

      "dialog.deposit.add": "Pay deposit",

      "dialog.later": "Not now",

      "dialog.payment.add": "Add payment info",

      "dialog.schufa.add": "ADD ADDRESS",

      "dialog.tariff.add": "Choose Tariff",

      "digitalFuel.acquired.box.countdown": "This note closes in %s s",

      "digitalFuel.acquired.box.dismiss": "Dismiss",

      "digitalFuel.acquired.box.message": "Thank you! The refueling process for %s is complete and has been paid for. You can now drive off.",

      "digitalFuel.acquired.box.title": "Fueled Up & Paid",

      "digitalFuel.choice.adblue.desc": "Pay with the fuel card from the vehicle.",

      "digitalFuel.choice.adblue.title": "AdBlue",

      "digitalFuel.choice.fuel.desc": "Pay by app at the pump – no fuel card, no cash.",

      "digitalFuel.choice.fuel.title": "Fuel",

      "digitalFuel.choice.title": "What would you like to fill up?",

      "digitalFuel.confirmClose.leave": "Leave",

      "digitalFuel.confirmClose.message": "Your progress will be lost. Do you want to leave this screen?",

      "digitalFuel.confirmClose.stay": "Stay",

      "digitalFuel.confirmClose.title": "Close digital fueling?",

      "digitalFuel.desktop.subtitle": "Scan the code to open digital fueling on your phone.",

      "digitalFuel.desktop.title": "Continue on your phone",

      "digitalFuel.location.permission.message": "Please allow location access in your browser settings to start fueling.",

      "digitalFuel.location.permission.title": "Location needed",

      "digitalFuel.location.unavailable.message": "Your location could not be determined. Please try again.",

      "digitalFuel.mileage.caption": "Please enter the current mileage of the vehicle to be refueled.",

      "digitalFuel.mileage.header": "Mileage",

      "digitalFuel.plate.caption": "Please enter the license plate number of the vehicle to be refueled. Hyphens and spaces are optional, e.g. \"HH-EU-1234\" or \"HHEU1234\".",

      "digitalFuel.plate.errorEmpty": "Please enter your license plate.",

      "digitalFuel.plate.errorNotFound": "We could not match plate \"%s\" to a vehicle. Please double-check and try again or contact our service team.",

      "digitalFuel.plate.header": "License plate",

      "digitalFuel.plate.placeholder": "HH-EU 1234",

      "digitalFuel.productGroup.cng": "CNG",

      "digitalFuel.productGroup.electric": "Electric",

      "digitalFuel.productGroup.gasoline": "Petrol",

      "digitalFuel.session.closed": "The fueling session has ended.",

      "digitalFuel.settings.desc": "New: refuel without a fuel card and without cash. The app pays automatically – in three simple steps.",

      "digitalFuel.settings.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Do I need a fuel card or cash? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> No. Payment is handled entirely by the app. You neither insert a card nor go to the counter. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> How do I know which petrol station I can use? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Tap “Map”. Only petrol stations where paying by app works are shown, and the nearest one is selected for you. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> “Start fuelling” is missing or not working – what now? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Park the vehicle right at the petrol station and allow the app to use your location. Both are needed before fuelling can start. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> How do I know everything worked? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> After fuelling the app shows a green note “Fuelling completed”. You can drive away then. If something goes wrong, our support is one tap away via the chat icon at the top right. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">",

      "digitalFuel.settings.stepOne": "1. Find a petrol station",

      "digitalFuel.settings.stepOne.desc": "Tap “Map”. We show you the nearest petrol station where you can pay by app, and the way there.",

      "digitalFuel.settings.stepThree": "3. Start fuelling and pay",

      "digitalFuel.settings.stepThree.desc": "On the station card tap “Start fuelling”, choose the number of your pump and fill up as usual. Afterwards the app pays automatically – no need to go to the counter.",

      "digitalFuel.settings.stepTwo": "2. Park at the pump",

      "digitalFuel.settings.stepTwo.desc": "Drive up to an available pump and switch off the engine. Fuelling can only be started when you and the vehicle are right at the station.",

      "digitalFuel.settings.title": "Refuel with your phone",

      "digitalFuel.splash.subtitle": "Thank you for refueling one of our vehicles.",

      "digitalFuel.splash.subtitleCarSharing": "We already have your vehicle details — one moment please.",

      "digitalFuel.splash.title": "Refuel by smartphone",

      "digitalFuel.splash.welcome": "Welcome to",

      "digitalFuel.start.confirm.message": "Make sure you're first in line.",

      "digitalFuel.start.confirm.title": "Start fueling?",

      "digitalFuel.station.adblueNote": "Pay for AdBlue with the fuel card from the vehicle – app payment is not available for AdBlue yet.",

      "digitalFuel.station.availability": "Availability",

      "digitalFuel.station.currentLevel": "Current level: %s%",

      "digitalFuel.station.distance": "Distance",

      "digitalFuel.station.fuelType": "Fuel type",

      "digitalFuel.station.fuelTypes": "Fuel types",

      "digitalFuel.station.note": "Pay directly in the app at the pump – no fuel card needed. Tap \"Start fueling\", pick your pump and fill up as usual.",

      "digitalFuel.station.offline": "Currently not available",

      "digitalFuel.station.remainingTankCapacity": "Remaining tank capacity: %s L",

      "digitalFuel.station.startFueling": "Start fueling",

      "digitalFuel.station.tankCapacity": "Tank size: %s L",

      "digitalFuel.station.tooFar.message": "Drive to the station first – fueling can only start once you and the vehicle are right at the station (within 50 m).",

      "digitalFuel.station.tooFar.title": "Not at the station yet",

      "digitalFuel.success.backToRental": "Back to rental",

      "digitalFuel.success.subtitle": "Your fueling was completed successfully.",

      "digitalFuel.success.title": "Thank you!",

      "direct.debit": "Direct debit",

      "direct.debit.account.bic": "Bank number",

      "direct.debit.account.number": "Account number",

      "direct.debit.add": "ADD",

      "direct.debit.agreements.less": "I hereby grant teilauto.app (im Auftrag der teilAuto eG) and its payment service provider Adyen N.V. (Creditor ID NL48ZZ342764500000) a direct debit authorization as a SEPA direct debit mandate to collect payments due and instruct my financial institution to honor the direct debits drawn on my account. I may request reimbursement of the debited amount within eight weeks, beginning with the debit date. The conditions agreed with my credit institution apply. I agree to the reduction of the period of notice (pre-notification) for future SEPA direct debits to one (1) calendar day [German version applicable].",

      "direct.debit.agreements.more": "I hereby grant the contractual partner and its payment service provider Adyen N.V. (Creditor ID NL48ZZ342764500000) a direct debit authorization as a SEPA direct debit mandate",

      "direct.debit.desc": "Für sichere und bequeme Zahlungen per Lastschrift hinterlege bitte deine IBAN.",

      "direct.debit.iban": "IBAN",

      "direct.debit.title": "Add direct debit",

      "directdebit": "Direct Debit",

      "disconnected.dialog.message": "It seems like you are not connected to the internet. Please make sure to enable your internet connection to use the app.",

      "disconnected.dialog.title": "You are offline",

      "distance": "Distance",

      "dl.age.footnote": "The issue date of a plastic driving license can usually be found on the front under the number 4a",

      "dl.age.title": "When was your driver's license issued?",

      "dl.option.not.old": "After %s",

      "dl.option.old": "For more  than %s years",

      "dl.rejected.title": "Please pay attention to the following note on your previously submitted document:",

      "dl.tab.paper": "Paper format",

      "dl.tab.plastic": "Plastic format",

      "dob.button.title": "Take over",

      "dob.dateOfBirth.label": "Birthday (DD.MM.YYYY)",

      "dob.description": "To continue, please tell us when you were born.",

      "dob.title": "Your birthday",

      "document.upload.success": "Uploaded successfuly",

      "done": "Done",

      "dongle.rental.fuelSettings.instruction": "You do not have to keep the invoice. After fueling please put the fuel card back in the booklet together with the vehicle documents.",

      "dongle.rental.section.locked": "Given back",

      "dongle.rental.section.unlocked": "Taken over",

      "driver.distanceduration.price.description": "{0} €/Hr + {1} €/km",

      "driver.distanceduration.price.map.description": "€/Hr",

      "driver.id.status.open": "Add ID document",

      "driver.id.status.verified": "Identity card",

      "driver.id.status.verifying": "Verifying Identity card",

      "driver.license.banned.failure": "Please enter the starting and ending date of the ban before submitting",

      "driver.license.banned.update.button": "UPDATE",

      "driver.license.banned.update.date.button": "CHOOSE",

      "driver.license.banned.update.description": "I'm banned from driving for legal reasons between the dates entered below.",

      "driver.license.banned.update.end": "Ending date",

      "driver.license.banned.update.start": "Starting date",

      "driver.license.banned.update.title": "Banned from driving",

      "driver.license.banned.warning": "Please enter the starting date first",

      "driver.license.bottom.description": "By submitting this I acknowledge that if my driving license is held by the authorities or if I am not legally allowed to drive for any reason I will change the status of this document.",

      "driver.license.frontImage": "Front Image",

      "driver.license.info.desc": "In order to unlock any car around you, please verify your driving license.",

      "driver.license.info.save": "CONFIRM",

      "driver.license.info.title": "Your driving License",

      "driver.license.notuploaded.description": "Please verify your driver license",

      "driver.license.open.description": "Submitted on %@",

      "driver.license.rearImage": "Rear Image",

      "driver.license.selfieImage": "Your Selfie",

      "driver.license.status.deleted": "Declined, please verify again",

      "driver.license.status.notuploaded": "Add driver's license",

      "driver.license.status.open": "Verifying...",

      "driver.license.status.paused": "Banned",

      "driver.license.status.verified": "Driving license",

      "driver.license.status.verifying": "Verifying driving license",

      "driver.license.submit.failed": "Please attach all required photos to continue.",

      "driver.license.submit.notNow": "Please get your license verified to rent cars nearby.",

      "driver.license.submit.success": "Thanks for submitting your license. We will contact you after the check.",

      "driver.license.submited.description": "Submitted on %@",

      "driver.license.title": "Driving license",

      "driver.license.top.description": "Submit your driving license for verification by taking photos of it's front, rear and a selfi.",

      "driver.license.verified.description": "Update your driving license",

      "driver.mba.passenger.price.description": "{0} €/Hr + {1} €/Extra Km",

      "driver.mba.passenger.price.description.daily": "{0} €/Day + {1} €/Extra Km",

      "driver.mba.passenger.price.map.description": "€/Hr",

      "driver.mba.passenger.price.map.description.daily": "€/Day",

      "driver.mba.transporter.price.description": "{0} €/Hr + {1} €/Extra Km",

      "driver.mba.transporter.price.description.daily": "{0} €/Day + {1} €/Extra Km",

      "driver.mba.transporter.price.map.description": "€/Hr",

      "driver.mba.transporter.price.map.description.daily": "€/Day",

      "driver.mis.price.description": "{0} €/Day + {1} €/Extra Km",

      "driver.mis.price.map.description": "€/Day",

      "driver.mis.spain.price.description": "{0} €/Day",

      "driver.mis.spain.price.map.description": "€/Day",

      "driver.mis.transporter.price.description": "{0} €/Hr + {1} €/Extra Km",

      "driver.mis.transporter.price.map.description": "€/Hr",

      "driver.price.description": "{0} €/Hr + {1} €/km",

      "driver.price.getaway.description": "from 0,00 €/h",

      "driver.price.ikea.description": "{0} €/hr + {1} €/km",

      "driver.price.ikea.description.weekend": "{0} € + {1} €/km",

      "driver.price.ikea.map.description": "€/hr",

      "driver.price.ikea.map.description.weekend": "€",

      "driver.price.map.description": "€/Hr",

      "driver.price.map.description.weekend": "€",

      "driver.price.obi.description": "{0} €/Hr. + {1} €/excess km",

      "driver.price.obi.description.weekend": "{0} € + {1} €/excess km",

      "drivercar.profile.priceDetails": "price info",

      "drivercar.profile.request.action": "Request",

      "drivercar.profile.reserve.action": "Book now",

      "drivercar.profile.service.reserve.action": "Start service",

      "drivercar.rental.dialog.message": "Do you want to rent this car for personal use or to run a GETAWAY service? ",

      "drivercar.rental.dialog.reserve.rental": "Continue for personal use",

      "drivercar.rental.dialog.reserve.service": "Continue as service trip",

      "drivercar.rental.dialog.title": "Please choose your driving profile",

      "drivercar.reserved.status": "RESERVED",

      "drivercar.review.novalue": "✨ New car",

      "drivercar.unavailable.status": "Currently in use",

      "driving.damage.candrive": "Car can still be driven.",

      "driving.damage.cantdrive": "Car can't be driven anymore.",

      "driving.finish.rental.dialog.message": "Please turn of the engine to finish this rental.",

      "driving.finish.rental.dialog.retry": "Retry ",

      "driving.finish.rental.dialog.title": "Cannot finish",

      "driving.refuel.dialog.message": "Please turn of the engine to refuel the car.",

      "driving.refuel.dialog.title": "Refueling not possible",

      "drivinglicense.form.selfie.description": "Record a short selfie video",

      "drivinglicense.form.selfie.done.dialog.again": "Record again",

      "drivinglicense.form.selfie.done.dialog.message": "Your selfie is required to verify your driver license.",

      "drivinglicense.form.selfie.done.dialog.title": "Upload selfie",

      "duration": "Duration",

      "email.domain.error.dialog.ignore": "Ignore",

      "email.domain.error.dialog.update": "Update",

      "email.domain.error.prefix": "Do you mean",

      "email.domain.prefix.error": "Did you mean",

      "email.update.button": "Apply",

      "email.update.desc": "currently: %s",

      "email.update.success": "Your email address has been updated. Please confirm it by entering the email verification code.",

      "email.update.title": "change email address",

      "email.verify.desc": "Enter the code we just sent to this e-mail address:",

      "email.verify.skip": "Confirm later",

      "email.verify.success": "Email verified successfully",

      "email.verify.title": "Enter email confirmation code",

      "emergency.call": "Emergency call",

      "empty": "no results found",

      "enjoyYourTrip.location.subtitle": "Pick-up & Return Location",

      "enjoyYourTrip.title": "Enjoy your trip!",

      "equipment.4wd": "Four wheel drive",

      "equipment.abs": "ABS",

      "equipment.aircondition": "Air conditioning",

      "equipment.childseat": "Child seat",

      "equipment.collosion.avoidance": "Collision avoidance system",

      "equipment.cruise": "Cruise control",

      "equipment.disabled": "Disabled accessible",

      "equipment.esp": "ESP",

      "equipment.handsfree": "Hands-free kit",

      "equipment.heating.aux": "Auxiliary heating",

      "equipment.heating.seat": "Electric heated seats",

      "equipment.light.adaptive": "Adaptive lighting",

      "equipment.multifunctionalwheel": "Multifunctional wheel",

      "equipment.navigation": "Navigation system",

      "equipment.parking.assistant": "Parking assist system",

      "equipment.powersteering": "Power assisted steering",

      "equipment.roof.bars": "Roof bars",

      "equipment.roof.panorama": "Panoramic roof",

      "equipment.sensor.lane": "Lane departure warning system",

      "equipment.sensor.proximity": "Distance control assist system",

      "equipment.sensor.rain": "Rain sensor",

      "equipment.start-stop": "Start-stop system",

      "equipment.sunroof": "Sunroof",

      "equipment.traction": "Traction control",

      "equipment.trailor": "Trailer coupling",

      "equipment.wheels.alloy": "Alloy wheels",

      "error": "Something went wrong. Please try again. Thanks!",

      "error.new.password.wrong": "Invalid password. Please try to enter your password for the booking system again.",

      "feature.gate.register.title": "UNLOCK YOUR AREA",

      "feature.gate.register.url": "https://www.get-a-way.com/",

      "feature.gate.start": "2018-01-18",

      "feature.gate.submit": "START",

      "feature.gate.zip.error": "This postal code is not yet activated, get an invitation code now.",

      "feature.gate.zipcodes": "10589",

      "fees.url": "https://get-a-way.com/entgelte",

      "finish.rental.refreshButton": "Refresh",

      "finished.rental.carkey.description": "Please make sure that the car key is in the glove compartment.",

      "finished.rental.carkey.title": "Car key",

      "finished.rental.checkBelongings.button": "FINISHED",

      "finished.rental.checkBelongings.title": "Check for personal belongings.",

      "finished.rental.doors.description": "Please make sure that all the doors \nand windows are closed",

      "finished.rental.doors.title": "Doors & windows",

      "finished.rental.fuelLevel.description": "Please refuel the vehicle (free with provided fuel card) before finishing the rental. Else fees (<25%: 5€; <10%: 50€) might apply.",

      "finished.rental.fuelLevel.title": "Low fuel level",

      "finished.rental.fuelcard.description": "Please return the fuel card to the box in the glove compartment.",

      "finished.rental.fuelcard.title": "Fuel card",

      "finished.rental.location.button": "GET DIRECTIONS",

      "finished.rental.location.description": "Too far from the return area! Please check the return area or finish the rental regardless; Fees may apply.",

      "finished.rental.location.force": "Force finish",

      "finished.rental.location.title": "Return area",

      "finished.rental.locked.button": "LOCK",

      "finished.rental.locked.description": "Please lock the car from the outside to continue and make sure all doors and windows are locked.",

      "finished.rental.locked.title": "Lock vehicle from outside",

      "finished.rental.thank.you.button": "YES",

      "finished.rental.thank.you.description": "Please take the key from the glove \ncompartment.",

      "firstSteps.address.billing.title": "Alternative billing address",

      "firstSteps.address.city.placeholder": "City",

      "firstSteps.address.country.placeholder": "Country",

      "firstSteps.address.instructions": "Please note that this must be your current registration address.",

      "firstSteps.address.optimized.title": "Current registration address",

      "firstSteps.address.personalInfo": "Personal Information",

      "firstSteps.address.postalCode.placeholder": "Post code",

      "firstSteps.address.search.text": "Search address",

      "firstSteps.address.streetName.placeholder": "Street",

      "firstSteps.address.streetNum.placeholder": "No.",

      "firstSteps.address.subTitle": "Registered address",

      "firstSteps.address.submitBtn.text": "Add",

      "firstSteps.address.title": "Registered address",

      "firstSteps.email.code.placeholder": "Verification code",

      "firstSteps.payment.bic.placeholder": "BIC",

      "firstSteps.payment.optimized.sepa.desc": "For secure and convenient payments by direct debit, please enter your IBAN.",

      "firstSteps.payment.optimized.sepa.title": "Direct debit",

      "firstSteps.payment.sepa.description.text": "I hereby grant teilauto.app (im Auftrag der teilAuto eG) and its payment service provider Adyen N.V. (Creditor ID NL48ZZZ342764500000) a direct debit authorization as a SEPA direct debit mandate for the collection of payments due and instruct my financial institution to redeem the direct debits drawn on my account. I can demand reimbursement of the debited amount within eight weeks of the debit date. The conditions agreed with my bank apply. I agree to the shortening of the deadline for the pre-notification of future SEPA direct debits to one (1) calendar day.",

      "firstSteps.payment.sepa.iban.placeholder": "enter IBAN manually",

      "firstSteps.payment.sepa.info": "Consent to direct debit",

      "firstSteps.payment.sepa.instruction": "For secure and convenient payments by direct debit, please enter your IBAN.",

      "firstSteps.payment.sepa.name.placeholder": "Account holder",

      "firstSteps.payment.sepa.submit.text": "Add",

      "firstSteps.payment.sepa.title": "Direct debit",

      "firstSteps.payment.sepa.url": "https://google.com",

      "firstSteps.payment.sepa.url.text": "More",

      "firstSteps.phone.code.placeholder": "SMS verification code",

      "fleetadmin.admins.admin.new": "Create new admin",

      "fleetadmin.admins.info.account": "Account",

      "fleetadmin.admins.info.active": "active",

      "fleetadmin.admins.info.archive": "Archive account",

      "fleetadmin.admins.info.cancel": "Cancel",

      "fleetadmin.admins.info.created": "Created at",

      "fleetadmin.admins.info.createdby": "Created by",

      "fleetadmin.admins.info.delete.title": "Are you sure you want to delete this admin?",

      "fleetadmin.admins.info.deleted": "archived",

      "fleetadmin.admins.info.email": "Email address",

      "fleetadmin.admins.info.firstName": "First Name",

      "fleetadmin.admins.info.language": "System language",

      "fleetadmin.admins.info.lastName": "Last Name",

      "fleetadmin.admins.info.merchant": "Client account",

      "fleetadmin.admins.info.status": "Account status",

      "fleetadmin.admins.info.update": "Update",

      "fleetadmin.admins.info.update.title": "Update user info",

      "fleetadmin.admins.info.user": "User",

      "fleetadmin.admins.permission.automatically": "Add new automatically ",

      "fleetadmin.admins.permission.claimsmanager": "damage claims",

      "fleetadmin.admins.permission.clear.all": "Remove all",

      "fleetadmin.admins.permission.fleet.title": "Fleet Management",

      "fleetadmin.admins.permission.fleetmanager": "vehicles and areas",

      "fleetadmin.admins.permission.mechanic": "Mechanic (G-Connect)",

      "fleetadmin.admins.permission.merchant.title": "Merchant and Brand Management",

      "fleetadmin.admins.permission.merchantmanager": "Admin user administration",

      "fleetadmin.admins.permission.select.all": "Add all",

      "fleetadmin.admins.permission.tripsmanager": "Trips and Reservations",

      "fleetadmin.admins.permission.user.title": "User Management",

      "fleetadmin.admins.permission.usergroupsmanager": "User Circles",

      "fleetadmin.admins.permission.usermanager": "End user",

      "fleetadmin.admins.permissions.update": "Update",

      "fleetadmin.admins.tab.info": "Info",

      "fleetadmin.admins.tab.permissions": "Permissions",

      "fleetadmin.admins.table.access": "Permission",

      "fleetadmin.admins.table.blocked": "Status",

      "fleetadmin.admins.table.created": "Created at",

      "fleetadmin.admins.table.email": "Email",

      "fleetadmin.admins.table.firstname": "First name",

      "fleetadmin.admins.table.fleets": "Assigned Fleets",

      "fleetadmin.admins.table.full": "Unlimited",

      "fleetadmin.admins.table.fullaccess": "Access",

      "fleetadmin.admins.table.lastname": "Last name",

      "fleetadmin.admins.table.limited": "Limited",

      "fleetadmin.allAroundModal.noImage": "This image is not available",

      "fleetadmin.area.noCoordinations": "No coordinations data",

      "fleetadmin.areaList.title": "Area",

      "fleetadmin.areaListItem.updated": "{date} by {username}",

      "fleetadmin.blockReasons.needsAccessKitCheck": "Needs AccessKit check",

      "fleetadmin.blockReasons.needsBattery": "Needs Battery",

      "fleetadmin.blockReasons.needsCleaning": "Needs Cleaning",

      "fleetadmin.blockReasons.needsFuel": "Needs Fuel",

      "fleetadmin.blockReasons.needsFuelCard": "Needs FuelCard Check",

      "fleetadmin.blockReasons.needsKeyFob": "Needs KeyFob check",

      "fleetadmin.blockReasons.needsOther": "Needs other service",

      "fleetadmin.blockReasons.needsRelocation": "Needs Relocation",

      "fleetadmin.blockReasons.needsRepair": "Needs Repair",

      "fleetadmin.booking.blockreasons.label": "Block reasons",

      "fleetadmin.booking.button.assign": "Assign",

      "fleetadmin.booking.button.cancel": "Cancel",

      "fleetadmin.booking.button.update": "Update",

      "fleetadmin.booking.create.button": "Create",

      "fleetadmin.booking.create.duration": "Duration",

      "fleetadmin.booking.create.plate": "Car plate",

      "fleetadmin.booking.create.title": "Create new booking ",

      "fleetadmin.booking.create.type": "Type",

      "fleetadmin.booking.create.type.offline": "End user",

      "fleetadmin.booking.create.type.service": "Service",

      "fleetadmin.booking.create.user": "User",

      "fleetadmin.booking.create.user.placeholder": "email",

      "fleetadmin.booking.statuschange.label": "Note",

      "fleetadmin.booking.type.offline": "Offline",

      "fleetadmin.booking.type.rental": "Rental",

      "fleetadmin.booking.type.service": "service",

      "fleetadmin.booking.type.statusChange": "Status change",

      "fleetadmin.booking.update.from.label": "Start",

      "fleetadmin.booking.update.from.title": "Update booking start and end date ? ",

      "fleetadmin.booking.update.to.label": "End",

      "fleetadmin.booking.update.to.title": "Update booking times",

      "fleetadmin.booking.update.user.title": "Update booking user",

      "fleetadmin.booking.update.vehicle.label": "car plate",

      "fleetadmin.booking.update.vehicle.title": "Assign new vehicle to booking ? ",

      "fleetadmin.booking.user.label": "Assigned user",

      "fleetadmin.booking.user.placeholder": "User email",

      "fleetadmin.bookingStatus.cancelled": "Cancelled",

      "fleetadmin.bookingStatus.confirmed": "Confirmed",

      "fleetadmin.bookingStatus.finished": "Finished",

      "fleetadmin.bookingStatus.offered": "Offered",

      "fleetadmin.bookingStatus.started": "Started",

      "fleetadmin.bookingStatus.waiting": "Waiting",

      "fleetadmin.car.areaNotAssigned": "Not assigned",

      "fleetadmin.car.noPositionData": "No position data",

      "fleetadmin.car.status.clear.note": "Clear status note ",

      "fleetadmin.car.status.range.instant": "Immediately",

      "fleetadmin.carEditor.areaSelector.placeholder": "Select area",

      "fleetadmin.carEditor.batteryVoltage": "Battery",

      "fleetadmin.carEditor.blockReasons": "Block reasons",

      "fleetadmin.carEditor.carKey": "Car key",

      "fleetadmin.carEditor.enginePower": "Engine power",

      "fleetadmin.carEditor.enginePowerUnit": "KW",

      "fleetadmin.carEditor.fleet": "Fleet",

      "fleetadmin.carEditor.fuel": "Fuel",

      "fleetadmin.carEditor.fuelCard": "Fuel card",

      "fleetadmin.carEditor.fuelCardNumber": "Fuel card number",

      "fleetadmin.carEditor.fuelLevel": "Fuel level",

      "fleetadmin.carEditor.gear": "Gear",

      "fleetadmin.carEditor.initialRegistration": "Initial registration",

      "fleetadmin.carEditor.labelArea": "Area",

      "fleetadmin.carEditor.location": "Location",

      "fleetadmin.carEditor.lock": "Lock",

      "fleetadmin.carEditor.mileage": "Mileage",

      "fleetadmin.carEditor.missing": "missing",

      "fleetadmin.carEditor.model": "Model",

      "fleetadmin.carEditor.noNotes": "There are no notes available for this vehicle.",

      "fleetadmin.carEditor.plate": "Plate",

      "fleetadmin.carEditor.pollutionBadge": "Pollution badge",

      "fleetadmin.carEditor.release": "Release the vehicle",

      "fleetadmin.carEditor.resetBluetooth": "Reset Bluetooth",

      "fleetadmin.carEditor.resetBoard": "Reset Board",

      "fleetadmin.carEditor.resetGPRS": "Reset GPRS",

      "fleetadmin.carEditor.resetModem": "Reset Modem",

      "fleetadmin.carEditor.unlock": "Unlock",

      "fleetadmin.carEditor.unrelease": "Unrelease. Make unavailable",

      "fleetadmin.carEditor.update": "Pull status",

      "fleetadmin.carEditor.vin": "VIN",

      "fleetadmin.carList.title": "Vehicle",

      "fleetadmin.carStatus.BLOCKED": "blocked",

      "fleetadmin.carStatus.EQUIPMENT_READY": "equipmentReady",

      "fleetadmin.carStatus.EQUIPPED": "equipped",

      "fleetadmin.carStatus.RELEASED": "released",

      "fleetadmin.carStatus.RELEASE_READY": "releaseReady",

      "fleetadmin.carStatus.REMOVED": "removed",

      "fleetadmin.carStatus.RENTED": "inRental",

      "fleetadmin.carStatus.TERMINATED": "terminated",

      "fleetadmin.circle.action.header": "Action",

      "fleetadmin.circle.code.header": "Code",

      "fleetadmin.circle.email.header": "Email",

      "fleetadmin.circle.name.header": "Name",

      "fleetadmin.circleList.circleCode": "Code: {circleCode}",

      "fleetadmin.circleList.fleets": "{totalFleets} Fleets",

      "fleetadmin.circleList.members": "{totalUsers} Members",

      "fleetadmin.circleList.title": "Circle",

      "fleetadmin.claim.after": "After",

      "fleetadmin.claim.invoice.create": "Create the invoice",

      "fleetadmin.claim.invoice.created": "Created invoice",

      "fleetadmin.claim.invoice.wontinvoice": "Closed as won't invoice",

      "fleetadmin.claim.noPositionData": "No position data",

      "fleetadmin.claim.section.complete": "Complete the claim",

      "fleetadmin.claim.section.completed": "Completed",

      "fleetadmin.claim.section.incomplete": "Closed as incomplete",

      "fleetadmin.claimStatus.closed": "Closed",

      "fleetadmin.claimStatus.closed_settled": "Closed",

      "fleetadmin.claimStatus.completed": "Completed",

      "fleetadmin.claimStatus.confirmed": "Confirmed",

      "fleetadmin.claimStatus.inProgress": "In progress",

      "fleetadmin.claimStatus.open": "Open",

      "fleetadmin.claimStatus.tag.closed": "Closed",

      "fleetadmin.claimStatus.tag.completed": "Completed",

      "fleetadmin.claimStatus.tag.confirmed": "Confirmed",

      "fleetadmin.claimStatus.tag.inProgress": "In progress",

      "fleetadmin.claimStatus.tag.open": "Open",

      "fleetadmin.damage.component.bumber": "Stoßstange",

      "fleetadmin.damage.component.bumper": "Stoßstange",

      "fleetadmin.damage.component.door": "Tür",

      "fleetadmin.damage.component.engineBonnet": "Motorhaube",

      "fleetadmin.damage.component.exteriorMirror": "Spiegel",

      "fleetadmin.damage.component.floor": "Boden",

      "fleetadmin.damage.component.header": "Bauteil",

      "fleetadmin.damage.component.hubcap": "Radkappe",

      "fleetadmin.damage.component.interiorTrim": "Innenverkleidung",

      "fleetadmin.damage.component.other": "Anderes",

      "fleetadmin.damage.component.rearWindow": "Fenster",

      "fleetadmin.damage.component.seat": "Sitz",

      "fleetadmin.damage.component.sill": "Schweller",

      "fleetadmin.damage.component.trunk": "Ladefläche",

      "fleetadmin.damage.component.wheelRim": "Felge",

      "fleetadmin.damage.component.windscreen": "Frontscheibe",

      "fleetadmin.damage.component.wing": "Kotflügel",

      "fleetadmin.damage.index.header": "#",

      "fleetadmin.damage.location.center": "mittig",

      "fleetadmin.damage.location.front": "vorne",

      "fleetadmin.damage.location.header": "Lage",

      "fleetadmin.damage.location.rear": "hinten",

      "fleetadmin.damage.side.center": "Mitte",

      "fleetadmin.damage.side.coDriversSide": "Beifahrer",

      "fleetadmin.damage.side.driversSide": "Fahrer",

      "fleetadmin.damage.side.header": "Seite",

      "fleetadmin.damage.where.exterior": "Außen",

      "fleetadmin.damage.where.header": "In/Ex",

      "fleetadmin.damage.where.interior": "Innen",

      "fleetadmin.damageModal.noImage": "There are no pictures available for this Damage Report.",

      "fleetadmin.deviceStatus.offline": "Offline",

      "fleetadmin.deviceStatus.online": "Online",

      "fleetadmin.error.reset": "Reset",

      "fleetadmin.error.unknown1": "An unexpected error has occurred. We were notified automatically and will fix it soon 💪",

      "fleetadmin.error.unknown2": "If you need assistance pls contact our SupportTeam via {email} or {number} (#1)",

      "fleetadmin.event.areaChanged": "Area changed",

      "fleetadmin.event.bookingAssigned": "Booking assigned",

      "fleetadmin.event.borderCrossing": "Border crossed",

      "fleetadmin.event.checkedIn": "checked IN",

      "fleetadmin.event.checkedOut": "checked OUT",

      "fleetadmin.event.damageRecordUpdated": "Damage claimed",

      "fleetadmin.event.ignitionChanged": "Ignition changed",

      "fleetadmin.event.ignitionOff": "Ignition OFF",

      "fleetadmin.event.ignitionOffFinally": "Ignition OFF (finally)",

      "fleetadmin.event.ignitionOn": "Ignition ON",

      "fleetadmin.event.ignitionOnInitially": "Ignition ON (initially)",

      "fleetadmin.event.lockChanged": "Lock changed",

      "fleetadmin.event.locked": "Locked",

      "fleetadmin.event.noteAdded": "Note Added",

      "fleetadmin.event.recordAdded": "Record Added",

      "fleetadmin.event.rentalEndImage": "All-around check (final)",

      "fleetadmin.event.rentalStartImage": "All-around check (initial)",

      "fleetadmin.event.serviceNoteAdded": "Service note added",

      "fleetadmin.event.serviceReported": "Service reported",

      "fleetadmin.event.serviceTripImage": "Service image added",

      "fleetadmin.event.shockDetected": "Shock detected",

      "fleetadmin.event.startCarCheckUploaded": "All-around checked",

      "fleetadmin.event.startCarCheckUploaded.description": "4 photos added",

      "fleetadmin.event.statusChanged": "VehicleStatus changed",

      "fleetadmin.event.tripFinished": "Locked (finally)",

      "fleetadmin.event.tripReserved": "Reserved",

      "fleetadmin.event.tripStarted": "Unlocked (initially)",

      "fleetadmin.event.unlocked": "Unlocked",

      "fleetadmin.filter.ADMINS.email": "Email",

      "fleetadmin.filter.ADMINS.firstName": "First Name",

      "fleetadmin.filter.ADMINS.lastName": "Last Name",

      "fleetadmin.filter.AREA.createdAt": "Created at - date",

      "fleetadmin.filter.AREA.fleetId": "Fleet",

      "fleetadmin.filter.AREA.id": "ID (area)",

      "fleetadmin.filter.AREA.kmlFilename": "File name (*.kml)",

      "fleetadmin.filter.AREA.lastUpdatedAt": "Last updated - date",

      "fleetadmin.filter.AREA.lastUpdatedBy": "Last updated - Username",

      "fleetadmin.filter.AREA.name": "Area name",

      "fleetadmin.filter.AREA.numOfVehicle": "Vehicles Count",

      "fleetadmin.filter.BOOKING.offline": "Offline",

      "fleetadmin.filter.BOOKING.presentableId": "ID (booking)",

      "fleetadmin.filter.BOOKING.status": "Status",

      "fleetadmin.filter.BOOKING.type": "booking type",

      "fleetadmin.filter.CARE.areaId": "Area",

      "fleetadmin.filter.CARE.brand": "Brand",

      "fleetadmin.filter.CARE.chassisNumber": "VIN",

      "fleetadmin.filter.CARE.code": "code (service)",

      "fleetadmin.filter.CARE.fleetId": "Fleet",

      "fleetadmin.filter.CARE.id": "ID (service)",

      "fleetadmin.filter.CARE.plate": "Plate",

      "fleetadmin.filter.CARE.serviceTypes": "ServiceItemType",

      "fleetadmin.filter.CARE.status": "Status",

      "fleetadmin.filter.CARE.tripEnd": "Trip end",

      "fleetadmin.filter.CARE.tripStart": "Trip start",

      "fleetadmin.filter.CARE.userReferralCode": "ServiceHero",

      "fleetadmin.filter.CATEGORIES.acrissCode": "Acriss Code",

      "fleetadmin.filter.CATEGORIES.brandId": "Brand",

      "fleetadmin.filter.CATEGORIES.name": "Name",

      "fleetadmin.filter.CATEGORIES.numOfVehicle": "Vehicles Count",

      "fleetadmin.filter.CIRCLE.addressRequired": "Address required",

      "fleetadmin.filter.CIRCLE.circleType": "Type",

      "fleetadmin.filter.CIRCLE.driverLicenseRequired": "driver license required",

      "fleetadmin.filter.CIRCLE.identityApprovalRequired": "Identity approval required",

      "fleetadmin.filter.CIRCLE.name": "Name",

      "fleetadmin.filter.CIRCLE.paymentMethodRequired": "Payment method required",

      "fleetadmin.filter.CLAIM.addedAt": "Created at",

      "fleetadmin.filter.CLAIM.brand": "Brand",

      "fleetadmin.filter.CLAIM.closeReason": "Close reason",

      "fleetadmin.filter.CLAIM.damageId": "ID (claim)",

      "fleetadmin.filter.CLAIM.fleetId": "Fleet",

      "fleetadmin.filter.CLAIM.plate": "Plate",

      "fleetadmin.filter.CLAIM.roadworthiness": "Roadworthiness",

      "fleetadmin.filter.CLAIM.status": "Status",

      "fleetadmin.filter.CLAIM.thirdParty": "3rd-party",

      "fleetadmin.filter.CLAIM.tripIgnition": "Trip ignition",

      "fleetadmin.filter.CLAIM.tripPresentableId": "ID (trip)",

      "fleetadmin.filter.CLAIM.userReferralCode": "Created by",

      "fleetadmin.filter.PRICING.name": "Name",

      "fleetadmin.filter.PROFILE.brandId": "Brand",

      "fleetadmin.filter.PROFILE.brandName": "Brand Name",

      "fleetadmin.filter.PROFILE.model": "Model",

      "fleetadmin.filter.PROFILE.name": "Name",

      "fleetadmin.filter.SHARE.code": "Code (trip)",

      "fleetadmin.filter.SHARE.fleetId": "Fleet",

      "fleetadmin.filter.SHARE.insurance": "Insurance",

      "fleetadmin.filter.SHARE.merchantRef": "ID (contract)",

      "fleetadmin.filter.SHARE.plate": "Plate No.",

      "fleetadmin.filter.SHARE.status": "Status",

      "fleetadmin.filter.SHARE.tripEnd": "Finished at",

      "fleetadmin.filter.SHARE.tripStart": "Started at",

      "fleetadmin.filter.SHARE.userReferralCode": "User",

      "fleetadmin.filter.SHARE.violationLowFuel": "Violation: Low fuel",

      "fleetadmin.filter.SHARE.violationMissingFuelCard": "Violation: Missing fuel card",

      "fleetadmin.filter.SHARE.violationMissionKey": "Violation: Missing key",

      "fleetadmin.filter.SHARE.violationReturnArea": "Violation: Return area",

      "fleetadmin.filter.USERS.email": "Email",

      "fleetadmin.filter.USERS.firstName": "First Name",

      "fleetadmin.filter.USERS.lastName": "Last Name",

      "fleetadmin.filter.USERS.referralCode": "User code",

      "fleetadmin.filter.VEHICLE.areaId": "Area",

      "fleetadmin.filter.VEHICLE.blockReasons": "Block Reasons",

      "fleetadmin.filter.VEHICLE.chassisNumber": "VIN",

      "fleetadmin.filter.VEHICLE.deviceSNR": "Access Kit No.",

      "fleetadmin.filter.VEHICLE.equippedSince": "Equipped At",

      "fleetadmin.filter.VEHICLE.fleetId": "Fleet",

      "fleetadmin.filter.VEHICLE.fuel": "FuelType",

      "fleetadmin.filter.VEHICLE.fuelCardNumber": "FuelCard number",

      "fleetadmin.filter.VEHICLE.fuelLevel": "Fuel status",

      "fleetadmin.filter.VEHICLE.lastStatus.fuelCardIn": "Fuel card In",

      "fleetadmin.filter.VEHICLE.lastStatus.keyFobIn": "Key Fob In",

      "fleetadmin.filter.VEHICLE.model": "Model",

      "fleetadmin.filter.VEHICLE.plate": "Plate",

      "fleetadmin.filter.VEHICLE.rentalCount": "Rental counts",

      "fleetadmin.filter.VEHICLE.status": "Status",

      "fleetadmin.filter.VEHICLE.supportedVehicleConnections": "Access Kit type",

      "fleetadmin.filter.VEHICLE.vehicleConnection": "Active Access Kit type",

      "fleetadmin.filter.numberSearch.lessThan": "less than",

      "fleetadmin.filter.numberSearch.moreThan": "more than",

      "fleetadmin.forgot.button": "Send Email",

      "fleetadmin.forgot.fail": "Network error. Please try it again.",

      "fleetadmin.forgot.form.placeholder": "Enter your email",

      "fleetadmin.forgot.success": "Please check your email: {email}",

      "fleetadmin.forgot.title": "Forgot Password",

      "fleetadmin.header.admins": "Admins",

      "fleetadmin.header.area": "Areas",

      "fleetadmin.header.capability": "Capability",

      "fleetadmin.header.care": "FleetCare",

      "fleetadmin.header.categories": "VehicleCategories",

      "fleetadmin.header.circle": "Groups",

      "fleetadmin.header.claim": "Claims",

      "fleetadmin.header.fleetControl": "Fleet control",

      "fleetadmin.header.pricing": "Pricing",

      "fleetadmin.header.profile": "Vehicle Profile",

      "fleetadmin.header.settings": "Settings",

      "fleetadmin.header.share": "FleetShare",

      "fleetadmin.header.userControl": "User control",

      "fleetadmin.header.users": "Users",

      "fleetadmin.header.vehicle": "Vehicles",

      "fleetadmin.login.button": "Log in",

      "fleetadmin.login.checkbox": "Remember me",

      "fleetadmin.login.form1.placeholder": "Enter your email",

      "fleetadmin.login.form2.placeholder": "Enter your password",

      "fleetadmin.login.linkToForgot": "Forgot password?",

      "fleetadmin.login.title": "Login",

      "fleetadmin.logoutConfirm.text": "When you click OK, you will be logout. You have to login again.",

      "fleetadmin.logoutConfirm.title": "Are you sure to logout?",

      "fleetadmin.password.button": "Reset Password",

      "fleetadmin.password.fail": "Network error. Please try it again.",

      "fleetadmin.password.form1.placeholder": "New password",

      "fleetadmin.password.form2.placeholder": "Confirm Password",

      "fleetadmin.password.invalidToken": "Link is invalid. Please request new one.",

      "fleetadmin.password.linkToForgot": "Request Email again",

      "fleetadmin.password.success": "Success to set the password",

      "fleetadmin.password.title": "Create Password",

      "fleetadmin.releaseModal.confirm": "Confirm release",

      "fleetadmin.releaseModal.title": "Release vehicle to:",

      "fleetadmin.searchBox.area.label": "AREA",

      "fleetadmin.searchBox.area.placeholder": "Select area",

      "fleetadmin.searchBox.brand.label": "BRAND",

      "fleetadmin.searchBox.brand.placeholder": "Select brand",

      "fleetadmin.searchBox.fallback.placeholder": "Select values",

      "fleetadmin.searchBox.fleet.label": "FLEET",

      "fleetadmin.searchBox.fleet.placeholder": "Select fleet",

      "fleetadmin.searchBox.numberOfAreas": "Areas ({number})",

      "fleetadmin.searchBox.numberOfVehicles": "Vehicles ({number})",

      "fleetadmin.searchBox.resetButton": "Reset filters",

      "fleetadmin.searchBox.serviceHero.label": "SERVICE ANGEL",

      "fleetadmin.searchBox.serviceHero.placeholder": "Select service angel",

      "fleetadmin.searchBox.serviceStatus.label": "SERVICE STATUS",

      "fleetadmin.searchBox.serviceStatus.placeholder": "Select service status",

      "fleetadmin.searchBox.status.label": "STATUS",

      "fleetadmin.searchBox.status.placeholder": "Select car status",

      "fleetadmin.searchBox.text.label": "SEARCH",

      "fleetadmin.searchBox.text.placeholder": "Input search text",

      "fleetadmin.serviceStatus.CLOSED": "Closed",

      "fleetadmin.serviceStatus.IN_PROGRESS": "In progress",

      "fleetadmin.serviceStatus.OPEN": "Open",

      "fleetadmin.serviceStatus.PLANNED": "Planned",

      "fleetadmin.serviceStatus.closed": "Closed",

      "fleetadmin.serviceStatus.inProgress": "InProgress",

      "fleetadmin.serviceStatus.open": "Open",

      "fleetadmin.serviceStatus.planned": "Planned",

      "fleetadmin.serviceType.basicBranding": "Basic Branding",

      "fleetadmin.serviceType.basicCarPhotos": "Basic Car Photos",

      "fleetadmin.serviceType.basicDamageRecords": "Schadensakte",

      "fleetadmin.serviceType.batteryChangeOpening": "Batteriewechsel (mit Notfallöffnung)",

      "fleetadmin.serviceType.batteryChangeSimple": "Batteriewechsel (einfach)",

      "fleetadmin.serviceType.cleanOutsideDry": "Außenreinigung (trocken)",

      "fleetadmin.serviceType.comboPremium": "comboPremium",

      "fleetadmin.serviceType.comboPro": "comboPro",

      "fleetadmin.serviceType.comboRefuelWashInside": "comboRefuelWashInside",

      "fleetadmin.serviceType.comboRefuelWashOutside": "comboRefuelWashOutside",

      "fleetadmin.serviceType.comboRefuelWashTotal": "comboRefuelWashTotal",

      "fleetadmin.serviceType.dashboardCleaning": "Lüftungsschlitze und Ablagen intensiv reinigen",

      "fleetadmin.serviceType.desinfektion": "Desinfektion",

      "fleetadmin.serviceType.exchangeFuelCard": "Exchange Fuel Card",

      "fleetadmin.serviceType.extra10min": "Sonderreinigungszeit, je 10 Min",

      "fleetadmin.serviceType.grillCleaning": "Kühlergrill-Reinigung",

      "fleetadmin.serviceType.highGlossFinish": "Hochglanz-Finish mit Lackversiegelung",

      "fleetadmin.serviceType.otherBasicService": "Other Basic Service",

      "fleetadmin.serviceType.refuel": "Betankung",

      "fleetadmin.serviceType.relocate": "Verlegungsfahrt",

      "fleetadmin.serviceType.relocation": "Verlegungsfahrt",

      "fleetadmin.serviceType.relocationEndLt24": "Zustellung innerhalb von 24 Std.",

      "fleetadmin.serviceType.relocationStartOnTime": "Abholung innerhalb von 30 Min.",

      "fleetadmin.serviceType.rimsCleaning": "Felgen-Intensivpflege",

      "fleetadmin.serviceType.safetyCheck": "Safety-Check",

      "fleetadmin.serviceType.tirePressure": "Reifendruck",

      "fleetadmin.serviceType.vacuumCleaning": "Kofferraum und Fußmatten intensiv saugen",

      "fleetadmin.serviceType.washInside": "Innenreinigung",

      "fleetadmin.serviceType.washOutside": "Außenreinigung (nass)",

      "fleetadmin.serviceType.windshieldFluidRefill": "Auffüllen des Scheibenwischwassers",

      "fleetadmin.sideMenu.admins": "Admins",

      "fleetadmin.sideMenu.area": "Areas",

      "fleetadmin.sideMenu.capabilities": "CAPABILITIES",

      "fleetadmin.sideMenu.claim": "Claims",

      "fleetadmin.sideMenu.fleetCare": "FleetCare",

      "fleetadmin.sideMenu.fleetCategories": "Vehicle Categories",

      "fleetadmin.sideMenu.fleetCircles": "Groups",

      "fleetadmin.sideMenu.fleetControl": "FLEET CONTROL",

      "fleetadmin.sideMenu.fleetPricing": "Pricing",

      "fleetadmin.sideMenu.fleetProfiles": "Vehicle Profiles",

      "fleetadmin.sideMenu.fleetSettings": "SETTINGS",

      "fleetadmin.sideMenu.fleetShare": "FleetShare",

      "fleetadmin.sideMenu.fleetShare.bookings": "Reservations",

      "fleetadmin.sideMenu.fleetShare.bookings.cancelled": "Cancelled",

      "fleetadmin.sideMenu.fleetShare.bookings.confirmed": "Upcoming",

      "fleetadmin.sideMenu.fleetShare.trips": "Trips",

      "fleetadmin.sideMenu.logout": "Logout",

      "fleetadmin.sideMenu.phoneReport": "PhoneReport",

      "fleetadmin.sideMenu.reports": "REPORTS",

      "fleetadmin.sideMenu.userControl": "USER CONTROL",

      "fleetadmin.sideMenu.users": "Users",

      "fleetadmin.sideMenu.vehicle": "Vehicles",

      "fleetadmin.sideMenu.vehicle.all": "All",

      "fleetadmin.sideMenu.vehicle.archived": "Archived",

      "fleetadmin.support.email": "fleet-support@getaway.pro",

      "fleetadmin.support.number": "+49 30 30808441",

      "fleetadmin.trip.allAround.title": "“All-around check” record /",

      "fleetadmin.trip.info.backby.label": "Return time",

      "fleetadmin.trip.info.tripstarted.label": "Started At",

      "fleetadmin.trip.serviceImage.modal.title": "Service Images",

      "fleetadmin.trip.update.backby.label": "Return time",

      "fleetadmin.trip.update.backby.title": "Update trip return time ?",

      "fleetadmin.tripStatus.cancelled": "Cancelled",

      "fleetadmin.tripStatus.done": "Done",

      "fleetadmin.tripStatus.expired": "Expired",

      "fleetadmin.tripStatus.in_progress": "In progress",

      "fleetadmin.tripStatus.reserved": "Reserved",

      "fleetadmin.updateStatusModal.BLOCKED": "Blocked",

      "fleetadmin.updateStatusModal.RELEASED": "Released",

      "fleetadmin.updateStatusModal.RELEASE_READY": "ReleaseReady",

      "fleetadmin.updateStatusModal.reasonPlaceholder": "Select reason (multiple choice)",

      "fleetadmin.updateStatusModal.statusPlaceholder": "Select status",

      "fleetadmin.users.create.title": "Create user",

      "fleetadmin.users.info.upsellings.servicepaket300sb": "Service-Paket",

      "fleetadmin.validation.invalidEmail": "Please enter a valid email address.",

      "fleetadmin.validation.invalidPassword": "Min. 8 characters (incl. 1 cap/ lowercase/ no./ special sign)",

      "fleetadmin.validation.notIdentical": "Must match the previous entry",

      "fleetadmin.validation.required": "This field can't be empty",

      "fleetadmin.violationType.fuelCardMissing": "Fuel card missing",

      "fleetadmin.violationType.keyMissing": "key missing",

      "fleetadmin.violationType.lowFuelLevel": "Low fuel (service)",

      "fleetadmin.violationType.returnedOutsideArea": "Return area (service)",

      "for": "detailed pricing please checkout %s",

      "forget.email": "Forgot your email?",

      "forget.email.desc": "Enter your phone number that you've registered with your account. You will receive a verification code via SMS.",

      "forget.email.title": "Forgot your email address?",

      "forgot.email.desc": "Enter your phone number that you've registered with your account. You will receive a verification code via SMS.",

      "forgot.email.dialog.title": "In order to find your email address, we will ask you in the next step to authenticate yourself using the mobile phone number you have provided.",

      "forgot.email.dialog.yes": "Continue",

      "forgot.email.title": "Forgotten your e-mail address?",

      "form.31MgGL.1.desc": "This is important information for participation in our bonus programs.",

      "form.31MgGL.1.title": "Have you been referred?",

      "form.3yYJ8x.1.desc": "If you live in the property of one of our real estate partners\nplease select the relevant partner.",

      "form.3yYJ8x.1.title": "Choose a real estate partner",

      "form.3yYJ8x.2.desc": "At which location do you expect to use our service\ndo you expect to use our service most frequently?",

      "form.3yYJ8x.2.title": "Choose location",

      "form.woGyQx.1.desc": "This information is important for participation in our\nbenefit programs.",

      "form.woGyQx.1.title": "Have you been recruited?",

      "from": "from",

      "fuel.card.view.btn.txt": "Continue",

      "fuel.card.view.description": "Please pick the connected fuel card to continue",

      "fuel.card.view.search.label": "Fuel Card",

      "fuel.card.view.title": "Connect the FuelCard",

      "fuelstation.an.name": "Aral",

      "fuelstation.ap.name": "AP",

      "fuelstation.aral.name": "ARAL",

      "fuelstation.aral.title": "Aral fuel station",

      "fuelstation.avanti.name": "Avanti",

      "fuelstation.bp.name": "BP",

      "fuelstation.eni.name": "Eni",

      "fuelstation.help.text": "help with fueling",

      "fuelstation.om.name": "OMV",

      "fuelstation.omv.name": "OMV",

      "fuelstation.openallday": "opened 24h",

      "fuelstation.opennow": "Open now: ",

      "fuelstation.openstoday": "Opens today: ",

      "fuelstation.openstomorrow": "Opens tomorrow: ",

      "fuelstation.status.prefix": "fuel station",

      "fuelstation.total.name": "Total",

      "fuelstation.totalenergies.name": "Total Energies",

      "fuelstation.westfalen.name": "Westfalen",

      "gas.station.note.text": "Refueling is included in the rental price. There is a fuel card in every vehicle, which you can use to fill up without cash at all partner filling stations. The PIN for payment is displayed via the app.",

      "handover.all.around.confirm": "Agree & continue",

      "handover.all.around.no": "Take all-round photos",

      "handover.all.around.warning": "I am aware of them and expressly agree to the following obligations to cooperate:\n\n\n✓ Obligation to provide documentation: Without photo documentation, the vehicle is deemed not to be properly documented upon return. I acknowledge that any damage discovered subsequently that was not listed in the damage list before the start of the journey can be attributed to me, unless I can prove the condition otherwise.\n\n\n✓ Obligation to forward: I undertake to send the 4 all-round photos immediately by e-mail to Customer Support. If any new damage found on the photos after the end of the rental period due to poor quality (e.g. blurring, darkness or wrong angle) cannot be ruled out beyond doubt, I can be held liable for this damage.\n\n\n✓ Obligation to store: In addition, I undertake to store these photos digitally for a period of 90 days from the end of the rental period and to make them available to the landlord again at any time upon request.",

      "handover.belonging.title": "All belongings taken",

      "handover.belongings.button.title": "I have my things out",

      "handover.belongings.decr": "Please make sure you have everything out of the car before continuing.",

      "handover.belongings.title": "Please check your belongings.",

      "handover.bottom.description": "You will find the car key in the glove compartment",

      "handover.carCheck.title": "All-around photos taken",

      "handover.card.title": "The fuel card has been returned",

      "handover.damages.count": "%d Damages",

      "handover.demages.description": "Listed damages",

      "handover.dongle.card.title": "put back fuel card",

      "handover.dongle.key.title": "Give back key",

      "handover.doorsWidows.title": "Nothing forgotten & got off",

      "handover.doorsWindows.title": "I took my personal belongings and stepped out of the vehicle",

      "handover.engine.dialog.message": "Simply start the engine to confirm the handover check. You'll find the key in the glove compartment.",

      "handover.engine.dialog.title": "Start the engine",

      "handover.fuel.title": "I choose refuel service",

      "handover.fuelCard.button.title": "Refresh",

      "handover.fuelCard.decr": "Please make sure that the fuel card is in the glove compartment.",

      "handover.fuelCard.title": "Fuel card has been returned",

      "handover.key.title": "The key has been returned",

      "handover.location.button.title": "Show return location",

      "handover.location.decr": "Now the car is not in its return location. Please return it before finishing the rental.",

      "handover.location.option": "Drive yourself",

      "handover.location.title": "Return location",

      "handover.location.warning": "I am willing to pay 500 €",

      "handover.lock.button.title": "Lock the car",

      "handover.lock.locking": "Locking ...",

      "handover.lock.title": "Shut all doors and windows and lock the vehicle from outside",

      "handover.lowFuel.button.title": "Locate next gas station",

      "handover.lowFuel.decr": "Please refuel the car before finishing the rental. Contact our service team if you need help.",

      "handover.lowFuel.option": "Refuel yourself",

      "handover.lowFuel.title": "Low fuel level",

      "handover.lowFuel.warning": "I am willing to pay 50 €.",

      "handover.lowfuel.fee": "I choose the tank service (%s)",

      "handover.payAsReserved.prefix": "Zahlungspflichtig bis",

      "handover.report": "Report a damage or infringement",

      "handover.returnKey.button.title": "Refresh",

      "handover.returnKey.decr": "Please make sure that the car key is in the glove compartment.",

      "handover.returnKey.title": "Return car key ",

      "handover.returnLocation.title": "I choose the return service",

      "handover.title": "Start the engine",

      "handover.top.description": "If the car is free of damages aside from the already reported ones, start the engine and have a safe trip!",

      "handover.unlock.description": "Your rental wasn't finished, please try to unlock and try again. If you still have a problem please contact our service team.",

      "handover.unlock.slider.title": "Open vehicle",

      "handover.unlock.title": "Something went wrong!",

      "handover.warning.message": "Risk associated with poor photo quality: If new damage identified after the end of the rental cannot be ruled out beyond doubt in the photos due to poor quality (e.g. blurriness, darkness or incorrect angle), I may be held liable for this damage.",

      "help.dialog.chat": "LiveChat",

      "help.dialog.helpcenter": "HelpCenter",

      "help.dialog.title": "Contact Service Team",

      "heyOBI.heyOBI.pricing": "| Rental period ||\n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | ~~19.99~~ €16.99/hour (incl. 20km/hour) |\n| Mon-Sat, 8pm-8am | ~~59.90~~ €50.92 (incl. 100km) |\n| Sat, 8pm - Mon, 8am | ~~139.90~~ €102.00 (incl. 150km) |\n| On public holidays | ~~59.90~~ €50.92 (incl. 100km) |\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| per additional kilometer | 0,30 € |\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 €/rental |\n| Return outside the zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Border crossing fee | 7,50 € / day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Fuel level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).",

      "home.about": "© GETAWAY, legal info ",

      "home.button.title": "Get started",

      "home.walkthrough.guest": "Als Gast fortfahren",

      "home.walkthrough.login": "Login",

      "home.walkthrough.map.signup": "Log in",

      "home.walkthrough.signup": "Get started",

      "hour": "hour",

      "hours": "hours",

      "hours.short": "hrs",

      "iban": "IBAN",

      "id.card.country.not.valid": "Online document verification is not possible for other countries. Do you have any questions? Simply contact our support team.",

      "id.rejected.title": "Please pay attention to the following note on your previously submitted document:",

      "id.tab.card": "ID Card",

      "id.tab.passport": "Passport",

      "ikeaInnsbruck.ubeeqo.pricing": "| Rental period (9:30 a.m. to 9 p.m.) | |\n| :-------- | -------: |\n| hour 1 to 4 | 7,90 €/hour|\n| from 5th hour | 9,90 €/hour|\n\n\n| night surcharge (9 p.m. to 9:30 a.m.) | |\n| :-------- | -------: |\n| Mon - Fri | +20 €|\n| Sat - Mon | +89 €|\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,39 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf).",

      "ikeaInnsbruckBub.Buchbinder.pricing": "| Rental period (9:30 a.m. to 9 p.m.) | |\n| :-------- | -------: |\n| hour 1 to 4 | 7,90 €/hour|\n| from 5th hour | 9,90 €/hour|\n\n\n| night surcharge (9 p.m. to 9:30 a.m.) | |\n| :-------- | -------: |\n| Mon - Fri | +20 €|\n| Sat - Mon | +89 €|\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,49 € / km |\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf).",

      "ikeaMain.duration.prefix": ".",

      "ikeaMain.ubeeqo.pricing": "| Rental period | | \n| :-------- | -------: |\n| Hour 1 to 4 | 7,90 €/hour|\n| From 5th hour | 9,90 €/hour|\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf).",

      "ikeaMainBub.Buchbinder.pricing": "|Rental period | |\n| :-------- | -------: |\n| Hour 1 to 4 | 7,90 €/hour|\n| From 5th hour | 9,90 €/hour|\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,49 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/68fe517026116829219fdd72/pdf).",

      "image.upload.success": "Uploaded successfully",

      "input.error.invalid": "Invalid input",

      "input.error.invalidCountry": "Invalid",

      "input.password.error.invalid": "Password must be at least 6 characters, include a number, a capital letter, and a symbol.",

      "insecuredevice.dialog.message": "This smartphone is not paired to your account. To verify it we'll send you a confirmation code via sms to the phone number stored in your account.",

      "insecuredevice.dialog.no": "Not now",

      "insecuredevice.dialog.title": "Verify this smartphone",

      "insecuredevice.dialog.yes": "Verify",

      "installation.cancel.dialog.message": "Are you sure you want to cancel the installation?",

      "installation.cancel.dialog.title": "Cancel installation!",

      "installation.cancel.dialog.yes": "Yes",

      "installed.view.btn.txt": "Start another job",

      "installed.view.duration": "Finished in",

      "installed.view.duration.minutes": "%s Minutes",

      "installed.view.duration.seconds": "%s Seconds",

      "installed.view.title": "One more vehicle connected!",

      "insurance.card.61dd46ad39dc364cd98f6739.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.61e015735925e70e8d972ef2.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.635665e30ad73328ee31a4e3.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.6360f3d14a2bec0c9d4088e6.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.636254dfd40f7c05a6517d5b.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.636ce123e5b01a0ca02d45ef.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.68f3457cacc9b808fc277bb8.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.68fe0e6c3e05fe5524a95644.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.6997422aa61cb20c384efab8.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.69a076f945c6fd1ee157f00d.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.69e8d1871c39133cc07d35c2.subtitle": "max. 500€ excess",

      "insurance.card.69e8d1871c39133cc07d35c2.title": "Minimum protection",

      "insurance.card.69e8d1bb1c39133cc07d35c4.subtitle": "max. 150€ excess",

      "insurance.card.69e8d1bb1c39133cc07d35c4.title": "Best protection",

      "insurance.card.6a7dd8798a03e46ab9d0154d.subtitle": "max. 1500€ excess\n",

      "insurance.card.6a7dd8798a03e46ab9d0154d.title": "Minimum protection",

      "insurance.card.6a7dd8798a03e46ab9d0154f.subtitle": "max. 500€ excess\n",

      "insurance.card.6a7dd8798a03e46ab9d0154f.title": "Protection",

      "insurance.card.6a7dd8798a03e46ab9d01551.subtitle": "max. 150€ excess\n",

      "insurance.card.6a7dd8798a03e46ab9d01551.title": "Best protection",

      "insurance.card.6a881be56c0e2870fcea139f.subtitle": "€0 deductible",

      "insurance.card.6a881be56c0e2870fcea139f.title": "Best protection",

      "insurance.card.6a88487d6c0e2870fcea13c0.subtitle": "Max. €2,800 deductible",

      "insurance.card.6a88487d6c0e2870fcea13c0.title": "Minimal protection",

      "insurance.card.F3008.title": "Best protection",

      "insurance.card.F3040.subtitle": "max. 500€ excess",

      "insurance.card.F3040.title": "Minimum protection",

      "insurance.card.F3041.subtitle": "max. 150€ excess",

      "insurance.card.F3041.title": "Best protection",

      "insurance.charterline.150": "Maximum 150 €",

      "insurance.charterline.1500": "Maximum 1.500 €",

      "insurance.charterline.15000": "Maximum 15.000 €",

      "insurance.charterline.151": "Maximum 150 €",

      "insurance.charterline.500": "Maximum 500 €",

      "insurance.charterline.501": "Maximum 500 €",

      "insurance.charterline.650": "Maximum 650 €",

      "insurance.charterline.750": "Maximum 750 €",

      "insurance.charterline.description": "Co-Payment",

      "insurance.charterline.description.1500": "Up to 15.000 €",

      "insurance.charterline.headline": "Co-Payment",

      "insurance.charterline.value.150": "+24 €/KalTag",

      "insurance.charterline.value.1500": "incl.",

      "insurance.charterline.value.15000": "incl.",

      "insurance.charterline.value.151": "+34 €/CalDay",

      "insurance.charterline.value.500": "+19 €/CalDay",

      "insurance.charterline.value.501": "+29 €/CalDay",

      "insurance.charterline.value.650": "incl.",

      "insurance.charterline.value.750": "incl.",

      "insurance.description": "Max",

      "insurance.description.free": "Up to",

      "insurance.fee_item.description": "Reduzierung SB %s",

      "insurance.label.free": "max. 1.500€",

      "insurance.previous_for_the_same_car_must_be_used": "User should use the same insurance if he rents the same car again.",

      "insurance.rental.title": "Your retention!",

      "insurance.value": "€/CalDay",

      "insurance.value.free": "incl.",

      "internet.disconnected.message": "Please check your internet connection",

      "invitation.code.label": "Invitation code",

      "invitation.code.submit": "Let's get started",

      "invitation.description": "Enter your invitation code to redeem your welcome bonus",

      "invitation.remove.text": "Remove",

      "invitation.submit.text": "APPLY",

      "invitation.text.placeholder": "Invitation Code",

      "invitation.title": "do you have an invitation?",

      "invite.browse.contacts.button": "BROWSE CONTACTS",

      "invite.contacs.success": "Invitations have been sent. We will notify you as soon as your invitations have been accepted.",

      "invite.contact.email.warning": "You need to set up an email account on your device to invite friends via email.",

      "invite.email.description": "GETAWAY is the first professional fleet by drivers for drivers. If you have a car, you can let it earn money and thus cover all your car costs. If you have a driver's license, you can find your dream car anytime and anywhere via app and drive off immediately. Try it out and get €10 starting credit on %@ with my invitation",

      "invite.email.title": "I want you to join GETAWAY",

      "invite.friends.share.button": "SHARE",

      "invite.friends.share.description": "Click and hold to copy your invitation link",

      "invite.message": "Join me on GETAWAY, today. Simply download the app and receive a 10€ welcome bonus with my invitation:",

      "invite.message.title": "You've been invited to join GETAWAY",

      "invoice.footer.issuedBy": "Document issued by:",

      "invoice.footer.page": "PAGE %s OF %s",

      "invoice.intro": "Thank you for using %s! Please find the charged services below.",

      "invoice.intro.credit": "Thank you for your order. For the service period %s we credit the following:",

      "invoice.intro.thanks": "Thank you for using %s!",

      "invoice.issuedOnBehalf": "Document issued on behalf of",

      "invoice.item.f3004": "Rental hour(s) ",

      "invoice.item.f3060": "Deductible reduction (€500) per hour",

      "invoice.item.f9999": "Miscellaneous",

      "invoice.meta.bookingRef": "Reference number:",

      "invoice.meta.customerRef": "Customer reference:",

      "invoice.meta.date": "Document date:",

      "invoice.meta.number": "Document number:",

      "invoice.odometer": "Odometer %s",

      "invoice.payment.heading": "PAYMENT METHOD",

      "invoice.pickup": "PICKUP",

      "invoice.rental.label": "Rental:",

      "invoice.rental.plate": "License plate:",

      "invoice.rental.userGroup": "User group:",

      "invoice.return": "RETURN",

      "invoice.storno": "This cancels the document (attached) %s",

      "invoice.storno.footer": "The cancelled amount is refunded to the beneficiary's original payment method. The beneficiary is responsible for proper taxation.",

      "invoice.table.amountDue": "Amount due",

      "invoice.table.amountRefund": "Amount refunded",

      "invoice.table.grossSum": "Total gross",

      "invoice.table.grossTotal": "GROSS TOTAL",

      "invoice.table.lessCredit": "Less credit",

      "invoice.table.netTotal": "NET TOTAL",

      "invoice.table.qty": "QTY",

      "invoice.table.subtotal": "Subtotals",

      "invoice.table.title": "Rental",

      "invoice.table.unitGross": "GROSS",

      "invoice.table.vatNote": "(incl. VAT %s)",

      "invoice.table.vatPortion": "%s of %s",

      "invoice.title.creditNote": "Credit Note",

      "invoice.title.invoice": "Invoice",

      "joinCircle.title": "Enter the circle",

      "keine": "None",

      "landing.card1.desc": "Enjoy our pay per km billing system and save money and time!",

      "landing.card1.title": "Get any car arounds you \nand drive it around",

      "landing.card2.desc": "We’ve got you covered! List your car and we\ntake care of insurances and other stuf that\nEd needs to brag about here!",

      "landing.card2.title": "List your car and start\nmaking money!",

      "landing.later": "LATER",

      "landing.login": "I already have a user account",

      "landing.signup": "Welcome!",

      "landing.signup.dialog.email.exists": "It seems like you already have an account, do you want to reset your password?",

      "language.dialog.cz": "Čeština (CZ)",

      "language.dialog.de": "Deutsch (DE)",

      "language.dialog.en": "English (EN)",

      "language.dialog.es": "Español (ES)",

      "language.dialog.fr": "Français (FR)",

      "language.dialog.gr": "Ελληνικά (EL)",

      "language.dialog.it": "Italiano (IT)",

      "language.dialog.pl": "Polski (PL)",

      "language.dialog.sk": "slovenský (SK)",

      "language.dialog.title": "Select language",

      "language.dialog.tr": "Türkçe (TR)",

      "late": "late",

      "less": "Less",

      "license.addPhoto.back": "Add driver's license back",

      "license.addPhoto.front": "Add driver's license front",

      "license.addVideo": "Add selfy video",

      "license.addedPhoto.back": "Driver's license back",

      "license.addedPhoto.front": "Driver's license front",

      "license.addedVideo": "Selfy video",

      "license.submit.title": "Further",

      "license.title": "Add driver's license",

      "licenses.title": "Copyright info",

      "list.car.desc": "To check how much your car could earn for you, take a picture of the full front of the car’s registration certificate.",

      "list.car.footer": "This car has a valid vehicle insurance and general inspection.",

      "list.car.license": "Vehicle registration",

      "list.car.ownership.error": "Please select your ownership status for this car",

      "list.car.ownership.message": "If you don't own the car, you need to hand in letter of attorney later. A template will be provided.",

      "list.car.submit": "SUBMIT FOR CHECK",

      "list.car.success": "Thanks. Your car registration license has been submitted. We've sent you an email with the next steps.",

      "list.car.takeaphoto.error": "Please take a photo first",

      "list.car.title": "How much car your car earn?",

      "litre.short": "l",

      "loading": "loading ...",

      "location.permission": "Attention: Enable location services to find and rent vehicles.",

      "location.permission.details": "Please grant GETAWAY access to your location to enable location-based services and to show you available cars around.",

      "location.permission.no": "Later",

      "location.permission.title": "Enable location-based services",

      "location.permission.unauthorized": "Getaway can't work propery without accessing your location.",

      "location.permission.yes": "Allow",

      "lock.error": "We are unable to lock the car, please contact support",

      "login.button.title": "Login",

      "login.email": "Log in with e-mail code instead",

      "login.email.button.title": "Request e-mail code",

      "login.email.desc": "Please enter the e-mail address you used to register. You will then receive an e-mail with a code to log in.",

      "login.email.placeholder": "Email",

      "login.email.title": "Register with e-mail code",

      "login.failed.again.text": "Try again",

      "login.failed.alert.body": "You've entered a wrong email or password. Please try again or click \"Forgot?\" to reset your password.",

      "login.failed.alert.title": "Failed to login",

      "login.footnote.signup.action": "Signup here",

      "login.footnote.signup.text": "Don’t have an account?",

      "login.forgot.desc": "Please enter the e-mail address you used to register. We will then send you an e-mail to reset your password.",

      "login.forgot.text": "Reset password",

      "login.forgot.title": "Forgotten your password?",

      "login.orloginfacebook.text": "Or login with",

      "login.orsignupfacebook.text": "Or sign up with",

      "login.password.placeholder": "Password",

      "login.title": "Good to see you again!",

      "login.with.password": "Log in with password instead",

      "logout.prompty.logout": "YES",

      "mages.510cm": "5 - 10cm",

      "map.blocked.callout": "Vehicle needs maintenance. It's back available soon.",

      "map.booking.reserve": "Reserve",

      "map.bookings.button.text": "Booking from",

      "map.callout.bonus.lowAndOut": "Up to 10€ instant bonus",

      "map.callout.bonus.lowFuel": "5€ instant bonus",

      "map.callout.bonus.lowFuel&out": "Up to 10€ instant bonus",

      "map.car.eligible.description": "[in queue] soon being available",

      "map.car.inqueue.callout": "If more users around sign up I will be available soon.",

      "map.car.release_ready.callout": "Car is currently unavailable, please try another time frame",

      "map.car.release_ready.description": "[currently busy] Please check again, later",

      "map.car.released.callout": "Available until\n%@",

      "map.car.selected.callout": "I will be available very soon. Rent me another day 🙌",

      "map.card.refuel": "Please refuel",

      "map.card.rentedFuel": "min. 25%",

      "map.consent.returnrefuel.no": "No",

      "map.consent.returnrefuel.yes": "Yes",

      "map.embedded.area.label": "Pickup & return",

      "map.embedded.area.placeholder": "Please select",

      "map.embedded.card.button": "Show vehicles",

      "map.embedded.card.title": "Miete Transporter bequem in deiner Nähe",

      "map.embedded.cars.empty": "No vehicles available for the selected period.",

      "map.embedded.from": "From",

      "map.embedded.to": "To",

      "map.fillProfile.dialog.add": "Add",

      "map.fillProfile.dialog.message": "Complete your user details now (only 2 minutes) to continue.",

      "map.fillProfile.dialog.no": "Not now",

      "map.fillProfile.dialog.secure": "Card Authentication",

      "map.fillProfile.dialog.support": "Complete registration",

      "map.fillProfile.dialog.title": "Missing user information",

      "map.fillProfile.dialog.yes": "OK",

      "map.filter.check": "Check availability",

      "map.filter.description": "Set your desired pick-up and return time.",

      "map.filter.findCar": "Find vehicle",

      "map.filter.header": "When would you like  a vehicle?",

      "map.filter.now": "Now",

      "map.filter.pickup": "Pick-up",

      "map.filter.reset": "Reset",

      "map.filter.return": "Return",

      "map.filter.secondary.text": "Edit date",

      "map.filter.time.to": "until",

      "map.filter.title": "When do you want a vehicle?",

      "map.marker.perHours": "€/Hr",

      "map.popup.firststeps": "%@ and get your welcome bonus, today.",

      "map.popup.firststeps.url": "https://applink.get-a-way.com/user-challenges-firststeps",

      "map.popup.firststeps.url.text": "Finish you profile",

      "map.rental.blocked": "Trip is blocked",

      "map.rented.callout": "Not available in your chosen time frame.",

      "map.rented.car.callout": "Available after\n%@",

      "map.reservedCarHeader.settings.title": "Upgrade your rental settings",

      "map.reservedCarHeader.title": "This car is reserved!",

      "map.service.lastCleaning.new": "new",

      "map.station.card.button": "choose",

      "map.station.card.description": "Station",

      "map.station.card.headline": "Choose a vehicle category",

      "map.station.card.no.categories": "No available cars  in given time frame",

      "map.station.card.phone": "Phone",

      "map.station.card.position": "Location",

      "map.station.card.title": "Robben & Wientjes",

      "map.station.card.workinghrs": "Working Hours",

      "map.station.closed.text": "Station is closed this time period",

      "map.station.note.title": "Notes",

      "map.time": "filter cars",

      "map.time.select.apply": "Filter",

      "map.time.select.title": "how long do you want a GETAWAY?",

      "map.unavailable.callout": "Not available in your chosen time frame. %s .",

      "map.unavailable.callout.link": "https://www.google.com/",

      "map.unavailable.callout.link.text": "Show availability.",

      "map.user.blocked": "Account is on hold",

      "map.usercar.BLOCKED.callout": "✋ I am currently blocked. Please contact the Service Team.",

      "map.usercar.ELIGIBLE.callout": "💪 I've passed all tests",

      "map.usercar.EQUIPPED.callout": "⚙ I am equipped",

      "map.usercar.SELECTED.callout": "🎉 I can't wait to get equipped!",

      "map.usercar.blocked.callout": "✋ I am currently blocked. Please contact the Service Team.",

      "map.usercar.eligible.callout": "💪 I've passed all tests",

      "map.usercar.equipment_ready.callout": "👨‍🔧 I am waiting for the technician",

      "map.usercar.listed.callout": "💰 Ka-Ching! I could earn up to 400€ every month.",

      "map.usercar.released.callout": "Released until\n%@",

      "map.usercar.selected.callout": "🎉 I can't wait to get equipped!",

      "map.usercar.service.callout": "🚗✨ I am currently enjoying a service",

      "marketing.consent": "I agree to receive the newsletter via email. I can revoke my consent at any time.",

      "md.demo": "## UBEEQO \"OBI DEFAULT\"\n\n| rental period | |\n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | 19,99 € (incl. 20km/h)|\n| Mon-Sat 8pm-8am | 59,90 € (incl. 100km)|\n| Sat, 8 pm - Mon, 8 am | 139,90 € (incl. 150km) |\n| On public holidays | 59,90 € (incl. 100km) |\n<br/>\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| Per additional kilometer | 0,30 €|\n<br/>\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n<br/>\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n<br/>\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n<br/>\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).\n\n<br/><br/>\n## UBEEQO \"HEY OBI\"\n\n| rental period | |\n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | 16,99 € (incl. 20km/h)|\n| Mon-Sat 8pm-8am | 50,92 € (incl. 100km)|\n| Sat, 8 pm - Mon, 8 am | 102,00 € (incl. 150km) |\n| On public holidays | 50,92 € (incl. 100km) |\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| Per additional kilometer | 0,30 € |\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).\n\n<br/><br/>\n## UBEEQO \"OBI employees\"\n\n| rental period | |\n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | 16,99 € (incl. 20km/h)|\n| Mon-Sat 8pm-8am | 50,92 € (incl. 100km)|\n| Sat, 8 pm - Mon, 8 am | 102,00 € (incl. 150km) |\n| On public holidays | 50,92 € (incl. 100km) |\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| Per additional kilometer | 0,30 € |\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).\n\n## UBEEQO \"SPP Default\"\n\n| Rental period | |\n| :-------- | -------: |\n| Hour 1 to 4 | 6,90 €/hour|\n| From 5th hour | 8,90 €/hour|\n| night rate | 20 €|\n| Weekend rate | 79 €|\n\n| Distance traveled (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf).\n\n<br/><br/>\n## UBEEQO \"SPP customer\"\n\n| rental period | |\n| :-------- | -------: |\n| Hour 1 to 4 | 0 €/hour*|\n| From 5th hour | 8,90 €/hour|\n| night rate | 20 €|\n| Weekend rate | 79 €|\n\n *The discount on the first four hours can only be redeemed once.\n\n\n| Distance traveled (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf).\n\n<br/><br/>\n## UBEEQO \"SPP employees\"\n\n\n| rental period | |\n| :-------- | -------: |\n| Hour 1 to 4 | 0 €/hour*|\n| From 5th hour | 8,90 €/hour|\n| night rate | 20 €|\n| Weekend rate | 79 €|\n\n*The discount on the first four hours can only be redeemed once.<br/>\n\n\n| Distance traveled (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf).\n\n\n\n<br/><br/>\n## UBEEQO \"IKEA DEFAULT\"\n\n\n| rental period | |\n| :-------- | -------: |\n| Hour 1 to 4 | 7,90 €/hour|\n| From 5th hour | 9,90 €/hour|\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf).\n\n\n<br/><br/>\n## UBEEQO \"IKEA INNSBRUCK ETC\"\n\n\n| rental period (9:30 am to 9 pm) | |\n| :-------- | -------: |\n| hour 1 to 4 | 7,90 €/hour|\n| from 5th hour | 9,90 €/hour|\n\n\n| night surcharge (9 p.m. to 9:30 a.m.) | |\n| :-------- | -------: |\n| Mon - Fri | +20 €|\n| Sat - Mon | +89 €|\n\n\n| distance (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf).",

      "meter.short": "m",

      "mileage": "Mileage",

      "minute": "minute",

      "minute.short": "min",

      "minutes": "minutes",

      "more": "More",

      "multiplecars.add": "Submit new car",

      "multiplecars.footnote": "%@ out how to make money by renting your car with GETAWAY!",

      "multiplecars.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#geld-verdienen",

      "multiplecars.footnote.url.text": "Find out",

      "multiplecars.released.returntime": "until",

      "multiplecars.rented.returntime": "by not later than",

      "multiplecars.title": "MY CARS",

      "navigate": "Navigate",

      "needsAccessKitCheck": "needs AccessKit check",

      "needsBattery": "needs battery",

      "needsCleaning": "needs cleaning",

      "needsFuel": "needs fuel",

      "needsFuelCard": "needs fuel card",

      "needsKeyFob": "needs key fob",

      "needsOther": "needs other",

      "needsRelocation": "needs relocation",

      "needsRepair": "needs Repair",

      "new.insurance.charterline.150": "150 €",

      "new.insurance.charterline.1500": "1500 €",

      "new.insurance.charterline.15000": "15.000 €",

      "new.insurance.charterline.151": "150 €",

      "new.insurance.charterline.500": "500 €",

      "new.insurance.charterline.501": "500 €",

      "new.insurance.charterline.650": "650 €",

      "new.insurance.charterline.750": "750 €",

      "new.insurance.charterline.description": "Max",

      "new.insurance.charterline.description.15000": "Up to",

      "new.partner.password.placeholder": "Passwort",

      "new.password.yes": "Proceed to reenter password",

      "no": "No",

      "no.geocode": "show area",

      "noBlockReason": "No downtime reason available",

      "noRentals": "No rentals yet",

      "noServices": "No services",

      "nocars.invite": "INVITE",

      "nocars.screen.title": "Invite your friends for more cars in this area!",

      "normal.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeDamage_compressed.png",

      "notNow": "Not now",

      "notification.backby.desc": "Please remember to return them on time, otherwise fees may apply.",

      "notification.backby.hide": "HIDE NOTIFICATION",

      "notification.backby.title": "%s left",

      "notification.backby.title.late": "Since %s",

      "notification.booking.rentals": "My rentals",

      "notification.booking.success": "You've successfully placed your booking. You'll find its status in your account.",

      "notification.email": "Via email",

      "notification.email.desc": "Permission to contact via email.",

      "notification.finishRental.complain": "😕 I want to complain.",

      "notification.finishRental.description": "Your rental has been finished. You will receive an overview via email.",

      "notification.finishRental.title": "Thank you for using GETAWAY!",

      "notification.mail": "Via mail",

      "notification.mail.desc": "Permission to contact via mail.",

      "notification.negative.backby.desc": "Please return the vehicle. Another user is waiting. Fees might apply.",

      "notification.push": "Via push notification",

      "notification.push.desc": "Permission to contact via push notification.",

      "notification.sms": "Via SMS",

      "notification.sms.desc": "Permission to contact via SMS.",

      "now": "Now",

      "obiEmployees.OBIMitarbeiter.pricing": "Rental period | | \n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | ~~19,99~~ 16,99 €/hour (incl. 20km/hour)|\n| Mon-Sat, 8pm-8am | ~~59,90~~ 50,92 € (incl. 100km)|\n| Sat, 8 pm - Mon, 8 am | ~~139,90~~ 102,00 € (incl. 150km) |\n| On public holidays | ~~59,90~~ 50,92 € (incl. 100km) |\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| per additional kilometer | 0,30 € |\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 €/rental |\n| Return outside the zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Border crossing fee | 7,50 € / day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Fuel level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).",

      "obiPublicUsers.OBIMitarbeiter.pricing": "Rental period | | \n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | ~~19,99~~ 16,99 €/hour (incl. 20km/hour)|\n| Mon-Sat, 8pm-8am | ~~59,90~~ 50,92 € (incl. 100km)|\n| Sat, 8 pm - Mon, 8 am | ~~139,90~~ 102,00 € (incl. 150km) |\n| On public holidays | ~~59,90~~ 50,92 € (incl. 100km) |\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| per additional kilometer | 0,30 € |\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 €/rental |\n| Return outside the zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Border crossing fee | 7,50 € / day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Fuel level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).",

      "obiPublicUsers.heyOBI.pricing": "Rental period    |  |\n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | ~~19,99~~ 16,99 €/hour (incl. 20km/hour)|\n| Mon-Sat, 8pm-8am | ~~59,90~~ 50,92 € (incl. 100km)|\n| Sat, 8 pm - Mon, 8 am | ~~139,90~~ 102,00 € (incl. 150km) |\n| On public holidays | ~~59,90~~ 50,92 € (incl. 100km) |\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| per additional kilometer | 0,30 € |\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 €/rental |\n| Return outside the zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Border crossing fee | 7,50 € / day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Fuel level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).",

      "obiPublicUsers.ubeeqo.pricing": "Rental period | | \n| :-------- | -------: |\n| Mon-Sat, 8am-8pm | 19,99 €/hour (incl. 20km/hour)|\n| Mon-Sat, 8pm-8am | 59.90 € (incl. 100km)|\n| Sat, 8 pm - Mon, 8 am | 139,90 € (incl. 150km) |\n| On public holidays | 59,90 € (incl. 100km) |\n\n| Distance (incl. fuel) | |\n| :-------- | -------: |\n| Per additional kilometer | 0,30 €|\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 €/rental |\n| Return outside the zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Border crossing fee | 7,50 € / day |\n\n| Fuel service (on return) | |\n| :-------- | -------: |\n| Fuel level < 25% | 15 € |\n| Tank level < 10% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf).",

      "offline": "OFF",

      "offlineService.report.title": "Service report",

      "ok": "OK",

      "online": "ON",

      "open.directions.title": "Start navigation",

      "open.email.gmail": "Open GMail",

      "open.email.outlook": "Open Outlook",

      "opennow": "Open now",

      "openstoday": "Opens today",

      "openstomorrow": "Opens tomorrow",

      "ops.damage.add.noImages.error": "Please make sure you've added at least one image",

      "other": "Other",

      "parking.description": "Free for 120 minutes. Any additional costs only 5 Ct",

      "parking.hours": "hours",

      "parking.minutes": "minutes",

      "parking.title": "Parking",

      "partner.password.new.subtitle": "Please enter your current password that you use to log in to our (web) app.",

      "partner.password.new.title": "Password required",

      "passport.country.not.valid": "Online document verification is not possible for other countries. Do you have any questions? Simply contact our support team.",

      "password.conditions.8.min.length": "at least 8 characters",

      "password.conditions.lowercase.and.uppercase": "both lower and upper case letters",

      "password.conditions.number": "at least one number",

      "password.conditions.specialCharacter": "at least one special character",

      "password.token.expired": "Expired token, please submit a new password reset request.",

      "payByLink.transaction.description": "Please select your payment method to settle the outstanding amount.",

      "payment.3ds.title": "Credit card authentication",

      "payment.add.description": "For verification of your user account, only. The registration is and stays completely free of charge.",

      "payment.add.error": "Failed. Please try again or contact our service team.",

      "payment.bank.comdirekt": "Comdirekt",

      "payment.bank.commerzbank": "Commerzbank",

      "payment.bank.deutschebank": "Deutsche Bank",

      "payment.bank.dkb": "DKB",

      "payment.bank.header": "Or choose bank",

      "payment.bank.ing": "ING Bank",

      "payment.bank.owner.consent": "I am acting on my own behalf.",

      "payment.bank.postbank": "Postbank",

      "payment.bank.revolut": "Revolut",

      "payment.bank.santander": "Santander",

      "payment.bank.search": "Find My Bank",

      "payment.bank.spardabank": "Spardabank",

      "payment.bank.sparkasse": "Sparkasse",

      "payment.bank.targobank": "Targobank",

      "payment.bank.volksbank": "Volksbank",

      "payment.billing.address.button": "Confirm",

      "payment.billing.address.company.contact": "Contact person",

      "payment.billing.address.company.name": "Company name",

      "payment.billing.address.description": "Add your company's billing address here",

      "payment.billing.address.headline": "Address",

      "payment.billing.address.title": "Add Company billing address",

      "payment.billing.company.headline": "Company",

      "payment.birthday.prefix": "born",

      "payment.card.add.description": "add and verify your credit card",

      "payment.card.add.title": "add credit card",

      "payment.card.add.verifying": "Verifying...",

      "payment.card.code.label": "CVC/CVV",

      "payment.card.expiration.label": "Expiration",

      "payment.card.name.label": "Account holder",

      "payment.card.number.label": "Card number",

      "payment.firstname.placeholder": "My first name",

      "payment.footnote": "By selecting the SEPA direct debit procedure, I consent to the processing of my data for a %s.",

      "payment.footnote.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "payment.footnote.url.text": "creditworthiness check",

      "payment.googlePay.description": "In the next step you can add Google Pay as a payment method.",

      "payment.googlePay.title": "Add Google Pay",

      "payment.lastname.placeholder": "My surname",

      "payment.paypal.block.description": "In the next step you will be redirected to Paypal to set up your Paypal account as a payment method.",

      "payment.paypal.block.title": "Add Paypal",

      "payment.paypal.block.yes": "Continue",

      "payment.postingText": "Thanks.",

      "payment.postingTextReference": "%s",

      "payment.profile.billing": "Alternative billing address",

      "payment.profile.billing.add": "Set different billing address",

      "payment.profile.billing.title": "BILLING INFORMATION",

      "payment.profile.company.add": "Set company info",

      "payment.profile.default": "Set as default",

      "payment.profile.delete": "delete payment profile",

      "payment.profile.option.business": "Business",

      "payment.profile.option.personal": "Private",

      "payment.profile.reset": "Reset billing information",

      "payment.profile.title": "Payment profile",

      "payment.profile.type": "Profile type",

      "payment.secured.success": "authentication passed successfully, thanks !",

      "payment.sepa.description": "SEPA Direct Deposit",

      "payment.singleLineItem.accountDeposit": "Deposit account: %@",

      "payment.singleLineItem.ibanVerification": "IBAN verification: %@",

      "payment.singleLineItem.invoice": "Invoice: %@",

      "payment.singleLineItem.tripDeposit": "Deposit reservation: %@",

      "paypal.desc": "Add one of our popular and secure payment methods to use our services.",

      "paypal.placeholder": "PayPal account",

      "paypal.title": "Add PayPal",

      "per.calday": "/calendar day",

      "per.km": "per km",

      "permission.settings.button": "GRANT ACCESS",

      "personal": "personal",

      "pfofile.wizard.continue": "Continue registration",

      "phone.pairing.message": "Click here, to pair this smartphone to your account.",

      "phone.resend.code": "Resend code",

      "phone.search": "Search",

      "phone.verification.resend.success": "Confirmation code has been sent again.",

      "phone.verify.code.apply": "APPLY CODE",

      "phone.verify.code.desc": "We've just sent you a 4 digits verification code at %s. Enter the code below to verify your device.",

      "phone.verify.code.title": "Enter SMS code",

      "phone.verify.desc": "Enter your phone number to receive a confirmation code via SMS.",

      "phone.verify.mobile.phone.text": "Mobile phone number",

      "phone.verify.send.button": "Confirm",

      "phone.verify.send.code": "Request SMS-Code",

      "phone.verify.sms": "{{code}} is your GETAWAY verification code.",

      "phone.verify.title": "Add mobile phone",

      "phone.wrong.format.error": "Please enter correct phone number",

      "phoneNumberVerification.authy.custom_message": "{{code}} is your GETAWAY verification code.",

      "phonenumber.verification.error": "This cell phone number is invalid or has already been assigned to an active user account. Please use a different one or log in with the existing user account.",

      "photo": "Photo",

      "photo.continue": "CONTINUE",

      "photo.library": "Photo Library",

      "photo.source.dialog.title": "Upload photos via",

      "photos": "Photos",

      "photos.add": "Add car photos",

      "photos.add.button": "Add photo",

      "photos.add.description": "Take photos the front, the side and interior. Great photos help to have more rentals 🤩",

      "photos.desc": "A picture is worth a thousand words. Add some photos that really make your car shine",

      "photos.permission": "Please give this app permission to access your photo library in your settings.",

      "photos.permission.details": "Please grant GETAWAY access to your photo library to upload photos.",

      "photos.permission.no": "Not now",

      "photos.permission.title": "Access Photos",

      "photos.permission.yes": "Allow",

      "photos.photo": "Photo",

      "photos.photo.reached.max": "You reached max photos count.",

      "photos.skip.no.photos": "You can always add photos later.",

      "photos.skip.photos": "You have uploaded photos.",

      "picker.placeholder": "Select an item ...",

      "pin.button": "Confirm",

      "pin.footnote.md": "Enter your personal card PIN here. You'll need the PIN to unlock the reserved vehicle.\n\n\n⚠️ <b>Warning</b>: The PIN is to be used exclusively for personal access to the vehicle. Disclosing or sharing it with third parties may result in, among other things, a contractual penalty.",

      "pin.header": "Access to the vehicle",

      "portal.area.count": "%s veh.",

      "portal.area.filter": "Filter locations",

      "portal.area.title": "Pickup & Return",

      "portal.car.cta": "Continue",

      "portal.car.details": "Show vehicle details",

      "portal.car.insurance.fallback": "Protection",

      "portal.card.lessAbout": "Show less",

      "portal.card.moreAbout": "More about the vehicle",

      "portal.card.orSimilar": "or similar",

      "portal.card.pricePrefix": "Total from",

      "portal.card.seats": "seats",

      "portal.card.select": "Select",

      "portal.card.selected": "Selected",

      "portal.checkout.billing": "Different billing address",

      "portal.checkout.consent": "By clicking \"Book now\" you accept the",

      "portal.checkout.consent.link": "Terms",

      "portal.checkout.cta": "Book now",

      "portal.checkout.cta.hint": "Becomes active once your driver details are complete.",

      "portal.checkout.cta.hint.payment": "Becomes active once a payment method is set up.",

      "portal.checkout.cta.payment": "Choose payment method",

      "portal.checkout.cta.reserve": "Make a reservation (subject to a fee)",

      "portal.checkout.cta.signin": "Sign in to continue",

      "portal.checkout.deposit.note": "When you reserve, %s is blocked on your card as a deposit – not charged. The amount is released automatically after return.",

      "portal.checkout.deposit.sub": "released after return",

      "portal.checkout.deposit.title": "Blocked now (deposit)",

      "portal.checkout.details": "Details ›",

      "portal.checkout.driver.title": "Who's driving?",

      "portal.checkout.payment.title": "How would you like to pay?",

      "portal.checkout.signin.hint": "Sign in to complete your booking.",

      "portal.checkout.signin.link": "Already a customer? Sign in",

      "portal.checkout.signout": "Not you? Sign out",

      "portal.checkout.signup.link": "No account yet? Sign up on our website",

      "portal.checkout.title": "Who drives and pays?",

      "portal.checkout.total.sub": "Rental incl. selected options",

      "portal.checkout.total.title": "Total price",

      "portal.date.apply": "Apply",

      "portal.date.title": "Select a time period",

      "portal.desktop.change": "Change",

      "portal.desktop.cta.bookHint": "The deposit is only held; it is not debited",

      "portal.desktop.cta.nextHint": "No payment is due yet",

      "portal.desktop.cta.pickHint": "Select a vehicle on the left",

      "portal.desktop.day": "%s day",

      "portal.desktop.days": "%s days",

      "portal.desktop.empty.text": "Select a vehicle on the left—the price and options will then appear here.",

      "portal.desktop.empty.title": "No vehicle has been selected yet",

      "portal.desktop.location": "Pickup & Return",

      "portal.desktop.lock.options": "Select options first",

      "portal.desktop.lock.vehicle": "Choose a vehicle first",

      "portal.desktop.options.title": "Booking option & insurance",

      "portal.desktop.period": "Period",

      "portal.desktop.summary.title": "Your booking",

      "portal.desktop.total": "Total Price",

      "portal.desktop.trust.cancel": "Free cancellation (depending on option)",

      "portal.desktop.trust.fees": "No hidden fees",

      "portal.desktop.trust.support": "Support via chat & phone",

      "portal.desktop.vehicle": "Vehicle",

      "portal.done.booking.cta": "Open booking",

      "portal.done.booking.md": "Your reservation has been confirmed.\nIf a new browser window did not open, click \"Open Reservation.\"\nAlternatively, you can manually copy the link into your browser's address bar.",

      "portal.done.presignup.cta": "Continue booking",

      "portal.done.presignup.md": "Your selection is saved.\n\nIf no new browser window has opened, click on the “Continue booking” button.\n\nAlternatively, you can copy the link manually into the address bar of your browser.",

      "portal.footer.priceDetails": "Price details",

      "portal.footer.total": "total",

      "portal.insurance.heading": "Reduce your risk",

      "portal.insurance.sub": "Damage can get expensive fast. Limit your liability with a reduced deductible.",

      "portal.insurance.title": "Insurance cover",

      "portal.results.nearby": "Other nearby locations",

      "portal.results.seeAvailability": "See availability ›",

      "portal.results.title": "Choose vehicle",

      "portal.results.unavailable": "Currently unavailable",

      "portal.results.vehicles": "vehicles",

      "portal.resume.carGone": "This vehicle is no longer available for your dates — please choose another.",

      "portal.resume.datesMoved": "Your dates were in the past — we moved them to the next available time.",

      "portal.resume.insuranceReset": "The insurance option you picked is no longer offered — we reset it to the default.",

      "portal.search.area.error": "Please choose a location",

      "portal.search.area.label": "Pickup & return",

      "portal.search.area.placeholder": "Please select",

      "portal.search.cta": "Show vehicles",

      "portal.search.from": "From",

      "portal.search.title": "Rent a vehicle",

      "portal.search.until": "Until",

      "portal.sort.priceAsc": "Price ascending",

      "portal.sort.priceDesc": "Price descending",

      "portal.sort.title": "Sort by",

      "price": "Price",

      "price.day.short": "Day",

      "price.details.footnote": "* A new driver is someone with a class B driving license less than 24 months old.",

      "price.details.footnote.url.text": "Current Price list",

      "price.distance.100.prefix": "first 100km: ",

      "price.distance.101.prefix": "from 101km:",

      "price.distance.headline": "Mileage",

      "price.duration.headline": "Duration",

      "price.duration.headline.mo-fr": "Weekdays (Mon-Fri)",

      "price.duration.headline.mo-sa": "rental duration",

      "price.duration.headline.sa-mo": "Sat, 18:00 - Mon, 08:00",

      "price.duration.headline.sa-so": "Weekend (Sat-Sun)",

      "price.duration.holiday": "on holidays: %s (100 km incl.)",

      "price.duration.holiday.headline": "Holiday",

      "price.duration.mo-fr.night.prefix": "9pm - 9:30am: ",

      "price.duration.mo-fr.prefix": "9:30am - 09:00 pm: %s",

      "price.duration.mo-sa.daily": "8am - 6pm: %s/work day (100 km incl.)",

      "price.duration.mo-sa.hourly": "Mon-Sat 8am - 8pm: %s/hr + (20km incl. /hr), max. %s/day (100km incl.)",

      "price.duration.mo-sa.night": "7pm - 6am: %s/night (100km incl.)",

      "price.duration.sa-mo": "Sat 6pm - Mon 8am: %s (150 km incl.)",

      "price.duration.sa-so.night.prefix": "Sa, 6pm - Mon 9:30am: ",

      "price.duration.sa-so.prefix": "Sa, 9:30am - 6pm :  %s (1st hour free)",

      "price.extraKm.short": "Extra Km",

      "price.hour.short": "hr",

      "price.insurance.150.prefix": "max. 150€: ",

      "price.insurance.1500.prefix": "max. 1.500€: Incl.",

      "price.insurance.15000.prefix": "max. 15.000€:  Incl.",

      "price.insurance.151.prefix": "max. 150€: ",

      "price.insurance.500.prefix": "max. 500€: ",

      "price.insurance.501.prefix": "max. 500€: ",

      "price.insurance.650.prefix": "max. 650€:  incl.",

      "price.insurance.750.prefix": "max. 750€:  incl.",

      "price.insurance.headline": "Insurance Deductable (per Claim)",

      "price.insurance.young.headline": "Insurance Deductable (New Drivers*)",

      "price.km.short": "km",

      "price.return.service.headline": "Return Service (at return)",

      "price.tank.10.prefix": "Fuel Level <10%: ",

      "price.tank.25.prefix": "Fuel Level <25%: ",

      "price.tank.headline": "Fueling Service (at return)",

      "price.weekend.surcharge.prefix": "WeekendSurcharge (Fr-Sun):",

      "pricedetails.basic.title": "Pay As You Drive",

      "pricedetails.distancePackages.remaining": "After %@. km",

      "pricedetails.example.day": "One day (24 hrs)",

      "pricedetails.example.description": "incl. %s km* and fuel",

      "pricedetails.example.hour": "One hour",

      "pricedetails.example.kilometer": "One Kilometer",

      "pricedetails.example.kilometer.description": "Including insurance and fuel",

      "pricedetails.example.month": "One month (28 days)",

      "pricedetails.example.title": "PRICING CASES",

      "pricedetails.example.value.description": "equals %s per Min.",

      "pricedetails.example.value.description.day": "Ø %s € per cal.day",

      "pricedetails.example.value.description.owner": "you earn %s",

      "pricedetails.example.week": "One week",

      "pricedetails.longterm.description.oneday": "incl. 80 km per 24 Hrs*",

      "pricedetails.longterm.footnote": "Prices include insurance and fuel. You will automatically be charged the cheapest price.\n \n*each additional Kilometer or standing time will be billed according to the peruse pricing.",

      "pricedetails.longterm.footnote.url": "https://get-a-way.com/agb/entgelte-und-gebuehren/",

      "pricedetails.longterm.footnote.url.text": "Here",

      "pricedetails.longterm.tier1.description": "incl. 80 km* and fuel",

      "pricedetails.longterm.tier1.title": "From 1st day",

      "pricedetails.longterm.tier1.value.description": "per 24 Hrs",

      "pricedetails.longterm.tier2.description": "incl. 40 km* and fuel",

      "pricedetails.longterm.tier2.title": "From day 4",

      "pricedetails.longterm.tier2.value.description": "per 24 Hrs",

      "pricedetails.longterm.tier3.description": "incl. 20 km* and fuel",

      "pricedetails.longterm.tier3.title": "From day 8",

      "pricedetails.longterm.tier3.value.description": "per 24 Hrs",

      "pricedetails.longterm.title": "From %s th day",

      "pricedetails.longterm.value.description": "per %s",

      "pricedetails.parking.freeminutes": "%s Min. free per km",

      "pricedetails.parking.title": "Standing time",

      "pricedetails.parking.value": "afterwards %s per Min.",

      "pricedetails.pricePerKm.title": "Driven Mileage",

      "pricedetails.pricePerKm.value": "%s per km",

      "pricedetails.specialoffers.title": "Daily deals",

      "pricedetails.title": "Price info",

      "pricing.CharterlinePricing.url": "https://api.get-a-way.com/pricing/5d170e35f892b13d8468f283/pdf",

      "pricing.HagebauMarktPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/58944_Preisliste+Ubeeqo_Hagebaumarkt_A4_v02.pdf",

      "pricing.HeyOBIPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.IkeaInnsbruck.duration.after_first_n_hours": "9:30am - 09:00 pm (from the 5th hour): %s/h",

      "pricing.IkeaInnsbruck.duration.first_n_hours": "9:30am - 09:00 pm (1st to 4th hour): %s/h ",

      "pricing.IkeaInnsbruck.duration.hourly": "9:30am - 09:00 pm: %s/Std",

      "pricing.IkeaInnsbruck.duration.night": "9pm - 9:30am: %s",

      "pricing.IkeaInnsbruck.duration.weekday": "rental hours (Mon-Fri)",

      "pricing.IkeaInnsbruck.duration.weekend": "rental hours (Sat-Sun)",

      "pricing.IkeaInnsbruck.duration.weekend.sat": "Sa, 9:30am - 6pm : %s",

      "pricing.IkeaInnsbruck.duration.weekend.sat.after_first_n_hours": "Sat, 9:30am - 6pm (from the 5th hour): %s/hr ",

      "pricing.IkeaInnsbruck.duration.weekend.sat.first_n_hours": "Sat, 9:30am - 6pm (1st to 4th hour): %s/hr ",

      "pricing.IkeaInnsbruck.duration.weekend.so": "Sa, 6pm - Mon 9:30am: %s",

      "pricing.IkeaInnsbruckPricing.url": "https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7cf/pdf",

      "pricing.IkeaMainPricing.url": "https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf",

      "pricing.MISSmartPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.MISSmartSpainPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.MISTransporterPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.OBIEmployeesPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_OBI_Employees.pdf",

      "pricing.OBIPublicUsersPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.OBIUsersPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.bubPassenger.distance.101": "from 101km: %s/km",

      "pricing.bubPassenger.duration.fromDay4": "from 4th day: %s €/day",

      "pricing.bubPassenger.duration.hourly": "%s/h (max. %s/cal. day)",

      "pricing.bubPassenger.duration.weekend": "WeekendSurcharge (Fr-Sun): + %s/h (Max %s/day)",

      "pricing.bubTransporter.duration.hourly": "%s/h (max. %s/cal. day)",

      "pricing.bubTransporter.duration.weekend": "WeekendSurcharge (Fr-Sun): + %s/h (Max %s/day)",

      "pricing.charterline.distance.100": "first 100km: %s/Km",

      "pricing.charterline.distance.101": "from 101km: %s/km",

      "pricing.charterline.duration.hourly": "%s/Std (max. %s/cal. day)",

      "pricing.charterline.duration.weekend": "WeekendSurcharge (Fr-Sun): + %s/Std (Max %s/day)",

      "pricing.degressive.distance": "${format:euro(price.driversPricePerKm)}/km (from ${price.firstDiscountedKm}. km only ${format:euro(price.firstDiscountedPrice)})",

      "pricing.degressive.parking": "${price.freeParkingMinutesPerKm} free minutes/km, then ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.distance": "Mileage (Fuel inc.)",

      "pricing.distance.details": "%s/km",

      "pricing.distance.excess": "Mileage (per excess km)",

      "pricing.distance.noFuel": "Mileage",

      "pricing.duration": "rental duration",

      "pricing.duration.hourly": "%s/h",

      "pricing.expert.distance": "%s/km",

      "pricing.expert.duration": "%s/h",

      "pricing.expert.duration.hourly": "Mon-Fri 9am-7pm, Sat 9am-4pm: %s/hr, max. %s/day",

      "pricing.expert.duration.night": "7pm - 9am: %s/night",

      "pricing.expert.duration.weekend": "Sat 4pm - Mon 9am: %s",

      "pricing.fee.crossBorder": "Cross Border Fee",

      "pricing.fee.crossBorder.details": "%s per day in allowed country, max %s units per rental",

      "pricing.fee.driver.injury.protection": "Passenger Protection: %s",

      "pricing.fee.driver.protection": "Extras",

      "pricing.fee.noShow": "No Show Fee",

      "pricing.fee.noShow.details": "Up to %s (depending on planned rental duration)",

      "pricing.fee.return": "Return Service (at return)",

      "pricing.fee.return.details": "%s + %s/100m",

      "pricing.fee.tank": "Fueling Service (at return)",

      "pricing.fee.tank.fuel.consumption": "Lower fuel level: %s / liter",

      "pricing.fee.tank.low.10": "Fuel Level <10%:",

      "pricing.fee.tank.low.25": "Fuel Level <25%:",

      "pricing.heyOBI.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.ikea.duration.after_first_n_hours": "from the 5th hour: %s/h",

      "pricing.ikea.duration.first_n_hours": "1st to 4th hour: %s/h",

      "pricing.insurance": "Insurance Deductable (per Claim)",

      "pricing.insurance.table": "max. %s€: %s€/cal. day",

      "pricing.insurance.table.daily": "max. %s€: %s€/calDay",

      "pricing.insurance.table.free": "max. %s€: Included",

      "pricing.insurance.young": "Insurance Deductable (Young driver)",

      "pricing.longterm.distance": "${format:euro(price.driversPricePerKm)}/km",

      "pricing.longterm.parking": "${price.freeParkingMinutesPerKm} free minutes/km, then ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.longtermanddistance.distance": "${format:euro(price.driversPricePerKm)}/km (from ${price.firstDiscountedKm}. km only ${format:euro(price.firstDiscountedPrice)})",

      "pricing.longtermanddistance.parking": "${price.freeParkingMinutesPerKm} free minutes/km, then ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.mba.duration": "Rental period (hourly)",

      "pricing.mba.duration.package": "Rental period (packages)",

      "pricing.mba.duration.transporter.1day": "1 day: %s",

      "pricing.mba.duration.transporter.3days": "3 days: %s",

      "pricing.mba.duration.transporter.3days.per_day": "3 days: %s/day	",

      "pricing.mba.duration.transporter.6hours": "6 hours: %s",

      "pricing.mba.duration.transporter.extra_hours": "%s/extra hour",

      "pricing.mba.duration.transporter.hourly": "%s/hour",

      "pricing.mba.duration.transporter.hourly_weekend": "%s/h. (max. %s/day)",

      "pricing.mba.duration.weekend": "Weekend surcharge (FRI to SUN)",

      "pricing.mba.passenger.duration.after.30": "Rental duration (30 days and more)",

      "pricing.mba.passenger.duration.before.30": "Rental duration (up to 30 days)",

      "pricing.mba.passenger.duration.daily": "1st to 3rd day: %s/day",

      "pricing.mba.passenger.duration.daily.plus3": "from day 4: %sday",

      "pricing.mba.passenger.duration.daily.plus30": "From day one: %s/day",

      "pricing.mba.passenger.included_distance": "Included %s km/day (%s/Extra-km)",

      "pricing.mba.transporter.distance": "%s/km",

      "pricing.mba.transporter.extra_distance": "Extra-km: %s/km",

      "pricing.mba.transporter.included_distance": "Included km: %s km/h (max. %s km/day)",

      "pricing.mis.distance": "incl. 50 km/24Hrs (%s/excess km)",

      "pricing.mis.duration.after.30": "rental duration (more than 30 days)",

      "pricing.mis.duration.before.30": "rental duration (up to 30 days)",

      "pricing.mis.duration.daily": "1st to 3rd day: %s/24hrs",

      "pricing.mis.duration.daily.plus3": "from day 4: %s/24hrs",

      "pricing.mis.duration.daily.plus30": "from day one: %s/24hrs.",

      "pricing.mis.duration.transporter.hourly": "After 3 hours: %s/h. (max. %s/24hrs)",

      "pricing.mis.duration.transporter.hourly.lt3h": "first 3 hours: %s",

      "pricing.mis.spain.daily.plus1": "then  %s/24Std",

      "pricing.mis.spain.duration.daily": "first 24 hours %s",

      "pricing.mis.transporter.distance": "%s/excess km (50 km/24Hrs incl.)",

      "pricing.obi.distance": "%s/excess km",

      "pricing.obi.duration.holiday": "on holidays: %s (incl. 100km)        ",

      "pricing.obi.duration.hourly": "Mon-Sat 8am-8pm: %s/hr (20km incl. /hr), max. %s/day (100km incl.)",

      "pricing.obi.duration.night": "8pm - 8am: %s/night (100km incl.)",

      "pricing.obi.duration.weekend": "Sat 8pm - Mon 8am: %s (incl. 150km)",

      "pricing.obiEmployees.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_OBI_Employees.pdf",

      "pricing.obiPublicUsers.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.obiUsers.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.serviceTrip.distance": ".",

      "pricing.serviceTrip.parking": ".",

      "pricing.spp.duration.firstNHours": "first 4 hours %s/hr",

      "pricing.spp.duration.hourly": "from 5th hour %s/hr",

      "pricing.spp.duration.night": "9pm - 9:30am: %s/night",

      "pricing.spp.duration.weekend": "Sat 6pm - Mon 9:30am: %s",

      "pricing.static.distance": "${price.driversPricePerKm}/km",

      "pricing.static.parking": "${price.freeParkingMinutes} free minutes/km, then ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.title": "Price Details",

      "privacy.text": "YOUR DATA ARE PRIVATE AND PROTECTED",

      "privacy.url": "https://get-a-way.com/datenschutz?utm_source=app",

      "profile-account-warning-title": "User account deactivated",

      "profile-deposit.warning.btn": "Add deposit",

      "profile-deposit.warning.desc": "To enable this payment method add a one-time deposit.",

      "profile.blocked.button.login": "Register now",

      "profile.blocked.msg.cC": "Unlocking your payment method has failed. Unfortunately we cannot offer any alternative at the moment to finish your registration.",

      "profile.blocked.msg.creditCheck": "Unlocking your payment method has failed. Unfortunately we cannot offer any alternative at the moment to finish your registration.\n\nPlease refrain from further attempts to register.",

      "profile.blocked.msg.d": "This account is temporarily deactivated. Each user may only have 1 account. Please delete duplicate accounts and contact us again afterwards.",

      "profile.blocked.msg.duplicate": "Each user may only have 1 account. Please delete duplicate accounts and contact us again afterwards.",

      "profile.blocked.msg.f": "This account is temporarily deactivated. For more information please contact our Service Team.",

      "profile.blocked.msg.fraud": "Each user may only have one user account. After internal review, we are unfortunately unable to allow you to complete your registration.\n\nWe ask that you refrain from further attempts to register.\n\nIf the deactivation was carried out in error, please contact our service team.",

      "profile.blocked.msg.manualApproval": "Your account is being reviewed by our team. We will let you know as soon as it has been approved.",

      "profile.blocked.msg.manualApprovalFailed": "We could not approve your account. Please contact our support team.",

      "profile.blocked.msg.originalactive": "Each user may only have one user account.\n\nPlease log in with your initial user account. If you have forgotten your password, you can reset it in the login screen.",

      "profile.blocked.msg.pDe": "The activation of this payment method has failed. Unfortunately, we are currently unable to offer you an alternative to complete your registration.",

      "profile.blocked.msg.pDr": "Unfortunately, we cannot currently offer you an alternative to complete the registration.\n\nWe ask that you refrain from further attempts to register.",

      "profile.blocked.msg.spam": "This user account is temporarily deactivated. Please contact our service team if you have any questions",

      "profile.blocked.title.d": "User account temporarily deactivated.",

      "profile.blocked.title.duplicate": "User account temporarily deactivated.",

      "profile.blocked.title.f": "User account temporarily deactivated.",

      "profile.blocked.title.fraud": "User account temporarily deactivated.",

      "profile.blocked.title.manualApproval": "Account under review",

      "profile.blocked.title.manualApprovalFailed": "Verification rejected",

      "profile.blocked.title.o": "User account deactivated",

      "profile.blocked.title.originalactive": "User account temporarily deactivated.",

      "profile.blocked.title.spam": "User account deactivated",

      "profile.blocked.title.undefined": "User account deactivated",

      "profile.completed.msg": "Check out \"Log-in data\" where and with which login data you can log in.",

      "profile.completed.org.msg": "Check out \"Log-in data\" where and with which login data you can log in.",

      "profile.completed.org.title": "Your registration is finished",

      "profile.completed.title": "Your registration is finished",

      "profile.deposit.missing": "To proceed, please pay a deposit first.",

      "profile.gdpr.dialog.more": "More about data security",

      "profile.gdpr.dialog.msg": "Here you can download your personal data. \n\nTo protect your privacy you will be asked to confirm your request by entering a confirmation code ther will be sent to you via email. After this is done, the download will start.\n\nPlease note that these are personal information regarding the use of %s. Potential processed data relating to other services can be found on the data security website of %s.",

      "profile.gdpr.dialog.request": "Request now",

      "profile.gdpr.dialog.title": "Exercising GDPR rights of access and portability",

      "profile.gdpr.resend": "The code you entered is not correct.",

      "profile.gdpr.saved": "File has been saved to Downloads",

      "profile.no.available.tariffs.desc": "We cannot offer you a suitable tariff. If you have any further questions, please contact our support team.",

      "profile.no.available.tariffs.title": "No tariff available",

      "profile.payment.missing": "To continue, please enter your payment information first",

      "profile.payment.type.business": "Business",

      "profile.payment.type.personal": "Private",

      "profile.schufa.missing": "To continue, please select your registration address first.",

      "profile.tab.account": "My Data",

      "profile.tab.services": "Log-in data",

      "profile.tx.open.pay": "Pay now",

      "profile.tx.open.title": "Outstanding amounts",

      "profile.under.age.desc": "There is currently no suitable tariff available for your current age. Please try again as soon as you turn 22.",

      "profile.under.age.title": "Young Driver",

      "profile.verify.email.sent": "Verification email has been sent",

      "profile.wizard.continue": "Continue registration",

      "push.permission": "Please enable push notifications now",

      "push.permission.details": "Allow GETAWAY to send you push notifications, in order to get notified when your car or rental status is changing.",

      "push.permission.no": "Later",

      "push.permission.title": "Enable push notifications",

      "push.permission.yes": "Allow",

      "qrCamera.title": "Scan QR code",

      "recaptcha.branding": "This site is protected by reCAPTCHA.",

      "referFriend.code.error": "Please enter a valid invitation code",

      "refuel": "refuel",

      "refuel.payment.subTitle": "Payment",

      "refuel.payment.title": "Credit Card PIN",

      "refuel.subTitle": "Take the credit card from the glove compartment and use the PIN displayed below. You don't need to keep the receipt.",

      "refuel.title": "Refuel for free",

      "remove.cancel.dialog.message": "Are you sure you want to deinstall the car?",

      "remove.cancel.dialog.title": "Car Deinstallation!",

      "remove.cancel.dialog.yes": "Deinstall",

      "remove.view.btn.txt": "Confirm",

      "remove.view.description": "Please check car data before removal confirmation.",

      "remove.view.title": "Car check",

      "rent.car.driver.gear.restricted": "You can't rent this car as your driving license is restricted to automatic gears only.",

      "rent.car.driver.license.baned": "Your driving license is banned",

      "rent.car.driver.license.open": "Your driving license is under verification, we will email you once its ready.",

      "rental": "Rental",

      "rental.action.damages": "Report damage",

      "rental.action.finish": "Finish rental",

      "rental.action.fuel": "Refuel",

      "rental.add.damage.wizard.description": "Listing all current damages helps to identify future damages.",

      "rental.allaround.add": "Add",

      "rental.allarouund.add": "Add allaround pictures",

      "rental.backby.button": "Übernehmen",

      "rental.backby.update": "Ändern",

      "rental.backby.update.desc": " Aktuell: %s",

      "rental.backby.update.other": "anzeigen",

      "rental.backby.update.title": "Rückgabezeit ändern",

      "rental.backby.update.until": "Available until",

      "rental.cancel": "Cancel",

      "rental.cancel.handover.ok": "Finish rental",

      "rental.cancel.handover.title": "You are about to cancel the current process.",

      "rental.carCheck.button": "Continue",

      "rental.carCheck.cancel": "Finish",

      "rental.carCheck.footnote": "This helps to avoid to high costs in case of a damage and is mandatory before starting the ignition.",

      "rental.carCheck.header.desc": "Take a photo from all four perspectives to start the engine.",

      "rental.carCheck.header.title": "All-around check",

      "rental.checkBelongings.finish.message": "Please make sure you have everything out of the car before continuing.",

      "rental.checkBelongings.finish.messege": "Please make sure you have everything out of the car before continuing.",

      "rental.checkBelongings.finish.title": "Please check your belongings",

      "rental.damage.added": "The damage was successfully logged at %@",

      "rental.damages.support.ubq.footNote": "If you report new damage, please inform the landlord %@",

      "rental.damages.ubq.helpdesk.text": "by telephone",

      "rental.dialog.service.error": "Please select performed services and at least one image.",

      "rental.dongle.end.title": "end rental",

      "rental.dongle.handover.description": "To end your rental please check all the points in this list",

      "rental.dongle.key.return.description": "Please hand over the vehicle keys and documents (including the fuel card) to a station employee at the express counter at the end of your rental. Alternatively, drop them in the station's night deposit box, which is signposted accordingly.",

      "rental.dongle.key.return.title": "Return keys & papers",

      "rental.driving.backBy": "Time to return",

      "rental.driving.damages.add": "Report",

      "rental.driving.greeting": "Enjoy your trip!",

      "rental.driving.tank": "fuel level",

      "rental.extra.F0105.title": "Additional driver",

      "rental.extra.F3023.title": "Passenger protection: 10,00 €",

      "rental.finish.button": "Finish & lock",

      "rental.finish.success": "Your rental was finished successfully!\nHave a nice day!",

      "rental.fuelScreen.title": "Refuel cashless",

      "rental.fuelScreen.title.adblue": "Top up AdBlue cashless",

      "rental.fuelSettings.desc": "Refuel comfortably & cashlessly with the fuel card from the glove compartment at all partner petrol stations.",

      "rental.fuelSettings.desc.adblue": "Top up AdBlue comfortably & cashlessly with the fuel card from the glove compartment at all partner petrol stations.",

      "rental.fuelSettings.fuelCard": "Fuel card: ",

      "rental.fuelSettings.fuelNote": "Do not refuel premium types. Else fees might apply.",

      "rental.fuelSettings.fuelPin": "PIN:  ",

      "rental.fuelSettings.gasStation.desc": "Prior to the refuelling please check that the gas station accepts the fuel card provided.",

      "rental.fuelSettings.gasStation.desc.adblue": "Before topping up, please check that the station accepts the fuel card and offers AdBlue at the pump or as a canister.",

      "rental.fuelSettings.instruction": "You don’t need to keep the receipt.\nReturn the fuel card after.",

      "rental.fuelSettings.navigate": "Map",

      "rental.fuelSettings.stepOne": "1. Find partner gas station",

      "rental.fuelSettings.stepOne.adblue": "1. Find a partner station with AdBlue",

      "rental.fuelSettings.stepThree": "3. Pay with the fuel card",

      "rental.fuelSettings.stepTwo": "2. Refuel (no premium type)",

      "rental.fuelSettings.stepTwo.adblue": "2. Top up AdBlue (blue cap next to the fuel filler)",

      "rental.fuelSettings.title": "Refuel for free",

      "rental.fuelSettings.where": "Where?",

      "rental.fuelling.amount": "Total cost",

      "rental.fuelling.chargedToDriver": "Charged to you",

      "rental.fuelling.paidByBrand": "Paid by us – not charged to you",

      "rental.fuelling.quantity": "Quantity",

      "rental.fuelling.station": "Station",

      "rental.fuelling.title": "Fuelling",

      "rental.fuelstation": "Fuel Station",

      "rental.handover.description": "If everything is alright, lock the vehicle from the outside with your smartphone to finish the rental.",

      "rental.handover.header": "Thank you,",

      "rental.handover.lock.title": "Finish trip",

      "rental.handover.title": "Finish rental",

      "rental.history.header": "Rental",

      "rental.history.invoice": "Show rental invoice",

      "rental.immobilizer.allaround.msg": "This immobilizer will be unlocked as soon as the all-around photos have been uploaded.",

      "rental.immobilizer.blocked": "Locked",

      "rental.immobilizer.payment.msg": "This is not a glitch. The immobilizer is locked due to a payment issue. Please contact our Service Team to unlock the engine, again.",

      "rental.immobilizer.title": "Immobilizer",

      "rental.insurance.change.error": "Insurance option is not available for this trip.",

      "rental.insurance.dialog.button": "CALL INSURANCE",

      "rental.insurance.dialog.description": "For instant help please call our insurance partner \"Gothaer\", now. Please refer to the following insurance policy number:",

      "rental.insurance.dialog.footer": "24/7 Service center. Landline number +49 30 5508 81508",

      "rental.insurance.dialog.number": "02.925.777 777",

      "rental.insurance.dialog.number.description": "Insurance policy number",

      "rental.insurance.dialog.phone.number": "+4930550881508",

      "rental.insurance.dialog.title": "Emergency Support",

      "rental.insurance.gothaer.dialog.description": "For instant help please call our insurance partner \"Gothaer\", now. Please refer to the following insurance policy number:",

      "rental.insurance.gothaer.dialog.footer": "24/7 Service center. Landline number +49 30 5508 81508.",

      "rental.insurance.label": "Insurance",

      "rental.insurance.settings.footnote": "In case of damage, it can quickly become expensive. Limit your liability risk and choose a% s",

      "rental.insurance.settings.more.url.text": "Percentage excess",

      "rental.insurances.info.url": "https://getaway.app/insurance",

      "rental.internet.disconnected.message": "Unable to connect to GETAWAY. Please make sure you're connected to the internet or call our service team.",

      "rental.internet.disconnected.title": "No internet connection",

      "rental.keyOut.button.title": "I have the car key",

      "rental.keyless.engine.dialog.message": "Turn off the engine to lock or unlock the vehicle.",

      "rental.keyless.engine.dialog.title": "Engine is running",

      "rental.keyless.key.dialog.message": "No key provided for this vehicle. Control the central lock with the app. Start the ignition with the Start-Stop-Button.",

      "rental.keyless.lock": "Lock",

      "rental.keyless.offline.body": "Without internet you control the central locking via Bluetooth. The following points must be met. Phone support details are at the end of this list.",

      "rental.keyless.offline.connected": "All requirements met. You can control the vehicle via Bluetooth:",

      "rental.keyless.offline.finish.message": "Get internet or call support to finish your trip.",

      "rental.keyless.offline.pin": "PIN",

      "rental.keyless.offline.step.connected.hint": "Move closer to the vehicle (max. 5 m) so the app can connect.",

      "rental.keyless.offline.step.connected.title": "Connection to the vehicle established",

      "rental.keyless.offline.step.enabled.hint": "Enable Bluetooth in your phone's system settings or control center.",

      "rental.keyless.offline.step.enabled.title": "Bluetooth enabled on the phone",

      "rental.keyless.offline.step.permission.hint": "Open **Settings › Bluetooth** and allow access.",

      "rental.keyless.offline.step.permission.title": "Bluetooth allowed for this app",

      "rental.keyless.offline.support": "Support",

      "rental.keyless.offline.title": "No-internet mode",

      "rental.keyless.unlock": "Unlock",

      "rental.opened.damages.title": "Damage record",

      "rental.opened.dongle.continue": "Continue",

      "rental.opened.header.desc": "If the vehicle is free of new damages, start the engine now.",

      "rental.opened.header.title": "Start the engine",

      "rental.opened.instruction": "Please take the key.",

      "rental.opened.key.option": "Where do I find the key?",

      "rental.opened.troubleshoot.door": "Doors still looked?",

      "rental.opened.troubleshoot.engine": "Engine doesn't start ?",

      "rental.opened.troubleshoot.key": "Where do I find the keys?",

      "rental.opened.troubleshoot.options": "Options",

      "rental.opened.troubleshoot.title": "Troubleshoot support?",

      "rental.opened.troubleshoot.unblock": "Unblock",

      "rental.opened.troubleshoot.unlock": "Unlock",

      "rental.opened.video.description": "The key holder is located in the glove compartment.",

      "rental.opened.video.title": "Take out the key",

      "rental.parking.findCar": "Find my car",

      "rental.prompty.end": "Finish Rental",

      "rental.rate.negative": "NO",

      "rental.rate.positive": "YES",

      "rental.rate.title": "Did you like the car?",

      "rental.refuel.warning": "Before finishing your rental, pls refuel the vehicle with the fuel card provided. Else fees might apply.",

      "rental.reserved.desc.connected": "Unlock the vehicle to start payable rental.",

      "rental.reserved.desc.disabled": "Activate bluetooth to unlock the vehicle with your mobile phone.",

      "rental.reserved.desc.searching": "Go to the vehicle to unlock it with your mobile phone.",

      "rental.reserved.header.connected": "Unlock",

      "rental.reserved.header.disabled": "Enable Bluetooth",

      "rental.reserved.header.searching": "Reduce distance",

      "rental.reserved.location.enable": "Enable location permission",

      "rental.returnlocation": "Return Location",

      "rental.returntime.late": "%@ late",

      "rental.review.negative.notification": "Thanks for your feedback...",

      "rental.section.booked": "Booked",

      "rental.section.locked": "Locked",

      "rental.section.reserved": "Reserved",

      "rental.section.return": "Return",

      "rental.section.unlocked": "Unlocked",

      "rental.service.note": "Additional note (optional)",

      "rental.service.report.button": "Submit service report",

      "rental.service.report.submit.success": "Your report was submitted",

      "rental.service.report.title": "Service report",

      "rental.settings.insurance.more": "More information",

      "rental.settings.insurance.title": "Reduce your percentage excess!",

      "rental.settings.title": "Rental Settings",

      "rental.slider.lock": "Lock & Exit",

      "rental.slider.unlock": "Start rental",

      "rental.startEngine.decr": "If the car is free of damages aside from the already reported ones, start the engine and have a save trip!",

      "rental.startEngine.title": "Start the engine now!",

      "rental.status": "Status",

      "rental.title": "Rental %s",

      "rental.vehicle.booking.link": "Vehicle availability",

      "rental.vehicle.booking.prelink": "Next booking at %s ,",

      "rental.walkthrough.button": "Ok",

      "rental.walkthrough.page1.description": "Select your desired liability limit (retention) before unlocking the vehicle with your mobile phone.",

      "rental.walkthrough.page1.title": "Select insurance and start rental",

      "rental.walkthrough.page2.description": "Return the vehicle to the color-coded return zone with a fuel level of at least 25% and lock it with your cell phone.\n\nNew: Would you like us to return the vehicle? Then simply choose the convenient return service at the end of the rental for just €10 + €0.49 per 100m.",

      "rental.walkthrough.page2.title": "Return and finish rental",

      "rental.walkthrough.page3.description": "Smoking and vaping is prohibited in our vehicles, among other things to protect subsequent users. The vehicles are equipped with smoke sensors to ensure compliance with the smoking ban and to punish violations by means of contractual penalties.",

      "rental.walkthrough.page3.title": "No smoking or vaping",

      "rental.warning.carvaloo.button": "Record vehicle condition",

      "rental.warning.carvaloo.msg": "Please record the condition of the vehicle. Please note that insurance cover will be jeopardized if you do not cooperate.",

      "rental.warning.carvaloo.title": "Damage event detected",

      "required": "Please fill in.",

      "resend": "Resend",

      "reserve.btn.blocked": "maintenance",

      "reserve.btn.unavailable": "Already booked",

      "reset": "Reset",

      "reset.password.button.title": "Update",

      "reset.password.desc": "Please enter the e-mail address you used to register. We will then send you an e-mail to reset your password.",

      "reset.password.placeholder": "New Password",

      "reset.password.title": "Change your password",

      "reset.password.updated": "Your password has been updated",

      "returncar.apply": "RELEASE NOW",

      "returncar.cancel": "I don't want to release my car",

      "returncar.title": ", when do you want your car to be returned?",

      "review": "Review",

      "review.dialog.later": "Not now 😒",

      "review.dialog.message": "If you like our app, please write us a review.\n\nBy doing so, you will help to inspire more users for sustainable mobility 🙏",

      "review.dialog.no": "Feedback",

      "review.dialog.title": "⭐⭐⭐⭐⭐",

      "review.dialog.yes": "Yes, I like 😃",

      "route.dialog.applemaps": "Apple Maps",

      "route.dialog.copy": "Copy Address",

      "route.dialog.googlemaps": "Google Maps",

      "salutation": "Salutation",

      "save": "Save",

      "schufa.address": "ADDRESS",

      "schufa.button.title": "Take over",

      "schufa.dateOfBirth.dateFormat": "Day / Month / Year",

      "schufa.dateOfBirth.label": "My Date of birth (dd/mm/yyyy)",

      "schufa.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4>\n\n<hr style=\"border: 0.5px solid #0000001f;\">\n\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\">\n<summary>\nWhat is the SEPA direct debit scheme?\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nThe SEPA Direct Debit Scheme is a secure and convenient payment method in which invoice amounts are debited directly from your bank account. It is considered particularly consumer-friendly, as you can object to an authorized SEPA direct debit within eight weeks of it being debited and get your money back.\n</p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\">\n<summary>\nWhy can't I select a different country? </summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nTo complete the registration, your current registration address must be in the country listed in the country selection. If you are currently registered in another country, you will not be able to continue the registration process. </p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\">\n<summary>\nHow is the probability of payment checked? </summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nTo activate the SEPA Direct Debit Scheme as a payment method, a credit check must be agreed to in advance. For this purpose, a comparison is made with the SCHUFA database. You can revoke your consent at any time with effect for the future. </p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\">",

      "schufa.instruction": "Please enter your current registration address to activate the SEPA Direct Debit Scheme.",

      "schufa.notification.message": "😥 Unfortunately, our payment provider cannot set up a SEPA mandate for you. Please choose an alternative payment method. We are already working on other alternatives.",

      "schufa.notification.title": "Unlock payment method",

      "schufa.personalInfo": "PERSONAL INFO",

      "schufa.title": "Your registration address",

      "schufaCheck.dialog.message": "😥 Unfortunately, our payment provider cannot set up a SEPA mandate for you. Please choose an alternative payment method. We are already working on other alternatives.",

      "schufaCheck.dialog.title": "Payment method approval",

      "schufaCheck.dialog.yes": "OK",

      "screen.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeCockpit_compressed.png",

      "screen.damage.option1": "Orange",

      "screen.damage.option2": "Red",

      "screen.damage.option3": "I don't know",

      "screen.damage.picker.holder": "Color",

      "screen.damage.title": "Report a warning light",

      "seconds.short": "sec.",

      "select.bank.card.desc": "Can't remember your IBAN? Enter your bank details simply and securely via your online banking.",

      "select.bank.card.title": "Select bank from list",

      "select.bank.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4>\n\n<hr style=\"border: 0.5px solid #0000001f;\">\n\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\">\n<summary>\nWhat is the SEPA direct debit scheme?\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nThe SEPA Direct Debit Scheme is a secure and convenient payment method in which invoice amounts are debited directly from your bank account. It is considered particularly consumer-friendly, as you can object to an authorized SEPA direct debit within eight weeks of it being debited and get your money back.\n</p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\">\n<summary>\nWhy should I log in through my online banking?\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nWith the online banking method, we protect your account from misuse and make it easier for you to enter your bank details for direct debit.<br><br>How it works:<br>\n1. click on \"Choose my bank\"<br>\n2. select your bank from the list and log in<br>\n3. allow your bank details to be shared<br><br>\nWith your permission, only your IBAN and BIC, the account holder and the fact that you have successfully authenticated yourself will be shared.\n</p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\">\n",

      "select.bank.footnote": "If your bank is not listed, you can alternatively %s",

      "select.bank.footnote.url": "https://www.google.com/",

      "select.bank.footnote.url.text": "enter your IBAN manually",

      "select.bank.manual.desc": "Enter your IBAN manually to set up the direct debit procedure.",

      "select.bank.manual.title": "Deposit manually",

      "selectPayment.desr": "Enter your preferred payment method to complete your registration.",

      "selectPayment.sepaCard.text": "Add SEPA",

      "selectPayment.title": "Add payment method",

      "selectPayment.visaCard.text": "Add Visa or MasterCard",

      "selfie.add.button": "take a 3 sec selfie video",

      "sepaIbanMismatch.desc": "We have received the verification payment from a different bank account. Should we update your bank information accordingly?",

      "sepaIbanMismatch.retry.desc": "Make the verification payment from this bank account to confirm it",

      "sepaIbanMismatch.retry.title": "Keep and repeat verification payment",

      "sepaIbanMismatch.title": "Choose your bank information",

      "sepaIbanMismatch.use.title": "Update my bank information",

      "sepaVerification.bankTransfer.cta": "Done",

      "sepaVerification.bankTransfer.unavailable": "Bank transfer is currently unavailable, please pay online instead.",

      "sepaVerification.bankTransfer.verified": "Bank account verified",

      "sepaVerification.card.desc.md": "Please make a 1-euro test transfer from the bank account listed above. The amount will be refunded immediately.",

      "sepaVerification.card.title": "1-Euro Verification",

      "sepaVerification.cta": "To the 1-Euro Transfer",

      "sepaVerification.desc": "To confirm your bank account, please make a 1-euro payment from the given bank account. The amount will be refunded immediately.",

      "sepaVerification.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Why do I need to do a verification payment? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> We want to protect your banking information. That's why you should only be able to save banking information for direct debit transactions for which access has been verified. If the IBAN matches, it can be used. </p> </details><hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Will the amount be refunded? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Yes, the amount transferred to confirm your bank account will be refunded immediately. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> What if the IBAN does not match? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> If verified bank information is required, the IBAN on file must match the IBAN of the account from which the verification payment was initiated. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n",

      "sepaVerification.footnote.secure.text": "Securely and instantly verify your bank account for a smoother, more reliable payment process.",

      "sepaVerification.method.bankTransfer.desc": "Make the fully refundable %s payment via SEPA bank transfer.",

      "sepaVerification.method.bankTransfer.title": "Verify within 1–2 business days",

      "sepaVerification.method.header": "Please choose a verification method",

      "sepaVerification.method.link.badge": "Recommended",

      "sepaVerification.method.link.desc": "Make the fully refundable %s payment using Trustly or Klarna.",

      "sepaVerification.method.link.title": "Verify instantly",

      "sepaVerification.title": "Confirm bank details",

      "service.TIL.desc": "teilAuto is the most important car sharing service for Saxony, Saxony-Anhalt and Thuringia with over 2,500 vehicles in 30 cities.",

      "service.TIL.provider": "teilAuto eG",

      "service.TIL.title": "teilAuto",

      "service.account": "Kundenkonto",

      "service.agb": "AGB",

      "service.bnd.org.note": "As soon as all necessary data was entered and checked, you will be notified via e-mail when your account is verified.",

      "service.button.text": "Reserve service",

      "service.ctf.desc": "With over 150 vehicles, cityflitzer is the first free-floating carsharing service in Leipzig for spontaneous journeys from A to B. Once you have been activated, simply log in with your customer number and the password you chose during registration.",

      "service.ctf.provider": "Mobility Center GmbH",

      "service.ctf.title": "cityflitzer",

      "service.customer.number": "Customer number",

      "service.customer.pin": "PIN (Unlock)",

      "service.data": "Datenschutzerklärung",

      "service.email": "E-Mail",

      "service.imprint": "Impressum",

      "service.info": "Anbieterinformationen",

      "service.info.desc": "Beschreibung",

      "service.info.provider": "Anbieter",

      "service.login": "Log-in",

      "service.login.section": "Access data",

      "service.map.filter.apply": "Show on map",

      "service.mobi": "Back to MOBIcar",

      "service.payment": "Payment profile",

      "service.report.accomplished": "I have accomplished services",

      "service.report.image.note": "The license plate must be recognizable on at least one photo.",

      "service.report.noService.note": "Extra notes",

      "service.reserved.services.title": "Requested services",

      "service.start.button": "Start service",

      "service.started.finish.button": "Finish service",

      "service.started.services.title": "Requested services",

      "service.status": "Status",

      "service.status.locked": "Not unlocked",

      "service.status.locked.note": "Either data is still missing for successful activation or a user account already exists.",

      "service.tab.all": "All",

      "service.tab.thisWeek": "Week",

      "service.tab.thisweek": "Week",

      "service.tab.today": "Today",

      "service.tab.tomorrow": "Tmrw",

      "service.tariff": "Tariff",

      "service.tariff.mainPartnerTerminated": "Activation failed. Please contact the inviting owner of the main account.",

      "service.tariff.maxPartnersExceeded": "No further tarifpartner can be created.\nPlease contact support for more information.",

      "service.title": "Service trip",

      "service.type.basicBranding": "Affix stickers",

      "service.type.basicCarPhotos": "Update car profile photos",

      "service.type.basicDamageRecords": "damage protocol",

      "service.type.batteryChangeOpening": "Battery change (w/ emergency opening)",

      "service.type.batteryChangeSimple": "Battery Change (simple)",

      "service.type.batteryCharge": "Charge battery",

      "service.type.cleanOutsideDry": "wash outside (dry)",

      "service.type.comboPremium": "comboPremium",

      "service.type.comboPro": "Package \"Total Care\"",

      "service.type.comboRefuelWashInside": "Package \"Refuel & Clean inside\"",

      "service.type.comboRefuelWashOutside": "Paket \"Tanken & Glanzaußenwäsche\"",

      "service.type.comboRefuelWashTotal": "Paket \"Tanken & Innen-/Außenreinigung\"",

      "service.type.dashboardCleaning": "clean ventillation and storage places",

      "service.type.desinfektion": "desinifect",

      "service.type.exchangeFuelCard": "Replace fuel card",

      "service.type.extra10min": "Extra Time, per 10 Minutes",

      "service.type.grillCleaning": "Grill cleaning",

      "service.type.highGlossFinish": "high-gloss finish and color sealing",

      "service.type.noService": "I haven’t performed any services",

      "service.type.otherBasicService": "Other Service",

      "service.type.refuel": "Refuel",

      "service.type.relocate": "Relocation",

      "service.type.relocation": "Relocation",

      "service.type.rimsCleaning": "Intensive rim cleaning",

      "service.type.safetyCheck": "Safety Check",

      "service.type.tirePressure": "tire pressure check",

      "service.type.vacuumCleaning": "hover trunk and floor mats",

      "service.type.washInside": "clean inside",

      "service.type.washOutside": "clean outside (wet)",

      "service.type.windshieldFluidRefill": "Fill-up washer fluid",

      "services.item.subTitle": "WMA Order",

      "services.map.filter.apply": "Show on map",

      "settings": "Settings",

      "settings.addPaymentMethod.googlePay": "Google Pay",

      "settings.addPaymentMethod.payIn": "Unlock pay in advance",

      "settings.addPaymentMethod.paypal": "Add PayPal",

      "settings.addPaymentMethod.sepa": "SEPA",

      "settings.addPaymentMethod.sepa.disabled": "Currently not available",

      "settings.addPaymentMethod.visa": "Add credit card",

      "settings.address.footnote": "By changing my address info, I hereby agree to proceed a %s to verify my identity.",

      "settings.address.footnote.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "settings.address.footnote.url.text": "data check",

      "settings.address.org.text": "Add Company Address",

      "settings.circles.data": "EXCLUSIVE CIRCLES",

      "settings.circles.data.add": "Join a circle",

      "settings.consents": "My consents",

      "settings.email.update.success": "Thanks. Your email address has been updated.",

      "settings.gdpr": "Request my data",

      "settings.login.data": "ACCOUNT DATA",

      "settings.login.data.driverslicense": "DRIVING LICENSE",

      "settings.login.data.email.edit": "Tap here to edit your email address",

      "settings.login.data.email.facebook": "Connect your facebook account",

      "settings.login.data.facebook.dest": "Connect your facebook account and enjoy one-click login. We won't publish anything on your timeline without your prior permission!",

      "settings.login.data.moreactions": "MORE ACTIONS",

      "settings.login.data.notifications": "Notifications",

      "settings.login.data.notifications.change": "Manage your notifications settings",

      "settings.login.data.password": "Reset password",

      "settings.login.data.password.edit": "Tap here to edit your password",

      "settings.login.data.pin": "PIN (unlocking)",

      "settings.login.data.terminate": "Terminate account",

      "settings.login.data.touchId": "Touch/Face ID",

      "settings.login.data.touchId.edit": "Login via Touch/Face ID",

      "settings.login.data.user.add.address.text": "Add registration address",

      "settings.login.data.user.add.phone.text": "Add mobile phone number",

      "settings.login.data.user.address.disabled.text": "Please contact our Service Team to make changes",

      "settings.login.data.user.address.text": "Tap here to edit your address",

      "settings.login.data.user.info.text": "Please contact our Service Team to make changes",

      "settings.login.data.user.phone.text": "Tap here to edit your mobile phone number.",

      "settings.logout": "Logout",

      "settings.notification": "Notification",

      "settings.org.data": "BUSINESS DATA",

      "settings.org.personal.data": "PERSONAL DATA",

      "settings.payIn.open": "Payment method is blocked until identity check is verified, please contact support team",

      "settings.payIn.status.open.message": "Please add an Identity card to activate Pay in",

      "settings.payment.data": "PAYMENT PROFILES",

      "settings.payment.data.add": "Add payment method",

      "settings.payment.footnote": "By selecting the SEPA direct debit procedure, I consent to the processing of my data for a %s.",

      "settings.payment.footnote.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_smp/WL_DataPrivacy-DATA_Checks-en%2B02_2024.pdf",

      "settings.payment.footnote.url.text": "creditworthiness check",

      "settings.payment.payIn.title": "Pay in advance",

      "settings.payment.paypal.title": "Add PayPal",

      "settings.payment.profile.add": "Add payment profile",

      "settings.payment.sepa.title": "Add SEPA",

      "settings.payment.sepa.url": "https://google.com",

      "settings.permission": "Permission needed",

      "settings.personal.data": "PERSONAL DATA",

      "settings.select.tariff": "Choose Tariff",

      "settings.selectedPayment.payIn.title": "PayIn",

      "settings.tariff": "Tariff %s",

      "settings.tariff.6654adffda9d82661df73dcb.name": "cityflitzer",

      "settings.tariff.66574cfe7dfac60795ffa1bc.name": "cityflitzer",

      "settings.terminate.info": "To terminate your account please contact service team.",

      "settings.terminate.no": "Cancel",

      "settings.terminate.yes": "Contact",

      "settings.title": "SETTINGS",

      "settings.upload.camera": "Open Camera",

      "settings.upload.file": "Choose file",

      "settings.upload.title": "Upload Document",

      "settings.uploadDoc": "Upload a document",

      "settled": "settled",

      "share.car.message": "Check out this car at GETAWAY: %@ %@, from %@/km or %@/day incl. insurance and fuel. https://applink.get-a-way.com/map?id=%@",

      "share.car.subject": "I’ve found a car for you",

      "share.panel.description": "Share your invitation link",

      "share.panel.title": "Want more cars?",

      "shortcut.release": "Release my car",

      "shortcut.release4hours": "Release my car for 4 hrs",

      "signup.booking.invitation.footnote": "If you accept the invitation, your e-mail address and the date of activation will be shared with the inviting party.",

      "signup.booking.invitation.prefix": "You were invited as an additional driver by",

      "signup.button.title": "Create free account",

      "signup.card.org.desc": "e.g. GmbH, AG, e.V., Gmbh & Co KG, KG, OHG",

      "signup.card.org.title": "As an organization",

      "signup.company.name.placeholder": "Company name (without legal type)",

      "signup.country.label": "Country",

      "signup.desc": "Sign up for free and start renting immediately.",

      "signup.desc.noBonus": "Sign up for free and start renting immediately.",

      "signup.description": "create your free account and receive a %@, today.",

      "signup.description.highlight": " 5€ welcome bonus ",

      "signup.dialog.ownsACar.message": "This info help us provide better service for you.",

      "signup.dialog.ownsACar.title": "Do you have a car?",

      "signup.domain.dialog.confirm": "Confirm",

      "signup.domain.dialog.message": "Please double check your email address.",

      "signup.email.org.placeholder": "Company email",

      "signup.email.placeholder": "Email",

      "signup.facebook.complete.placeholder": "COMPLETE",

      "signup.facebook.dateofbirth.placeholder": "Date of birth",

      "signup.facebook.email.placeholder": "Email",

      "signup.facebook.firstname.placeholder": "First name",

      "signup.facebook.lastname.placeholder": "Last name",

      "signup.facebook.picker.mr": "Mr.",

      "signup.facebook.picker.mrs": "Mrs",

      "signup.facebook.picker.ms": "Ms.",

      "signup.facebook.title": "SIGN UP VIA FACEBOOK",

      "signup.facebook.title.placeholder": "Title",

      "signup.fees.text": "Fees table",

      "signup.footnote.login.action": "Login",

      "signup.footnote.login.text": "Have an account ?",

      "signup.footnote.secure.text": "Secure and encrypted data transmission",

      "signup.header": "Sign up now",

      "signup.individual.dialog.btn": "» Sign up as an individual",

      "signup.individual.dialog.msg": "In this case, please use the registration as an individual.",

      "signup.individual.org.desc": "e.g. sole proprietor, GbR, eK, UG",

      "signup.individual.org.title": "As a sole proprietor or member of a GbR",

      "signup.invitation.footnote": "If you accept the invitation, your e-mail address and the date of activation will be shared with the inviting account.",

      "signup.invitation.header": "Sign up as Tarifpartner",

      "signup.invitation.prefix": "You have been invited by",

      "signup.invitation.remove.cancel": "Cancel",

      "signup.invitation.remove.confirm": "Confirm",

      "signup.invitation.remove.message": "Remove message",

      "signup.invitation.remove.title": "Remove",

      "signup.invite.circleCard.text": "Join one of our exclusive user groups and get special access to vehicles and prizes!",

      "signup.invite.code.seleted.text": "Get your %@ welcome credit from %@ today!",

      "signup.invite.title": "I've got invited (optional)",

      "signup.legal.other.placeholder": "Other",

      "signup.legal.type.placeholder": "Legal type",

      "signup.md.widget.success": "Please continue with your registration.\n\nIf no new browser window has opened, click on the \"Continue registration\" button.\n\nAlternatively, you can copy the link manually into the address bar of your browser.",

      "signup.name.placeholder": "First name",

      "signup.name.policy.text": "Privacy Policy",

      "signup.name.terms.text": "By creating an account you agree to GETAWAY's Terms of Service and Data Privacy Terms.",

      "signup.name.termsservice.text": "Terms of Service",

      "signup.org.desc": " ",

      "signup.org.director.header": "And now to your person. Please choose:",

      "signup.org.header": "Register as a business customer",

      "signup.org.info": "Information about your organization",

      "signup.org.manual.link": "“ Not included? Enter manually",

      "signup.org.search.button": "Search for",

      "signup.org.search.header": "Ok, let's find your organization",

      "signup.org.search.placeholder": "Company name (incl. legal type)",

      "signup.org.type.header": "What is the legal type of your organization?",

      "signup.password.placeholder": "Password",

      "signup.personal.section": "Personal details",

      "signup.policy.cancel": "Cancel",

      "signup.register.location.placeholder": "Registry court",

      "signup.register.nr.placeholder": "Registry No",

      "signup.terms.text": "I accept the %s and %s of %s.",

      "signup.terms.url": "https://getaway.app/terms",

      "signup.terms.url.text": "Terms of Service",

      "signup.title": "Hi,",

      "signup.type.company": "Register as a business customer",

      "signup.type.dialog.bnd": "book-n-drive",

      "signup.type.dialog.bnd.link": "https://web.book-n-drive.de/registration/pid/575",

      "signup.type.dialog.cf": "cityFlitzer",

      "signup.type.dialog.cf.link": "https://de1.cantamen.de/pub/okw/form?orgnr=125&package=&authKey=77f2663b-3e06-84d7-9dfb-a521724124f4&product=firm-jp-wok",

      "signup.type.dialog.title": "Register as a business customer",

      "signup.type.org": "Register as a business customer",

      "signup.type.private": "Sign up as an individual",

      "signup.update.placeholder": "new email address",

      "signup.widget.success.cta": "Continue registration",

      "signup.widget.success.reset": "Reset form",

      "signup.zipcode.placeholder": "What is your zip code?",

      "sort.byDistance": "sort by distance",

      "sort.byDistance.label": "Sort by distance",

      "sort.byDue": "sort by due date",

      "sort.byDue.label": "sort by due date",

      "sppStandard.SPPKunde.pricing": "Rental period | | \n| :-------- | -------: |\n| Hour 1 to 4 | ~~6,90~~ 0 €/hour*|\n| From 5th hour | 8,90 €/hour|\n| night rate | 20 €|\n| Weekend rate | 79 €|\n\n *The discount on the first four hours can only be redeemed once.\n\n\n| Distance traveled (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 15 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf).",

      "sppStandard.SPPMitarbeiter.pricing": "Rental period | | \n| :-------- | -------: |\n| Hour 1 to 4 | ~~6,90~~ 0 €/hour*|\n| From 5th hour | 8,90 €/hour|\n| night rate | 20 €|\n| Weekend rate | 79 €|\n\n*The discount on the first four hours can only be redeemed once.<br/>\n\n\n| Distance traveled (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf).",

      "sppStandard.ubeeqo.pricing": "Rental period | | \n| :-------- | -------: |\n| Hour 1 to 4 | 6,90 €/hour|\n| From 5th hour | 8,90 €/hour|\n| night rate | 20 €|\n| Weekend rate | 79 €|\n\n| Distance traveled (incl. fuel) | |\n| :-------- | -------: |\n| Per kilometer | 0,30 € / km |\n\n\n| Excess (per claim) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (included) |\n| max. 500€ | 11 €/cal.day |\n| max. 150€ | 19 €/cal.day |\n\n| additional services | |\n| :-------- | -------: |\n| Passenger protection | 10 € |\n\n| refueling service (on return) | |\n| :-------- | -------: |\n| Tank level < 25% | 5 € |\n| Tank level < 5% | 50 € |\n\n> The complete list of all charges can be found in the [current price list](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf).",

      "start.engine.description": "Please take the key from the glove compartment",

      "start.engine.title": "Start the engine and enjoy",

      "station.booking.cancel": "cancel reservation",

      "station.booking.category": "vehicle category",

      "station.booking.code": "Reservation Code",

      "station.booking.confirm.button": "Confirm Reservation",

      "station.booking.confirm.category": "vehicle category",

      "station.booking.confirm.dates": "Reservation information",

      "station.booking.confirm.description": "check your reservation information and finish your reservation",

      "station.booking.confirm.from": "From",

      "station.booking.confirm.group": "Pick-up",

      "station.booking.confirm.title": "check your reservation",

      "station.booking.confirm.to": "To",

      "station.booking.confirm.where": "Where?",

      "station.booking.description": "When your reservation starts, you have 30 minutes to pick up your vehicle at the station's express counter.",

      "station.booking.from": "From",

      "station.booking.group": "pick-up",

      "station.booking.key.category": "category",

      "station.booking.key.code": "reservation code",

      "station.booking.key.from": "From",

      "station.booking.key.insurance": "insurance",

      "station.booking.key.insurance.default": "SB500",

      "station.booking.key.item": "Vehicle",

      "station.booking.key.title": "Key handover",

      "station.booking.key.to": "To",

      "station.booking.later.than": "To start until",

      "station.booking.later.value": "Key handover",

      "station.booking.merchant.waiting": "being requested",

      "station.booking.reservation": "reserved",

      "station.booking.title": "Your Reservation",

      "station.booking.to": "To",

      "station.booking.where": "Where?",

      "storage.permission.details": "Please grant GETAWAY access to your storage to enable saving requested files.",

      "storage.permission.title": "Enable storage permission",

      "storage.permission.yes": "Allow",

      "submit": "Apply",

      "submt": "Apply",

      "support.call": "Call support team",

      "support.cancel": "Cancel",

      "support.chat": "Live Chat",

      "support.email": "E-mail",

      "support.phone.number": "+493012088089",

      "support.whatsapp": "LiveChat",

      "tariff.Firmentarif": "Firmentarif",

      "tariff.Firmentarif.desc": "✓ including excess <s>1500€</s> 750€\n\n✓ including fuel costs\n\n✓ save up to 50% on the time price\n\n✓ Over 4,000 vehicles across Germany in station-based and flexible car sharing",

      "tariff.Firmentarif.price": "<div style=\"display: flex;\">One time <s style=\"margin-left: 3px; margin-right: 3px;\"> 19€ </s> <strong style=\"color: #749600;\"> gratis</strong>・monthly 0€</div>",

      "tariff.Rahmentarif.desc.new": "✓ 16% discount compared to the starting rate<br>\n✓ 4 tariff partners included<br>\n\nBahnCard, public transport subscription or student? Save with the %s\"",

      "tariff.button.text": "Apply tariff",

      "tariff.coupon": "Redeem voucher",

      "tariff.coupon.desc": "If the voucher code is valid, it will be applied after activation.",

      "tariff.coupon.number": "Enter voucher code",

      "tariff.desc": "Choose your suitable tariff and optionally reduce the excess in the event of a damage.",

      "tariff.discount.selected.header": "Please provide suitable proof",

      "tariff.discount.selected.proof": "Proof",

      "tariff.discounts": "Apply discount",

      "tariff.discounts.header": "Select offer",

      "tariff.grf.coupon.desc": "If the voucher code is valid, it will be applied after activation.",

      "tariff.header.desc": "Confirm your chosen tariff.",

      "tariff.org.consent": "The customer contract is concluded subject to positive credit information and can be revoked if the information is negative.",

      "tariff.partner.desc": " ",

      "tariff.partner.link.footnote.md": "Anyone who successfully registers with the invitation link will automatically be added to your main account as a tariff partner. When the invitation link is shared, the inviter's data is also shared.",

      "tariff.partner.link.prefix": "Invitation link",

      "tariff.partner.link.share": "Share invitation link",

      "tariff.partner.share.text": "Join your partner %@",

      "tariff.partner.share.title": "Share",

      "tariff.partner.switch.title": "Enable invitation link",

      "tariff.partner.title": "Tarifpartner",

      "tariff.title": "Choose your tariff",

      "tariff.upselling.SB.header": "Security package",

      "tariff.upselling.free.header": "No extra protection",

      "tariff.upselling.free.price": "0€ (included)",

      "tariff.upselling.title": "Service-Paket",

      "tba": "tba",

      "terms.url": "https://get-a-way.com/agb?utm_source=app",

      "test.oleksandr.key1": "<h4 style=\"font-weight: 600;\">",

      "textkey": "en-DE",

      "time": "Point of time",

      "tirePressure": "tire pressure check",

      "today": "Today",

      "toggle.or": "OR",

      "tomorrow": "tomorrow",

      "tonne.short": "t",

      "touchId.password.dialog.message": "Please enter your GETAWAY password to enable Touch ID.",

      "touchId.password.dialog.title": "Confirm with password",

      "touchid.enable.message": "From now on, you can conveniently login via Touch ID.",

      "touchid.login.message": "Enable Touch ID for a convenient and secure login to GETAWAY.",

      "transaction.open.button": "Pay now",

      "transaction.open.description": "Please pay the open receipt",

      "transaction.open.title": "Open transaction",

      "transactions.bonus.description": "[{0}]",

      "transactions.bonus.title": "Bonus",

      "transactions.cancel.description": "Cancellation [{0}]",

      "transactions.cancel.title": "Refund",

      "transactions.chargeback.description": "{0} {1}",

      "transactions.chargeback.title": "Chargeback",

      "transactions.fee.description": "{0} {1}",

      "transactions.fee.title": "Fee #{0}",

      "transactions.firststepsbonus.description": "🎉 Welcome Bonus",

      "transactions.goodwillbonus.description": "Goodwill bonus [{0}]",

      "transactions.payment.deposit.description": "Invoice [{0}]",

      "transactions.payment.deposit.title": "Deposit",

      "transactions.payment.title": "(Pre-)Payment [{0}]",

      "transactions.payout.title": "Payout",

      "transactions.refuel.description": "{0} at {1}",

      "transactions.refuel.title": "Refuel",

      "transactions.refuelbonus.description": "🙏 Thanks for refuelling",

      "transactions.refund.deposit.description": "Rental [{0}] ",

      "transactions.refund.deposit.title": "Deposit Refund",

      "transactions.refund.title": "Amount paid out",

      "transactions.rental.description": "{0} | {1}km at {2}",

      "transactions.rental.title": "Invoice [{0}]",

      "transactions.type.bonus": "Reward",

      "transactions.type.bonus.description": "First steps finished",

      "transactions.type.fee": "Fee",

      "transactions.type.payment": "Payment",

      "transactions.type.payment.reason": "Reason",

      "transactions.type.referrerBonus": "Credit",

      "transactions.type.referrerBonus.description": "Reward for inviting a friend to join getaway",

      "trip.adult.desc": "Older than 15 years",

      "trip.adult.placeholder": "Adult",

      "trip.cancel.confirm.msg": "Do you really want to cancel the trip? Please note that cancellation fees may apply.",

      "trip.cancel.confirm.title": "Cancel reservation",

      "trip.cancel.dialog.title": "Do you really want to cancel the trip? Please note that cancellation fees may apply.",

      "trip.cancel.no": "No",

      "trip.cancel.yes": "Yes",

      "trip.children.desc": "0 - 14 years",

      "trip.children.placeholder": "Children",

      "trip.damage.report": "Report a damage",

      "trip.driving.refuel": "Refuel now",

      "trip.force.finish": "End trip prematurely",

      "trip.force.finish.msg": "Would you like to end the trip prematurely at your own risk?",

      "trip.force.finish.title": "End trip prematurely",

      "trip.force.no": "Discard",

      "trip.force.yes": "Finish now",

      "trip.opened.stepOne": "I am strapped in",

      "trip.opened.stepTwo": "The vehicle door is closed again",

      "trip.order.arrived": "Your vehicle arrived. Please unlock.",

      "trip.order.brake": "Emergency brake",

      "trip.order.driving": "Have a good trip!",

      "trip.order.finished.submit": "End trip",

      "trip.order.opened": "Please enter the vehicle",

      "trip.order.parking": "Please get out of the car",

      "trip.order.parking.submit": "Finish trip",

      "trip.order.start": "Start",

      "trip.order.stop": "Intermediate stop: not your exit.",

      "trip.order.transit": "Intermediate stop: not your exit.",

      "trip.order.unlock": "Unlock",

      "trip.order.waiting": "Your vehicle is on the way.",

      "trip.parking.stepOne": "I got out",

      "trip.parking.stepThree": "The vehicle door is closed again",

      "trip.parking.stepTwo": "I haven't forgotten anything",

      "trip.payByLink.description": "Deposit for rental %@",

      "trip.search.confirm": "Confirm",

      "trip.search.enter.destination": "Enter destination",

      "trip.search.enter.start": "Enter start",

      "trip.search.enter.start.location": "Submit",

      "trip.service.type.refuel": "Refueling",

      "trip.service.type.relocate": "Relocating",

      "trip.service.type.relocateAndRelease": "Relocate And Release",

      "trip.service.type.title": "What was the performed service?",

      "trip.stop.confirm.msg": "Do you really want to activate the emergency brake? Please note that misuse is punishable by law.",

      "trip.stop.confirm.title": "Emergency stop",

      "trip.stop.item": "Stop %s",

      "trip.stop.no": "No",

      "trip.stop.yes": "Yes",

      "trip.stops.title": "%s Stop",

      "trip.support": "Contact service",

      "trip.wheelchair.desc": "1 wheelchair per car",

      "trip.wheelchair.placeholder": "Wheelchair",

      "tripHistory.complain": "Report a complaint",

      "tripHistory.end": "Return",

      "tripHistory.fee": "Rental",

      "tripHistory.revenue": "Rental earnings",

      "tripHistory.services": "Executed service(s)",

      "tripHistory.start": "Takeover",

      "tutorial.listcar.button": "CHECK YOUR EARNINGS",

      "tutorial.listcar.step1.message": "Your car stands idle around for 23h a day. Put your car to work with one hassle-free click whenever you park it.",

      "tutorial.listcar.step1.title": "Generate\nincome\nwhile parking",

      "tutorial.listcar.step2.message": "You can set the availability and your car's earnings per km. Earnings are credited automatically.",

      "tutorial.listcar.step2.title": "You\nare in\ncontrol",

      "tutorial.listcar.step3.message": "We verify each traveler’s identity and have your car fully covered by our insurance partner „Die Gothaer“.",

      "tutorial.listcar.step3.title": "We take\ncare of\nyour piece\nof mind",

      "tutorial.listcar.step4.message": "Let’s use our resources more efficiently. Join us to save the environment without losing the convenience of owning a car.",

      "tutorial.listcar.step4.title": "Great for\nyou. Great \nfor the\nenvironment",

      "tutorial.listcar.step5.message": "Join thousands of car owners and list your car by simply taking a photo of your car registration license via the app.",

      "tutorial.listcar.step5.title": "How \nmuch can \nyour car\nearn?",

      "tutorial.map.listCar.button": "CHECK NOW",

      "tutorial.map.listCar.message": "Make a free and nonbinding check, how much your car could earn for you.",

      "tutorial.map.listCar.title": "How much could\nyour car earn?",

      "tutorial.map.step1.message": "If there’s anything we can do for you, please let us know.",

      "tutorial.map.step1.title": "We are just\na tap away",

      "tutorial.map.step2.message": "Access your profile and all your settings by simply clicking the user icon.",

      "tutorial.map.step2.title": "Stay\ntuned",

      "tutorial.map.step3.message": "Just choose for how long you want the car, and we will show you all the available cars until that time.",

      "tutorial.map.step3.title": "Get a car\nget away!",

      "tutorial.map.step4.button": "GET STARTED",

      "tutorial.map.step4.message": "Complete your profile and get free credit. It takes usually less than 2 minutes.",

      "tutorial.map.step4.title": "Get your\nstreet credibility",

      "tutorial.signup.button": "GET STARTED",

      "tutorial.signup.extraAction": "I've an account »",

      "tutorial.signup.step1.message": "Unlock & drive any private car around with your smartphone",

      "tutorial.signup.step1.title": "UNLOCK\nANY\nCAR",

      "tutorial.signup.step2.message": "Charges per kilometer keep you relaxed and costs transparent.",

      "tutorial.signup.step2.title": "STAY\nRELAXED",

      "tutorial.signup.step3.message": "Rent your car spontaneously whenever you park it.",

      "tutorial.signup.step3.title": "YOUR\nCAR\nCAN\nWORK",

      "tutorial.signup.step4.message": "Release your car with only one click on your smartphone",

      "tutorial.signup.step4.title": "JUST\nA\nCLICK",

      "unavailablecar.request": "Start Booking",

      "until": "Until",

      "upcoming.booking.event.description": "You can find your booking here",

      "upcoming.booking.event.title": "Rental car reservation",

      "update.address.add": "ADD",

      "update.address.city": "City",

      "update.address.country": "Country",

      "update.address.desc": "Please note that this address needs to be your official living address.",

      "update.address.germany": "Germany",

      "update.address.location.error": "Our service is not available in your country yet.",

      "update.address.number": "Number",

      "update.address.search": "Search address",

      "update.address.street": "Street",

      "update.address.success": "Thanks! Your address has been successfully updated.",

      "update.address.update": "UPDATE",

      "update.address.zip": "ZIP Code",

      "update.email.desc": "Your current email address is %@. Please enter your new email address and confirm with your current password.",

      "update.email.new": "New email address",

      "update.email.title": "Change your email address",

      "update.email.update": "UPDATE",

      "update.email.wrong.pass": "Incorrect password",

      "update.notifications.channels": "CHANNELS",

      "update.notifications.email": "Via email",

      "update.notifications.email.desc": "Permission to contact you via email.",

      "update.notifications.mail": "Via mail",

      "update.notifications.mail.desc": "Permission to contact you via mail.",

      "update.notifications.push": "Via push notification",

      "update.notifications.push.desc": "Permission to contact you via push notification.",

      "update.notifications.push.wizard.button": "GO TO SETTINGS",

      "update.notifications.push.wizard.desc": "Please enable push notifications in your settings to get immediate updates.",

      "update.notifications.push.wizard.latter": "NOT NOW",

      "update.notifications.push.wizard.latter.error": "Push notifications are disabled",

      "update.notifications.push.wizard.title": "Enable push notifications",

      "update.notifications.sms": "Via SMS",

      "update.notifications.sms.desc": "Permission to contact you via SMS.",

      "update.notifications.title": "NOTIFICATIONS",

      "update.notifications.topics.name.bookings.description": "Receive notifications about your bookings.",

      "update.notifications.topics.name.bookings.title": "Bookings Notifications",

      "update.notifications.topics.name.monthlyOverview.description": "Receive monthly financial reports for your account",

      "update.notifications.topics.name.monthlyOverview.title": "Monthly Reports",

      "update.password.forgot.error": "Please enter your email address and tap \"Forgot\" again. We will send you an email with the instructions to reset your password.",

      "update.password.text": "If the e-mail address is registered, a link to reset the password has just been sent to %@.",

      "update.password.wizard.desc": "Please enter your new password",

      "update.password.wizard.newpassword": "New password",

      "update.password.wizard.title": "New password",

      "update.password.wizard.update": "UPDATE",

      "upselling.dialog.message": "Do you want to book this package?",

      "upselling.dialog.noAction": "Still without extra protection",

      "upselling.dialog.title": "No extra protection?",

      "upselling.dialog.yesAction": "Yes",

      "upsellings.button.text": "Apply",

      "upsellings.header.desc": " In the event of damage, it can quickly become expensive. Limit your liability risk.",

      "upsellings.title": "Reduced excess",

      "user-duplicate.phone.cancel": "CANCEL",

      "user.DL.completed.message": "To change your driving license, please contact our service team.",

      "user.DL.inProgress.message": "Your driving licence is being verified, please wait.",

      "user.DL.resubmission.message": "Maximum amount of attempts used. Please contact our service team.",

      "user.ID.completed.message": "To make changes, please contact our service team.",

      "user.ID.inProgress.message": "Your Identity card is being verified, please wait.",

      "user.ID.resubmission.message": "To add your identity card, please contact our service team.",

      "user.action.support.text": "Contact service team",

      "user.add_to_circle.brand_not_matches": "Circle's and User's Brands are different so User cannot be added to that Circle",

      "user.address.completed.message": "To change your address, please contact our service team.",

      "user.address.inProgress.message": "Your address is being verified, please wait.",

      "user.car.selector.listed": "%@ (from %@)",

      "user.car.selector.release_ready": "%@ (Unreleased)",

      "user.car.selector.released": "%@ (Released)",

      "user.car.selector.rented": "%@ (In Rental)",

      "user.car.selector.submitted": "New Car (from %@)",

      "user.car.selector.title": "Select your car",

      "user.circle.description": "Do you really want to leave this circle?",

      "user.circle.leave": "Leave this circle",

      "user.circle.leave.description": "By leaving this circle, you will not have access to circle cars & offers any more. Are you sure you want to proceed?",

      "user.circle.switchAccess": "Switch access to this circle",

      "user.deletePayment.dialog.message": "Are you sure ?",

      "user.deletePayment.dialog.no": "Cancel",

      "user.deletePayment.dialog.title": "Delete payment profile",

      "user.deletePayment.dialog.yes": "Delete",

      "user.deposit.dialog.msg": "You can download the invoice for your deposit here after completing your registration.\n\nIf you would like a refund, you will receive it automatically as soon as you cancel your registration and remove your user account.",

      "user.deposit.dialog.no": "Not now",

      "user.deposit.dialog.yes": "Open LiveChat",

      "user.document.resubmitInstruction.BAD_QUALITY_IMAGE": "Poorly legible: Please upload a document of sufficient quality.",

      "user.document.resubmitInstruction.BLURRED": "Poorly legible: Please upload a document with sufficient clarity.",

      "user.document.resubmitInstruction.CAR_DRIVING_PERMISSION_IS_NO": "Missing information: Please submit a driver's license on which the required driving license is clearly visible.",

      "user.document.resubmitInstruction.COUNTRY_NOT_ALLOWED": "The document you have submitted cannot be processed due to the country of issue. Please submit a document with a different country of issue.",

      "user.document.resubmitInstruction.DAMAGED_DOCUMENT": "Please submit an undamaged/unpunched document.",

      "user.document.resubmitInstruction.EXPIRED_DOCUMENT": "Document Expired: Please submit a valid document.",

      "user.document.resubmitInstruction.GLARE": "Poorly legible: Please submit your document without reflections. It may help to switch off the flash",

      "user.document.resubmitInstruction.IDENTITY_MISMATCH_APPROVED_USER_IDENTITY": "Missing match: Please submit a document that matches your user details.",

      "user.document.resubmitInstruction.INCOMPLETE_DATA": "Missing information: Please make sure that all information on the document is clearly legible the next time you try.",

      "user.document.resubmitInstruction.LIVENESS_FAILED": "Camera orientation: Please make sure to take the photos in portrait mode (portrait) the next time you try this.",

      "user.document.resubmitInstruction.MANIPULATED_DOCUMENT": "Document cannot be processed due to changes to the document. Please submit another document.",

      "user.document.resubmitInstruction.MISSING_PAGE": "Missing information: Please make sure that the front and back are uploaded.",

      "user.document.resubmitInstruction.MISSING_SIGNATURE": "Missing signature: Please submit a valid document with all security features.",

      "user.document.resubmitInstruction.NO_ID_UPLOADED": "No document uploaded. If you have difficulties, please try another browser.",

      "user.document.resubmitInstruction.NO_MATCH": "Missing match: Please submit a document that has been issued to you personally.",

      "user.document.resubmitInstruction.PART_OF_DOCUMENT_MISSING": "Please submit your document in such a way that it can be viewed in full.",

      "user.document.resubmitInstruction.PHOTOCOPY": "Please only scan the requested document from the original.",

      "user.document.resubmitInstruction.PUNCHED": "Please submit an undamaged/unpunched document.",

      "user.document.resubmitInstruction.WRONG_DOCUMENT_TYPE": "Wrong document: Please check this time whether a driver's license or an ID document is required.",

      "user.duplicate.api_error.org.duplicate.cancel": "CANCEL",

      "user.duplicate.api_error.org.duplicate.msg": "This company is already registered.\nWould you like to reset your password?",

      "user.duplicate.api_error.org.duplicate.yes": "RESET",

      "user.duplicate.email.cancel": "CANCEL",

      "user.duplicate.email.msg": "The email can only be used once.\nPlease log in with your initial user account. If you have forgotten your password, you can reset it in the login screen.",

      "user.duplicate.email.yes": "LOGIN",

      "user.duplicate.iban.cancel": "CANCEL",

      "user.duplicate.iban.msg": "The IBAN can only be used once. \n\nPlease log in with your initial user account.  \n\nIf you have forgotten your password, you can reset it in the login screen.",

      "user.duplicate.iban.yes": "LOGIN NOW",

      "user.duplicate.phone.cancel": "CANCEL",

      "user.duplicate.phone.msg": "The mobile number can only be used once.\n\nPlease log in with your initial user account. If you have forgotten your password, you can reset it in the login screen.",

      "user.duplicate.phone.yes": "CONTINUE TO LOGIN",

      "user.email.completed.message": "To change your email address, please contact our service team.",

      "user.id.not.required": "This step is no longer required",

      "user.logout.cancelReservation.message": "Please cancel the reservation before moving forward.",

      "user.logout.cancelReservation.ok": "Ok",

      "user.logout.dialog.message": "Are you sure ?",

      "user.logout.dialog.no": "Cancel",

      "user.logout.dialog.title": "Logout",

      "user.logout.dialog.yes": "Logout",

      "user.noPayment.action": "Add payment method",

      "user.noPayment.message": "You need to add a valid payment method first",

      "user.notNow": "Not now",

      "user.notification.terminate.message": "Your account deletion request is currently being processed.",

      "user.org.signupCertificate.events.signedUp.description": "	The user account has been registered as an organizational account under the name %s, with the legal form %s, the registry number %s at the registry court %s by %s %s with the e-mail address %s and the terms and conditions and privacy policy valid at this time have been agreed to.",

      "user.payment.not.added": "You don't have any payment methods, Please add one first ",

      "user.paymentLink.iban_verification.description": "A small payment is required to validate that you have access to the provided IBAN. the payment will be fully refunded once the verification process is completed.",

      "user.phone.completed.message": "To change your phone number, please contact our service team.",

      "user.phone.edit.desc": "To update your phone number, we will send a verification code to your email.",

      "user.pin.completed.message": "To make a change, please contact our service team.",

      "user.profile.payment.org.pending": "The payment method will be released after successful verification by the service team.",

      "user.profile.payment.pending": "Your payment will be verified once ID card and DL is added ",

      "user.scan.attempts.out": "No attempts left. Please contact our Service Team.",

      "user.selectPayment.noCC": "I don't have a credit card",

      "user.signupCertificate.accountHistory": "Account History",

      "user.signupCertificate.createdBy": "Created by",

      "user.signupCertificate.createdBy.at": "at",

      "user.signupCertificate.deviceUuid": "Device UUID",

      "user.signupCertificate.documentId": "ID (Document)",

      "user.signupCertificate.events.addressVerified.description": "The registered address %s has been added to the user account.",

      "user.signupCertificate.events.creditCheck.description": "Consent has been given to the processing of the data to check the probability of payment. The comparison resulted in a match and a score and the address %s.",

      "user.signupCertificate.events.creditCheck.manualapproval.description": "The data for checking the probability of payment was confirmed manually.",

      "user.signupCertificate.events.creditCheck.plusAddress.description": "The processing of the data to check the creditworthiness has been consented to. The comparison resulted in a match, a score and the address %s.",

      "user.signupCertificate.events.idVerified.description": "The ID document (type: %s) with the number %s has been added to the user account.",

      "user.signupCertificate.events.idVerified.plusAddress.description": "The ID document (type: %s) with the number %s and the address %s has been added to the user account.",

      "user.signupCertificate.events.licenseVerified.description": "The driver's license with the number %s has been added to the user account.",

      "user.signupCertificate.events.marketingConsentGiven.description": "The consent \"Newsletter\" has been given.",

      "user.signupCertificate.events.marketingConsentRevoked.description": "The consent \"Newsletter\" has been revoked.",

      "user.signupCertificate.events.merchantReferenceAssigned.description": "The customer number %s has been added to the user account in the course of activation.",

      "user.signupCertificate.events.phoneVerified.description": "The cell phone number %s has been added to the user account.",

      "user.signupCertificate.events.sepaAdded.description": "The payment method SEPA %s has been added to the user account and the direct debit mandate has been approved.",

      "user.signupCertificate.events.sepaAddedWithTrueLayer.description": "The SEPA direct debit payment method has been added to the user account and the direct debit mandate has been approved. Authentication via online banking login revealed the IBAN %s, the BIC %s and the account holder %s.",

      "user.signupCertificate.events.sepaVerifiedWithBankTransfer.description": "The SEPA direct debit payment method with the IBAN %s, the BIC %s and the account holder %s has been verified via bank transfer.",

      "user.signupCertificate.events.signedUp.description": "The user account is registered as %s %s with the e-mail address %s and the terms and conditions, privacy policy and registration fee valid at that time have been agreed to.",

      "user.signupCertificate.events.tariffSelected.description": "The \"%s\" tariff (without reduction of the deductible) has been added to the user account.",

      "user.signupCertificate.events.tariffSelected.descriptionWithServicePackage": "The \"%s\" tariff (with service package) has been added to the user account.",

      "user.signupCertificate.events.tariffSelected.descriptionWithUpsellings": "The \"%s\" tariff (with reduction of the deductible) has been added to the user account.",

      "user.signupCertificate.events.tariffSelected.descriptionWithoutServicePackage": "The \"%s\" tariff (without service package) has been added to the user account.",

      "user.signupCertificate.events.tariffSelectedFromPartner.description": "The user account is assigned the tariff \"%s\" (without security package) via the main account (customer no. %s).",

      "user.signupCertificate.id.DRIVING_LICENSE": "Driving license",

      "user.signupCertificate.id.ID_CARD": "ID Card",

      "user.signupCertificate.id.PASSPORT": "Passport",

      "user.signupCertificate.id.UNSUPPORTED": "Unknown",

      "user.signupCertificate.id.VISA": "Resident Permit",

      "user.signupCertificate.ip": "IP",

      "user.signupCertificate.page": "Page",

      "user.signupCertificate.pageOf": "of",

      "user.signupCertificate.status": "Status",

      "user.signupCertificate.status.active": "Active",

      "user.signupCertificate.title": "Title",

      "user.signupCertificate.titleValue": "Account Registration Records",

      "user.signupCertificate.userId": "ID (user)",

      "user.signupCertificate.userIdentity": "User Identity",

      "user.terminate.dialog.message": "Please note:\n\n1. the removal of your user account cannot be reversed.\n\n2. you will not be able to create a new user account until further notice. If you need assistance to complete your existing registration, please contact us via the service icon. We will be happy to help!",

      "user.terminate.dialog.no": "Cancel",

      "user.terminate.dialog.title": "Delete your account",

      "user.terminate.dialog.yes": "DELETE NOW",

      "user.transaction.settled.success": "Transaction has been settled successfuly",

      "usercar.fillprofile.footnote": "Check out our %@ how to increase your rental earnings.",

      "usercar.fillprofile.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "usercar.fillprofile.footnote.url.text": "help center",

      "usercar.item.blocked.title": "Can't release. Please contact our Service Team",

      "usercar.item.eligible.title": "In queue to get selected",

      "usercar.item.equipment_ready.title": "Soon to be equipped",

      "usercar.item.equipped.title": "Your car is ready to join the fleet.",

      "usercar.item.listed.title": "Your car is on our waiting list.",

      "usercar.item.release_ready.title": "Unreleased",

      "usercar.item.released.title": "Released until",

      "usercar.item.selected.title": "Selected- look forward to get equipped.",

      "usercar.item.submitted.description": "Submitted on",

      "usercar.item.submitted.title": "Thanks for submitting your car's license.",

      "usercar.item.terminated.description": "Terminated on ",

      "usercar.item.terminated.title": "Your car will be removed",

      "usercar.photo.description": "Take a photo from the front, the sides and the interior.",

      "usercar.profile.blocked.status": "BLOCKED",

      "usercar.profile.blocked.title": "This car is currently blocked.",

      "usercar.profile.eligible.description": "Your car is in the queue, now. Speed up the onboarding and share your personal invitation code with your friends and neighbours.",

      "usercar.profile.eligible.status": "IN QUEUE",

      "usercar.profile.eligible.title": "Awesome %@, your car has past all tests 💪",

      "usercar.profile.equipment_ready.description": "Our technician will meet you at the agreed time and address. He will call you 30 minutes before it actually starts. Please have your car key and car's registration license with you.\n\nIf you need to cancel the appointment please inform us minimum 48 hours in advance to avoid any possible cancelation fees.",

      "usercar.profile.equipment_ready.status": "INSTALLATION",

      "usercar.profile.equipment_ready.title": "%@, your car will be equipped soon",

      "usercar.profile.equipped.description": "Just a moment. As soon as the final checks are completed, we will activate your car.",

      "usercar.profile.equipped.status": "CONNECTED",

      "usercar.profile.equipped.title": "%@, your car has been equipped",

      "usercar.profile.firssteps.description": "In order to earn money with your car please finish the First Steps.",

      "usercar.profile.firssteps.title": "Please complete your account infos",

      "usercar.profile.firststeps.description": "Following this, we are able to check what your car could earn for you.	",

      "usercar.profile.firststeps.title": "%@, please update your https://applink.get-a-way.com/user-challenges-firststeps, now",

      "usercar.profile.firststeps.title.url": "https://applink.get-a-way.com/user-challenges-firststeps",

      "usercar.profile.firststeps.title.url.text": "user profile",

      "usercar.profile.listed.description": "Specify now, how your car should be offered in the app. You can modify these infos at any time later, too.",

      "usercar.profile.listed.status": "VERIFYING",

      "usercar.profile.listed.title": "%@, enrich your car's profile now",

      "usercar.profile.release.availableuntil": "Release now until",

      "usercar.profile.release_ready.status": "PRIVATE",

      "usercar.profile.released.availableuntil": "Released until",

      "usercar.profile.released.status": "RELEASED",

      "usercar.profile.rented.status": "IN RENTAL",

      "usercar.profile.selected.description": "To ensure a convenient and safe rental experience, we'll equip your car with our SafetyKit once. Our technician will call you soon to find an  appointment for the installation.",

      "usercar.profile.selected.status": "SELECTED",

      "usercar.profile.selected.title": "%@, your car is ready to get equipped 🙌",

      "usercar.profile.service.status": "IN SERVICE",

      "usercar.profile.submit.action": "Submit car license now",

      "usercar.profile.submit.description": "Hundreds have joined already. Check now, how much you car could earn for you. Its free and without any engagement.",

      "usercar.profile.submit.left": "MY CAR",

      "usercar.profile.submit.status": " ",

      "usercar.profile.submit.title": "start to earn money with your car, today!",

      "usercar.profile.submitted.description": "Specify now, how your car should be offered in the app. You can modify these infos at any time later, too.",

      "usercar.profile.submitted.status": "VERIFYING",

      "usercar.profile.submitted.title": "%@, enrich your car's profile now",

      "usercar.profile.terminated.status": "TERMINATED",

      "usercar.profile.title": "My Car",

      "usercar.review.novalue": "✨ New car",

      "usercar.troubleshoot": "Troubleshooting",

      "usercar.troubleshoot.dialog.message": "As a car owner, you can now unlock your car and deactivate the immobilizer. After, your car is not locked via GETAWAY anymore. We strongly recommend to proceed only if you are next to your car.",

      "usercar.troubleshoot.dialog.title": "Troubleshooting",

      "usercar.troubleshoot.dialog.unlock": "Unlock car and immobilizer",

      "usercarprofile.example.title": "What the driver would pay",

      "usercarprofile.price.details.footnote": "Learn more about setting the perfect pricing in our %@.",

      "usercarprofile.price.details.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto/mein-autoprofil/so-legst-du-den-idealen-preis-fur-dein-auto-fest",

      "usercarprofile.price.details.footnote.url.text": "help center ",

      "usercarprofile.price.indicator.title": "you earn",

      "usercarprofile.price.slider.aboveaverage": "above average",

      "usercarprofile.submit.status": " ",

      "users.merchantSystem.sync": "sync status",

      "validation.accountholder.invalid": "Please enter a valid account holder name",

      "validation.address.street.invalid": "Please enter a valid street name",

      "validation.address.streetnumber.invalid": "Please enter a valid street number",

      "validation.address.zip.invalid": "Please enter a valid postal code",

      "validation.email.invalid": "Please enter a valid email address.",

      "validation.iban.invalid": "Please enter a valid IBAN",

      "validation.name.invalid": "2 letters min",

      "validation.password.invalid": "Min. 8 characters (incl. 1 cap/ lowercase/ no./ special sign)",

      "validation.phone.invalid": "This mobile phone number can't be confirmed. Please try another one.",

      "validation.required": "Please fill in.",

      "validation.required.empty": "This field can't be empty",

      "validator.name.error": "Name must be at least 2 characters long.",

      "validator.password.error": "Password must contain at least 6 characters and one digit.",

      "validator.streetNumber.error": "Please enter a valid street number",

      "verify.phone.failed": "Incorrect code",

      "verify.phone.passwordView.description": "Your current mobile number is %@. Please enter your password to change it.",

      "verify.phone.passwordView.title": "Change your mobile number",

      "verify.phone.resend.success": "You'll shortly receive an SMS with the confirmation code",

      "verify.phone.success": "Thanks! Your phone number has been successfully updated.",

      "video": "video",

      "violation.adyenPayByLinkRequest.noError.hasError.assertFalse": "Payment link creation failed. Please try again or contact support",

      "violation.adyenPaymentProvider.responseValidator.authorized.assertTrue": "This credit card can’t be added. Please try another one.",

      "violation.adyenPaymentProvider.responseValidator.cvcDeclined.assertFalse": "Incorrect CVC. Please check your credit card data and try again.",

      "violation.adyenPaymentProvider.responseValidator.noResponse.assertFalse": "Could not connect to payment provider. Please try again.",

      "violation.adyenPaymentProvider.responseValidator.notificationSuccess.assertTrue": "This credit card can’t be added. Please try another one.",

      "violation.apiVersionCheck.version.min": "Your app version is not supported any longer, please update it via the App Store.",

      "violation.booking.bookingPayInAllowedValidator.payInAllowed.assertTrue": "Deposit can't be used since you have a balance on your account. please contact customer support to request a refund or use a another payment method.",

      "violation.booking.bookingPaymentValidator.adyenRequestRejected.assertFalse": "Payment request was rejected",

      "violation.booking.bookingPaymentValidator.adyenRequestTimedOut.assertFalse": "Payment request timed out",

      "violation.booking.bookingPaymentValidator.blockedPaymentNotNeededOrConfirmed.assertTrue": "Deposit payment refused by your bank. Please try another payment method.",

      "violation.booking.bookingRequestValidator.canBook.assertTrue": "Unfortunately you cannot take this vehicle because you have already booked another vehicle.",

      "violation.booking.bookingRequestValidator.confirmedCarValid.assertTrue": "This vehicle is unfortunately not available for the selected rental period.",

      "violation.booking.bookingRequestValidator.watchlistCheckPassed.assertTrue": "Please make sure that your profile is completed. Contact customer support if you need help.",

      "violation.booking.bookingRequestValidator.withinOpeningHours.assertTrue": "Booking not possible. Collection and return of the vehicle are only possible during opening hours. The start and/or end time of the booking request is outside these times.\n\nPlease try again with a different start and/or end time. The access times can be found in the vehicle profile under “Info”.",

      "violation.booking.bookingRequestValidator.youngDriver.assertFalse": "Please be patient. Your driving license needs to be issued at least two years ago. You will automatically approved and notified as soon this happens.",

      "violation.booking.offerConfirmationValidator.creditworthinessApproved.assertTrue": "You do not currently have a valid or active payment method. Please check your user account.",

      "violation.booking.offerConfirmationValidator.watchlistCheckPassed.assertTrue": "Your account is incomplete. Please contact our Service Team.",

      "violation.car.chassisNumberUniqueValidator.chassisNumber.assertTrue": "This chassisNumber is already in the system",

      "violation.car.damages.characteristics.notNull": "Please choose the damage characteristics.",

      "violation.car.damages.component.notNull": "Please choose a damage component.",

      "violation.car.damages.where.notNull": "Please define the location of the damage.",

      "violation.car.generateOwnerAccessToken.rented.assertFalse": "The car can't be opened during an active rental.",

      "violation.car.onlineCheck.online.assertTrue": "Connection lost. Please change car's location and try again. Or contact our Service Team.",

      "violation.car.owner.notNull": "The car needs to be assigned to an owner.",

      "violation.car.plateUniqueValidator.plate.assertTrue": "This plate is already in the system",

      "violation.car.registrationCertificate.plate.pattern": "Please enter a valid car plate.",

      "violation.car.registrationCertificate.plate.plateRegion": "The region of the entered car plate is unknown.",

      "violation.car.releaseCheck.availableUntil.assertTrue": "The return date is too early ! Please chose a longer time frame.",

      "violation.car.releaseCheck.basicPrice.notNull": "Price is not set ! Please set the price per km for your car before releasing.",

      "violation.car.releaseCheck.doorsClosed.assertTrue": "Doors are open! Please close them to continue.",

      "violation.car.releaseCheck.fuelCardIn.assertTrue": "Fuel card is not in its place! Please return it to continue.",

      "violation.car.releaseCheck.fuelLevel.min": "Fuel level is below 25%, Please refuel the car and try again.",

      "violation.car.releaseCheck.ignitionOff.assertTrue": "Ignition is on! Please turn off the car to continue .",

      "violation.car.releaseCheck.keyFobIn.assertTrue": "Key is not in its place! Please return it to continue.",

      "violation.car.releaseCheck.online.assertTrue": "Connection lost. Please change car's location and try, again. Or contact our Service Team.",

      "violation.car.releaseCheck.paymentMethodExists.assertTrue": "Please add a valid payment method.",

      "violation.car.releaseCheck.windowsClosed.assertTrue": "Windows are open! Please close them to continue.",

      "violation.clientVersionCheck.version.min": "Your app version is not supported any longer, please update it via the App Store.",

      "violation.device.alreadyPairedValidator.device.assertTrue": "Your user account is not paired with the current smartphone. Please contact our Service Team to continue.",

      "violation.driversLicenseTokenData.validation.validToken.assertTrue": "Your session is invalid or has expired. Please try again.",

      "violation.fleetAdmin.validPasswordValidator.password.assertTrue": "Please enter a valid password (six characters long, incl. at least one digit)",

      "violation.forgotPasswordResource.resetPasswordCheck.validToken.assertTrue": "This link is not valid anymore. Please contact our service team for more information.",

      "violation.installation.mechanic.notNull": "The installation needs to be assigned to a registered mechanic.",

      "violation.paymentMethod.existingPaymentMethod.isBlocked.assertFalse": "You can't add this payment method. Please try again with another payment method.",

      "violation.paymentResource.paymentMethodTypeCheck.paymentMethodNotAllowed.assertFalse": "You can't add this payment method. Please try again with another payment method.",

      "violation.paymentResource.paymentMethodTypeCheck.tariffMissing.assertFalse": "You should select a Tariff before adding payment method.",

      "violation.phoneNumber.noNewNumberWhenPairedValidator.phoneNumber.assertTrue": "Not allowed. Your Device is Paired. Please contact our Service Team to continue. ",

      "violation.phoneNumber.userPhoneNumberUniqueValidator.phoneNumber.assertTrue": "This cell phone number is invalid or has already been assigned to an active user account. Please use a different one or log in with the existing user account.",

      "violation.phoneNumber.userPhoneNumberUniqueValidator.phoneNumberInactive.assertTrue": "This cell phone number has already been assigned to a user account. Please contact support to continue.",

      "violation.phoneNumber.validPhoneNumberValidator.phoneNumber.assertTrue": "Invalid code, please make sure to enter the right one or request a new code.",

      "violation.phoneNumber.validPhoneNumberValidator.smsLimitExceeded.assertFalse": "Phone verification attempts exceeded",

      "violation.phoneNumber.validVerificationCodeValidator.phoneNumber.assertTrue": "Please enter correct verification code",

      "violation.rentalResource.serviceTripCheck.userUnauthorized.assertFalse": "Sorry, you are not allowed to carry out a ServiceTrip. Please start a regular rental.",

      "violation.sepa.ibanValidator.sepa.assertTrue": "Please enter a valid IBAN.",

      "violation.serviceCircle.serviceCircleValidator.pricingEmpty.assertTrue": "Changing pricing for Service UserGroups is not supported",

      "violation.trip.cancellation.reserved.assertTrue": "Only valid reservations can be canceled.",

      "violation.trip.driverQualificationValidator.addressVerified.assertTrue": "Please register your address to continue.",

      "violation.trip.driverQualificationValidator.creditCheck.assertTrue": "Please contact our service team to complete your user data.",

      "violation.trip.driverQualificationValidator.identityChecked.assertTrue": "Please contact our service team to complete your user data.",

      "violation.trip.driverQualificationValidator.paymentMethodExists.assertTrue": "Hmm, payment is not linked! Please submit a payment method to continue.",

      "violation.trip.driverQualificationValidator.phoneNumberVerified.assertTrue": "Please verify your phone number on this device to continue.",

      "violation.trip.driverQualificationValidator.positiveBalance.assertTrue": "Insufficient funds. Please make sure you don't have a negative balance before starting a new trip.",

      "violation.trip.driverQualificationValidator.validLicence.assertTrue": "Your driving license needs to be verified to rent cars. Please check the current status in your account settings.",

      "violation.trip.finishCheck.bitLessFuelOnReturn.assertFalse": "I choose a fueling service (2,80 €/Liter) ",

      "violation.trip.finishCheck.correctLocation.assertTrue": "Too far from the return location ! Please check the return location or finish the rental regardless; Fees may apply.",

      "violation.trip.finishCheck.endCheckImagesUploaded.assertTrue": "Your all-round photos haven’t reached us yet. Please check your connection and slide to finish again.",

      "violation.trip.finishCheck.extremelyLowFuelLevel.assertFalse": "I choose the refuel service <10% (50,- €)",

      "violation.trip.finishCheck.finishLocationAllowed.assertTrue": "I have returned the car",

      "violation.trip.finishCheck.fuelLevel.min": "I choose refuel service (5 €)",

      "violation.trip.finishCheck.fuelLevelOBI.min": "I choose refuel service (15 €)",

      "violation.trip.finishCheck.initialUnlockIsSet.assertTrue": "The car has to be initially unlocked in order to finish the rental.",

      "violation.trip.finishCheck.insideArea.assertTrue": "I choose return service (10€ + 4.9€/km)",

      "violation.trip.finishCheck.keyFobIn.assertTrue": "The trip can only be finished if the key is correctly put into the holder in the glove box. Please make sure it is and try again.",

      "violation.trip.finishCheck.online.assertTrue": "failed to connect to the vehicle, please try again or contact customer support",

      "violation.trip.finishCheck.openDamageReport.assertFalse": "You have an open damage please check your sms for filling the damage report",

      "violation.trip.finishCheck.payAsReserved.assertFalse": "I finish my rental prematurely.",

      "violation.trip.postReservation.accessToken.assertTrue": "This vehicle can't be reserver at the moment.",

      "violation.trip.postReservation.accessToken.notNull": "Ups..something went wrong. Please try again later.",

      "violation.trip.postReservation.adyenRequestRejected.assertFalse": "Payment request was rejected",

      "violation.trip.postReservation.adyenRequestTimedOut.assertFalse": "Payment request timed out",

      "violation.trip.postReservation.blockedPaymentConfirmed.assertTrue": "Your bank has refused this transaction. Please contact your bank for more info or try another payment method.",

      "violation.trip.rating.onlyFinished": "The rental has to be finished successfully to add a rating.",

      "violation.trip.rentalReservationValidator.addressVerified.assertTrue": "Please register your address to continue.",

      "violation.trip.rentalReservationValidator.backByConflictsWithBooking.assertFalse": "This vehicle is already booked in this timeframe. Please choose another time or another vehicle.",

      "violation.trip.rentalReservationValidator.blockedByUpcomingBooking.assertFalse": "This vehicle has a booking starting soon, please try another one.",

      "violation.trip.rentalReservationValidator.carAvailable.assertTrue": "Oops! The selected car is not available anymore.",

      "violation.trip.rentalReservationValidator.carStatusReleased.assertTrue": "Oops, car was taken offline. Please look for another one.",

      "violation.trip.rentalReservationValidator.creditworthinessApproved.assertTrue": "Please contact our service team to complete your user data.",

      "violation.trip.rentalReservationValidator.identityChecked.assertTrue": "Your name, birthday and registered address couldn't be approved, yet. Please contact us via the live chat icon to finish your verification.",

      "violation.trip.rentalReservationValidator.online.assertTrue": "This vehicle is currently unavailable and can not be rented.",

      "violation.trip.rentalReservationValidator.paymentMethodExists.assertTrue": "Please add a valid payment method to continue.",

      "violation.trip.rentalReservationValidator.phoneNumberVerified.assertTrue": "You can not make a reservation unless your phone number is verified. Please add your phone number to your account and try again.",

      "violation.trip.rentalReservationValidator.positiveBalance.assertTrue": "Insufficient funds. Please make sure you don't have a negative balance before starting a new trip.",

      "violation.trip.rentalReservationValidator.serviceTripAllowed.assertTrue": "User is not allowed to perform service trips on this car.",

      "violation.trip.rentalReservationValidator.userMarkedForFraud.assertFalse": "😐 Unfortunately the action you attempt is not available for the moment. Please contact our Service Team for further information.",

      "violation.trip.rentalReservationValidator.userMarkedForFraud.assertTrue": "😐 Unfortunately the action you attempt is not available for the moment. Please contact our ServiceTeam for further information.",

      "violation.trip.rentalReservationValidator.validLicence.assertTrue": "Your driving license needs to be verified to rent cars. Please check the current status in your account settings.",

      "violation.trip.rentalReservationValidator.watchlistCheckPassed": "Please make sure that your profile is completed. Contact customer support if you need help.",

      "violation.trip.rentalReservationValidator.withinOpeningHours.assertTrue": "Rental not possible. The start and/or end time of the booking request is outside the opening hours.",

      "violation.trip.rentalReservationValidator.youngDriver.assertFalse": "Please be patient. Your driving license needs to be issues at least two years ago. You will automatically approved and notified as soon this happens.",

      "violation.trip.reservationValidator.manualGearRestricted.assertFalse": "Sorry but this car have a manual gearbox and it seems like you're not allowed to drive that! If this is a mistake please contact our support.",

      "violation.user.account.paymentMethods.sepa.ibanValid": "Please enter a valid IBAN",

      "violation.user.archiveCheck.hasOpenBookingRequests.assertFalse": "It seems like you have some open invoices please contact our customer support to continue.",

      "violation.user.archiveCheck.hasOpenTransactions.assertFalse": "Can't continue due to either open or unsettled invoice. Please try again later, as settlement is dependent on payment confirmation.",

      "violation.user.dateOfBirth.min": "To rent a vehicle, you must have a valid Class B license for at least 2 years.",

      "violation.user.device.alreadyPaired": "Your user account is not paired with the current smartphone. Please contact our Service Team to continue.",

      "violation.user.email.notNull": "Please add a valid email address to your user account.",

      "violation.user.email.pattern": "Please add a valid email address to your user account.",

      "violation.user.email.userEmail.Unique": "Hmm, it seems like we already have an account for this email, do you want to reset your password?",

      "violation.user.email.userEmailUnique": "Hmm, it seems like we already have an account for this email, do you want to reset your password?",

      "violation.user.emailVerificationCheck.codeNotMatches.assertFalse": "Verification code didn't match",

      "violation.user.emailVerificationCheck.codeWasNotGenerated.assertFalse": "Currently no pending email verification.",

      "violation.user.emailVerificationCheck.maxVerificationAttemptsPassed.assertFalse": "No attempts left. Please contact our Service Team.",

      "violation.user.firstName.notNull": "Please add a valid first name to your user account.",

      "violation.user.firstName.size": "Please add a valid first name to your user account.",

      "violation.user.lastName.size": "Your last name must contain at least 2 characters.",

      "violation.user.password.validPassword": "Please enter a valid password (six characters long, incl. at least one digit)",

      "violation.user.phoneNumber.phoneNumber.noNewNumberWhenPaired": "Not allowed. Your Device is Paired. Please contact our Service Team to continue.",

      "violation.user.phoneNumber.phoneNumber.validVerificationCode": "Invalid code, please make sure to enter the right one or request a new code.",

      "violation.user.phoneNumber.userPhoneNumberUnique": "This mobile number can't be used. Please try another one.",

      "violation.user.phoneNumber.validPhoneNumber": "Please add a valid mobile number to your user account.",

      "violation.user.phoneNumber.validVerificationCode": "This verification code is invalid. Please request a new one.",

      "violation.user.referredBy.referralCodeExists": "Hmm, it seems like this referral code doesn't exist, can you please double check or contact our customer support, they would love to help!",

      "violation.user.requireDevice.hasPairedDevice.assertTrue": "Please verify your mobile number on this smartphone to continue.",

      "violation.user.requireDevice.isCorrectDevice.assertTrue": "This phone is not authorised for this interaction. Please contact our service team.",

      "violation.user.sendVerificationCodeCheck.smsLimitExceeded.assertFalse": "Phone verification attempts exceeded",

      "violation.user.userEmailUniqueValidator.email.assertTrue": "Hmm, it seems like we already have an account for this email, do you want to reset your password?",

      "violation.user.userEmailUniqueValidator.emailInactive.assertTrue": "This email has already been assigned to a user account. Please contact support to continue.",

      "violation.user.validPasswordValidator.password.assertTrue": "Please enter a valid password (six characters long, incl. at least one digit)",

      "violation.validatePaymentMethods.haveBlockedPaymentIfPayInOnly": "A deposit using payment method PayIn must be done before Rental",

      "violation.validatePaymentMethods.haveBlockedPaymentIfPayInOnly.assertTrue": "A deposit using payment method PayIn must be paid before Rental.",

      "wait": "Please wait..",

      "web.copy": "Copy",

      "web.edit": "Edit",

      "web.external.browser.title": "Please continue in a different web browser.",

      "web.external.button.section": "Click on the following Button",

      "web.external.button.title": "Continue the registration in Browser",

      "web.external.email.section": "Checkout your email inbox",

      "web.external.email.section.desc": "Click on the button in the email we just sent to this address:",

      "web.external.ignore.link": "Ignore & continue",

      "web.external.link.section": "Or",

      "web.external.link.section.desc": "Copy the following link and open it in another Web-Browser",

      "whatsapp": "Live Chat (Whatsapp)",

      "wj.copy.no": "Cancel",

      "wj.copy.title": "Copy to clipboard",

      "wj.copy.yes": "Copy",

      "wj.email.code.placeholder": "Enter 4-digit code",

      "wj.email.verify.desc": "Enter the code we just sent to this e-mail address:",

      "wj.email.verify.title": "Confirm email",

      "wj.link.copied": "Copied to clipboard",

      "wj.map.filter.violation.duration": "Range selected should be at least one hour",

      "wj.map.filter.violation.min": "Please make sure selected dates are valid",

      "wj.map.filter.violation.order": "Please make sure selected dates are valid",

      "wj.map.filter.violation.period": "Booking period should be less ",

      "wj.phone.code.placeholder": "Enter 4-digit SMS code",

      "wj.phone.verify.code.desc": "Enter the code we have just sent by SMS to this cell phone number:",

      "wj.phone.verify.code.title": "Enter SMS code",

      "wj.pin.desc": " ",

      "wj.pin.placeholder": "Enter 4-digit PIN",

      "wj.pin.title": "Access data",

      "wj.schufa.birthday.violation.max": "Please make sure selected date is valid",

      "wj.schufa.birthday.violation.min": "Please make sure selected date is valid",

      "wj.upload": "Upload image",

      "wj.value.copied": "Value copied to clipboard: %s",

      "wma.trackingPage.extendedArea.name": "Driving to extended area",

      "yes": "Yes",

      "yesterday": "yesterday",

    },
    "de": {
      "ADD": "HINZUFÜGEN",

      "AT": "Österreich",

      "Ab": "Ab",

      "Assigned": "Mieten",

      "BE": "Belgien",

      "BG": "Bulgarien",

      "CH": "Schweiz",

      "CY": "Zypern",

      "CZ": "Tschechien",

      "Camera": "Kamera",

      "DE": "Deutschland",

      "DK": "Dänemark",

      "DL.button.text": "Führerschein jetzt scannen",

      "DL.desr": "Lass deine Fahrerlaubnis bestätigen, indem du deinen Führerschein jetzt hochlädst.",

      "DL.issuecountry.placeholder": "Ausstellungsland ",

      "DL.paper.country.notvalid": "Wir unterstützen nur Papierführerscheine aus Deutschland und Österreich.\nBitte versuche es erneut mit einem Führerschein im Plastikformat.",

      "DL.paper.date.notvalid": "Rosa Führerscheine im Papierformat für Personen, die nach 1953 geboren sind, können digital nicht verarbeitet werden. Bitte probiere es mit einem Führerschein im Plastikformat.",

      "DL.paper.stepFour": "Achte auf die Lichtverhältnisse und nimm alles ab, was dein Gesicht verdeckt (Brille, Hut etc.).",

      "DL.paper.stepOne": "Gültig nur bei Geburtsjahr vor 1953.",

      "DL.paper.stepThree": "Nimm je ein Foto von der kompletten Vorder- und Rückseite auf.",

      "DL.paper.stepTwo": "Lege deinen vollständig aufgeklappten Führerschein auf einen farblich neutralen Untergrund.",

      "DL.stepFour": "Achte auf die Lichtverhältnisse und nimm alles ab, was dein Gesicht verdeckt (Brille, Hut etc.).",

      "DL.stepOne": "Halte deinen persönlichen Führerschein (nicht Ihren Personalausweis!) im Original bereit.",

      "DL.stepThree": "Lege deinen Führerschein auf einen farblich neutralen Untergrund.",

      "DL.stepTwo": "Vorläufige und Nicht-EU-Führerscheine werden nicht akzeptiert.",

      "DL.title": "Fahrerlaubnis",

      "Did.you.mean": "Meinst du",

      "EE": "Estland",

      "EL": "Griechenland",

      "ES": "Spanien",

      "EUR": "€",

      "FI": "Finnland",

      "FR": "Frankreich",

      "FRM_Franklin_Partner_Fix": "Franklin Partner Fix",

      "GB": "Großbritannien",

      "GR": "Griechenland",

      "HR": "Kroatien",

      "HU": "Ungarn",

      "ID.button.text": "Ausweisdokument jetzt scannen",

      "ID.desr": "Wähle, mit welchem Dokumenten-Typ du dich ausweisen möchtest.",

      "ID.id_card.stepFour": "Dein Ausweis muss in einem EU-Land ausgestellt worden sein.",

      "ID.id_card.stepOne": "Halte deinen persönlichen Personalausweis oder Aufenthaltstitel im Original bereit.",

      "ID.id_card.stepThree": "Achte auf die Lichtverhältnisse und nimm alles ab, was dein Gesicht verdeckt (Brille, Hut etc.).",

      "ID.id_card.stepTwo": "Lege deinen Ausweis auf einen farblich neutralen Untergrund.",

      "ID.manual.option": "Ich habe kein Dokument mit meiner Adresse",

      "ID.passport.stepOne": "Halte deinen persönlichen Reisepass im Original bereit.",

      "ID.passport.stepThree": "Achte auf die Lichtverhältnisse und nimm alles ab, was dein Gesicht verdeckt (Brille, Hut etc.).",

      "ID.passport.stepTwo": "Lege den Reisepass auf einen farblich neutralen Untergrund.",

      "ID.stepOne": "Ich habe ein in der EU ausgestelltes Ausweisdokument (Personalausweis, Reisepass oder Aufenthaltstitel).",

      "ID.stepThree": "Achte auf die Lichtverhältnisse und nimm alles ab, was dein Gesicht verdeckt (Brille, Hut etc.)",

      "ID.stepTwo": "Lege dein Ausweisdokument auf einen farblich neutralen Untergrund.",

      "ID.title": "Ausweisdokument",

      "ID.type.card": "Personalausweis oder Aufenthaltstitel",

      "ID.type.label": "Art des Dokuments wählen",

      "ID.type.passport": "Reisepass",

      "ID_CARD": "Personalausweis",

      "IE": "Irland",

      "IS": "Island",

      "IT": "Italien",

      "LI": "Liechtenstein",

      "LT": "Litauen",

      "LU": "Luxemburg",

      "LV": "Lettland",

      "MC": "Monaco",

      "MR": "Herr",

      "MRS": "Frau",

      "MT": "Malta",

      "NL": "Niederlande",

      "NO": "Norwegen",

      "Other": "Andere",

      "PASSPORT": "Reisepass",

      "PL": "Polen",

      "PT": "Portugal",

      "RO": "Rumänien",

      "SE": "Schweden",

      "SI": "Slowenien",

      "SK": "Slovensky",

      "UK": "Vereinigtes Königreich",

      "Uhr": "Uhr",

      "Update.email": "Update",

      "VISA": "Aufenthaltstitel",

      "about.dialog": "Über GETAWAY",

      "about.url": "https://get-a-way.com/getaway-carsharing?utm_source=app",

      "accepted.invitation": "ANGENOMMENE EINLADUNGEN",

      "account-deposit.warning.btn": "Kaution hinterlegen",

      "account-deposit.warning.desc": "Um dein Nutzerkonto freizuschalten, hinterlege bitte jetzt die erstattungsfähige Kaution. <br><br>✓ wird erstattet nach Vertragsende<br> ✓ mit Kautionsrechnung als Pdf<br> ✓ sichere Zahlung per PayPal, Kreditkarte uvm.",

      "account.deposit.description": "Um dein Nutzerkonto freizuschalten, hinterlege bitte jetzt die erstattungsfähige Kaution. ✓ wird erstattet nach Vertragsende ✓ mit Kautionsrechnung als Pdf",

      "account.low.schufa.desc": "Die Freischaltung dieser Zahlungsmethode ist fehlgeschlagen. Die Bonitätsprüfung ergab keine Übereinstimmung. Leider können wir Ihnen derzeit keine Alternative anbieten, um die Registrierung abzuschließen.\n\nWir bitten, von weiteren Registrierungsversuchen abzusehen.",

      "account.org.pending.payment.note": "Deine Zahlung wird geprüft. Du erhältst eine E-Mail, sobald es Neuigkeiten gibt.",

      "account.payment.blocked.desc": "Um diese Zahlungsmethode freizuschalten, begleichen Sie bitte alle offenen Forderungen. Bei Rückfragen kontaktieren Sie user Service Team.",

      "account.sepaVerification.mismatch.dialog.message": "Deine Bankverbindung %s wird durch %s ersetzt.",

      "account.sepaVerification.mismatch.dialog.no": "Abbrechen",

      "account.sepaVerification.mismatch.dialog.title": "Bankverbindung ändern?",

      "account.sepaVerification.mismatch.dialog.yes": "Ändern",

      "account.sepaVerification.warning.btn": "Jetzt bestätigen",

      "account.sepaVerification.warning.desc": "Um diese Bankverbindung zu bestätigen, führe bitte die 1-Euro-Verifizierung durch.",

      "accountHolder": "Kontoinhaber",

      "action.permission.button.title": "Neu anmelden",

      "action.permission.details": "Wir haben eine Fehlermeldung erhalten und arbeiten bereits an der Lösung. Bitte beende jetzt die App und starte sie neu. \n\nSollte das Problem weiterhin auftreten, kontaktiere bitte unser Service Team.",

      "action.permission.title": "Etwas hat nicht funktioniert.",

      "action.permission.yes": "Ja",

      "add": "HINZUFÜGEN",

      "add.car.enhancement.wizard.description": "Je besser dein Auto ausgestattet ist, desto eher wird es gemietet.",

      "add.car.enhancement.wizard.title": "Aktualisiere die Ausstattung deines Autos",

      "add.damage.wizard.description": "Bitte protokolliere alle aktuellen Mängel am Auto, um für eventuelle Neuschäden reibungsfreier entschädigt zu werden.",

      "add.damage.wizard.footer": "Ich bestätige, dass das Auto bis auf die bereits aufgeführten Mängel schadenfrei ist.",

      "add.damage.wizard.title": "Schäden & Mängel",

      "add.damage.wizard.update": "ÜBERNEHMEN",

      "add.damages.footnote": "Wenn keine der Optionen passt, klick bitte oben rechts auf das Support-Symbol, um uns zu kontaktieren",

      "add.payment.method.success": "Danke, deine Zahlungsmethode ist aktualisiert worden.",

      "add.tariff": "Zur Tarifwahl",

      "add.to.apple.calendar": "Zum Apple Kalender hinzufügen",

      "add.to.calendar.title": "Kalender",

      "add.to.device.calendar": "Zum Gerätekalender hinzufügen",

      "add.to.google.calendar": "Zum Google Kalender hinzufügen",

      "add.to.outlook.calendar": "Zum Outlook-Kalender hinzufügen",

      "add.to.yahoo.calendar": "Zum Yahoo-Kalender hinzufügen",

      "addpayment.card.desc": "Kredit-/Debitkarte hinzufügen",

      "addpayment.card.title": "Visa oder MasterCard",

      "addpayment.directdebit.desc": "Girokonto hinzufügen",

      "addpayment.paypal": "Paypal",

      "addpayment.paypal.desc": "Verbinde dein Paypal-Konto",

      "address": "Meldeadresse",

      "address.austria.streetNum.label": "Haus/Stiege/Tür",

      "address.required": "Um fortzufahren, füge bitte deine Adresse hinzu.",

      "address.unavailable": "Abholzone anzeigen",

      "addressCheck.dialog.message": "Die Überprüfung deiner Meldeadresse war nicht erfolgreich. \n\nBitte kontaktiere unser Service Team.",

      "addressCheck.dialog.title": "Überprüfung der Meldeadresse",

      "addressCheck.dialog.tryAgain": "ERNEUT VERSUCHEN",

      "addressCheck.dialog.yes": "OK",

      "addressProof.button.text": "Dokument hochladen",

      "addressProof.desr": "Meine Adresse durch ein offizielles Dokument bestätigen lassen",

      "addressProof.stepOne": "Schreiben vom Finanzamt, von deiner Bank, etc.",

      "addressProof.stepTwo": "Adresse und Name gut lesbar",

      "addressProof.title": "Dokument mit Adresse",

      "addressSearch.cancel.text": "Abbrechen",

      "addressSearch.current.label": "Mein Standort",

      "addressSearch.search.placeholder": "Adresse suchen",

      "always.open": "rund um die Uhr",

      "android.update.dialog.message": "Es ist eine neue Version erhältlich. Bitte aktualisiere auf die neuste Version.",

      "android.update.dialog.no": "Später",

      "android.update.dialog.title": "Update erhältlich",

      "android.update.dialog.yes": "Update",

      "api_error.active_invite_not_found": "Einladungscode nicht gefunden oder inaktiv",

      "api_error.block_payment_parameter_missing": "Zahlung fehlgeschlagen. Bitte mit alternativer Zahlungsmethode oder später erneut versuchen.",

      "api_error.block_payment_required": "Zahlung fehlgeschlagen. Bitte mit alternativer Zahlungsmethode oder später erneut versuchen.",

      "api_error.booking.combined_signup_not_allowed": "Die Anmeldung ist gesperrt",

      "api_error.booking.confirm.blocked_payment_failed": "Problem mit autorisiertem Betrag. Buchung konnte nicht bestätigt werden.",

      "api_error.booking.confirm.fleet_not_allowed_for_circle": "Fahrzeug ist für diesen Nutzerkreis nicht verfügbar.",

      "api_error.booking.confirm.rental_type_not_matching": "Falscher Nutzerkreis-Typ für diese Buchung",

      "api_error.booking.payin.from": "Bitte wähle eine spätere Startzeit, um fortzufahren",

      "api_error.booking.update.conflicting_booking_for_car": "Es besteht bereits eine Reservierung für diesen Zeitraum.",

      "api_error.booking.update.conflicting_booking_for_user": "Nutzer hat bereits eine Reservierung in diesem Zeitraum",

      "api_error.booking.update.conflicting_rental_for_car": "Fahrzeug ist bereits in Miete",

      "api_error.booking.update.conflicting_rental_for_user": "Nutzer ist bereits in Miete",

      "api_error.booking.update.invalid_interval": "Verlängerung nicht möglich, es besteht bereits Folgebuchung.",

      "api_error.brand.sunset.bookings_restricted": "Aufgrund der Abschaltung der Marke kann diese Reservierung leider nicht angelegt werden.",

      "api_error.brand.sunset.rentals_restricted": "Aufgrund der Abschaltung der App kann diese Miete nicht angelegt werden.",

      "api_error.brand.sunset.user_profile_update_restricted": "Die Aktualisierung des Nutzerkontos ist wegen der Abschaltung der Marke eingeschränkt",

      "api_error.cantamen.invalid_password": "Authentifizierung notwendig: Bitte gib dein aktuelles Passwort an, mit dem du dich in der (Web-)App einloggst.",

      "api_error.captcha-check-failed": "Wir konnten nicht nachweisen, dass du ein Mensch bist. Bitte versuche es erneut oder kontaktiere den Support",

      "api_error.carUnavailable": "dieses Auto ist nicht zur Verfügung bitte ein anderes wählen",

      "api_error.email_code.no_more_attempts": "Keine weiteren Versuche",

      "api_error.invalid_tariff": "Tarif nicht erlaubt",

      "api_error.invitation.link_expired": "Einladungslink ist abgelaufen oder Einladungslimit überschritten",

      "api_error.invites_disabled_for_circle": "Neue Einladungen deaktiviert",

      "api_error.not_available": "Diese Aktion kann nicht ausgeführt werden.",

      "api_error.not_available_forPayin": "Diese Aktion kann mit der momentan ausgewählten Zahlungsmethode nicht ausgeführt werden.",

      "api_error.org.duplicate": "Firma mit dieser Registernummer existiert bereits.",

      "api_error.partners.new_registration.rejected": "Dein aktueller Tarif erlaubt keine Tarifpartner. Bitte kontaktiere den Support für Bestandskunden für weitere Informationen. Wir bitten die Unannehmlichkeit zu entschuldigen.",

      "api_error.partners.partners_limit_exceeded": "Die maximale Anzahl von Tarifpartnern wurde erreicht. Bitte kontaktiere den Support für weitere Informationen.",

      "api_error.payin_notAllowed": "Bitte wähle eine spätere Startzeit, um fortzufahren",

      "api_error.payment.3ds_required": "Bitte authentifiziere jetzt deine Kreditkarte (Händlername \"GETAWAY\"), um fortzufahren.\n\nDie Authentifizierung löst keine Zahlung aus.",

      "api_error.payment.adyen_3ds_response_not_received": "Die Antwort unseres Zahlungsdienstleisters hat zu lange gedauert. Bitte versuche es erneut.",

      "api_error.payment.adyen_rejected_request": "Zahlungsanfrage wurde abgelehnt.",

      "api_error.payment.adyen_response_not_received": "Zahlungsanfrage ausgelaufen.",

      "api_error.payment.card_validation_attempts_exceeded": "Verifizierung der Zahlungsmethode fehlgeschlagen, bitte kontaktiere den Support",

      "api_error.payment.card_validation_failed": "Verifizierung fehlgeschlagen",

      "api_error.payment.method_not_allowed": "Deine aktive Zahlungsmethode wird in diesem Land derzeit nicht unterstützt, bitte füge eine andere hinzu.",

      "api_error.payment.paypal_validation_attempts_exceeded": "PayPal Verifizierung fehlgeschlagen.",

      "api_error.payment.paypal_validation_failed": "PayPal Verifizierung zu oft fehlgeschlagen. Bitte kontaktiere unser Service Team.",

      "api_error.phoneNumber.isValid": "Die eingegebene Telefonnummer ist ungültig. Bitte gib eine neue Nummer ein",

      "api_error.rental.update.cannot_reduce_back_by_if_pay_as_reserved": "Die Rückgabezeit kann nicht verkürzt werden, da die gesamte gebuchte Dauer berechnet wird.",

      "api_error.rental.update.invalid_back_by": "Falsch eingegebene Zeit",

      "api_error.ride.pooling.no_offer": "Es sind keine Fahrzeuge in Deiner Nähe",

      "api_error.ride_pooling.no_offer": "Es sind keine Fahrzeuge in Deiner Nähe",

      "api_error.ride_pooling.no_offer.has_ongoing_trip": "Du hast bereits eine aktive Fahrt oder Reservierung",

      "api_error.ride_pooling.no_offer.no_seats": "Es gibt keine freien Plätze für diese Fahrt",

      "api_error.ride_pooling.no_offer.resolved_same_stop_for_pickup_and_release": "Einstiegs- und Ausstiegsort sind identisch",

      "api_error.ryd.digital_fuel.car_position_unknown": "Das Fahrzeug kann derzeit nicht geortet werden, daher lässt sich keine Tankstelle vorschlagen.",

      "api_error.ryd.digital_fuel.not_enabled": "Digitales Tanken ist für dieses Fahrzeug nicht verfügbar.",

      "api_error.ryd.digital_fuel.session_not_cancellable": "Dieser Tankvorgang kann nicht mehr abgebrochen werden.",

      "api_error.ryd.digital_fuel.tank_full": "Der Tank ist schon voll.",

      "api_error.ryd.digital_fuel.trip_not_started": "Tanken ist erst nach der Fahrzeugübernahme möglich.",

      "api_error.user.cw_address_missing": "Bitte gib deine Adresse ein, um fortzufahren.",

      "api_error.user.email.change_not_allowed": "Diese E-Mail Adresse kann nicht genutzt werden.",

      "api_error.user.iban.duplicate": "Diese IBAN kann nicht registriert werden. Möglicherweise wird sie bereits genutzt. Kontaktiere den Support für weitere Hilfe.",

      "api_error.user.id_submission_attempts_exceeded": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktiere unser Service Team.",

      "api_error.user.identityMismatch": "Diese Person kann nicht zur Bonitätsprüfung herangezogen werden",

      "api_error.user.identity_card_submission_attempts_exceeded": "Maximale Anzahl an Versuchen aufgebraucht. Bitte kontaktiere den Support.",

      "api_error.user.invitation_link.max_invites_exceeded": "Anzahl der Plätze für diesen Einladungslink überschritten",

      "api_error.user.invitation_link.wrong_booking_status": "Kann nicht beitreten, weil die Reservierung bereits begonnen oder storniert wurde",

      "api_error.user.license_submission_attempts_exceeded": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktiere unser Service Team.",

      "api_error.user.password_reset.same_phone_used_in_multiple_accounts": "Kann nicht fortfahren, weil dieselbe Telefonnummer für mehrere Konten verwendet wird.",

      "api_error.user.phone_verification.max_attempts": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktiere unser Service Team.",

      "api_error.user.redirectToWeb": "Bitte fahre in deinem eigenen Webbrowser fort.",

      "api_error.user.schufaCheck.data_incomplete": "Daten unvollständig",

      "api_error.user.tariff_missing": "Um fortzufahren, wähle  bitte zuerst einen Tarif.",

      "api_error.user.too_young": "Für dein aktuelles Alter steht derzeit kein passender Tarif zur Auswahl. Bitte versuche es erneut, sobald du %s Jahre alt wirst",

      "api_error.user.update.synced_with_merchant_system": "Das Benutzerkonto konnte nicht aktualisiert werden. Bitte versuche es erneut oder kontaktiere den Support",

      "api_error.user.verificationCode.incorrectOrExpired": "Code inkorrekt oder abgelaufen.",

      "api_error.user_not_belong_to_circle_brand": "Kein Mitglied des Nutzerkreises",

      "app.old.dialog.description": "Wir haben festgestellt, dass auf deinem Gerät noch die alte GETAWAY-App installiert ist. \n\nBitte klicke auf \"Deinstallieren\", um diese zu entfernen.",

      "app.old.dialog.title": "Deinstalliere die alte App",

      "app.privacy.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA-INT_dataprivacy-de.pdf",

      "app.terms.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA-INT_termsandconditions-de.pdf",

      "applink.error": "Dieser Link ist nicht mehr aktuell. Bitte kontaktiere unser Service Team für weitere Infos.",

      "apply": "ÜBERNEHMEN",

      "area.6195052566acea0d11785b70.name": "Berlin (Neuenhagen)",

      "area.6293587021004a075975ed81.name": "Zhero (Mallorca)",

      "area.632abb191018da079a871065.name": "Berlin Brandenburg",

      "area.636fd246f563af071662cf6c.name": "Lustenau",

      "area.63f3b9000af72c0765aae927.name": "Mallorca (Lindner Hotel)",

      "area.63ff1dcac77ce8071d9dbac1.name": "Dornbirn (Kehlerstraße 6)",

      "area.644bc810935fbb07bb0b902a.name": "Bregenz (Lochau)",

      "area.6697be5570475106e9c17023.name": "Bregenz (Bahnhof)",

      "area.68fe520326116829219fddad.name": "IKEA Klagenfurt",

      "area.68fe520326116829219fddb0.name": "IKEA Innsbruck",

      "area.68fe520326116829219fddb4.name": "IKEA Vösendorf",

      "area.68fe520326116829219fddb7.name": "IKEA Graz",

      "area.68fe520326116829219fddba.name": "IKEA Haid",

      "area.68fe520326116829219fddbd.name": "IKEA Wien (Nord)",

      "area.68fe520326116829219fddc0.name": "Stationsbetrieb Buchbinder",

      "area.68fe520326116829219fddc3.name": "Station Wien (Modecenterstraße)",

      "area.68fe520326116829219fddc6.name": "IKEA Salzburg",

      "area.68fe520326116829219fddca.name": "IKEA Linz",

      "area.68fe520326116829219fddce.name": "IKEA CDC Strebersdorf",

      "area.68fe520326116829219fddd1.name": "IKEA Wiener Neustadt",

      "area.698b458181ab41790a6824ef.name": "OBI Wien (Hadikgasse)",

      "area.698c4d7c1ad7db155a40bd51.name": "Stationsbetrieb Wien (Flughafen)",

      "area.69b95ad89db4e3682c4f0bf7.name": "OBI Wien (Triester Straße)",

      "area.69b95bc89db4e3682c4f10b3.name": "OBI Wien (Haidhofstraße)",

      "area.69b961408393db4678aaa974.name": "OBI Vösendorf (Triester Straße)",

      "area.69e0f2dccb79244ac5c0d10c.name": "Stationsbetrieb Graz (Stadt)",

      "area.69ec8d8b611ea67412f119c6.name": "Transporter Wien (Modecenterstraße)",

      "area.69faec19cb07f61532b93d39.name": "Campingplatz (Berlin)",

      "area.69fb7e4ce24a290cbe584cf8.name": "IKEA Linz (Transporter)",

      "area.6a1ebd0cccaef87a77cd90f9.name": "IKEA Salzburg (Transporter)",

      "area.6a2023e639e0293c43b74e53.name": "IKEA CDC Strebersdorf (Transporter)",

      "area.6a26ce03940743260dc9b94d.name": "Innsbruck",

      "area.6a314e6b2a390664b74ab06c.name": "IKEA Klagenfurt (Transporter)",

      "area.6a7049c957fb440b9e358bef.name": "Innsbruck Flughafen (Transporter)",

      "area.6a7ed7d4eddc5114a270b468.name": "Innsbruck Flughafen",

      "area.brand_not_resolved": "Gewählter Anbieter wurde nicht erkannt.",

      "area.card.info": "Infos zur Zone",

      "area.card.navigate": "Navigieren",

      "area.fleet.brand.not_match": "Gewählte Flotte gehört nicht zum ausgewählten Anbieter.",

      "area.fleet_not_resolved": "Flotte wurde nicht erkannt.",

      "area.label": "Rückgabezone",

      "area.label.outside": "Bitte beachte die Rückgabezone",

      "area.walkthrough.description": "Bringe das Fahrzeug zum Beenden der Miete in die farblich hervorgehobene Rückgabezone mit einem Tankstand von mind. 25% zurück und verriegele es mit dein Handy.",

      "area.walkthrough.title": "Zurückbringen und Miete beenden",

      "auth.failed.alert.body": "Bitte versuche es erneut oder klicke \"Vergessen?\", um dein Passwort zurückzusetzen.",

      "auth.failed.alert.title": "Falsches Passwort",

      "backend.error": "Ups..etwas ist schief gelaufen. Bitte probiere es gleich noch einmal.",

      "balance": "Guthaben",

      "balance.addFunds": "Guthaben hinzufügen",

      "balance.addFunds.description": "Spare mit unseren Guthabenpaketen",

      "balance.addPaymentMethod": "Zahlungsmittel hinzufügen",

      "balance.delete.confirm": "Möchtest du dieses Zahlungsmittel tatsächlich entfernen?",

      "balance.getFreeCredit": "Erhalte gratis Guthaben",

      "balance.getFreeCredit.description": "Meistere Herausforderungen und erhalte Belohnungen.",

      "balance.invoice.failure": "Entschuldige bitte. Der Beleg konnte nicht versendet werden.",

      "balance.invoice.success": "Dein Beleg wird dir zeitnah per E-Mail gesendet!",

      "balance.paymentMethods": "ZAHLUNGSMITTEL",

      "balance.payoutFunds": "Guthaben auszahlen",

      "balance.payoutFunds.addSEPA.dialog.message": "Bitte füge deine Kontodaten hinzu, sodass wir dir dein Guthaben auszahlen können.",

      "balance.payoutFunds.addSEPA.dialog.title": "Auszahlungsart hinzufügen",

      "balance.payoutFunds.description": "Auszahlbares Guthaben",

      "balance.payoutFunds.dialog.message": "Auszahlbares Guthaben wird deinem Konto am Monatsende automatisch gutgeschrieben.",

      "balance.payoutFunds.dialog.title": "Guthaben auszahlen",

      "balance.payoutFunds.error.message": "Auszahlbares Guthaben wird einmal im Monat automatisch auf dein hinterlegtes Bankonto überwiesen.",

      "balance.send.invoice": "BELEG\SENDEN",

      "balance.transactions": "UMSÄTZE",

      "bank.select.desr": "Hinterlege jetzt deine Kontodaten für sichere und bequeme Zahlungen per Lastschriftverfahren.",

      "bank.select.header": "Bitte wähle dein Bankkonto",

      "bank.select.title": "Zahlungsmethode hinterlegen",

      "bis": "bis",

      "bluetooth.dialog.description": "Per Bluethooth kannst du Autos in deiner Umgebung einfach per Handy öffnen.",

      "bluetooth.dialog.title": "Bluetooth® aktivieren",

      "bluetooth.disabled.message": "Achtung: Bitte erlaube Zugriff auf dein Bluetooth, um Fahrzeuge ent-/verriegeln zu können.",

      "bluetooth.permission.allow.details": "Achtung: Bitte erlaube Zugriff auf dein Bluetooth, um Fahrzeuge ent-/verriegeln zu können.",

      "bluetooth.permission.allow.title": "Bluetooth Freigabe",

      "bluetooth.permission.details": "Zur sicheren Handy/Auto-Interaktion aktiviere jetzt die Bluetooth-Funktion im Control Center deines Handys.",

      "bluetooth.permission.message": "Achtung: Bitte erlaube Zugriff auf dein Bluetooth, um Fahrzeuge ent-/verriegeln zu können.",

      "bluetooth.permission.title": "Aktiviere Bluethooth®",

      "bluetooth.permission.yes": "Erlauben",

      "bonus.sheet.description.lowAndOut": "Der Tankstand des Fahrzeugs muss bei Rückgabe mindestens 25% betragen.\n\nErhalte 5 € Sofort-Gutschrift, wenn du die Miete in der Rückgabezone beendest und weitere 5 €, wenn du das Fahrzeug betankst.",

      "bonus.sheet.description.lowFuel": "Der Tankstand des Fahrzeugs muss bei Rückgabe mindestens 25% betragen.\n\nErhalte eine 5€ Sofort-Gutschrift als Dank, wenn du das Fahrzeug volltankst. Die Bezahlung ist kostenfrei und bargeldlos mit der bereitgestellten Tankkarte im Handschuhfach. ",

      "bonus.sheet.description.out&low": "Der Tankstand des Fahrzeugs muss bei Rückgabe mindestens 25% betragen und das Beenden der Miete muss in der Rückgabezone erfolgen\n\nErhalte eine 5€ Sofort-Gutschrift, wenn du den Mietvorgang in der Rückgabezone des Fahrzeugs beendest.\n\nErhalte weitere 5€, wenn du das Fahrzeug volltankst. Die Bezahlung ist kostenfrei und bargeldlos mit der bereitgestellten Tankkarte im Handschuhfach.",

      "bonus.sheet.description.outsideArea": "Das Beenden der Miete muss in der Rückgabezone erfolgen.\n\nErhalte eine 5€ Sofort-Gutschrift als Dank, wenn du den Mietvorgang in der Rückgabezone des Fahrzeugs beendest.",

      "bonus.sheet.ok": "Ok",

      "book.station.cta": "An Station finden",

      "booking.1.available.cars": "Noch 1 Fahrzeug zu diesem Preis verfügbar.",

      "booking.2.available.cars": "Noch 2 Fahrzeuge zu diesem Preis verfügbar.",

      "booking.BookedCarIsBLOCKED": "Fahrzeug war nicht verfügbar",

      "booking.BookedCarIsRELEASE_READY": "Fahrzeug war nicht verfügbar",

      "booking.BookedCarIsRENTED": "Fahrzeug war nicht verfügbar",

      "booking.BookedCarIsUnavailable": "Fahrzeug war nicht verfügbar",

      "booking.BookingCancelled": "Reservierung wurde storniert",

      "booking.DriverHasOngoingRental": "Es lief bereits eine Miete",

      "booking.OtherReason": "technische Probleme",

      "booking.OtherRentalConstraintViolation": "Fahrzeug war nicht verfügbar",

      "booking.RentalCancelled": "Miete wurde storniert",

      "booking.RentalExpired": "Reservierung abgelaufen",

      "booking.accessToken": "technische Probleme",

      "booking.add.to.calendar": "Zum Kalender hinzufügen",

      "booking.added.to.calendar.success": "Zum Kalender hinzugefügt",

      "booking.additional.driver.action": "Zusatzfahrer",

      "booking.additional.driver.description": "Zusatzfahrer müssen sich im Anschluss an die Reservierung über den Einladungslink registrieren und vor Mietbeginn verifiziert sein. Fahranfänger sind nicht zulässig.",

      "booking.additional.driver.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_additionalDriver.png",

      "booking.additional.driver.link.footnote.md": "Zusatzfahrer müssen sich über den Einladungslink registrieren und vor Mietbeginn verifiziert sein. Fahranfänger sind nicht zulässig.",

      "booking.additional.driver.link.prefix": "Einladungslink",

      "booking.additional.driver.link.share": "Einladungslink teilen",

      "booking.additional.driver.price": "9€ + 2€/Kal.Tag",

      "booking.additional.driver.section.title": "Zusatzfahrer",

      "booking.additional.driver.share.text": "Schließ dich der Buchung %@ an",

      "booking.additional.driver.title": "Zusatzfahrer",

      "booking.backByConflictsWithBooking": "technische Probleme",

      "booking.backByExpired": "technische Probleme",

      "booking.blockedByUpcomingBooking": "technische Probleme",

      "booking.blockedPaymentConfirmed": "Zahlung fehlgeschlagen",

      "booking.button.text": "Auf Karte anzeigen",

      "booking.cancel.fee.footnote": "Danach fällt eine Stornierungsgebühr iHv. bis zu %s an. Diese Gebühr wird erlassen, sofern bis %s ein alternativer Mietvorgang gestartet wird.",

      "booking.cancellation.text": "✓ Gratis stornierbar bis %s",

      "booking.cancelled": "Storniert",

      "booking.cancelled.at": "Reservierung storniert um %s",

      "booking.car.unavailable": "Das Fahrzeug ist nicht verfügbar",

      "booking.confirm.car.profile": "Fahrzeug",

      "booking.confirm.cost": "Initiale Kosten",

      "booking.confirm.from": "Von",

      "booking.confirm.payin.text": "Direkt im Anschluss an die Reservierung ist das Hinterlegen einer Kaution fällig. Es wird hierfür ein Zahlungs-Link zur Verfügung gestellt.                                               \n                                                            \nMöchtest du das nicht, dann wähle eine alternative Zahlungsart.",

      "booking.confirm.payin.title": "Kaution",

      "booking.confirm.profile": "Fahrzeug",

      "booking.confirm.profile.consent": "Mir ist bewusst, dass ich meine Registrierung vor planmäßigem Buchungsbeginn abgeschlossen haben muss - andernfalls wird diese zu den Bedingungen gemäß Stornierungen durch Kundenverschulden storniert.",

      "booking.confirm.to": "Bis",

      "booking.confirmation.button": "Kostenpflichtig reservieren",

      "booking.confirmation.title": "Prüfe die Reservierung",

      "booking.conformation.no.address": "Abholzone anzeigen",

      "booking.consent.button": "Reservierung bestätigen",

      "booking.consent.cancel": "Ablehnen",

      "booking.consent.cancel.dialog.message": "Wenn du die Reservierungsanfrage ablehnst, wird diese storniert. Das Fahrzeug kann dann von anderen Nutzern gemietet werden.",

      "booking.consent.cancel.dialog.title": "Bitte bestätige deine Auswahl",

      "booking.consent.cancel.dialog.yes": "Ablehnen & stornieren",

      "booking.consent.circle": "Nutzerkreis",

      "booking.consent.later.dialog.message": "Prüfe und bestätige die Reservierungsanfrage rechtzeitig. Andernfalls wird diese automatisch storniert.",

      "booking.consent.later.dialog.yes": "Ok",

      "booking.cost.footnote": "Zusätzliche Entgelte können anfallen. Mehr Infos sind dem %s zu entnehmen.\n\nBitte beachte bei geplanten Buchungen, dass für die Berechnung der Mietkosten auch bei einer vorzeitigen Rückgabe der gesamte ursprünglich reservierte Zeitraum herangezogen werden kann.",

      "booking.cost.footnote.url": "https://google.com",

      "booking.cost.footnote.url.text": "Fahrzeugprofil",

      "booking.cost.includedkm": "Inklusivkilometer",

      "booking.cost.section": "Kosten",

      "booking.create": "GETAWAY finden",

      "booking.create.success": "Danke! Wir haben deine Anfrage erhalten und suchen jetzt einen passenden GETAWAY für dich.",

      "booking.created": "Erstellt",

      "booking.date.fake.url": "https://googles.com",

      "booking.deposit.footnote": "Mit der Reservierung wird eine initiale Kaution iHv. %s fällig. Übersteigen die Mietkosten die hinterlegte Kaution, werden weitere Kautionszahlungen fällig. Bitte sorge stets für ausreichend Deckung.\n\nIm Anschluss an den Mietvorgang wird die Gesamtkaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen erstattet.",

      "booking.deposit.section": "Initiale Kaution",

      "booking.deposit.title": "Kaution",

      "booking.desktop.start": "Miete Starten",

      "booking.details.header.descr": "Ab planmäßigem Mietbeginn startest du den Mietvorgang, indem du das Fahrzeug mit deinem Handy entriegelst.",

      "booking.details.section.title": "Deine Reservierung",

      "booking.driver.accepted.title": "gute Fahrt mit deinem GETAWAY!",

      "booking.driver.add": "Fahrer",

      "booking.driver.cancel": "Reservierung stornieren",

      "booking.driver.cancel.dialog.message": "Stornierungsgebühren können anfallen.\n\nIst eine Kaution hinterlegt worden, wird diese nach Verrechnung etwaiger Gebühren unmittelbar im Anschluss an die Stornierung erstattet.",

      "booking.driver.cancel.dialog.title": "Reservierung stornieren",

      "booking.driver.cancel.dialog.yes": "Jetzt stornieren",

      "booking.driver.cancel.success": "Deine Reservierung ist storniert worden. Ist eine Kaution hinterlegt worden, wird diese automatisch erstattet.",

      "booking.driver.confirm.dialog.message": "Gute Wahl! Mit deiner Bestätigung wird dieser GETAWAY für dich reserviert.",

      "booking.driver.confirm.dialog.title": "Diesen GETAWAY reservieren",

      "booking.driver.confirm.dialog.yes": "Jetzt reservieren",

      "booking.driver.count.title": "Zusatzfahrer",

      "booking.driver.details.description": "Sobald wir passende Autos für dich gefunden haben, schicken wir dir die Auswahl.",

      "booking.driver.details.header.description": "Bitte sei nachsichtig. Dieses Feature befindet sich in der Testphase. Wir freuen uns über dein Feedback!",

      "booking.driver.details.header.title": "Finde deinen perfekten GETAWAY! [BETA]",

      "booking.driver.details.text": "Die Preise basieren auf der genannten Dauer und Gesamtstrecke inkl. Kraftstoff. Der Endpreis berechnet sich nach tatsächlicher Dauer und zurückgelegter Strecke.",

      "booking.driver.details.title": "Deine Reservierung",

      "booking.driver.nooffers": "✨\nVerfügbare GETAWAYs\nwerden dir hier angezeigt.",

      "booking.driver.offer.choose": "Auswählen",

      "booking.driver.offer.request": "Anfragen",

      "booking.driver.offer.reserve": "Reservieren",

      "booking.driver.offer.reserving": "Reservierung läuft...",

      "booking.driver.offered.title": "wähle deinen perfekten GETAWAY!",

      "booking.driver.section": "Fahrer",

      "booking.driver.waitingoffer": "Angebot warten",

      "booking.early.start": "Reservierung früher starten",

      "booking.end": "Bis",

      "booking.fee.fake.url": "https://google.com",

      "booking.fee.title": "Stornierungsbedingungen",

      "booking.fee.value": "25€",

      "booking.fix.cancellation.note": "Bei Stornierung keine Erstattung der zeitbezogenen Kosten (Stunden-, Tagespreise etc.).\n  \nDu hast 30 Minuten ab planmäßigem Mietbeginn Zeit, den Mietvorgang zu starten. Danach verfällt deine Reservierung ersatzlos.",

      "booking.fix.option.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_besterPreis.png",

      "booking.flex.cancellation.note": "Bei Stornierung vor planmäßigem Mietbeginn am %s Uhr werden die Mietkosten erstattet. Die Gebühr für flexibles Buchen ist nicht erstattungsfähig.\n\nBei Stornierung danach findet keine Erstattung statt.\n\nDu hast bis zu 24 Stunden ab planmäßigem Mietbeginn Zeit, den Mietvorgang zu starten - maximal jedoch bis zum planmäßigem Mietende. Danach verfällt deine Reservierung ersatzlos.",

      "booking.flex.option.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_flexibelBleiben.png",

      "booking.free.cancellation.text": "✓ Gratis stornierbar ",

      "booking.fuelCardMissing": "technische Probleme",

      "booking.guest.confirmation.button": "Jetzt anmelden",

      "booking.haveBlockedPaymentIfPayInOnly": "bitte wählest du den Zeitrahmen für die  Reservierung.",

      "booking.header.in": "Noch",

      "booking.headline.expired": "Reservierung ist abgelaufen",

      "booking.headline.payment": "Zahlungsdaten",

      "booking.headline.reservation": "Reservierungsdaten",

      "booking.headline.started": "Reservierung hat begonnen",

      "booking.insurance.SB500.popular": "Meist gewählt",

      "booking.insurance.desc": "Im Schadensfall kann es schnell teuer werden. Begrenze dein Haftungsrisiko mit einer reduzierten Selbstbeteiligung.",

      "booking.insurance.title": "Reduzieren Sie Ihr Risiko",

      "booking.insurance.type": "Typ",

      "booking.label.checked": "Zurückgenommen",

      "booking.label.expired": "Abgelaufen",

      "booking.label.started": "Gestartet",

      "booking.label.waiting.checkin": "in Rückgabe",

      "booking.map.bar.text": "Nächste Reservierung:",

      "booking.map.pre.signup": "Klicke hier um deine Buchung abzuschließen.",

      "booking.mileage.placeholder": "Ich weiß noch nicht",

      "booking.mileage.title": "Gesamtstrecke (circa)",

      "booking.online": "technische Probleme",

      "booking.option.SB500.popular": "Meist gewählt",

      "booking.option.fix.price": "0€ (inklusive)",

      "booking.option.fix.subtitle": "✓ Keine Erstattung bei Stornierung\n✓ Miete ist innerhalb von 30 Min. ab planmäßigem Mietbeginn zu starten",

      "booking.option.fix.title": "Bester Preis",

      "booking.option.flex.price": "0,49 €/Std (4,90 €/Kal.Tag)",

      "booking.option.flexBooking.popular": "Beliebt",

      "booking.option.flexBooking.subtitle": "✓ Gratis stornierbar bis planmäßigem Mietbeginn\n✓ 24 Std. ab planmäßigem Mietbeginn (max. Mietende), um Miete zu starten",

      "booking.option.flexBooking.title": "Flexibel bleiben",

      "booking.option.title": "Wähle die Buchungsoption",

      "booking.payByLink.description": "Schließe bitte jetzt die Zahlung ab und kehre im Anschluss zu deinem Nutzerkonto zurück.",

      "booking.payin.blockPayment.description": "Mit der Reservierung werden 300,-€ via Vorkasse angefordert. Übersteigen die Mietkosten den Kautionsbetrag, können weitere Zahlungen fällig werden. Bitte sorge stets für ausreichend Deckung.\n\nIm Anschluss an den Mietvorgang wird die Kaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen wieder freigegeben.",

      "booking.payin.blockPayment.title": "Kaution bei Vorkasse-Zahlung",

      "booking.payin.blockPayment.yes.text": "Weiter",

      "booking.payment": "Zahlungsart",

      "booking.payment.change": "Zahlungsmethode wechseln",

      "booking.payment.payIn.title": "Vorkasse",

      "booking.payment.section": "Zahlungsdaten",

      "booking.places.current": "Aktuelle Position",

      "booking.places.search": "Adresse eingeben",

      "booking.places.title": "Von wo",

      "booking.pre.signup.clear": "Löschen",

      "booking.preferredcar.title": "Auto",

      "booking.requestedCar.title": "Fahrzeug",

      "booking.section.details": "Details",

      "booking.section.timeline": "Zeitstrahl",

      "booking.start": "Von",

      "booking.start.address": "Von wo",

      "booking.status": "Status",

      "booking.status.cancelled": "Storniert",

      "booking.status.expired": "Abgelaufen",

      "booking.upsellings.SB500.popular": "Meist gewählt",

      "booking.userMarkedForFraud": "Zahlung fehlgeschlagen",

      "booking.warning.payin.button": "Jetzt Kaution hinterlegen",

      "booking.warning.payin.text": "Hinterlege jetzt die Kaution, um die Reservierung abzuschließen. Andernfalls wird sie in wenigen Minuten storniert.",

      "booking.warning.payin.text.payed": "Das hat geklappt. Bitte warte nun auf den Beginn deiner Miete.",

      "booking.warning.payin.title": "Kaution",

      "booking.warning.payin.title.payed": "Kaution erfolgreich hinterlegt",

      "booking.warning.payin.value": "150,00 Euro",

      "booking.warning.profile.button": "Vollständiges Profil",

      "booking.warning.profile.text": "⚠️ Bitte vervollständige dein Profil vor planmäßigem Buchungsstart – andernfalls wird die Reservierung storniert und es gelten die Bedingungen für Stornierung durch Kundenverschulden.",

      "booking.warning.profile.title": "Vervollständige dein Profil",

      "booking.when": "Wann?",

      "bookings.headline.booked": "Gebucht",

      "bookings.headline.reservation": "Reserviert",

      "bookings.profile.cancel.text": "Reservierung stornieren",

      "bookings.profile.title": "Meine Reservierungen",

      "bookings.where.desc": "Der genaue Standort des Fahrzeugs wird 30 Minuten vor Buchungsbeginn angezeigt.",

      "brand.bnd.name": "book-n-drive",

      "brand.getaway.name": "GETAWAY",

      "brand.mba.name": "Mietbar",

      "brand.mis.name": "Miet Smart",

      "brand.msi.name": "Miet Smart",

      "brand.rw.name": "Share die Robbe",

      "brand.ubq.name": "ubeeqo",

      "brandName": "Markenname",

      "bubPassenger.Buchbinder.pricing.6a7de9e98a03e46ab9d01572": "|||\n| :------------- |------------:|\n|       |  **Stundenpreis**     |\n| Mo-Do    |   3,90 €    |\n| Fr-So      | 4,90 €     |\n\n\n||||\n| :------------- |-------------:|-------------:|\n|       | **Tag 1 bis 3**    | **Ab Tag 4**     |\n| Mo-Do      | 39 €/Kal.Tag     | 29 €/Kal.Tag     |\n| Fr-So      | 49 €/Kal.Tag     | 39 €/Kal.Tag     |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,44 €/km|\n| Ab dem 101. Kilometer | 0,39 €/km|\n\n\n| Selbstbeteiligung (je Schadensfall) | | |\n| :-------- | -------: | -------: |\n| SB bis Fahrzeugwert | | inklusive (0€) |\n| SB 1.500€ | 1€/Std. | 9 €/Kal.Tag |\n| SB 500€ | 2€/Std. | 14 €/Kal.Tag |\n| SB 150€ | 4€/Std. | 19 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/6a7dd88a8a03e46ab9d01559/pdf) zu entnehmen. ",

      "bubPassenger.Buchbinder.pricing.6a7de9fe8a03e46ab9d01574": "|||\n| :------------- |------------:|\n|       |  **Stundenpreis**     |\n| Mo-Do    |   4,90 €    |\n| Fr-So      | 5,90 €     |\n\n\n||||\n| :------------- |-------------:|-------------:|\n|       | **Tag 1 bis 3**    | **Ab Tag 4**     |\n| Mo-Do      | 49 €/Kal.Tag     | 39 €/Kal.Tag     |\n| Fr-So      | 59 €/Kal.Tag     | 49 €/Kal.Tag     |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,44 €/km|\n| Ab dem 101. Kilometer | 0,39 €/km|\n\n\n| Selbstbeteiligung (je Schadensfall) | | |\n| :-------- | -------: | -------: |\n| SB bis Fahrzeugwert | | inklusive (0€) |\n| SB 1.500€ | 1€/Std. | 9 €/Kal.Tag |\n| SB 500€ | 2€/Std. | 14 €/Kal.Tag |\n| SB 150€ | 4€/Std. | 19 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/6a7dd88a8a03e46ab9d01559/pdf) zu entnehmen. ",

      "bubTransporter.Buchbinder.pricing": "**Transporter L1 (Fiat Scudo o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n|       | **je Std.**    | **je Kal.Tag**     |\n| Mo–Do | 7,90 €| max. 79 €|\n| Fr–So | 9,90 € | max. 99 € |\n\n\n**Transporter L3 (Nissan Interstar o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n|       | **je Std.**    | **je Kal.Tag**     |\n| Mo–Do | 9,90 € | max. 99 €|\n| Fr–So | 11,90 € | max. 119 € |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 €/km|\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| SB bis Fahrzeugwert | inklusive (0€) |\n| SB 1.500€ | 14 €/Kal.Tag |\n| SB 500€ | 19 €/Kal.Tag |\n| SB 150€ | 24 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf) zu entnehmen. ",

      "bubTransporter.Buchbinder.pricing.68fe518326116829219fdd7a": "**Transporter L1 (Fiat Scudo o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n|       | **je Std.**    | **je Kal.Tag**     |\n| Mo–Do | 7,90 €| max. 79 €|\n| Fr–So | 9,90 € | max. 99 € |\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 €/km|\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| SB bis Fahrzeugwert | inklusive (0€) |\n| SB 1.500€ | 14 €/Kal.Tag |\n| SB 500€ | 19 €/Kal.Tag |\n| SB 150€ | 24 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf) zu entnehmen. ",

      "bubTransporter.Buchbinder.pricing.69aaadf2af5c7b01c5a98c5b": "**Transporter L3 (Nissan Interstar o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n|       | **je Std.**    | **je Kal.Tag**     |\n| Mo–Do | 9,90 € | max. 99 €|\n| Fr–So | 11,90 € | max. 119 € |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 €/km|\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| SB bis Fahrzeugwert | inklusive (0€) |\n| SB 1.500€ | 14 €/Kal.Tag |\n| SB 500€ | 19 €/Kal.Tag |\n| SB 150€ | 24 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf) zu entnehmen. ",

      "business": "geschäftlich",

      "button.lock": "Verriegeln",

      "button.unlock": "Entriegeln",

      "calendar.dismiss": "Schließen",

      "call": "Anrufen",

      "callout.show.availability": "Verfügbarkeit anzeigen",

      "camera.addressProof.upload": "hochladen",

      "camera.permission.details": "Um fortzufahren und Fotos aufzunehmen, erlaube GETAWAY jetzt Zugriff auf deine Kamera.",

      "camera.permission.no": "Später",

      "camera.permission.title": "Zugriff auf Kamera",

      "camera.permission.yes": "Erlauben",

      "cancel": "Abbrechen",

      "cancel.FirstSteps.dialog.message": "Nur 2 Minuten: Schließe jetzt die Registrierung ab und starte sofort deine erste Miete.",

      "cancel.FirstSteps.dialog.message.noBonus": "Nur 2 Minuten: Schließe jetzt die Registrierung ab und starte sofort deine erste Miete.",

      "cancel.FirstSteps.dialog.no": "Abbrechen",

      "cancel.FirstSteps.dialog.yes": "Jetzt nicht",

      "cancel.rental.handover": "Möchtest du den aktuellen Mietvorgang abbrechen?",

      "car.approximateMileage.gt250k": "über 250.000 km",

      "car.approximateMileage.lt100k": "50.000 - 100.000 km",

      "car.approximateMileage.lt150k": "100.000 - 150.000 km",

      "car.approximateMileage.lt200k": "150.000 - 200.000 km",

      "car.approximateMileage.lt250k": "200.000 - 250.000 km",

      "car.approximateMileage.lt50k": "unter 50.000 km",

      "car.available.book": "BUCHEN",

      "car.category.name.label": "Preisgruppe",

      "car.co2.text": "Kg eingespartes CO2",

      "car.damage": "Schaden",

      "car.damage.categories.title": "Was möchten Sie melden?",

      "car.damage.create.dialog.title": "Schaden oder Mangel melden",

      "car.damage.edit.notallowed.description": "Während einer laufenden Miete kann das Schadenprotokoll nicht geändert werden.",

      "car.damage.edit.notallowed.title": "Änderungen nicht möglich",

      "car.damage.remove.dialog.remove": "Schaden entfernen",

      "car.damage.remove.dialog.title": "Bist du sicher?",

      "car.damages": "Schäden",

      "car.damages.photos.dialog.description": "Füge jetzt bitte mindestens ein Foto von diesem Schaden/Mangel hinzu, um diesen besser nachvollziehbar zu machen.",

      "car.damages.photos.dialog.title": "Fotos vom Schaden",

      "car.data.title": "Stammdaten",

      "car.data.view.btn.continue": "Weiter",

      "car.data.view.btn.start": "Beginnen",

      "car.data.view.btn.upload": "Hochladen",

      "car.data.view.description": "Bitte stelle sicher, dass VIN und Fahrzeugmodell korrekt sind, bevor du weitermachst.",

      "car.data.view.document": "Foto der Einbau-Daten",

      "car.data.view.document.sample": "Siehe Beispiel: ",

      "car.data.view.title": "Daten zum Einbau",

      "car.demo.unavailable.messege": "Bitte öffne den Appstore und aktualisiere jetzt deine App-Version, um dieses Auto zu mieten.",

      "car.demo.unavailable.title": "Miete nicht möglich",

      "car.details.available.until.placeholder": "Verfügbar bis",

      "car.details.car.info": "AUTOPROFIL",

      "car.details.carplate.placeholder": "Kennzeichen",

      "car.details.damages": "Schäden",

      "car.details.equipment": "AUSSTATTUNG",

      "car.details.fuel.diesel": "Diesel",

      "car.details.fuel.electric": "Elektrisch",

      "car.details.fuel.hybrid": "Hybrid",

      "car.details.fuel.hybrid_diesel": "Hybrid/Diesel",

      "car.details.fuel.hybrid_unleaded95": "Hybrid/Benzin 95",

      "car.details.fuel.hybrid_unleaded98": "Hybrid/Benzin 98",

      "car.details.fuel.lpg": "LPG",

      "car.details.fuel.other": "Anderer",

      "car.details.fuel.placeholder": "Kraftstoff",

      "car.details.fuel.unleaded95": "Super",

      "car.details.fuel.unleaded98": "Super Plus",

      "car.details.gear.automatic": "Automatik",

      "car.details.gear.manual": "Manuell",

      "car.details.gear.type.placeholder": "Getriebeart",

      "car.details.height": "Ladehöhe",

      "car.details.initial.registration.placeholder": "Erstzulassung",

      "car.details.length": "Ladelänge",

      "car.details.list.damages.placeholder": "Gemeldete Schäden",

      "car.details.listofdamages.title": "SCHADENSLISTE",

      "car.details.loadCapacity": "Ladegewicht",

      "car.details.lock.text": "VERRIEGELN",

      "car.details.mileage.gt100": "Mehr als 100.000 km",

      "car.details.mileage.lt100": "Weniger als 100.000 km",

      "car.details.mileage.lt20": "Weniger als 20.000 km",

      "car.details.mileage.lt50": "Weniger als 50.000 km",

      "car.details.mileage.placeholder": "Kilometerstand",

      "car.details.pickupreturn.placeholder": "Standort",

      "car.details.pollution.placeholder": "Umweltplakette",

      "car.details.pos.reviews": "Positive Bewertungen",

      "car.details.reviews": "Bewertungen",

      "car.details.techincaldata": "Technische Daten",

      "car.details.uhr": "Uhr",

      "car.details.unlock.text": "Miete starten",

      "car.details.unlock.text.brand": "Miete starten",

      "car.details.unlocking.text": "Entriegeln...",

      "car.details.width": "Ladebreite",

      "car.device.doors.open": "Bitte stelle sicher, dass alle Türen verschlossen sind.",

      "car.device.fuel.card.missing": "Bitte lege die Tankkarte in die dafür vorgesehene Halterung im Handschuhfach.",

      "car.device.keys.missing": "Bitte stelle sicher, dass der Autoschlüssel in der dafür vorgesehenen Halterung im Handschuhfach liegt.",

      "car.device.view.btn.txt": "Weiter",

      "car.device.view.description": "Bitte anhand der Seriennummer auswählen",

      "car.device.view.search.label": "Nach SN suchen",

      "car.device.view.title": "CloudBoxx verbinden",

      "car.device.windows.open": "Bitte stelle sicher, dass alle Fenster verschlossen sind.",

      "car.equipment.abs": "ABS",

      "car.equipment.adaptiveLighting": "Kurvenlicht",

      "car.equipment.airConditioning": "Klimaanlage",

      "car.equipment.alloyWheels": "Leichtmetallfelgen",

      "car.equipment.auxiliaryHeating": "Standheizung",

      "car.equipment.childSeat": "Kindersitz",

      "car.equipment.collisionAvoidanceSystem": "Notbremsassistent",

      "car.equipment.cruiseControl": "Tempomat",

      "car.equipment.disabledAccessible": "Behindertengerecht",

      "car.equipment.distanceControlAssistSystem": "Abstandstempomat",

      "car.equipment.electricHeatedSeats": "Sitzheizung",

      "car.equipment.esp": "ESP",

      "car.equipment.feature": "Extras",

      "car.equipment.fourWheelDrive": "Allradantrieb",

      "car.equipment.handsFreeKit": "Freisprechanlage",

      "car.equipment.interior": "Innenausstattung",

      "car.equipment.laneDepartureWarningSystem": "Spurhalteassistent",

      "car.equipment.multifunctionalWheel": "Multifunktionslenkrad",

      "car.equipment.navigationSystem": "Navigationssystem",

      "car.equipment.panoramicRoof": "Panorama-Dach",

      "car.equipment.parkingAssistSystem": "Einparkhilfe",

      "car.equipment.powerAssistedSteering": "Servolenkung",

      "car.equipment.rainSensor": "Regensensor",

      "car.equipment.roofBars": "Dachgepäckträger",

      "car.equipment.safety": "Sicherheit",

      "car.equipment.startStopSystem": "Start/Stopp-Automatik",

      "car.equipment.sunroof": "Schiebedach",

      "car.equipment.tractionControl": "Traktionskontrolle",

      "car.equipment.trailerCoupling": "Anhängerkupplung",

      "car.feedback.text": "liebe dein Auto",

      "car.findNearest.notExist": "Kein verfügbares Fahrzeug. Versuche einen anderen Zeitraum oder vergrößere den Kartenausschnitt.",

      "car.handover.failed.description.unlock": "Entriegele das Auto und starte den Vorgang erneut.",

      "car.handover.failed.title": "Vorgang fehlgeschlagen",

      "car.handover.manual.fuelLevel.description": "Niemand möchte ein Auto mit fast leerem Tank hinterlassen bekommen. Bitte bestätige, dass das der Tankstand mindestens ca. 25% beträgt.",

      "car.handover.manual.fuelLevel.title": "Tankstand ausreichend?",

      "car.handover.nodamages": "Keine gemeldeten Schäden",

      "car.insurance": "Versicherungsschutz",

      "car.owner.dialog.rented.message": "Zum Schutz der Privatsphäre des Mieters ist die aktuelle Position deines Autos verschlüsselt. Wir benachrichtigen dich im Anschluss des Mietvorgangs.",

      "car.owner.dialog.rented.title": "Aktuell vermietet",

      "car.pollution.green": "Grün",

      "car.pollution.nobadge": "Keine",

      "car.pollution.red": "Rot",

      "car.pollution.unknown": "Unbekannt",

      "car.pollution.yellow": "Gelb",

      "car.price": "%@ € pro km",

      "car.price.desc": "Lege fest, was du pro Kilometer verdienen möchtest. Du kannst diesen Wert jederzeit anpassen.",

      "car.price.footer": "*Hierbei handelt es sich um eine unverbindliche Schätzung. Letztlich hängen die tatsächlichen Einnahmen von der Verfügbarkeit und Begehrtheit deines Autos ab.",

      "car.price.high": "Zu teuer",

      "car.price.low": "Zu günstig",

      "car.price.title": "Verdienst pro Kilometer",

      "car.price.update": "SPEICHERN",

      "car.profile.area.name": "Name",

      "car.profile.area.note": "Hinweise zur Zone",

      "car.profile.area.openinghrs": "Zugang",

      "car.profile.area.title": "Abhol-/Rückgabezone",

      "car.profile.blockReasons.label": "Downtime-Grund:",

      "car.profile.brand": "Marke",

      "car.profile.damages": "Schäden & Mängel",

      "car.profile.description": "Bearbeite dein Autoprofil",

      "car.profile.dimensions.note": "Maße können abweichen. Wenn es knapp werden könnte, wähle zur Sicherheit eine größere Fahrzeugkategorie.",

      "car.profile.engine": "Motorleistung",

      "car.profile.equipment": "Ausstattung",

      "car.profile.history.date.interval.to": "bis",

      "car.profile.instructions": "Die besten Tipps, um deine Mieteinnahmen zu erhöhen, findest du in unserem %@.",

      "car.profile.instructions.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "car.profile.instructions.url.text": "HilfeCenter",

      "car.profile.lastCleaning.label": "Letzte Reinigung:",

      "car.profile.model": "Modell",

      "car.profile.price.details": " https://robbe.app/feetable",

      "car.profile.price.message": "Circa %@ € pro Monat*",

      "car.profile.price.per.km": "Dein Verdienst pro km",

      "car.profile.rental.description": "Liste aller Mietvorgänge",

      "car.profile.rental.history": "MIETVORGÄNGE",

      "car.profile.rented.back": "Rückkehr spät.",

      "car.profile.tab.availability": "Verfügbarkeit",

      "car.profile.tab.info": "Info",

      "car.profile.tab.pricing": "Preise",

      "car.profile.terminate": "AUTO ENTFERNEN",

      "car.profile.view": "Autoprofil",

      "car.registration.camera.description": "Positioniere die aufgeklappte Kfz-Schein Vorderseite innerhalb der Markierung.",

      "car.registration.photo.description": "(vollständig aufgeklappt)",

      "car.registration.photo.title": "Kfz-Schein Vorderseite",

      "car.release.ignition.message": "Du kannst dein Auto nur freigeben, wenn der Motor aus ist.",

      "car.release.ignition.title": "Freigabe nicht möglich",

      "car.released": "Dein Auto ist freigegeben worden",

      "car.released.error": "Bitte probiere es später erneut",

      "car.rental.cancelled": "Deine Reservierung ist storniert worden. Ist eine Kaution hinterlegt worden, wird diese automatisch erstattet.",

      "car.rental.cancelled.time": "Deine Buchung ist storniert worden. Du hast das Auto nicht rechtzeitig geöffnet.",

      "car.rental.count": "Mietvorgänge",

      "car.rental.rental": "Mietvorgang",

      "car.rental.rentals": "Mietvorgänge",

      "car.rental.trips": "FAHRTEN",

      "car.rentals.title": "Mietvorgänge",

      "car.rented.back": "Zurück am",

      "car.rented.backtoday": "Zurück um",

      "car.rented.backtomorrow": "Morgen zurück um",

      "car.reserve.blockPayment.description": "Mit der Reservierung werden initial 100,-€ auf deiner Kreditkarte geblockt. Übersteigen die Mietkosten den Kautionsbetrag, können weitere Zahlungen fällig werden. Bitte sorge stets für ausreichend Deckung.\n\nIm Anschluss an den Mietvorgang wird die Kaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen wieder freigegeben.",

      "car.reserve.blockPayment.paypal.description": "Mit der Reservierung werden initial 100,-€ auf deinem Paypal-Konto geblockt. Übersteigen die Mietkosten den Kautionsbetrag, können weitere Zahlungen fällig werden. Bitte sorge stets für ausreichend Deckung. Im Anschluss an den Mietvorgang wird die Kaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen wieder freigegeben.	",

      "car.reserve.blockPayment.paypal.title": "Kaution bei Zahlung via PayPal",

      "car.reserve.blockPayment.paypal.yes": "Fortfahren",

      "car.reserve.blockPayment.title": "Kaution bei Kreditkartenzahlung",

      "car.reserve.blockPayment.yes.text": "Fortfahren",

      "car.reserve.carBooked.description": "Dieses Fahrzeug hat eine Folgemiete und muss bis zu diesem Zeitpunkt zurückgebracht werden. Andernfalls können Gebühren anfallen.",

      "car.reserve.carBooked.title": "Fahrzeugrückgabe in %s.",

      "car.reserve.carBooked.yes.text": "Zustimmen",

      "car.review.title": "Erfahrungen",

      "car.search.notExist": "Dieses Fahrzeug existiert nicht.",

      "car.select.cta": "Los geht's!",

      "car.select.search.label": "Nach VIN suchen",

      "car.select.tab.installation": "Installation",

      "car.select.tab.removal": "Deinstallation",

      "car.select.view.description": "Wähle jetzt das Fahrzeug anhand der Fahrgestellnummer.",

      "car.select.view.ongoing.label": "Laufende Einbauten",

      "car.select.view.title": "Fahrzeug wählen",

      "car.service.count": "Service-Fahrten",

      "car.status.battery.voltage": "Batteriespannung",

      "car.status.button.refresh": "Status aktualisieren",

      "car.status.fuel.card": "Tankkarte",

      "car.status.fuel.level": "Tankstand",

      "car.status.key": "Fahrzeugschlüssel",

      "car.status.mileage": "Kilometerstand",

      "car.status.missing": "Fehlt",

      "car.status.not.found": "Autostatus kann nicht gelesen werden.",

      "car.status.not.required": "Nicht verfügbar",

      "car.submit.approximateMileage": "Ungefährer Kilometerstand",

      "car.submit.footer": "Das Auto  ist verkehrstüchtig mit gültiger Haftpflichtversicherung und Hauptuntersuchung.",

      "car.submit.leased": "Ich bin Leasingnehmer",

      "car.submit.legalnotice": "Ich stimme einer etwaigen Datenprüfung zur Zahlungswahrscheinlichkeit zu und bestätige, dass das Auto verkehrstüchtig ist und über eine gültige Haftpflichtversicherung wie auch einer Hauptuntersuchung verfügt.",

      "car.submit.legalnotice.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "car.submit.legalnotice.url.text": "Datenprüfung",

      "car.submit.notowner": "Ich bin nicht Halter/Eigentümer",

      "car.submit.owner": "Ich bin Halter/Eigentümer",

      "car.submit.ownership": "Wem gehört das Auto?",

      "car.submit.ownership.description": "Du kannst das Auto problemlos anmelden, auch wenn du selbst nicht Halter/Eigentümer bist. Mehr Infos folgen in der Anmeldebestätigung.",

      "car.terminate.dialog.message": "Bitte kontaktiere unser Service Team, um dein Autoprofil entfernen zu lassen.",

      "car.terminate.dialog.title": "Autoprofil entfernen",

      "car.title": "DEIN AUTO",

      "car.transaction.title": "Mieteinnahme %@",

      "car.unlock.bluetooth.disabled": "Bluetooth® aktivieren \nzum Entriegeln",

      "car.unlock.bluetooth.disabled.brand": "Bluetooth® aktivieren",

      "car.unlock.bluetooth.searching": "Distanz verringern\nzum Entriegeln",

      "car.unlock.bluetooth.searching.brand": "Distanz verringern",

      "car.unlock.closeToCar.action": "Ich stehe am Fahrzeug - jetzt entriegeln",

      "car.unlock.locationpermission.dialog.message": "Bitte erteile über die Browsereinstellungen die Standortberechtigung, um das Auto aufzuschließen.",

      "car.unlock.locationpermission.dialog.title": "standortermittlung ist deaktiviert",

      "car.unlock.tooFar.message": "Bitte probiere es erneut aus geringerer Distanz. Sobald sich dein Handy mit dem Fahrzeug verbunden hat, kannst du es mit der App entriegeln.\n\nBei Problemen kontaktiere bitte unser Service Team über das Chat-Symbol oben rechts im Bildschirm.",

      "car.unlock.tooFar.title": "Bitte verringere die Distanz",

      "car.unreleased": "Dein Auto ist nicht mehr freigegeben",

      "car.unreleased.error": "Dein Auto kann nicht freigegeben werden. Bitte probiere es später erneut.",

      "carCheck.addImage.labelFour": "Hinten, links",

      "carCheck.addImage.labelOne": "Vorne, links",

      "carCheck.addImage.labelThree": "Hinten, rechts",

      "carCheck.addImage.labelTwo": "Vorne, rechts",

      "card.number": "Kreditkartennummer",

      "carprofile.footnote": "Die besten Tipps, um deine Mieteinnahmen zu erhöhen, findest du in unserem %@.",

      "carprofile.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "carprofile.footnote.url.text": "HilfeCenter",

      "carprofile.troubleshoot.description": "Der Motor deines Autos springt nicht an? Hier kannst du die Motorsperre entriegeln.",

      "carprofile.troubleshoot.title": "Motorsperre verwalten",

      "cars.carousel.title": "Finde deinen perfekten GETAWAY!",

      "challenges.completed.section": "GEMEISTERTE HERAUSFORDERUNGEN",

      "challenges.firstSteps.addPayment.text": "Zur Verifizierung deines Nutzerkontos",

      "challenges.firstSteps.addPayment.title": "Hinterlege eine Zahlungsmethode",

      "challenges.firstSteps.bonusTransactionReason": "Erste Schritte",

      "challenges.firstSteps.createAccount.text": "Großartig, du hast dich erfolgreich registriert",

      "challenges.firstSteps.createAccount.title": "Erstelle ein Nutzerkonto",

      "challenges.firstSteps.description": "Du bist kurz davor, die Straße zu erobern. Erledige schnell die ersten Schritte und erhalte sofort %s € Startguthaben!",

      "challenges.firstSteps.enterPIN.title": "PIN bestimmt",

      "challenges.firstSteps.firstRental.text": "Mache deinen ersten Ausflug mit GETAWAY",

      "challenges.firstSteps.firstRental.title": "Miete ein Auto",

      "challenges.firstSteps.listCar.text": "Lass dein Auto Geld für dich verdienen!",

      "challenges.firstSteps.listCar.title": "Registriere dein Auto",

      "challenges.firstSteps.manualApproval.title": "Manuell freigegeben",

      "challenges.firstSteps.payDeposit.title": "Anzahlung leisten",

      "challenges.firstSteps.saveAddress.text": "Schreibe uns, wo du wohnst",

      "challenges.firstSteps.saveAddress.title": "Hinterlege deine Meldeadresse",

      "challenges.firstSteps.selectTariff.title": "Tarif auswählen",

      "challenges.firstSteps.title": "Erste Schritte",

      "challenges.firstSteps.verifyAuthorizedRepresentative.title": "Vertretungsberechtigung verifiziert",

      "challenges.firstSteps.verifyCompany.title": "Organisation verifiziert",

      "challenges.firstSteps.verifyDriversLicense.text": "Um Zugang zum Fuhrpark zu erhalten",

      "challenges.firstSteps.verifyDriversLicense.title": "Bestätige deine Fahrerlaubnis",

      "challenges.firstSteps.verifyEmail.text": "Um deine E-Mail Adresse zu verifizieren",

      "challenges.firstSteps.verifyEmail.title": "Verifiziere deine E-Mail Adresse.",

      "challenges.firstSteps.verifyIDDocument.text": "Um Zugang zur Fahrzeugflotte zu erhalten.",

      "challenges.firstSteps.verifyIDDocument.title": "Identitäts-Dokument verifizieren",

      "challenges.firstSteps.verifyIban.title": "IBAN überprüfen",

      "challenges.firstSteps.verifyPhoneNumber.text": "Um dein Handy zum Autoschlüssel zu machen",

      "challenges.firstSteps.verifyPhoneNumber.title": "Bestätige deine Handy-Nummer",

      "challenges.inviteFriends.bonusTransactionReason": "Eingeladener Freund",

      "challenges.inviteFriends.description": "Schenke deinen Freunden und Nachbarn einen 10€ Willkommensbonus und erhalte selbst 10€, wenn sie diesen einlösen.",

      "challenges.inviteFriends.title": "Lade 5 Freunde ein",

      "challenges.up.to": "Bis zu",

      "change": "Ändern",

      "change.password.success": "Dein Passwort ist erfolgreich aktualisiert worden.",

      "circle.brand_not_resolved": "Nutzerkreis nicht erkannt",

      "circle.emailRequired": "E-Mail-Adresse erforderlich",

      "circle.type.area": "Gebietsbezogen",

      "circles.button.text": "ÜBERNEHMEN",

      "circles.input.placeholder": "Einladungscode eingeben",

      "circles.join.success.msg": "Du hast jetzt besonderen Zugang zu Fahrzeugen und Preisen!",

      "circles.join.success.title": "Du bist dem Nutzerkreis beigetreten.",

      "claim": "Melden",

      "claim.photo.note": "Bitte füge mindestens ein Foto hinzu.",

      "claim.photo.title": "Fotos hinzufügen",

      "clean.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeDirt_compressed.png",

      "clean.damage.option1": "Ja",

      "clean.damage.option2": "Nein",

      "clean.damage.option3": "Ich weiß es nicht",

      "clean.damage.picker.holder": "Muss gereinigt werden?",

      "clean.damage.title": "Verschmutzung melden",

      "clear.damages": "Schäden zurücksetzen",

      "clear.damages.prompt.text": "Bist du sicher?",

      "clipboard.link.copied": "Dein Einladungslink ist in deine Zwischenablage kopiert worden.",

      "closed": "geschlossen",

      "common.entity_created": "erstellt_am",

      "confirm": "Bestätigen",

      "connect.getaway.name": "Getaway Connect",

      "connect.getaway.support.phone": "+49 30 30808441",

      "connect.item.brand.name": "Kundenmarke",

      "connect.item.car.install": "Nach VIN suchen",

      "connect.item.car.remove": "Nach VIN suchen",

      "connect.item.chassisNumber": "VIN",

      "connect.item.cloudboxx.number": "CloudBoxx SN",

      "connect.item.device.serialNo": "CloudBoxx SN",

      "connect.item.fuel.card.number": "Tankkarte",

      "connect.item.mobile": "Handynummer",

      "connect.item.model": "Marke/Modell",

      "connect.item.plate": "Kennzeichen",

      "consents.agb": "Einwilligung",

      "consents.agb.desc": "Ich akzeptiere die [AGB](https://brandname.app/terms) von Brandname.",

      "consents.agb.title": "Allgemeine Geschäftsbedingungen",

      "consents.consent": "Einwilligung",

      "consents.details": "Details",

      "consents.newsletter.desc": "Ich bin damit einverstanden, den Newsletter zu erhalten.",

      "consents.newsletter.title": "Newsletter",

      "consents.privacy.policy.title": "Datenschutzerklärung",

      "consents.schufa.desc": "Ich willige der Verarbeitung meiner Daten zur [Prüfung der Zahlungswahrscheinlichkeit](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_smp/WL_DataPrivacy-DATA_Checks-de+02_2024.pdf) ein.",

      "consents.schufa.title": "Bonitätscheck",

      "consents.title": "Meine Einwilligungen",

      "contacts.invite.contact": "LADE %d KONTAKT EIN",

      "contacts.invite.contact.many": "LADE %d KONTAKTE EIN",

      "contacts.invite.earn": "Verdiene bis zu %@",

      "contacts.permission.details": "Um fortzufahren und Kontakte auszuwählen, erlaube GETAWAY jetzt Zugang zu deinen Kontakten.",

      "contacts.permission.no": "später",

      "contacts.permission.title": "Zugriff auf Kontakte",

      "contacts.permission.yes": "Erlauben",

      "continue": "Fortfahren",

      "countries.phone.list": "Verfügbare Länder",

      "creditcheck.terms": "Mit der Auswahl des SEPA-Lastschriftverfahrens willige ich der Verarbeitung meiner Daten zur %s ein.",

      "creditcheck.terms.highlight": "Prüfung der Zahlungswahrscheinlichkeit",

      "creditcheck.terms.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/WL_DataPrivacy-DATA_Checks-de.pdf",

      "custom.camera.description.car.registration": "Bitte fotografiere deinen Fahrzeugschein auf einer neutralen Oberfläche und stelle sicher, dass er innerhalb des Rahmens ist.",

      "custom.camera.description.damage": "Bitte achte darauf, dass der Schaden gut zu erkennen und in der Mitte des Photos ist.",

      "custom.camera.description.license": "Bitte lege deinen Führerschein auf eine neutrale Oberfläche innerhalb der Markierung und nimm ein Foto auf.",

      "custom.camera.description.selfie": "Bitte halte den Aufnahme-Button für 3 Sekunden gedrückt.",

      "custom.camera.holdmessage.selfie": "Halte den Aufnahme-Button für 3 Sekunden gedrückt, um dein Selfie aufzunehmen.",

      "custom.camera.repeat": "Wiederholen",

      "custom.camera.submit": "Übernehmen",

      "custom.camera.title.car.registration": "Fahrzeugschein",

      "custom.camera.title.damage": "Schadenaufnahme",

      "custom.camera.title.license.back": "Führerschein-Rückseite",

      "custom.camera.title.license.front": "Führerschein-Vorderseite",

      "custom.camera.title.selfie": "Selfie",

      "customerSupport.call": "ServiceTeam anrufen",

      "damage.add.noImages.error": "Bitte stelle sicher, dass du mindestens zwei Bilder hinzugefügt hast.",

      "damage.add.success": "Vielen Dank für deine Schadensmeldung!",

      "damage.clean.description": "Dreck, Zurückgelassenes oder sonstiges (Innen oder Außen)",

      "damage.clean.title": "Verschmutzung melden",

      "damage.detected.carvaloo_feedback_link": "Schadensereignis erkannt. Bitte jetzt Zustand des Fahrzeugs erfassen: %s",

      "damage.detials.reportedon": "Gemeldet am:",

      "damage.new": "NEU",

      "damage.new.notification.description": "Vielen Dank für die Aktualisierung des Schadenprotokolls! Du hast nun die Möglichkeit, die Vermieterin anzurufen.",

      "damage.normal.description": "Kratzer, Dellen, Beulen oder mehr",

      "damage.normal.title": "Schaden melden",

      "damage.screen.description": "Warnsymbol im Cockpit leuchtet",

      "damage.screen.title": "Kontrollleuchte melden",

      "damages.add": "Schaden melden",

      "damages.add.button.text": "Schaden hinzufügen",

      "damages.add.error.noimages": "Bitte füge mind. ein Foto des Schadens hinzu, um fortzufahren.",

      "damages.add.image.note": "Mindestens zwei Fotos (unterschiedliche Blickwinkel/ Abstände). Auf einem Foto muss das Kennzeichen zu erkennen sein.",

      "damages.bumper": "Stoßstange",

      "damages.burn": "Brandfleck",

      "damages.call": "Zu unseren Pannenhotlines",

      "damages.carRoadworthy": "Ist das Fahrzeug verkehrstüchtig?",

      "damages.characteristic": "Eigenschaften",

      "damages.characteristic.freeText": "anderes",

      "damages.characteristics.burn": "Brandfleck",

      "damages.characteristics.crack": "Riss",

      "damages.characteristics.deepScratch": "Kratzer (bis zur Grundierung)",

      "damages.characteristics.deepscratch": "Kratzer (bis zur Grundierung)",

      "damages.characteristics.dent": "Delle",

      "damages.characteristics.dirt": "Verschmutzung",

      "damages.characteristics.missing": "Nicht vorhanden",

      "damages.characteristics.other": "Anderes",

      "damages.characteristics.permanentDirt": "Dauerhafte Verschmutzung",

      "damages.characteristics.scratch": "Kratzer (oberflächlich)",

      "damages.characteristics.stoneChip": "Steinschlag",

      "damages.chars.left": "verbleibende Zeichen",

      "damages.component": "Bauteil",

      "damages.component.bumper": "Stoßstange",

      "damages.component.door": "Tür",

      "damages.component.engineBonnet": "Motorhaube",

      "damages.component.exteriorMirror": "Spiegel",

      "damages.component.floor": "Boden",

      "damages.component.hubcap": "Radkappe",

      "damages.component.interiorTrim": "Innenverkleidung",

      "damages.component.other": "Anderes",

      "damages.component.rearWindow": "Fenster",

      "damages.component.seat": "Sitz",

      "damages.component.sill": "Schweller",

      "damages.component.slidingDoor": "Schiebetür",

      "damages.component.tire": "Reifen",

      "damages.component.trunk": "Kofferraum/ Ladefläche",

      "damages.component.wheelRim": "Felge",

      "damages.component.windscreen": "Frontscheibe",

      "damages.component.wing": "Kotflügel",

      "damages.confirmRecord.button.text": "Schadensmeldung bestätigen",

      "damages.crack": "Riss",

      "damages.damage.desc": "Schadenbeschreibung",

      "damages.deepscratch": "Kratzer",

      "damages.dent": "Delle",

      "damages.description": "Schadensbeschreibung",

      "damages.dirt": "Verschmutzung",

      "damages.door": "Tür",

      "damages.engine.bonnet": "Motorhaube",

      "damages.exterior": "Außen",

      "damages.exterior.mirror": "Spiegel",

      "damages.floor": "Boden",

      "damages.gt10cm": ">10 cm",

      "damages.hubcap": "Radkappe",

      "damages.interior": "Innen",

      "damages.location": "Lage",

      "damages.location.front": "Vorderseite",

      "damages.location.na": "nicht verfügbar",

      "damages.location.rear": "Rückseite",

      "damages.location.side.center": "Mitte",

      "damages.location.side.codriver": "Beifahrerseite",

      "damages.location.side.driver": "Fahrerseite",

      "damages.lt10cm": "5 - 10cm",

      "damages.lt5cm": "<5 cm",

      "damages.new.photos.add": "Fotos hinzufügen",

      "damages.noRecord.text": "Keine Schadenmeldung",

      "damages.other": "Anderes",

      "damages.pernament.dirt": "Dauerhafte Verschmutzung",

      "damages.rear.window": "Fenster",

      "damages.report.areaQ": "Welcher Bereich?",

      "damages.report.charQ": "Was für ein Schaden?",

      "damages.report.compareSub": "An dieser Stelle sind bereits Schäden bekannt. Ist deiner dabei?",

      "damages.report.compareTitle": "Schon erfasst?",

      "damages.report.componentQ": "Welches Bauteil?",

      "damages.report.continue": "Weiter",

      "damages.report.continueNew": "Weiter — Neuschaden melden",

      "damages.report.describe": "Bitte beschreiben",

      "damages.report.doneBtn": "Fertig",

      "damages.report.doneSub": "Danke! Der Neuschaden wurde erfasst und wird geprüft.",

      "damages.report.doneTitle": "Schaden gemeldet",

      "damages.report.isKnown": "Ist bereits erfasst",

      "damages.report.isNew": "Nein — Neuschaden melden",

      "damages.report.knownSub": "Dann ist nichts weiter zu tun — der Schaden ist bereits dokumentiert.",

      "damages.report.knownTitle": "Alles klar",

      "damages.report.noneSub": "An dieser Stelle ist noch nichts erfasst — sieht nach einem Neuschaden aus.",

      "damages.report.noneTitle": "Keine bekannten Schäden",

      "damages.report.noteLabel": "Anmerkung (optional)",

      "damages.report.notePlaceholder": "z. B. zusätzliche Details …",

      "damages.report.other": "Sonstiges / Ich weiß es nicht",

      "damages.report.photoQ": "Fotos hinzufügen",

      "damages.report.sideQ": "Welche Seite?",

      "damages.report.submit": "Schaden melden",

      "damages.report.title": "Neuen Schaden melden",

      "damages.report.whereQ": "Wo ist der Schaden?",

      "damages.scratch": "Kratzer",

      "damages.seat": "Sitz",

      "damages.side": "Seite",

      "damages.side.center": "Mitte",

      "damages.side.coDriversSide": "Beifahrerseite",

      "damages.side.driversSide": "Fahrerseite",

      "damages.sill": "Schweller",

      "damages.size": "Größe",

      "damages.size.gt10cm": ">10cm",

      "damages.size.lt10cm": "5 - 10cm",

      "damages.size.lt5cm": "<5cm",

      "damages.stonechip": "Steinschlang",

      "damages.thirdParty": "Beteiligung einer dritten Partei",

      "damages.thirdParty.carRoadworthyDontKnow": "Ich weiß es nicht",

      "damages.thirdParty.dontKnow": "Ich weiß nicht",

      "damages.thirdParty.isInvolved": "Dritte Parteien sind beteiligt",

      "damages.thirdParty.notInvolved": "Dritte Parteien sind nicht beteiligt",

      "damages.thirdParty.notRoadworthy": "Nicht verkehrstüchtig",

      "damages.thirdParty.roadworthy": "Verkehrstüchtig",

      "damages.title": "Schadensbericht",

      "damages.toolbar.done": "Fertig",

      "damages.toolbar.next": "Nächstes",

      "damages.trim": "Innenverkleidung",

      "damages.trunk": "Kofferraum",

      "damages.viewer.damages": "Schäden",

      "damages.viewer.detail": "Schaden-Detail",

      "damages.viewer.graphic": "Grafik",

      "damages.viewer.groupByArea": "Gruppieren nach Bereich",

      "damages.viewer.list": "Liste",

      "damages.viewer.photo": "Foto",

      "damages.viewer.tapHint": "Tippe, um Schäden zu sehen oder zu melden",

      "damages.viewer.title": "Bekannte Schäden",

      "damages.viewer.zoomHint": "Mit +/− zoomen — am Gerät auch per Zwei-Finger-Geste",

      "damages.wheel.rim": "Felge",

      "damages.where": "Wo",

      "damages.where.exterior": "Außen",

      "damages.where.interior": "Innen",

      "damages.windscreen": "Frontscheibe",

      "damages.wing": "Kotflügel",

      "dashboard.about": "Rechtliches",

      "dashboard.balance": "Zahlungen",

      "dashboard.carprofile": "Autoprofil",

      "dashboard.dialog": "Impressum",

      "dashboard.dialog.bnd.url": "https://book-n-drive.app/imprint",

      "dashboard.dialog.cookies": "Cookies",

      "dashboard.dialog.getaway": "GETAWAY Impressum",

      "dashboard.dialog.getaway.url": "https://getaway.pro/imprint",

      "dashboard.dialog.interrent.url": "https://www.interrent.com/de/rechtliche-hinweise",

      "dashboard.dialog.licenses": "Urheberrechtshinweise",

      "dashboard.dialog.mba": "Impressum",

      "dashboard.dialog.mba.url": "https://mietbar.app/privacy#datenschutz",

      "dashboard.dialog.msi.url": "https://mietsmart.app/imprint",

      "dashboard.dialog.privacy": "Datenschutzerklärung",

      "dashboard.dialog.rw": "Impressum",

      "dashboard.dialog.rw.url": "https://robbe.app/imprint",

      "dashboard.dialog.terms": "AGB",

      "dashboard.dialog.ubq": "Impressum",

      "dashboard.dialog.ubq.url": "https://ubq.app/imprint",

      "dashboard.freecredit": "Erhalte gratis Guthaben",

      "dashboard.headline": "Hallo 👋\n%@ %@",

      "dashboard.help": "Hilfe-Center",

      "dashboard.hi": "Hi",

      "dashboard.list.car": "Erfahre, wie viel du mit deinem Auto verdienen kannst.",

      "dashboard.list.cars": "Weiteres Auto anmelden",

      "dashboard.logout": "ABMELDEN",

      "dashboard.logout.active.rental.prompt": "Bitte beende den Mietvorgang",

      "dashboard.logout.prompt": "Möchtest du dich tatsächlich abmelden?",

      "dashboard.logout.success": "Du hast dich erfolgreich abgemeldet.",

      "dashboard.menu.profile": "Nutzerkonto",

      "dashboard.myRentals": "Mietvorgänge",

      "dashboard.profile": "Deine Registrierung",

      "dashboard.releasing": "Freigeben...",

      "dashboard.review": "Die App bewerten",

      "dashboard.services": "Serviceaufträge",

      "dashboard.settings": "EINSTELLUNGEN",

      "data.confirm.view.btn.txt": "Bestätigen",

      "data.confirm.view.description": "Bitte prüfe alle Daten erneut auf ihre Richtigkeit.",

      "data.confirm.view.title": "Bitte bestätigen!",

      "data.test.view.btn.txt": "Weiter",

      "data.test.view.description": "Bitte bestätige, dass der Fahrzeugstatus korrekt wiedergegeben wird und alles funktioniert.",

      "data.test.view.title": "Verbindungstest",

      "day": "Tag",

      "day.ago": "Tage her",

      "day.fr": "Freitag",

      "day.mo": "Montag",

      "day.sa": "Samstag",

      "day.short": "Tag",

      "day.su": "Sonntag",

      "day.th": "Donnerstag",

      "day.tu": "Dienstag",

      "day.we": "Mittwoch",

      "days": "Tage",

      "days.ago": "Tage her",

      "days.short": "Tage",

      "delete": "Entfernen",

      "deposit.balance.title": "Hinterlegte Kaution",

      "deposit.card.desc.md": "✓ wird erstattet nach Vertragsende<br>✓ mit Kautionsrechnung als Pdf<br>✓ sichere Zahlung per GooglePay, Kreditkarte uvm.<br>",

      "deposit.card.price": "Einmalig %s",

      "deposit.card.title": "Kaution (erstattungsfähig)",

      "deposit.cta": "Zahlungsmethode wählen",

      "deposit.desc": "Um deine Zahlungsmethode freizuschalten, hinterlege bitte jetzt die erstattungsfähige Kaution.",

      "deposit.dialog.receipt": "Beleg anzeigen",

      "deposit.dialog.refund": "Erstattung anfordern",

      "deposit.dialog.title": "Hinterlegte Kaution",

      "deposit.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Warum muss eine Kaution hinterlegt werden? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Die Kaution dient als Sicherheit für offene Forderungen aus der Fahrzeugnutzung, wie zum Beispiel Selbstbeteiligungen im Schadensfall oder nicht gedeckte Gebühren. Sie wird bei der Registrierung hinterlegt und nach Vertragsende zurückerstattet, sofern keine offenen Beträge bestehen. </p> </details><hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Wann wird die Kaution erstattet? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Die Kaution wird idR. innerhalb von 6 Wochen nach Vertragsende nach Verrechnung mit etwaigen offenen Forderungen erstattet. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Erhalte ich eine Kautionsrechnung? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Ja, mit dem Abschluss deiner Registrierung und Freischaltung für den Carsharing-Service kannst du die Kautionsrechnung als Pdf herunterladen. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Wie berechnet sich die Kautionshöhe? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Zur Freischaltung des Nutzerkontos ist die Hinterlegung einer Kaution fällig. Die Höhe bemisst sich nach der aktuell gültigen Preisliste. Bei negativer oder fehlgeschlagener SCHUFA-Auskunft (oder einer vergleichbaren Wirtschaftsauskunftei) wird sich vorbehalten, eine höhere Kaution zu verlangen. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">",

      "deposit.footnote.secure.text": "Sichere und verschlüsselte Datenübertragung",

      "deposit.title": "Kaution hinterlegen",

      "description": "Beschreibung",

      "desktop.switch.mobile.desc": "Um fortzufahren, scanne bitte jetzt den QR-Code mit deinem Smartphone.",

      "desktop.switch.mobile.title": "Mit Smartphone fortfahren",

      "dialog.camera.permission.desc": "Bitte aktiviere den Kamerazugriff in den Browsereinstellungen für diese Seite",

      "dialog.camera.permission.title": "Kamera-Berechtigung verweigert",

      "dialog.deposit.add": "Kaution hinterlegen",

      "dialog.later": "Später",

      "dialog.payment.add": "Zahlungsmittel hinzufügen",

      "dialog.schufa.add": "MELDEADRESSE HINTERLEGEN",

      "dialog.tariff.add": "Tarif wählen",

      "digitalFuel.acquired.box.countdown": "Diese Notiz endet in %s s",

      "digitalFuel.acquired.box.dismiss": "Ausblenden",

      "digitalFuel.acquired.box.message": "Danke! Der Tankvorgang von %s ist abgeschlossen und bezahlt. Du kannst jetzt losfahren.",

      "digitalFuel.acquired.box.title": "Getankt & bezahlt",

      "digitalFuel.choice.adblue.desc": "Mit der Tankkarte aus dem Fahrzeug bezahlen.",

      "digitalFuel.choice.adblue.title": "AdBlue",

      "digitalFuel.choice.fuel.desc": "Per App an der Zapfsäule bezahlen – ohne Tankkarte und ohne Bargeld.",

      "digitalFuel.choice.fuel.title": "Kraftstoff",

      "digitalFuel.choice.title": "Was möchtest du tanken?",

      "digitalFuel.confirmClose.leave": "Verlassen",

      "digitalFuel.confirmClose.message": "Dein Fortschritt geht verloren. Möchtest du diesen Bildschirm verlassen?",

      "digitalFuel.confirmClose.stay": "Bleiben",

      "digitalFuel.confirmClose.title": "Digitales Tanken schließen?",

      "digitalFuel.desktop.subtitle": "Scanne den Code, um digitales Tanken auf dem Handy zu öffnen.",

      "digitalFuel.desktop.title": "Weiter auf deinem Handy",

      "digitalFuel.location.permission.message": "Bitte erlaube in deinen Browsereinstellungen den Zugriff auf deinen Standort, damit du mit dem Tanken beginnen kannst.",

      "digitalFuel.location.permission.title": "Standort erforderlich",

      "digitalFuel.location.unavailable.message": "Dein Standort konnte nicht ermittelt werden. Bitte versuch es noch einmal.",

      "digitalFuel.mileage.caption": "Bitte trage den aktuellen Kilometerstand des Fahrzeugs ein, das betankt werden soll.",

      "digitalFuel.mileage.header": "Kilometerstand",

      "digitalFuel.plate.caption": "Bitte trage das Kennzeichen des Fahrzeugs ein, das betankt werden soll. Bindestriche und Leerzeichen sind optional, zB \"HH-EU-1234\" oder \"HHEU1234\".",

      "digitalFuel.plate.errorEmpty": "Bitte trage das Kennzeichen ein.",

      "digitalFuel.plate.errorNotFound": "Wir konnten das Kennzeichen \"%s\" nicht einem Fahrzeug zuordnen. Bitte überprüfe es noch einmal und versuche es erneut oder kontaktiere unser Service Team.",

      "digitalFuel.plate.header": "Kennzeichen",

      "digitalFuel.plate.placeholder": "HH-EU 1234",

      "digitalFuel.productGroup.cng": "Erdgas (CNG)",

      "digitalFuel.productGroup.electric": "Strom",

      "digitalFuel.productGroup.gasoline": "Benzin",

      "digitalFuel.session.closed": "Der Tankvorgang wurde beendet.",

      "digitalFuel.settings.desc": "Neu: Tanken ohne Tankkarte und ohne Bargeld. Die App bezahlt automatisch – in drei einfachen Schritten.",

      "digitalFuel.settings.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Brauche ich eine Tankkarte oder Bargeld? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Nein. Die Bezahlung läuft komplett über die App. Du musst weder eine Karte einstecken noch zur Kasse gehen. </p> </details> <hr style=\"border: 0,5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Woher weiß ich, welche Tankstelle ich nutzen kann? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Tippe auf „Karte“. Es werden nur Tankstellen angezeigt, an denen die Bezahlung per App funktioniert, und die nächstgelegene wird für dich ausgewählt. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> „Tanken starten“ fehlt oder funktioniert nicht – was nun? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Parke das Fahrzeug direkt an der Tankstelle und erlaube der App, deinen Standort zu nutzen. Beides ist erforderlich, bevor das Tanken beginnen kann. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Woher weiß ich, ob alles geklappt hat? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Nach dem Tanken zeigt die App die grüne Meldung „Tanken abgeschlossen“ an. Dann kannst du losfahren. Falls etwas schiefgeht, ist unser Support nur einen Fingertipp entfernt – über das Chat-Symbol oben rechts. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">",

      "digitalFuel.settings.stepOne": "1. Eine Tankstelle suchen",

      "digitalFuel.settings.stepOne.desc": "Tippe auf „Karte“. Wir zeigen dir die nächstgelegene Tankstelle, an der du per App bezahlen kannst, sowie den Weg dorthin.",

      "digitalFuel.settings.stepThree": "3. Tanken und bezahlen",

      "digitalFuel.settings.stepThree.desc": "Tippe auf der Tankstellenkarte auf „Tanken starten“, wähle die Nummer deiner Zapfsäule aus und tanke wie gewohnt. Danach bezahlt die App automatisch – du musst nicht zur Kasse gehen.",

      "digitalFuel.settings.stepTwo": "2. An der Zapfsäule parken",

      "digitalFuel.settings.stepTwo.desc": "Fahre an eine freie Zapfsäule heran und stelle den Motor ab. Das Tanken kann erst beginnen, wenn du und das Fahrzeug direkt an der Tankstelle stehen.",

      "digitalFuel.settings.title": "Tanken mit deinem Handy",

      "digitalFuel.splash.subtitle": "Danke, dass du eines unserer Fahrzeuge betankst.",

      "digitalFuel.splash.subtitleCarSharing": "Wir haben deine Fahrzeugdaten bereits — einen Moment bitte.",

      "digitalFuel.splash.title": "Per Handy tanken",

      "digitalFuel.splash.welcome": "Willkommen bei",

      "digitalFuel.start.confirm.message": "Stelle sicher, dass du als Erste*r in der Reihe stehst.",

      "digitalFuel.start.confirm.title": "Tanken starten?",

      "digitalFuel.station.adblueNote": "AdBlue bezahlst du mit der Tankkarte aus dem Fahrzeug – die Bezahlung per App ist für AdBlue noch nicht möglich.",

      "digitalFuel.station.availability": "Verfügbarkeit",

      "digitalFuel.station.currentLevel": "Aktueller Füllstand: %s%",

      "digitalFuel.station.distance": "Entfernung",

      "digitalFuel.station.fuelType": "Kraftstoffart",

      "digitalFuel.station.fuelTypes": "Kraftstoffe",

      "digitalFuel.station.note": "Bezahle direkt per App an der Zapfsäule – du brauchst keine Tankkarte. Tippe auf „Tanken starten\", wähle die Zapfsäule und tanke wie gewohnt.",

      "digitalFuel.station.offline": "Derzeit nicht verfügbar",

      "digitalFuel.station.remainingTankCapacity": "Verbleibendes Tankkapazität: %s l",

      "digitalFuel.station.startFueling": "Tanken starten",

      "digitalFuel.station.tankCapacity": "Tankgröße: %s L",

      "digitalFuel.station.tooFar.message": "Fahr zuerst zur Tankstelle – das Tanken kann erst beginnen, wenn du und das Fahrzeug direkt an der Tankstelle sind (innerhalb von 50 m).",

      "digitalFuel.station.tooFar.title": "Tankstelle zu weit entfernt",

      "digitalFuel.success.backToRental": "Zurück zur Miete",

      "digitalFuel.success.subtitle": "Dein Tankvorgang wurde erfolgreich abgeschlossen.",

      "digitalFuel.success.title": "Danke!",

      "direct.debit": "Lastschriftverfahren",

      "direct.debit.account.bic": "Bankleitzahl",

      "direct.debit.account.number": "Kontonummer",

      "direct.debit.add": "HINZUFÜGEN",

      "direct.debit.agreements.less": "Hiermit erteile ich teilauto.app (im Auftrag der teilAuto eG) und ihrem Zahlungsdienstleister Adyen N.V. (Gläubiger-ID NL48ZZZ342764500000) eine Einzugsermächtigung als SEPA-Lastschriftmandat zur Einziehung fälliger Zahlungen und weise mein Geldinstitut an, die auf mein Konto gezogenen Lastschriften einzulösen. Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Ich stimme der Fristverkürzung für die Vorankündigungen (Pre-Notification) zukünftiger SEPA-Lastschriften auf einen (1) Kalendertag zu.",

      "direct.debit.agreements.more": "Hiermit erteile ich der Vertragspartnerin und ihrem Zahlungsdienstleister Adyen N.V. (Gläubiger-ID NL48ZZZ342764500000) eine Einzugsermächtigung",

      "direct.debit.desc": "Für sichere und bequeme Zahlungen per Lastschrift hinterlege bitte deine IBAN.",

      "direct.debit.iban": "IBAN",

      "direct.debit.title": "Lastschriftverfahren",

      "directdebit": "Lastschriftverfahren",

      "disconnected.dialog.message": "Du scheinst keine Internetverbindung zu haben. Bitte gehe online, um die App nutzen zu können.",

      "disconnected.dialog.title": "Du bist offline",

      "distance": "Gesamtstrecke",

      "dl.age.footnote": "Das Ausstellungsdatum eines Führerscheins im Plastikformat findest du idR. auf der Vorderseite unter der Nummer 4a",

      "dl.age.title": "Wann wurde dein Führerschein ausgestellt?",

      "dl.option.not.old": "Nach dem %s",

      "dl.option.old": "Vor mehr als %s Jahren",

      "dl.rejected.title": "Bitte achte auf folgenden Hinweis zu deinem vorher eingereichten Dokument:",

      "dl.tab.paper": "Papierformat",

      "dl.tab.plastic": "Plastikformat",

      "dob.button.title": "Übernehmen",

      "dob.dateOfBirth.label": "Geburtstag (TT.MM.JJJJ)",

      "dob.description": "Um fortzufahren, sag uns bitte, wann du geboren wurdest.",

      "dob.title": "Dein Geburtstag",

      "document.upload.success": "Hochladen erfolgreich abgeschlossen",

      "done": "Fertig",

      "dongle.rental.fuelSettings.instruction": "Die Quittung muss nicht aufbewahrt werden. Im Anschluss lege bitte die Tankkarte zurück in das Heftchen zum KFZ-Schein.",

      "dongle.rental.section.locked": "Zurückgegeben",

      "dongle.rental.section.unlocked": "Übernommen",

      "driver.distanceduration.price.description": "{0} €/Std. + {1} €/km",

      "driver.distanceduration.price.map.description": "€/Std.",

      "driver.id.status.open": "Ausweisdokument hinzufügen",

      "driver.id.status.verified": "Personalausweis",

      "driver.id.status.verifying": "Dokument wird geprüft",

      "driver.license.banned.failure": "Bitte trage den Zeitraum ein",

      "driver.license.banned.update.button": "AKTUALISIEREN",

      "driver.license.banned.update.date.button": "WÄHLE",

      "driver.license.banned.update.description": "Ich habe ein behördlich angeordnetes Fahrverbot innerhalb des angegebenen Zeitraums.",

      "driver.license.banned.update.end": "Verbotsende",

      "driver.license.banned.update.start": "Verbotsbeginn",

      "driver.license.banned.update.title": "Fahrverbot",

      "driver.license.banned.warning": "Bitte beginne mit dem Anfangsdatum des Fahrverbots",

      "driver.license.bottom.description": "Hiermit versichere ich, dass meine Fahrerlaubnis behördlich ausgestellt und in Deutschland gültig ist und ich bei Bekanntwerden eines behördlich angeordneten Fahrverbots, diesen unverzüglich an GETAWAY melde.",

      "driver.license.frontImage": "Vorderseite",

      "driver.license.info.desc": "Bitte lass deinen Führerschein bestätigen, damit du Autos in deiner Umgebung mieten kannst.",

      "driver.license.info.save": "BESTÄTIGEN",

      "driver.license.info.title": "Deine Fahrerlaubnis",

      "driver.license.notuploaded.description": "Bitte lass deinen Führerschein bestätigen",

      "driver.license.open.description": "Eingereicht am %@",

      "driver.license.rearImage": "Rückseite",

      "driver.license.selfieImage": "Dein Selfie",

      "driver.license.status.deleted": "Abgelehnt, bitte erneut prüfen lassen",

      "driver.license.status.notuploaded": "Führerschein hinzufügen",

      "driver.license.status.open": "Wird geprüft...",

      "driver.license.status.paused": "Pausiert",

      "driver.license.status.verified": "Führerschein",

      "driver.license.status.verifying": "Führerschein wird geprüft",

      "driver.license.submit.failed": "Bitte lade alle Fotos hoch, um fortzufahren.",

      "driver.license.submit.notNow": "Bitte lass deine Fahrerlaubnis bestätigen, um Autos in deiner Nähe mieten zu können.",

      "driver.license.submit.success": "Danke. Wir haben deine Fahrerlaubnis erhalten und melden uns bei dir nach erfolgter Prüfung.",

      "driver.license.submited.description": "Eingereicht am %@",

      "driver.license.title": "Fahrerlaubnis",

      "driver.license.top.description": "Lass deine Fahrerlaubnis bestätigen, indem du deinen Führerschein jetzt hochlädst.",

      "driver.license.verified.description": "Aktualisiere deine Fahrerlaubnis",

      "driver.mba.passenger.price.description": "{0} €/Std. + {1} €/Extra Km",

      "driver.mba.passenger.price.description.daily": "{0} €/Tag + {1} €/Mehr-Km",

      "driver.mba.passenger.price.map.description": "€/Std.",

      "driver.mba.passenger.price.map.description.daily": "€/Tag",

      "driver.mba.transporter.price.description": "{0} €/Std. + {1} €/Extra Km",

      "driver.mba.transporter.price.description.daily": "{0} €/Tag + {1} €/Mehr-Km",

      "driver.mba.transporter.price.map.description": "€/Std.",

      "driver.mba.transporter.price.map.description.daily": "€/Tag",

      "driver.mis.price.description": "{0} €/Tag + {1} €/Mehr-Km",

      "driver.mis.price.map.description": "€/Tag",

      "driver.mis.spain.price.description": "{0} €/Tag",

      "driver.mis.spain.price.map.description": "€/Tag",

      "driver.mis.transporter.price.description": "{0} €/Std + {1} €/Mehr-Km",

      "driver.mis.transporter.price.map.description": "€/Std",

      "driver.price.description": "{0} €/Std. + {1} €/km",

      "driver.price.getaway.description": "ab 0,00 €/Std",

      "driver.price.ikea.description": "{0} €/Std + {1} €/km",

      "driver.price.ikea.description.weekend": "{0} € + {1} €/km",

      "driver.price.ikea.map.description": "€/Std.",

      "driver.price.ikea.map.description.weekend": "€",

      "driver.price.map.description": "€/Std.",

      "driver.price.map.description.weekend": "€",

      "driver.price.obi.description": "{0} €/Std. + {1} €/Mehr-Km",

      "driver.price.obi.description.weekend": "{0} € + {1} €/Mehr-Km",

      "drivercar.profile.priceDetails": "Preisinfo",

      "drivercar.profile.request.action": "Anfragen",

      "drivercar.profile.reserve.action": "Jetzt buchen",

      "drivercar.profile.service.reserve.action": "Service starten",

      "drivercar.rental.dialog.message": "Möchtest du das Auto für den persönlichen Gebrauch mieten oder einen GETAWAY Service durchführen?",

      "drivercar.rental.dialog.reserve.rental": "Weiter für persönlichen Gebrauch",

      "drivercar.rental.dialog.reserve.service": "Weiter als Service-Trip",

      "drivercar.rental.dialog.title": "Bitte wähle dein Fahrerprofil",

      "drivercar.reserved.status": "RESERVIERT",

      "drivercar.review.novalue": "✨ Neues Auto",

      "drivercar.unavailable.status": "Aktuell in Nutzung",

      "driving.damage.candrive": "Auto ist noch verkehrstüchtig.",

      "driving.damage.cantdrive": "Auto ist nicht mehr verkehrstüchtig.",

      "driving.finish.rental.dialog.message": "Der Mietvorgang kann nur beendet werden, wenn der Motor aus ist.",

      "driving.finish.rental.dialog.retry": "Erneut versuchen",

      "driving.finish.rental.dialog.title": "Beenden nicht möglich",

      "driving.refuel.dialog.message": "Der Tankvorgang kann nur gestartet werden, wenn der Motor aus ist.",

      "driving.refuel.dialog.title": "Tanken nicht möglich",

      "drivinglicense.form.selfie.description": "Video (3 Sekunden) aufnehmen",

      "drivinglicense.form.selfie.done.dialog.again": "Wiederholen",

      "drivinglicense.form.selfie.done.dialog.message": "Dein Selfie wird zur Verifizierung deines Führerscheins benötigt.",

      "drivinglicense.form.selfie.done.dialog.title": "Selfie hochladen",

      "duration": "Gesamtdauer",

      "email.domain.error.dialog.ignore": "Ignorieren",

      "email.domain.error.dialog.update": "Update",

      "email.domain.error.prefix": "Meinst du",

      "email.domain.prefix.error": "Meintest du",

      "email.update.button": "Übernehmen",

      "email.update.desc": "Aktuell: %s",

      "email.update.success": "Eine neue E-Mail-Adresse ist hinterlegt worden. Bitte bestätige sie indem du den Bestätigungs-Code eingibst.",

      "email.update.title": "E-Mail Adresse ändern",

      "email.verify.desc": "Gib den Code ein, den wir soeben an diese E-Mail-Adresse gesendet haben:",

      "email.verify.skip": "Später bestätigen",

      "email.verify.success": "E-Mail erfolgreich verifiziert",

      "email.verify.title": "E-Mail-Bestätigungscode eingeben",

      "emergency.call": "Notruf",

      "empty": "keine Ergebnisse gefunden",

      "enjoyYourTrip.location.subtitle": "Abhol- & Rückkehrort",

      "enjoyYourTrip.title": "Gute Fahrt!",

      "equipment.4wd": "Allradantrieb",

      "equipment.abs": "ABS",

      "equipment.aircondition": "Klimaanlage",

      "equipment.childseat": "Kindersitz",

      "equipment.collosion.avoidance": "Notbremsassistent",

      "equipment.cruise": "Tempomat",

      "equipment.disabled": "Behindertengerecht",

      "equipment.esp": "ESP",

      "equipment.handsfree": "Freisprechanlage",

      "equipment.heating.aux": "Standheizung",

      "equipment.heating.seat": "Sitzheizung",

      "equipment.light.adaptive": "Kurvenlicht",

      "equipment.multifunctionalwheel": "Multifunktionslenkrad",

      "equipment.navigation": "Navigationssystem",

      "equipment.parking.assistant": "Einparkhilfe",

      "equipment.powersteering": "Servolenkung",

      "equipment.roof.bars": "Dachgepäckträger",

      "equipment.roof.panorama": "Panorama-Dach",

      "equipment.sensor.lane": "Spurhalteassistent",

      "equipment.sensor.proximity": "Abstandstempomat",

      "equipment.sensor.rain": "Regensensor",

      "equipment.start-stop": "Start/Stopp-Automatik",

      "equipment.sunroof": "Schiebedach",

      "equipment.traction": "Traktionskontrolle",

      "equipment.trailor": "Anhängerkupplung",

      "equipment.wheels.alloy": "Leichtmetallfelgen",

      "error": "Etwas hat nicht funktioniert. Bitte probiere es erneut. Danke!",

      "error.new.password.wrong": "Ungültiges Passwort. Bitte versuche erneut, dein Passwort für das Buchungssystem einzugeben.",

      "feature.gate.register.title": "PLZ FREISCHALTEN",

      "feature.gate.register.url": "https://www.get-a-way.com/",

      "feature.gate.start": "2018-01-18",

      "feature.gate.submit": "STARTEN",

      "feature.gate.zip.error": "Diese Postleitzahl ist noch nicht freigeschaltet. Sichere dir jetzt deine Einladung.",

      "feature.gate.zipcodes": "10589",

      "fees.url": "https://get-a-way.com/entgelte",

      "finish.rental.refreshButton": "Aktualisieren",

      "finished.rental.carkey.description": "Bitte lege den Autoschlüssel in das dafür vorgesehene Fach zurück.",

      "finished.rental.carkey.title": "Autoschlüssel",

      "finished.rental.checkBelongings.button": "FINISHED",

      "finished.rental.checkBelongings.title": "Bitte achte auf deine persönlichen Gegenstände.",

      "finished.rental.doors.description": "Bitte stelle sicher",

      "finished.rental.doors.title": "Fenster & Türen",

      "finished.rental.fuelLevel.description": "Bitte betanke das Fahrzeug (kostenfrei mit Tankkarte), bevor du den Mietvorgang beendest. Andernfalls können Entgelte (<25%: 5€; <10%: 50€) fällig werden.",

      "finished.rental.fuelLevel.title": "Geringer Tankstand",

      "finished.rental.fuelcard.description": "Bitte lege die Tankkarte in das dafür vorgesehene Fach zurück.",

      "finished.rental.fuelcard.title": "Tankkarte",

      "finished.rental.location.button": "ROUTE ANZEIGEN",

      "finished.rental.location.description": "Bitte beende die Miete in der angegebenen Rückgabezone. Andernfalls können Gebühren anfallen.",

      "finished.rental.location.force": "Mietende erzwingen",

      "finished.rental.location.title": "Rückgabezone",

      "finished.rental.locked.button": "VERRIEGELN",

      "finished.rental.locked.description": "Um fortzufahren, verriegele jetzt bitte das Auto von außen und stelle sicher, dass alle Türen und Fenster verschlossen sind.",

      "finished.rental.locked.title": "Auto von außen verriegeln",

      "finished.rental.thank.you.button": "JA",

      "finished.rental.thank.you.description": "Bitte entnehme den Schlüssel aus dem Handschuhfach.",

      "firstSteps.address.billing.title": "Alternative Rechnungsadresse",

      "firstSteps.address.city.placeholder": "Stadt",

      "firstSteps.address.country.placeholder": "Land",

      "firstSteps.address.instructions": "Bitte beachte, dass es sich hierbei um deine aktuelle Meldeadresse handeln muss.",

      "firstSteps.address.optimized.title": "Aktuelle Meldeadresse",

      "firstSteps.address.personalInfo": "Persönliche Informationen",

      "firstSteps.address.postalCode.placeholder": "PLZ",

      "firstSteps.address.search.text": "Adresse suchen",

      "firstSteps.address.streetName.placeholder": "Straße",

      "firstSteps.address.streetNum.placeholder": "Nr.",

      "firstSteps.address.subTitle": "Meldeadresse",

      "firstSteps.address.submitBtn.text": "Hinzufügen",

      "firstSteps.address.title": "Meldeadresse",

      "firstSteps.email.code.placeholder": "E-Mail-Bestätigungscode",

      "firstSteps.payment.bic.placeholder": "BIC",

      "firstSteps.payment.optimized.sepa.desc": "Für sichere und bequeme Zahlungen per Lastschrift hinterlege bitte deine IBAN.",

      "firstSteps.payment.optimized.sepa.title": "Lastschriftverfahren",

      "firstSteps.payment.sepa.description.text": "Hiermit erteile ich teilauto.app (im Auftrag der teilAuto eG) und ihrem Zahlungsdienstleister Adyen N.V. (Gläubiger-ID NL48ZZZ342764500000) eine Einzugsermächtigung als SEPA-Lastschriftmandat zur Einziehung fälliger Zahlungen und weise mein Geldinstitut an, die auf mein Konto gezogenen Lastschriften einzulösen. Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Ich stimme der Fristverkürzung für die Vorankündigungen (Pre-Notification) zukünftiger SEPA-Lastschriften auf einen (1) Kalendertag zu.",

      "firstSteps.payment.sepa.iban.placeholder": "IBAN manuell eingeben",

      "firstSteps.payment.sepa.info": "Zustimmung zum Lastschriftverfahren",

      "firstSteps.payment.sepa.instruction": "Für sichere und bequeme Zahlungen per Lastschrift hinterlege bitte deine IBAN.",

      "firstSteps.payment.sepa.name.placeholder": "Kontoinhaber",

      "firstSteps.payment.sepa.submit.text": "Hinzufügen",

      "firstSteps.payment.sepa.title": "Lastschriftverfahren",

      "firstSteps.payment.sepa.url": "https://google.com",

      "firstSteps.payment.sepa.url.text": "Mehr",

      "firstSteps.phone.code.placeholder": "SMS-Bestätigungscode",

      "fleetadmin.admins.admin.new": "Neuen Administrator erstellen",

      "fleetadmin.admins.info.account": "Nutzerkonto",

      "fleetadmin.admins.info.active": "aktiv",

      "fleetadmin.admins.info.archive": "Nutzerkonto archivieren",

      "fleetadmin.admins.info.cancel": "Abbrechen",

      "fleetadmin.admins.info.created": "Erstellt am",

      "fleetadmin.admins.info.createdby": "Erstellt von",

      "fleetadmin.admins.info.delete.title": "Sicher, dass du diesen Administrator löschen willst?",

      "fleetadmin.admins.info.deleted": "archiviert",

      "fleetadmin.admins.info.email": "E-Mail",

      "fleetadmin.admins.info.firstName": "Vorname",

      "fleetadmin.admins.info.language": "Sprache",

      "fleetadmin.admins.info.lastName": "Nachname",

      "fleetadmin.admins.info.merchant": "Kunden-Account",

      "fleetadmin.admins.info.status": "Status",

      "fleetadmin.admins.info.update": "Aktualisieren",

      "fleetadmin.admins.info.update.title": "Nutzerinformationen aktualisieren",

      "fleetadmin.admins.info.user": "Nutzer",

      "fleetadmin.admins.permission.automatically": "Neue automatisch hinzufügen",

      "fleetadmin.admins.permission.claimsmanager": "Schadensbearbeitung",

      "fleetadmin.admins.permission.clear.all": "Alle entfernen",

      "fleetadmin.admins.permission.fleet.title": "Flottenverwaltung",

      "fleetadmin.admins.permission.fleetmanager": "Fahrzeuge und Zonen",

      "fleetadmin.admins.permission.mechanic": "Mechaniker (G-Connect)",

      "fleetadmin.admins.permission.merchant.title": "Account und Markenzugang",

      "fleetadmin.admins.permission.merchantmanager": "Administratorenverwaltung",

      "fleetadmin.admins.permission.select.all": "Alle hinzufügen",

      "fleetadmin.admins.permission.tripsmanager": "Mieten und Reservierungen",

      "fleetadmin.admins.permission.user.title": "Nutzerverwaltung",

      "fleetadmin.admins.permission.usergroupsmanager": "Nutzerkreise",

      "fleetadmin.admins.permission.usermanager": "Endnutzer",

      "fleetadmin.admins.permissions.update": "Aktualisieren",

      "fleetadmin.admins.tab.info": "Info",

      "fleetadmin.admins.tab.permissions": "Berechtigungen",

      "fleetadmin.admins.table.access": "Berechtigung",

      "fleetadmin.admins.table.blocked": "Status",

      "fleetadmin.admins.table.created": "Angelegt am",

      "fleetadmin.admins.table.email": "E-Mail",

      "fleetadmin.admins.table.firstname": "Vorname",

      "fleetadmin.admins.table.fleets": "Flottenzugang",

      "fleetadmin.admins.table.full": "Uneingeschränkt",

      "fleetadmin.admins.table.fullaccess": "Zugriff",

      "fleetadmin.admins.table.lastname": "Nachname",

      "fleetadmin.admins.table.limited": "Eingeschränkt",

      "fleetadmin.allAroundModal.noImage": "Dieses Bild ist nicht verfügbar.",

      "fleetadmin.area.noCoordinations": "Keine Daten",

      "fleetadmin.areaList.title": "Zone",

      "fleetadmin.areaListItem.updated": "{date} von {username}",

      "fleetadmin.blockReasons.needsAccessKitCheck": "AccessKit-Check",

      "fleetadmin.blockReasons.needsBattery": "Batterieladung nötig",

      "fleetadmin.blockReasons.needsCleaning": "Reinigung nötig",

      "fleetadmin.blockReasons.needsFuel": "Kraftstoff nötig",

      "fleetadmin.blockReasons.needsFuelCard": "Tankkarten-Check",

      "fleetadmin.blockReasons.needsKeyFob": "Schlüssel-Check",

      "fleetadmin.blockReasons.needsOther": "Anderer Service nötig",

      "fleetadmin.blockReasons.needsRelocation": "Umparken nötig",

      "fleetadmin.blockReasons.needsRepair": "Reparatur nötig",

      "fleetadmin.booking.blockreasons.label": "Gründe für Blockierung",

      "fleetadmin.booking.button.assign": "Zuweisen",

      "fleetadmin.booking.button.cancel": "Abbrechen",

      "fleetadmin.booking.button.update": "Aktualisieren",

      "fleetadmin.booking.create.button": "Erstellen",

      "fleetadmin.booking.create.duration": "Dauer",

      "fleetadmin.booking.create.plate": "Kennzeichen",

      "fleetadmin.booking.create.title": "Neue Buchung erstellen",

      "fleetadmin.booking.create.type": "Typ",

      "fleetadmin.booking.create.type.offline": "Nutzer",

      "fleetadmin.booking.create.type.service": "Service",

      "fleetadmin.booking.create.user": "Nutzer",

      "fleetadmin.booking.create.user.placeholder": "E-Mail",

      "fleetadmin.booking.statuschange.label": "Kommentar",

      "fleetadmin.booking.type.offline": "Offline",

      "fleetadmin.booking.type.rental": "Miete",

      "fleetadmin.booking.type.service": "Service",

      "fleetadmin.booking.type.statusChange": "Statusänderung",

      "fleetadmin.booking.update.from.label": "Start ",

      "fleetadmin.booking.update.from.title": "Start- und End-Datum der Buchung aktualisieren?",

      "fleetadmin.booking.update.to.label": "End ",

      "fleetadmin.booking.update.to.title": "Zeit aktualisieren",

      "fleetadmin.booking.update.user.title": "User aktualisieren",

      "fleetadmin.booking.update.vehicle.label": "Kennzeichen",

      "fleetadmin.booking.update.vehicle.title": "Neues Fahrzeug der Reservierung zuweisen?",

      "fleetadmin.booking.user.label": "Zugeordneter User",

      "fleetadmin.booking.user.placeholder": "E-Mail Adresse",

      "fleetadmin.bookingStatus.cancelled": "Storniert",

      "fleetadmin.bookingStatus.confirmed": "Bestätigt",

      "fleetadmin.bookingStatus.finished": "Beendet",

      "fleetadmin.bookingStatus.offered": "Angeboten",

      "fleetadmin.bookingStatus.started": "Begonnen",

      "fleetadmin.bookingStatus.waiting": "Wartend",

      "fleetadmin.car.areaNotAssigned": "Nicht zugeordnet",

      "fleetadmin.car.noPositionData": "Keine Positionsdaten",

      "fleetadmin.car.status.clear.note": "Notiz entfernen.",

      "fleetadmin.car.status.range.instant": "Sofort",

      "fleetadmin.carEditor.areaSelector.placeholder": "Zone auswählen",

      "fleetadmin.carEditor.batteryVoltage": "Batteriestand",

      "fleetadmin.carEditor.blockReasons": "Gründe für Block",

      "fleetadmin.carEditor.carKey": "Autoschlüssel",

      "fleetadmin.carEditor.enginePower": "Motorleistung",

      "fleetadmin.carEditor.enginePowerUnit": "KW",

      "fleetadmin.carEditor.fleet": "Flotte",

      "fleetadmin.carEditor.fuel": "Kraftstoff",

      "fleetadmin.carEditor.fuelCard": "Tankkarte",

      "fleetadmin.carEditor.fuelCardNumber": "Tankkarten-Nummer",

      "fleetadmin.carEditor.fuelLevel": "Tankstand",

      "fleetadmin.carEditor.gear": "Schaltung",

      "fleetadmin.carEditor.initialRegistration": "Erstzulassung",

      "fleetadmin.carEditor.labelArea": "Zone",

      "fleetadmin.carEditor.location": "Position",

      "fleetadmin.carEditor.lock": "Verriegeln",

      "fleetadmin.carEditor.mileage": "Kilometerstand",

      "fleetadmin.carEditor.missing": "fehlt",

      "fleetadmin.carEditor.model": "Modell",

      "fleetadmin.carEditor.noNotes": "Es gibt keine Notizen für dieses Fahrzeug.",

      "fleetadmin.carEditor.plate": "Kennzeichen",

      "fleetadmin.carEditor.pollutionBadge": "Umweltplakette",

      "fleetadmin.carEditor.release": "Fahrzeug freigeben",

      "fleetadmin.carEditor.resetBluetooth": "Bluetooth zurücksetzen",

      "fleetadmin.carEditor.resetBoard": "Board zurücksetzen",

      "fleetadmin.carEditor.resetGPRS": "GPRS zurücksetzen",

      "fleetadmin.carEditor.resetModem": "Modem zurücksetzen",

      "fleetadmin.carEditor.unlock": "Entriegeln",

      "fleetadmin.carEditor.unrelease": "Nicht freigeben",

      "fleetadmin.carEditor.update": "Status anfragen",

      "fleetadmin.carEditor.vin": "VIN",

      "fleetadmin.carList.title": "Fahrzeug",

      "fleetadmin.carStatus.BLOCKED": "geblockt",

      "fleetadmin.carStatus.EQUIPMENT_READY": "einbaufertig",

      "fleetadmin.carStatus.EQUIPPED": "eingebaut",

      "fleetadmin.carStatus.RELEASED": "freigegeben",

      "fleetadmin.carStatus.RELEASE_READY": "freigebbar",

      "fleetadmin.carStatus.REMOVED": "ausgebaut",

      "fleetadmin.carStatus.RENTED": "gemietet",

      "fleetadmin.carStatus.TERMINATED": "gekündigt",

      "fleetadmin.circle.action.header": "Action",

      "fleetadmin.circle.code.header": "Code",

      "fleetadmin.circle.email.header": "Email",

      "fleetadmin.circle.name.header": "Name",

      "fleetadmin.circleList.circleCode": "Code: {circleCode}",

      "fleetadmin.circleList.fleets": "{totalFleets} Flotten",

      "fleetadmin.circleList.members": "{totalUsers} Mitglieder",

      "fleetadmin.circleList.title": "Nutzerkreis",

      "fleetadmin.claim.after": "Nach",

      "fleetadmin.claim.invoice.create": "Rechnung erstellen",

      "fleetadmin.claim.invoice.created": "Erstellte Rechnung",

      "fleetadmin.claim.invoice.wontinvoice": "Geschlossen (nicht berechnet)",

      "fleetadmin.claim.noPositionData": "Keine Positions-Daten",

      "fleetadmin.claim.section.complete": "Forderung abschließen",

      "fleetadmin.claim.section.completed": "Vollständig",

      "fleetadmin.claim.section.incomplete": "Schließen als unvollständig",

      "fleetadmin.claimStatus.closed": "Geschlossen",

      "fleetadmin.claimStatus.closed_settled": "Geschlossen",

      "fleetadmin.claimStatus.completed": "Abgeschlossen",

      "fleetadmin.claimStatus.confirmed": "Bestätigt",

      "fleetadmin.claimStatus.inProgress": "In Nutzung",

      "fleetadmin.claimStatus.open": "Offen",

      "fleetadmin.claimStatus.tag.closed": "Geschlossen",

      "fleetadmin.claimStatus.tag.completed": "Abgeschlossen",

      "fleetadmin.claimStatus.tag.confirmed": "Bestätigt",

      "fleetadmin.claimStatus.tag.inProgress": "In Nutzung",

      "fleetadmin.claimStatus.tag.open": "Offen",

      "fleetadmin.damage.component.bumber": "Stoßstange",

      "fleetadmin.damage.component.bumper": "Stoßstange",

      "fleetadmin.damage.component.door": "Tür",

      "fleetadmin.damage.component.engineBonnet": "Motorhaube",

      "fleetadmin.damage.component.exteriorMirror": "Spiegel",

      "fleetadmin.damage.component.floor": "Boden",

      "fleetadmin.damage.component.header": "Bauteil",

      "fleetadmin.damage.component.hubcap": "Radkappe",

      "fleetadmin.damage.component.interiorTrim": "Innenverkleidung",

      "fleetadmin.damage.component.other": "Anderes",

      "fleetadmin.damage.component.rearWindow": "Fenster",

      "fleetadmin.damage.component.seat": "Sitz",

      "fleetadmin.damage.component.sill": "Schweller",

      "fleetadmin.damage.component.trunk": "Ladefläche",

      "fleetadmin.damage.component.wheelRim": "Felge",

      "fleetadmin.damage.component.windscreen": "Frontscheibe",

      "fleetadmin.damage.component.wing": "Kotflügel",

      "fleetadmin.damage.index.header": "#",

      "fleetadmin.damage.location.center": "mittig",

      "fleetadmin.damage.location.front": "vorne",

      "fleetadmin.damage.location.header": "Lage",

      "fleetadmin.damage.location.rear": "hinten",

      "fleetadmin.damage.side.center": "Mitte",

      "fleetadmin.damage.side.coDriversSide": "Beifahrer",

      "fleetadmin.damage.side.driversSide": "Fahrer",

      "fleetadmin.damage.side.header": "Seite",

      "fleetadmin.damage.where.exterior": "Außen",

      "fleetadmin.damage.where.header": "In/Ex",

      "fleetadmin.damage.where.interior": "Innen",

      "fleetadmin.damageModal.noImage": "Es gibt keine Bilder für diese Schadensmeldung.",

      "fleetadmin.deviceStatus.offline": "Offline",

      "fleetadmin.deviceStatus.online": "Online",

      "fleetadmin.error.reset": "Zurücksetzen",

      "fleetadmin.error.unknown1": "Ein unerwarteter Fehler ist aufgetreten. Wir wurden automatisch benachrichtigt und beheben ihn schnellstmöglich 💪",

      "fleetadmin.error.unknown2": "Wenn du Hilfe benötigst, kontaktiere unser SupportTeam via {email} oder {number} (#1)",

      "fleetadmin.event.areaChanged": "Zone geändert",

      "fleetadmin.event.bookingAssigned": "Buchung zugeordnet",

      "fleetadmin.event.borderCrossing": "Grenze überschritten",

      "fleetadmin.event.checkedIn": "checked IN",

      "fleetadmin.event.checkedOut": "checked OUT",

      "fleetadmin.event.damageRecordUpdated": "Schaden angelegt",

      "fleetadmin.event.ignitionChanged": "Zündungsstatus geändert",

      "fleetadmin.event.ignitionOff": "Zündung AUS ",

      "fleetadmin.event.ignitionOffFinally": "Zündung AUS (final)",

      "fleetadmin.event.ignitionOn": "Zündung AN",

      "fleetadmin.event.ignitionOnInitially": "Zündung AUS (initial)",

      "fleetadmin.event.lockChanged": "Schließ-Event",

      "fleetadmin.event.locked": "Entriegelt",

      "fleetadmin.event.noteAdded": "Notiz hinzugefügt",

      "fleetadmin.event.recordAdded": "Eintrag hinzugefügt",

      "fleetadmin.event.rentalEndImage": "Rundum-Check (final)",

      "fleetadmin.event.rentalStartImage": "Rundum-Check (initital)",

      "fleetadmin.event.serviceNoteAdded": "Service Notiz hinzugefügt",

      "fleetadmin.event.serviceReported": "Service gemeldet",

      "fleetadmin.event.serviceTripImage": "Service-Foto hinzugefügt",

      "fleetadmin.event.shockDetected": "Aufprall aufgezeichnet",

      "fleetadmin.event.startCarCheckUploaded": "Rundum-Check erledigt",

      "fleetadmin.event.startCarCheckUploaded.description": "4 Fotos hinzugefügt",

      "fleetadmin.event.statusChanged": "Fahrzeug-Status geändert",

      "fleetadmin.event.tripFinished": "Verriegelt (final)",

      "fleetadmin.event.tripReserved": "Reserviert",

      "fleetadmin.event.tripStarted": "Entriegelt (initial)",

      "fleetadmin.event.unlocked": "Verriegelt",

      "fleetadmin.filter.ADMINS.email": "E-Mail",

      "fleetadmin.filter.ADMINS.firstName": "Vorname",

      "fleetadmin.filter.ADMINS.lastName": "Nachname",

      "fleetadmin.filter.AREA.createdAt": "Erstellt am - Datum",

      "fleetadmin.filter.AREA.fleetId": "Flotte",

      "fleetadmin.filter.AREA.id": "ID (Zone)",

      "fleetadmin.filter.AREA.kmlFilename": "Dateiname (*.kml)",

      "fleetadmin.filter.AREA.lastUpdatedAt": "Zuletzt aktualisiert - Datum",

      "fleetadmin.filter.AREA.lastUpdatedBy": "Zuletzt aktualisiert - Nutzer",

      "fleetadmin.filter.AREA.name": "Name der Zone",

      "fleetadmin.filter.AREA.numOfVehicle": "Fahrzeuganzahl",

      "fleetadmin.filter.BOOKING.offline": "Offline",

      "fleetadmin.filter.BOOKING.presentableId": "ID (Buchung)",

      "fleetadmin.filter.BOOKING.status": "Status",

      "fleetadmin.filter.BOOKING.type": "Buchungs-Typ",

      "fleetadmin.filter.CARE.areaId": "Zone",

      "fleetadmin.filter.CARE.brand": "Brand",

      "fleetadmin.filter.CARE.chassisNumber": "VIN",

      "fleetadmin.filter.CARE.code": "Code (Servicevorgang)",

      "fleetadmin.filter.CARE.fleetId": "Flotte",

      "fleetadmin.filter.CARE.id": "ID (Servicevorgang)",

      "fleetadmin.filter.CARE.plate": "Kennzeichen",

      "fleetadmin.filter.CARE.serviceTypes": "Service Typ",

      "fleetadmin.filter.CARE.status": "Status",

      "fleetadmin.filter.CARE.tripEnd": "Mietende",

      "fleetadmin.filter.CARE.tripStart": "Mietbeginn",

      "fleetadmin.filter.CARE.userReferralCode": "ServiceHero",

      "fleetadmin.filter.CATEGORIES.acrissCode": "Acriss Code",

      "fleetadmin.filter.CATEGORIES.brandId": "Brand",

      "fleetadmin.filter.CATEGORIES.name": "Name",

      "fleetadmin.filter.CATEGORIES.numOfVehicle": "Anzahl der Fahrzeuge",

      "fleetadmin.filter.CIRCLE.addressRequired": "Adresse benötigt",

      "fleetadmin.filter.CIRCLE.circleType": "Typ",

      "fleetadmin.filter.CIRCLE.driverLicenseRequired": "Führerschein benötigt",

      "fleetadmin.filter.CIRCLE.identityApprovalRequired": "Identitätsprüfung benötigt",

      "fleetadmin.filter.CIRCLE.name": "Name",

      "fleetadmin.filter.CIRCLE.paymentMethodRequired": "Zahlungsmittel benötigt",

      "fleetadmin.filter.CLAIM.addedAt": "Erstellt am",

      "fleetadmin.filter.CLAIM.brand": "Brand",

      "fleetadmin.filter.CLAIM.closeReason": "Abschluss-Grund",

      "fleetadmin.filter.CLAIM.damageId": "ID (Forderung)",

      "fleetadmin.filter.CLAIM.fleetId": "Flotte",

      "fleetadmin.filter.CLAIM.plate": "Kennzeichen",

      "fleetadmin.filter.CLAIM.roadworthiness": "Fahrtüchtigkeit",

      "fleetadmin.filter.CLAIM.status": "Status",

      "fleetadmin.filter.CLAIM.thirdParty": "Dritte",

      "fleetadmin.filter.CLAIM.tripIgnition": "Miete Zündung",

      "fleetadmin.filter.CLAIM.tripPresentableId": "ID (Mietvorgang)",

      "fleetadmin.filter.CLAIM.userReferralCode": "Erstellt von",

      "fleetadmin.filter.PRICING.name": "Name",

      "fleetadmin.filter.PROFILE.brandId": "Brand",

      "fleetadmin.filter.PROFILE.brandName": "Brand Name",

      "fleetadmin.filter.PROFILE.model": "Modell",

      "fleetadmin.filter.PROFILE.name": "Name",

      "fleetadmin.filter.SHARE.code": "Code (Mietvorgang)",

      "fleetadmin.filter.SHARE.fleetId": "Flotte",

      "fleetadmin.filter.SHARE.insurance": "Versicherung",

      "fleetadmin.filter.SHARE.merchantRef": "ID (Mietvertrag)",

      "fleetadmin.filter.SHARE.plate": "Kennzeichen",

      "fleetadmin.filter.SHARE.status": "Status",

      "fleetadmin.filter.SHARE.tripEnd": "Beendet um",

      "fleetadmin.filter.SHARE.tripStart": "Begonnen um",

      "fleetadmin.filter.SHARE.userReferralCode": "Nutzer",

      "fleetadmin.filter.SHARE.violationLowFuel": "Verstoß: Niedriger Tankstand",

      "fleetadmin.filter.SHARE.violationMissingFuelCard": "Verstoß: Tankkarte fehlt",

      "fleetadmin.filter.SHARE.violationMissionKey": "Verstoß: Schlüssel fehlt",

      "fleetadmin.filter.SHARE.violationReturnArea": "Verstoß: Rückgabezone",

      "fleetadmin.filter.USERS.email": "E-Mail",

      "fleetadmin.filter.USERS.firstName": "Vorname",

      "fleetadmin.filter.USERS.lastName": "Nachname",

      "fleetadmin.filter.USERS.referralCode": "Nutzer-Code",

      "fleetadmin.filter.VEHICLE.areaId": "Zone",

      "fleetadmin.filter.VEHICLE.blockReasons": "Gründe für Block",

      "fleetadmin.filter.VEHICLE.chassisNumber": "VIN",

      "fleetadmin.filter.VEHICLE.deviceSNR": "Access Kit Nummer",

      "fleetadmin.filter.VEHICLE.equippedSince": "Installiert am",

      "fleetadmin.filter.VEHICLE.fleetId": "Flotte",

      "fleetadmin.filter.VEHICLE.fuel": "Kraftstofftyp",

      "fleetadmin.filter.VEHICLE.fuelCardNumber": "Tankkarten-Nummer",

      "fleetadmin.filter.VEHICLE.fuelLevel": "Tankstand",

      "fleetadmin.filter.VEHICLE.lastStatus.fuelCardIn": "Tankkarte In",

      "fleetadmin.filter.VEHICLE.lastStatus.keyFobIn": "KeyFob In",

      "fleetadmin.filter.VEHICLE.model": "Modell",

      "fleetadmin.filter.VEHICLE.plate": "Kennzeichen",

      "fleetadmin.filter.VEHICLE.rentalCount": "Anzahl an Mieten",

      "fleetadmin.filter.VEHICLE.status": "Status",

      "fleetadmin.filter.VEHICLE.supportedVehicleConnections": "Access Kit Typ",

      "fleetadmin.filter.VEHICLE.vehicleConnection": "Aktiver Access Kit Typ",

      "fleetadmin.filter.numberSearch.lessThan": "weniger als",

      "fleetadmin.filter.numberSearch.moreThan": "mehr als",

      "fleetadmin.forgot.button": "E-Mail senden",

      "fleetadmin.forgot.fail": "Netzwerkfehler, bitte versuche es erneut.",

      "fleetadmin.forgot.form.placeholder": "E-Mail Adresse eingeben",

      "fleetadmin.forgot.success": "Bitte prüfe dein E-Mail Postfach: {email}",

      "fleetadmin.forgot.title": "Passwort vergessen?",

      "fleetadmin.header.admins": "Administratoren",

      "fleetadmin.header.area": "Zonen",

      "fleetadmin.header.capability": "Capability",

      "fleetadmin.header.care": "Servicevorgänge",

      "fleetadmin.header.categories": "Fahrzeugkategorien",

      "fleetadmin.header.circle": "Nutzerkreise",

      "fleetadmin.header.claim": "Forderungen",

      "fleetadmin.header.fleetControl": "Fleet control",

      "fleetadmin.header.pricing": "Fahrzeugpreise",

      "fleetadmin.header.profile": "Fahrzeugprofile",

      "fleetadmin.header.settings": "Einstellungen",

      "fleetadmin.header.share": "FleetShare",

      "fleetadmin.header.userControl": "User control",

      "fleetadmin.header.users": "Nutzer",

      "fleetadmin.header.vehicle": "Fahrzeuge",

      "fleetadmin.login.button": "Einloggen",

      "fleetadmin.login.checkbox": "Meine Daten merken",

      "fleetadmin.login.form1.placeholder": "E-Mail Adresse eingeben",

      "fleetadmin.login.form2.placeholder": "Passwort eingeben",

      "fleetadmin.login.linkToForgot": "Passwort vergessen?",

      "fleetadmin.login.title": "Anmeldung",

      "fleetadmin.logoutConfirm.text": "Mit Klick auf OK wirst du abgemeldet. Du wirst dich dann wieder anmelden müssen.",

      "fleetadmin.logoutConfirm.title": "Bist du sicher, dass du dich abmelden willst?",

      "fleetadmin.password.button": "Passwort zurücksetzen",

      "fleetadmin.password.fail": "Netzwerkfehler, bitte versuche es erneut.",

      "fleetadmin.password.form1.placeholder": "Neues Passwort",

      "fleetadmin.password.form2.placeholder": "Passwort bestätigen",

      "fleetadmin.password.invalidToken": "Dieser Link ist abgelaufen, bitte fordere einen neuen an.",

      "fleetadmin.password.linkToForgot": "E-Mail erneut anfordern",

      "fleetadmin.password.success": "Neues Passwort erfolgreich angelegt.",

      "fleetadmin.password.title": "Passwort erstellen",

      "fleetadmin.releaseModal.confirm": "Freigabe bestätigen",

      "fleetadmin.releaseModal.title": "Fahrzeug freigeben um:",

      "fleetadmin.searchBox.area.label": "Zone",

      "fleetadmin.searchBox.area.placeholder": "Zone auswählen",

      "fleetadmin.searchBox.brand.label": "BRAND",

      "fleetadmin.searchBox.brand.placeholder": "Brand wählen",

      "fleetadmin.searchBox.fallback.placeholder": "Werte auswählen",

      "fleetadmin.searchBox.fleet.label": "FLOTTE",

      "fleetadmin.searchBox.fleet.placeholder": "Flotte auswählen",

      "fleetadmin.searchBox.numberOfAreas": "Zonen ((number))",

      "fleetadmin.searchBox.numberOfVehicles": "Fahrzeuge ((number))",

      "fleetadmin.searchBox.resetButton": "Filter zurücksetzen",

      "fleetadmin.searchBox.serviceHero.label": "SERVICE HERO",

      "fleetadmin.searchBox.serviceHero.placeholder": "ServiceHero auswählen",

      "fleetadmin.searchBox.serviceStatus.label": "Service Status",

      "fleetadmin.searchBox.serviceStatus.placeholder": "Service Status wählen",

      "fleetadmin.searchBox.status.label": "STATUS",

      "fleetadmin.searchBox.status.placeholder": "Fahrzeug-Status wählen",

      "fleetadmin.searchBox.text.label": "SUCHEN",

      "fleetadmin.searchBox.text.placeholder": "Suchtext einfügen",

      "fleetadmin.serviceStatus.CLOSED": "Geschlossen",

      "fleetadmin.serviceStatus.IN_PROGRESS": "In Nutzung",

      "fleetadmin.serviceStatus.OPEN": "Offen",

      "fleetadmin.serviceStatus.PLANNED": "Geplant",

      "fleetadmin.serviceStatus.closed": "Geschlossen",

      "fleetadmin.serviceStatus.inProgress": "In Nutzung",

      "fleetadmin.serviceStatus.open": "Offen",

      "fleetadmin.serviceStatus.planned": "Geplant",

      "fleetadmin.serviceType.basicBranding": "Branding",

      "fleetadmin.serviceType.basicCarPhotos": "Fahrzeugfotos",

      "fleetadmin.serviceType.basicDamageRecords": "Schadensakte",

      "fleetadmin.serviceType.batteryChangeOpening": "Batteriewechsel (mit Notfallöffnung)",

      "fleetadmin.serviceType.batteryChangeSimple": "Batteriewechsel (einfach)",

      "fleetadmin.serviceType.cleanOutsideDry": "Außenreinigung (trocken)",

      "fleetadmin.serviceType.comboPremium": "Premium (Kombi)",

      "fleetadmin.serviceType.comboPro": "Pro (Kombi)",

      "fleetadmin.serviceType.comboRefuelWashInside": "Innenreinigung (Kombi)",

      "fleetadmin.serviceType.comboRefuelWashOutside": "Außernreinigung (Kombi)",

      "fleetadmin.serviceType.comboRefuelWashTotal": "Komplettreinigung (Kombi)",

      "fleetadmin.serviceType.dashboardCleaning": "Lüftungsschlitze und Ablagen intensiv reinigen",

      "fleetadmin.serviceType.desinfektion": "Desinfektion",

      "fleetadmin.serviceType.exchangeFuelCard": "Tankkarte tauschen",

      "fleetadmin.serviceType.extra10min": "Sonderreinigungszeit, je 10 Min",

      "fleetadmin.serviceType.grillCleaning": "Kühlergrill-Reinigung",

      "fleetadmin.serviceType.highGlossFinish": "Hochglanz-Finish mit Lackversiegelung",

      "fleetadmin.serviceType.otherBasicService": "andere Services",

      "fleetadmin.serviceType.refuel": "Betankung",

      "fleetadmin.serviceType.relocate": "Verlegungsfahrt",

      "fleetadmin.serviceType.relocation": "Verlegungsfahrt",

      "fleetadmin.serviceType.relocationEndLt24": "Zustellung innerhalb von 24 Std.",

      "fleetadmin.serviceType.relocationStartOnTime": "Abholung innerhalb von 30 Min.",

      "fleetadmin.serviceType.rimsCleaning": "Felgen-Intensivpflege",

      "fleetadmin.serviceType.safetyCheck": "Safety-Check",

      "fleetadmin.serviceType.tirePressure": "Reifendruck",

      "fleetadmin.serviceType.vacuumCleaning": "Kofferraum und Fußmatten intensiv saugen",

      "fleetadmin.serviceType.washInside": "Innenreinigung",

      "fleetadmin.serviceType.washOutside": "Außenreinigung (nass)",

      "fleetadmin.serviceType.windshieldFluidRefill": "Auffüllen des Scheibenwischwassers",

      "fleetadmin.sideMenu.admins": "Administratoren",

      "fleetadmin.sideMenu.area": "Zonen",

      "fleetadmin.sideMenu.capabilities": "Capability",

      "fleetadmin.sideMenu.claim": "Forderungen",

      "fleetadmin.sideMenu.fleetCare": "Servicevorgänge",

      "fleetadmin.sideMenu.fleetCategories": "Fahrzeugkategorien",

      "fleetadmin.sideMenu.fleetCircles": "Nutzerkreise",

      "fleetadmin.sideMenu.fleetControl": "Fleet control",

      "fleetadmin.sideMenu.fleetPricing": "Fahrzeugpreise",

      "fleetadmin.sideMenu.fleetProfiles": "Fahrzeugprofile",

      "fleetadmin.sideMenu.fleetSettings": "Einstellungen",

      "fleetadmin.sideMenu.fleetShare": "FleetShare",

      "fleetadmin.sideMenu.fleetShare.bookings": "Reservierungen",

      "fleetadmin.sideMenu.fleetShare.bookings.cancelled": "Storniert",

      "fleetadmin.sideMenu.fleetShare.bookings.confirmed": "Kommende",

      "fleetadmin.sideMenu.fleetShare.trips": "Mietvorgänge",

      "fleetadmin.sideMenu.logout": "Ausloggen",

      "fleetadmin.sideMenu.phoneReport": "Telefon-Report",

      "fleetadmin.sideMenu.reports": "Reports",

      "fleetadmin.sideMenu.userControl": "User control",

      "fleetadmin.sideMenu.users": "Nutzer",

      "fleetadmin.sideMenu.vehicle": "Fahrzeuge",

      "fleetadmin.sideMenu.vehicle.all": "Alle",

      "fleetadmin.sideMenu.vehicle.archived": "Achiviert",

      "fleetadmin.support.email": "fleet-support@getaway.pro",

      "fleetadmin.support.number": "+49 30 30808441",

      "fleetadmin.trip.allAround.title": "\"Rundum-Check\" Notizen",

      "fleetadmin.trip.info.backby.label": "Rückgabe-Zeit",

      "fleetadmin.trip.info.tripstarted.label": "Begann um",

      "fleetadmin.trip.serviceImage.modal.title": "Service Bilder",

      "fleetadmin.trip.update.backby.label": "Rückgabezeit  ",

      "fleetadmin.trip.update.backby.title": "Rückgabezeit aktualisieren?",

      "fleetadmin.tripStatus.cancelled": "Storniert",

      "fleetadmin.tripStatus.done": "Erledigt",

      "fleetadmin.tripStatus.expired": "Ausgelaufen",

      "fleetadmin.tripStatus.in_progress": "In Nutzung",

      "fleetadmin.tripStatus.reserved": "Reserviert",

      "fleetadmin.updateStatusModal.BLOCKED": "geblockt",

      "fleetadmin.updateStatusModal.RELEASED": "freigegeben",

      "fleetadmin.updateStatusModal.RELEASE_READY": "freigebbar",

      "fleetadmin.updateStatusModal.reasonPlaceholder": "Grund auswählen (mehrere möglich)",

      "fleetadmin.updateStatusModal.statusPlaceholder": "Status wählen",

      "fleetadmin.user.blocked.duplicateUserMarkedAsFraud": "Duplikat – Betrug (Sonstiges)",

      "fleetadmin.users.create.title": "Nutzer erstellen",

      "fleetadmin.users.info.upsellings.servicepaket300sb": "Service-Paket",

      "fleetadmin.validation.invalidEmail": "Bitte gebe eine gültige E-Mail Adresse ein.",

      "fleetadmin.validation.invalidPassword": "Mind. 8 Zeichen (inkl. 1 Groß- und 1 Kleinbuchstaben, 1 Nummer und Sonderzeichen)",

      "fleetadmin.validation.notIdentical": "Muss mit dem vorherigen Eintrag übereinstimmen.",

      "fleetadmin.validation.required": "Diese Feld darf nicht leer sein.",

      "fleetadmin.violationType.fuelCardMissing": "Fehlende Tankkarte",

      "fleetadmin.violationType.keyMissing": "Schlüssel fehlt",

      "fleetadmin.violationType.lowFuelLevel": "Niedriger Tankstand (Service)",

      "fleetadmin.violationType.returnedOutsideArea": "Rückgabezone (Service)",

      "fleetadmin.wallet.serviceref": "Dienstreferenz",

      "forget.email": "E-Mail-Adresse vergessen?",

      "forget.email.desc": "Trage die Handy-Nr. ein, die deinem Nutzerkonto hinterlegt ist. Du erhältst im Anschluss einen Bestätigungscode per SMS.",

      "forget.email.title": "E-Mail-Adresse vergessen?",

      "forgot.email.desc": "Trage die Handy-Nr. ein, die deinem Nutzerkonto hinterlegt ist. Du erhältst im Anschluss einen Bestätigungscode per SMS.",

      "forgot.email.dialog.title": "Um deine E-Mail-Adresse zu finden, werden wir dich im nächsten Schritt bitten, dich mit der von dir angegebenen Handynummer zu authentifizieren.",

      "forgot.email.dialog.yes": "Weiter",

      "forgot.email.title": "E-Mail-Adresse vergessen?",

      "form.31MgGL.1.desc": "Diese Angabe ist wichtig für die Teilnahme an unseren Vorteilsprogrammen.",

      "form.31MgGL.1.title": "Bist du  geworben worden?",

      "form.3yYJ8x.1.desc": "Sofern Sie in der Immobilie eines unserer Immobilienpartner\nwohnen, wählen Sie bitte den entsprechenden Partner.",

      "form.3yYJ8x.1.title": "Immobilienpartner wählen",

      "form.3yYJ8x.2.desc": "An welchem Standort werden Sie unseren Service\nvoraussichtlich am häufigsten nutzen?",

      "form.3yYJ8x.2.title": "Standort wählen",

      "form.woGyQx.1.desc": "Diese Angabe ist wichtig für die Teilnahme an unseren\nVorteilsprogrammen.",

      "form.woGyQx.1.title": "Sind Sie geworben worden?",

      "from": "Ab",

      "fuel.card.view.btn.txt": "Weiter",

      "fuel.card.view.description": "Bitte wähle die verbundene Tankkarte um fortzufahren",

      "fuel.card.view.search.label": "Tankkarte",

      "fuel.card.view.title": "Tankkarte verbinden",

      "fuelstation.an.name": "Aral",

      "fuelstation.ap.name": "AP",

      "fuelstation.aral.name": "ARAL",

      "fuelstation.aral.title": "Aral Tankstelle",

      "fuelstation.avanti.name": "Avanti",

      "fuelstation.bp.name": "BP",

      "fuelstation.eni.name": "Eni",

      "fuelstation.help.text": "Hilfe zur Nutzung der Tankkarte",

      "fuelstation.om.name": "OMV",

      "fuelstation.omv.name": "OMV",

      "fuelstation.openallday": "24 Stunden geöffnet",

      "fuelstation.opennow": "Aktuell geöffnet:",

      "fuelstation.openstoday": "Heute geöffnet:",

      "fuelstation.openstomorrow": "Morgen geöffnet:",

      "fuelstation.status.prefix": "Tankstelle",

      "fuelstation.total.name": "Total",

      "fuelstation.totalenergies.name": "Total Energies",

      "fuelstation.westfalen.name": "Westfalen",

      "gas.station.note.text": "Tanken ist im Mietpreis inbegriffen. In jedem Fahrzeug befindet sich eine Tankkarte, mit der Sie bei allen Partnertankstellen bargeldlos tanken können. Die PIN zur Bezahlung wird Ihnen über die App angezeigt.",

      "handover.all.around.confirm": "Zustimmen & fortfahren",

      "handover.all.around.no": "Rundum-Fotos aufnehmen",

      "handover.all.around.warning": "Mir sind sie bewusst und ich stimme folgenden Mitwirkungspflichten ausdrücklich zu:\n\n\n✓ Pflicht zur Dokumentation: Ohne Fotodokumentation gilt das Fahrzeug bei Rückgabe als nicht ordnungsgemäß dokumentiert. Ich nehme zur Kenntnis, dass nachträglich festgestellte Schäden, die nicht in der Schadenliste vor Fahrtantritt aufgeführt waren, mir zugerechnet werden können, sofern ich den Zustand nicht anderweitig widerlegen kann.\n\n\n✓ Pflicht zur Nachsendung: Ich verpflichte mich, die 4 Rundum-Fotos unmittelbar per E-Mail an den Kundensupport zu übermitteln. Sollte ein nach Mietende festgestellter Neuschaden auf den Fotos aufgrund mangelhafter Qualität (z. B. Unschärfe, Dunkelheit oder falscher Winkel) nicht zweifelsfrei ausgeschlossen werden können, kann ich für diesen Schaden haftbar gemacht werden.\n\n\n✓ Pflicht zur Aufbewahrung: Zudem verpflichte ich mich, diese Fotos für einen Zeitraum von 90 Tagen ab Mietende digital aufzubewahren und der Vermieterin auf Verlangen jederzeit erneut zur Verfügung zu stellen.",

      "handover.belonging.title": "Alle Habseligkeiten entnommen",

      "handover.belongings.button.title": "Ich habe alles bei mir",

      "handover.belongings.decr": "Bitte überprüfe, dass du keine privaten Gegenstände im Auto vergessen hast.",

      "handover.belongings.title": "Nichts vergessen?",

      "handover.bottom.description": "Du findest den Schlüssel im Handschuhfach auf der Beifahrerseite",

      "handover.carCheck.title": "Rundum-Fotos aufgenommen",

      "handover.card.title": "Tankkarte zurückgelegt",

      "handover.damages.count": "%d Schäden",

      "handover.demages.description": "Gemeldete Schäden",

      "handover.dongle.card.title": "Tankkarte zurückgeben",

      "handover.dongle.key.title": "Schlüssel zurückgeben",

      "handover.doorsWidows.title": "Nichts vergessen & ausgestiegen",

      "handover.doorsWindows.title": "Ich habe nichts vergessen & bin ausgestiegen",

      "handover.engine.dialog.message": "Starte einfach den Motor, um den Übergabe-Check zu bestätigen. Du findest den Autoschlüssel im Handschuhfach auf der Beifahrerseite.",

      "handover.engine.dialog.title": "Jetzt Motor starten",

      "handover.fuel.title": "Ich wähle den Tank-Service",

      "handover.fuelCard.button.title": "Aktualisieren",

      "handover.fuelCard.decr": "Bitte sicherstellen, dass sich die Tankkarte im Handschuhfach befindet.",

      "handover.fuelCard.title": "Tankkarte zurückgelegt",

      "handover.key.title": "Schlüssel zurückgelegt",

      "handover.location.button.title": "Rückgabeort anzeigen",

      "handover.location.decr": "Bitte die Miete im Umkreis des angegebenen Rückgabeorts beenden. ",

      "handover.location.option": "Selbst fahren",

      "handover.location.title": "Rückgabeort",

      "handover.location.warning": "Ich erkläre mich einverstanden, 500 € zu zahlen.",

      "handover.lock.button.title": "Auto verriegeln",

      "handover.lock.locking": "Verriegle ...",

      "handover.lock.title": "Schließe alle Türen und Fenster und verriegele das Fahrzeug von außen.",

      "handover.lowFuel.button.title": "Suche nächste Tankstelle",

      "handover.lowFuel.decr": "Bitte tanke das Auto, bevor du die Miete beendest. Für Hilfe, kontaktiere unser Service-Team.",

      "handover.lowFuel.option": "Selbst tanken",

      "handover.lowFuel.title": "Niedriger Kraftstoffstand",

      "handover.lowFuel.warning": "Ich erkläre mich einverstanden, 50 € zu zahlen.",

      "handover.lowfuel.fee": "Ich wähle den Tank-Service (%s)",

      "handover.payAsReserved.prefix": "Zahlungspflichtig bis",

      "handover.report": "Schaden bzw. Mangel melden",

      "handover.returnKey.button.title": "Aktualisieren",

      "handover.returnKey.decr": "Bitte sicherstellen, dass sich der Autoschlüssel im Handschuhfach befindet.",

      "handover.returnKey.title": "Autoschlüssel zurückgeben",

      "handover.returnLocation.title": "Ich wähle den Rückbring-Service (nur innerhalb von 5km um die Rückgabezone möglich)",

      "handover.title": "Starte jetzt den Motor",

      "handover.top.description": "Wenn das Auto bis auf die bereits aufgeführten Mängel schadenfrei ist, starte den Motor und habe eine gute Fahrt!",

      "handover.unlock.description": "Deine Miete wurde nicht beendet. Bitte versuche es erneut. Sollte das Problem anschließend nicht behoben sein, wende dich bitte an unser Service Team.",

      "handover.unlock.slider.title": "Fahrzeug öffnen",

      "handover.unlock.title": "Etwas ist schief gelaufen!",

      "handover.warning.message": "Risiko bei mangelhafter Fotoqualität: Sollte ein nach Mietende festgestellter Neuschaden auf den Fotos aufgrund mangelhafter Qualität (z. B. Unschärfe, Dunkelheit oder falscher Winkel) nicht zweifelsfrei ausgeschlossen werden können, kann ich für diesen Schaden haftbar gemacht werden. Mir steht es frei, zusätzliche Fotos aufzubewahren.",

      "help.dialog.chat": "LiveChat",

      "help.dialog.helpcenter": "HilfeCenter",

      "help.dialog.title": "Service Team kontaktieren",

      "heyOBI.heyOBI.pricing": "| Mietdauer    ||\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete|\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "home.about": "© GETAWAY, rechtl. Info ",

      "home.button.title": "Los geht's",

      "home.walkthrough.guest": "Als Gast fortfahren",

      "home.walkthrough.login": "Login",

      "home.walkthrough.map.signup": "Anmelden",

      "home.walkthrough.signup": "Los geht's",

      "hour": "Stunde",

      "hours": "Stunden",

      "hours.short": "Std.",

      "iban": "IBAN",

      "id.card.country.not.valid": "Für andere Länder ist keine Online-Dokumentenprüfung möglich. Hast du Fragen? Wende dich einfach an unseren Support.",

      "id.rejected.title": "Bitte achte auf folgenden Hinweis zu deinem vorher eingereichten Dokument:",

      "id.tab.card": "Personalausweis",

      "id.tab.passport": "Reisepass",

      "ikeaInnsbruck.ubeeqo.pricing": "| Mietdauer (9:30 bis 21 Uhr)    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| ab 5. Stunde | 9,90 €/Std|\n\n\n|  Nachtzuschlag (21 bis 9:30 Uhr)    |  |\n| :-------- | -------: |\n| Mo - Fr | +20 €|\n| Sa - Mo | +89 €|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,39 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "ikeaInnsbruckBub.Buchbinder.pricing": "| Mietdauer (9:30 bis 21 Uhr)    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| ab 5. Stunde | 9,90 €/Std|\n\n\n|  Nachtzuschlag (21 bis 9:30 Uhr)    |  |\n| :-------- | -------: |\n| Mo - Fr | +20 €|\n| Sa - Mo | +89 €|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,49 € / km |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "ikeaMain.duration.prefix": ".",

      "ikeaMain.ubeeqo.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| Ab 5. Stunde | 9,90 €/Std|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "ikeaMainBub.Buchbinder.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| Ab 5. Stunde | 9,90 €/Std|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,49 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/68fe517026116829219fdd72/pdf) zu entnehmen.",

      "image.upload.success": "Hochladen erfolgreich",

      "input.error.invalid": "Falsche Eingabe",

      "input.error.invalidCountry": "Ungültig",

      "input.password.error.invalid": "Passwort muss mindestens 6 Zeichen, eine Zahl, einen Großbuchstaben, und ein Symbol enthalten.",

      "insecuredevice.dialog.message": "Dieses Handy ist nicht mit deinem Nutzerkonto verknüpft. Um es zu verifizieren, senden wir dir einen Bestätigungscode per SMS an die Handynummer, die in deinem Konto hinterlegt ist.",

      "insecuredevice.dialog.no": "Jetzt nicht",

      "insecuredevice.dialog.title": "Dieses Handy verifizieren",

      "insecuredevice.dialog.yes": "Verifizieren",

      "installation.cancel.dialog.message": "Bist du sicher, dass du die Installation abbrechen möchtest?",

      "installation.cancel.dialog.title": "Installation abbrechen!",

      "installation.cancel.dialog.yes": "Ja",

      "installed.view.btn.txt": "Anderen Auftrag beginnen",

      "installed.view.duration": "Fertig in",

      "installed.view.duration.minutes": "%s Minuten",

      "installed.view.duration.seconds": "%s Sekunden",

      "installed.view.title": "Ein weiteres Fahrzeug wurde verbunden!",

      "insurance.card.61dd46ad39dc364cd98f6739.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.61e015735925e70e8d972ef2.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.635665e30ad73328ee31a4e3.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.6360f3d14a2bec0c9d4088e6.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.636254dfd40f7c05a6517d5b.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.636ce123e5b01a0ca02d45ef.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.68f3457cacc9b808fc277bb8.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.68fe0e6c3e05fe5524a95644.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.6997422aa61cb20c384efab8.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.69a076f945c6fd1ee157f00d.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.69e8d1871c39133cc07d35c2.subtitle": "max. 500€ Selbstbeteiligung",

      "insurance.card.69e8d1871c39133cc07d35c2.title": "Mindestschutz",

      "insurance.card.69e8d1bb1c39133cc07d35c4.subtitle": "max. 150€ Selbstbeteiligung",

      "insurance.card.69e8d1bb1c39133cc07d35c4.title": "Bester Schutz",

      "insurance.card.6a7dd8798a03e46ab9d0154d.subtitle": "max. 1500 € Selbstbehalt\n",

      "insurance.card.6a7dd8798a03e46ab9d0154d.title": "Mindestschutz",

      "insurance.card.6a7dd8798a03e46ab9d0154f.subtitle": "max. 500 € Selbstbeteiligung\n",

      "insurance.card.6a7dd8798a03e46ab9d0154f.title": "Schutz",

      "insurance.card.6a7dd8798a03e46ab9d01551.subtitle": "max. 150 € Selbstbeteiligung\n",

      "insurance.card.6a7dd8798a03e46ab9d01551.title": "Bester Schutz",

      "insurance.card.6a881be56c0e2870fcea139f.subtitle": "0€ Selbstbeteiligung",

      "insurance.card.6a881be56c0e2870fcea139f.title": "Bester Schutz",

      "insurance.card.6a88487d6c0e2870fcea13c0.subtitle": "max. 2800€ Selbstbeteiligung",

      "insurance.card.6a88487d6c0e2870fcea13c0.title": "Minimaler Schutz",

      "insurance.card.F3008.title": "Bester Schutz",

      "insurance.card.F3040.subtitle": "max. 500€ Selbstbeteiligung",

      "insurance.card.F3040.title": "Mindestschutz",

      "insurance.card.F3041.subtitle": "max. 150€ Selbstbeteiligung",

      "insurance.card.F3041.title": "Bester Schutz",

      "insurance.charterline.150": "Maximal 150 €",

      "insurance.charterline.1500": "Maximal 1.500 €",

      "insurance.charterline.15000": "Maximal 15.000 €",

      "insurance.charterline.151": "Maximal 150 €",

      "insurance.charterline.500": "Maximal 500 €",

      "insurance.charterline.501": "Maximal 500 €",

      "insurance.charterline.650": "Maximal 650 €",

      "insurance.charterline.750": "Maximal 750 €",

      "insurance.charterline.description": "Selbstbeteiligung",

      "insurance.charterline.description.1500": "Bis zu 15.000 €",

      "insurance.charterline.headline": "Selbstbeteiligung",

      "insurance.charterline.value.150": "+24 €/KalTag",

      "insurance.charterline.value.1500": "inkl.",

      "insurance.charterline.value.15000": "inkl.",

      "insurance.charterline.value.151": "+34 €/KalTag",

      "insurance.charterline.value.500": "+19 €/KalTag",

      "insurance.charterline.value.501": "+29 €/KalTag",

      "insurance.charterline.value.650": "inkl.",

      "insurance.charterline.value.750": "inkl.",

      "insurance.description": "maximal",

      "insurance.description.free": "Bis zu",

      "insurance.fee_item.description": "Reduzierung SB %s",

      "insurance.label.free": "max. 1.500€",

      "insurance.previous_for_the_same_car_must_be_used": "Bei Benutzung des gleichen Fahrzeugs muss die selbe Versicherungsoption gewählt werden.",

      "insurance.rental.title": "Deine Selbstbeteiligung!",

      "insurance.value": "€/KalTag",

      "insurance.value.free": "inkl.",

      "internet.disconnected.message": "Bitte überprüfe deine Internetverbindung",

      "invitation.code.label": "Einladungscode eingeben",

      "invitation.code.submit": "Los geht’s",

      "invitation.description": "Gib jetzt deinen Einladungscode an",

      "invitation.remove.text": "ENTFERNEN",

      "invitation.submit.text": "ÜBERNEHMEN",

      "invitation.text.placeholder": "Einladungscode",

      "invitation.title": "Du hast eine Einladung?",

      "invite.browse.contacts.button": "KONTAKTE DURCHSUCHEN",

      "invite.contacs.success": "Einladung ist abgeschickt worden. Wir benachrichtigen dich, sobald sie angenommen wird.",

      "invite.contact.email.warning": "Du musst einen E-Mail Account eingerichtet haben",

      "invite.email.description": "GETAWAY ist der erste professionelle Fuhrpark von Autofahrern für Autofahrer. Wenn du ein Auto hast, kannst du es Geld verdienen lassen und somit alle deine Autokosten decken. Hast du einen Führerschein, kannst du jederzeit und überall dein Wunschauto per App finden und sofort losfahren. Probiere es aus und sichere dir mit meiner Einladung 10€ Startguthaben auf %@",

      "invite.email.title": "Mach mit bei GETAWAY",

      "invite.friends.share.button": "TEILEN",

      "invite.friends.share.description": "Zum Kopieren, Einladungslink klicken und halten",

      "invite.message": "Ich schenke dir 10€ Startguthaben für GETAWAY, deinem Universalschlüssel zu jedem Auto in deiner Umgebung.  Oder vermiete dein eigenes Auto und verdiene 100€ wöchentlich. Lade dir jetzt gratis die App herunter.",

      "invite.message.title": "Du bist zu GETAWAY eingeladen worden",

      "invoice.footer.issuedBy": "Beleg ausgestellt durch:",

      "invoice.footer.page": "SEITE %s VON %s",

      "invoice.intro": "Vielen Dank für die Nutzung von %s! Hiermit erlauben wir uns folgende Leistungen in Rechnung zu stellen.",

      "invoice.intro.credit": "Vielen Dank für die Beauftragung. Wir berechnen für den Leistungszeitraum %s was folgt:",

      "invoice.intro.thanks": "Vielen Dank für die Nutzung von %s!",

      "invoice.issuedOnBehalf": "Beleg ausgestellt im Auftrag von",

      "invoice.item.f3004": "Mietstunde(n)",

      "invoice.item.f3060": "Reduzierung Selbstbehalt (500€) pro Std.",

      "invoice.item.f9999": "Diverse",

      "invoice.meta.bookingRef": "Referenznummer:",

      "invoice.meta.customerRef": "Kundenzeichen:",

      "invoice.meta.date": "Belegdatum:",

      "invoice.meta.number": "Belegnummer:",

      "invoice.odometer": "Km-Stand %s",

      "invoice.payment.heading": "ZAHLUNGSMITTEL",

      "invoice.pickup": "ÜBERNAHME",

      "invoice.rental.label": "Mietvorgang:",

      "invoice.rental.plate": "Kennzeichen:",

      "invoice.rental.userGroup": "Nutzerkreis:",

      "invoice.return": "RÜCKGABE",

      "invoice.storno": "Hiermit wird der Beleg (Anhang) storniert %s",

      "invoice.storno.footer": "Der stornierte Betrag wird auf die jeweilige Einzahlungsmethode des Begünstigten erstattet. Für die ordnungsgemäße Versteuerung ist der Begünstigte selbst verantwortlich.",

      "invoice.table.amountDue": "Zu zahlender Betrag",

      "invoice.table.amountRefund": "Zu erstattender Betrag",

      "invoice.table.grossSum": "Gesamtbrutto",

      "invoice.table.grossTotal": "BRUTTO GESAMT",

      "invoice.table.lessCredit": "Abzgl. Guthaben",

      "invoice.table.netTotal": "NETTO GESAMT",

      "invoice.table.qty": "MENGE",

      "invoice.table.subtotal": "Zwischensummen",

      "invoice.table.title": "Mietvorgang",

      "invoice.table.unitGross": "BRUTTO",

      "invoice.table.vatNote": "(inkl. USt. %s)",

      "invoice.table.vatPortion": "%s iHv. %s",

      "invoice.title.creditNote": "Gutschrift",

      "invoice.title.invoice": "Rechnung",

      "joinCircle.title": "Nutzerkreis beitreten",

      "keine": "Keine",

      "landing.card1.desc": "Decke deine Autokosten, indem du es sicher und ohne Aufwand in deiner Nachbarschaft vermietest.",

      "landing.card1.title": "Dein Auto verdient es!",

      "landing.card2.desc": "Unsere Versicherung schützt dein Auto und deine Mobilität.",

      "landing.card2.title": "Rundum versichert",

      "landing.later": "SPÄTER",

      "landing.login": "Ich habe bereits ein Nutzerkonto",

      "landing.signup": "Willkommen!",

      "landing.signup.dialog.email.exists": "Es scheint, als sei deine E-Mail Adresse bereits hinterlegt. Möchtest du dein Passwort zurücksetzen?",

      "language.dialog.cz": "Čeština (CZ)",

      "language.dialog.de": "Deutsch (DE)",

      "language.dialog.en": "English (EN)",

      "language.dialog.es": "Español (ES)",

      "language.dialog.fr": "Français (FR)",

      "language.dialog.gr": "Ελληνικά (EL)",

      "language.dialog.it": "Italiano (IT)",

      "language.dialog.pl": "Polski (PL)",

      "language.dialog.sk": "slovenský (SK)",

      "language.dialog.title": "Sprache wählen",

      "language.dialog.tr": "Türkçe (TR)",

      "late": "abgelaufen",

      "less": "Weniger",

      "license.addPhoto.back": "Führerschein-Rückseite hinzufügen",

      "license.addPhoto.front": "Führerschein-Vorderseite hinzufügen",

      "license.addVideo": "Selfie-Video hinzufügen",

      "license.addedPhoto.back": "Führerschein-Rückseite",

      "license.addedPhoto.front": "Führerschein-Vorderseite",

      "license.addedVideo": "Selfie-Video",

      "license.submit.title": "Weiter",

      "license.title": "Führerschein hinzufügen",

      "licenses.title": "Urheberrechtshinweise",

      "list.car.desc": "Fotografiere jetzt die Vorderseite deines Fahrzeugscheins und lass gratis prüfen, wie viel dein Auto für dich verdienen kann.",

      "list.car.footer": "Das Auto hat eine gültige Haftpflichtversicherung und eine gültige Hauptuntersuchung.",

      "list.car.license": "Kfz-Schein Vorderseite (vollst. aufgeklappt)",

      "list.car.ownership.error": "Bitte gib das Eigentumsverhältnis an",

      "list.car.ownership.message": "Wer nicht Halter bzw. Eigentümer des Fahrzeugs ist, muss alternativ eine Vollmacht vorlegen. Eine Vorlage wird zur Verfügung gestellt.",

      "list.car.submit": "JETZT CHECKEN LASSEN",

      "list.car.success": "Danke, dein Fahrzeugschein ist übermittelt worden. Wir schicken dir eine E-Mail mit der weiteren Vorgehensweise.",

      "list.car.takeaphoto.error": "Bitte lade deinen Kfz-Schein hoch, um fortzufahren.",

      "list.car.title": "Wie viel verdient dein Auto?",

      "litre.short": "l",

      "loading": "loading ...",

      "location.permission": "Achtung: Bitte erlaube Zugriff auf deinen Standort, um Fahrzeuge finden und mieten zu können.",

      "location.permission.details": "Um u.a. Autos in deiner Nähe angezeigt zu bekommen, aktiviere jetzt bitte die Standortdienste.",

      "location.permission.no": "Später",

      "location.permission.title": "Standortdienste aktivieren",

      "location.permission.unauthorized": "GETAWAY kann ohne die Info über deinen Standort nicht einwandfrei funktionieren.",

      "location.permission.yes": "Erlauben",

      "lock.error": "Auto kann nicht verschlossen werden. Bitte kontaktiere unser Service Team.",

      "login.button.title": "Login",

      "login.email": "Stattdessen mit E-Mail-Code anmelden",

      "login.email.button.title": "E-Mail-Code anfordern",

      "login.email.desc": "Bitte gib die E-Mail-Adresse an, mit der du dich registriert hast. Du erhältst im Anschluss eine E-Mail mit einem Code, um sich anzumelden.",

      "login.email.placeholder": "E-Mail",

      "login.email.title": "Mit E-Mail-Code anmelden",

      "login.failed.again.text": "Erneut versuchen",

      "login.failed.alert.body": "E-Mail und/oder Passwort stimmen nicht. Versuche es noch einmal oder klicke \"Vergessen?\"",

      "login.failed.alert.title": "Anmelden fehlgeschlagen",

      "login.footnote.signup.action": "Hier registrieren",

      "login.footnote.signup.text": "Noch kein Nutzerkonto?",

      "login.forgot.desc": "Bitte gib die E-Mail-Adresse an, mit der du dich registriert hast. Du erhältst im Anschluss eine E-Mail zum Zurücksetzen deines Passworts.",

      "login.forgot.text": "Passwort zurücksetzen",

      "login.forgot.title": "Passwort vergessen?",

      "login.orloginfacebook.text": "Oder per",

      "login.orsignupfacebook.text": "Oder per",

      "login.password.placeholder": "Passwort",

      "login.title": "Schön, dich wiederzusehen!",

      "login.with.password": "Stattdessen mit Passwort anmelden",

      "logout.prompty.logout": "JA",

      "mages.510cm": "5 - 10cm",

      "map.blocked.callout": "Fahrzeug muss gewartet werden. Es ist in Kürze wieder verfügbar.",

      "map.booking.reserve": "Reservieren",

      "map.bookings.button.text": "Reservierung ab",

      "map.callout.bonus.lowAndOut": "Bis zu 10 € Sofort-Gutschrift.",

      "map.callout.bonus.lowFuel": "5€ Sofort-Bonus",

      "map.callout.bonus.lowFuel&out": "Bis zu 10€ Sofort-Bonus",

      "map.car.eligible.description": "[In Warteschlange] Bald in deiner Nähe verfügbar.",

      "map.car.inqueue.callout": "Melden sich mehr aus meiner Nähe an, stehe ich in Kürze zur Verfügung.",

      "map.car.release_ready.callout": "Dieses Fahrzeug ist leider aktuell nicht verfügbar. Bitte wähle einen anderen Zeitraum.",

      "map.car.release_ready.description": "[In Nutzung] Bitte probiere es später erneut.",

      "map.car.released.callout": "Verfügbar bis\n%@",

      "map.car.selected.callout": "Ich bin bald verfügbar. Du wirst mich in Kürze mieten können 🙌",

      "map.card.refuel": "Bitte tanken",

      "map.card.rentedFuel": "mind. 25 %",

      "map.consent.returnrefuel.no": "Abbrechen",

      "map.consent.returnrefuel.yes": "Zustimmen",

      "map.embedded.area.label": "Abholung & Rückgabe",

      "map.embedded.area.placeholder": "Bitte wähle aus",

      "map.embedded.card.button": "Fahrzeuge anzeigen",

      "map.embedded.card.title": "Miete Transporter bequem in deiner Nähe",

      "map.embedded.cars.empty": "Für den ausgewählten Zeitraum sind keine Fahrzeuge verfügbar.",

      "map.embedded.from": "Von",

      "map.embedded.to": "Bis",

      "map.fillProfile.dialog.add": "Hinzufügen",

      "map.fillProfile.dialog.message": "Vervollständige jetzt deine Nutzerangaben (nur 2 Min.), um fortzufahren.",

      "map.fillProfile.dialog.no": "Jetzt nicht",

      "map.fillProfile.dialog.secure": "Kreditkartenüberprüfung",

      "map.fillProfile.dialog.support": "Registrierung abschließen",

      "map.fillProfile.dialog.title": "Fehlende Nutzerangaben",

      "map.fillProfile.dialog.yes": "OK",

      "map.filter.check": "Verfügbarkeit prüfen",

      "map.filter.description": "Gib den gewünschten Abholungs- und Rückgabezeitpunkt an.",

      "map.filter.findCar": "Fahrzeug finden",

      "map.filter.header": "Wann möchtest du ein Fahrzeug?",

      "map.filter.now": "Ab sofort",

      "map.filter.pickup": "Abholung",

      "map.filter.reset": "Zurücksetzen",

      "map.filter.return": "Rückgabe",

      "map.filter.secondary.text": "Zeitraum ändern",

      "map.filter.time.to": "bis",

      "map.filter.title": "Wann brauchst du ein Fahrzeug?",

      "map.marker.perHours": "€/Std.",

      "map.popup.firststeps": "%@ und erhalte deinen Willkommensbonus.",

      "map.popup.firststeps.url": "https://applink.get-a-way.com/user-challenges-firststeps",

      "map.popup.firststeps.url.text": "Schließe jetzt deine Anmeldung ab",

      "map.rental.blocked": "Miete ist geblockt",

      "map.rented.callout": "Im gewählten Zeitraum nicht verfügbar.",

      "map.rented.car.callout": "Verfügbar nach\n%@",

      "map.reservedCarHeader.settings.title": "Mieteinstellungen (Versicherung etc.)",

      "map.reservedCarHeader.title": "Das Auto ist reserviert!",

      "map.service.lastCleaning.new": "neu",

      "map.station.card.button": "Auswählen",

      "map.station.card.description": "Station",

      "map.station.card.headline": "Wähle eine Fahrzeugkategorie",

      "map.station.card.no.categories": "In dieser Station stehen im gewählten Zeitraum keine Fahrzeuge per App zur Verfügung.",

      "map.station.card.phone": "Telefon",

      "map.station.card.position": "Standort",

      "map.station.card.title": "Robben & Wientjes",

      "map.station.card.workinghrs": "Öffnungszeiten",

      "map.station.closed.text": "In dieser Station stehen im gewählten Zeitraum keine Fahrzeuge per App zur Verfügung.",

      "map.station.note.title": "Hinweise",

      "map.time": "Autos filtern",

      "map.time.select.apply": "Filtern",

      "map.time.select.title": "wie lange möchtest du einen GETAWAY?",

      "map.unavailable.callout": "Im gewählten Zeitraum nicht verfügbar. %s .",

      "map.unavailable.callout.link": "https://www.google.com/",

      "map.unavailable.callout.link.text": "Verfügbarkeit anzeigen",

      "map.user.blocked": "Nutzerkonto blockiert",

      "map.usercar.BLOCKED.callout": "✋ Ich bin aktuell geblockt. Bitte kontaktiere das Service Team.",

      "map.usercar.ELIGIBLE.callout": "💪 Ich habe alle Tests bestanden",

      "map.usercar.EQUIPPED.callout": "⚙ Ich bin ausgerüstet",

      "map.usercar.SELECTED.callout": "🎉 Ich kann es kaum erwarten, ausgerüstet zu werden!",

      "map.usercar.blocked.callout": "✋ Ich bin aktuell geblockt. Bitte kontaktiere das Service Team.",

      "map.usercar.eligible.callout": "💪 Ich habe alle Tests bestanden",

      "map.usercar.equipment_ready.callout": "👨‍🔧 Ich warte auf den GETAWAY Techniker",

      "map.usercar.listed.callout": "💰 Ich könnte bis zu 400€ pro Monat verdienen!",

      "map.usercar.released.callout": "Freigegeben bis\n%@",

      "map.usercar.selected.callout": "🎉 Ich kann es kaum erwarten, ausgerüstet zu werden!",

      "map.usercar.service.callout": "🚗✨ Ich genieße gerade einen Service",

      "marketing.consent": "Ich bin einverstanden, den Newsletter per E-Mail zu erhalten. Jederzeit widerrufbar.",

      "md.demo": "## UBEEQO \"OBI DEFAULT\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 19,99 € (inkl. 20km/Std)|\n| Mo-Sa 20-8 Uhr | 59,90 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 139,90 € (inkl. 150km) |\n| An Feiertagen | 59,90 € (inkl. 100km) |\n<br/>\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 €|\n<br/>\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n<br/>\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n<br/>\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n<br/>\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"HEY OBI\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 16,99 € (inkl. 20km/Std)|\n| Mo-Sa 20-8 Uhr | 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 102,00 € (inkl. 150km) |\n| An Feiertagen | 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"OBI Mitarbeiter\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 16,99 € (inkl. 20km/Std)|\n| Mo-Sa 20-8 Uhr | 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 102,00 € (inkl. 150km) |\n| An Feiertagen | 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.\n\n## UBEEQO \"SPP Default\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 6,90 €/Std|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachttarif | 20 €|\n| Wochenendtarif | 79 €|\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"SPP Kunde\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n *Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"SPP Mitarbeiter\"\n\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n*Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.<br/>\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.\n\n\n\n<br/><br/>\n## UBEEQO \"IKEA DEFAULT\"\n\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| Ab 5. Stunde | 9,90 €/Std|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.\n\n\n<br/><br/>\n## UBEEQO \"IKEA INNSBRUCK ETC\"\n\n\n| Mietdauer (9:30 bis 21 Uhr)    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| ab 5. Stunde | 9,90 €/Std|\n\n\n|  Nachtzuschlag (21 bis 9:30 Uhr)    |  |\n| :-------- | -------: |\n| Mo - Fr | +20 €|\n| Sa - Mo | +89 €|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "meter.short": "m",

      "mileage": "Km-Stand",

      "minute": "Minute",

      "minute.short": "Min.",

      "minutes": "Minuten",

      "more": "Mehr",

      "multiplecars.add": "Jetzt neues Auto prüfen lassen",

      "multiplecars.footnote": "Tipps und Tricks, wie du mit deinem Auto Geld verdienst, erfährst du in unserem %@.",

      "multiplecars.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#geld-verdienen",

      "multiplecars.footnote.url.text": "HilfeCenter",

      "multiplecars.released.returntime": "bis",

      "multiplecars.rented.returntime": "bis spät.",

      "multiplecars.title": "MEINE AUTOS",

      "navigate": "Navigieren",

      "needsAccessKitCheck": "AccessKit prüfen",

      "needsBattery": "Niedriger Batteriestand",

      "needsCleaning": "Reinigung nötig",

      "needsFuel": "Kraftstoff nötig",

      "needsFuelCard": "Tankkarte nötig",

      "needsKeyFob": "KeyFob nötig",

      "needsOther": "Sonstiges nötig",

      "needsRelocation": "Verlegungsfahrt nötig",

      "needsRepair": "Reparatur nötig",

      "new.insurance.charterline.150": "150 €",

      "new.insurance.charterline.1500": "1500 €",

      "new.insurance.charterline.15000": "15.000 €",

      "new.insurance.charterline.151": "150 €",

      "new.insurance.charterline.500": "500 €",

      "new.insurance.charterline.501": "500 €",

      "new.insurance.charterline.650": "650 €",

      "new.insurance.charterline.750": "750 €",

      "new.insurance.charterline.description": "Max",

      "new.insurance.charterline.description.15000": "Bis zu",

      "new.partner.password.placeholder": "Passwort",

      "new.password.yes": "Zur Passworteingabe",

      "no": "Nein",

      "no.geocode": "Rückgabezone anzeigen",

      "noBlockReason": "Kein Downtime-Grund verfügbar",

      "noRentals": "Keine Mietvorgänge vorhanden",

      "noServices": "Keine Aufträge",

      "nocars.invite": "EINLADEN",

      "nocars.screen.title": "Lade Freunde ein für mehr Autos in deiner Nähe!",

      "normal.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeDamage_compressed.png",

      "notNow": "Nicht jetzt",

      "notification.backby.desc": "Bitte denke an die rechtzeitige Rückgabe, andernfalls können Gebühren anfallen.",

      "notification.backby.hide": "HINWEIS VERBERGEN",

      "notification.backby.title": "Noch %s",

      "notification.backby.title.late": "Seit %s",

      "notification.booking.rentals": "Meine Mieten",

      "notification.booking.success": "Du hast deine Buchung erfolgreich durchgeführt. Du findest den Buchungsstatus in deinem Nutzerkonto.",

      "notification.email": "Per E-Mail",

      "notification.email.desc": "Erlaubnis, dich per E-Mail zu kontaktieren.",

      "notification.finishRental.complain": "😕 Ich möchte mich beschweren.",

      "notification.finishRental.description": "Deine Fahrt wurde beendet. Du erhältst eine Übersicht per E-Mail.",

      "notification.finishRental.title": "Vielen Dank, dass du GETAWAY nutzt!",

      "notification.mail": "Per Post",

      "notification.mail.desc": "Erlaubnis, dich per Post zu kontaktieren.",

      "notification.negative.backby.desc": "Bitte bring das Fahrzeug zurück. Ein anderer Nutzer wartet bereits. Es können Gebühren anfallen.",

      "notification.push": "Per App-Mitteilung",

      "notification.push.desc": "Erlaubnis, dich per App-Mitteilung zu kontaktieren.",

      "notification.rental.dongle.finish.description": "Sobald die Stationsmitarbeiter Schlüssel und Fahrzeug entgegengenommen haben, wird deine Miete beendet und dir eine Übersicht per E-Mail geschickt.",

      "notification.sms": "Per SMS",

      "notification.sms.desc": "Erlaubnis, dich per SMS zu kontaktieren.",

      "now": "Jetzt",

      "obiEmployees.OBIMitarbeiter.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "obiPublicUsers.OBIMitarbeiter.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "obiPublicUsers.heyOBI.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "obiPublicUsers.ubeeqo.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 19,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | 59,90 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 139,90 € (inkl. 150km) |\n| An Feiertagen | 59,90 € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 €|\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone  |  25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "offline": "OFF",

      "offlineService.report.title": "Auftragsübersicht",

      "ok": "OK",

      "online": "ON",

      "open.directions.title": "Navigation starten",

      "open.email.gmail": "GMail öffnen",

      "open.email.outlook": "Outlook öffnen",

      "opennow": "Aktuell geöffnet",

      "openstoday": "Heute geöffnet",

      "openstomorrow": "Morgen geöffnet",

      "ops.damage.add.noImages.error": "Bitte stell sicher, dass du mindestens ein Bild hinzugefügt hast",

      "other": "Andere",

      "parking.description": "Gratis für 120 Min. Jede weitere kostet nur 5 Ct",

      "parking.hours": "Stunden",

      "parking.minutes": "Minuten",

      "parking.title": "Parkmodus",

      "partner.password.new.subtitle": "Bitte gib dein aktuelles Passwort an, mit dem du dich in unserer (Web-)App einloggst.",

      "partner.password.new.title": "Passwort erforderlich",

      "passport.country.not.valid": "Für andere Länder ist keine Online-Dokumentenprüfung möglich. Hast du Fragen? Wende dich einfach an unseren Support.",

      "password.conditions.8.min.length": "mindestens 8 Zeichen",

      "password.conditions.lowercase.and.uppercase": "sowohl Klein- als auch Großbuchstaben",

      "password.conditions.number": "mindestens eine Zahl",

      "password.conditions.specialCharacter": "mindestens ein Sonderzeichen",

      "password.token.expired": "Dieser Zurücksetzen-Link ist abgelaufen. Bitte setze dein Passwort erneut zurück.",

      "payByLink.transaction.description": "Bitte wähle deine Zahlungsmethode, um den offenen Betrag zu begleichen.",

      "payment.3ds.title": "Kreditkarte authentifizieren",

      "payment.add.description": "Zur Verifizierung deines Nutzerkontos. Es erfolgt keine Abbuchung. Die Anmeldung ist und bleibt gratis.",

      "payment.add.error": "Fehlgeschlagen. Bitte versuche es erneut oder kontaktiere unser Service Team.",

      "payment.bank.comdirekt": "Comdirekt",

      "payment.bank.commerzbank": "Commerzbank",

      "payment.bank.deutschebank": "Deutsche Bank",

      "payment.bank.dkb": "DKB",

      "payment.bank.header": "Oder Bank wählen",

      "payment.bank.ing": "ING Bank",

      "payment.bank.owner.consent": "Ich handele in eigenem Namen.",

      "payment.bank.postbank": "Postbank",

      "payment.bank.revolut": "Revolut",

      "payment.bank.santander": "Santander",

      "payment.bank.search": "Meine Bank suchen",

      "payment.bank.spardabank": "Spardabank",

      "payment.bank.sparkasse": "Sparkasse",

      "payment.bank.targobank": "Targobank",

      "payment.bank.volksbank": "Volksbank",

      "payment.billing.address.button": "Übernehmen",

      "payment.billing.address.company.contact": "Ansprechpartner",

      "payment.billing.address.company.name": "Firmenname",

      "payment.billing.address.description": "Lege fest, an wen die Rechnung adressiert werden soll.",

      "payment.billing.address.headline": "Adresse",

      "payment.billing.address.title": "Rechnungsdaten",

      "payment.billing.company.headline": "Firma",

      "payment.birthday.prefix": "geb. am",

      "payment.card.add.description": "Kredit-/Debitkarte hinzufügen und verifizieren",

      "payment.card.add.title": "Kredit-/Debitkarte hinzufügen",

      "payment.card.add.verifying": "Verifizierung läuft...",

      "payment.card.code.label": "Prüfziffern (CVC)",

      "payment.card.expiration.label": "Gültigkeit (mm/jj)",

      "payment.card.name.label": "Karteninhaber",

      "payment.card.number.label": "Kartennummer",

      "payment.firstname.placeholder": "Mein Vorname",

      "payment.footnote": "Mit der Auswahl des SEPA-Lastschriftverfahrens willige ich der Verarbeitung meiner Daten zur %s ein.",

      "payment.footnote.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "payment.footnote.url.text": "Prüfung der Zahlungswahrscheinlichkeit",

      "payment.googlePay.description": "Im nächsten Schritt kannst du Google Pay als Zahlungsmethode hinzufügen.",

      "payment.googlePay.title": "Google Pay hinzufügen",

      "payment.lastname.placeholder": "Mein Nachname",

      "payment.paypal.block.description": "Im nächsten Schritt wirst du zu Paypal weitergeleitet, um dein Paypal-Konto als Zahlmethode zu hinterlegen.",

      "payment.paypal.block.title": "Paypal hinzufügen",

      "payment.paypal.block.yes": "Fortfahren",

      "payment.postingText": "Danke.",

      "payment.postingTextReference": "%s",

      "payment.profile.billing": "Alternative Rechnungsadresse",

      "payment.profile.billing.add": "Rechnungsadresse ändern",

      "payment.profile.billing.title": "RECHNUNGSDATEN",

      "payment.profile.company.add": "Firmeninformationen hinterlegen",

      "payment.profile.default": "Als Standard festlegen",

      "payment.profile.delete": "Zahlungsprofil entfernen",

      "payment.profile.option.business": "Business",

      "payment.profile.option.personal": "Privat",

      "payment.profile.reset": "Rechnungsdaten zurücksetzen",

      "payment.profile.title": "Zahlungsprofil",

      "payment.profile.type": "Art des Profils",

      "payment.secured.success": "Authentifizierung erfolgreich bestanden, danke!",

      "payment.sepa.description": "SEPA-Lastschrift",

      "payment.singleLineItem.accountDeposit": "Girokonto: %@",

      "payment.singleLineItem.ibanVerification": "IBAN-Prüfung: %@",

      "payment.singleLineItem.invoice": "Rechnung: %@",

      "payment.singleLineItem.tripDeposit": "Anzahlung: %@",

      "paypal.desc": "Füge eine unserer sicheren und beliebten Zahlungsmittel hinzu.",

      "paypal.placeholder": "Paypal-Konto",

      "paypal.title": "Paypal hinzufügen",

      "per.calday": "/Kal.Tag",

      "per.km": "je km",

      "permission.settings.button": "ERLAUBEN",

      "personal": "privat",

      "pfofile.wizard.continue": "Registrierung fortsetzen",

      "phone.pairing.message": "Klicke hier, um dieses Handy zu verifizieren.",

      "phone.resend.code": "Erneut senden",

      "phone.search": "Suchen",

      "phone.verification.resend.success": "Bestätigungscode ist erneut versendet worden.",

      "phone.verify.code.apply": "CODE ÜBERNEHMEN",

      "phone.verify.code.desc": "Wir haben dir soeben einen 4-stelligen Code per SMS an %s geschickt. Bitte trage ihn jetzt ein.",

      "phone.verify.code.title": "SMS-Code eingeben",

      "phone.verify.desc": "Trage deine Handy-Nr ein. Du erhältst im Anschluss einen Bestätigungscode per SMS.",

      "phone.verify.mobile.phone.text": "Handy-Nummer",

      "phone.verify.send.button": "Bestätigen",

      "phone.verify.send.code": "SMS-Code anfordern",

      "phone.verify.sms": "{{code}} lautet dein GETAWAY Bestätigungscode.",

      "phone.verify.title": "Handy-Nr hinzufügen",

      "phone.wrong.format.error": "Bitte gebe die richtige Telefonnummer ein",

      "phoneNumberVerification.authy.custom_message": "{{code}} lautet dein GETAWAY Bestätigungscode.",

      "phonenumber.verification.error": "Diese Handynummer ist ungültig oder bereits einem aktivem Nutzerkonto hinterlegt. Bitte verwende eine andere oder melde dich mit dem bestehenden Nutzerkonto an.",

      "photo": "Foto",

      "photo.continue": "FORTFAHREN",

      "photo.library": "Fotos",

      "photo.source.dialog.title": "Fotos hochladen via",

      "photos": "Fotos",

      "photos.add": "Fotos vom Auto",

      "photos.add.button": "Foto hinzufügen",

      "photos.add.description": "Von Vorne, von der Seite und vom Innenraum. Je ansprechender, desto mehr Mieteinnahmen 🤩",

      "photos.desc": "Ein Foto sagt mehr als Tausend Wort. Füge jetzt mindestens eins hinzu.",

      "photos.permission": "Bitte erlaube GETAWAY Zugriff auf deine Fotos in deinen Einstellungen.",

      "photos.permission.details": "Um fortzufahren und Fotos hochzuladen, erlaube GETAWAY jetzt Zugang zu deinen Fotos.",

      "photos.permission.no": "Nicht jetzt",

      "photos.permission.title": "Zugang zu Fotos",

      "photos.permission.yes": "Erlauben",

      "photos.photo": "Foto",

      "photos.photo.reached.max": "Du hast die Maximalanzahl an Fotos erreicht.",

      "photos.skip.no.photos": "Du kannst Fotos jederzeit ergänzen.",

      "photos.skip.photos": "Du hast mindestens ein Foto hochgeladen.",

      "picker.placeholder": "Wähle aus ...",

      "pin.button": "Übernehmen",

      "pin.footnote.md": "Vergib hier deine persönliche Karten-PIN. Die PIN benötigst du, um das gebuchte Fahrzeug zu entriegeln.\n\n\n⚠️ <b>Achtung</b>: PIN ist ausschließlich für persönlichen Zugang zum Fahrzeug zu gebrauchen. Offenlegung oder Weitergabe an Dritte kann u.a. Vertragsstrafe zur Folge haben.",

      "pin.header": "Zugang zum Fahrzeug",

      "portal.area.count": "%s Fzg.",

      "portal.area.filter": "Standorte filtern",

      "portal.area.title": "Abholung & Rückgabe",

      "portal.car.cta": "Weiter",

      "portal.car.details": "Fahrzeugdetails anzeigen",

      "portal.car.insurance.fallback": "Schutz",

      "portal.card.lessAbout": "Weniger anzeigen",

      "portal.card.moreAbout": "Mehr zum Fahrzeug",

      "portal.card.orSimilar": "oder ähnlich",

      "portal.card.pricePrefix": "Gesamt ab",

      "portal.card.seats": "Sitze",

      "portal.card.select": "Wählen",

      "portal.card.selected": "Ausgewählt",

      "portal.checkout.billing": "Abweichende Rechnungsadresse",

      "portal.checkout.consent": "Mit Klick auf „Jetzt buchen\" akzeptierst du die",

      "portal.checkout.consent.link": "AGB",

      "portal.checkout.cta": "Jetzt buchen",

      "portal.checkout.cta.hint": "Wird aktiv, sobald deine Fahrerdaten vollständig sind.",

      "portal.checkout.cta.hint.payment": "Wird aktiv, sobald eine Zahlungsart hinterlegt ist.",

      "portal.checkout.cta.payment": "Zahlungsmittel wählen",

      "portal.checkout.cta.reserve": "Kostenpflichtig reservieren",

      "portal.checkout.cta.signin": "Anmelden und fortfahren",

      "portal.checkout.deposit.note": "Bei der Reservierung werden %s als Kaution auf deiner Karte geblockt – nicht abgebucht. Der Betrag wird nach der Rückgabe automatisch freigegeben.",

      "portal.checkout.deposit.sub": "wird nach Rückgabe freigegeben",

      "portal.checkout.deposit.title": "Jetzt geblockt (Kaution)",

      "portal.checkout.details": "Details ›",

      "portal.checkout.driver.title": "Wer fährt?",

      "portal.checkout.payment.title": "Wie möchtest du bezahlen?",

      "portal.checkout.signin.hint": "Melde dich an, um deine Buchung abzuschließen.",

      "portal.checkout.signin.link": "Bereits Kunde? Anmelden",

      "portal.checkout.signout": "Nicht du? Abmelden",

      "portal.checkout.signup.link": "Noch kein Konto? Jetzt auf unserer Website registrieren",

      "portal.checkout.title": "Wer fährt und zahlt?",

      "portal.checkout.total.sub": "Miete inkl. gewählter Optionen",

      "portal.checkout.total.title": "Gesamtpreis",

      "portal.date.apply": "Übernehmen",

      "portal.date.title": "Zeitraum wählen",

      "portal.desktop.change": "Ändern",

      "portal.desktop.cta.bookHint": "Die Kaution wird nur geblockt, nicht abgebucht",

      "portal.desktop.cta.nextHint": "Noch keine Zahlung fällig",

      "portal.desktop.cta.pickHint": "Wähle links ein Fahrzeug",

      "portal.desktop.day": "%s Tag",

      "portal.desktop.days": "%s Tage",

      "portal.desktop.empty.text": "Wähle links ein Fahrzeug – Preis und Optionen erscheinen dann hier.",

      "portal.desktop.empty.title": "Noch kein Fahrzeug gewählt",

      "portal.desktop.location": "Abholung & Rückgabe",

      "portal.desktop.lock.options": "Erst Optionen wählen",

      "portal.desktop.lock.vehicle": "Wähle zuerst ein Fahrzeug aus",

      "portal.desktop.options.title": "Buchungsoptionen & Versicherung",

      "portal.desktop.period": "Zeitraum",

      "portal.desktop.summary.title": "Deine Buchung",

      "portal.desktop.total": "Gesamtpreis",

      "portal.desktop.trust.cancel": "Kostenlose Stornierung (je nach Option)",

      "portal.desktop.trust.fees": "Keine versteckten Gebühren",

      "portal.desktop.trust.support": "Support per Chat und Telefon",

      "portal.desktop.vehicle": "Fahrzeug",

      "portal.done.booking.cta": "Buchung öffnen",

      "portal.done.booking.md": "Deine Buchung ist bestätigt.\nFalls sich kein neues Browserfenster geöffnet hat, klicke auf „Buchung öffnen\".\nAlternativ kannst du den Link manuell in die Adresszeile deines Browsers kopieren.",

      "portal.done.presignup.cta": "Buchung fortsetzen",

      "portal.done.presignup.md": "Deine Auswahl ist gespeichert.\n\nFalls sich kein neues Browserfenster geöffnet hat, klicke auf den Button “Buchung fortsetzen”.\n\nAlternativ kannst du den Link manuell in die Adresszeile deines Browsers kopieren.",

      "portal.footer.priceDetails": "Preisdetails",

      "portal.footer.total": "gesamt",

      "portal.insurance.heading": "Reduziere dein Risiko",

      "portal.insurance.sub": "Schäden werden schnell teuer. Begrenze deine Haftung mit einer reduzierten Selbstbeteiligung.",

      "portal.insurance.title": "Versicherungsschutz",

      "portal.results.nearby": "Weitere Standorte in der Nähe",

      "portal.results.seeAvailability": "Verfügbarkeit ansehen ›",

      "portal.results.title": "Fahrzeug wählen",

      "portal.results.unavailable": "Derzeit nicht verfügbar",

      "portal.results.vehicles": "Fahrzeuge",

      "portal.resume.carGone": "Dieses Fahrzeug ist für deinen Zeitraum leider nicht mehr verfügbar – bitte wähle ein anderes aus.",

      "portal.resume.datesMoved": "Deine Termine lagen in der Vergangenheit – wir haben sie auf den nächstmöglichen Zeitpunkt verschoben.",

      "portal.resume.insuranceReset": "Die von dir gewählte Versicherungsoption wird nicht mehr angeboten – wir haben sie auf die Standardeinstellung zurückgesetzt.",

      "portal.search.area.error": "Bitte wähle einen Standort",

      "portal.search.area.label": "Abholung & Rückgabe",

      "portal.search.area.placeholder": "Bitte wählen",

      "portal.search.cta": "Fahrzeuge anzeigen",

      "portal.search.from": "Von",

      "portal.search.title": "Fahrzeug mieten",

      "portal.search.until": "Bis",

      "portal.sort.priceAsc": "Preis aufsteigend",

      "portal.sort.priceDesc": "Preis absteigend",

      "portal.sort.title": "Sortieren nach",

      "price": "Preis",

      "price.day.short": "Tag",

      "price.details.footnote": "*Fahranfänger ist, wer seine Fahrerlaubnis vor weniger als 24 Monaten erhalten hat. Die vollständige Aufstellung aller Entgelte sind der %s zu entnehmen.",

      "price.details.footnote.url.text": "aktuellen Preisliste",

      "price.distance.100.prefix": "bis 100 km:",

      "price.distance.101.prefix": "ab 101. km:",

      "price.distance.headline": "Fahrtstrecke",

      "price.duration.headline": "Mietdauer",

      "price.duration.headline.mo-fr": "Mietdauer (Mo-Fri)",

      "price.duration.headline.mo-sa": "Mietdauer",

      "price.duration.headline.sa-mo": "Sa, 18:00 - Mo, 08:00",

      "price.duration.headline.sa-so": "Mietdauer (Sa-So)",

      "price.duration.holiday": "Feiertags: %s/Kal.Tag (inkl. 100km)",

      "price.duration.holiday.headline": "Feiertag",

      "price.duration.mo-fr.night.prefix": "21 - 9:30 Uhr:  ",

      "price.duration.mo-fr.prefix": "9:30 - 21 Uhr: %s",

      "price.duration.mo-sa.daily": "Mo-Sa, 8-18 Uhr: %s/Kal.Tag (inkl. 100 km)        ",

      "price.duration.mo-sa.hourly": "Mo-Sa 8 - 20: %s/Std (inkl. 20 km/Std), max. %s/Kal.Tag (inkl. 100 km)",

      "price.duration.mo-sa.night": "Mo-Sa, außerhalb der Öffnungszeiten: %s (inkl. 100km)",

      "price.duration.sa-mo": "Sa, 18 Uhr - Mo, 8 Uhr: %s (inkl. 150 km)",

      "price.duration.sa-so.night.prefix": "Sa, 18 - Mo, 9:30 Uhr:  ",

      "price.duration.sa-so.prefix": "Sa, 9:30 - 18 Uhr:  %s  (1. Std. gratis)",

      "price.extraKm.short": "Extra Km",

      "price.hour.short": "hr",

      "price.insurance.150.prefix": "max. 150€:",

      "price.insurance.1500.prefix": "max. 1.500€: Inkl.",

      "price.insurance.15000.prefix": "max. 15.000€:  inkl.",

      "price.insurance.151.prefix": "max. 150€:",

      "price.insurance.500.prefix": "max. 500€:",

      "price.insurance.501.prefix": "max. 500€:",

      "price.insurance.650.prefix": "max. 650€:  inkl.",

      "price.insurance.750.prefix": "max. 750€:  inkl.",

      "price.insurance.headline": "Selbstbeteiligung (je Schadensfall)",

      "price.insurance.young.headline": "Selbstbeteiligung (Fahranfänger*)",

      "price.km.short": "km",

      "price.return.service.headline": "Rückhol-Service (bei Rückgabe)",

      "price.tank.10.prefix": "Tankstand <10%:",

      "price.tank.25.prefix": "Tankstand <25%: ",

      "price.tank.headline": "Tank-Service (bei Rückgabe)",

      "price.weekend.surcharge.prefix": "Wochenendzuschlag (Fr-So):",

      "pricedetails.basic.title": "Zahle nur, was du verfährst",

      "pricedetails.distancePackages.remaining": "Ab %@. Kilometer",

      "pricedetails.example.day": "Ein Tag (24 Std.)",

      "pricedetails.example.description": "inkl. %s km* und Kraftstoff",

      "pricedetails.example.hour": "Eine Stunde",

      "pricedetails.example.kilometer": "Ein Kilometer",

      "pricedetails.example.kilometer.description": "Inkl. Kraftstoff",

      "pricedetails.example.month": "Ein Monat (28 Tage)",

      "pricedetails.example.title": "Preisbeispiele (inkl. Kraftstoff & Versicherung)",

      "pricedetails.example.value.description": "entspricht %s je Min.",

      "pricedetails.example.value.description.day": "Ø %s €/Kal.Tag",

      "pricedetails.example.value.description.owner": "du verdienst %s",

      "pricedetails.example.week": "Eine Woche",

      "pricedetails.longterm.description.oneday": "inkl. 80 km je 24 Std.*",

      "pricedetails.longterm.footnote": "*Jeder weitere Kilometer bzw. weitere Standzeit wird nutzungsgenau abgerechnet.\n\nDir wird automatisch das günstigste Angebot berechnet. Eine Übersicht aller Entgelte findest du %@.",

      "pricedetails.longterm.footnote.url": "https://get-a-way.com/agb/entgelte-und-gebuehren/",

      "pricedetails.longterm.footnote.url.text": "hier",

      "pricedetails.longterm.tier1.description": "inkl. 80 km* und Kraftstoff",

      "pricedetails.longterm.tier1.title": "Ab dem 1. Tag",

      "pricedetails.longterm.tier1.value.description": "je 24 Std.",

      "pricedetails.longterm.tier2.description": "inkl. 40 km* und Kraftstoff",

      "pricedetails.longterm.tier2.title": "Ab dem 4. Tag",

      "pricedetails.longterm.tier2.value.description": "je 24 Std.",

      "pricedetails.longterm.tier3.description": "inkl. 20 km* und Kraftstoff",

      "pricedetails.longterm.tier3.title": "Ab dem 8. Tag",

      "pricedetails.longterm.tier3.value.description": "je 24 Std.",

      "pricedetails.longterm.title": "Ab %s.",

      "pricedetails.longterm.value.description": "je %s",

      "pricedetails.parking.freeminutes": "%s Min. gratis je km",

      "pricedetails.parking.title": "Standzeit",

      "pricedetails.parking.value": "danach %s je Min.",

      "pricedetails.pricePerKm.title": "Gefahrene Strecke",

      "pricedetails.pricePerKm.value": "%s je km",

      "pricedetails.specialoffers.title": "TAGESRABATTE",

      "pricedetails.title": "Preisinfo",

      "pricing.CharterlinePricing.url": "https://api.get-a-way.com/pricing/5d170e35f892b13d8468f283/pdf",

      "pricing.HagebauMarktPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/58944_Preisliste+Ubeeqo_Hagebaumarkt_A4_v02.pdf",

      "pricing.HeyOBIPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.IkeaInnsbruck.duration.after_first_n_hours": "9:30 - 21:00 Uhr (ab 5. Std): %s/Std",

      "pricing.IkeaInnsbruck.duration.first_n_hours": "9:30 - 21:00 Uhr (1. bis 4. Std): %s/Std",

      "pricing.IkeaInnsbruck.duration.hourly": "9:30 Uhr - 21:00 Uhr: %s/Std",

      "pricing.IkeaInnsbruck.duration.night": "21:00 Uhr - 9:30 Uhr: %s",

      "pricing.IkeaInnsbruck.duration.weekday": "Mietdauer (Mo-Fri)",

      "pricing.IkeaInnsbruck.duration.weekend": "Mietdauer (Sa-So)",

      "pricing.IkeaInnsbruck.duration.weekend.sat": "Sa, 9:30 Uhr - 18:00 Uhr : %s",

      "pricing.IkeaInnsbruck.duration.weekend.sat.after_first_n_hours": "Sa, 9:30 - 18:00 Uhr (ab 5. Std): %s/Std",

      "pricing.IkeaInnsbruck.duration.weekend.sat.first_n_hours": "Sa, 9:30 - 18:00 Uhr (1. bis 4. Std): %s/Std ",

      "pricing.IkeaInnsbruck.duration.weekend.so": "Sa, 18 - Mo, 9:30 Uhr: %s",

      "pricing.IkeaInnsbruckPricing.url": "https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7cf/pdf",

      "pricing.IkeaMainPricing.url": "https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf",

      "pricing.MISSmartPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.MISSmartSpainPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.MISTransporterPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.OBIEmployeesPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_OBI_Employees.pdf",

      "pricing.OBIPublicUsersPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.OBIUsersPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.bubPassenger.distance.101": "ab dem 101. km: %s/km",

      "pricing.bubPassenger.duration.fromDay4": "ab dem 4. Tag: %s €/Tag",

      "pricing.bubPassenger.duration.hourly": "%s/Std (max. %s/Kal.Tag)",

      "pricing.bubPassenger.duration.weekend": "Fr-So: +%s €/Std (max. %s €/Kal.Tag)",

      "pricing.bubTransporter.duration.hourly": "%s/Std (max. %s/Kal.Tag)",

      "pricing.bubTransporter.duration.weekend": "Fr-So: +%s €/Std (max. %s €/Kal.Tag)",

      "pricing.charterline.distance.100": "bis 100km: %s/km",

      "pricing.charterline.distance.101": "ab dem 101. km: %s/km",

      "pricing.charterline.duration.hourly": "%s/Std (max. %s/Kal.Tag)",

      "pricing.charterline.duration.weekend": "Fr-So: +2,00 €/Std (max. 12,00 €/Kal.Tag)",

      "pricing.degressive.distance": "${format:euro(price.driversPricePerKm)}/km (ab dem ${price.firstDiscountedKm}. km nur ${format:euro(price.firstDiscountedPrice)})",

      "pricing.degressive.parking": "${price.freeParkingMinutesPerKm} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.distance": "Fahrtstrecke (inkl. Kraftstoff)",

      "pricing.distance.details": "%s/km",

      "pricing.distance.excess": "Fahrtstrecke (je Mehrkilometer)",

      "pricing.distance.noFuel": "Fahrtstrecke",

      "pricing.duration": "Mietdauer",

      "pricing.duration.hourly": "%s/Std",

      "pricing.expert.distance": "%s/km",

      "pricing.expert.duration": "%s/Std",

      "pricing.expert.duration.hourly": "Mo-Fr 9-19 Uhr, Sa 9-16 Uhr: %s/Std, max. %s/Kal.Tag",

      "pricing.expert.duration.night": "Mo-Sa, 19 Uhr - 9 Uhr: %s",

      "pricing.expert.duration.weekend": "Sa 16:00 Uhr - Mo 09:00 Uhr: %s",

      "pricing.fee.crossBorder": "Auslandsfahrten",

      "pricing.fee.crossBorder.details": "%s pro Tag für erlaubte Länder, max. %s pro Miete",

      "pricing.fee.driver.injury.protection": "Insassenschutz: %s",

      "pricing.fee.driver.protection": "Zusatzleistungen",

      "pricing.fee.noShow": "Stornierungsgebühr",

      "pricing.fee.noShow.details": "Bis zu %s (abhängig von der geplanten Mietdauer)",

      "pricing.fee.return": "Rückbring-Service (bei Rückgabe)",

      "pricing.fee.return.details": "%s + %s/100m",

      "pricing.fee.tank": "Tank-Service (bei Rückgabe)",

      "pricing.fee.tank.fuel.consumption": "geringerer Tankstand: %s je Liter",

      "pricing.fee.tank.low.10": "Tankstand <10%:",

      "pricing.fee.tank.low.25": "Tankstand <25%:",

      "pricing.heyOBI.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.ikea.duration.after_first_n_hours": "ab 5. Stunde: %s/Std",

      "pricing.ikea.duration.first_n_hours": "1. bis 4. Stunde: %s/Std",

      "pricing.insurance": "Selbstbeteiligung (je Schadensfall)",

      "pricing.insurance.table": "max. %s€: %s€/Kal.Tag",

      "pricing.insurance.table.daily": "max. %s€: %s€/KalTag",

      "pricing.insurance.table.free": "max. %s€: inklusive",

      "pricing.insurance.young": "Selbstbehalt (Young Driver)",

      "pricing.longterm.distance": "${format:euro(price.driversPricePerKm)}/km",

      "pricing.longterm.parking": "${price.freeParkingMinutesPerKm} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.longtermanddistance.distance": "${format:euro(price.driversPricePerKm)}/km (ab dem ${price.firstDiscountedKm + 1}. km nur ${format:euro(price.firstDiscountedPrice)})",

      "pricing.longtermanddistance.parking": "${price.freeParkingMinutesPerKm} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.mba.duration": "Mietdauer (Stündlich)",

      "pricing.mba.duration.package": "Mietdauer (Pakete)",

      "pricing.mba.duration.transporter.1day": "1 Tag: %s",

      "pricing.mba.duration.transporter.3days": "3 Tage: %s",

      "pricing.mba.duration.transporter.3days.per_day": "3 Tage: %s/Tag	",

      "pricing.mba.duration.transporter.6hours": "6 Stunden: %s",

      "pricing.mba.duration.transporter.extra_hours": "%s/zusätzliche Stunde",

      "pricing.mba.duration.transporter.hourly": "%s/Stunde",

      "pricing.mba.duration.transporter.hourly_weekend": "+%s/Std (max. %s/Tag)",

      "pricing.mba.duration.weekend": "Wochenendzuschlag (Fr-So):	",

      "pricing.mba.passenger.duration.after.30": "Mietdauer (30 Tage und mehr)",

      "pricing.mba.passenger.duration.before.30": "Mietdauer (Bis 30 Tage)",

      "pricing.mba.passenger.duration.daily": "Tag 1 bis 3: %s/Tag",

      "pricing.mba.passenger.duration.daily.plus3": "Ab Tag 4: %s/Tag",

      "pricing.mba.passenger.duration.daily.plus30": "ab Tag 1: %s/Tag",

      "pricing.mba.passenger.included_distance": "Inklusiv-km: %s km/Tag (%s/Extra-km)",

      "pricing.mba.transporter.distance": "%s/km",

      "pricing.mba.transporter.extra_distance": "Extra-km: %s/km",

      "pricing.mba.transporter.included_distance": "Inklusiv-km: %s km/Std (max. %s km/Tag)",

      "pricing.mis.distance": "inklusive 50 km/24Std. (%s/Mehr-Km)",

      "pricing.mis.duration.after.30": "Mietdauer (mehr 30 Tage)",

      "pricing.mis.duration.before.30": "Mietdauer (von Tag 1 - 30)",

      "pricing.mis.duration.daily": "Tag 1 bis 3:  %s/24Std.",

      "pricing.mis.duration.daily.plus3": "Ab dem 4. Tag: %s/24Std.",

      "pricing.mis.duration.daily.plus30": "ab Tag 1: %s/24Std.",

      "pricing.mis.duration.transporter.hourly": "ab der 4. Stunde:  %s/Std. (max. %s/24Std.)",

      "pricing.mis.duration.transporter.hourly.lt3h": "bis zu 3 Stunden: %s",

      "pricing.mis.spain.daily.plus1": "danach  %s/24Std",

      "pricing.mis.spain.duration.daily": "erste 24Std %s",

      "pricing.mis.transporter.distance": "inklusive 50 km/24Std. (%s/Mehr-Km)",

      "pricing.obi.distance": "%s/ Mehr-Km",

      "pricing.obi.duration.holiday": "An Feiertagen: %s (inkl. 100km)",

      "pricing.obi.duration.hourly": "Mo-Sa, 8-20 Uhr: %s/Std (inkl. 20 km/Std), max. %s/Kal.Tag (inkl. 100 km)",

      "pricing.obi.duration.night": "Mo-Sa, 20 Uhr - 8 Uhr: %s (inkl. 100km)",

      "pricing.obi.duration.weekend": "Sa 20:00 Uhr - Mo 08:00 Uhr: %s (inkl. 150km)",

      "pricing.obiEmployees.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_OBI_Employees.pdf",

      "pricing.obiPublicUsers.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.obiUsers.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.serviceTrip.distance": ".",

      "pricing.serviceTrip.parking": ".",

      "pricing.spp.duration.firstNHours": "Bis 4 Stunden: %s/Std.",

      "pricing.spp.duration.hourly": "Ab 5. Stunde: %s/Std.",

      "pricing.spp.duration.night": "21 Uhr - 9:30 Uhr: %s/Nacht",

      "pricing.spp.duration.weekend": "Sa, 18 Uhr - Mo, 9:30 Uhr: %s",

      "pricing.static.distance": "${price.driversPricePerKm}/km",

      "pricing.static.parking": "${price.freeParkingMinutes} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.title": "Preisangaben",

      "privacy.text": "DEINE DATEN SIND PRIVAT & GESCHÜTZT",

      "privacy.url": "https://get-a-way.com/datenschutz?utm_source=app",

      "profile-account-warning-title": "Nutzerkonto deaktiviert",

      "profile-deposit.warning.btn": "Kaution hinterlegen",

      "profile-deposit.warning.desc": "Um diese Zahlungsmethode freizuschalten, hinterlege bitte jetzt eine einmalige Kaution.",

      "profile.blocked.button.login": "Jetzt anmelden",

      "profile.blocked.msg.cC": "Die Freischaltung deiner Zahlungsmethode ist fehlgeschlagen. Leider können wir dir derzeit keine Alternative anbieten, um die Registrierung abzuschließen.",

      "profile.blocked.msg.creditCheck": "Die Freischaltung deiner Zahlungsmethode ist fehlgeschlagen. Die Bonitätsprüfung ergab keine Übereinstimmung. Leider können wir Ihnen derzeit keine Alternative anbieten, um die Registrierung abzuschließen.\n\nWir bitten, von weiteren Registrierungsversuchen abzusehen.",

      "profile.blocked.msg.d": "Jeder Nutzer darf nur ein Nutzerkonto haben.\n \nBitte melde Dich mit deinem initialen Nutzerkonto an. Falls Du dein Passwort vergessen hast, kannst Du es in der Anmeldemaske zurücksetzen.",

      "profile.blocked.msg.duplicate": "Jeder Nutzer darf nur ein Nutzerkonto haben.\nBitte lösche die doppelten Nutzerkonten und kontaktiere uns im Anschluss.",

      "profile.blocked.msg.f": "Dieses Nutzerkonto ist temporär deaktiviert. Bei Rückfragen kontaktiere bitte unser Service Team.",

      "profile.blocked.msg.fraud": "Jeder Nutzer darf nur ein Nutzerkonto haben. Nach einer internen Prüfung können wir deine Registrierung leider nicht abschließen.\n\nBitte sieh von weiteren Registrierungsversuchen ab.\nFalls die Deaktivierung ein Versehen war, wende dich bitte an unser Serviceteam.\"",

      "profile.blocked.msg.manualApproval": "Dein Nutzerkonto wird gerade von unserem Team geprüft. Wir melden uns, sobald es freigegeben ist.",

      "profile.blocked.msg.manualApprovalFailed": "Wir konnten dein Nutzerkonto nicht freischalten. Bitte wende dich an unseren Kundensupport.",

      "profile.blocked.msg.originalactive": "Jeder Nutzer darf nur ein Nutzerkonto haben.\n\nBitte melden Sie sich mit Ihrem initialen Nutzerkonto an. Falls Sie Ihr Passwort vergessen haben, können Sie es in der Anmeldemaske zurücksetzen.",

      "profile.blocked.msg.pDe": "Die Freischaltung dieser Zahlungsmethode ist fehlgeschlagen. Leider können wir Ihnen derzeit keine Alternative anbieten, um die Registrierung abzuschließen.\n\nWir bitten, von weiteren Versuchen der Registrierung abzusehen.",

      "profile.blocked.msg.pDr": "Leider können wir dir derzeit keine Alternative anbieten, um die Anmeldung abzuschließen.\n\nWir bitten dich, von weiteren Anmeldeversuchen Abstand zu nehmen.",

      "profile.blocked.msg.spam": "Dieses Nutzerkonto ist temporär deaktiviert. Bitte kontaktiere für Rückfragen unser Service Team",

      "profile.blocked.title.d": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.duplicate": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.f": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.fraud": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.manualApproval": "Nutzerkonto wird geprüft",

      "profile.blocked.title.manualApprovalFailed": "Verifizierung abgelehnt",

      "profile.blocked.title.o": "Benutzerkonto deaktiviert",

      "profile.blocked.title.originalactive": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.spam": "Nutzerkonto deaktiviert",

      "profile.blocked.title.undefined": "Nutzerkonto deaktiviert",

      "profile.completed.msg": "Schaue unter \"Log-in Daten\", wo du dich mit welchen Daten anmelden kannst.",

      "profile.completed.org.msg": "Schaue unter \"Log-in Daten\", wo du dich mit welchen Daten anmelden kannst.",

      "profile.completed.org.title": "Registrierung abgeschlossen",

      "profile.completed.title": "Registrierung abgeschlossen",

      "profile.deposit.missing": "Um fortzufahren, hinterlege bitte zunächst eine Kaution.",

      "profile.gdpr.dialog.more": "Mehr zum Datenschutz",

      "profile.gdpr.dialog.msg": "Du kannst hier deine personenbezogenen Daten herunterladen.\n\nZum Schutz deiner Privatsphäre wirst du zunächst gebeten, deine Anfrage zu bestätigen, indem du einen Bestätigungscode eingibst, der dir per E-Mail geschickt wird. Im Anschluss wird der Download gestartet.\n\nBitte beachte, dass es sich um die personenbezogenen Daten im Zusammenhang mit der Nutzung von %s handelt. Etwaige Datenverarbeitungen im Zusammenhang mit anderen Services, sind auf der Datenschutzseite von %s in Erfahrung zu bringen.",

      "profile.gdpr.dialog.request": "Jetzt anfordern",

      "profile.gdpr.dialog.title": "DSGVO-Rechte nach Auskunft und Übertragbarkeit wahrnehmen",

      "profile.gdpr.resend": "Der eingegebene Code ist nicht korrekt.",

      "profile.gdpr.saved": "Datei wurde in Downloads gespeichert.",

      "profile.no.available.tariffs.desc": "Wir können dir keinen passenden Tarif anbieten. Für weitere Fragen wende dich bitte an unseren Support.",

      "profile.no.available.tariffs.title": "Kein Tarif verfügbar",

      "profile.payment.missing": "Um fortzufahren, bitte hinterlege zuerst ein Zahlungsmittel.",

      "profile.payment.type.business": "Business",

      "profile.payment.type.personal": "Privat",

      "profile.schufa.missing": "Um fortzufahren, bitte hinterlege zuerst deine Meldeadresse.",

      "profile.tab.account": "Meine Daten",

      "profile.tab.services": "Log-in-Daten",

      "profile.tx.open.pay": "Betrag begleichen",

      "profile.tx.open.title": "Ausstehende Beträge",

      "profile.under.age.desc": "Für Ihr aktuelles Alter steht derzeit kein passender Tarif zur Auswahl. Bitte versuchen Sie es erneut, sobald Sie 22 Jahre alt werden.",

      "profile.under.age.title": "Young Driver",

      "profile.verify.email.sent": "Bestätigungsmail wurde versendet",

      "profile.wizard.continue": "Registrierung fortsetzen",

      "push.permission": "Bitte aktiviere jetzt App-Mitteilungen",

      "push.permission.details": "Erlaube GETAWAY dir App-Mitteilungen zu senden, um dich über den aktuellen Status deines Autos bzw. deiner Miete informieren zu können.",

      "push.permission.no": "Später",

      "push.permission.title": "Erlaube Mitteilungen",

      "push.permission.yes": "Erlauben",

      "qrCamera.title": "QR-Code scannen",

      "recaptcha.branding": "Diese Seite ist durch reCAPTCHA geschützt.",

      "referFriend.code.error": "Bitte trage einen gültigen Einladungscode ein",

      "refuel": "Betankung",

      "refuel.payment.subTitle": "Bezahlung",

      "refuel.payment.title": "Kreditkarten PIN",

      "refuel.subTitle": "Bitte nimm die GETAWAY-Tankkarte aus dem Handschuhfach und nutze die angezeigte PIN. Die Quittung brauchst du nicht aufzuheben.",

      "refuel.title": "Tanke gratis",

      "remove.cancel.dialog.message": "Bist du sicher, dass du das Fahrzeug deinstallieren willst?",

      "remove.cancel.dialog.title": "Fahrzeug-Deinstallation!",

      "remove.cancel.dialog.yes": "Deinstallieren",

      "remove.view.btn.txt": "Bestätigen",

      "remove.view.description": "Bitte prüfe die Fahrzeugdaten, bevor du die Deinstallation bestätigst.",

      "remove.view.title": "Fahrzeugprüfung",

      "rent.car.driver.gear.restricted": "Du kannst dieses Auto nicht mieten, da deine Fahrerlaubnis nur für Automatikgetriebe gilt.",

      "rent.car.driver.license.baned": "Du hast ein Fahrverbot",

      "rent.car.driver.license.open": "Deine Fahrerlaubnis ist nicht geprüft",

      "rental": "Miete",

      "rental.action.damages": "Schaden melden",

      "rental.action.finish": "Miete beenden",

      "rental.action.fuel": "Tanken",

      "rental.add.damage.wizard.description": "Protokolliere alle aktuellen Mängel, um eventuelle Neuschäden besser identifizieren zu können.",

      "rental.allaround.add": "Rundum-Fotos aufnehmen",

      "rental.allarouund.add": "Rundum-Fotos aufnehmen",

      "rental.backby.button": "Übernehmen",

      "rental.backby.update": "Ändern",

      "rental.backby.update.desc": "Aktuell: %s ",

      "rental.backby.update.other": "anzeigen",

      "rental.backby.update.title": "Rückgabezeit ändern",

      "rental.backby.update.until": "Verfügbar bis",

      "rental.cancel": "Abbrechen",

      "rental.cancel.handover.ok": "Mietvorgang beenden",

      "rental.cancel.handover.title": "Du bist dabei, den aktuellen Vorgang abzubrechen.",

      "rental.carCheck.button": "Fortfahren",

      "rental.carCheck.cancel": "Beenden",

      "rental.carCheck.footnote": "Dies schützt dich im Schadensfalle vor zu hohen Kosten und ist nötig, um den Motor starten zu können.",

      "rental.carCheck.header.desc": "Nimm jetzt je ein Foto aus vier verschiedenen Perspektiven auf, um den Motor starten zu können.",

      "rental.carCheck.header.title": "Rundum-Check",

      "rental.checkBelongings.finish.message": "Bitte achte auf deine persönlichen Sachen, bevor du fortfährst.",

      "rental.checkBelongings.finish.messege": "Bitte achte auf deine persönlichen Sachen, bevor du fortfährst.",

      "rental.checkBelongings.finish.title": "Nichts vergessen?",

      "rental.damage.added": "Der Schaden/Mangel ist um %@ erfolgreich protokolliert worden.",

      "rental.damages.support.ubq.footNote": "Melden Sie einen neuen Schaden, informieren Sie bitte im Anschluss den Vermieter %@",

      "rental.damages.ubq.helpdesk.text": "telefonisch",

      "rental.dialog.service.error": "Bitte wähle den durchgeführten Service und mindestens ein Foto aus.",

      "rental.dongle.end.title": "Miete beenden",

      "rental.dongle.handover.description": "Bitte gehe nun die Checkliste durch, um den Mietvorgang zu beenden",

      "rental.dongle.key.return.description": "Bitte übergebe Fahrzeugschlüssel und -papiere (inkl. der Tankkarte) am Ende deiner Miete einem Stationsmitarbeiter am Express-Schalter. Alternativ wirf diese in den entsprechend ausgeschilderten Nachteinwurf der Station.",

      "rental.dongle.key.return.title": "Schlüssel & Papiere zurückgeben",

      "rental.driving.backBy": "Rückgabezeit",

      "rental.driving.damages.add": "Melden",

      "rental.driving.greeting": "Gute Fahrt!",

      "rental.driving.tank": "Tankstand",

      "rental.extra.F0105.title": "Zusatzfahrer",

      "rental.extra.F3023.title": "Insassenschutz: 10,00 €",

      "rental.finish.button": "Beenden & verriegeln",

      "rental.finish.success": "Dein Mietvorgang ist erfolgreich beendet worden. Habe einen schönen Tag!",

      "rental.fuelScreen.title": "Bargeldlos Tanken",

      "rental.fuelScreen.title.adblue": "AdBlue bargeldlos nachfüllen",

      "rental.fuelSettings.desc": "Tanke bequem & bargeldlos mit der Tankkarte aus dem Handschuhfach an allen Partnertankstellen.",

      "rental.fuelSettings.desc.adblue": "Fülle AdBlue bequem & bargeldlos mit der Tankkarte aus dem Handschuhfach an allen Partnertankstellen nach.",

      "rental.fuelSettings.fuelCard": "Tankkarte: ",

      "rental.fuelSettings.fuelNote": "Keine Premium-Kraftstoffe tanken. Andernfalls können Entgelte fällig werden.",

      "rental.fuelSettings.fuelPin": "PIN:  ",

      "rental.fuelSettings.gasStation.desc": "Bitte vergewissere dich vor dem Tankvorgang, dass die Tankstelle die Tankkarte akzeptiert.",

      "rental.fuelSettings.gasStation.desc.adblue": "Bitte vergewissere dich vor dem Nachfüllen, dass die Tankstelle die Tankkarte akzeptiert und AdBlue an der Zapfsäule oder als Kanister anbietet.",

      "rental.fuelSettings.instruction": "Die Quittung muss nicht aufbewahrt werden.\nIm Anschluss lege bitte die Tankkarte in die dafür vorgesehene Halterung im Handschuhfach zurück.",

      "rental.fuelSettings.navigate": "Karte",

      "rental.fuelSettings.stepOne": "1. Partnertankstelle anfahren",

      "rental.fuelSettings.stepOne.adblue": "1. Partnertankstelle mit AdBlue anfahren",

      "rental.fuelSettings.stepThree": "3. Mit Tankkarte bezahlen",

      "rental.fuelSettings.stepTwo": "2. Kraftstoff tanken (keine Premiumsorte)",

      "rental.fuelSettings.stepTwo.adblue": "2. AdBlue nachfüllen (blauer Deckel neben dem Tankstutzen)",

      "rental.fuelSettings.title": "Kostenlos Tanken",

      "rental.fuelSettings.where": "Wo?",

      "rental.fuelling.amount": "Gesamtkosten",

      "rental.fuelling.chargedToDriver": "Dir berechnet",

      "rental.fuelling.paidByBrand": "Von uns bezahlt – dir nicht berechnet",

      "rental.fuelling.quantity": "Menge",

      "rental.fuelling.station": "Tankstelle",

      "rental.fuelling.title": "Tankvorgang",

      "rental.fuelstation": "Tankestelle",

      "rental.handover.description": "Verriegele das Fahrzeug von außen mit deinem Handy, um die Miete zu beenden.",

      "rental.handover.header": "Danke,",

      "rental.handover.lock.title": "Miete beenden",

      "rental.handover.title": "Miete beenden",

      "rental.history.header": "Miete",

      "rental.history.invoice": "Rechnung zur Miete anzeigen",

      "rental.immobilizer.allaround.msg": "Die Motorsperre wird deaktiviert, sobald die Rundum-Fotos aufgenommen und hochgeladen wurden.",

      "rental.immobilizer.blocked": "Gesperrt",

      "rental.immobilizer.payment.msg": "Dies ist keine Panne. Die Motorsperre ist aufgrund eines Zahlungsproblems aktiviert. Bitte hinterlege eine belastbare Zahlungsmethode und kontaktiere unser Service Team, um den Motor wieder zu entsperren.",

      "rental.immobilizer.title": "Motor-/Wegfahrsperre",

      "rental.insurance.change.error": "Für diese Fahrt ist keine Versicherungsoption verfügbar.",

      "rental.insurance.dialog.button": "VERSICHERUNG ANRUFEN",

      "rental.insurance.dialog.description": "Für unmittelbare Hilfe rufe jetzt bitte unseren Versicherungspartner \"Gothaer Versicherung\" an und beziehe dich auf folgende Versicherungsschein-Nummer:",

      "rental.insurance.dialog.footer": "24/7 Schadenservicecenter unter der Festnetznummer +49 30 5508 81508",

      "rental.insurance.dialog.number": "02.925.777 777",

      "rental.insurance.dialog.number.description": "Versicherungsschein-Nr",

      "rental.insurance.dialog.phone.number": "+4930550881508",

      "rental.insurance.dialog.title": "Soforthilfe",

      "rental.insurance.gothaer.dialog.description": "Für unmittelbare Hilfe rufe jetzt bitte unseren Versicherungspartner \"Gothaer Versicherung\" an und beziehe dich auf folgende Versicherungsschein-Nummer:",

      "rental.insurance.gothaer.dialog.footer": "24/7 Schadenservicecenter unter der Festnetznummer +49 30 5508 81508",

      "rental.insurance.label": "Selbstbeteiligung",

      "rental.insurance.settings.footnote": "Im Schadensfall kann es schnell teuer werden. Begrenze dein Haftungsrisiko und wähle eine %s",

      "rental.insurance.settings.more.url.text": "Selbstbeteiligung",

      "rental.insurances.info.url": "https://getaway.app/insurance",

      "rental.internet.disconnected.message": "Es kann keine Verbindung hergestellt werden. Bitte stelle sicher, dass du online bist. Bei Schwierigkeiten kontaktiere bitte unser Service Team.",

      "rental.internet.disconnected.title": "Keine Internetverbindung",

      "rental.keyOut.button.title": "Ich habe den Autoschlüssel",

      "rental.keyless.engine.dialog.message": "Stell den Motor ab, um das Fahrzeug zu ver- oder entriegeln.",

      "rental.keyless.engine.dialog.title": "Motor läuft",

      "rental.keyless.key.dialog.message": "Dieses Fahrzeug benötigt keinen Schlüssel. Öffnen und Schließen funktioniert über die App, die Zündung über den Start-Stopp-Button.",

      "rental.keyless.lock": "Verriegeln",

      "rental.keyless.offline.body": "Ohne Internet steuerst du die Zentralverriegelung per Bluetooth. Dafür müssen folgende Punkte erfüllt sein. Infos zum Telefon-Support findest du am Ende dieser Liste.",

      "rental.keyless.offline.connected": "Alle Voraussetzungen sind erfüllt. Du kannst das Fahrzeug über Bluetooth steuern:",

      "rental.keyless.offline.finish.message": "Aktiviere deine Internetverbindung oder kontaktiere den Support um deine Miete zu beenden.",

      "rental.keyless.offline.pin": "PIN",

      "rental.keyless.offline.step.connected.hint": "Geh näher an das Fahrzeug (max. 5 m), damit sich die App verbinden kann.",

      "rental.keyless.offline.step.connected.title": "Verbindung zum Fahrzeug hergestellt",

      "rental.keyless.offline.step.enabled.hint": "Aktiviere Bluetooth in den Systemeinstellungen oder im Kontrollzentrum.",

      "rental.keyless.offline.step.enabled.title": "Bluetooth auf dem Handy aktiviert",

      "rental.keyless.offline.step.permission.hint": "Öffne **Einstellungen › Bluetooth** und erlaube den Zugriff.",

      "rental.keyless.offline.step.permission.title": "Bluetooth für diese App freigegeben",

      "rental.keyless.offline.support": "Support",

      "rental.keyless.offline.title": "Kein-Internet-Modus",

      "rental.keyless.unlock": "Entriegeln",

      "rental.opened.damages.title": "Schadenprotokoll",

      "rental.opened.dongle.continue": "Weiter",

      "rental.opened.header.desc": "Wenn das Fahrzeug keine neuen Schäden aufweist, dann starte jetzt den Motor.",

      "rental.opened.header.title": "Starte den Motor",

      "rental.opened.instruction": "Bitte den Schlüssel der Halterung entnehmen.",

      "rental.opened.key.option": "Wo finde ich den Fzg-Schlüssel?",

      "rental.opened.troubleshoot.door": "Türen verschlossen?",

      "rental.opened.troubleshoot.engine": "Motor startet nicht?",

      "rental.opened.troubleshoot.key": "Wo finde ich den Schlüssel?",

      "rental.opened.troubleshoot.options": "Optionen",

      "rental.opened.troubleshoot.title": "Können wir helfen?",

      "rental.opened.troubleshoot.unblock": "Freischalten",

      "rental.opened.troubleshoot.unlock": "Entriegeln",

      "rental.opened.video.description": "Die Schlüsselhalterung befindet sich im Handschuhfach.",

      "rental.opened.video.title": "Entnehme den Schlüssel",

      "rental.parking.findCar": "Finde mein Auto",

      "rental.prompty.end": "Miete beenden",

      "rental.rate.negative": "NEIN",

      "rental.rate.positive": "JA",

      "rental.rate.title": "Hat dir das Auto gefallen?",

      "rental.refuel.warning": "Vor Rückgabe bitte mit bereitgestellter Tankkarte tanken. Andernfalls können Gebühren anfallen.",

      "rental.reserved.desc.connected": "Mit dem Entriegeln startest du den kostenpflichtigen Mietvorgang.",

      "rental.reserved.desc.disabled": "Aktiviere Bluetooth, um das Fahrzeug mit deinem Handy zu entriegeln.",

      "rental.reserved.desc.searching": "Gehe jetzt zum Fahrzeug, um es mit deinem Handy zu entriegeln.",

      "rental.reserved.header.connected": "Bitte entriegeln",

      "rental.reserved.header.disabled": "Aktiviere Bluetooth",

      "rental.reserved.header.searching": "Verringere die Distanz ",

      "rental.reserved.location.enable": "Erlaube Zugriff auf Standort",

      "rental.returnlocation": "Rückgabeort",

      "rental.returntime.late": "%@ zu spät",

      "rental.review.negative.notification": "Vielen Dank für dein Feedback...",

      "rental.section.booked": "Gebucht",

      "rental.section.locked": "Verriegelt",

      "rental.section.reserved": "Reserviert",

      "rental.section.return": "Rückgabe",

      "rental.section.unlocked": "Entriegelt",

      "rental.service.note": "Zusätzlicher Hinweis (optional)",

      "rental.service.report.button": "Servicebericht absenden",

      "rental.service.report.submit.success": "Dein Bericht wurde übermittelt",

      "rental.service.report.title": "Servicebericht",

      "rental.settings.insurance.more": "Mehr Infos zur Selbstbeteiligung",

      "rental.settings.insurance.title": "Reduziere deine Selbstbeteiligung!",

      "rental.settings.title": "Mieteinstellung",

      "rental.slider.lock": "Verriegeln & beenden",

      "rental.slider.unlock": "Miete starten",

      "rental.startEngine.decr": "Sofern das Auto keine neuen Schäden (siehe Schadensprotokoll) aufweist, starte bitte jetzt den Motor. Hab eine sichere Fahrt!",

      "rental.startEngine.title": "Starte jetzt den Motor!",

      "rental.status": "Status",

      "rental.title": "Miete %s",

      "rental.vehicle.booking.link": "Verfügbarkeit",

      "rental.vehicle.booking.prelink": "Nächste Buchung in %s ,",

      "rental.walkthrough.button": "Ok",

      "rental.walkthrough.page1.description": "Im Schadensfall kann es schnell teuer werden. Wähle deine gewünschte Haftungsbegrenzung (Selbstbeteiligung) bevor du das Fahrzeug mit deinem Handy entriegelst.",

      "rental.walkthrough.page1.title": "Reduziere deine Selbstbeteiligung",

      "rental.walkthrough.page2.description": "Bringe das Fahrzeug in die farblich hervorgehobene Rückgabezone mit einem Tankstand von mind. 25% zurück und verriegele es mit deinem Handy.\n\nNeu: Möchtest du, dass wir das Fahrzeug zurückzubringen? Dann wähle am Ende der Miete einfach den bequemen Rückbring-Service iHv. nur 10€ + 0,49€ je 100m.",

      "rental.walkthrough.page2.title": "Zurückbringen und Miete beenden",

      "rental.walkthrough.page3.description": "In unseren Fahrzeugen ist das Rauchen und Vapen u.a. zum Schutz nachfolgender Nutzer untersagt. Um die Einhaltung des Rauchverbots sicherzustellen und Verstöße auch mittels Vertragsstrafen zu ahnden, sind die Fahrzeuge mit Rauchsensoren ausgestattet.",

      "rental.walkthrough.page3.title": "Rauchen und Vapen verboten",

      "rental.warning.carvaloo.button": "Zustand erfassen",

      "rental.warning.carvaloo.msg": "Bitte erfasse den Zustand des Fahrzeugs. Bitte beachte, dass ohne Mitwirkung der Versicherungsschutz riskiert wird.",

      "rental.warning.carvaloo.title": "Schadensereignis erkannt",

      "required": "Bitte ausfüllen.",

      "resend": "Erneut senden",

      "reserve.btn.blocked": "in Wartung",

      "reserve.btn.unavailable": "Bereits gebucht",

      "reset": "Zurücksetzen",

      "reset.password.button.title": "Aktualisieren",

      "reset.password.desc": "Bitte gib die E-Mail-Adresse an, mit der du dich registriert hast. Wir senden dir im Anschluss eine E-Mail zum Zurücksetzen deines Passworts.",

      "reset.password.placeholder": "Neues Passwort",

      "reset.password.title": "Passwort ändern",

      "reset.password.updated": "Dein Passwort wurde aktualisiert.",

      "returncar.apply": "JETZT FREIGEBEN",

      "returncar.cancel": "Auto jetzt nicht freigeben",

      "returncar.title": ", wann möchtest du dein Auto wieder?",

      "review": "Bewertung",

      "review.dialog.later": "Nicht jetzt 😒",

      "review.dialog.message": "Wenn dir unsere App gefällt, schreibe uns bitte eine Bewertung.\n\nDamit hilfst du, mehr Nutzer für nachhaltige Mobilität zu begeistern 🙏",

      "review.dialog.no": "Feedback",

      "review.dialog.title": "⭐⭐⭐⭐⭐",

      "review.dialog.yes": "Ja, gefällt mir 😃",

      "route.dialog.applemaps": "Apple Maps",

      "route.dialog.copy": "Adresse kopieren",

      "route.dialog.googlemaps": "Google Maps",

      "salutation": "Anrede",

      "save": "Speichern",

      "schufa.address": "ADRESSE",

      "schufa.button.title": "Übernehmen",

      "schufa.dateOfBirth.dateFormat": "Tag / Monat / Jahr",

      "schufa.dateOfBirth.label": "Mein Geburtstag (TT/MM/JJJJ)",

      "schufa.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> \n\n<hr style=\"border: 0.5px solid #0000001f;\"> \n\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWas ist das SEPA-Lastschriftverfahren?</summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nDas SEPA-Lastschriftverfahren ist ein sicheres und bequemes Zahlungsverfahren, bei dem Rechnungsbeträge direkt von deinem Bankkonto abgebucht werden. Es wird als besonders verbraucherfreundlich eingestuft, da du einer autorisierten SEPA-Lastschrift innerhalb von acht Wochen nach Belastung widersprechen kannst und dein Geld zurückerhältst.\n</p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> \n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWarum kann ich kein anderes Land auswählen? </summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nUm die Registrierung abzuschließen, muss deine aktuelle Meldeadresse in dem Land liegen, das in der Länderauswahl aufgelistet ist. Bist du derzeit in einem anderen Land gemeldet, kannst du die Registrierung nicht fortführen. </p> \n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> \n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWie wird die Zahlungswahrscheinlichkeit geprüft? </summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nUm das SEPA-Lastschriftverfahren als Zahlungsmethode freizuschalten, muss im Vorfeld einer Bonitätsprüfung zugestimmt werden. Hierzu findet ein Abgleich mit der Datenbank der SCHUFA statt. Du kannst der Einwilligung jederzeit mit Wirkung für die Zukunft widersprechen. </p> \n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> ",

      "schufa.instruction": "Gib bitte deine aktuelle Meldeadresse an, um das Lastschriftverfahren freizuschalten.",

      "schufa.notification.message": "😥 Unser Zahlungsmittelanbieter kann leider kein SEPA-Mandat für dich einrichten. Bitte wähle eine alternative Zahlungsmethode. Wir arbeiten bereits an weiteren Alternativen.",

      "schufa.notification.title": "Zahlungsmethode freischalten",

      "schufa.personalInfo": "PERSÖNLICHE INFORMATIONEN",

      "schufa.title": "Deine Meldeadresse",

      "schufaCheck.dialog.message": "😥 Unser Zahlungsmittelanbieter kann leider kein SEPA-Mandat für dich einrichten. Bitte wähle eine alternative Zahlungsmethode. Wir arbeiten bereits an weiteren Alternativen.",

      "schufaCheck.dialog.title": "Zahlungsmittel-Freigabe",

      "schufaCheck.dialog.yes": "OK",

      "screen.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeCockpit_compressed.png",

      "screen.damage.option1": "Orange",

      "screen.damage.option2": "Rot",

      "screen.damage.option3": "Ich weiß es nicht",

      "screen.damage.picker.holder": "Farbe",

      "screen.damage.title": "Kontrollleuchte melden",

      "seconds.short": "Sek.",

      "select.bank.card.desc": "IBAN nicht im Kopf? Hinterlege deine Bankdaten einfach und sicher über dein Online-Banking.",

      "select.bank.card.title": "Bank aus Liste wählen",

      "select.bank.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> \n\n<hr style=\"border: 0.5px solid #0000001f;\"> \n\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWas ist das SEPA-Lastschriftverfahren?</summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nDas SEPA-Lastschriftverfahren ist ein sicheres und bequemes Zahlungsverfahren, bei dem Rechnungsbeträge direkt von deinem Bankkonto abgebucht werden. Es wird als besonders verbraucherfreundlich eingestuft, da du einer autorisierten SEPA-Lastschrift innerhalb von acht Wochen nach Belastung widersprechen kannst und dein Geld zurückerhältst.\n</p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> \n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWarum sollte ich mich über mein Online-Banking anmelden?</summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nMit der Online-Banking-Methode schützen wir dein Konto vor Missbrauch und erleichtern es dir, deine Bankverbindung für das Lastschriftverfahren zu hinterlegen.<br><br>So einfach geht's:<br>\n1. Klicke auf \"Meine Bank wählen\"<br>\n2. Wähle deine Bank aus der Liste und melde dich an<br>\n3. Erlaube, dass deine Bankverbindung geteilt wird<br><br>\nMit deiner Erlaubnis werden ausschließlich deine IBAN und BIC, der Kontoinhaber und der Umstand, dass du dich erfolgreich authentifiziert hast, geteilt.\n</p> \n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> \n",

      "select.bank.footnote": "Wenn deine Bank nicht aufgeführt ist, kannst du alternativ deine %s",

      "select.bank.footnote.url": "https://www.google.com/",

      "select.bank.footnote.url.text": "IBAN manuell eingeben",

      "select.bank.manual.desc": "Gib deine IBAN manuell ein, um das Lastschriftverfahren einzurichten.",

      "select.bank.manual.title": "Manuell hinterlegen",

      "selectPayment.desr": "Hinterlege dein gewünschtes Zahlungsmittel, um deine Registrierung abzuschließen. ",

      "selectPayment.sepaCard.text": "Lastschrift hinzufügen",

      "selectPayment.title": "Zahlungsmittel hinzufügen",

      "selectPayment.visaCard.text": "Visa oder MasterCard hinzufügen",

      "selfie.add.button": "Video (3 Sekunden) aufnehmen",

      "sepaIbanMismatch.desc": "Wir haben die Verifizierungszahlung von einem anderen Bankkonto erhalten. Sollen wir deine Bankverbindung entsprechend aktualisieren?",

      "sepaIbanMismatch.retry.desc": "Führe die Verifizierungszahlung von diesem Bankkonto aus, um es zu bestätigen",

      "sepaIbanMismatch.retry.title": "Beibehalten und Verifizierungszahlung wiederholen",

      "sepaIbanMismatch.title": "Wähle deine Bankverbindung",

      "sepaIbanMismatch.use.title": "Meine Bankverbindung aktualisieren",

      "sepaVerification.bankTransfer.cta": "Fertig",

      "sepaVerification.bankTransfer.unavailable": "Banküberweisung ist derzeit nicht verfügbar, bitte zahle online.",

      "sepaVerification.bankTransfer.verified": "Bankkonto verifiziert",

      "sepaVerification.card.desc.md": "Bitte führe eine 1-Euro-Testüberweisung von dem oben genannten Bankkonto durch. Der Betrag wird umgehend wieder erstattet.",

      "sepaVerification.card.title": "1-Euro-Verifizierung",

      "sepaVerification.cta": "Zur 1-Euro-Überweisung",

      "sepaVerification.desc": "Um dein Bankkonto zu bestätigen, führe bitte eine 1-Euro-Zahlung von dem angegebenen Bankkonto durch. Der Betrag wird sofort erstattet.",

      "sepaVerification.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Warum muss ich eine Verifizierungszahlung vornehmen? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Wir möchten deine Bankdaten schützen. Deshalb solltest du Bankdaten nur für Lastschriftvorgänge speichern können, für die der Zugriff verifiziert wurde. Wenn die IBAN übereinstimmt, kann sie verwendet werden. </p> </details><hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Wird der Betrag zurückerstattet? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Ja, der zur Bestätigung deines Bankkontos überwiesene Betrag wird sofort zurückerstattet. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Was passiert, wenn die IBAN nicht übereinstimmt? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Wenn verifizierte Bankdaten erforderlich sind, muss die hinterlegte IBAN mit der IBAN des Kontos übereinstimmen, von dem aus die Verifizierungszahlung getätigt wurde. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n",

      "sepaVerification.footnote.secure.text": "Verifiziere dein Bankkonto sicher und sofort, um einen reibungsloseren und zuverlässigeren Zahlungsvorgang zu gewährleisten.",

      "sepaVerification.method.bankTransfer.desc": "Zahle den voll erstattungsfähigen Betrag von %s per SEPA-Überweisung.",

      "sepaVerification.method.bankTransfer.title": "Verifizierung innerhalb von 1–2 Werktagen",

      "sepaVerification.method.header": "Bitte wähle eine Verifizierungsmethode",

      "sepaVerification.method.link.badge": "Empfohlen",

      "sepaVerification.method.link.desc": "Zahle den voll erstattungsfähigen Betrag von %s über Trustly oder Klarna.",

      "sepaVerification.method.link.title": "Sofort verifizieren",

      "sepaVerification.title": "Bankverbindung bestätigen",

      "service.TIL.desc": "teilAuto ist mit über 2.500 Fahrzeugen in 30 Städten das bedeutendste Carsharing-Angebot für Sachsen, Sachsen-Anhalt und Thüringen.",

      "service.TIL.provider": "teilAuto eG",

      "service.TIL.title": "teilAuto",

      "service.account": "Kundenkonto",

      "service.agb": "AGB",

      "service.bnd.org.note": "Sobald alle geforderten Daten eingetragen und geprüft wurden, wirst du nach erfolgreicher Freischaltung per E-Mail benachrichtigt.",

      "service.button.text": "Auftrag annehmen",

      "service.ctf.desc": "cityflitzer ist mit über 150 Fahrzeugen der erste Freefloating-Carsharer in Leipzig für spontane Fahrten von A nach B. Logge dich nach erfolgter Freischaltung einfach mit deiner Kundennummer und dem bei der Registrierung gewählten Passwort ein.",

      "service.ctf.provider": "Mobility Center GmbH",

      "service.ctf.title": "cityflitzer",

      "service.customer.number": "Kundennummer",

      "service.customer.pin": "PIN (Entriegeln)",

      "service.data": "Datenschutzerklärung",

      "service.email": "E-Mail",

      "service.imprint": "Impressum",

      "service.info": "Anbieterinformationen",

      "service.info.desc": "Beschreibung",

      "service.info.provider": "Anbieter",

      "service.login": "Log-in",

      "service.login.section": "Zugangsdaten",

      "service.map.filter.apply": "Auf Karte anzeigen",

      "service.mobi": "Zurück zu MOBIcar",

      "service.payment": "Zahlungsprofil",

      "service.report.accomplished": "Ich habe Services durchgeführt",

      "service.report.image.note": "Auf mindestens einem Foto muss das Kennzeichen zu erkennen sein.",

      "service.report.noService.note": "Zusätzliche Notizen",

      "service.reserved.services.title": "Angefragte Aufträge",

      "service.start.button": "Auftrag starten",

      "service.started.finish.button": "Auftrag abschließen",

      "service.started.services.title": "Angefragte Aufträge",

      "service.status": "Status",

      "service.status.locked": "Nicht freigeschaltet",

      "service.status.locked.note": "Entweder fehlen noch Daten für eine erfolgreiche Freischaltung oder es besteht bereits ein Nutzerkonto.",

      "service.tab.all": "Alle",

      "service.tab.thisWeek": "Woche",

      "service.tab.thisweek": "Woche",

      "service.tab.today": "Heute",

      "service.tab.tomorrow": "Morgen",

      "service.tariff": "Tarif",

      "service.tariff.mainPartnerTerminated": "Freischaltung fehlgeschlagen. Bitte kontaktiere den einladenden Inhaber des Hauptkontos.",

      "service.tariff.maxPartnersExceeded": "Es können keine weiteren Tarifpartner erstellt werden.\nBitte kontaktiere den Support für weitere Informationen.",

      "service.title": "Service-Fahrt",

      "service.type.basicBranding": "Autosticker",

      "service.type.basicCarPhotos": "Fotos für Autoprofil",

      "service.type.basicDamageRecords": "Schadensakte",

      "service.type.batteryChangeOpening": "Batteriewechsel (mit Notfallöffnung)",

      "service.type.batteryChangeSimple": "Batteriewechsel (einfach)",

      "service.type.batteryCharge": "Batterie laden",

      "service.type.cleanOutsideDry": "Außenreinigung (trocken)",

      "service.type.comboPremium": "comboPremium",

      "service.type.comboPro": "Paket \"Komplettpflege\"",

      "service.type.comboRefuelWashInside": "Paket \"Tanken & Innenreinigung\"",

      "service.type.comboRefuelWashOutside": "Package \"Refuel & Clean outside\"",

      "service.type.comboRefuelWashTotal": "Package \"Refuel & Total Clean\"",

      "service.type.dashboardCleaning": "Lüftungsschlitze und Ablagen intensiv reinigen",

      "service.type.desinfektion": "Desinfektion",

      "service.type.exchangeFuelCard": "Tankkarte wechseln",

      "service.type.extra10min": "Sonderreinigungszeit, je 10 Min",

      "service.type.grillCleaning": "Kühlergrill-Reinigung",

      "service.type.highGlossFinish": "Hochglanz-Finish mit Lackversiegelung",

      "service.type.noService": "Ich habe keinen Service durchgeführt",

      "service.type.otherBasicService": "Sonstiger Service",

      "service.type.refuel": "Betankung",

      "service.type.relocate": "Verlegungsfahrt",

      "service.type.relocation": "Verlegungsfahrt",

      "service.type.rimsCleaning": "Felgen-Intensivpflege",

      "service.type.safetyCheck": "Safety-Check",

      "service.type.tirePressure": "Reifendruck",

      "service.type.vacuumCleaning": "Kofferraum und Fußmatten intensiv saugen",

      "service.type.washInside": "Innenreinigung",

      "service.type.washOutside": "Außenreinigung (nass)",

      "service.type.windshieldFluidRefill": "Auffüllen des Scheibenwischwassers",

      "services.item.subTitle": "Wasch-Mein-Auto Serviceauftrag",

      "services.map.filter.apply": "Auf Karte anzeigen",

      "settings": "Einstellungen",

      "settings.addPaymentMethod.googlePay": "Google Pay",

      "settings.addPaymentMethod.payIn": "Vorkasse freischalten",

      "settings.addPaymentMethod.paypal": "PayPal hinzufügen",

      "settings.addPaymentMethod.sepa": "Lastschrift",

      "settings.addPaymentMethod.sepa.disabled": "Aktuell nicht verfügbar",

      "settings.addPaymentMethod.visa": "Kredit-/Debitkarte hinzufügen",

      "settings.address.footnote": "Mit dem Bearbeiten meiner Adressangaben stimme ich einer etwaigen %s zur Identitätsprüfung zu.",

      "settings.address.footnote.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "settings.address.footnote.url.text": "Datenprüfung",

      "settings.address.org.text": "Geschäftsadresse hinzufügen",

      "settings.circles.data": "EXKLUSIVE NUTZERKREISE",

      "settings.circles.data.add": "Nutzerkreis beitreten",

      "settings.consents": "Einwilligungen",

      "settings.email.update.success": "Danke, deine E-Mail-Adresse ist aktualisiert worden.",

      "settings.gdpr": "Meine Daten anfordern",

      "settings.login.data": "KONTODATEN",

      "settings.login.data.driverslicense": "FAHRERLAUBNIS",

      "settings.login.data.email.edit": "Tippe, um deine E-Mail-Adresse zu ändern",

      "settings.login.data.email.facebook": "Verbinde deinen Facebook-Account",

      "settings.login.data.facebook.dest": "Verbinde deinen Facebook-Account und nutze der 1-Klick Login. Wir posten nichts auf Facebook ohne deinen ausdrücklichen Wunsch!",

      "settings.login.data.moreactions": "WEITERE EINSTELLUNGEN",

      "settings.login.data.notifications": "Benachrichtigungen",

      "settings.login.data.notifications.change": "Verwalte deine Benachrichtigungen",

      "settings.login.data.password": "Passwort zurücksetzen",

      "settings.login.data.password.edit": "Tippe, um dein Passwort zu ändern",

      "settings.login.data.pin": "PIN (Entriegeln)",

      "settings.login.data.terminate": "Konto entfernen",

      "settings.login.data.touchId": "Touch/Face ID",

      "settings.login.data.touchId.edit": "Login mit Touch/Face ID",

      "settings.login.data.user.add.address.text": "Meldeadresse hinzufügen",

      "settings.login.data.user.add.phone.text": "Handy-Nummer hinzufügen",

      "settings.login.data.user.address.disabled.text": "Für Änderungen kontaktiere bitte unser Service Team",

      "settings.login.data.user.address.text": "Tippe, um deine Adresse zu ändern",

      "settings.login.data.user.info.text": "Für Änderungen kontaktiere bitte unser Service Team",

      "settings.login.data.user.phone.text": "Tippe, um deine Handy-Nummer zu ändern",

      "settings.logout": "Abmelden",

      "settings.notification": "Benachrichtigung",

      "settings.org.data": "GESCHÄFTSDATEN",

      "settings.org.personal.data": "PERSÖNLICHE DATEN",

      "settings.payIn.open": "Diese Zahlungsart kann nicht genutzt werden, bis die Identitätsprüfung abgeschlossen ist. Bitte kontaktiere unseren Support.",

      "settings.payIn.status.open.message": "Bitte füge deinen Personalausweis hinzu, um Zahlung per Vorkasse nutzen zu können.",

      "settings.payment.data": "ZAHLUNGSPROFILE",

      "settings.payment.data.add": "Zahlungsmittel hinzufügen",

      "settings.payment.footnote": "Mit der Auswahl des SEPA-Lastschriftverfahrens willige ich der Verarbeitung meiner Daten zur %s ein.",

      "settings.payment.footnote.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_smp/WL_DataPrivacy-DATA_Checks-de+02_2024.pdf",

      "settings.payment.footnote.url.text": "Prüfung der Zahlungswahrscheinlichkeit",

      "settings.payment.payIn.title": "Zahlung per Vorkasse",

      "settings.payment.paypal.title": "PayPal hinzufügen",

      "settings.payment.profile.add": "Zahlungsprofil hinzufügen",

      "settings.payment.sepa.title": "Lastschrift hinzufügen",

      "settings.payment.sepa.url": "https://google.com",

      "settings.permission": "Berechtigung erforderlich",

      "settings.personal.data": "PERSÖNLICHE DATEN",

      "settings.select.tariff": "Tarif wählen",

      "settings.selectedPayment.payIn.title": "Vorkasse",

      "settings.tariff": "Tarif %s",

      "settings.tariff.6654adffda9d82661df73dcb.name": "cityflitzer",

      "settings.tariff.66574cfe7dfac60795ffa1bc.name": "cityflitzer",

      "settings.terminate.info": "Bitte kontaktiere unser Service Team, um dein Konto löschen zu lassen.",

      "settings.terminate.no": "Abbrechen",

      "settings.terminate.yes": "Kontakt",

      "settings.title": "EINSTELLUNGEN",

      "settings.upload.camera": "Foto aufnehmen",

      "settings.upload.file": "Datei auswählen",

      "settings.upload.title": "Dokument zur Prüfung hochladen",

      "settings.uploadDoc": "Dokument hochladen",

      "settled": "Beglichen",

      "share.car.message": "Schau dir dieses Auto bei GETAWAY an: %@ %@, ab %@/km bzw. %@/Tag inkl. Versicherung und Benzin https://applink.get-a-way.com/map?id=%@",

      "share.car.subject": "Ich habe ein Auto für dich gefunden",

      "share.panel.description": "Teile deinen Einladungslink",

      "share.panel.title": "Du willst mehr Autos?",

      "shortcut.release": "Mein Auto freigeben",

      "shortcut.release4hours": "Mein Auto für 4 Std. freigeben",

      "signup.booking.invitation.footnote": "Nimmst du die Einladung an, wird deine E-Mail-Adresse und das Datum der Freischaltung mit dem Einladenden geteilt.",

      "signup.booking.invitation.prefix": "Sie wurden als Zusatzfahrer eingeladen von",

      "signup.button.title": "Jetzt gratis registrieren",

      "signup.card.org.desc": "zB. GmbH, AG, e.V., Gmbh & Co KG, KG, OHG",

      "signup.card.org.title": "Als Organisation",

      "signup.company.name.placeholder": "Firmenname (ohne Rechtsform)",

      "signup.country.label": "Land",

      "signup.desc": "Melde dich jetzt gratis an und starte deine erste Miete in wenigen Minuten.",

      "signup.desc.noBonus": "Melde dich jetzt gratis an und starte deine erste Miete.",

      "signup.description": "melde dich jetzt gratis bei GETAWAY an und erhalte %@.",

      "signup.description.highlight": " 5€ Startguthaben ",

      "signup.dialog.ownsACar.message": "Die Info hilft uns, unsere Services für dich zu verbessern.",

      "signup.dialog.ownsACar.title": "Hast du ein Auto?",

      "signup.domain.dialog.confirm": "Bestätigen",

      "signup.domain.dialog.message": "Bitte prüfe deine E-Mail-Adresse.",

      "signup.email.org.placeholder": "E-Mail (dienstlich)",

      "signup.email.placeholder": "E-Mail",

      "signup.facebook.complete.placeholder": "VERVOLLSTÄNDIGEN",

      "signup.facebook.dateofbirth.placeholder": "Geburtstag",

      "signup.facebook.email.placeholder": "E-Mail",

      "signup.facebook.firstname.placeholder": "Vorname",

      "signup.facebook.lastname.placeholder": "Nachname",

      "signup.facebook.picker.mr": "Herr",

      "signup.facebook.picker.mrs": "Frau",

      "signup.facebook.picker.ms": "Frau",

      "signup.facebook.title": "VIA FACEBOOK ANMELDEN",

      "signup.facebook.title.placeholder": "Anrede",

      "signup.fees.text": "Entgelte & Gebühren",

      "signup.footnote.login.action": "Login",

      "signup.footnote.login.text": "Du hast ein Nutzerkonto?",

      "signup.footnote.secure.text": "Sichere und verschlüsselte Datenübertragung",

      "signup.header": "Jetzt registrieren",

      "signup.individual.dialog.btn": "» Zur Registrierung als Einzelperson",

      "signup.individual.dialog.msg": "Bitte nutze in diesem Falle die Registrierung als Einzelperson.",

      "signup.individual.org.desc": "zB. Einzelunternehmer, GbR, eK, UG",

      "signup.individual.org.title": "Als Einzelunternehmer oder Mitglied einer GbR",

      "signup.invitation.footnote": "Nehme die Einladung an, wird deine E-Mail-Adresse und das Datum der Freischaltung mit dem Einladenden geteilt.",

      "signup.invitation.header": "Registriere dich als Tarifpartner",

      "signup.invitation.prefix": "Du wurdest eingeladen von",

      "signup.invitation.remove.cancel": "Abbrechen",

      "signup.invitation.remove.confirm": "Bestätigen",

      "signup.invitation.remove.message": "Nachricht entfernen",

      "signup.invitation.remove.title": "Entfernen",

      "signup.invite.circleCard.text": "Schließ dich einem unserer exklusiven Nutzerkreise an und erhalte besonderen Zugang zu Fahrzeugen und Preisen!",

      "signup.invite.code.seleted.text": "Erhalte jetzt dein %@ Startguthaben von %@ !",

      "signup.invite.title": "Ich bin eingeladen worden (optional)",

      "signup.legal.other.placeholder": "Andere",

      "signup.legal.type.placeholder": "Rechtsform",

      "signup.md.widget.success": "Bitte fahre mit deiner Registrierung fort.\n\nFalls sich kein neues Browser-Fenster geöffnet hat, klicke auf \"Registrieren fortfahren\".\n\nAlternativ kannst du den Link manuell in die Adresszeile deines Browsers kopieren.",

      "signup.name.placeholder": "Vorname",

      "signup.name.policy.text": "Datenschutzerklärung",

      "signup.name.terms.text": "Mit deiner Registrierung akzeptiere ich die AGB und Datenschutzerklärung von GETAWAY.",

      "signup.name.termsservice.text": "AGB",

      "signup.org.desc": " ",

      "signup.org.director.header": "Und nun zu deiner Person. Bitte wählen:",

      "signup.org.header": "Als Geschäftskunde registrieren",

      "signup.org.info": "Angaben zu deiner Organisation",

      "signup.org.manual.link": "» Nicht dabei? Manuell eingeben",

      "signup.org.search.button": "Suchen",

      "signup.org.search.header": "Ok, lass uns deine Organisation finden",

      "signup.org.search.placeholder": "Firmenname inkl. Rechtsform (zB. Firma GmbH)",

      "signup.org.type.header": "Welche Rechtsform hat deine Organisation?",

      "signup.password.placeholder": "Passwort",

      "signup.personal.section": "Angaben zu deiner Person",

      "signup.policy.cancel": "Abbrechen",

      "signup.register.location.placeholder": "Registergericht",

      "signup.register.nr.placeholder": "Register-Nr",

      "signup.terms.text": "Ich akzeptiere die %s und %s von %s.",

      "signup.terms.url": "https://getaway.app/terms",

      "signup.terms.url.text": "AGB",

      "signup.title": "Hi,",

      "signup.type.company": "Als Geschäftskunde registrieren",

      "signup.type.dialog.bnd": "book-n-drive",

      "signup.type.dialog.bnd.link": "https://web.book-n-drive.de/registration/pid/575",

      "signup.type.dialog.cf": "cityFlitzer",

      "signup.type.dialog.cf.link": "https://de1.cantamen.de/pub/okw/form?orgnr=125&package=&authKey=77f2663b-3e06-84d7-9dfb-a521724124f4&product=firm-jp-wok",

      "signup.type.dialog.title": "Als Geschäftskunde registrieren",

      "signup.type.org": "Als Geschäftskunde registrieren",

      "signup.type.private": "Als Einzelperson registrieren",

      "signup.update.placeholder": "Neue E-Mail Adresse",

      "signup.widget.success.cta": "Registrierung fortfahren",

      "signup.widget.success.reset": "Formular zurücksetzen",

      "signup.zipcode.placeholder": "Wie lautet deine Postleitzahl?",

      "sort.byDistance": "Sortieren (Distanz)",

      "sort.byDistance.label": "Nach Distanz sortieren",

      "sort.byDue": "Sortieren (Fälligkeit)",

      "sort.byDue.label": "Nach Fälligkeit sortieren",

      "sppStandard.SPPKunde.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | ~~6,90~~ 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n *Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.",

      "sppStandard.SPPMitarbeiter.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | ~~6,90~~ 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n*Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.<br/>\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.",

      "sppStandard.ubeeqo.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 6,90 €/Std|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachttarif | 20 €|\n| Wochenendtarif | 79 €|\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.",

      "start.engine.description": "Bitte entnehme den Schlüssel aus dem Handschuhfach.",

      "start.engine.title": "Starte den Motor und gute Fahrt!",

      "station.booking.button": "Schlüsselübergabe",

      "station.booking.cancel": "Reservierung stornieren",

      "station.booking.category": "Fahrzeugkategorie",

      "station.booking.code": "Reservierungscode",

      "station.booking.confirm.button": "Jetzt reservieren",

      "station.booking.confirm.category": "Fahrzeugkategorie",

      "station.booking.confirm.dates": "Reservierungsdaten",

      "station.booking.confirm.description": "Überprüfe deine Reservierungsdaten und schließe die Reservierung ab",

      "station.booking.confirm.from": "Von",

      "station.booking.confirm.group": "Abholung",

      "station.booking.confirm.title": "Prüfe deine Reservierung",

      "station.booking.confirm.to": "Bis",

      "station.booking.confirm.where": "Wo?",

      "station.booking.description": "Sobald deine Reservierung beginnt, hast du 30 Minuten Zeit, das Fahrzeug am Express-Schalter der Station abzuholen.",

      "station.booking.from": "Von",

      "station.booking.group": "Abholung",

      "station.booking.key.category": "Kategorie",

      "station.booking.key.code": "Reservierungscode",

      "station.booking.key.description": "Zeige diese Ansicht einem Mitarbeiter an der Station. Nach erfolgreicher Schlüsselübergabe beginnt dein Mietvorgang automatisch.",

      "station.booking.key.from": "Von",

      "station.booking.key.insurance": "Selbstbeteiligung",

      "station.booking.key.insurance.default": "SB500",

      "station.booking.key.item": "Fahrzeug",

      "station.booking.key.title": "Schlüsselübergabe",

      "station.booking.key.to": "Bis",

      "station.booking.later.than": "Zu starten bis",

      "station.booking.later.value": "Schlüsselübergabe",

      "station.booking.merchant.waiting": "wird abgerufen",

      "station.booking.reservation": "Reserviert",

      "station.booking.title": "Deine Reservierung",

      "station.booking.to": "Bis",

      "station.booking.where": "Wo?",

      "storage.permission.details": "Bitte gewähre GETAWAY Zugriff auf deinen Speicher um die angefragten Dateien abzuspeichern.",

      "storage.permission.title": "Zugriffsanfrage gewähren",

      "storage.permission.yes": "Erlauben",

      "submit": "Übernehmen",

      "submt": "Übernehmen",

      "support.call": "Service Team anrufen",

      "support.cancel": "Abbrechen",

      "support.chat": "LiveChat",

      "support.email": "E-Mail",

      "support.phone.number": "+493012088089",

      "support.whatsapp": "LiveChat",

      "tariff.Firmentarif": "Firmentarif",

      "tariff.Firmentarif.desc": "✓ inklusive Selbstbeteiligung <s>1500€</s>  750€\n\n✓ inklusive Kraftstoffkosten\n\n✓ bis zu 50% auf den Zeitpreis sparen\n\n✓ Über 4.000 Fahrzeuge deutschlandweit im stationsbasierten und -flexiblen Carsharing",

      "tariff.Firmentarif.price": "<div style=\"display: flex;\">einmalig <s style=\"margin-left: 3px; margin-right: 3px;\"> 19€ </s> <strong style=\"color: #749600;\"> gratis</strong>・monatlich 0€</div>",

      "tariff.Rahmentarif.desc.new": "✓ 16% Rabatt im Vergleich zum Starttarif <br>\n✓ 4 Tarifpartner inklusive<br>\n\nBahnCard, ÖPNV-Abo oder Student? Spare mit dem %s\"",

      "tariff.button.text": "Tarif übernehmen",

      "tariff.coupon": "Gutschein einlösen",

      "tariff.coupon.desc": "Sofern der Gutscheincode gültig ist, wird dieser im\nAnschluss an die Freischaltung angewendet.",

      "tariff.coupon.number": "Gutscheincode eingeben",

      "tariff.desc": "Wähle deinen passenden Tarif und optional die Reduzierung der Selbstbeteiligung.",

      "tariff.discount.selected.header": "Bitte Nachweis hinterlegen",

      "tariff.discount.selected.proof": "Nachweis",

      "tariff.discounts": "Ermäßigung anwenden",

      "tariff.discounts.header": "Partnerrabbat wählen",

      "tariff.grf.coupon.desc": "Sofern der Gutscheincode gültig ist, wird dieser im Anschluss an die Freischaltung angewendet.",

      "tariff.header.desc": "Bestätige jetzt den passenden Tarif.",

      "tariff.org.consent": "Der Kundenvertrag wird vorbehaltlich einer positiven Bonitätsauskunft abgeschlossen und kann bei negativer Auskunft widerrufen werden.",

      "tariff.partner.desc": "  ",

      "tariff.partner.link.footnote.md": "Wer sich mit dem Einladungslink erfolgreich registriert, wird automatisch dein Haupt-Account als Tarifpartner hinzugefügt. Beim Teilen des Einladungslinks werden auch Daten des Einladenden geteilt. ",

      "tariff.partner.link.prefix": "Einladungslink",

      "tariff.partner.link.share": "Einladungslink teilen",

      "tariff.partner.share.text": "Schließ dich deinem Partner an %@",

      "tariff.partner.share.title": "Teilen",

      "tariff.partner.switch.title": "Einladungslink erlauben",

      "tariff.partner.title": "Tarifpartner",

      "tariff.title": "Tarif wählen",

      "tariff.upselling.SB.header": "Sicherheitspaket",

      "tariff.upselling.free.header": "Kein Extra-Schutz",

      "tariff.upselling.free.price": "0€ (inklusive)",

      "tariff.upselling.title": "Service-Paket",

      "tba": "tba",

      "terms.url": "https://get-a-way.com/agb?utm_source=app",

      "textkey": "de-DE",

      "time": "Zeitpunkt",

      "tirePressure": "Reifendruck",

      "today": "Heute",

      "toggle.or": "ODER",

      "tomorrow": "Morgen",

      "tonne.short": "t",

      "touchId.password.dialog.message": "Bitte gib jetzt dein GETAWAY Passwort ein, um Touch ID zu aktivieren.",

      "touchId.password.dialog.title": "Mit Passwort bestätigen",

      "touchid.enable.message": "Melde dich ab sofort noch einfacher bei GETAWAY per Touch ID an.",

      "touchid.login.message": "Nutze Touch ID, um dich noch einfacher bei GETAWAY anzumelden.",

      "transaction.open.button": "Jetzt bezahlen",

      "transaction.open.description": "Bitte zahle die offene Rechnung ",

      "transaction.open.title": "Offene Zahlung",

      "transactions.bonus.description": "[{0}]",

      "transactions.bonus.title": "Gutschrift",

      "transactions.cancel.description": "Storno [{0}]",

      "transactions.cancel.title": "Rückerstattung",

      "transactions.chargeback.description": "{0} {1}",

      "transactions.chargeback.title": "Rücklastschrft",

      "transactions.fee.description": "{0} {1}",

      "transactions.fee.title": "Entgelt #{0}",

      "transactions.firststepsbonus.description": "🎉 Willkommensbonus",

      "transactions.goodwillbonus.description": "Kulanz-Gutschrift [{0}]",

      "transactions.payment.deposit.description": "Rechnung [{0}]",

      "transactions.payment.deposit.title": "Kaution Einzahlung",

      "transactions.payment.title": "(An-)Zahlung [{0}]",

      "transactions.payout.title": "Auszahlung",

      "transactions.refuel.description": "{0} am {1} Uhr",

      "transactions.refuel.title": "Tankvorgang",

      "transactions.refuelbonus.description": "🙏 Danke für's Tanken",

      "transactions.refund.deposit.description": "Mietvorgang [{0}]",

      "transactions.refund.deposit.title": "Rückzahlung Kaution",

      "transactions.refund.title": "Auszahlung",

      "transactions.rental.description": "{0} | {1}km am {2} Uhr",

      "transactions.rental.title": "Rechnung [{0}]",

      "transactions.type.bonus": "Gutschrift",

      "transactions.type.bonus.description": "Erste Schritte wurden gemeistert",

      "transactions.type.fee": "Gebühr",

      "transactions.type.payment": "Zahlung",

      "transactions.type.payment.reason": "Grund",

      "transactions.type.referrerBonus": "Gutschrift",

      "transactions.type.referrerBonus.description": "Für deine Empfehlung an deine Freunde",

      "trip.adult.desc": "ab 15 Jahre",

      "trip.adult.placeholder": "Passagiere (Regeltarif)",

      "trip.cancel.confirm.msg": "Möchtest Du die Fahrt tatsächlich stornieren? Bitte beachte, dass Stornierungsgebühren anfallen können.",

      "trip.cancel.confirm.title": "Fahrt stornieren",

      "trip.cancel.dialog.title": "Möchtest Du die Fahrt tatsächlich stornieren? Bitte beachte, dass Stornierungsgebühren anfallen können.",

      "trip.cancel.no": "Abbrechen",

      "trip.cancel.yes": "Jetzt stornieren",

      "trip.children.desc": "0 - 14 Jahre",

      "trip.children.placeholder": "Passagiere (ermäßigt)",

      "trip.damage.report": "Schaden melden",

      "trip.driving.refuel": "Jetzt tanken",

      "trip.force.finish": "Fahrt vorzeitig beenden",

      "trip.force.finish.msg": "Möchtest Du die Fahrt auf eigenes Risiko jetzt vorzeitig beenden?",

      "trip.force.finish.title": "Fahrt vorzeitig beenden",

      "trip.force.no": "Verwerfen",

      "trip.force.yes": "Jetzt beenden",

      "trip.opened.stepOne": "Ich bin angeschnallt",

      "trip.opened.stepTwo": "Die Fahrzeugtür ist wieder verschlossen",

      "trip.order.arrived": "Rufbus ist da: Jetzt Seitentür öffnen",

      "trip.order.brake": "Notbremse",

      "trip.order.driving": "Gute Fahrt!",

      "trip.order.finished.submit": "Fahrt beenden",

      "trip.order.opened": "Bitte einsteigen",

      "trip.order.parking": "Bitte aussteigen",

      "trip.order.parking.submit": "Fahrt beenden",

      "trip.order.start": "Los geht’s",

      "trip.order.stop": "Zwischenhalt: nicht Dein Ausstieg.",

      "trip.order.transit": "Zwischenhalt: nicht Dein Ausstieg.",

      "trip.order.unlock": "Tür ist geöffnet",

      "trip.order.waiting": "Rufbus ist auf dem Weg",

      "trip.parking.stepOne": "Ich bin ausgestiegen",

      "trip.parking.stepThree": "Fahrzeugtür ist wieder verschlossen",

      "trip.parking.stepTwo": "Ich habe nichts vergessen",

      "trip.payByLink.description": "Kaution für Mietvorgang %@",

      "trip.search.confirm": "Bestellen",

      "trip.search.enter.destination": "Zieladresse übernehmen",

      "trip.search.enter.start": "Ziel eingeben",

      "trip.search.enter.start.location": "Startadresse übernehmen",

      "trip.service.type.refuel": "Refueling",

      "trip.service.type.relocate": "Relocating",

      "trip.service.type.relocateAndRelease": "Relocate And Release",

      "trip.service.type.title": "Welcher Service wurde durchgeführt?",

      "trip.start.location.placeholder": "Start-Adresse eingeben",

      "trip.stop.confirm.msg": "Möchtest du die Notbremse tatsächlich auslösen? Bitte beachte, dass ein Missbrauch strafbar ist.",

      "trip.stop.confirm.title": "Notbremse",

      "trip.stop.item": "Haltestelle %s",

      "trip.stop.no": "Abbrechen",

      "trip.stop.yes": "Notbremse auslösen",

      "trip.stops.title": "%s Haltestellen",

      "trip.support": "Service kontaktieren",

      "trip.wheelchair.desc": "1 Rollstuhl je Fzg möglich",

      "trip.wheelchair.placeholder": "Rollstuhlbedarf",

      "tripHistory.complain": "Beschwerde einreichen",

      "tripHistory.end": "Rückgabe",

      "tripHistory.fee": "Mietvorgang",

      "tripHistory.revenue": "Mieteinnahmen",

      "tripHistory.services": "Durchgeführte(r) Service(s)",

      "tripHistory.start": "Übernahme",

      "tutorial.listcar.button": "AUTO GRATIS CHECKEN",

      "tutorial.listcar.step1.message": "Dein Auto steht täglich 23 Std. still. Gib es in Standzeiten minutenweise zum Vermieten frei und verdiene bis zu 100€ pro Woche und mehr.",

      "tutorial.listcar.step1.title": "Parkst du \nnoch oder \nverdienst du \nschon?",

      "tutorial.listcar.step2.message": "Bestimme spontan die Verfügbarkeit und deinen Verdienst pro Kilometer. Erhalte deine Einnahmen automatisch gutgeschrieben.",

      "tutorial.listcar.step2.title": "Du \nbehältst\ndie \nKontrolle",

      "tutorial.listcar.step3.message": "Wir prüfen jeden Mieter, behalten dein Auto mit modernster Technologie im Blick und lassen es rundum über „Die Gothaer“ versichern.",

      "tutorial.listcar.step3.title": "Damit\ndu gelassen\nbleiben\nkannst",

      "tutorial.listcar.step4.message": "Bestehende Ressourcen effizienter nutzen: Entlaste die Umwelt ganz nebenbei, ohne auf deine Freiheit eines Autos zu verzichten.",

      "tutorial.listcar.step4.title": "Gut für’s \nGewissen. \nGut für die \nUmwelt.",

      "tutorial.listcar.step5.message": "Lass dein Auto jetzt gratis und unverbindlich von uns prüfen und erfahre, wie viel dein Auto für dich verdienen kann.",

      "tutorial.listcar.step5.title": "Wie viel\nkann dein\nAuto \nverdienen?",

      "tutorial.map.listCar.button": "JETZT CHECKEN",

      "tutorial.map.listCar.message": "Lass jetzt gratis und unverbindlich prüfen, wie viel dein Auto für dich verdienen kann.",

      "tutorial.map.listCar.title": "Wie viel verdient \ndein Auto?",

      "tutorial.map.step1.message": "Für Hilfe, Feedback oder Anregungen ist unser Team stets nur einen Klick entfernt.",

      "tutorial.map.step1.title": "Stets an\ndeiner Seite",

      "tutorial.map.step2.message": "Über das Nutzer-Symbol gelangst du zu deinen persönlichen Einstellungen.",

      "tutorial.map.step2.title": "Alles\nim Blick",

      "tutorial.map.step3.message": "Gib deinen Wunschzeitraum an und verfügbare Autos werden automatisch gefiltert.",

      "tutorial.map.step3.title": "Spontan\nein Auto?",

      "tutorial.map.step4.button": "LOS GEHT’S",

      "tutorial.map.step4.message": "Schließe die ersten Schritte ab und sichere dir dein Startguthaben. Es dauert nur 2 Minuten.",

      "tutorial.map.step4.title": "Erobere\ndie Straße",

      "tutorial.signup.button": "LOS GEHT’S",

      "tutorial.signup.extraAction": "Ich habe ein Nutzerkonto »",

      "tutorial.signup.step1.message": "Öffne & miete Privatautos in deiner Nähe sofort per Handy\n",

      "tutorial.signup.step1.title": "AUTOS\nVON\nNEBENAN",

      "tutorial.signup.step2.message": "Preise je Kilometer machen Kosten planbar und dich im Stau entspannt.",

      "tutorial.signup.step2.title": "STRESS\nDICH\nNICHT",

      "tutorial.signup.step3.message": "Vermiete dein Auto spontan, während du es selbst nicht benötigst.",

      "tutorial.signup.step3.title": "DU\nHAST\nEIN\nAUTO?",

      "tutorial.signup.step4.message": "Gib dein Auto beim Parken mit nur einem Klick zum Vermieten frei",

      "tutorial.signup.step4.title": "MIT\nNUR\nEINEM\nKLICK",

      "unavailablecar.request": "Start Booking",

      "until": "Bis",

      "upcoming.booking.event.description": "Du kannst deine Buchung hier finden",

      "upcoming.booking.event.title": "Reservierung Mietwagen",

      "update.address.add": "HINZUFÜGEN",

      "update.address.city": "Stadt",

      "update.address.country": "Land",

      "update.address.desc": "Bitte beachte, dass es sich hierbei um deine offizielle Meldeadresse handeln muss.",

      "update.address.germany": "Deutschland",

      "update.address.location.error": "GETAWAY ist noch nicht in deinem Land verfügbar.",

      "update.address.number": "Nr",

      "update.address.search": "Adresse suchen",

      "update.address.street": "Straße",

      "update.address.success": "Danke, deine Adresse ist erfolgreich aktualisiert worden.",

      "update.address.update": "AKTUALISIEREN",

      "update.address.zip": "Plz",

      "update.email.desc": "Deine aktuelle E-Mail-Adresse lautet %@. Bitte gib deine neue E-Mail ein und bestätige dies mit deinem Passwort.",

      "update.email.new": "Neue E-Mail-Adresse",

      "update.email.title": "E-Mail-Adresse aktualisieren",

      "update.email.update": "AKTUALISIEREN",

      "update.email.wrong.pass": "Falsches Passwort",

      "update.notifications.channels": "KANÄLE",

      "update.notifications.email": "Per E-Mail",

      "update.notifications.email.desc": "Erlaubnis, dich per E-Mail zu kontaktieren.",

      "update.notifications.mail": "Per Post",

      "update.notifications.mail.desc": "Erlaubnis, dich per Post zu kontaktieren.",

      "update.notifications.push": "Per Push-Nachricht",

      "update.notifications.push.desc": "Erlaubnis, dich per App-Mitteilung zu kontaktieren.",

      "update.notifications.push.wizard.button": "ZU DEN EINSTELLUNGEN",

      "update.notifications.push.wizard.desc": "Aktiviere Push-Nachrichten",

      "update.notifications.push.wizard.latter": "NICHT JETZT",

      "update.notifications.push.wizard.latter.error": "Push-Nachricht sind deaktiviert",

      "update.notifications.push.wizard.title": "Push-Nachrichten aktivieren",

      "update.notifications.sms": "Per SMS",

      "update.notifications.sms.desc": "Erlaubnis, dich per SMS zu kontaktieren.",

      "update.notifications.title": "BENACHRICHTIGUNGEN",

      "update.notifications.topics.name.bookings.description": "Wir halten dich über deine Buchungen auf dem Laufenden.",

      "update.notifications.topics.name.bookings.title": "Buchungen",

      "update.notifications.topics.name.monthlyOverview.description": "Behalte deine Fahrten und dein Guthaben im Blick",

      "update.notifications.topics.name.monthlyOverview.title": "Monatliche Übersicht",

      "update.password.forgot.error": "Bitte gib deine E-Mail-Adresse an und tippe erneut auf \"Vergessen\". Wir senden dir im Anschluss ein Link zum Zurücksetzen deines Passworts.",

      "update.password.text": "Sofern die E-Mail-Adresse registriert ist, ist soeben ein Link zum Zurücksetzen des Passworts an %@ gesendet worden.",

      "update.password.wizard.desc": "Bitte gib ein neues Passwort ein",

      "update.password.wizard.newpassword": "Neues Passwort",

      "update.password.wizard.title": "Passwort aktualisieren",

      "update.password.wizard.update": "AKTUALISIEREN",

      "upselling.dialog.message": "Willst du dieses Paket buchen?",

      "upselling.dialog.noAction": "Weiter ohne Extra-Schutz",

      "upselling.dialog.title": "Kein Extra-Schutz?",

      "upselling.dialog.yesAction": "Ja",

      "upsellings.button.text": "Übernehmen",

      "upsellings.header.desc": " Im Schadenfall kann es schnell teuer werden. Beschränke dein Haftungsrisiko.",

      "upsellings.title": "Selbstbeteiligung",

      "user-duplicate.phone.cancel": "ABBRECHEN",

      "user.DL.completed.message": "Um deine Fahrerlaubnisdaten (Fahrverbot oder neuer Führerschein) zu aktualisieren, wende dich bitte an unser Service Team.",

      "user.DL.inProgress.message": "Bitte habe noch etwas Geduld. Deine Fahrerlaubnis wird gerade verifiziert.",

      "user.DL.resubmission.message": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktiere unser Service Team.",

      "user.ID.completed.message": "Um eine Änderung vorzunehmen, kontaktiere bitte unser Service Team.",

      "user.ID.inProgress.message": "Dein Ausweisdokument wird verifiziert. Wir bitten um Geduld.",

      "user.ID.resubmission.message": "Um ein Ausweis-Dokument hochzuladen, kontaktiere bitte unser Service-Team.",

      "user.action.support.text": "Service Team kontaktieren",

      "user.add_to_circle.brand_not_matches": "Nutzerkreis und Anbieter stimmen nicht überein, Nutzerkreis kann daher nicht hinzugefügt werden.",

      "user.address.completed.message": "Um deine Adresse zu ändern, wende dich bitte an unser Service Team.",

      "user.address.inProgress.message": "Bitte habe noch etwas Geduld. Deine Adresse wird gerade verifiziert.",

      "user.car.selector.listed": "%@ (vom %@)",

      "user.car.selector.release_ready": "%@ (Nicht freigegeben)",

      "user.car.selector.released": "%@ (Freigegeben)",

      "user.car.selector.rented": "%@ (In Miete)",

      "user.car.selector.submitted": "Neues Auto (vom %@)",

      "user.car.selector.title": "Wähle dein Auto",

      "user.circle.description": "Willst du diesen Nutzerkreis wirklich verlassen?",

      "user.circle.leave": "Nutzerkreis verlassen",

      "user.circle.leave.description": "Wenn du diesen Nutzerkreis verlässt, hast du keinen Zugang mehr zu dessen Fahrzeugen und Angeboten. Bist du sicher, dass du fortfahren möchtest?",

      "user.circle.switchAccess": "Nutzerkreis wechseln",

      "user.deletePayment.dialog.message": "Bist du sicher ?",

      "user.deletePayment.dialog.no": "Abbrechen",

      "user.deletePayment.dialog.title": "Zahlungsprofil entfernen",

      "user.deletePayment.dialog.yes": "Entfernen",

      "user.deposit.dialog.msg": "Die Rechnung zur hinterlegten Kaution kannst du hier nach Abschluss deiner Registrierung herunterladen.\n\nFalls du eine Erstattung wünschst, erhältst du diese automatisch, sobald du deine Registrierung abbrichst und dein Nutzerkonto entfernst.",

      "user.deposit.dialog.no": "Jetzt nicht",

      "user.deposit.dialog.yes": "LiveChat öffnen",

      "user.document.resubmitInstruction.BAD_QUALITY_IMAGE": "Schlecht lesbar: Bitte lade ein Dokument in ausreichender Qualität ein.",

      "user.document.resubmitInstruction.BLURRED": "Schlecht lesbar: Bitte lade  ein Dokument in ausreichender Schärfe ein.",

      "user.document.resubmitInstruction.CAR_DRIVING_PERMISSION_IS_NO": "Fehlende Infos: Bitte reichen einen Führerschein ein, auf dem die nötige Fahrerlaubnis eindeutig erkennbar ist.",

      "user.document.resubmitInstruction.COUNTRY_NOT_ALLOWED": "Das von dir eingereichte Dokument kann aufgrund des Ausstellungslands nicht verarbeitet werden. Bitte reiche ein Dokument mit einem anderen Ausstellungsland ein.",

      "user.document.resubmitInstruction.DAMAGED_DOCUMENT": "Bitte reiche ein unbeschädigtes/ungelochtes Dokument ein.",

      "user.document.resubmitInstruction.EXPIRED_DOCUMENT": "Dokument Abgelaufen: Bitte reiche ein gültiges Dokument ein.",

      "user.document.resubmitInstruction.GLARE": "Schlecht lesbar: Bitte reiche dein Dokument ohne Reflexionen ein. Ggf. hilft es, den Blitz auszuschalten",

      "user.document.resubmitInstruction.IDENTITY_MISMATCH_APPROVED_USER_IDENTITY": "Fehlende Übereinstimmung: Bitte reiche ein Dokument ein, dass mit deinen Nutzerangaben übereinstimmt.",

      "user.document.resubmitInstruction.INCOMPLETE_DATA": "Fehlende Angaben: Bitte achte beim nächsten Versuch darauf, dass alle Angaben auf dem Dokument gut lesbar sind.",

      "user.document.resubmitInstruction.LIVENESS_FAILED": "Kameraausrichtung: Bitte achte beim nächsten Versuch darauf, die Aufnahmen im Porträtmodus (hochkant) zu machen.",

      "user.document.resubmitInstruction.MANIPULATED_DOCUMENT": "Dokument kann aufgrund von Änderungen am Dokument nicht verarbeitet werden. Bitte reiche ein anderes Dokument ein.",

      "user.document.resubmitInstruction.MISSING_PAGE": "Fehlende Infos: Bitte achte darauf, dass Vorder- und Rückseite hochgeladen werden.",

      "user.document.resubmitInstruction.MISSING_SIGNATURE": "Fehlende Unterschrift: Bitte reiche ein gültiges Dokument mit allen Sicherheitsmerkmalen ein.",

      "user.document.resubmitInstruction.NO_ID_UPLOADED": "Kein Dokument hochgeladen. Falls du Schwierigkeiten hast, versuche es bitte in einem anderen Browser.",

      "user.document.resubmitInstruction.NO_MATCH": "Fehlende Übereinstimmung: Bitte reiche ein Dokument ein, dass auf dich persönlich ausgestellt wurde.",

      "user.document.resubmitInstruction.PART_OF_DOCUMENT_MISSING": "Bitte reiche dein Dokument so ein, sodass es vollständig einsehbar ist.",

      "user.document.resubmitInstruction.PHOTOCOPY": "Bitte scanne das geforderte Dokument ausschließlich vom Original ab.",

      "user.document.resubmitInstruction.PUNCHED": "Bitte reiche ein unbeschädigtes/ungelochtes Dokument ein.",

      "user.document.resubmitInstruction.WRONG_DOCUMENT_TYPE": "Falsches Dokument: Bitte achte bei diesem Versuch darauf, ob hierbei ein Führerschein oder ob ein Ausweisdokument gefordert ist.",

      "user.duplicate.api_error.org.duplicate.cancel": "ABBRECHEN",

      "user.duplicate.api_error.org.duplicate.msg": "Diese Firma ist bereits hinterlegt.\nMöchten Sie Ihr Passwort zurücksetzen?",

      "user.duplicate.api_error.org.duplicate.yes": "ZURÜCKSETZEN",

      "user.duplicate.email.cancel": "ABBRECHEN",

      "user.duplicate.email.msg": "Eine E-Mail darf nur ein Mal verwendet werden.\nBitte melde dich mit deinem initialen Nutzerkonto an. Falls du dein Passwort vergessen hast, kannst du es in der Anmeldemaske zurücksetzen.",

      "user.duplicate.email.yes": "JETZT ANMELDEN",

      "user.duplicate.iban.cancel": "ABBRECHEN",

      "user.duplicate.iban.msg": "Eine IBAN darf nur ein Mal verwendet werden. \n\nBitte melde dich mit deinem initialen Nutzerkonto an. \n\nFalls du dein Passwort vergessen hast, kannst du es in der Anmeldemaske zurücksetzen.",

      "user.duplicate.iban.yes": "JETZT ANMELDEN",

      "user.duplicate.phone.cancel": "ABBRECHEN",

      "user.duplicate.phone.msg": "Die Handynummer kann nur einmal verwendet werden.\n\nBitte melde dich mit deinem ursprünglichen Benutzerkonto an. Wenn du dein Passwort vergessen hast, kannst du es auf dem Anmeldebildschirm zurücksetzen.",

      "user.duplicate.phone.yes": "JETZT ANMELDEN",

      "user.email.completed.message": "Um deine E-Mail-Adresse zu ändern, wende dich bitte an unser Service Team.",

      "user.id.not.required": "Dieser Schritt ist nicht mehr erforderlich",

      "user.logout.cancelReservation.message": "Bitte storniere die Reservierung, bevor du fortfährst.",

      "user.logout.cancelReservation.ok": "Ok",

      "user.logout.dialog.message": "Bist du sicher?",

      "user.logout.dialog.no": "Abbrechen",

      "user.logout.dialog.title": "Abmelden",

      "user.logout.dialog.yes": "Abmelden",

      "user.noPayment.action": "Zahlungsmittel hinzufügen",

      "user.noPayment.message": "Bitte hinterlege zuerst ein gültiges Zahlungsmittel",

      "user.notNow": "Jetzt nicht",

      "user.notification.terminate.message": "Ihr Antrag zur Kontolöschung wird derzeit bearbeitet.",

      "user.onboarding.cw_check.done": "Bonitätsprüfung_abgeschlossen_am",

      "user.onboarding.id_card.verified_or_rejected": "Ausweis_geprüft_oder_abgelehnt_am",

      "user.onboarding.license.verified_or_rejected": "Führerschein_geprüft_oder_abgelehnt_am",

      "user.org.signupCertificate.events.signedUp.description": "Das Nutzerkonto ist als organisatorisches Konto unter dem Namen %s, mit der Rechtsform %s, der Register-Nr %s am Registergericht %s durch %s %s mit der E-Mail-Adresse %s registriert und den/r zu diesem Zeitpunkt gültigen/r AGB und Datenschutzerklärung ist zugestimmt worden.",

      "user.payment.not.added": "Es wurde bisher keine Zahlungsmethode hinterlegt. Bitte hole dies zuerst nach.",

      "user.paymentLink.iban_verification.description": "Um zu bestätigen, dass du Zugriff auf das Konto mit der angegebenen IBAN hast, ist eine kleine Zahlung nötig. Sobald die Überprüfung abgeschlossen ist, bekommst du den Betrag vollständig zurück.",

      "user.phone.completed.message": "Um deine Handynummer zu ändern, wende dich bitte an unser Service Team.",

      "user.phone.edit.desc": "Um deine Telefonnummer zu aktualisieren, senden wir einen Bestätigungscode an deine E-Mail-Adresse.",

      "user.pin.completed.message": "Um eine Änderung vorzunehmen, kontaktiere bitte unser Service Team.",

      "user.profile.payment.org.pending": "Die Zahlungsmethode wird nach erfolgreicher Prüfung durch das Service Team freigegeben.",

      "user.profile.payment.pending": "Die Zahlungsmethode wird verifiziert, sobald Ausweis und Führerschein hinzugefügt wurden.",

      "user.scan.attempts.out": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktiere unser Service Team.",

      "user.selectPayment.noCC": "Ich habe keine Kredit-/Debitkarte",

      "user.signupCertificate.accountHistory": "Nutzerkonto-Verlauf",

      "user.signupCertificate.createdBy": "Erstellt von",

      "user.signupCertificate.createdBy.at": "am",

      "user.signupCertificate.deviceUuid": "UUID",

      "user.signupCertificate.documentId": "ID (Dokument)",

      "user.signupCertificate.events.addressVerified.description": "Dem Nutzerkonto ist die Meldeadresse %s hinzugefügt worden.",

      "user.signupCertificate.events.creditCheck.description": "Der Verarbeitung der Daten zur Prüfung der Zahlungswahrscheinlichkeit ist eingewilligt worden. Der Abgleich ergab eine Übereinstimmung und einen Score und die Adresse %s.",

      "user.signupCertificate.events.creditCheck.manualapproval.description": "Die Daten zur Prüfung der Zahlungswahrscheinlichkeit wurden manuell bestätigt.",

      "user.signupCertificate.events.creditCheck.plusAddress.description": "Der Verarbeitung der Daten zur Prüfung der Zahlungswahrscheinlichkeit ist eingewilligt worden. Der Abgleich ergab eine Übereinstimmung, einen Score und die Adresse %s.",

      "user.signupCertificate.events.idVerified.description": "Dem Nutzerkonto ist das Ausweisdokument (Typ: %s) mit der Nummer %s hinzugefügt worden.",

      "user.signupCertificate.events.idVerified.plusAddress.description": "Dem Nutzerkonto ist das Ausweisdokument (%s) mit der Dokumenten-Nummer %s und Adresse %s hinzugefügt worden",

      "user.signupCertificate.events.licenseVerified.description": "Dem Nutzerkonto ist der Führerschein mit der Nummer %s hinzugefügt worden.",

      "user.signupCertificate.events.marketingConsentGiven.description": "Die Einwilligung \"Newsletter\" ist erteilt worden.",

      "user.signupCertificate.events.marketingConsentRevoked.description": "Die Einwilligung \"Newsletter\" ist entzogen worden.",

      "user.signupCertificate.events.merchantReferenceAssigned.description": "Dem Nutzerkonto ist im Zuge der Freischaltung die Kunden-Nr %s hinzugefügt worden.",

      "user.signupCertificate.events.phoneVerified.description": "Dem Nutzerkonto ist die Handynummer %s hinzugefügt worden.",

      "user.signupCertificate.events.sepaAdded.description": "Dem Nutzerkonto ist die Zahlungsmethode SEPA %s hinzugefügt und dem Lastschriftmandat zugestimmt worden.",

      "user.signupCertificate.events.sepaAddedWithTrueLayer.description": "Dem Nutzerkonto ist die Zahlungsmethode SEPA-Lastschrift hinzugefügt und dem Lastschriftmandat ist zugestimmt worden. Die Authentifizierung per Online-Banking-Login ergab die IBAN %s, die BIC %s und den/die KontoinhaberIn %s.",

      "user.signupCertificate.events.sepaVerifiedWithBankTransfer.description": "Die Zahlungsart „SEPA-Lastschrift“ mit der IBAN %s, dem BIC %s und dem Kontoinhaber %s wurde per Banküberweisung überprüft.",

      "user.signupCertificate.events.signedUp.description": "Das Nutzerkonto ist als %s %s mit der E-Mail-Adresse %s registriert und den/r zu diesem Zeitpunkt gültigen/r AGB, Datenschutzerklärung und Anmeldegebühr ist zugestimmt worden.",

      "user.signupCertificate.events.tariffSelected.description": "Dem Nutzerkonto ist der Tarif \"%s\" (ohne Reduzierung der Selbstbeteiligung) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelected.descriptionWithServicePackage": "Dem Nutzerkonto ist der Tarif \"%s\" (mit Service-Paket) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelected.descriptionWithUpsellings": "Dem Nutzerkonto ist der Tarif \"%s\" (mit Reduzierung der Selbstbeteiligung) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelected.descriptionWithoutServicePackage": "Dem Nutzerkonto ist der Tarif \"%s\" (ohne Service-Paket) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelectedFromPartner.description": "Dem Nutzerkonto ist der Tarif \"%s\" (ohne Sicherheitspaket) über das Hauptkonto (Kunden-Nr. %s) zugewiesen.",

      "user.signupCertificate.id.DRIVING_LICENSE": "Führerschein",

      "user.signupCertificate.id.ID_CARD": "Personalausweis",

      "user.signupCertificate.id.PASSPORT": "Reisepass",

      "user.signupCertificate.id.UNSUPPORTED": "Unbekannt",

      "user.signupCertificate.id.VISA": "Aufenthaltstitel",

      "user.signupCertificate.ip": "IP",

      "user.signupCertificate.page": "Seite",

      "user.signupCertificate.pageOf": "von",

      "user.signupCertificate.status": "Status",

      "user.signupCertificate.status.active": "Aktiv",

      "user.signupCertificate.title": "Titel",

      "user.signupCertificate.titleValue": "Nutzerkonto Registrierungsprotokoll",

      "user.signupCertificate.userId": "ID (Nutzer)",

      "user.signupCertificate.userIdentity": "Nutzer-Identität",

      "user.terminate.dialog.message": "Bitte beachte:\n\n1. Die Entfernung deines Nutzerkontos kann nicht rückgängig gemacht werden.\n\n2. Du wirst bis auf Weiteres kein neues Nutzerkonto einrichten können. Solltest du Unterstützung brauchen, deine bestehende Registrierung abzuschließen, kontaktiere uns bitte über das Service-Symbol. Wir helfen gerne weiter!",

      "user.terminate.dialog.no": "Abbrechen",

      "user.terminate.dialog.title": "Nutzerkonto entfernen",

      "user.terminate.dialog.yes": "Jetzt endgültig entfernen",

      "user.transaction.settled.success": "Zahlung wurde erfolgreich abgeschlossen.",

      "usercar.fillprofile.footnote": "Die besten Tipps, um deine Mieteinnahmen zu erhöhen, findest du in unserem %@.",

      "usercar.fillprofile.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "usercar.fillprofile.footnote.url.text": "HilfeCenter",

      "usercar.item.blocked.title": "Dein Auto kann nicht freigegeben werden. Bitte kontaktiere unser Service Team für mehr Infos.",

      "usercar.item.eligible.title": "In Warteschlange",

      "usercar.item.equipment_ready.title": "Installation in Kürze",

      "usercar.item.equipped.title": "Dein Auto ist ausgerüstet.",

      "usercar.item.listed.title": "Dein Auto steht auf der Warteliste.",

      "usercar.item.release_ready.title": "Nicht freigegeben",

      "usercar.item.released.title": "Freigegeben bis",

      "usercar.item.selected.title": "Dein Auto wird in Kürze ausgerüstet.",

      "usercar.item.submitted.description": "Übermittelt am",

      "usercar.item.submitted.title": "Dein Auto wird geprüft.",

      "usercar.item.terminated.description": "Entfernt am",

      "usercar.item.terminated.title": "Dein Autoprofil wird entfernt.",

      "usercar.photo.description": "Mach am besten ein Foto von vorne, von der Seite und vom Innenraum.",

      "usercar.profile.blocked.status": "BLOCKIERT",

      "usercar.profile.blocked.title": "Dieses Auto ist aktuell geblockt.",

      "usercar.profile.eligible.description": "Es ist nun in der Warteschlange, um in den Fuhrpark aufgenommen zu werden. Je mehr sich aus deiner Nähe anmelden, desto schneller bist du dabei. Teile jetzt deinen persönlichen Einladungscode mit deinen Freunden und Nachbarn.",

      "usercar.profile.eligible.status": "IN WARTESCHLANGE",

      "usercar.profile.eligible.title": "Prima %@, dein Auto hat alle Tests bestanden 💪",

      "usercar.profile.equipment_ready.description": "Unser Techniker kommt zum vereinbarten Wunschtermin zu der von dir gewählten Adresse. Er wird dich ca. 30 Minuten vor Terminbeginn anrufen, um den exakten Treffpunkt beim Auto abzusprechen. Bitte habe deinen Autoschlüssel und Kfz-Schein parat.\n\nBitte gib uns mind. 48 Stunden vorab Bescheid, solltest du den Termin nicht wahrnehmen können, um etwaige Gebühren zu vermeiden.",

      "usercar.profile.equipment_ready.status": "INSTALLATION",

      "usercar.profile.equipment_ready.title": "%@, der Einbautermin für dein Auto steht bevor",

      "usercar.profile.equipped.description": "Bitte habe einen Moment Geduld. Sobald die letzten Funktions- und Sicherheitschecks abgeschlossen sind, wird dein Auto freigeschaltet.",

      "usercar.profile.equipped.status": "WIRD FREIGESCHALTET",

      "usercar.profile.equipped.title": "%@, in Installation ist abgeschlossen",

      "usercar.profile.firssteps.description": "Um Vermieter zu werden, schließe jetzt bitte die Ersten Schritte ab.",

      "usercar.profile.firssteps.title": "Bitte vervollständige jetzt deine Nutzerangaben",

      "usercar.profile.firststeps.description": "Im Anschluss können wir prüfen, was dein Auto für dich verdienen könnte.",

      "usercar.profile.firststeps.title": "%@, bitte vervollständige jetzt deine https://applink.get-a-way.com/user-challenges-firststeps",

      "usercar.profile.firststeps.title.url": "https://applink.get-a-way.com/user-challenges-firststeps",

      "usercar.profile.firststeps.title.url.text": "Nutzerangaben",

      "usercar.profile.listed.description": "Lege hier fest, wie Mietern dein Auto angeboten werden soll. Du kannst diese Infos jederzeit anpassen.",

      "usercar.profile.listed.status": "IN PRÜFUNG",

      "usercar.profile.listed.title": "%@, vervollständige jetzt dein Autoprofil",

      "usercar.profile.release.availableuntil": "Jetzt freigeben bis",

      "usercar.profile.release_ready.status": "PRIVAT",

      "usercar.profile.released.availableuntil": "Freigegeben bis",

      "usercar.profile.released.status": "FREIGEGEBEN",

      "usercar.profile.rented.status": "VERMIETET",

      "usercar.profile.selected.description": "Um einfachste Mietabläufe zu gewährleisten und Acht auf dein Auto geben zu können, wenn es vermietet wird, rüsten wir es einmalig mit unserem SafetyKit aus. Unser Techniker-Team wird dich zeitnah kontaktieren, um einen individuellen Einbautermin zu vereinbaren.",

      "usercar.profile.selected.status": "AUSGEWÄHLT",

      "usercar.profile.selected.title": "%@, dein Auto kann ausgerüstet werden 🙌",

      "usercar.profile.service.status": "IM SERVICE",

      "usercar.profile.submit.action": "Jetzt prüfen lassen",

      "usercar.profile.submit.description": "Hunderte sind bereits dabei. Lass jetzt gratis & unverbindlich prüfen, wie viel dein Auto für dich verdienen könnte.",

      "usercar.profile.submit.left": "MEIN AUTO",

      "usercar.profile.submit.status": " ",

      "usercar.profile.submit.title": "erfahre, was dein Auto für dich verdienen könnte!",

      "usercar.profile.submitted.description": "Lege hier fest, wie Mietern dein Auto angeboten werden soll. Du kannst diese Infos jederzeit anpassen.",

      "usercar.profile.submitted.status": "IN PRÜFUNG",

      "usercar.profile.submitted.title": "%@, vervollständige jetzt dein Autoprofil",

      "usercar.profile.terminated.status": "TERMINATED",

      "usercar.profile.title": "Mein Auto",

      "usercar.review.novalue": "✨ Neues Auto",

      "usercar.troubleshoot": "Störungsbehebung",

      "usercar.troubleshoot.dialog.message": "Als Autobesitzer kannst du jetzt dein Auto entriegeln und die Motorsperre aufheben. Dein Auto ist im Anschluss nicht mehr über GETAWAY gesichert. Wir empfehlen dringend, nur fortzufahren, sofern du dich unmittelbar an deinem Auto befindest.",

      "usercar.troubleshoot.dialog.title": "Störungsbehebung",

      "usercar.troubleshoot.dialog.unlock": "Auto- und Motorsperre deaktivieren",

      "usercarprofile.example.title": "Was ein Mieter zahlen würde",

      "usercarprofile.price.details.footnote": "Weitere Infos, wie du den idealen Preis festlegst, findest du in unserem %@.",

      "usercarprofile.price.details.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto/mein-autoprofil/so-legst-du-den-idealen-preis-fur-dein-auto-fest",

      "usercarprofile.price.details.footnote.url.text": "Hilfe-Center",

      "usercarprofile.price.indicator.title": "du verdienst",

      "usercarprofile.price.slider.aboveaverage": "überdurchschnittlich",

      "usercarprofile.submit.status": " ",

      "users.merchantSystem.sync": "Sync",

      "validation.accountholder.invalid": "Bitte gib einen gültigen Kontoinhaber an",

      "validation.address.street.invalid": "Bitte gültigen Straßennamen eintragen",

      "validation.address.streetnumber.invalid": "Bitte gültige Hausnummer eintragen",

      "validation.address.zip.invalid": "Bitte gültige Postleitzahl eintragen",

      "validation.email.invalid": "Bitte gültige E-Mail-Adresse eintragen",

      "validation.iban.invalid": "Bitte eine gültige IBAN eintragen",

      "validation.name.invalid": "Mind. zwei Buchstaben",

      "validation.password.invalid": "Mind. 8 Zeichen (inkl. Groß-/ Kleinbuchst./ Ziff./ Sonderz.)",

      "validation.phone.invalid": "Diese Handy-Nummer kann nicht bestätigt werden. Bitte nutze eine andere.",

      "validation.required": "Bitte ausfüllen.",

      "validation.required.empty": "Dieses Feld darf nicht leer bleiben",

      "validator.name.error": "Dein Name muss mindestens zwei Buchstaben enthalten.",

      "validator.password.error": "Passwort muss mind. aus 6 Zeichen inklusive einer Ziffer bestehen.",

      "validator.streetNumber.error": "Bitte gebe eine gültige Hausnummer an",

      "verify.phone.failed": "Falscher Code",

      "verify.phone.passwordView.description": "Deine aktuelle Handy-Nummer lautet %@. Bitte gib dein Passwort ein.",

      "verify.phone.passwordView.title": "Handy-Nummer ändern",

      "verify.phone.resend.success": "Du wirst in Kürze einen Bestätigungscode per SMS erhalten",

      "verify.phone.success": "Danke, deine Handy-Nummer ist erfolgreich aktualisiert worden.",

      "video": "Video",

      "violation.adyenPayByLinkRequest.noError.hasError.assertFalse": "Die Erstellung des Zahlungslinks ist fehlgeschlagen. Bitte versuche es erneut oder kontaktiere den Support",

      "violation.adyenPaymentProvider.responseValidator.authorized.assertTrue": "Diese Kreditkarte kann nicht hinzugefügt werden, bitte versuche es mit einer anderen.",

      "violation.adyenPaymentProvider.responseValidator.cvcDeclined.assertFalse": "Prüfnummer inkorrekt. Bitte prüfe deine Kreditkarte und versuche es erneut.",

      "violation.adyenPaymentProvider.responseValidator.noResponse.assertFalse": "Konnte keine Verbindung zum Zahlungsdienstleister herstellen. Bitte versuche es erneut.",

      "violation.adyenPaymentProvider.responseValidator.notificationSuccess.assertTrue": "Diese Kreditkarte kann nicht hinzugefügt werden, bitte versuche es mit einer anderen.",

      "violation.apiVersionCheck.version.min": "Deine App-Version wird leider nicht mehr unterstützt. Bitte führe ein Update durch.",

      "violation.booking.bookingPayInAllowedValidator.payInAllowed.assertTrue": "Zahlung per Vorkasse kann nicht verwendet werden, da du ein Guthaben auf deinem Konto hast. Bitte wende dich an den Kundendienst, um eine Rückerstattung zu beantragen oder verwende eine andere Zahlungsmethode.",

      "violation.booking.bookingPaymentValidator.adyenRequestRejected.assertFalse": "Zahlungsanfrage wurde abgelehnt.",

      "violation.booking.bookingPaymentValidator.adyenRequestTimedOut.assertFalse": "Zahlungsanfrage ausgelaufen.",

      "violation.booking.bookingPaymentValidator.blockedPaymentNotNeededOrConfirmed.assertTrue": "Leider wurde die Autorisierung des Sicherheitsbetrages von deiner Bank abgelehnt. Bitte versuche es mit einer anderen Zahlungsmethode.",

      "violation.booking.bookingRequestValidator.canBook.assertTrue": "Leider kannst du dieses Fahrzeug nicht buchen, da du bereits eine Reservierung für diesen Zeitraum hast. Siehe dazu deine Mietvorgänge.",

      "violation.booking.bookingRequestValidator.confirmedCarValid.assertTrue": "Dieses Fahrzeug ist in dem gewählten Zeitraum leider nicht verfügbar.",

      "violation.booking.bookingRequestValidator.watchlistCheckPassed.assertTrue": "Bitte stelle sicher, dass dein Nutzerkonto vollständig ist. Falls du Hilfe benötigst, wende dich bitte an den Kundenservice.",

      "violation.booking.bookingRequestValidator.withinOpeningHours.assertTrue": "Buchung nicht möglich. Abholung und Rückgabe des Fahrzeug sind nur innerhalb der Öffnungszeiten möglich. Die Start- und/oder Endzeit der Buchungsanfrage liegen außerhalb.\n\nBitte versuche es erneut mit geänderter Start- und/oder Endzeit. Die Zugangszeiten sind dem Fahrzeugprofil unter \"Info\" zu entnehmen.",

      "violation.booking.bookingRequestValidator.youngDriver.assertFalse": "Bitte habe etwas Geduld. Dein Führerschein muss vor mindestens 2 Jahren ausgestellt worden sein. Du wirst automatisch bestätigt und benachrichtigt, sobald das geschieht.",

      "violation.booking.offerConfirmationValidator.creditworthinessApproved.assertTrue": "Du hast aktuell keine gültige oder aktive Zahlungsmethode hinterlegt. Bitte prüfe dein Nutzerkonto.",

      "violation.booking.offerConfirmationValidator.watchlistCheckPassed.assertTrue": "Deine Nutzerdaten sind unvollständig. Bitte kontaktiere unser Service Team.",

      "violation.car.chassisNumberUniqueValidator.chassisNumber.assertTrue": "Fahrgestellnummer bereits im System",

      "violation.car.damages.characteristics.notNull": "Bitte wähle die Schadens-Charakteristika.",

      "violation.car.damages.component.notNull": "Bitte wähle das beschädigte Teil.",

      "violation.car.damages.where.notNull": "Bitte bestimme, wo der Schaden genau ist.",

      "violation.car.generateOwnerAccessToken.rented.assertFalse": "Das Fahrzeug kann während einer laufenden Miete nicht geöffnet werden.",

      "violation.car.onlineCheck.online.assertTrue": "Verbindung verloren. Bitte ändere den Fahrzeugstandort und versuche es noch einmal, oder kontaktiere unser ServiceTeam.",

      "violation.car.owner.notNull": "Fahrzeug muss einem Halter zugeordnet werden.",

      "violation.car.plateUniqueValidator.plate.assertTrue": "Autokennzeichen bereits im System",

      "violation.car.registrationCertificate.plate.pattern": "Bitte gültiges Kennzeichen eingeben.",

      "violation.car.registrationCertificate.plate.plateRegion": "Die Region des Kennzeichens ist unbekannt.",

      "violation.car.releaseCheck.availableUntil.assertTrue": "Rückgabezeit ist zu früh, bitte wähle ein größeres Zeitfenster.",

      "violation.car.releaseCheck.basicPrice.notNull": "Preis noch nicht hinterlegt. Bitte trage einen Preis/km ein bevor das Fahrzeug freigegeben werden kann.",

      "violation.car.releaseCheck.doorsClosed.assertTrue": "Türen sind noch offen! Bitte schließe sie um fortzufahren.",

      "violation.car.releaseCheck.fuelCardIn.assertTrue": "Tankkarte ist nicht in der Halterung! Bitte stecke sie korrekt zurück um fortzufahren.",

      "violation.car.releaseCheck.fuelLevel.min": "Tankstand unter 25%, bitte tanke das Fahrzeug auf und versuche es dann erneut.",

      "violation.car.releaseCheck.ignitionOff.assertTrue": "Zündung ist an! Bitte ausschalten um fortzufahren.",

      "violation.car.releaseCheck.keyFobIn.assertTrue": "Schlüssel steckt nicht in der Halterung! Bitte stecke ihn ordentlich zurück um fortzufahren.",

      "violation.car.releaseCheck.online.assertTrue": "Verbindung verloren. Bitte ändere den Fahrzeugstandort und versuche es noch einmal, oder kontaktiere unser ServiceTeam.",

      "violation.car.releaseCheck.paymentMethodExists.assertTrue": "Bitte gültige Zahlungsmethode eingeben.",

      "violation.car.releaseCheck.windowsClosed.assertTrue": "Fenster sind noch offen! Bitte schließe sie um fortzufahren.",

      "violation.clientVersionCheck.version.min": "Deine App-Version wird leider nicht mehr unterstützt. Bitte führe ein Update durch.",

      "violation.device.alreadyPairedValidator.device.assertTrue": "Dein Nutzerkonto ist nicht mit diesem Smartphone verbunden. Bitte kontaktiere unser Service Team, um fortzufahren.",

      "violation.driversLicenseTokenData.validation.validToken.assertTrue": "Deine Session ist ungültig oder abgelaufen. Bitte versuche es erneut.",

      "violation.fleetAdmin.validPasswordValidator.password.assertTrue": "Bitte trage ein gültiges Passwort ein (mind. 6 Zeichen, inkl. mind. einer Ziffer)",

      "violation.forgotPasswordResource.resetPasswordCheck.validToken.assertTrue": "Dieser Link ist nicht mehr gültig. Bitte kontaktiere unser Service-Team für nähere Informationen.",

      "violation.installation.mechanic.notNull": "Die Installation muss einem Mechaniker zugeordnet werden.",

      "violation.paymentMethod.existingPaymentMethod.isBlocked.assertFalse": "Diese Zahlungsmethode kann nicht hinzugefügt werden. Bitte wähle eine andere.",

      "violation.paymentResource.paymentMethodTypeCheck.paymentMethodNotAllowed.assertFalse": "Diese Zahlungsmethode kann nicht hinzugefügt werden. Bitte wähle eine andere.",

      "violation.paymentResource.paymentMethodTypeCheck.tariffMissing.assertFalse": "Du musst einen Tarif auswählen bevor du eine Zahlungsmethode hinzufügen kannst.",

      "violation.phoneNumber.noNewNumberWhenPairedValidator.phoneNumber.assertTrue": "Nicht möglich. Dein Nutzerkonto ist mit diesem Smartphone verbunden. Bitte kontaktiere unser Service Team, um fortzufahren.",

      "violation.phoneNumber.userPhoneNumberUniqueValidator.phoneNumber.assertTrue": "Diese Handynummer ist ungültig oder bereits einem aktivem Nutzerkonto hinterlegt. Bitte verwende eine andere oder melde dich mit dem bestehenden Nutzerkonto an.	",

      "violation.phoneNumber.userPhoneNumberUniqueValidator.phoneNumberInactive.assertTrue": "Diese Handynummer wurde bereits einem Nutzerkonto zugeordnet. Bitte wende dich an den Support, um fortzufahren.",

      "violation.phoneNumber.validPhoneNumberValidator.phoneNumber.assertTrue": "Ungültiger Code! Bitte stelle sicher, dass du die richtige Handynummer angegeben hast oder fordere einen neuen Code an.",

      "violation.phoneNumber.validPhoneNumberValidator.smsLimitExceeded.assertFalse": "Telefon-Verifizierungsversuche überschritten.",

      "violation.phoneNumber.validVerificationCodeValidator.phoneNumber.assertTrue": "Bitte gebe den richtigen Bestätigungscode ein",

      "violation.rentalResource.serviceTripCheck.userUnauthorized.assertFalse": "Tut mir leid, du darfst leider keinen ServiceTrip durchführen. Bitte starte eine reguläre Miete.",

      "violation.sepa.ibanValidator.sepa.assertTrue": "Bitte gib eine gültige IBAN ein.",

      "violation.serviceCircle.serviceCircleValidator.pricingEmpty.assertTrue": "Die Änderung von Preisen für Service UserGroups wird nicht unterstützt",

      "violation.trip.cancellation.reserved.assertTrue": "Nur gültige Reservierungen können storniert werden.",

      "violation.trip.driverQualificationValidator.addressVerified.assertTrue": "Bitte bestätige deine Adresse um fortzufahren.",

      "violation.trip.driverQualificationValidator.creditCheck.assertTrue": "Bitte kontaktiere unser ServiceTeam um deine Daten zu vervollständigen.",

      "violation.trip.driverQualificationValidator.identityChecked.assertTrue": "Bitte kontaktiere unser ServiceTeam um deine Daten zu vervollständigen.",

      "violation.trip.driverQualificationValidator.paymentMethodExists.assertTrue": "Zahlung wurde nicht verknüpft! Bitte trage eine gültige Zahlungsmethode ein um fortzufahren.",

      "violation.trip.driverQualificationValidator.phoneNumberVerified.assertTrue": "Bitte bestätige deine Telefonnummer auf diesem Gerät um fortzufahren.",

      "violation.trip.driverQualificationValidator.positiveBalance.assertTrue": "Unzureichende Finanzmittel. Bitte stelle sicher, dass dein Nutzerkonto kein negatives Guthaben aufweist, bevor du eine neue Miete startest.",

      "violation.trip.driverQualificationValidator.validLicence.assertTrue": "Dein Führerschein muss bestätigt werden, um Fahrzeuge zu mieten. Bitte prüfen den Status in deinem Nutzerkonto.",

      "violation.trip.finishCheck.bitLessFuelOnReturn.assertFalse": "Tank-Service (2,80 €/Liter) wählen",

      "violation.trip.finishCheck.correctLocation.assertTrue": "Zu weit vom Abgabeort entfernt! Bitte prüfe die Rückgabezone oder beende die Miete dennoch; Dabei können Gebühren entstehen.",

      "violation.trip.finishCheck.endCheckImagesUploaded.assertTrue": "Deine Rundumfotos sind noch nicht bei uns angekommen. Bitte überprüfe deine Verbindung und wische noch einmal, um den Vorgang abzuschließen.",

      "violation.trip.finishCheck.extremelyLowFuelLevel.assertFalse": "Ich wähle den Tank-Service  <10% (50,- €)",

      "violation.trip.finishCheck.finishLocationAllowed.assertTrue": "Ich habe das Fahrzeug zurückgebracht",

      "violation.trip.finishCheck.fuelLevel.min": "Ich wähle den Tank-Service (5 €)",

      "violation.trip.finishCheck.fuelLevelOBI.min": "Ich wähle den Tank-Service (15 €)",

      "violation.trip.finishCheck.initialUnlockIsSet.assertTrue": "Das Fahrzeug muss erst einmal entsperrt werden, bevor die Miete beendet werden kann.",

      "violation.trip.finishCheck.insideArea.assertTrue": "Ich wähle den Rückbringservice (10€ + 4.9€/km)",

      "violation.trip.finishCheck.keyFobIn.assertTrue": "Die Miete kann nur beendet werden, wenn der Schlüssel korrekt in der Halterung im Handschuhfach hinterlegt ist (neben der Tankkarte). Bitte prüfe dies und versuche es dann erneut.",

      "violation.trip.finishCheck.online.assertTrue": "Es konnte leider keine Verbindung zum Fahrzeug hergestellt werden. Bitte versuche es erneut oder kontaktiere unseren Support.",

      "violation.trip.finishCheck.openDamageReport.assertFalse": "Du hast einen offenen Schaden. Bitte prüfe deine SMS, um den Schadensbericht auszufüllen.",

      "violation.trip.finishCheck.payAsReserved.assertFalse": "Ich beende meine Miete vorzeitig.",

      "violation.trip.postReservation.accessToken.assertTrue": "Das Fahrzeug kann zum jetzigen Zeitpunkt nicht reserviert werden.",

      "violation.trip.postReservation.accessToken.notNull": "Ups... etwas ist schiefgelaufen. Bitte versuche es später nochmal.",

      "violation.trip.postReservation.adyenRequestRejected.assertFalse": "Zahlungsanfrage wurde abgelehnt.",

      "violation.trip.postReservation.adyenRequestTimedOut.assertFalse": "Zahlungsanfrage ausgelaufen.",

      "violation.trip.postReservation.blockedPaymentConfirmed.assertTrue": "Deine Bank hat diese Transaktion abgelehnt. Bitte kontaktiere deine Bank für mehr Informationen oder versuche es mit einem anderen Zahlungsmittel.",

      "violation.trip.rating.onlyFinished": "Die Miete muss erst beendet werden, bevor du eine Bewertung abgeben kannst.",

      "violation.trip.rentalReservationValidator.addressVerified.assertTrue": "Bitte bestätige deine Adresse um fortzufahren.",

      "violation.trip.rentalReservationValidator.backByConflictsWithBooking.assertFalse": "Dieses Fahrzeug ist für den gewählten Zeitraum bereits reserviert. Bitte wähle ein anderes Fahrzeug oder eine andere Zeit.",

      "violation.trip.rentalReservationValidator.blockedByUpcomingBooking.assertFalse": "Dieses Fahrzeug ist bereits reserviert, bitte wähle ein anderes.",

      "violation.trip.rentalReservationValidator.carAvailable.assertTrue": "Ups.. das ausgewählte Fahrzeug ist leider nicht mehr verfügbar.",

      "violation.trip.rentalReservationValidator.carStatusReleased.assertTrue": "Das Fahrzeug wurde leider offline gestellt. Bitte wähle ein anderes Fahrzeug.",

      "violation.trip.rentalReservationValidator.creditworthinessApproved.assertTrue": "Bitte kontaktiere unser ServiceTeam um deine Daten zu vervollständigen.",

      "violation.trip.rentalReservationValidator.identityChecked.assertTrue": "Dein Name, Geburtstag und deine Adresse konnten bisher nicht verifiziert werden. Bitte kontaktiere uns via LiveChat um deine Registrierung abzuschließen.",

      "violation.trip.rentalReservationValidator.online.assertTrue": "Das Fahrzeug ist aktuell nicht verfügbar und kann daher nicht gemietet werden.",

      "violation.trip.rentalReservationValidator.paymentMethodExists.assertTrue": "Bitte füge eine gültige Zahlungsmethode hinzu um fortzufahren.",

      "violation.trip.rentalReservationValidator.phoneNumberVerified.assertTrue": "Es kann keine Reservierung angelegt werden, solange keine Telefonnummer verifiziert ist. Bitte hinterlege eine Telefonnummer in deinem Nutzerkonto und versuche es erneut.",

      "violation.trip.rentalReservationValidator.positiveBalance.assertTrue": "Unzureichende Finanzmittel. Bitte stelle sicher, dass dein Nutzerkonto kein negatives Guthaben aufweist, bevor du eine neue Miete startest.",

      "violation.trip.rentalReservationValidator.serviceTripAllowed.assertTrue": "Der Nutzer ist nicht berechtigt Service-Fahrten für dieses Fahrzeug durchzuführen.",

      "violation.trip.rentalReservationValidator.userMarkedForFraud.assertFalse": "😐 Leider ist diese Aktion momentan nicht möglich. Für weitere Informationen kontaktiere bitte unser Service Team.",

      "violation.trip.rentalReservationValidator.userMarkedForFraud.assertTrue": "Leider ist die gewünschte Aktion derzeit nicht möglich. Bitte kontaktiere unser ServiceTeam für nähere Informationen.",

      "violation.trip.rentalReservationValidator.validLicence.assertTrue": "Dein Führerschein muss bestätigt werden, um Fahrzeuge zu mieten. Bitte prüfe den Status in deinem Nutzerkonto.",

      "violation.trip.rentalReservationValidator.watchlistCheckPassed": "Bitte stelle sicher, dass dein Nutzerkonto vollständig ist. Wenn du Hilfe benötigst, kontaktiere gern unseren Kundenservice.",

      "violation.trip.rentalReservationValidator.withinOpeningHours.assertTrue": "Miete nicht möglich. Start- und/oder Endzeit der Buchungsfrage liegen außerhalb der Öffnungszeiten.",

      "violation.trip.rentalReservationValidator.youngDriver.assertFalse": "Bitte habe etwas Geduld. Dein Führerschein muss vor mindestens 2 Jahren ausgestellt worden sein. Du wirst automatisch bestätigt und benachrichtigt, sobald das geschieht.",

      "violation.trip.reservationValidator.manualGearRestricted.assertFalse": "Entschuldige, dieses Fahrzeug hat nur eine manuelle Schaltung und es sieht so aus, als dürftest du diese nicht fahren. Falls das ein Fehler ist, kontaktiere bitte unseren Support.",

      "violation.user.account.paymentMethods.sepa.ibanValid": "Bitte gib eine gültige IBAN ein.",

      "violation.user.archiveCheck.hasOpenBookingRequests.assertFalse": "Es scheint als hättest du offene Rechnungen, bitte kontaktiere unseren Support um fortzufahren.",

      "violation.user.archiveCheck.hasOpenTransactions.assertFalse": "Kann nicht fortgesetzt werden, da entweder eine offene oder eine nicht beglichene Rechnung vorliegt. Bitte versuchen Sie es später erneut, da dies von der Bestätigung der Zahlung durch die Bank abhängig ist.",

      "violation.user.dateOfBirth.min": "Um ein Fahrzeug zu mieten benötigst du einen Führerschein der Klasse B, der mindestens 2 Jahre alt ist.",

      "violation.user.device.alreadyPaired": "Dein Nutzerkonto ist nicht mit deinem aktuellen Gerät verknüpft. Bitte kontaktiere unser ServiceTeam um fortzufahren.",

      "violation.user.email.notNull": "Bitte gebe eine gültige E-Mail Adresse in deinem Nutzerkonto an.",

      "violation.user.email.pattern": "Bitte gebe eine gültige E-Mail Adresse in deinem Nutzerkonto an.",

      "violation.user.email.userEmail.Unique": "Es scheint, als hätten wir bereits ein Nutzerkonto unter dieser E-Mail Adresse. Möchtest du das Passwort dafür zurücksetzen?",

      "violation.user.email.userEmailUnique": "Es scheint, als hätten wir bereits ein Nutzerkonto unter dieser E-Mail Adresse. Möchtest du das Passwort dafür zurücksetzen?",

      "violation.user.emailVerificationCheck.codeNotMatches.assertFalse": "Verifizierungs-Code stimmt nicht überein",

      "violation.user.emailVerificationCheck.codeWasNotGenerated.assertFalse": "Derzeit keine ausstehende E-Mail-Verifizierung.",

      "violation.user.emailVerificationCheck.maxVerificationAttemptsPassed.assertFalse": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktiere unser Service Team.",

      "violation.user.firstName.notNull": "Bitte gebe einen gültigen Vornamen in deinem Nutzerkonto an.",

      "violation.user.firstName.size": "Bitte gebe einen gültigen Vornamen in deinem Nutzerkonto an.",

      "violation.user.lastName.size": "Dein Nachname muss mindestens 2 Zeichen enthalten.",

      "violation.user.password.validPassword": "Bitte gib ein gültiges Passwort an (mind. 6 Zeichen, incl. mindestens 1 Zahl).",

      "violation.user.phoneNumber.phoneNumber.noNewNumberWhenPaired": "Nicht gestattet, dein Gerät ist bereits verknüpft. Bitte kontaktiere unseren Service um fortzufahren.",

      "violation.user.phoneNumber.phoneNumber.validVerificationCode": "Ungültiger Code, bitte stelle sicher, dass du den richtigen Code eingegeben hast, oder fordere einen neuen an.",

      "violation.user.phoneNumber.userPhoneNumberUnique": "Diese Nummer kann leider nicht genutzt werden, bitte wähle eine andere.",

      "violation.user.phoneNumber.validPhoneNumber": "Bitte füge eine gültige Mobilfunknummer hinzu.",

      "violation.user.phoneNumber.validVerificationCode": "Der Verifizierungs-Code ist ungültig. Bitte fordere einen neuen an.",

      "violation.user.referredBy.referralCodeExists": "Es scheint, als würde dieser Code nicht exisiteren. Bitte prüfe ihn noch einmal oder kontaktiere unseren Support.",

      "violation.user.requireDevice.hasPairedDevice.assertTrue": "Bitte verifiziere deine Nummer über dieses Gerät um fortzufahren.",

      "violation.user.requireDevice.isCorrectDevice.assertTrue": "Dieses Gerät ist für diese Aktion nicht autorisiert. Bitte kontaktiere unser ServiceTeam.",

      "violation.user.sendVerificationCodeCheck.smsLimitExceeded.assertFalse": "Telefon-Verifizierungsversuche überschritten.",

      "violation.user.userEmailUniqueValidator.email.assertTrue": "Es scheint, als sei deine E-Mail Adresse bereits hinterlegt. Möchtest du dein Passwort zurücksetzen?",

      "violation.user.userEmailUniqueValidator.emailInactive.assertTrue": "Diese E-Mail wurde bereits einem Nutzerkonto zugeordnet. Bitte wende dich an den Support, um fortzufahren.",

      "violation.user.validPasswordValidator.password.assertTrue": "Bitte trage ein gültiges Passwort ein (mind. 6 Zeichen, inkl. mind. einer Ziffer) ",

      "violation.validatePaymentMethods.haveBlockedPaymentIfPayInOnly": "bitte wählest du den Zeitrahmen für die Reservierung.",

      "violation.validatePaymentMethods.haveBlockedPaymentIfPayInOnly.assertTrue": "bitte wählest du den Zeitrahmen für die Reservierung.",

      "wait": "Einen Augenblick bitte..",

      "web.copy": "kopieren",

      "web.edit": "ändern",

      "web.external.browser.title": "Bitte fahre in einem (anderen) Web-Browser fort.",

      "web.external.button.section": "Klicke auf folgenden Button",

      "web.external.button.title": "Registrierung im Browser fortfahren",

      "web.external.email.section": "Schau bitte in dein E-Mail-Postfach",

      "web.external.email.section.desc": "Klicke auf den Button in der E-Mail, die wir dir soeben an diese Adresse gesendet haben:",

      "web.external.ignore.link": "Ignorieren & fortfahren",

      "web.external.link.section": "Oder",

      "web.external.link.section.desc": "Kopiere folgenden Link und öffne diesen in einem (anderen) Web-Browser.",

      "whatsapp": "LiveChat (Whatsapp)",

      "wj.copy.no": "Abbrechen",

      "wj.copy.title": "In Zwischenablage speichern",

      "wj.copy.yes": "Kopieren",

      "wj.email.code.placeholder": "4-stelligen Code eingeben",

      "wj.email.verify.desc": "Gib den Code ein, den wir soeben an diese E-Mail-Adresse gesendet haben:",

      "wj.email.verify.title": "E-Mail bestätigen",

      "wj.link.copied": "In die Zwischenablage kopiert",

      "wj.map.filter.violation.duration": "Zeitraum muss min. 1 Stunde betragen.",

      "wj.map.filter.violation.min": "Stelle sicher, dass die angegebenen Daten korrekt sind.",

      "wj.map.filter.violation.order": "Stelle sicher, dass die angegebenen Daten korrekt sind.",

      "wj.map.filter.violation.period": "Buchung muss kürzer sein",

      "wj.phone.code.placeholder": "4-stelligen SMS-Code eingeben",

      "wj.phone.verify.code.desc": "Gib den Code ein, den wir soeben per SMS an diese Handy-Nr gesendet haben:",

      "wj.phone.verify.code.title": "SMS-Code eingeben",

      "wj.pin.desc": " ",

      "wj.pin.placeholder": "4-stelligen PIN eingeben",

      "wj.pin.title": "Zugangsdaten",

      "wj.schufa.birthday.violation.max": "Prüfe, ob das Datum korrekt ist.",

      "wj.schufa.birthday.violation.min": "Prüfe, ob das Datum korrekt ist.",

      "wj.upload": "Bild hochladen",

      "wj.value.copied": "In die Zwischenablage kopiert: %s",

      "wma.trackingPage.extendedArea.name": "Anfahrt, erweitertes Gebiet",

      "yes": "Ja",

      "yesterday": "gestern",

    },
    "deformal": {
      "ADD": "HINZUFÜGEN",

      "AT": "Österreich",

      "Ab": "Ab",

      "BE": "Belgien",

      "BG": "Bulgarien",

      "CH": "Schweiz",

      "CY": "Zypern",

      "CZ": "Tschechien",

      "Camera": "Kamera",

      "DE": "Deutschland",

      "DK": "Dänemark",

      "DL.button.text": "Führerschein jetzt scannen",

      "DL.desr": "Lassen Sie Ihre Fahrerlaubnis bestätigen, indem Sie Ihren Führerschein jetzt hochladen.",

      "DL.issuecountry.placeholder": "Ausstellungsland ",

      "DL.paper.country.notvalid": "Wir unterstützen nur Papierführerscheine aus Deutschland und Österreich.\nBitte versuchen Sie es erneut mit einem Führerschein im Plastikformat.",

      "DL.paper.date.notvalid": "Rosa Führerscheine im Papierformat für Personen, die nach 1953 geboren sind, können digital nicht verarbeitet werden. Bitte probieren Sie es mit einem Führerschein im Plastikformat.",

      "DL.paper.stepFour": "Achten Sie auf die Lichtverhältnisse und nehmen Sie alles ab, was Ihr Gesicht verdeckt (Brille, Hut etc.).",

      "DL.paper.stepOne": "Gültig nur bei Geburtsjahr vor 1953.",

      "DL.paper.stepThree": "Nehmen Sie je ein Foto von der kompletten Vorder- und Rückseite auf.",

      "DL.paper.stepTwo": "Legen Sie Ihren vollständig aufgeklappten Führerschein auf einen farblich neutralen Untergrund.",

      "DL.stepFour": "Achten Sie auf die Lichtverhältnisse und nehmen Sie alles ab, was Ihr Gesicht verdeckt (Brille, Hut etc.).",

      "DL.stepOne": "Halten Sie Ihren persönlichen Führerschein (nicht Ihren Personalausweis!) im Original bereit.",

      "DL.stepThree": "Legen Sie Ihren Führerschein auf einen farblich neutralen Untergrund.",

      "DL.stepTwo": "Vorläufige und Nicht-EU-Führerscheine werden nicht akzeptiert.",

      "DL.title": "Fahrerlaubnis",

      "Did.you.mean": "Meinen Sie",

      "EE": "Estland",

      "EL": "Griechenland",

      "ES": "Spanien",

      "EUR": "€",

      "FI": "Finnland",

      "FR": "Frankreich",

      "FRM_Franklin_Partner_Fix": "Franklin Partner Fix",

      "GB": "Großbritannien",

      "GR": "Griechenland",

      "HR": "Kroatien",

      "HU": "Ungarn",

      "ID.button.text": "Ausweisdokument jetzt scannen",

      "ID.desr": "Wählen Sie, mit welchem Dokumenten-Typ Sie sich ausweisen möchten.",

      "ID.id_card.stepFour": "Ihr Ausweis muss in einem EU-Land ausgestellt worden sein.",

      "ID.id_card.stepOne": "Halten Sie Ihren persönlichen Personalausweis oder Aufenthaltstitel im Original bereit.",

      "ID.id_card.stepThree": "Achten Sie auf die Lichtverhältnisse und nehmen Sie alles ab, was Ihr Gesicht verdeckt (Brille, Hut etc.).",

      "ID.id_card.stepTwo": "Legen Sie Ihren Ausweis auf einen farblich neutralen Untergrund.",

      "ID.manual.option": "Ich habe kein Dokument mit meiner Adresse",

      "ID.passport.stepOne": "Halten Sie Ihren persönlichen Reisepass im Original bereit.",

      "ID.passport.stepThree": "Achten Sie auf die Lichtverhältnisse und nehmen Sie alles ab, was Ihr Gesicht verdeckt (Brille, Hut etc.).",

      "ID.passport.stepTwo": "Legen Sie Ihren Reisepass auf einen farblich neutralen Untergrund.",

      "ID.stepOne": "Ich habe ein in der EU ausgestelltes Ausweisdokument (Personalausweis, Reisepass oder Aufenthaltstitel).",

      "ID.stepThree": "Achten Sie auf die Lichtverhältnisse und nehmen Sie alles ab, was Ihr Gesicht verdeckt (Brille, Hut etc.)",

      "ID.stepTwo": "Legen Sie Ihr Ausweisdokument auf einen farblich neutralen Untergrund.",

      "ID.title": "Ausweisdokument",

      "ID.type.card": "Personalausweis oder Aufenthaltstitel",

      "ID.type.label": "Art des Dokuments wählen",

      "ID.type.passport": "Reisepass",

      "ID_CARD": "Personalausweis",

      "IE": "Irland",

      "IS": "Island",

      "IT": "Italien",

      "LI": "Liechtenstein",

      "LT": "Litauen",

      "LU": "Luxemburg",

      "LV": "Lettland",

      "MC": "Monaco",

      "MR": "Herr",

      "MRS": "Frau",

      "MT": "Malta",

      "NL": "Niederlande",

      "NO": "Norwegen",

      "Other": "Andere",

      "PASSPORT": "Reisepass",

      "PL": "Polen",

      "PT": "Portugal",

      "RO": "Rumänien",

      "SE": "Schweden",

      "SI": "Slowenien",

      "SK": "Slovensky",

      "UK": "Vereinigtes Königreich",

      "Uhr": "Uhr",

      "Update.email": "Update",

      "VISA": "Aufenthaltstitel",

      "about.dialog": "Über GETAWAY",

      "about.url": "https://get-a-way.com/getaway-carsharing?utm_source=app",

      "accepted.invitation": "ANGENOMMENE EINLADUNGEN",

      "account-deposit.warning.btn": "Kaution hinterlegen",

      "account-deposit.warning.desc": "Um Ihr Nutzerkonto freizuschalten, hinterlegen Sie bitte jetzt die erstattungsfähige Kaution.<br><br> ✓ wird erstattet nach Vertragsende<br> ✓ mit Kautionsrechnung als Pdf<br> ✓ sichere Zahlung per PayPal, Kreditkarte uvm.",

      "account.deposit.description": "Um Ihr Nutzerkonto freizuschalten, hinterlegen Sie bitte jetzt die erstattungsfähige Kaution. ✓ wird erstattet nach Vertragsende ✓ mit Kautionsrechnung als Pdf",

      "account.low.schufa.desc": "Die Freischaltung dieser Zahlungsmethode ist fehlgeschlagen. Die Bonitätsprüfung ergab keine Übereinstimmung. Leider können wir Ihnen derzeit keine Alternative anbieten, um die Registrierung abzuschließen.\n\nWir bitten, von weiteren Registrierungsversuchen abzusehen.",

      "account.org.pending.payment.note": "Ihre Zahlung wird geprüft. Sie erhalten eine E-Mail, sobald es Neuigkeiten gibt.",

      "account.payment.blocked.desc": "Um diese Zahlungsmethode freizuschalten, begleichen Sie bitte alle offenen Forderungen. Bei Rückfragen kontaktieren Sie user Service Team.",

      "account.sepaVerification.mismatch.dialog.message": "Ihre Bankverbindung %s wird durch %s ersetzt.",

      "account.sepaVerification.mismatch.dialog.no": "Abbrechen",

      "account.sepaVerification.mismatch.dialog.title": "Bankverbindung ändern?",

      "account.sepaVerification.mismatch.dialog.yes": "Ändern",

      "account.sepaVerification.warning.btn": "Jetzt bestätigen",

      "account.sepaVerification.warning.desc": "Um diese Bankverbindung zu bestätigen, führe bitte die 1-Euro-Verifizierung durch.",

      "accountHolder": "Kontoinhaber",

      "action.permission.button.title": "Neu anmelden",

      "action.permission.details": "Wir haben eine Fehlermeldung erhalten und arbeiten bereits an der Lösung. Bitte beenden Sie jetzt die App und starten Sie diese neu. \n\nSollte das Problem weiterhin auftreten, kontaktieren Sie bitte unser Service Team.",

      "action.permission.title": "Etwas hat nicht funktioniert.",

      "action.permission.yes": "Ja",

      "add": "HINZUFÜGEN",

      "add.car.enhancement.wizard.description": "Je besser Ihr Auto ausgestattet ist, desto eher wird es gemietet.",

      "add.car.enhancement.wizard.title": "Aktualisieren Sie die Ausstattung Ihres Autos",

      "add.damage.wizard.description": "Bitte protokollieren Sie alle aktuellen Mängel am Auto, um für eventuelle Neuschäden reibungsfreier entschädigt zu werden.",

      "add.damage.wizard.footer": "Ich bestätige, dass das Auto bis auf die bereits aufgeführten Mängel schadenfrei ist.",

      "add.damage.wizard.title": "Schäden & Mängel",

      "add.damage.wizard.update": "ÜBERNEHMEN",

      "add.damages.footnote": "Wenn keine der Optionen passt, klicken Sie bitte oben rechts auf das Support-Symbol, um uns zu kontaktieren",

      "add.payment.method.success": "Danke, Ihre Zahlungsmethode ist aktualisiert worden.",

      "add.tariff": "Zur Tarifwahl",

      "add.to.apple.calendar": "Zum Apple Kalender hinzufügen",

      "add.to.calendar.title": "Kalender",

      "add.to.device.calendar": "Zum Gerätekalender hinzufügen",

      "add.to.google.calendar": "Zum Google Kalender hinzufügen",

      "add.to.outlook.calendar": "Zum Outlook-Kalender hinzufügen",

      "add.to.yahoo.calendar": "Zum Yahoo-Kalender hinzufügen",

      "addpayment.card.desc": "Kredit-/Debitkarte hinzufügen",

      "addpayment.card.title": "Visa oder MasterCard",

      "addpayment.directdebit.desc": "Girokonto hinzufügen",

      "addpayment.paypal": "Paypal",

      "addpayment.paypal.desc": "Verbinden Sie Ihr Paypal-Konto",

      "address": "Meldeadresse",

      "address.austria.streetNum.label": "Haus/Stiege/Tür",

      "address.required": "Um fortzufahren, fügen Sie bitte Ihre Adresse hinzu.",

      "address.unavailable": "Abholzone anzeigen",

      "addressCheck.dialog.message": "Die Überprüfung Ihrer Meldeadresse war nicht erfolgreich. \n\nBitte kontaktieren Sie unser Service Team.",

      "addressCheck.dialog.title": "Überprüfung der Meldeadresse",

      "addressCheck.dialog.tryAgain": "ERNEUT VERSUCHEN",

      "addressCheck.dialog.yes": "OK",

      "addressProof.button.text": "Dokument hochladen",

      "addressProof.desr": "Meine Adresse durch ein offizielles Dokument bestätigen lassen",

      "addressProof.stepOne": "Schreiben vom Finanzamt, von deiner Bank, etc.",

      "addressProof.stepTwo": "Adresse und Name gut lesbar",

      "addressProof.title": "Dokument mit Adresse",

      "addressSearch.cancel.text": "Abbrechen",

      "addressSearch.current.label": "Mein Standort",

      "addressSearch.search.placeholder": "Adresse suchen",

      "always.open": "rund um die Uhr",

      "android.update.dialog.message": "Es ist eine neue Version erhältlich. Bitte aktualisieren Sie auf die neuste Version.",

      "android.update.dialog.no": "Später",

      "android.update.dialog.title": "Update erhältlich",

      "android.update.dialog.yes": "Update",

      "api_error.active_invite_not_found": "Einladungscode nicht gefunden oder inaktiv",

      "api_error.block_payment_parameter_missing": "Zahlung fehlgeschlagen. Bitte mit alternativer Zahlungsmethode oder später erneut versuchen.",

      "api_error.block_payment_required": "Zahlung fehlgeschlagen. Bitte mit alternativer Zahlungsmethode oder später erneut versuchen.",

      "api_error.booking.combined_signup_not_allowed": "Die Registrierung ist gesperrt",

      "api_error.booking.confirm.blocked_payment_failed": "Problem mit autorisiertem Betrag. Buchung konnte nicht bestätigt werden.",

      "api_error.booking.confirm.fleet_not_allowed_for_circle": "Fahrzeug ist für diesen Nutzerkreis nicht verfügbar.",

      "api_error.booking.confirm.rental_type_not_matching": "Falscher Nutzerkreis-Typ für diese Buchung",

      "api_error.booking.payin.from": "Bitte wähle eine spätere Startzeit, um fortzufahren",

      "api_error.booking.update.conflicting_booking_for_car": "Es besteht bereits eine Reservierung für diesen Zeitraum.",

      "api_error.booking.update.conflicting_booking_for_user": "Nutzer hat bereits eine Reservierung in diesem Zeitraum",

      "api_error.booking.update.conflicting_rental_for_car": "Fahrzeug ist bereits in Miete",

      "api_error.booking.update.conflicting_rental_for_user": "Nutzer ist bereits in Miete",

      "api_error.booking.update.invalid_interval": "Verlängerung nicht möglich, es besteht bereits Folgebuchung.",

      "api_error.brand.sunset.bookings_restricted": "Aufgrund der Abschaltung der Marke kann diese Reservierung leider nicht angelegt werden.",

      "api_error.brand.sunset.rentals_restricted": "Aufgrund der Abschaltung der App kann diese Miete nicht angelegt werden.",

      "api_error.brand.sunset.user_profile_update_restricted": "Die Aktualisierung des Nutzerkontos ist aufgrund der Abschaltung der Marke eingeschränkt",

      "api_error.cantamen.invalid_password": "Authentifizierung notwendig: Bitte geben Sie Ihr aktuelles Passwort an, mit dem Sie sich in der (Web-)App einloggen.",

      "api_error.captcha-check-failed": "Wir konnten nicht nachweisen, dass Sie ein Mensch sind. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support",

      "api_error.carUnavailable": "dieses Auto ist nicht zur Verfügung bitte ein anderes wählen",

      "api_error.email_code.no_more_attempts": "Keine weiteren Versuche",

      "api_error.invalid_tariff": "Tarif nicht erlaubt",

      "api_error.invitation.link_expired": "Einladungslink ist abgelaufen oder Einladungslimit überschritten",

      "api_error.invites_disabled_for_circle": "Neue Einladungen deaktiviert",

      "api_error.not_available": "Diese Aktion kann nicht ausgeführt werden.",

      "api_error.not_available_forPayin": "Diese Aktion kann mit der momentan ausgewählten Zahlungsmethode nicht ausgeführt werden.",

      "api_error.org.duplicate": "Firma mit dieser Registernummer existiert bereits.",

      "api_error.partners.new_registration.rejected": "Ihr aktueller Tarif erlaubt keine Tarifpartner. Bitte kontaktieren Sie den Support für Bestandskunden für weitere Informationen. Wir bitten die Unannehmlichkeit zu entschuldigen.",

      "api_error.partners.partners_limit_exceeded": "Die maximale Anzahl von Tarifpartnern wurde erreicht. Bitte kontaktieren Sie den Support für weitere Informationen.",

      "api_error.payin_notAllowed": "Bitte wähle eine spätere Startzeit, um fortzufahren",

      "api_error.payment.3ds_required": "Bitte authentifiziere jetzt deine Kreditkarte (Händlername \"GETAWAY\"), um fortzufahren.\n\nDie Authentifizierung löst keine Zahlung aus.",

      "api_error.payment.adyen_3ds_response_not_received": "Die Antwort unseres Zahlungsdienstleisters hat zu lange gedauert. Bitte versuchen Sie es erneut.",

      "api_error.payment.adyen_rejected_request": "Zahlungsanfrage wurde abgelehnt.",

      "api_error.payment.adyen_response_not_received": "Zahlungsanfrage ausgelaufen.",

      "api_error.payment.card_validation_attempts_exceeded": "Verifizierung der Zahlungsmethode fehlgeschlagen, bitte kontaktieren Sie den Support",

      "api_error.payment.card_validation_failed": "Verifizierung fehlgeschlagen",

      "api_error.payment.method_not_allowed": "Deine aktive Zahlungsmethode wird in diesem Land derzeit nicht unterstützt, bitte füge eine andere hinzu.",

      "api_error.payment.paypal_validation_attempts_exceeded": "PayPal Verifizierung fehlgeschlagen.",

      "api_error.payment.paypal_validation_failed": "PayPal Verifizierung zu oft fehlgeschlagen. Bitte kontaktiere unser Service Team.",

      "api_error.phoneNumber.isValid": "Die eingegebene Telefonnummer ist ungültig. Bitte geben Sie eine neue Nummer ein",

      "api_error.rental.update.cannot_reduce_back_by_if_pay_as_reserved": "Die Rückgabezeit kann nicht verkürzt werden, da die gesamte gebuchte Dauer berechnet wird.",

      "api_error.rental.update.invalid_back_by": "Falsch eingegebene Zeit",

      "api_error.ride.pooling.no_offer": "Es sind keine Fahrzeuge in Ihrer Nähe",

      "api_error.ride_pooling.no_offer": "Es sind keine Fahrzeuge in Ihrer Nähe",

      "api_error.ride_pooling.no_offer.has_ongoing_trip": "Sie haben bereits eine aktive Fahrt oder Reservierung",

      "api_error.ride_pooling.no_offer.no_seats": "Es gibt keine freien Plätze für diese Fahrt",

      "api_error.ride_pooling.no_offer.resolved_same_stop_for_pickup_and_release": "Einstiegs- und Ausstiegsort sind identisch",

      "api_error.ryd.digital_fuel.car_position_unknown": "Das Fahrzeug kann derzeit nicht geortet werden, daher lässt sich keine Tankstelle vorschlagen.",

      "api_error.ryd.digital_fuel.not_enabled": "Digitales Tanken ist für dieses Fahrzeug nicht verfügbar.",

      "api_error.ryd.digital_fuel.session_not_cancellable": "Dieser Tankvorgang kann nicht mehr abgebrochen werden.",

      "api_error.ryd.digital_fuel.tank_full": "Der Tank ist bereits voll.",

      "api_error.ryd.digital_fuel.trip_not_started": "Tanken ist erst nach der Fahrzeugübernahme möglich.",

      "api_error.user.cw_address_missing": "Bitte geben Sie Ihre Adresse ein, um fortzufahren.",

      "api_error.user.email.change_not_allowed": "Diese E-Mail Adresse kann nicht genutzt werden.",

      "api_error.user.iban.duplicate": "Diese IBAN kann nicht registriert werden. Möglicherweise wird sie bereits genutzt. Kontaktieren Sie den Support für weitere Hilfe.",

      "api_error.user.id_submission_attempts_exceeded": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktieren Sie unser Service Team.",

      "api_error.user.identityMismatch": "Diese Person kann nicht zur Bonitätsprüfung herangezogen werden",

      "api_error.user.identity_card_submission_attempts_exceeded": "Maximale Anzahl an Versuchen aufgebraucht. Bitte kontaktieren Sie den Support.",

      "api_error.user.invitation_link.max_invites_exceeded": "Anzahl der Plätze für diesen Einladungslink überschritten",

      "api_error.user.invitation_link.wrong_booking_status": "Kann nicht beitreten, da die Reservierung bereits begonnen oder storniert wurde",

      "api_error.user.license_submission_attempts_exceeded": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktieren Sie unser Service Team.",

      "api_error.user.password_reset.same_phone_used_in_multiple_accounts": "Kann nicht fortfahren, da dieselbe Telefonnummer für mehrere Konten verwendet wird.",

      "api_error.user.phone_verification.max_attempts": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktieren Sie unser Service Team.",

      "api_error.user.redirectToWeb": "Bitte fahren Sie in Ihrem eigenen Webbrowser fort.",

      "api_error.user.schufaCheck.data_incomplete": "Daten unvollständig",

      "api_error.user.tariff_missing": "Um fortzufahren, wählen Sie bitte zuerst einen Tarif.",

      "api_error.user.too_young": "Für Ihr aktuelles Alter steht derzeit kein passender Tarif zur Auswahl. Bitte versuchen Sie es erneut, sobald Sie %s Jahre alt werden.",

      "api_error.user.update.synced_with_merchant_system": "Das Benutzerkonto konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support",

      "api_error.user.verificationCode.incorrectOrExpired": "Code inkorrekt oder abgelaufen.",

      "api_error.user_not_belong_to_circle_brand": "Kein Mitglied des Nutzerkreises",

      "app.old.dialog.description": "Wir haben festgestellt, dass auf Ihrem Gerät noch die alte GETAWAY-App installiert ist. \n\nBitte klicken Sie auf \"Deinstallieren\", um diese zu entfernen.\n\n",

      "app.old.dialog.title": "Deinstallieren Sie die alte App",

      "app.privacy.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA-INT_dataprivacy-de.pdf",

      "app.terms.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA-INT_termsandconditions-de.pdf",

      "applink.error": "Dieser Link ist nicht mehr aktuell. Bitte kontaktieren Sie unser Service Team für weitere Infos.",

      "apply": "ÜBERNEHMEN",

      "area.6195052566acea0d11785b70.name": "Berlin (Neuenhagen)",

      "area.6293587021004a075975ed81.name": "Zhero (Mallorca)",

      "area.632abb191018da079a871065.name": "Berlin Brandenburg",

      "area.636fd246f563af071662cf6c.name": "Lustenau",

      "area.63f3b9000af72c0765aae927.name": "Mallorca (Lindner Hotel)",

      "area.63ff1dcac77ce8071d9dbac1.name": "Dornbirn (Kehlerstraße 6)",

      "area.644bc810935fbb07bb0b902a.name": "Bregenz (Lochau)",

      "area.6697be5570475106e9c17023.name": "Bregenz (Bahnhof)",

      "area.68fe520326116829219fddad.name": "IKEA Klagenfurt",

      "area.68fe520326116829219fddb0.name": "IKEA Innsbruck",

      "area.68fe520326116829219fddb4.name": "IKEA Vösendorf",

      "area.68fe520326116829219fddb7.name": "IKEA Graz",

      "area.68fe520326116829219fddba.name": "IKEA Haid",

      "area.68fe520326116829219fddbd.name": "IKEA Wien (Nord)",

      "area.68fe520326116829219fddc0.name": "Stationsbetrieb Buchbinder",

      "area.68fe520326116829219fddc3.name": "Station Wien (Modecenterstraße)",

      "area.68fe520326116829219fddc6.name": "IKEA Salzburg",

      "area.68fe520326116829219fddca.name": "IKEA Linz",

      "area.68fe520326116829219fddce.name": "IKEA CDC Strebersdorf",

      "area.68fe520326116829219fddd1.name": "IKEA Wiener Neustadt",

      "area.698b458181ab41790a6824ef.name": "OBI Wien (Hadikgasse)",

      "area.698c4d7c1ad7db155a40bd51.name": "Stationsbetrieb Wien (Flughafen)",

      "area.69b95ad89db4e3682c4f0bf7.name": "OBI Wien (Triester Straße)",

      "area.69b95bc89db4e3682c4f10b3.name": "OBI Wien (Haidhofstraße)",

      "area.69b961408393db4678aaa974.name": "OBI Vösendorf (Triester Straße)",

      "area.69e0f2dccb79244ac5c0d10c.name": "Stationsbetrieb Graz (Stadt)",

      "area.69ec8d8b611ea67412f119c6.name": "Transporter Wien (Modecenterstraße)",

      "area.69faec19cb07f61532b93d39.name": "Campingplatz (Berlin)",

      "area.69fb7e4ce24a290cbe584cf8.name": "IKEA Linz (Transporter)",

      "area.6a1ebd0cccaef87a77cd90f9.name": "IKEA Salzburg (Transporter)",

      "area.6a2023e639e0293c43b74e53.name": "IKEA CDC Strebersdorf (Transporter)",

      "area.6a26ce03940743260dc9b94d.name": "Innsbruck",

      "area.6a314e6b2a390664b74ab06c.name": "IKEA Klagenfurt (Transporter)",

      "area.6a7049c957fb440b9e358bef.name": "Innsbruck Flughafen (Transporter)",

      "area.6a7ed7d4eddc5114a270b468.name": "Innsbruck Flughafen",

      "area.brand_not_resolved": "Gewählter Anbieter wurde nicht erkannt.",

      "area.card.info": "Infos zur Zone",

      "area.card.navigate": "Navigieren",

      "area.fleet.brand.not_match": "Gewählte Flotte gehört nicht zum ausgewählten Anbieter.",

      "area.fleet_not_resolved": "Flotte wurde nicht erkannt.",

      "area.label": "Rückgabezone",

      "area.label.outside": "Bitte beachten Sie die Rückgabezone",

      "area.walkthrough.description": "Bringe das Fahrzeug zum Beenden der Miete in die farblich hervorgehobene Rückgabezone mit einem Tankstand von mind. 25% zurück und verriegele es mit dein Handy.",

      "area.walkthrough.title": "Zurückbringen und Miete beenden",

      "auth.failed.alert.body": "Bitte versuchen Sie es erneut oder klicken Sie \"Vergessen?\", um Ihr Passwort zurückzusetzen.",

      "auth.failed.alert.title": "Falsches Passwort",

      "backend.error": "Ups..etwas ist schief gelaufen. Bitte probieren Sie es gleich noch einmal.",

      "balance": "Guthaben",

      "balance.addFunds": "Guthaben hinzufügen",

      "balance.addFunds.description": "Sparen Sie mit unseren Guthabenpaketen",

      "balance.addPaymentMethod": "Zahlungsmittel hinzufügen",

      "balance.delete.confirm": "Möchten Sie dieses Zahlungsmittel tatsächlich entfernen?",

      "balance.getFreeCredit": "Erhalten Sie gratis Guthaben",

      "balance.getFreeCredit.description": "Meistern Sie Herausforderungen und erhalten Belohnungen.",

      "balance.invoice.failure": "Entschuldigen Sie bitte. Der Beleg konnte nicht versendet werden.",

      "balance.invoice.success": "Ihr Beleg wird Ihnen zeitnah per E-Mail gesendet!",

      "balance.paymentMethods": "ZAHLUNGSMITTEL",

      "balance.payoutFunds": "Guthaben auszahlen",

      "balance.payoutFunds.addSEPA.dialog.message": "Bitte fügen Sie Kontodaten hinzu, sodass wir Ihnen Ihr Guthaben auszahlen können.",

      "balance.payoutFunds.addSEPA.dialog.title": "Auszahlungsart hinzufügen",

      "balance.payoutFunds.description": "Auszahlbares Guthaben",

      "balance.payoutFunds.dialog.message": "Auszahlbares Guthaben wird Ihrem Konto am Monatsende automatisch gutgeschrieben.",

      "balance.payoutFunds.dialog.title": "Guthaben auszahlen",

      "balance.payoutFunds.error.message": "Auszahlbares Guthaben wird einmal im Monat automatisch auf Ihr hinterlegtes Bankonto überwiesen.",

      "balance.send.invoice": "BELEG\SENDEN",

      "balance.transactions": "UMSÄTZE",

      "bank.select.desr": "Hinterlegen Sie jetzt Ihre Kontodaten für sichere und bequeme Zahlungen per Lastschriftverfahren.",

      "bank.select.header": "Bitte wählen Sie Ihr Bankkonto",

      "bank.select.title": "Zahlungsmethode hinterlegen",

      "bis": "bis",

      "bluetooth.dialog.description": "Per Bluethooth können Sie Autos in Ihrer Umgebung einfach per Handy öffnen.",

      "bluetooth.dialog.title": "Bluetooth® aktivieren",

      "bluetooth.disabled.message": "Achtung: Bitte erlauben Sie Zugriff auf Ihr Bluetooth, um Fahrzeuge ent-/verriegeln zu können.",

      "bluetooth.permission.allow.details": "Achtung: Bitte erlauben Sie Zugriff auf Ihr Bluetooth, um Fahrzeuge ent-/verriegeln zu können.",

      "bluetooth.permission.allow.title": "Bluetooth Freigabe",

      "bluetooth.permission.details": "Zur sicheren Handy/Auto-Interaktion aktivieren Sie jetzt die Bluetooth-Funktion im Control Center Ihres Handys.",

      "bluetooth.permission.message": "Achtung: Bitte erlaube Zugriff auf dein Bluetooth, um Fahrzeuge ent-/verriegeln zu können.",

      "bluetooth.permission.title": "Aktivieren Sie Bluethooth®",

      "bluetooth.permission.yes": "Erlauben",

      "bonus.sheet.description.lowAndOut": "Der Tankstand des Fahrzeugs muss bei Rückgabe mindestens 25% betragen.\n\nErhalte 5 € Sofort-Gutschrift, wenn du die Miete in der Rückgabezone beendest und weitere 5 €, wenn du das Fahrzeug betankst.",

      "bonus.sheet.description.lowFuel": "Der Tankstand des Fahrzeugs muss bei Rückgabe mindestens 25% betragen.\n\nErhalten Sie eine 5€ Sofort-Gutschrift als Dank, wenn Sie das Fahrzeug volltanken. Die Bezahlung ist kostenfrei und bargeldlos mit der bereitgestellten Tankkarte im Handschuhfach. ",

      "bonus.sheet.description.out&low": "Der Tankstand des Fahrzeugs muss bei Rückgabe mindestens 25% betragen und das Beenden der Miete muss in der Rückgabezone erfolgen\n\nErhalten Sie  eine 5€ Sofort-Gutschrift, wenn Sie den Mietvorgang in der Rückgabezone des Fahrzeugs beenden.\n\nErhalten Sie weitere 5€, wenn Sie das Fahrzeug volltanken. Die Bezahlung ist kostenfrei und bargeldlos mit der bereitgestellten Tankkarte im Handschuhfach.",

      "bonus.sheet.description.outsideArea": "Das Beenden der Miete muss in der Rückgabezone erfolgen.\n\nErhalten Sie eine 5€ Sofort-Gutschrift als Dank, wenn Sie den Mietvorgang in der Rückgabezone des Fahrzeugs beenden.",

      "bonus.sheet.ok": "Ok",

      "book.station.cta": "An Station finden",

      "booking.1.available.cars": "Noch 1 Fahrzeug zu diesem Preis verfügbar.",

      "booking.2.available.cars": "Noch 2 Fahrzeuge zu diesem Preis verfügbar.",

      "booking.BookedCarIsBLOCKED": "Fahrzeug war nicht verfügbar",

      "booking.BookedCarIsRELEASE_READY": "Fahrzeug war nicht verfügbar",

      "booking.BookedCarIsRENTED": "Fahrzeug war nicht verfügbar",

      "booking.BookedCarIsUnavailable": "Fahrzeug war nicht verfügbar",

      "booking.BookingCancelled": "Reservierung wurde storniert",

      "booking.DriverHasOngoingRental": "Es lief bereits eine Miete",

      "booking.OtherReason": "technische Probleme",

      "booking.OtherRentalConstraintViolation": "Fahrzeug war nicht verfügbar",

      "booking.RentalCancelled": "Miete wurde storniert",

      "booking.RentalExpired": "Reservierung abgelaufen",

      "booking.accessToken": "technische Probleme",

      "booking.add.to.calendar": "Zum Kalender hinzufügen",

      "booking.added.to.calendar.success": "Zum Kalender hinzugefügt",

      "booking.additional.driver.action": "Zusatzfahrer",

      "booking.additional.driver.description": "Zusatzfahrer müssen sich im Anschluss an die Reservierung über den Einladungslink registrieren und vor Mietbeginn verifiziert sein. Fahranfänger sind nicht zulässig.",

      "booking.additional.driver.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_additionalDriver.png",

      "booking.additional.driver.link.footnote.md": "Zusatzfahrer müssen sich über den Einladungslink registrieren und vor Mietbeginn verifiziert sein. Fahranfänger sind nicht zulässig.",

      "booking.additional.driver.link.prefix": "Einladungslink",

      "booking.additional.driver.link.share": "Einladungslink teilen",

      "booking.additional.driver.price": "9€ + 2€/Kal.Tag",

      "booking.additional.driver.section.title": "Zusatzfahrer",

      "booking.additional.driver.share.text": "Schließen Sie sich der Buchung %@ an",

      "booking.additional.driver.title": "Zusatzfahrer",

      "booking.backByConflictsWithBooking": "technische Probleme",

      "booking.backByExpired": "technische Probleme",

      "booking.blockedByUpcomingBooking": "technische Probleme",

      "booking.blockedPaymentConfirmed": "Zahlung fehlgeschlagen",

      "booking.button.text": "Auf Karte anzeigen",

      "booking.cancel.fee.footnote": "Danach fällt eine Stornierungsgebühr iHv. bis zu %s an. Diese Gebühr wird erlassen, sofern bis %s ein alternativer Mietvorgang gestartet wird.",

      "booking.cancellation.text": "✓ Gratis stornierbar bis %s",

      "booking.cancelled": "Storniert",

      "booking.cancelled.at": "Reservierung storniert um %s",

      "booking.car.unavailable": "Das Fahrzeug ist nicht verfügbar",

      "booking.confirm.car.profile": "Fahrzeug",

      "booking.confirm.cost": "Initiale Kosten",

      "booking.confirm.from": "Von",

      "booking.confirm.payin.text": "Direkt im Anschluss an die Reservierung ist das Hinterlegen einer Kaution fällig. Es wird hierfür ein Zahlungs-Link zur Verfügung gestellt.                                               \n                                                            \nMöchtest du das nicht, dann wähle eine alternative Zahlungsart.",

      "booking.confirm.payin.title": "Kaution",

      "booking.confirm.profile": "Fahrzeug",

      "booking.confirm.profile.consent": "Mir ist bewusst, dass ich meine Registrierung vor planmäßigem Buchungsbeginn abgeschlossen haben muss - andernfalls wird diese zu den Bedingungen gemäß Stornierungen durch Kundenverschulden storniert.",

      "booking.confirm.to": "Bis",

      "booking.confirmation.button": "Kostenpflichtig reservieren",

      "booking.confirmation.title": "Prüfen Sie die Reservierung",

      "booking.conformation.no.address": "Abholzone anzeigen",

      "booking.consent.button": "Reservierung bestätigen",

      "booking.consent.cancel": "Ablehnen",

      "booking.consent.cancel.dialog.message": "Wenn du die Reservierungsanfrage ablehnst, wird diese storniert. Das Fahrzeug kann dann von anderen Nutzern gemietet werden.",

      "booking.consent.cancel.dialog.title": "Bitte bestätige deine Auswahl",

      "booking.consent.cancel.dialog.yes": "Ablehnen & stornieren",

      "booking.consent.circle": "Nutzerkreis",

      "booking.consent.later.dialog.message": "Prüfe und bestätige die Reservierungsanfrage rechtzeitig. Andernfalls wird diese automatisch storniert.",

      "booking.consent.later.dialog.yes": "Ok",

      "booking.cost.footnote": "Zusätzliche Entgelte können anfallen. Mehr Infos sind dem %s zu entnehmen.\n\nBitte beachten Sie bei geplanten Buchungen, dass für die Berechnung der Mietkosten auch bei einer vorzeitigen Rückgabe der gesamte ursprünglich reservierte Zeitraum herangezogen werden kann.",

      "booking.cost.footnote.url": "https://google.com",

      "booking.cost.footnote.url.text": "Fahrzeugprofil",

      "booking.cost.includedkm": "Inklusivkilometer",

      "booking.cost.section": "Kosten",

      "booking.create": "GETAWAY finden",

      "booking.create.success": "Danke! Wir haben Ihre Anfrage erhalten und suchen jetzt einen passenden GETAWAY für Sie.",

      "booking.created": "Erstellt",

      "booking.date.fake.url": "https://googles.com",

      "booking.deposit.footnote": "Mit der Reservierung wird eine initiale Kaution iHv. %s fällig. Übersteigen die Mietkosten die hinterlegte Kaution, werden weitere Kautionszahlungen fällig. Bitte sorgen Sie stets für ausreichend Deckung.\n\nIm Anschluss an den Mietvorgang wird die Gesamtkaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen erstattet.",

      "booking.deposit.section": "Initiale Kaution",

      "booking.deposit.title": "Kaution",

      "booking.desktop.start": "Miete Starten",

      "booking.details.header.descr": "Ab planmäßigem Mietbeginn starten Sie den Mietvorgang, indem Sie das Fahrzeug mit Ihrem Handy entriegeln.",

      "booking.details.section.title": "Ihre Reservierung",

      "booking.driver.accepted.title": "gute Fahrt mit Ihrem GETAWAY!",

      "booking.driver.add": "Fahrer",

      "booking.driver.cancel": "Reservierung stornieren",

      "booking.driver.cancel.dialog.message": "Stornierungsgebühren können anfallen.\n\nIst eine Kaution hinterlegt worden, wird diese nach Verrechnung etwaiger Gebühren unmittelbar im Anschluss an die Stornierung erstattet.",

      "booking.driver.cancel.dialog.title": "Reservierung stornieren",

      "booking.driver.cancel.dialog.yes": "Jetzt stornieren",

      "booking.driver.cancel.success": "Ihre Reservierung ist storniert worden. Ist eine Kaution hinterlegt worden, wird diese automatisch erstattet.",

      "booking.driver.confirm.dialog.message": "Gute Wahl! Mit Ihrer Bestätigung wird dieser GETAWAY für Sie reserviert.",

      "booking.driver.confirm.dialog.title": "Diesen GETAWAY reservieren",

      "booking.driver.confirm.dialog.yes": "Jetzt reservieren",

      "booking.driver.count.title": "Zusatzfahrer",

      "booking.driver.details.description": "Sobald wir passende Autos für Sie gefunden haben, schicken wir Ihnen die Auswahl.",

      "booking.driver.details.header.description": "Bitte seien Sie nachsichtig. Dieses Feature befindet sich in der Testphase. Wir freuen uns über Ihr Feedback!",

      "booking.driver.details.header.title": "Finden Sie Ihren perfekten GETAWAY! [BETA]",

      "booking.driver.details.text": "Die Preise basieren auf der genannten Dauer und Gesamtstrecke inkl. Kraftstoff. Der Endpreis berechnet sich nach tatsächlicher Dauer und zurückgelegter Strecke.",

      "booking.driver.details.title": "Ihre Reservierung",

      "booking.driver.nooffers": "✨\nVerfügbare GETAWAYs\nwerden Ihnen hier angezeigt.",

      "booking.driver.offer.choose": "Auswählen",

      "booking.driver.offer.request": "Anfragen",

      "booking.driver.offer.reserve": "Reservieren",

      "booking.driver.offer.reserving": "Reservierung läuft...",

      "booking.driver.offered.title": "wählen Sie Ihren perfekten GETAWAY!",

      "booking.driver.section": "Fahrer",

      "booking.driver.waitingoffer": "Angebot warten",

      "booking.early.start": "Reservierung früher starten",

      "booking.end": "Bis",

      "booking.fee.fake.url": "https://google.com",

      "booking.fee.title": "Stornierungsbedingungen",

      "booking.fee.value": "25€",

      "booking.fix.cancellation.note": "Bei Stornierung keine Erstattung der zeitbezogenen Kosten (Stunden-, Tagespreise etc.).\n  \nSie haben 30 Minuten ab planmäßigem Mietbeginn Zeit, den Mietvorgang zu starten. Danach verfällt Ihre Reservierung ersatzlos.",

      "booking.fix.option.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_besterPreis.png",

      "booking.flex.cancellation.note": "Bei Stornierung vor planmäßigem Mietbeginn am %s Uhr werden die Mietkosten erstattet. Die Gebühr für flexibles Buchen ist nicht erstattungsfähig.\n\nBei Stornierung danach findet keine Erstattung statt.\n\nSie haben bis zu 24 Stunden ab planmäßigem Mietbeginn Zeit, den Mietvorgang zu starten - maximal jedoch bis zum planmäßigem Mietende. Danach verfällt Ihre Reservierung ersatzlos.",

      "booking.flex.option.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_flexibelBleiben.png",

      "booking.free.cancellation.text": "✓ Gratis stornierbar",

      "booking.fuelCardMissing": "technische Probleme",

      "booking.guest.confirmation.button": "Jetzt anmelden",

      "booking.haveBlockedPaymentIfPayInOnly": "bitte wählest du den Zeitrahmen für die  Reservierung.",

      "booking.header.in": "Noch",

      "booking.headline.expired": "Reservierung ist abgelaufen",

      "booking.headline.payment": "Zahlungsdaten",

      "booking.headline.reservation": "Reservierungsdaten",

      "booking.headline.started": "Reservierung hat begonnen",

      "booking.insurance.SB500.popular": "Meist gewählt",

      "booking.insurance.desc": "Im Schadensfall kann es schnell teuer werden. Begrenzen Sie Ihr Haftungsrisiko mit einer reduzierten Selbstbeteiligung.",

      "booking.insurance.title": "Reduzieren Sie Ihr Risiko",

      "booking.insurance.type": "Typ",

      "booking.label.checked": "Zurückgenommen",

      "booking.label.expired": "Abgelaufen",

      "booking.label.started": "Gestartet",

      "booking.label.waiting.checkin": "in Rückgabe",

      "booking.map.bar.text": "Nächste Reservierung:",

      "booking.map.pre.signup": "Klicke hier um deine Buchung abzuschließen.",

      "booking.mileage.placeholder": "Ich weiß noch nicht",

      "booking.mileage.title": "Gesamtstrecke (circa)",

      "booking.online": "technische Probleme",

      "booking.option.SB500.popular": "Meist gewählt",

      "booking.option.fix.price": "0€ (inklusive)",

      "booking.option.fix.subtitle": "✓ Keine Erstattung bei Stornierung\n✓ Miete ist innerhalb von 30 Min. ab planmäßigem Mietbeginn zu starten",

      "booking.option.fix.title": "Bester Preis",

      "booking.option.flex.price": "0,49 €/Std (4,90 €/Kal.Tag)",

      "booking.option.flexBooking.popular": "Beliebt",

      "booking.option.flexBooking.subtitle": "✓ Gratis stornierbar bis planmäßigem Mietbeginn\n✓ 24 Std. ab planmäßigem Mietbeginn (max. Mietende), um Miete zu starten",

      "booking.option.flexBooking.title": "Flexibel bleiben",

      "booking.option.title": "Wählen Sie die Buchungsoption",

      "booking.payByLink.description": "Schließen Sie bitte jetzt Ihre Zahlung ab und kehre danach zu Ihrem Nutzerkonto zurück.",

      "booking.payin.blockPayment.description": "Mit der Reservierung werden 300,-€ via Vorkasse angefordert. Übersteigen die Mietkosten den Kautionsbetrag, können weitere Zahlungen fällig werden. Bitte sorgen Sie stets für ausreichend Deckung.\n\nIm Anschluss an den Mietvorgang wird die Kaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen wieder freigegeben.",

      "booking.payin.blockPayment.title": "Kaution bei Vorkasse-Zahlung",

      "booking.payin.blockPayment.yes.text": "Weiter",

      "booking.payment": "Zahlungsart",

      "booking.payment.change": "Zahlungsmethode wechseln",

      "booking.payment.payIn.title": "Vorkasse",

      "booking.payment.section": "Zahlungsdaten",

      "booking.places.current": "Aktuelle Position",

      "booking.places.search": "Adresse eingeben",

      "booking.places.title": "Von wo",

      "booking.pre.signup.clear": "Löschen",

      "booking.preferredcar.title": "Auto",

      "booking.requestedCar.title": "Fahrzeug",

      "booking.section.details": "Details",

      "booking.section.timeline": "Zeitstrahl",

      "booking.start": "Von",

      "booking.start.address": "Von wo",

      "booking.status": "Status",

      "booking.status.cancelled": "Storniert",

      "booking.status.expired": "Abgelaufen",

      "booking.upsellings.SB500.popular": "Meist gewählt",

      "booking.userMarkedForFraud": "Zahlung fehlgeschlagen",

      "booking.warning.payin.button": "Jetzt Kaution hinterlegen",

      "booking.warning.payin.text": "Hinterlege jetzt die Kaution, um die Reservierung abzuschließen. Andernfalls wird sie in wenigen Minuten storniert.",

      "booking.warning.payin.text.payed": "Das hat geklappt. Bitte warten Sie  nun auf den Beginn Ihrer Miete.",

      "booking.warning.payin.title": "Kaution",

      "booking.warning.payin.title.payed": "Kaution erfolgreich hinterlegt",

      "booking.warning.payin.value": "150,00 Euro",

      "booking.warning.profile.button": "Vollständiges Profil",

      "booking.warning.profile.text": "⚠️ Bitte vervollständigen Sie Ihr Profil vor planmäßigem Buchungsstart – andernfalls wird die Reservierung storniert und es gelten die Bedingungen für Stornierung durch Kundenverschulden.",

      "booking.warning.profile.title": "Vervollständigen Sie Ihr Profil",

      "booking.when": "Wann?",

      "bookings.headline.booked": "Gebucht",

      "bookings.headline.reservation": "Reserviert",

      "bookings.profile.cancel.text": "Reservierung stornieren",

      "bookings.profile.title": "Meine Reservierungen",

      "bookings.where.desc": "Der genaue Standort des Fahrzeugs wird 30 Minuten vor Buchungsbeginn angezeigt.",

      "brand.bnd.name": "book-n-drive",

      "brand.getaway.name": "GETAWAY",

      "brand.mba.name": "Impressum",

      "brand.mis.name": "Miet Smart",

      "brand.msi.name": "Miet Smart",

      "brand.rw.name": "Share die Robbe",

      "brand.ubq.name": "ubeeqo",

      "bubPassenger.Buchbinder.pricing.6a7de9e98a03e46ab9d01572": "|||\n| :------------- |------------:|\n|       |  **Stundenpreis**     |\n| Mo-Do    |   3,90 €    |\n| Fr-So      | 4,90 €     |\n\n\n||||\n| :------------- |-------------:|-------------:|\n|       | **Tag 1 bis 3**    | **Ab Tag 4**     |\n| Mo-Do      | 39 €/Kal.Tag     | 29 €/Kal.Tag     |\n| Fr-So      | 49 €/Kal.Tag     | 39 €/Kal.Tag     |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,44 €/km|\n| Ab dem 101. Kilometer | 0,39 €/km|\n\n\n| Selbstbeteiligung (je Schadensfall) | | |\n| :-------- | -------: | -------: |\n| SB bis Fahrzeugwert | | inklusive (0€) |\n| SB 1.500€ | 1€/Std. | 9 €/Kal.Tag |\n| SB 500€ | 2€/Std. | 14 €/Kal.Tag |\n| SB 150€ | 4€/Std. | 19 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/6a7dd88a8a03e46ab9d01559/pdf) zu entnehmen. ",

      "bubPassenger.Buchbinder.pricing.6a7de9fe8a03e46ab9d01574": "|||\n| :------------- |------------:|\n|       |  **Stundenpreis**     |\n| Mo-Do    |   4,90 €    |\n| Fr-So      | 5,90 €     |\n\n\n||||\n| :------------- |-------------:|-------------:|\n|       | **Tag 1 bis 3**    | **Ab Tag 4**     |\n| Mo-Do      | 49 €/Kal.Tag     | 39 €/Kal.Tag     |\n| Fr-So      | 59 €/Kal.Tag     | 49 €/Kal.Tag     |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,44 €/km|\n| Ab dem 101. Kilometer | 0,39 €/km|\n\n\n| Selbstbeteiligung (je Schadensfall) | | |\n| :-------- | -------: | -------: |\n| SB bis Fahrzeugwert | | inklusive (0€) |\n| SB 1.500€ | 1€/Std. | 9 €/Kal.Tag |\n| SB 500€ | 2€/Std. | 14 €/Kal.Tag |\n| SB 150€ | 4€/Std. | 19 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/6a7dd88a8a03e46ab9d01559/pdf) zu entnehmen. ",

      "bubTransporter.Buchbinder.pricing": "**Transporter L1 (Fiat Scudo o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n| | **je Std.** | **je Kal.Tag** |\n| Mo–Do | 7,90 €| max. 79 €|\n| Fr–So | 9,90 € | max. 99 € |\n\n\n**Transporter L3 (Nissan Interstar o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n| | **je Std.** | **je Kal.Tag** |\n| Mo–Do | 9,90 € | max. 99 €|\n| Fr–So | 11,90 € | max. 119 € |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 €/km|\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| SB bis Fahrzeugwert | inklusive (0€) |\n| SB 1.500€ | 14 €/Kal.Tag |\n| SB 500€ | 19 €/Kal.Tag |\n| SB 150€ | 24 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf) zu entnehmen.",

      "bubTransporter.Buchbinder.pricing.68fe518326116829219fdd7a": "**Transporter L1 (Fiat Scudo o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n| | **je Std.** | **je Kal.Tag** |\n| Mo–Do | 7,90 €| max. 79 €|\n| Fr–So | 9,90 € | max. 99 € |\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 €/km|\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| SB bis Fahrzeugwert | inklusive (0€) |\n| SB 1.500€ | 14 €/Kal.Tag |\n| SB 500€ | 19 €/Kal.Tag |\n| SB 150€ | 24 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf) zu entnehmen.",

      "bubTransporter.Buchbinder.pricing.69aaadf2af5c7b01c5a98c5b": "**Transporter L3 (Nissan Interstar o.ä.)**\n\n||||\n|:----------|-------:|-----:|\n| | **je Std.** | **je Kal.Tag** |\n| Mo–Do | 9,90 € | max. 99 €|\n| Fr–So | 11,90 € | max. 119 € |\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 €/km|\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| SB bis Fahrzeugwert | inklusive (0€) |\n| SB 1.500€ | 14 €/Kal.Tag |\n| SB 500€ | 19 €/Kal.Tag |\n| SB 150€ | 24 €/Kal.Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Für Fahranfänger können die Preise für die Reduzierung der Selbstbeteiligung abweichen.\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/69a076fc45c6fd1ee157f00e/pdf) zu entnehmen.",

      "business": "geschäftlich",

      "button.lock": "Verriegeln",

      "button.unlock": "Entriegeln",

      "calendar.dismiss": "Schließen",

      "call": "Anrufen",

      "callout.show.availability": "Verfügbarkeit anzeigen",

      "camera.addressProof.upload": "hochladen",

      "camera.permission.details": "Um fortzufahren und Fotos aufzunehmen, erlauben Sie GETAWAY jetzt Zugriff auf Ihre Kamera.",

      "camera.permission.no": "Später",

      "camera.permission.title": "Zugriff auf Kamera",

      "camera.permission.yes": "Erlauben",

      "cancel": "Abbrechen",

      "cancel.FirstSteps.dialog.message": "Nur 2 Minuten: Schließen Sie jetzt Ihre Registrierung ab. Nur mit vollständigen Nutzerangaben können Sie unseren Service nutzen.",

      "cancel.FirstSteps.dialog.message.noBonus": "Nur 2 Minuten: Schließen Sie jetzt die Registrierung ab und starten Sie sofort Ihre erste Miete.",

      "cancel.FirstSteps.dialog.no": "Abbrechen",

      "cancel.FirstSteps.dialog.yes": "Jetzt nicht",

      "cancel.rental.handover": "Möchten Sie den aktuellen Mietvorgang abbrechen?",

      "car.approximateMileage.gt250k": "über 250.000 km",

      "car.approximateMileage.lt100k": "50.000 - 100.000 km",

      "car.approximateMileage.lt150k": "100.000 - 150.000 km",

      "car.approximateMileage.lt200k": "150.000 - 200.000 km",

      "car.approximateMileage.lt250k": "200.000 - 250.000 km",

      "car.approximateMileage.lt50k": "unter 50.000 km",

      "car.available.book": "BUCHEN",

      "car.category.name.label": "Preisgruppe",

      "car.co2.text": "Kg eingespartes CO2",

      "car.damage": "Schaden",

      "car.damage.categories.title": "Was möchten Sie melden?",

      "car.damage.create.dialog.title": "Schaden oder Mangel melden",

      "car.damage.edit.notallowed.description": "Während einer laufenden Miete kann das Schadenprotokoll nicht geändert werden.",

      "car.damage.edit.notallowed.title": "Änderungen nicht möglich",

      "car.damage.remove.dialog.remove": "Schaden entfernen",

      "car.damage.remove.dialog.title": "Sind Sie sicher?",

      "car.damages": "Schäden",

      "car.damages.photos.dialog.description": "Fügen Sie jetzt bitte mindestens ein Foto von diesem Schaden/Mangel hinzu, um diesen besser nachvollziehbar zu machen.",

      "car.damages.photos.dialog.title": "Fotos vom Schaden",

      "car.data.title": "Stammdaten",

      "car.data.view.btn.continue": "Weiter",

      "car.data.view.btn.start": "Beginnen",

      "car.data.view.btn.upload": "Hochladen",

      "car.data.view.description": "Bitte stellen Sie sicher, dass VIN und Fahrzeugmodell korrekt sind, bevor Sie weitermachen.",

      "car.data.view.document": "Foto der Einbau-Daten",

      "car.data.view.document.sample": "Siehe Beispiel: ",

      "car.data.view.title": "Daten zum Einbau",

      "car.demo.unavailable.messege": "Bitte öffnen Sie den Appstore und aktualisieren jetzt Ihre App-Version, um dieses Auto zu mieten.",

      "car.demo.unavailable.title": "Miete nicht möglich",

      "car.details.available.until.placeholder": "Verfügbar bis",

      "car.details.car.info": "AUTOPROFIL",

      "car.details.carplate.placeholder": "Kennzeichen",

      "car.details.damages": "Schäden",

      "car.details.equipment": "AUSSTATTUNG",

      "car.details.fuel.diesel": "Diesel",

      "car.details.fuel.electric": "Elektrisch",

      "car.details.fuel.hybrid": "Hybrid",

      "car.details.fuel.hybrid_diesel": "Hybrid/Diesel",

      "car.details.fuel.hybrid_unleaded95": "Hybrid/Benzin 95",

      "car.details.fuel.hybrid_unleaded98": "Hybrid/Benzin 98",

      "car.details.fuel.lpg": "LPG",

      "car.details.fuel.other": "Anderer",

      "car.details.fuel.placeholder": "Kraftstoff",

      "car.details.fuel.unleaded95": "Super",

      "car.details.fuel.unleaded98": "Super Plus",

      "car.details.gear.automatic": "Automatik",

      "car.details.gear.manual": "Manuell",

      "car.details.gear.type.placeholder": "Getriebeart",

      "car.details.height": "Ladehöhe",

      "car.details.initial.registration.placeholder": "Erstzulassung",

      "car.details.length": "Ladelänge",

      "car.details.list.damages.placeholder": "Gemeldete Schäden",

      "car.details.listofdamages.title": "SCHADENSLISTE",

      "car.details.loadCapacity": "Ladegewicht",

      "car.details.lock.text": "VERRIEGELN",

      "car.details.mileage.gt100": "Mehr als 100.000 km",

      "car.details.mileage.lt100": "Weniger als 100.000 km",

      "car.details.mileage.lt20": "Weniger als 20.000 km",

      "car.details.mileage.lt50": "Weniger als 50.000 km",

      "car.details.mileage.placeholder": "Kilometerstand",

      "car.details.pickupreturn.placeholder": "Standort",

      "car.details.pollution.placeholder": "Umweltplakette",

      "car.details.pos.reviews": "Positive Bewertungen",

      "car.details.reviews": "Bewertungen",

      "car.details.techincaldata": "Technische Daten",

      "car.details.uhr": "Uhr",

      "car.details.unlock.text": "Miete starten",

      "car.details.unlock.text.brand": "Miete starten",

      "car.details.unlocking.text": "Entriegeln...",

      "car.details.width": "Ladebreite",

      "car.device.doors.open": "Bitte stellen Sie sicher, dass alle Türen verschlossen sind.",

      "car.device.fuel.card.missing": "Bitte legen Sie die Tankkarte in die dafür vorgesehene Halterung im Handschuhfach.",

      "car.device.keys.missing": "Bitte stellen Sie sicher, dass der Autoschlüssel in der dafür vorgesehenen Halterung im Handschuhfach liegt.",

      "car.device.view.btn.txt": "Weiter",

      "car.device.view.description": "Bitte anhand der Seriennummer auswählen",

      "car.device.view.search.label": "Nach SN suchen",

      "car.device.view.title": "CloudBoxx verbinden",

      "car.device.windows.open": "Bitte stellen Sie sicher, dass alle Fenster verschlossen sind.",

      "car.equipment.abs": "ABS",

      "car.equipment.adaptiveLighting": "Kurvenlicht",

      "car.equipment.airConditioning": "Klimaanlage",

      "car.equipment.alloyWheels": "Leichtmetallfelgen",

      "car.equipment.auxiliaryHeating": "Standheizung",

      "car.equipment.childSeat": "Kindersitz",

      "car.equipment.collisionAvoidanceSystem": "Notbremsassistent",

      "car.equipment.cruiseControl": "Tempomat",

      "car.equipment.disabledAccessible": "Behindertengerecht",

      "car.equipment.distanceControlAssistSystem": "Abstandstempomat",

      "car.equipment.electricHeatedSeats": "Sitzheizung",

      "car.equipment.esp": "ESP",

      "car.equipment.feature": "Extras",

      "car.equipment.fourWheelDrive": "Allradantrieb",

      "car.equipment.handsFreeKit": "Freisprechanlage",

      "car.equipment.interior": "Innenausstattung",

      "car.equipment.laneDepartureWarningSystem": "Spurhalteassistent",

      "car.equipment.multifunctionalWheel": "Multifunktionslenkrad",

      "car.equipment.navigationSystem": "Navigationssystem",

      "car.equipment.panoramicRoof": "Panorama-Dach",

      "car.equipment.parkingAssistSystem": "Einparkhilfe",

      "car.equipment.powerAssistedSteering": "Servolenkung",

      "car.equipment.rainSensor": "Regensensor",

      "car.equipment.roofBars": "Dachgepäckträger",

      "car.equipment.safety": "Sicherheit",

      "car.equipment.startStopSystem": "Start/Stopp-Automatik",

      "car.equipment.sunroof": "Schiebedach",

      "car.equipment.tractionControl": "Traktionskontrolle",

      "car.equipment.trailerCoupling": "Anhängerkupplung",

      "car.feedback.text": "lieben Sie Ihr Auto",

      "car.findNearest.notExist": "Kein verfügbares Fahrzeug. Versuchen Sie einen anderen Zeitraum oder vergrößern Sie den Kartenausschnitt.",

      "car.handover.failed.description.unlock": "Entriegelen Sie das Auto und starten den Vorgang erneut.",

      "car.handover.failed.title": "Vorgang fehlgeschlagen",

      "car.handover.manual.fuelLevel.description": "Niemand möchte ein Auto mit fast leerem Tank hinterlassen bekommen. Bitte bestätigen Sie, dass das der Tankstand mindestens ca. 25% beträgt.",

      "car.handover.manual.fuelLevel.title": "Tankstand ausreichend?",

      "car.handover.nodamages": "Keine gemeldeten Schäden",

      "car.insurance": "Versicherungsschutz",

      "car.owner.dialog.rented.message": "Zum Schutz der Privatsphäre des Mieters ist die aktuelle Position Ihres Autos verschlüsselt. Wir benachrichtigen Sie im Anschluss des Mietvorgangs.",

      "car.owner.dialog.rented.title": "Aktuell vermietet",

      "car.pollution.green": "Grün",

      "car.pollution.nobadge": "Keine",

      "car.pollution.red": "Rot",

      "car.pollution.unknown": "Unbekannt",

      "car.pollution.yellow": "Gelb",

      "car.price": "%@ € pro km",

      "car.price.desc": "Legen Sie fest, was Sie pro Kilometer verdienen möchtest. Sie können diesen Wert jederzeit anpassen.",

      "car.price.footer": "*Hierbei handelt es sich um eine unverbindliche Schätzung. Letztlich hängen die tatsächlichen Einnahmen von der Verfügbarkeit und Begehrtheit Ihres Autos ab.",

      "car.price.high": "Zu teuer",

      "car.price.low": "Zu günstig",

      "car.price.title": "Verdienst pro Kilometer",

      "car.price.update": "SPEICHERN",

      "car.profile.area.name": "Name",

      "car.profile.area.note": "Hinweise zur Zone",

      "car.profile.area.openinghrs": "Zugang",

      "car.profile.area.title": "Abhol-/Rückgabezone",

      "car.profile.blockReasons.label": "Downtime-Grund:",

      "car.profile.brand": "Marke",

      "car.profile.damages": "Schäden & Mängel",

      "car.profile.description": "Bearbeiten Sie Ihr Autoprofil",

      "car.profile.dimensions.note": "Maße können abweichen. Wenn es knapp werden könnte, wähle zur Sicherheit eine größere Fahrzeugkategorie.",

      "car.profile.engine": "Motorleistung",

      "car.profile.equipment": "Ausstattung",

      "car.profile.history.date.interval.to": "bis",

      "car.profile.instructions": "Die besten Tipps, um Ihre Mieteinnahmen zu erhöhen, finden Sie in unserem %@.",

      "car.profile.instructions.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "car.profile.instructions.url.text": "HilfeCenter",

      "car.profile.lastCleaning.label": "Letzte Reinigung:",

      "car.profile.model": "Modell",

      "car.profile.price.details": " https://robbe.app/feetable",

      "car.profile.price.message": "Circa %@ € pro Monat*",

      "car.profile.price.per.km": "Ihr Verdienst pro km",

      "car.profile.rental.description": "Liste aller Mietvorgänge",

      "car.profile.rental.history": "MIETVORGÄNGE",

      "car.profile.rented.back": "Rückkehr spät.",

      "car.profile.tab.availability": "Verfügbarkeit",

      "car.profile.tab.info": "Info",

      "car.profile.tab.pricing": "Preise",

      "car.profile.terminate": "AUTO ENTFERNEN",

      "car.profile.view": "Autoprofil",

      "car.registration.camera.description": "Positionieren Sie die aufgeklappte Kfz-Schein Vorderseite innerhalb der Markierung.",

      "car.registration.photo.description": "(vollständig aufgeklappt)",

      "car.registration.photo.title": "Kfz-Schein Vorderseite",

      "car.release.ignition.message": "Sie können Ihr Auto nur freigeben, wenn der Motor aus ist.",

      "car.release.ignition.title": "Freigabe nicht möglich",

      "car.released": "Ihr Auto ist freigegeben worden",

      "car.released.error": "Bitte probieren Sie es später erneut",

      "car.rental.cancelled": "Deine Reservierung ist storniert worden. Ist eine Kaution hinterlegt worden, wird diese automatisch erstattet.",

      "car.rental.cancelled.time": "Ihre Buchung ist storniert worden. Sie haben das Auto nicht rechtzeitig geöffnet.",

      "car.rental.count": "Mietvorgänge",

      "car.rental.rental": "Mietvorgang",

      "car.rental.rentals": "Mietvorgänge",

      "car.rental.trips": "FAHRTEN",

      "car.rentals.title": "Mietvorgänge",

      "car.rented.back": "Zurück am",

      "car.rented.backtoday": "Zurück um",

      "car.rented.backtomorrow": "Morgen zurück um",

      "car.reserve.blockPayment.description": "Mit der Reservierung werden initial 100,-€ auf Ihrer Kreditkarte geblockt. Übersteigen die Mietkosten den Kautionsbetrag, können weitere Zahlungen fällig werden. Bitte sorgen Sie stets für ausreichend Deckung.\n\nIm Anschluss an den Mietvorgang wird die Kaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen wieder freigegeben.",

      "car.reserve.blockPayment.paypal.description": "Mit der Reservierung werden initial 100,-€ auf Ihrem Paypal-Konto geblockt. Übersteigen die Mietkosten den Kautionsbetrag, können weitere Zahlungen fällig werden. Bitte sorgen Sie stets für ausreichend Deckung. Im Anschluss an den Mietvorgang wird die Kaution nach Verrechnung mit den Mietkosten unter Vorbehalt weiterer möglicher Forderungen wieder freigegeben.	",

      "car.reserve.blockPayment.paypal.title": "Kaution bei Zahlung via PayPal",

      "car.reserve.blockPayment.paypal.yes": "Fortfahren",

      "car.reserve.blockPayment.title": "Kaution bei Kreditkartenzahlung",

      "car.reserve.blockPayment.yes.text": "Fortfahren",

      "car.reserve.carBooked.description": "Dieses Fahrzeug hat eine Folgemiete und muss bis zu diesem Zeitpunkt zurückgebracht werden. Andernfalls können Gebühren anfallen.",

      "car.reserve.carBooked.title": "Fahrzeugrückgabe in %s.",

      "car.reserve.carBooked.yes.text": "Zustimmen",

      "car.review.title": "Erfahrungen",

      "car.search.notExist": "Dieses Fahrzeug existiert nicht.",

      "car.select.cta": "Los geht's!",

      "car.select.search.label": "Nach VIN suchen",

      "car.select.tab.installation": "Installation",

      "car.select.tab.removal": "Deinstallation",

      "car.select.view.description": "Wählen Sie jetzt das Fahrzeug anhand der Fahrgestellnummer.",

      "car.select.view.ongoing.label": "Laufende Einbauten",

      "car.select.view.title": "Fahrzeug wählen",

      "car.service.count": "Service-Fahrten",

      "car.status.battery.voltage": "Batteriespannung",

      "car.status.button.refresh": "Status aktualisieren",

      "car.status.fuel.card": "Tankkarte",

      "car.status.fuel.level": "Tankstand",

      "car.status.key": "Fahrzeugschlüssel",

      "car.status.mileage": "Kilometerstand",

      "car.status.missing": "Fehlt",

      "car.status.not.found": "Autostatus kann nicht gelesen werden.",

      "car.status.not.required": "Nicht verfügbar",

      "car.submit.approximateMileage": "Ungefährer Kilometerstand",

      "car.submit.footer": "Das Auto  ist verkehrstüchtig mit gültiger Haftpflichtversicherung und Hauptuntersuchung.",

      "car.submit.leased": "Ich bin Leasingnehmer",

      "car.submit.legalnotice": "Ich stimme einer etwaigen Datenprüfung zur Zahlungswahrscheinlichkeit zu und bestätige, dass das Auto verkehrstüchtig ist und über eine gültige Haftpflichtversicherung wie auch einer Hauptuntersuchung verfügt.",

      "car.submit.legalnotice.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "car.submit.legalnotice.url.text": "Datenprüfung",

      "car.submit.notowner": "Ich bin nicht Halter/Eigentümer",

      "car.submit.owner": "Ich bin Halter/Eigentümer",

      "car.submit.ownership": "Wem gehört das Auto?",

      "car.submit.ownership.description": "Sie können das Auto problemlos anmelden, auch wenn Sie selbst nicht Halter/Eigentümer sind. Mehr Infos folgen in der Anmeldebestätigung.",

      "car.terminate.dialog.message": "Bitte kontaktieren Sie unser Service Team, um Ihr Autoprofil entfernen zu lassen.",

      "car.terminate.dialog.title": "Autoprofil entfernen",

      "car.title": "IHR AUTO",

      "car.transaction.title": "Mieteinnahme %@",

      "car.unlock.bluetooth.disabled": "Bluetooth® aktivieren\nzum Entriegeln",

      "car.unlock.bluetooth.disabled.brand": "Bluetooth® aktivieren",

      "car.unlock.bluetooth.searching": "Distanz verringern\nzum Entriegeln",

      "car.unlock.bluetooth.searching.brand": "Distanz verringern",

      "car.unlock.closeToCar.action": "Ich stehe am Fahrzeug - jetzt entriegeln",

      "car.unlock.locationpermission.dialog.message": "Bitte erteile über die Browsereinstellungen die Standortberechtigung, um das Auto aufzuschließen.",

      "car.unlock.locationpermission.dialog.title": "standortermittlung ist deaktiviert",

      "car.unlock.tooFar.message": "Bitte probieren Sie es erneut aus geringerer Distanz. Sobald sich Ihr Handy mit dem Fahrzeug verbunden hat, können Sie es mit der App entriegeln.\n\nBei Problemen kontaktieren Sie bitte unser Service Team über das Chat-Symbol oben rechts im Bildschirm.",

      "car.unlock.tooFar.title": "Bitte verringern Sie die Distanz",

      "car.unreleased": "Ihr Auto ist nicht mehr freigegeben",

      "car.unreleased.error": "Ihr Auto kann nicht freigegeben werden. Bitte probieren Sie es später erneut.",

      "carCheck.addImage.labelFour": "Hinten, links",

      "carCheck.addImage.labelOne": "Vorne, links",

      "carCheck.addImage.labelThree": "Hinten, rechts",

      "carCheck.addImage.labelTwo": "Vorne, rechts",

      "card.number": "Kreditkartennummer",

      "carprofile.footnote": "Die besten Tipps, um Ihre Mieteinnahmen zu erhöhen, finden Sie in unserem %@.",

      "carprofile.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "carprofile.footnote.url.text": "HilfeCenter",

      "carprofile.troubleshoot.description": "Der Motor Ihres Autos springt nicht an? Hier können Sie die Motorsperre entriegeln.",

      "carprofile.troubleshoot.title": "Motorsperre verwalten",

      "cars.carousel.title": "Finden Sie Ihren perfekten GETAWAY!",

      "challenges.completed.section": "GEMEISTERTE HERAUSFORDERUNGEN",

      "challenges.firstSteps.addPayment.text": "Zur Verifizierung Ihres Nutzerkontos",

      "challenges.firstSteps.addPayment.title": "Hinterlegen Sie eine Zahlungsmethode",

      "challenges.firstSteps.bonusTransactionReason": "Erste Schritte",

      "challenges.firstSteps.createAccount.text": "Großartig, Sie haben sich erfolgreich registriert",

      "challenges.firstSteps.createAccount.title": "Erstellen Sie ein Nutzerkonto",

      "challenges.firstSteps.description": "Sie sind kurz davor, die Straße zu erobern. Erledigen Sie schnell die ersten Schritte und erhalten sofort %s € Startguthaben!",

      "challenges.firstSteps.enterPIN.title": "PIN bestimmt",

      "challenges.firstSteps.firstRental.text": "Machen Sie Ihren ersten Ausflug mit GETAWAY",

      "challenges.firstSteps.firstRental.title": "Mieten Sie ein Auto",

      "challenges.firstSteps.listCar.text": "Lassen Sie Ihr Auto Geld für Sie verdienen!",

      "challenges.firstSteps.listCar.title": "Registrieren Sie Ihr Auto",

      "challenges.firstSteps.payDeposit.title": "Anzahlung leisten",

      "challenges.firstSteps.saveAddress.text": "Schreiben Sie uns, wo Sie wohnen",

      "challenges.firstSteps.saveAddress.title": "Hinterlegen Sie Ihre Meldeadresse",

      "challenges.firstSteps.selectTariff.title": "Tarif auswählen",

      "challenges.firstSteps.title": "Erste Schritte",

      "challenges.firstSteps.verifyAuthorizedRepresentative.title": "Vertretungsberechtigung verifiziert",

      "challenges.firstSteps.verifyCompany.title": "Organisation verifiziert",

      "challenges.firstSteps.verifyDriversLicense.text": "Um Zugang zum Fuhrpark zu erhalten",

      "challenges.firstSteps.verifyDriversLicense.title": "Bestätigen Sie Ihre Fahrerlaubnis",

      "challenges.firstSteps.verifyEmail.text": "Um Ihre E-Mail Adresse zu verifizieren",

      "challenges.firstSteps.verifyEmail.title": "Verifizieren Sie Ihre E-Mail Adresse.",

      "challenges.firstSteps.verifyIDDocument.text": "Um Zugang zur Fahrzeugflotte zu erhalten.",

      "challenges.firstSteps.verifyIDDocument.title": "Identitäts-Dokument verifizieren",

      "challenges.firstSteps.verifyIban.title": "IBAN überprüfen",

      "challenges.firstSteps.verifyPhoneNumber.text": "Um Ihr Handy zum Autoschlüssel zu machen",

      "challenges.firstSteps.verifyPhoneNumber.title": "Bestätigen Sie Ihre Handy-Nummer",

      "challenges.inviteFriends.bonusTransactionReason": "Eingeladener Freund",

      "challenges.inviteFriends.description": "Schenken Sie Ihren Freunden und Nachbarn einen 10€ Willkommensbonus und erhalten selbst 10€, wenn sie diesen einlösen.",

      "challenges.inviteFriends.title": "Laden Sie 5 Freunde ein",

      "challenges.up.to": "Bis zu",

      "change": "Ändern",

      "change.password.success": "Ihr Passwort ist erfolgreich aktualisiert worden.",

      "circle.brand_not_resolved": "Nutzerkreis nicht erkannt",

      "circle.emailRequired": "E-Mail-Adresse erforderlich",

      "circles.button.text": "ÜBERNEHMEN",

      "circles.input.placeholder": "Einladungscode eingeben",

      "circles.join.success.msg": "Sie haben jetzt besonderen Zugang zu Fahrzeugen und Preisen!",

      "circles.join.success.title": "Sie sind dem Nutzerkreis beigetreten.",

      "claim": "Melden",

      "claim.photo.note": "Bitte füge mindestens ein Foto hinzu.",

      "claim.photo.title": "Fotos hinzufügen",

      "clean.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeDirt_compressed.png",

      "clean.damage.option1": "Ja",

      "clean.damage.option2": "Nein",

      "clean.damage.option3": "Ich weiß es nicht",

      "clean.damage.picker.holder": "Muss gereinigt werden?",

      "clean.damage.title": "Verschmutzung melden",

      "clear.damages": "Schäden zurücksetzen",

      "clear.damages.prompt.text": "Sind Sie sich sicher?",

      "clipboard.link.copied": "Ihr Einladungslink ist in Ihre Zwischenablage kopiert worden.",

      "closed": "geschlossen",

      "confirm": "Bestätigen",

      "connect.getaway.name": "Getaway Connect",

      "connect.getaway.support.phone": "+49 30 30808441",

      "connect.item.brand.name": "Kundenmarke",

      "connect.item.car.install": "Nach VIN suchen",

      "connect.item.car.remove": "Nach VIN suchen",

      "connect.item.chassisNumber": "VIN",

      "connect.item.cloudboxx.number": "CloudBoxx SN",

      "connect.item.device.serialNo": "CloudBoxx SN",

      "connect.item.fuel.card.number": "Tankkarte",

      "connect.item.mobile": "Handynummer",

      "connect.item.model": "Marke/Modell",

      "connect.item.plate": "Kennzeichen",

      "consents.agb": "Einwilligung",

      "consents.agb.title": "Allgemeine Geschäftsbedingungen",

      "consents.consent": "Einwilligung",

      "consents.details": "Details",

      "consents.newsletter.desc": "Ich bin damit einverstanden, den Newsletter zu erhalten.",

      "consents.newsletter.title": "Newsletter",

      "consents.privacy.policy.title": "Datenschutzerklärung",

      "consents.schufa.desc": "Ich willige der Verarbeitung meiner Daten zur [Prüfung der Zahlungswahrscheinlichkeit](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_smp/WL_DataPrivacy-DATA_Checks-de+02_2024.pdf) ein.",

      "consents.schufa.title": "Bonitätscheck",

      "consents.title": "Meine Einwilligungen",

      "contacts.invite.contact": "LADEN SIE %d KONTAKT EIN",

      "contacts.invite.contact.many": "LADEN SIE %d KONTAKTE EIN",

      "contacts.invite.earn": "Verdienen Sie bis zu %@",

      "contacts.permission.details": "Um fortzufahren und Kontakte auszuwählen, erlauben Sie GETAWAY jetzt Zugang zu Ihren Kontakten.",

      "contacts.permission.no": "später",

      "contacts.permission.title": "Zugriff auf Kontakte",

      "contacts.permission.yes": "Erlauben",

      "continue": "Fortfahren",

      "countries.phone.list": "Verfügbare Länder",

      "creditcheck.terms": "Mit der Auswahl des SEPA-Lastschriftverfahrens willige ich der Verarbeitung meiner Daten zur %s ein.",

      "creditcheck.terms.highlight": "Prüfung der Zahlungswahrscheinlichkeit",

      "creditcheck.terms.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/WL_DataPrivacy-DATA_Checks-de.pdf",

      "custom.camera.description.car.registration": "Bitte fotografieren Sie Ihren Fahrzeugschein auf einer neutralen Oberfläche und stellen Sie sicher, dass er innerhalb des Rahmens ist.",

      "custom.camera.description.damage": "Bitte achten Sie darauf, dass der Schaden gut zu erkennen und in der Mitte des Photos ist.",

      "custom.camera.description.license": "Bitte legen Sie Ihren Führerschein auf eine neutrale Oberfläche innerhalb der Markierung und nehmen ein Foto auf.",

      "custom.camera.description.selfie": "Bitte halten Sie den Aufnahme-Button für 3 Sekunden gedrückt.",

      "custom.camera.holdmessage.selfie": "Halten Sie den Aufnahme-Button für 3 Sekunden gedrückt, um Ihr Selfie aufzunehmen.",

      "custom.camera.repeat": "Wiederholen",

      "custom.camera.submit": "Übernehmen",

      "custom.camera.title.car.registration": "Fahrzeugschein",

      "custom.camera.title.damage": "Schadenaufnahme",

      "custom.camera.title.license.back": "Führerschein-Rückseite",

      "custom.camera.title.license.front": "Führerschein-Vorderseite",

      "custom.camera.title.selfie": "Selfie",

      "customerSupport.call": "ServiceTeam anrufen",

      "damage.add.noImages.error": "Bitte stellen Sie sicher, dass Sie mindestens zwei Bilder hinzugefügt haben.",

      "damage.add.success": "Vielen Dank für Ihre Schadensmeldung!",

      "damage.clean.description": "Dreck, Zurückgelassenes oder sonstiges (Innen oder Außen)",

      "damage.clean.title": "Verschmutzung melden",

      "damage.detected.carvaloo_feedback_link": "Schadensereignis erkannt. Bitte jetzt Zustand des Fahrzeugs erfassen: %s",

      "damage.detials.reportedon": "Gemeldet am:",

      "damage.new": "NEU",

      "damage.new.notification.description": "Vielen Dank für die Aktualisierung des Schadenprotokolls! Sie haben nun die Möglichkeit, die Vermieterin anzurufen.",

      "damage.normal.description": "Kratzer, Dellen, Beulen oder mehr",

      "damage.normal.title": "Schaden melden",

      "damage.screen.description": "Warnsymbol im Cockpit leuchtet",

      "damage.screen.title": "Kontrollleuchte melden",

      "damages.add": "Schaden melden",

      "damages.add.button.text": "Schaden hinzufügen",

      "damages.add.error.noimages": "Bitte fügen Sie mind. ein Foto des Schadens hinzu, um fortzufahren.",

      "damages.add.image.note": "Mindestens zwei Fotos (unterschiedliche Blickwinkel/ Abstände). Auf einem Foto muss das Kennzeichen zu erkennen sein.",

      "damages.bumper": "Stoßstange",

      "damages.burn": "Brandfleck",

      "damages.call": "Zu unseren Pannenhotlines",

      "damages.carRoadworthy": "Ist das Fahrzeug verkehrstüchtig?",

      "damages.characteristic": "Eigenschaften",

      "damages.characteristic.freeText": "anderes",

      "damages.characteristics.burn": "Brandfleck",

      "damages.characteristics.crack": "Riss",

      "damages.characteristics.deepScratch": "Kratzer (bis zur Grundierung)",

      "damages.characteristics.deepscratch": "Kratzer (bis zur Grundierung)",

      "damages.characteristics.dent": "Delle",

      "damages.characteristics.dirt": "Verschmutzung",

      "damages.characteristics.missing": "Nicht vorhanden",

      "damages.characteristics.other": "Anderes",

      "damages.characteristics.permanentDirt": "Dauerhafte Verschmutzung",

      "damages.characteristics.scratch": "Kratzer (oberflächlich)",

      "damages.characteristics.stoneChip": "Steinschlag",

      "damages.chars.left": "verbleibende Zeichen",

      "damages.component": "Bauteil",

      "damages.component.bumper": "Stoßstange",

      "damages.component.door": "Tür",

      "damages.component.engineBonnet": "Motorhaube",

      "damages.component.exteriorMirror": "Spiegel",

      "damages.component.floor": "Boden",

      "damages.component.hubcap": "Radkappe",

      "damages.component.interiorTrim": "Innenverkleidung",

      "damages.component.other": "Anderes",

      "damages.component.rearWindow": "Fenster",

      "damages.component.seat": "Sitz",

      "damages.component.sill": "Schweller",

      "damages.component.slidingDoor": "Schiebetür",

      "damages.component.tire": "Reifen",

      "damages.component.trunk": "Kofferraum/ Ladefläche",

      "damages.component.wheelRim": "Felge",

      "damages.component.windscreen": "Frontscheibe",

      "damages.component.wing": "Kotflügel",

      "damages.confirmRecord.button.text": "Schadensmeldung bestätigen",

      "damages.crack": "Riss",

      "damages.damage.desc": "Schadenbeschreibung",

      "damages.deepscratch": "Kratzer",

      "damages.dent": "Delle",

      "damages.description": "Schadensbeschreibung",

      "damages.dirt": "Verschmutzung",

      "damages.door": "Tür",

      "damages.engine.bonnet": "Motorhaube",

      "damages.exterior": "Außen",

      "damages.exterior.mirror": "Spiegel",

      "damages.floor": "Boden",

      "damages.gt10cm": ">10 cm",

      "damages.hubcap": "Radkappe",

      "damages.interior": "Innen",

      "damages.location": "Lage",

      "damages.location.front": "Vorderseite",

      "damages.location.na": "nicht verfügbar",

      "damages.location.rear": "Rückseite",

      "damages.location.side.center": "Mitte",

      "damages.location.side.codriver": "Beifahrerseite",

      "damages.location.side.driver": "Fahrerseite",

      "damages.lt10cm": "5 - 10cm",

      "damages.lt5cm": "<5 cm",

      "damages.new.photos.add": "Fotos hinzufügen",

      "damages.noRecord.text": "Keine Schadenmeldung",

      "damages.other": "Anderes",

      "damages.pernament.dirt": "Dauerhafte Verschmutzung",

      "damages.rear.window": "Fenster",

      "damages.report.areaQ": "Welcher Bereich?",

      "damages.report.charQ": "Was für ein Schaden?",

      "damages.report.compareSub": "An dieser Stelle sind bereits Schäden bekannt. Ist Ihrer dabei?",

      "damages.report.compareTitle": "Schon erfasst?",

      "damages.report.componentQ": "Welches Bauteil?",

      "damages.report.continue": "Weiter",

      "damages.report.continueNew": "Weiter — Neuschaden melden",

      "damages.report.describe": "Bitte beschreiben",

      "damages.report.doneBtn": "Fertig",

      "damages.report.doneSub": "Danke! Der Neuschaden wurde erfasst und wird geprüft.",

      "damages.report.doneTitle": "Schaden gemeldet",

      "damages.report.isKnown": "Ist bereits erfasst",

      "damages.report.isNew": "Nein — Neuschaden melden",

      "damages.report.knownSub": "Dann ist nichts weiter zu tun — der Schaden ist bereits dokumentiert.",

      "damages.report.knownTitle": "Alles klar",

      "damages.report.noneSub": "An dieser Stelle ist noch nichts erfasst — sieht nach einem Neuschaden aus.",

      "damages.report.noneTitle": "Keine bekannten Schäden",

      "damages.report.noteLabel": "Anmerkung (optional)",

      "damages.report.notePlaceholder": "z. B. zusätzliche Details …",

      "damages.report.other": "Sonstiges / Ich weiß es nicht",

      "damages.report.photoQ": "Fotos hinzufügen",

      "damages.report.sideQ": "Welche Seite?",

      "damages.report.submit": "Schaden melden",

      "damages.report.title": "Neuen Schaden melden",

      "damages.report.whereQ": "Wo ist der Schaden?",

      "damages.scratch": "Kratzer",

      "damages.seat": "Sitz",

      "damages.side": "Seite",

      "damages.side.center": "Mitte",

      "damages.side.coDriversSide": "Beifahrerseite",

      "damages.side.driversSide": "Fahrerseite",

      "damages.sill": "Schweller",

      "damages.size": "Größe",

      "damages.size.gt10cm": ">10cm",

      "damages.size.lt10cm": "5 - 10cm",

      "damages.size.lt5cm": "<5cm",

      "damages.stonechip": "Steinschlang",

      "damages.thirdParty": "Beteiligung einer dritten Partei",

      "damages.thirdParty.carRoadworthyDontKnow": "Ich weiß es nicht",

      "damages.thirdParty.dontKnow": "Ich weiß nicht",

      "damages.thirdParty.isInvolved": "Dritte Parteien sind beteiligt",

      "damages.thirdParty.notInvolved": "Dritte Parteien sind nicht beteiligt",

      "damages.thirdParty.notRoadworthy": "Nicht verkehrstüchtig",

      "damages.thirdParty.roadworthy": "Verkehrstüchtig",

      "damages.title": "Schadensbericht",

      "damages.toolbar.done": "Fertig",

      "damages.toolbar.next": "Nächstes",

      "damages.trim": "Innenverkleidung",

      "damages.trunk": "Kofferraum",

      "damages.viewer.damages": "Schäden",

      "damages.viewer.detail": "Schaden-Detail",

      "damages.viewer.graphic": "Grafik",

      "damages.viewer.groupByArea": "Gruppieren nach Bereich",

      "damages.viewer.list": "Liste",

      "damages.viewer.photo": "Foto",

      "damages.viewer.tapHint": "Tippe, um Schäden zu sehen oder zu melden",

      "damages.viewer.title": "Bekannte Schäden",

      "damages.viewer.zoomHint": "Mit +/− zoomen — am Gerät auch per Zwei-Finger-Geste",

      "damages.wheel.rim": "Felge",

      "damages.where": "Wo",

      "damages.where.exterior": "Außen",

      "damages.where.interior": "Innen",

      "damages.windscreen": "Frontscheibe",

      "damages.wing": "Kotflügel",

      "dashboard.about": "Rechtliches",

      "dashboard.balance": "Zahlungen",

      "dashboard.carprofile": "Autoprofil",

      "dashboard.dialog": "Impressum",

      "dashboard.dialog.bnd.url": "https://book-n-drive.app/imprint",

      "dashboard.dialog.cookies": "Cookies",

      "dashboard.dialog.getaway": "GETAWAY Impressum",

      "dashboard.dialog.getaway.url": "https://getaway.pro/imprint",

      "dashboard.dialog.interrent.url": "https://www.interrent.com/de/rechtliche-hinweise",

      "dashboard.dialog.licenses": "Urheberrechtshinweise",

      "dashboard.dialog.mba.url": "https://mietbar.app/privacy#datenschutz",

      "dashboard.dialog.msi.url": "https://mietsmart.app/imprint",

      "dashboard.dialog.privacy": "Datenschutzerklärung",

      "dashboard.dialog.rw": "Impressum",

      "dashboard.dialog.rw.url": "https://robbe.app/imprint",

      "dashboard.dialog.terms": "AGB",

      "dashboard.dialog.ubq": "Impressum",

      "dashboard.dialog.ubq.url": "https://ubq.app/imprint",

      "dashboard.freecredit": "Erhalten Sie gratis Guthaben",

      "dashboard.headline": "Hallo\n%@ %@",

      "dashboard.help": "Hilfe-Center",

      "dashboard.hi": "Hi",

      "dashboard.list.car": "Erfahren Sie, wie viel Sie mit Ihrem Auto verdienen können.",

      "dashboard.list.cars": "Weiteres Auto anmelden",

      "dashboard.logout": "ABMELDEN",

      "dashboard.logout.active.rental.prompt": "Bitte beenden Sie den Mietvorgang",

      "dashboard.logout.prompt": "Möchten Sie sich tatsächlich abmelden?",

      "dashboard.logout.success": "Sie haben sich erfolgreich abgemeldet.",

      "dashboard.menu.profile": "Nutzerkonto",

      "dashboard.myRentals": "Mietvorgänge",

      "dashboard.profile": "Ihre Registrierung",

      "dashboard.releasing": "Freigeben...",

      "dashboard.review": "Die App bewerten",

      "dashboard.services": "Serviceaufträge",

      "dashboard.settings": "EINSTELLUNGEN",

      "data.confirm.view.btn.txt": "Bestätigen",

      "data.confirm.view.description": "Bitte prüfen Sie alle Daten erneut auf ihre Richtigkeit.",

      "data.confirm.view.title": "Bitte bestätigen!",

      "data.test.view.btn.txt": "Weiter",

      "data.test.view.description": "Bitte bestätigen Sie, dass der Fahrzeugstatus korrekt wiedergegeben wird und alles funktioniert.",

      "data.test.view.title": "Verbindungstest",

      "day": "Tag",

      "day.ago": "Tage her",

      "day.fr": "Freitag",

      "day.mo": "Montag",

      "day.sa": "Samstag",

      "day.short": "Tag",

      "day.su": "Sonntag",

      "day.th": "Donnerstag",

      "day.tu": "Dienstag",

      "day.we": "Mittwoch",

      "days": "Tage",

      "days.ago": "Tage her",

      "days.short": "Tage",

      "delete": "Entfernen",

      "deposit.balance.title": "Hinterlegte Kaution",

      "deposit.card.desc.md": "✓ wird erstattet nach Vertragsende<br>✓ mit Kautionsrechnung als Pdf<br>✓ sichere Zahlung per GooglePay, Kreditkarte uvm.<br>",

      "deposit.card.price": "Einmalig %s",

      "deposit.card.title": "Kaution (erstattungsfähig)",

      "deposit.cta": "Zahlungsmethode wählen",

      "deposit.desc": "Um Ihre Zahlungsmethode freizuschalten, hinterlegen Sie bitte jetzt die erstattungsfähige Kaution.",

      "deposit.dialog.receipt": "Beleg anzeigen",

      "deposit.dialog.refund": "Erstattung anfordern",

      "deposit.dialog.title": "Hinterlegte Kaution",

      "deposit.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Warum muss eine Kaution hinterlegt werden? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Die Kaution dient als Sicherheit für offene Forderungen aus der Fahrzeugnutzung, wie zum Beispiel Selbstbeteiligungen im Schadensfall oder nicht gedeckte Gebühren. Sie wird bei der Registrierung hinterlegt und nach Vertragsende zurückerstattet, sofern keine offenen Beträge bestehen. </p> </details><hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Wann wird die Kaution erstattet? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Die Kaution wird idR. innerhalb von 6 Wochen nach Vertragsende nach Verrechnung mit etwaigen offenen Forderungen erstattet. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Erhalte ich eine Kautionsrechnung? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Ja, mit dem Abschluss deiner Registrierung und Freischaltung für den Carsharing-Service kannst du die Kautionsrechnung als Pdf herunterladen. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Wie berechnet sich die Kautionshöhe? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Zur Freischaltung des Nutzerkontos ist die Hinterlegung einer Kaution fällig. Die Höhe bemisst sich nach der aktuell gültigen Preisliste. Bei negativer oder fehlgeschlagener SCHUFA-Auskunft (oder einer vergleichbaren Wirtschaftsauskunftei) wird sich vorbehalten, eine höhere Kaution zu verlangen. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">",

      "deposit.footnote.secure.text": "Sichere und verschlüsselte Datenübertragung",

      "deposit.title": "Kaution hinterlegen",

      "description": "Beschreibung",

      "desktop.switch.mobile.desc": "Um fortzufahren, scannen Sie bitte jetzt den QR-Code mit Ihrem Smartphone.",

      "desktop.switch.mobile.title": "Mit Smartphone fortfahren",

      "dialog.camera.permission.desc": "Bitte aktivieren Sie den Kamerazugriff in den Browsereinstellungen für diese Seite",

      "dialog.camera.permission.title": "Kamera-Berechtigung verweigert",

      "dialog.deposit.add": "Kaution hinterlegen",

      "dialog.later": "Später",

      "dialog.payment.add": "Zahlungsmittel hinzufügen",

      "dialog.schufa.add": "MELDEADRESSE HINTERLEGEN",

      "dialog.tariff.add": "Tarif wählen",

      "digitalFuel.acquired.box.countdown": "Diese Notiz endet in %s s",

      "digitalFuel.acquired.box.dismiss": "Ausblenden",

      "digitalFuel.acquired.box.message": "Danke! Der Tankvorgang von %s ist abgeschlossen und bezahlt. Sie können jetzt losfahren.",

      "digitalFuel.acquired.box.title": "Getankt & bezahlt",

      "digitalFuel.choice.adblue.desc": "Mit der Tankkarte aus dem Fahrzeug bezahlen.",

      "digitalFuel.choice.adblue.title": "AdBlue",

      "digitalFuel.choice.fuel.desc": "Per App an der Zapfsäule bezahlen – ohne Tankkarte und ohne Bargeld.",

      "digitalFuel.choice.fuel.title": "Kraftstoff",

      "digitalFuel.choice.title": "Was möchten Sie tanken?",

      "digitalFuel.confirmClose.leave": "Verlassen",

      "digitalFuel.confirmClose.message": "Ihr Fortschritt geht verloren. Möchten Sie diesen Bildschirm verlassen?",

      "digitalFuel.confirmClose.stay": "Bleiben",

      "digitalFuel.confirmClose.title": "Digitales Tanken schließen?",

      "digitalFuel.desktop.subtitle": "Scannen Sie den Code, um digitales Tanken auf dem Handy zu öffnen.",

      "digitalFuel.desktop.title": "Weiter auf deinem Handy",

      "digitalFuel.location.permission.message": "Bitte aktivieren Sie in Ihren Browsereinstellungen den Standortzugriff, um den Tankvorgang zu starten.",

      "digitalFuel.location.permission.title": "Standort erforderlich",

      "digitalFuel.location.unavailable.message": "Ihr Standort konnte nicht ermittelt werden. Bitte versuchen Sie es erneut.",

      "digitalFuel.mileage.caption": "Bitte tragen Sie den aktuellen Kilometerstand des Fahrzeugs ein, das betankt werden soll.",

      "digitalFuel.mileage.header": "Kilometerstand",

      "digitalFuel.plate.caption": "Bitte tragen Sie das Kennzeichen des Fahrzeugs ein, das betankt werden soll. Bindestriche und Leerzeichen sind optional, zB \"HH-EU-1234\" oder \"HHEU1234\".",

      "digitalFuel.plate.errorEmpty": "Bitte tragen Sie das Kennzeichen ein.",

      "digitalFuel.plate.errorNotFound": "Wir konnten das Kennzeichen \"%s\" nicht einem Fahrzeug zuordnen. Bitte überprüfen Sie es noch einmal und versuchen Sie es erneut oder kontaktieren Sie unser Service Team.",

      "digitalFuel.plate.header": "Kennzeichen",

      "digitalFuel.plate.placeholder": "HH-EU 1234",

      "digitalFuel.productGroup.cng": "Erdgas (CNG)",

      "digitalFuel.productGroup.electric": "Strom",

      "digitalFuel.productGroup.gasoline": "Benzin",

      "digitalFuel.session.closed": "Der Tankvorgang wurde beendet.",

      "digitalFuel.settings.desc": "Neu: Tanken ohne Tankkarte und ohne Bargeld. Die App bezahlt automatisch – in drei einfachen Schritten.",

      "digitalFuel.settings.faq": "<h4 style=\"font-weight: 600;\">Häufig gestellte Fragen</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Benötige ich eine Tankkarte oder Bargeld? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Nein. Die Bezahlung erfolgt vollständig über die App. Sie müssen weder eine Karte einführen noch zur Kasse gehen. </p> </details> <hr style=\"border: 0,5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Woher weiß ich, welche Tankstelle ich nutzen kann? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Tippen Sie auf „Karte“. Es werden nur Tankstellen angezeigt, an denen die Bezahlung per App möglich ist, und die nächstgelegene wird für Sie ausgewählt. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> „Tanken starten“ fehlt oder funktioniert nicht – was nun? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Parken Sie das Fahrzeug direkt an der Tankstelle und erlauben Sie der App, Ihren Standort zu nutzen. Beides ist erforderlich, bevor mit dem Tanken begonnen werden kann. </p> </details> <hr style=\"border: 0,5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Woran erkenne ich, dass alles geklappt hat? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Nach dem Tanken zeigt die App die grüne Meldung „Tanken abgeschlossen“ an. Sie können dann losfahren. Sollte etwas schiefgehen, ist unser Support über das Chat-Symbol oben rechts mit nur einem Fingertipp erreichbar. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">",

      "digitalFuel.settings.stepOne": "1. Suchen Sie eine Tankstelle",

      "digitalFuel.settings.stepOne.desc": "Tippen Sie auf „Karte“. Wir zeigen Ihnen die nächstgelegene Tankstelle, an der Sie per App bezahlen können, sowie den Weg dorthin.",

      "digitalFuel.settings.stepThree": "3. Beginnen Sie mit dem Tanken und bezahlen Sie",

      "digitalFuel.settings.stepThree.desc": "Tippen Sie auf der Tankstellenkarte auf „Tanken starten“, wählen Sie die Nummer Ihrer Zapfsäule aus und tanken Sie wie gewohnt. Anschließend erfolgt die Bezahlung automatisch über die App – Sie müssen nicht zur Kasse gehen.",

      "digitalFuel.settings.stepTwo": "2. Parken Sie an der Zapfsäule",

      "digitalFuel.settings.stepTwo.desc": "Fahren Sie an eine freie Zapfsäule heran und stellen Sie den Motor ab. Der Tankvorgang kann erst beginnen, wenn Sie sich mit dem Fahrzeug direkt an der Tankstelle befinden.",

      "digitalFuel.settings.title": "Tanken Sie mit Ihrem Smartphone",

      "digitalFuel.splash.subtitle": "Danke, dass Sie eines unserer Fahrzeuge betanken.",

      "digitalFuel.splash.subtitleCarSharing": "Wir haben Ihre Fahrzeugdaten bereits — einen Moment bitte.",

      "digitalFuel.splash.title": "Per Handy tanken",

      "digitalFuel.splash.welcome": "Willkommen bei",

      "digitalFuel.start.confirm.message": "Stellen Sie sicher, dass Sie als Erste*r in der Reihe stehen.",

      "digitalFuel.start.confirm.title": "Tanken starten?",

      "digitalFuel.station.adblueNote": "AdBlue bezahlen Sie mit der Tankkarte aus dem Fahrzeug – die Bezahlung per App ist für AdBlue noch nicht möglich.",

      "digitalFuel.station.availability": "Verfügbarkeit",

      "digitalFuel.station.currentLevel": "Aktueller Füllstand: %s%",

      "digitalFuel.station.distance": "Entfernung",

      "digitalFuel.station.fuelType": "Kraftstoffart",

      "digitalFuel.station.fuelTypes": "Kraftstoffe",

      "digitalFuel.station.note": "Bezahlen Sie direkt per App an der Zapfsäule – Sie brauchen keine Tankkarte. Tippen Sie auf „Tanken starten\", wählen Sie die Zapfsäule und tanken Sie wie gewohnt.",

      "digitalFuel.station.offline": "Derzeit nicht verfügbar",

      "digitalFuel.station.remainingTankCapacity": "Verbleibendes Tankkapazität: %s l",

      "digitalFuel.station.startFueling": "Tanken starten",

      "digitalFuel.station.tankCapacity": "Tankgröße: %s L",

      "digitalFuel.station.tooFar.message": "Fahren Sie zunächst zur Tankstelle – das Tanken kann erst beginnen, wenn Sie sich mit dem Fahrzeug direkt an der Tankstelle befinden (im Umkreis von 50 m).",

      "digitalFuel.station.tooFar.title": "Tankstelle zu weit entfernt",

      "digitalFuel.success.backToRental": "Zurück zur Miete",

      "digitalFuel.success.subtitle": "Ihr Tankvorgang wurde erfolgreich abgeschlossen.",

      "digitalFuel.success.title": "Vielen Dank!",

      "direct.debit": "Lastschriftverfahren",

      "direct.debit.account.bic": "Bankleitzahl",

      "direct.debit.account.number": "Kontonummer",

      "direct.debit.add": "HINZUFÜGEN",

      "direct.debit.agreements.less": "Hiermit erteile ich teilauto.app (im Auftrag der teilAuto eG) und ihrem Zahlungsdienstleister Adyen N.V. (Gläubiger-ID NL48ZZZ342764500000) eine Einzugsermächtigung als SEPA-Lastschriftmandat zur Einziehung fälliger Zahlungen und weise mein Geldinstitut an, die auf mein Konto gezogenen Lastschriften einzulösen. Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Ich stimme der Fristverkürzung für die Vorankündigungen (Pre-Notification) zukünftiger SEPA-Lastschriften auf einen (1) Kalendertag zu.",

      "direct.debit.agreements.more": "Hiermit erteile ich der Vertragspartnerin und ihrem Zahlungsdienstleister Adyen N.V. (Gläubiger-ID NL48ZZZ342764500000) eine Einzugsermächtigung",

      "direct.debit.desc": "Für sichere und bequeme Zahlungen per Lastschrift hinterlege bitte deine IBAN.",

      "direct.debit.iban": "IBAN",

      "direct.debit.title": "Lastschriftverfahren",

      "directdebit": "Lastschriftverfahren",

      "disconnected.dialog.message": "Sie scheinen keine Internetverbindung zu haben. Bitte gehen Sie online, um die App nutzen zu können.",

      "disconnected.dialog.title": "Sie sind offline",

      "distance": "Gesamtstrecke",

      "dl.age.footnote": "Das Ausstellungsdatum eines Führerscheins im Plastikformat finden Sie idR. auf der Vorderseite unter der Nummer 4a",

      "dl.age.title": "Wann wurde Ihr Führerschein ausgestellt?",

      "dl.option.not.old": "Nach dem %s",

      "dl.option.old": "Vor mehr als %s Jahren",

      "dl.rejected.title": "Bitte achten Sie auf folgenden Hinweis zu Ihrem vorher eingereichten Dokument:",

      "dl.tab.paper": "Papierformat",

      "dl.tab.plastic": "Plastikformat",

      "dob.button.title": "Übernehmen",

      "dob.dateOfBirth.label": "Geburtstag (TT.MM.JJJJ)",

      "dob.description": "Um fortzufahren, sagen Sie uns bitte, wann Sie geboren wurden.",

      "dob.title": "Ihr Geburtstag",

      "document.upload.success": "Hochladen erfolgreich abgeschlossen",

      "done": "Fertig",

      "dongle.rental.fuelSettings.instruction": "Die Quittung muss nicht aufbewahrt werden. Im Anschluss lege bitte die Tankkarte zurück in das Heftchen zum KFZ-Schein.",

      "dongle.rental.section.locked": "Zurückgegeben",

      "dongle.rental.section.unlocked": "Übernommen",

      "driver.distanceduration.price.description": "{0} €/Std. + {1} €/km",

      "driver.distanceduration.price.map.description": "€/Std.",

      "driver.id.status.open": "Ausweisdokument hinzufügen",

      "driver.id.status.verified": "Personalausweis",

      "driver.id.status.verifying": "Dokument wird geprüft",

      "driver.license.banned.failure": "Bitte tragen Sie den Zeitraum ein",

      "driver.license.banned.update.button": "AKTUALISIEREN",

      "driver.license.banned.update.date.button": "WÄHLE",

      "driver.license.banned.update.description": "Ich habe ein behördlich angeordnetes Fahrverbot innerhalb des angegebenen Zeitraums.",

      "driver.license.banned.update.end": "Verbotsende",

      "driver.license.banned.update.start": "Verbotsbeginn",

      "driver.license.banned.update.title": "Fahrverbot",

      "driver.license.banned.warning": "Bitte beginnen Sie mit dem Anfangsdatum des Fahrverbots",

      "driver.license.bottom.description": "Hiermit versichere ich, dass meine Fahrerlaubnis behördlich ausgestellt und in Deutschland gültig ist und ich bei Bekanntwerden eines behördlich angeordneten Fahrverbots, diesen unverzüglich an GETAWAY melde.",

      "driver.license.frontImage": "Vorderseite",

      "driver.license.info.desc": "Bitte lassen Sie Ihren Führerschein bestätigen, damit Sie Autos in Ihrer Umgebung mieten können.",

      "driver.license.info.save": "BESTÄTIGEN",

      "driver.license.info.title": "Ihre Fahrerlaubnis",

      "driver.license.notuploaded.description": "Bitte lassen Sie Ihren Führerschein bestätigen",

      "driver.license.open.description": "Eingereicht am %@",

      "driver.license.rearImage": "Rückseite",

      "driver.license.selfieImage": "Ihr Selfie",

      "driver.license.status.deleted": "Abgelehnt, bitte erneut prüfen lassen",

      "driver.license.status.notuploaded": "Führerschein hinzufügen",

      "driver.license.status.open": "Wird geprüft...",

      "driver.license.status.paused": "Pausiert",

      "driver.license.status.verified": "Führerschein",

      "driver.license.status.verifying": "Führerschein wird geprüft",

      "driver.license.submit.failed": "Bitte laden Sie alle Fotos hoch, um fortzufahren.",

      "driver.license.submit.notNow": "Bitte lassen Sie Ihre Fahrerlaubnis bestätigen, um Autos in Ihrer Nähe mieten zu können.",

      "driver.license.submit.success": "Danke. Wir haben Ihre Fahrerlaubnis erhalten und melden uns bei Ihnen nach erfolgter Prüfung.",

      "driver.license.submited.description": "Eingereicht am %@",

      "driver.license.title": "Fahrerlaubnis",

      "driver.license.top.description": "Lassen Sie Ihre Fahrerlaubnis bestätigen, indem Sie Ihren Führerschein jetzt hochladen.",

      "driver.license.verified.description": "Aktualisieren Sie Ihre Fahrerlaubnis",

      "driver.mba.passenger.price.description": "{0} €/Std. + {1} €/Extra Km",

      "driver.mba.passenger.price.description.daily": "{0} €/Tag + {1} €/Mehr-Km",

      "driver.mba.passenger.price.map.description": "€/Std.",

      "driver.mba.passenger.price.map.description.daily": "€/Tag",

      "driver.mba.transporter.price.description": "{0} €/Std. + {1} €/Extra Km",

      "driver.mba.transporter.price.description.daily": "{0} €/Tag + {1} €/Mehr-Km",

      "driver.mba.transporter.price.map.description": "€/Std.",

      "driver.mba.transporter.price.map.description.daily": "€/Tag",

      "driver.mis.price.description": "{0} €/Tag + {1} €/Mehr-Km",

      "driver.mis.price.map.description": "€/Tag",

      "driver.mis.spain.price.description": "{0} €/Tag",

      "driver.mis.spain.price.map.description": "€/Tag",

      "driver.mis.transporter.price.description": "{0} €/Std + {1} €/Mehr-Km",

      "driver.mis.transporter.price.map.description": "€/Std",

      "driver.price.description": "{0} €/Std. + {1} €/km",

      "driver.price.getaway.description": "ab 0,00 €/Std",

      "driver.price.ikea.description": "{0} €/Std. + {1} €/km",

      "driver.price.ikea.description.weekend": "{0} € + {1} €/km",

      "driver.price.ikea.map.description": "€/Std.",

      "driver.price.ikea.map.description.weekend": "€",

      "driver.price.map.description": "€/Std.",

      "driver.price.map.description.weekend": "€",

      "driver.price.obi.description": "{0} €/Std. + {1} €/Mehr-Km",

      "driver.price.obi.description.weekend": "{0} € + {1} €/extra km",

      "drivercar.profile.priceDetails": "Preisinfo",

      "drivercar.profile.request.action": "Anfragen",

      "drivercar.profile.reserve.action": "Jetzt buchen",

      "drivercar.profile.service.reserve.action": "Service starten",

      "drivercar.rental.dialog.message": "Möchten Sie das Auto für den persönlichen Gebrauch mieten oder einen GETAWAY Service durchführen?",

      "drivercar.rental.dialog.reserve.rental": "Weiter für persönlichen Gebrauch",

      "drivercar.rental.dialog.reserve.service": "Weiter als Service-Trip",

      "drivercar.rental.dialog.title": "Bitte wählen Sie Ihr Fahrerprofil",

      "drivercar.reserved.status": "RESERVIERT",

      "drivercar.review.novalue": "✨ Neues Auto",

      "drivercar.unavailable.status": "Aktuell in Nutzung",

      "driving.damage.candrive": "Auto ist noch verkehrstüchtig.",

      "driving.damage.cantdrive": "Auto ist nicht mehr verkehrstüchtig.",

      "driving.finish.rental.dialog.message": "Der Mietvorgang kann nur beendet werden, wenn der Motor aus ist.",

      "driving.finish.rental.dialog.retry": "Erneut versuchen",

      "driving.finish.rental.dialog.title": "Beenden nicht möglich",

      "driving.refuel.dialog.message": "Der Tankvorgang kann nur gestartet werden, wenn der Motor aus ist.",

      "driving.refuel.dialog.title": "Tanken nicht möglich",

      "drivinglicense.form.selfie.description": "Video (3 Sekunden) aufnehmen",

      "drivinglicense.form.selfie.done.dialog.again": "Wiederholen",

      "drivinglicense.form.selfie.done.dialog.message": "Ihr Selfie wird zur Verifizierung Ihres Führerscheins benötigt.",

      "drivinglicense.form.selfie.done.dialog.title": "Selfie hochladen",

      "duration": "Gesamtdauer",

      "email.domain.error.dialog.ignore": "Ignorieren",

      "email.domain.error.dialog.update": "Update",

      "email.domain.error.prefix": "Meinen Sie",

      "email.domain.prefix.error": "Meinten Sie",

      "email.update.button": "Übernehmen",

      "email.update.desc": "Aktuell: %s",

      "email.update.success": "Eine neue E-Mail-Adresse ist hinterlegt worden. Bitte bestätigen Sie sie, indem Sie den Bestätigungs-Code eingeben.",

      "email.update.title": "E-Mail Adresse ändern",

      "email.verify.desc": "Geben Sie den Code ein, den wir soeben an diese E-Mail-Adresse gesendet haben:",

      "email.verify.skip": "Später bestätigen",

      "email.verify.success": "E-Mail erfolgreich verifiziert",

      "email.verify.title": "E-Mail-Bestätigungscode eingeben",

      "emergency.call": "Notruf",

      "empty": "keine Ergebnisse gefunden",

      "enjoyYourTrip.location.subtitle": "Abhol- & Rückkehrort",

      "enjoyYourTrip.title": "Gute Fahrt!",

      "equipment.4wd": "Allradantrieb",

      "equipment.abs": "ABS",

      "equipment.aircondition": "Klimaanlage",

      "equipment.childseat": "Kindersitz",

      "equipment.collosion.avoidance": "Notbremsassistent",

      "equipment.cruise": "Tempomat",

      "equipment.disabled": "Behindertengerecht",

      "equipment.esp": "ESP",

      "equipment.handsfree": "Freisprechanlage",

      "equipment.heating.aux": "Standheizung",

      "equipment.heating.seat": "Sitzheizung",

      "equipment.light.adaptive": "Kurvenlicht",

      "equipment.multifunctionalwheel": "Multifunktionslenkrad",

      "equipment.navigation": "Navigationssystem",

      "equipment.parking.assistant": "Einparkhilfe",

      "equipment.powersteering": "Servolenkung",

      "equipment.roof.bars": "Dachgepäckträger",

      "equipment.roof.panorama": "Panorama-Dach",

      "equipment.sensor.lane": "Spurhalteassistent",

      "equipment.sensor.proximity": "Abstandstempomat",

      "equipment.sensor.rain": "Regensensor",

      "equipment.start-stop": "Start/Stopp-Automatik",

      "equipment.sunroof": "Schiebedach",

      "equipment.traction": "Traktionskontrolle",

      "equipment.trailor": "Anhängerkupplung",

      "equipment.wheels.alloy": "Leichtmetallfelgen",

      "error": "Etwas hat nicht funktioniert. Bitte probieren Sie es erneut. Danke!",

      "error.new.password.wrong": "Ungültiges Passwort. Bitte versuche erneut, dein Passwort für das Buchungssystem einzugeben.",

      "feature.gate.register.title": "PLZ FREISCHALTEN",

      "feature.gate.register.url": "https://www.get-a-way.com/",

      "feature.gate.start": "2018-01-18",

      "feature.gate.submit": "STARTEN",

      "feature.gate.zip.error": "Diese Postleitzahl ist noch nicht freigeschaltet. Sichern Sie sich jetzt Ihre Einladung.",

      "feature.gate.zipcodes": "10589",

      "fees.url": "https://get-a-way.com/entgelte",

      "finish.rental.refreshButton": "Aktualisieren",

      "finished.rental.carkey.description": "Bitte legen Sie den Autoschlüssel in das dafür vorgesehene Fach zurück.",

      "finished.rental.carkey.title": "Autoschlüssel",

      "finished.rental.checkBelongings.button": "FINISHED",

      "finished.rental.checkBelongings.title": "Bitte achten Sie auf Ihre persönlichen Gegenstände.",

      "finished.rental.doors.description": "Bitte stelle sicher",

      "finished.rental.doors.title": "Fenster & Türen",

      "finished.rental.fuelLevel.description": "Bitte betanken Sie das Fahrzeug (kostenfrei mit Tankkarte), bevor Sie den Mietvorgang beenden. Andernfalls können Entgelte (<25%: 5€; <10%: 50€) fällig werden.",

      "finished.rental.fuelLevel.title": "Geringer Tankstand",

      "finished.rental.fuelcard.description": "Bitte legen Sie die Tankkarte in das dafür vorgesehene Fach zurück.",

      "finished.rental.fuelcard.title": "Tankkarte",

      "finished.rental.location.button": "ROUTE ANZEIGEN",

      "finished.rental.location.description": "Bitte beenden Sie die Miete in der angegebenen Rückgabezone. Andernfalls können Gebühren anfallen.",

      "finished.rental.location.force": "Mietende erzwingen",

      "finished.rental.location.title": "Rückgabezone",

      "finished.rental.locked.button": "VERRIEGELN",

      "finished.rental.locked.description": "Um fortzufahren, verriegeln Sie jetzt bitte das Auto von außen und stellen sicher, dass alle Türen und Fenster verschlossen sind.",

      "finished.rental.locked.title": "Auto von außen verriegeln",

      "finished.rental.thank.you.button": "JA",

      "finished.rental.thank.you.description": "Bitte entnehmen Sie den Schlüssel aus dem Handschuhfach.",

      "firstSteps.address.billing.title": "Alternative Rechnungsadresse",

      "firstSteps.address.city.placeholder": "Stadt",

      "firstSteps.address.country.placeholder": "Land",

      "firstSteps.address.instructions": "Bitte beachten Sie, dass es sich hierbei um Ihre aktuelle Meldeadresse handeln muss.",

      "firstSteps.address.optimized.title": "Aktuelle Meldeadresse",

      "firstSteps.address.personalInfo": "Persönliche Informationen",

      "firstSteps.address.postalCode.placeholder": "PLZ",

      "firstSteps.address.search.text": "Adresse suchen",

      "firstSteps.address.streetName.placeholder": "Straße",

      "firstSteps.address.streetNum.placeholder": "Nr.",

      "firstSteps.address.subTitle": "Meldeadresse",

      "firstSteps.address.submitBtn.text": "Hinzufügen",

      "firstSteps.address.title": "Meldeadresse",

      "firstSteps.email.code.placeholder": "E-Mail-Bestätigungscode",

      "firstSteps.payment.bic.placeholder": "BIC",

      "firstSteps.payment.optimized.sepa.desc": "Für sichere und bequeme Zahlungen per Lastschrift hinterlegen Sie bitte Ihre IBAN.",

      "firstSteps.payment.optimized.sepa.title": "Lastschriftverfahren",

      "firstSteps.payment.sepa.description.text": "Hiermit erteile ich dem teilauto.app (im Auftrag der teilAuto eG) und ihrem Zahlungsdienstleister Adyen N.V. (Gläubiger-ID NL48ZZZ342764500000) eine Einzugsermächtigung als SEPA-Lastschriftmandat zur Einziehung fälliger Zahlungen und weise mein Geldinstitut an, die auf mein Konto gezogenen Lastschriften einzulösen. Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Ich stimme der Fristverkürzung für die Vorankündigungen (Pre-Notification) zukünftiger SEPA-Lastschriften auf einen (1) Kalendertag zu.",

      "firstSteps.payment.sepa.iban.placeholder": "IBAN manuell eingeben",

      "firstSteps.payment.sepa.info": "Zustimmung zum Lastschriftverfahren",

      "firstSteps.payment.sepa.instruction": "Für sichere und bequeme Zahlungen per Lastschrift hinterlegen Sie bitte Ihre IBAN.",

      "firstSteps.payment.sepa.name.placeholder": "Kontoinhaber",

      "firstSteps.payment.sepa.submit.text": "Hinzufügen",

      "firstSteps.payment.sepa.title": "Lastschriftverfahren",

      "firstSteps.payment.sepa.url": "https://google.com",

      "firstSteps.payment.sepa.url.text": "Mehr",

      "firstSteps.phone.code.placeholder": "SMS-Bestätigungscode",

      "fleetadmin.admins.admin.new": "Neuen Administrator erstellen",

      "fleetadmin.admins.info.account": "Nutzerkonto",

      "fleetadmin.admins.info.active": "aktiv",

      "fleetadmin.admins.info.archive": "Nutzerkonto archivieren",

      "fleetadmin.admins.info.cancel": "Abbrechen",

      "fleetadmin.admins.info.created": "Erstellt am",

      "fleetadmin.admins.info.createdby": "Erstellt von",

      "fleetadmin.admins.info.delete.title": "Sicher, dass du diesen Administrator löschen willst?",

      "fleetadmin.admins.info.deleted": "archiviert",

      "fleetadmin.admins.info.email": "E-Mail",

      "fleetadmin.admins.info.firstName": "Vorname",

      "fleetadmin.admins.info.language": "Sprache",

      "fleetadmin.admins.info.lastName": "Nachname",

      "fleetadmin.admins.info.merchant": "Kunden-Account",

      "fleetadmin.admins.info.status": "Status",

      "fleetadmin.admins.info.update": "Aktualisieren",

      "fleetadmin.admins.info.update.title": "Nutzerinformationen aktualisieren",

      "fleetadmin.admins.info.user": "Nutzer",

      "fleetadmin.admins.permission.automatically": "Neue automatisch hinzufügen",

      "fleetadmin.admins.permission.claimsmanager": "Schadensbearbeitung",

      "fleetadmin.admins.permission.clear.all": "Alle entfernen",

      "fleetadmin.admins.permission.fleet.title": "Flottenverwaltung",

      "fleetadmin.admins.permission.fleetmanager": "Fahrzeuge und Zonen",

      "fleetadmin.admins.permission.mechanic": "Mechaniker (G-Connect)",

      "fleetadmin.admins.permission.merchant.title": "Account und Markenzugang",

      "fleetadmin.admins.permission.merchantmanager": "Administratorenverwaltung",

      "fleetadmin.admins.permission.select.all": "Alle hinzufügen",

      "fleetadmin.admins.permission.tripsmanager": "Mieten und Reservierungen",

      "fleetadmin.admins.permission.user.title": "Nutzerverwaltung",

      "fleetadmin.admins.permission.usergroupsmanager": "Nutzerkreise",

      "fleetadmin.admins.permission.usermanager": "Endnutzer",

      "fleetadmin.admins.permissions.update": "Aktualisieren",

      "fleetadmin.admins.tab.info": "Info",

      "fleetadmin.admins.tab.permissions": "Berechtigungen",

      "fleetadmin.admins.table.access": "Berechtigung",

      "fleetadmin.admins.table.blocked": "Status",

      "fleetadmin.admins.table.created": "Angelegt am",

      "fleetadmin.admins.table.email": "E-Mail",

      "fleetadmin.admins.table.firstname": "Vorname",

      "fleetadmin.admins.table.fleets": "Flottenzugang",

      "fleetadmin.admins.table.full": "Uneingeschränkt",

      "fleetadmin.admins.table.fullaccess": "Zugriff",

      "fleetadmin.admins.table.lastname": "Nachname",

      "fleetadmin.admins.table.limited": "Eingeschränkt",

      "fleetadmin.booking.blockreasons.label": "Gründe für Blockierung",

      "fleetadmin.booking.button.assign": "Zuweisen",

      "fleetadmin.booking.button.cancel": "Abbrechen",

      "fleetadmin.booking.button.update": "Aktualisieren",

      "fleetadmin.booking.create.button": "Erstellen",

      "fleetadmin.booking.create.duration": "Dauer",

      "fleetadmin.booking.create.plate": "Kennzeichen",

      "fleetadmin.booking.create.title": "Neue Buchung erstellen",

      "fleetadmin.booking.create.type": "Typ",

      "fleetadmin.booking.create.type.offline": "Nutzer",

      "fleetadmin.booking.create.type.service": "Service",

      "fleetadmin.booking.create.user": "Nutzer",

      "fleetadmin.booking.create.user.placeholder": "E-Mail",

      "fleetadmin.booking.statuschange.label": "Kommentar",

      "fleetadmin.booking.type.offline": "Offline",

      "fleetadmin.booking.type.rental": "Miete",

      "fleetadmin.booking.type.service": "Service",

      "fleetadmin.booking.type.statusChange": "Statusänderung",

      "fleetadmin.booking.update.from.label": "Start ",

      "fleetadmin.booking.update.from.title": "Start- und End-Datum der Buchung aktualisieren?",

      "fleetadmin.booking.update.to.label": "End ",

      "fleetadmin.booking.update.to.title": "Zeit aktualisieren",

      "fleetadmin.booking.update.user.title": "User aktualisieren",

      "fleetadmin.booking.update.vehicle.label": "Kennzeichen",

      "fleetadmin.booking.update.vehicle.title": "Neues Fahrzeug der Reservierung zuweisen?",

      "fleetadmin.booking.user.label": "Zugeordneter User",

      "fleetadmin.booking.user.placeholder": "E-Mail Adresse",

      "fleetadmin.car.status.clear.note": "Notiz entfernen.",

      "fleetadmin.car.status.range.instant": "Sofort",

      "fleetadmin.claim.after": "Nach",

      "fleetadmin.claim.invoice.create": "Rechnung erstellen",

      "fleetadmin.claim.invoice.created": "Erstellte Rechnung",

      "fleetadmin.claim.invoice.wontinvoice": "Geschlossen (nicht berechnet)",

      "fleetadmin.claim.section.complete": "Forderung abschließen",

      "fleetadmin.claim.section.completed": "Vollständig",

      "fleetadmin.claim.section.incomplete": "Schließen als unvollständig",

      "fleetadmin.filter.BOOKING.type": "Buchungs-Typ",

      "fleetadmin.trip.info.backby.label": "Rückgabe-Zeit",

      "fleetadmin.trip.info.tripstarted.label": "Begann um",

      "fleetadmin.trip.update.backby.label": "Rückgabezeit  ",

      "fleetadmin.trip.update.backby.title": "Rückgabezeit aktualisieren?",

      "fleetadmin.users.create.title": "Nutzer erstellen",

      "fleetadmin.users.info.upsellings.servicepaket300sb": "Service-Paket",

      "forget.email": "E-Mail-Adresse vergessen?",

      "forget.email.desc": "Tragen Sie die Handy-Nr. ein, die Ihrem Nutzerkonto hinterlegt ist. Sie erhalten im Anschluss einen Bestätigungscode per SMS.",

      "forget.email.title": "E-Mail-Adresse vergessen?",

      "forgot.email.desc": "Tragen Sie die Handy-Nr. ein, die Ihrem Nutzerkonto hinterlegt ist. Sie erhalten im Anschluss einen Bestätigungscode per SMS.",

      "forgot.email.dialog.title": "Um Ihre E-Mail-Adresse zu ermitteln, werden wir Sie im nächsten Schritt bitten, sich mit der von Ihnen angegebenen Handynummer zu authentifizieren.",

      "forgot.email.dialog.yes": "Weiter",

      "forgot.email.title": "E-Mail-Adresse vergessen?",

      "form.31MgGL.1.desc": "Diese Angabe ist wichtig für die Teilnahme an unseren Vorteilsprogrammen.",

      "form.31MgGL.1.title": "Sind Sie geworben worden?",

      "form.3yYJ8x.1.desc": "Sofern Sie in der Immobilie eines unserer Immobilienpartner\nwohnen, wählen Sie bitte den entsprechenden Partner.",

      "form.3yYJ8x.1.title": "Immobilienpartner wählen",

      "form.3yYJ8x.2.desc": "An welchem Standort werden Sie unseren Service\nvoraussichtlich am häufigsten nutzen?",

      "form.3yYJ8x.2.title": "Standort wählen",

      "form.woGyQx.1.desc": "Diese Angabe ist wichtig für die Teilnahme an unseren\nVorteilsprogrammen.",

      "form.woGyQx.1.title": "Sind Sie geworben worden?",

      "from": "Ab",

      "fuel.card.view.btn.txt": "Weiter",

      "fuel.card.view.description": "Bitte wählen Sie die verbundene Tankkarte um fortzufahren",

      "fuel.card.view.search.label": "Tankkarte",

      "fuel.card.view.title": "Tankkarte verbinden",

      "fuelstation.an.name": "Aral",

      "fuelstation.ap.name": "AP",

      "fuelstation.aral.name": "ARAL",

      "fuelstation.aral.title": "Aral Tankstelle",

      "fuelstation.avanti.name": "Avanti",

      "fuelstation.bp.name": "BP",

      "fuelstation.eni.name": "Eni",

      "fuelstation.help.text": "Hilfe zur Nutzung der Tankkarte",

      "fuelstation.om.name": "OMV",

      "fuelstation.omv.name": "OMV",

      "fuelstation.openallday": "24 Stunden geöffnet",

      "fuelstation.opennow": "Aktuell geöffnet:",

      "fuelstation.openstoday": "Heute geöffnet:",

      "fuelstation.openstomorrow": "Morgen geöffnet:",

      "fuelstation.status.prefix": "Tankstelle",

      "fuelstation.total.name": "Total",

      "fuelstation.totalenergies.name": "Total Energies",

      "fuelstation.westfalen.name": "Westfalen",

      "gas.station.note.text": "Tanken ist im Mietpreis inbegriffen. In jedem Fahrzeug befindet sich eine Tankkarte, mit der Sie bei allen Partnertankstellen bargeldlos tanken können. Die PIN zur Bezahlung wird Ihnen über die App angezeigt.",

      "handover.all.around.confirm": "Zustimmen & fortfahren",

      "handover.all.around.no": "Rundum-Fotos aufnehmen",

      "handover.all.around.warning": "Mir sind sie bewusst und ich stimme folgenden Mitwirkungspflichten ausdrücklich zu:\n\n\n✓ Pflicht zur Dokumentation: Ohne Fotodokumentation gilt das Fahrzeug bei Rückgabe als nicht ordnungsgemäß dokumentiert. Ich nehme zur Kenntnis, dass nachträglich festgestellte Schäden, die nicht in der Schadenliste vor Fahrtantritt aufgeführt waren, mir zugerechnet werden können, sofern ich den Zustand nicht anderweitig widerlegen kann.\n\n\n✓ Pflicht zur Nachsendung: Ich verpflichte mich, die 4 Rundum-Fotos unmittelbar per E-Mail an den Kundensupport zu übermitteln. Sollte ein nach Mietende festgestellter Neuschaden auf den Fotos aufgrund mangelhafter Qualität (z. B. Unschärfe, Dunkelheit oder falscher Winkel) nicht zweifelsfrei ausgeschlossen werden können, kann ich für diesen Schaden haftbar gemacht werden.\n\n\n✓ Pflicht zur Aufbewahrung: Zudem verpflichte ich mich, diese Fotos für einen Zeitraum von 90 Tagen ab Mietende digital aufzubewahren und der Vermieterin auf Verlangen jederzeit erneut zur Verfügung zu stellen.",

      "handover.belonging.title": "Alle Habseligkeiten entnommen",

      "handover.belongings.button.title": "Ich habe alles bei mir",

      "handover.belongings.decr": "Bitte überprüfe, dass du keine privaten Gegenstände im Auto vergessen hast.",

      "handover.belongings.title": "Nichts vergessen?",

      "handover.bottom.description": "Sie finden den Schlüssel im Handschuhfach auf der Beifahrerseite",

      "handover.carCheck.title": "Rundum-Fotos aufgenommen",

      "handover.card.title": "Tankkarte zurückgelegt",

      "handover.damages.count": "%d Schäden",

      "handover.demages.description": "Gemeldete Schäden",

      "handover.dongle.card.title": "Tankkarte zurückgeben",

      "handover.dongle.key.title": "Schlüssel zurückgeben",

      "handover.doorsWidows.title": "Nichts vergessen & ausgestiegen",

      "handover.doorsWindows.title": "Ich habe nichts vergessen & bin ausgestiegen",

      "handover.engine.dialog.message": "Starten Sie einfach den Motor, um den Übergabe-Check zu bestätigen. Sie finden den Autoschlüssel im Handschuhfach auf der Beifahrerseite.",

      "handover.engine.dialog.title": "Jetzt Motor starten",

      "handover.fuel.title": "Ich wähle den Tank-Service",

      "handover.fuelCard.button.title": "Aktualisieren",

      "handover.fuelCard.decr": "Bitte sicherstellen, dass sich die Tankkarte im Handschuhfach befindet.",

      "handover.fuelCard.title": "Tankkarte zurückgelegt",

      "handover.key.title": "Schlüssel zurückgelegt",

      "handover.location.button.title": "Rückgabeort anzeigen",

      "handover.location.decr": "Bitte die Miete im Umkreis des angegebenen Rückgabeorts beenden. ",

      "handover.location.option": "Selbst fahren",

      "handover.location.title": "Rückgabeort",

      "handover.location.warning": "Ich erkläre mich einverstanden, 500 € zu zahlen.",

      "handover.lock.button.title": "Auto verriegeln",

      "handover.lock.locking": "Verriegle ...",

      "handover.lock.title": "Schließe alle Türen und Fenster und verriegele das Fahrzeug von außen.",

      "handover.lowFuel.button.title": "Suche nächste Tankstelle",

      "handover.lowFuel.decr": "Bitte tanke das Auto, bevor du die Miete beendest. Für Hilfe, kontaktiere unser Service-Team.",

      "handover.lowFuel.option": "Selbst tanken",

      "handover.lowFuel.title": "Niedriger Kraftstoffstand",

      "handover.lowFuel.warning": "Ich erkläre mich einverstanden, 50 € zu zahlen.",

      "handover.lowfuel.fee": "Ich wähle den Tank-Service (%s)",

      "handover.payAsReserved.prefix": "Zahlungspflichtig bis",

      "handover.report": "Schaden bzw. Mangel melden",

      "handover.returnKey.button.title": "Aktualisieren",

      "handover.returnKey.decr": "Bitte sicherstellen, dass sich der Autoschlüssel im Handschuhfach befindet.",

      "handover.returnKey.title": "Autoschlüssel zurückgeben",

      "handover.returnLocation.title": "Ich wähle den Rückbring-Service (nur innerhalb von 5km um die Rückgabezone möglich)",

      "handover.title": "Starten Sie jetzt den Motor",

      "handover.top.description": "Wenn das Auto bis auf die bereits aufgeführten Mängel schadenfrei ist, starten Sie den Motor und haben eine gute Fahrt!",

      "handover.unlock.description": "Ihre Miete wurde nicht beendet. Bitte versuchen Sie es erneut. Sollte das Problem anschließend nicht behoben sein, wenden Sie sich bitte an unser Service Team.",

      "handover.unlock.slider.title": "Fahrzeug öffnen",

      "handover.unlock.title": "Etwas ist schief gelaufen!",

      "handover.warning.message": "Risiko bei mangelhafter Fotoqualität: Sollte ein nach Mietende festgestellter Neuschaden auf den Fotos aufgrund mangelhafter Qualität (z. B. Unschärfe, Dunkelheit oder falscher Winkel) nicht zweifelsfrei ausgeschlossen werden können, kann ich für diesen Schaden haftbar gemacht werden. Mir steht es frei, zusätzliche Fotos aufzubewahren.",

      "help.dialog.chat": "LiveChat",

      "help.dialog.helpcenter": "HilfeCenter",

      "help.dialog.title": "Service Team kontaktieren",

      "heyOBI.heyOBI.pricing": "| Mietdauer ||\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 € € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen | |\n| :-------- | -------: |\n| Insassenschutz | 10 €/Miete|\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 10% | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "home.about": "© GETAWAY, rechtl. Info ",

      "home.button.title": "Los geht's",

      "home.walkthrough.guest": "Als Gast fortfahren",

      "home.walkthrough.login": "Login",

      "home.walkthrough.map.signup": "Anmelden",

      "home.walkthrough.signup": "Los geht's",

      "hour": "Stunde",

      "hours": "Stunden",

      "hours.short": "Std.",

      "iban": "IBAN",

      "id.card.country.not.valid": "Für andere Länder ist keine Online-Dokumentenprüfung möglich. Hast du Fragen? Wende dich einfach an unseren Support.",

      "id.rejected.title": "Bitte achten Sie auf folgenden Hinweis zu Ihrem zuvor eingereichtem Dokument:",

      "id.tab.card": "Personalausweis",

      "id.tab.passport": "Reisepass",

      "ikeaInnsbruck.ubeeqo.pricing": "| Mietdauer (9:30 bis 21 Uhr) | |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| ab 5. Stunde | 9,90 €/Std|\n\n\n| Nachtzuschlag (21 bis 9:30 Uhr) | |\n| :-------- | -------: |\n| Mo - Fr | +20 €|\n| Sa - Mo | +89 €|\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,39 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 5% | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "ikeaInnsbruckBub.Buchbinder.pricing": "| Mietdauer (9:30 bis 21 Uhr) | |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| ab 5. Stunde | 9,90 €/Std|\n\n\n| Nachtzuschlag (21 bis 9:30 Uhr) | |\n| :-------- | -------: |\n| Mo - Fr | +20 €|\n| Sa - Mo | +89 €|\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 € / km |\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 5% | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "ikeaMain.duration.prefix": ".",

      "ikeaMain.ubeeqo.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| Ab 5. Stunde | 9,90 €/Std|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "ikeaMainBub.Buchbinder.pricing": "| Mietdauer | |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| Ab 5. Stunde | 9,90 €/Std|\n\n\n| Fahrtstrecke (inkl. Kraftstoff) | |\n| :-------- | -------: |\n| Je Kilometer | 0,49 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall) | |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe) | |\n| :-------- | -------: |\n| Tankstand < 25% | 15 € |\n| Tankstand < 5% | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/68fe517026116829219fdd72/pdf) zu entnehmen.",

      "image.upload.success": "Hochladen erfolgreich",

      "input.error.invalid": "Falsche Eingabe",

      "input.error.invalidCountry": "Ungültig",

      "input.password.error.invalid": "Passwort muss mindestens 6 Zeichen, eine Zahl, einen Großbuchstaben, und ein Symbol enthalten.",

      "insecuredevice.dialog.message": "Dieses Handy ist nicht mit Ihrem Nutzerkonto verknüpft. Um es zu verifizieren, senden wir Ihnen einen Bestätigungscode per SMS an die Handynummer, die in Ihrem Konto hinterlegt ist.",

      "insecuredevice.dialog.no": "Jetzt nicht",

      "insecuredevice.dialog.title": "Dieses Handy verifizieren",

      "insecuredevice.dialog.yes": "Verifizieren",

      "installation.cancel.dialog.message": "Bist du sicher, dass du die Installation abbrechen möchtest?",

      "installation.cancel.dialog.title": "Installation abbrechen!",

      "installation.cancel.dialog.yes": "Ja",

      "installed.view.btn.txt": "Anderen Auftrag beginnen",

      "installed.view.duration": "Fertig in",

      "installed.view.duration.minutes": "%s Minuten",

      "installed.view.duration.seconds": "%s Sekunden",

      "installed.view.title": "Ein weiteres Fahrzeug wurde verbunden!",

      "insurance.card.61dd46ad39dc364cd98f6739.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.61e015735925e70e8d972ef2.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.635665e30ad73328ee31a4e3.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.6360f3d14a2bec0c9d4088e6.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.636254dfd40f7c05a6517d5b.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.636ce123e5b01a0ca02d45ef.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.68f3457cacc9b808fc277bb8.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.68fe0e6c3e05fe5524a95644.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.6997422aa61cb20c384efab8.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.69a076f945c6fd1ee157f00d.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/containerImages_noSB.png",

      "insurance.card.69e8d1871c39133cc07d35c2.subtitle": "max. 500€ Selbstbeteiligung",

      "insurance.card.69e8d1871c39133cc07d35c2.title": "Mindestschutz",

      "insurance.card.69e8d1bb1c39133cc07d35c4.subtitle": "max. 150€ Selbstbeteiligung",

      "insurance.card.69e8d1bb1c39133cc07d35c4.title": "Bester Schutz",

      "insurance.card.6a7dd8798a03e46ab9d0154d.subtitle": "max. 1500 € Selbstbehalt",

      "insurance.card.6a7dd8798a03e46ab9d0154d.title": "Mindestschutz",

      "insurance.card.6a7dd8798a03e46ab9d0154f.subtitle": "max. 500 € Selbstbeteiligung\n",

      "insurance.card.6a7dd8798a03e46ab9d0154f.title": "Schutz",

      "insurance.card.6a7dd8798a03e46ab9d01551.subtitle": "max. 150 € Selbstbeteiligung\n",

      "insurance.card.6a7dd8798a03e46ab9d01551.title": "Bester Schutz",

      "insurance.card.6a881be56c0e2870fcea139f.subtitle": "0€ Selbstbeteiligung",

      "insurance.card.6a881be56c0e2870fcea139f.title": "Bester Schutz",

      "insurance.card.6a88487d6c0e2870fcea13c0.subtitle": "max. 2800€ Selbstbeteiligung",

      "insurance.card.6a88487d6c0e2870fcea13c0.title": "Minimaler Schutz",

      "insurance.card.F3008.title": "Bester Schutz",

      "insurance.card.F3040.subtitle": "max. 500€ Selbstbeteiligung",

      "insurance.card.F3040.title": "Mindestschutz",

      "insurance.card.F3041.subtitle": "max. 150€ Selbstbeteiligung",

      "insurance.card.F3041.title": "Bester Schutz",

      "insurance.charterline.150": "Maximal 150 €",

      "insurance.charterline.1500": "Maximal 1.500 €",

      "insurance.charterline.15000": "Maximal 15.000 €",

      "insurance.charterline.151": "Maximal 150 €",

      "insurance.charterline.500": "Maximal 500 €",

      "insurance.charterline.501": "Maximal 500 €",

      "insurance.charterline.650": "Maximal 650 €",

      "insurance.charterline.750": "Maximal 750 €",

      "insurance.charterline.description": "Selbstbeteiligung",

      "insurance.charterline.description.1500": "Bis zu 15.000 €",

      "insurance.charterline.headline": "Selbstbeteiligung",

      "insurance.charterline.value.150": "+24 €/KalTag",

      "insurance.charterline.value.1500": "inkl.",

      "insurance.charterline.value.15000": "inkl.",

      "insurance.charterline.value.151": "+34 €/KalTag",

      "insurance.charterline.value.500": "+19 €/KalTag",

      "insurance.charterline.value.501": "+29 €/KalTag",

      "insurance.charterline.value.650": "inkl.",

      "insurance.charterline.value.750": "inkl.",

      "insurance.description": "maximal",

      "insurance.description.free": "Bis zu",

      "insurance.fee_item.description": "Reduzierung SB %s",

      "insurance.label.free": "max. 1.500€",

      "insurance.previous_for_the_same_car_must_be_used": "Bei Benutzung des gleichen Fahrzeugs muss die selbe Versicherungsoption gewählt werden.",

      "insurance.rental.title": "Ihre Selbstbeteiligung!",

      "insurance.value": "€/KalTag",

      "insurance.value.free": "inkl.",

      "internet.disconnected.message": "Bitte überprüfen Sie Ihre Internetverbindung",

      "invitation.code.label": "Einladungscode eingeben",

      "invitation.code.submit": "Los geht’s",

      "invitation.description": "Geben Sie jetzt Ihren Einladungscode an",

      "invitation.remove.text": "ENTFERNEN",

      "invitation.submit.text": "ÜBERNEHMEN",

      "invitation.text.placeholder": "Einladungscode",

      "invitation.title": "Sie haben eine Einladung?",

      "invite.browse.contacts.button": "KONTAKTE DURCHSUCHEN",

      "invite.contacs.success": "Einladung ist abgeschickt worden. Wir benachrichtigen Sie, sobald diese angenommen wird.",

      "invite.contact.email.warning": "Sie müssen einen E-Mail Account eingerichtet haben",

      "invite.email.description": "GETAWAY ist der erste professionelle Fuhrpark von Autofahrern für Autofahrer. Wenn Sie ein Auto haben, können Sie es Geld verdienen lassen und somit alle Ihre Autokosten decken. Haben Sie einen Führerschein, können Sie jederzeit und überall Ihr Wunschauto per App finden und sofort losfahren. Probieren Sie es aus und sichern sich mit dieser Einladung 10€ Startguthaben auf %@",

      "invite.email.title": "Machen Sie mit bei GETAWAY",

      "invite.friends.share.button": "TEILEN",

      "invite.friends.share.description": "Zum Kopieren, Einladungslink klicken und halten",

      "invite.message": "Ich schenke dir 10€ Startguthaben für GETAWAY, Ihrem Universalschlüssel zu jedem Auto in Ihrer Umgebung.  Oder vermieten Sie Ihr eigenes Auto und verdienen 100€ wöchentlich. Laden Sie sich jetzt gratis die App herunter.",

      "invite.message.title": "Sie sind zu GETAWAY eingeladen worden",

      "invoice.footer.issuedBy": "Beleg ausgestellt durch:",

      "invoice.footer.page": "SEITE %s VON %s",

      "invoice.intro": "Vielen Dank für die Nutzung von %s! Hiermit erlauben wir uns folgende Leistungen in Rechnung zu stellen.",

      "invoice.intro.credit": "Vielen Dank für die Beauftragung. Wir berechnen für den Leistungszeitraum %s was folgt:",

      "invoice.intro.thanks": "Vielen Dank für die Nutzung von %s!",

      "invoice.issuedOnBehalf": "Beleg ausgestellt im Auftrag von",

      "invoice.item.f3004": "Mietstunde(n)",

      "invoice.item.f3060": "Reduzierung Selbstbehalt (500€) pro Std.",

      "invoice.item.f9999": "Diverse",

      "invoice.meta.bookingRef": "Referenznummer:",

      "invoice.meta.customerRef": "Kundenzeichen:",

      "invoice.meta.date": "Belegdatum:",

      "invoice.meta.number": "Belegnummer:",

      "invoice.odometer": "Km-Stand %s",

      "invoice.payment.heading": "ZAHLUNGSMITTEL",

      "invoice.pickup": "ÜBERNAHME",

      "invoice.rental.label": "Mietvorgang:",

      "invoice.rental.plate": "Kennzeichen:",

      "invoice.rental.userGroup": "Nutzerkreis:",

      "invoice.return": "RÜCKGABE",

      "invoice.storno": "Hiermit wird der Beleg (Anhang) storniert %s",

      "invoice.storno.footer": "Der stornierte Betrag wird auf die jeweilige Einzahlungsmethode des Begünstigten erstattet. Für die ordnungsgemäße Versteuerung ist der Begünstigte selbst verantwortlich.",

      "invoice.table.amountDue": "Zu zahlender Betrag",

      "invoice.table.amountRefund": "Zu erstattender Betrag",

      "invoice.table.grossSum": "Gesamtbrutto",

      "invoice.table.grossTotal": "BRUTTO GESAMT",

      "invoice.table.lessCredit": "Abzgl. Guthaben",

      "invoice.table.netTotal": "NETTO GESAMT",

      "invoice.table.qty": "MENGE",

      "invoice.table.subtotal": "Zwischensummen",

      "invoice.table.title": "Mietvorgang",

      "invoice.table.unitGross": "BRUTTO",

      "invoice.table.vatNote": "(inkl. USt. %s)",

      "invoice.table.vatPortion": "%s iHv. %s",

      "invoice.title.creditNote": "Gutschrift",

      "invoice.title.invoice": "Rechnung",

      "joinCircle.title": "Nutzerkreis beitreten",

      "keine": "Keine",

      "landing.card1.desc": "Decken Sie Ihre Autokosten, indem Sie es sicher und ohne Aufwand in Ihrer Nachbarschaft vermieten.",

      "landing.card1.title": "Ihr Auto verdient es!",

      "landing.card2.desc": "Unsere Versicherung schützt Ihr Auto und Ihre Mobilität.",

      "landing.card2.title": "Rundum versichert",

      "landing.later": "SPÄTER",

      "landing.login": "Ich habe bereits ein Nutzerkonto",

      "landing.signup": "Willkommen!",

      "landing.signup.dialog.email.exists": "Es scheint, als sei Ihre E-Mail Adresse bereits hinterlegt. Möchten Sie Ihr Passwort zurücksetzen?",

      "language.dialog.cz": "Čeština (CZ)",

      "language.dialog.de": "Deutsch (DE)",

      "language.dialog.en": "English (EN)",

      "language.dialog.es": "Español (ES)",

      "language.dialog.fr": "Français (FR)",

      "language.dialog.gr": "Ελληνικά (EL)",

      "language.dialog.it": "Italiano (IT)",

      "language.dialog.pl": "Polski (PL)",

      "language.dialog.sk": "slovenský (SK)",

      "language.dialog.title": "Sprache wählen",

      "language.dialog.tr": "Türkçe (TR)",

      "late": "abgelaufen",

      "less": "Weniger",

      "license.addPhoto.back": "Führerschein-Rückseite hinzufügen",

      "license.addPhoto.front": "Führerschein-Vorderseite hinzufügen",

      "license.addVideo": "Selfie-Video hinzufügen",

      "license.addedPhoto.back": "Führerschein-Rückseite",

      "license.addedPhoto.front": "Führerschein-Vorderseite",

      "license.addedVideo": "Selfie-Video",

      "license.submit.title": "Weiter",

      "license.title": "Führerschein hinzufügen",

      "licenses.title": "Urheberrechtshinweise",

      "list.car.desc": "Fotografieren Sie jetzt die Vorderseite Ihres Fahrzeugscheins und lassen Sie gratis prüfen, wie viel Ihr Auto für Sie verdienen kann.",

      "list.car.footer": "Das Auto hat eine gültige Haftpflichtversicherung und eine gültige Hauptuntersuchung.",

      "list.car.license": "Kfz-Schein Vorderseite (vollst. aufgeklappt)",

      "list.car.ownership.error": "Bitte geben Sie das Eigentumsverhältnis an",

      "list.car.ownership.message": "Wer nicht Halter bzw. Eigentümer des Fahrzeugs ist, muss alternativ eine Vollmacht vorlegen. Eine Vorlage wird zur Verfügung gestellt.",

      "list.car.submit": "JETZT CHECKEN LASSEN",

      "list.car.success": "Danke, Ihr Fahrzeugschein ist übermittelt worden. Wir schicken Ihnen eine E-Mail mit der weiteren Vorgehensweise.",

      "list.car.takeaphoto.error": "Bitte laden sie Ihren Kfz-Schein hoch, um fortzufahren.",

      "list.car.title": "Wie viel verdient Ihr Auto?",

      "litre.short": "l",

      "loading": "loading ...",

      "location.permission": "Achtung: Bitte erlauben Sie Zugriff auf Ihren Standort, um Fahrzeuge finden und mieten zu können.",

      "location.permission.details": "Um u.a. Autos in Ihrer Nähe angezeigt zu bekommen, aktivieren Sie jetzt bitte die Standortdienste.",

      "location.permission.no": "Später",

      "location.permission.title": "Standortdienste aktivieren",

      "location.permission.unauthorized": "GETAWAY kann ohne die Info über Ihren Standort nicht einwandfrei funktionieren.",

      "location.permission.yes": "Erlauben",

      "lock.error": "Auto kann nicht verschlossen werden. Bitte kontaktieren Sie unser Service Team.",

      "login.button.title": "Login",

      "login.email": "Stattdessen mit E-Mail-Code anmelden",

      "login.email.button.title": "E-Mail-Code anfordern",

      "login.email.desc": "Bitte geben Sie die E-Mail-Adresse an, mit der Sie sich registriert haben. Sie erhalten im Anschluss eine E-Mail mit einem Code, um sich anzumelden.",

      "login.email.placeholder": "E-Mail",

      "login.email.title": "Mit E-Mail-Code anmelden",

      "login.failed.again.text": "Erneut versuchen",

      "login.failed.alert.body": "E-Mail und/oder Passwort stimmen nicht. Versuchen Sie es noch einmal oder klicken Sie \"Vergessen?\"",

      "login.failed.alert.title": "Anmelden fehlgeschlagen",

      "login.footnote.signup.action": "Hier registrieren",

      "login.footnote.signup.text": "Noch kein Nutzerkonto?",

      "login.forgot.desc": "Bitte geben Sie die E-Mail-Adresse an, mit der Sie sich registriert haben. Sie erhalten im Anschluss eine E-Mail zum Zurücksetzen Ihres Passworts.",

      "login.forgot.text": "Passwort zurücksetzen",

      "login.forgot.title": "Passwort vergessen?",

      "login.orloginfacebook.text": "Oder per",

      "login.orsignupfacebook.text": "Oder per",

      "login.password.placeholder": "Passwort",

      "login.title": "Schön, Sie wiederzusehen!",

      "login.with.password": "Stattdessen mit Passwort anmelden",

      "logout.prompty.logout": "JA",

      "mages.510cm": "5 - 10cm",

      "map.blocked.callout": "Fahrzeug muss gewartet werden. Es ist in Kürze wieder verfügbar.",

      "map.booking.reserve": "Reservieren",

      "map.bookings.button.text": "Reservierung ab",

      "map.callout.bonus.lowAndOut": "Bis zu 10 € Sofort-Gutschrift.",

      "map.callout.bonus.lowFuel": "5€ Sofort-Bonus",

      "map.callout.bonus.lowFuel&out": "Bis zu 10€ Sofort-Bonus",

      "map.car.eligible.description": "[In Warteschlange] Bald in Ihrer Nähe verfügbar.",

      "map.car.inqueue.callout": "Melden sich mehr aus meiner Nähe an, stehe ich in Kürze zur Verfügung.",

      "map.car.release_ready.callout": "Dieses Fahrzeug ist leider aktuell nicht verfügbar. Bitte wählen Sie einen anderen Zeitraum.",

      "map.car.release_ready.description": "[In Nutzung] Bitte probieren Sie es später erneut.",

      "map.car.released.callout": "Verfügbar bis\n%@",

      "map.car.selected.callout": "Ich bin bald verfügbar. Sie werden mich in Kürze mieten können 🙌",

      "map.card.refuel": "Bitte tanken",

      "map.card.rentedFuel": "mind. 25 %",

      "map.consent.returnrefuel.no": "Abbrechen",

      "map.consent.returnrefuel.yes": "Zustimmen",

      "map.embedded.area.label": "Abholung & Rückgabe",

      "map.embedded.area.placeholder": "Bitte wählen Sie aus",

      "map.embedded.card.button": "Fahrzeuge anzeigen",

      "map.embedded.card.title": "Mieten Sie Transporter bequem in Ihrer Nähe",

      "map.embedded.cars.empty": "Für den ausgewählten Zeitraum sind keine Fahrzeuge verfügbar.",

      "map.embedded.from": "Von",

      "map.embedded.to": "Bis",

      "map.fillProfile.dialog.add": "Hinzufügen",

      "map.fillProfile.dialog.message": "Vervollständigen Sie jetzt Ihre Nutzerangaben (nur 2 Min.), um fortzufahren.",

      "map.fillProfile.dialog.no": "Jetzt nicht",

      "map.fillProfile.dialog.secure": "Kreditkartenüberprüfung",

      "map.fillProfile.dialog.support": "Registrierung abschließen",

      "map.fillProfile.dialog.title": "Fehlende Nutzerangaben",

      "map.fillProfile.dialog.yes": "OK",

      "map.filter.check": "Verfügbarkeit prüfen",

      "map.filter.description": "Geben Sie den gewünschten Abholungs- und Rückgabezeitpunkt an.",

      "map.filter.findCar": "Fahrzeug finden",

      "map.filter.header": "Wann möchten Sie ein Fahrzeug?",

      "map.filter.now": "Ab sofort",

      "map.filter.pickup": "Abholung",

      "map.filter.reset": "Zurücksetzen",

      "map.filter.return": "Rückgabe",

      "map.filter.secondary.text": "Zeitraum ändern",

      "map.filter.time.to": "bis",

      "map.filter.title": "Wann brauchen Sie ein Fahrzeug?",

      "map.marker.perHours": "€/Std.",

      "map.popup.firststeps": "%@ und erhalten Sie Ihren Willkommensbonus.",

      "map.popup.firststeps.url": "https://applink.get-a-way.com/user-challenges-firststeps",

      "map.popup.firststeps.url.text": "Schließen Sie jetzt Ihre Anmeldung ab",

      "map.rental.blocked": "Miete ist geblockt",

      "map.rented.callout": "Im gewählten Zeitraum nicht verfügbar.",

      "map.rented.car.callout": "Verfügbar nach\n%@",

      "map.reservedCarHeader.settings.title": "Mieteinstellungen (Versicherung etc.)",

      "map.reservedCarHeader.title": "Das Auto ist reserviert!",

      "map.service.lastCleaning.new": "neu",

      "map.station.card.button": "Auswählen",

      "map.station.card.description": "Station",

      "map.station.card.headline": "Wähle eine Fahrzeugkategorie",

      "map.station.card.no.categories": "In dieser Station stehen im gewählten Zeitraum keine Fahrzeuge per App zur Verfügung.",

      "map.station.card.phone": "Telefon",

      "map.station.card.position": "Standort",

      "map.station.card.title": "Robben & Wientjes",

      "map.station.card.workinghrs": "Öffnungszeiten",

      "map.station.closed.text": "In dieser Station stehen im gewählten Zeitraum keine Fahrzeuge per App zur Verfügung.",

      "map.station.note.title": "Hinweise",

      "map.time": "Autos filtern",

      "map.time.select.apply": "Filtern",

      "map.time.select.title": "wie lange möchten Sie einen GETAWAY?",

      "map.unavailable.callout": "Im gewählten Zeitraum nicht verfügbar. %s .",

      "map.unavailable.callout.link": "https://www.google.com/",

      "map.unavailable.callout.link.text": "Verfügbarkeit anzeigen",

      "map.user.blocked": "Nutzerkonto blockiert",

      "map.usercar.BLOCKED.callout": "✋ Ich bin aktuell geblockt. Bitte kontaktieren Sie das Service Team.",

      "map.usercar.ELIGIBLE.callout": "💪 Ich habe alle Tests bestanden",

      "map.usercar.EQUIPPED.callout": "⚙ Ich bin ausgerüstet",

      "map.usercar.SELECTED.callout": "🎉 Ich kann es kaum erwarten, ausgerüstet zu werden!",

      "map.usercar.blocked.callout": "✋ Ich bin aktuell geblockt. Bitte kontaktieren Sie das Service Team.",

      "map.usercar.eligible.callout": "💪 Ich habe alle Tests bestanden",

      "map.usercar.equipment_ready.callout": "👨‍🔧 Ich warte auf den GETAWAY Techniker",

      "map.usercar.listed.callout": "💰 Ich könnte bis zu 400€ pro Monat verdienen!",

      "map.usercar.released.callout": "Freigegeben bis\n%@",

      "map.usercar.selected.callout": "🎉 Ich kann es kaum erwarten, ausgerüstet zu werden!",

      "map.usercar.service.callout": "🚗✨ Ich genieße gerade einen Service",

      "marketing.consent": "Ich bin einverstanden, den Newsletter per E-Mail zu erhalten. Jederzeit widerrufbar.",

      "md.demo": "## UBEEQO \"OBI DEFAULT\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 19,99 € (inkl. 20km/Std)|\n| Mo-Sa 20-8 Uhr | 59,90 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 139,90 € (inkl. 150km) |\n| An Feiertagen | 59,90 € (inkl. 100km) |\n<br/>\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 €|\n<br/>\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n<br/>\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n<br/>\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n<br/>\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"HEY OBI\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 16,99 € (inkl. 20km/Std)|\n| Mo-Sa 20-8 Uhr | 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 102,00 € (inkl. 150km) |\n| An Feiertagen | 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"OBI Mitarbeiter\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 16,99 € (inkl. 20km/Std)|\n| Mo-Sa 20-8 Uhr | 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 102,00 € (inkl. 150km) |\n| An Feiertagen | 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.\n\n## UBEEQO \"SPP Default\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 6,90 €/Std|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachttarif | 20 €|\n| Wochenendtarif | 79 €|\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"SPP Kunde\"\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n *Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.\n\n<br/><br/>\n## UBEEQO \"SPP Mitarbeiter\"\n\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n*Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.<br/>\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.\n\n\n\n<br/><br/>\n## UBEEQO \"IKEA DEFAULT\"\n\n\n| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| Ab 5. Stunde | 9,90 €/Std|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.\n\n\n<br/><br/>\n## UBEEQO \"IKEA INNSBRUCK ETC\"\n\n\n| Mietdauer (9:30 bis 21 Uhr)    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 7,90 €/Std|\n| ab 5. Stunde | 9,90 €/Std|\n\n\n|  Nachtzuschlag (21 bis 9:30 Uhr)    |  |\n| :-------- | -------: |\n| Mo - Fr | +20 €|\n| Sa - Mo | +89 €|\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf) zu entnehmen.",

      "meter.short": "m",

      "mileage": "Km-Stand",

      "minute": "Minute",

      "minute.short": "Min.",

      "minutes": "Minuten",

      "more": "Mehr",

      "multiplecars.add": "Jetzt neues Auto prüfen lassen",

      "multiplecars.footnote": "Tipps und Tricks, wie Sie mit Ihrem Auto Geld verdienen, erfahren Sie in unserem %@.",

      "multiplecars.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#geld-verdienen",

      "multiplecars.footnote.url.text": "HilfeCenter",

      "multiplecars.released.returntime": "bis",

      "multiplecars.rented.returntime": "bis spät.",

      "multiplecars.title": "MEINE AUTOS",

      "navigate": "Navigieren",

      "needsAccessKitCheck": "AccessKit prüfen",

      "needsBattery": "Niedriger Batteriestand",

      "needsCleaning": "Reinigung nötig",

      "needsFuel": "Kraftstoff nötig",

      "needsFuelCard": "Tankkarte nötig",

      "needsKeyFob": "KeyFob nötig",

      "needsOther": "Sonstiges nötig",

      "needsRelocation": "Verlegungsfahrt nötig",

      "needsRepair": "Reparatur nötig",

      "new.insurance.charterline.150": "150 €",

      "new.insurance.charterline.1500": "1500 €",

      "new.insurance.charterline.15000": "15.000 €",

      "new.insurance.charterline.151": "150 €",

      "new.insurance.charterline.500": "500 €",

      "new.insurance.charterline.501": "500 €",

      "new.insurance.charterline.650": "650 €",

      "new.insurance.charterline.750": "750 €",

      "new.insurance.charterline.description": "Max",

      "new.insurance.charterline.description.15000": "Bis zu",

      "new.partner.password.placeholder": "Passwort",

      "new.password.yes": "Zur Passworteingabe",

      "no": "Nein",

      "no.geocode": "Rückgabezone anzeigen",

      "noBlockReason": "Kein Downtime-Grund verfügbar",

      "noRentals": "Keine Mietvorgänge vorhanden",

      "noServices": "Keine Aufträge",

      "nocars.invite": "EINLADEN",

      "nocars.screen.title": "Laden Sie Freunde ein für mehr Autos in Ihrer Nähe!",

      "normal.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeDamage_compressed.png",

      "notNow": "Nicht jetzt",

      "notification.backby.desc": "Bitte denke an die rechtzeitige Rückgabe, andernfalls können Gebühren anfallen.",

      "notification.backby.hide": "HINWEIS VERBERGEN",

      "notification.backby.title": "Noch %s",

      "notification.backby.title.late": "Seit %s",

      "notification.booking.rentals": "Meine Mieten",

      "notification.booking.success": "Sie haben Ihre Buchung erfolgreich durchgeführt. Sie finden den Buchungsstatus in Ihrem Nutzerkonto.",

      "notification.email": "Per E-Mail",

      "notification.email.desc": "Erlaubnis, Sie per E-Mail zu kontaktieren.",

      "notification.finishRental.complain": "😕 Ich möchte mich beschweren.",

      "notification.finishRental.description": "Ihre Fahrt wurde beendet. Sie erhalten eine Übersicht per E-Mail.",

      "notification.finishRental.title": "Vielen Dank, dass Sie GETAWAY nutzen!",

      "notification.mail": "Per Post",

      "notification.mail.desc": "Erlaubnis, Sie per Post zu kontaktieren.",

      "notification.negative.backby.desc": "Bitte bringen Sie das Fahrzeug zurück. Ein anderer Nutzer wartet bereits. Es können Gebühren anfallen.",

      "notification.push": "Per App-Mitteilung",

      "notification.push.desc": "Erlaubnis, Sie per App-Mitteilung zu kontaktieren.",

      "notification.rental.dongle.finish.description": "Sobald die Stationsmitarbeiter Schlüssel und Fahrzeug entgegengenommen haben, wird Ihre Miete beendet und Ihnen eine Übersicht per E-Mail geschickt.",

      "notification.sms": "Per SMS",

      "notification.sms.desc": "Erlaubnis, Sie per SMS zu kontaktieren.",

      "now": "Jetzt",

      "obiEmployees.OBIMitarbeiter.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "obiPublicUsers.OBIMitarbeiter.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "obiPublicUsers.heyOBI.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | ~~19,99~~ 16,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | ~~59,90~~ 50,92 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | ~~139,90~~ 102,00 € (inkl. 150km) |\n| An Feiertagen | ~~59,90~~ 50,92 €  € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 € |\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone | 25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "obiPublicUsers.ubeeqo.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Mo-Sa, 8-20 Uhr | 19,99 €/Std. (inkl. 20km/Std)|\n| Mo-Sa, 20-8 Uhr | 59,90 € (inkl. 100km)|\n| Sa, 20 Uhr - Mo, 8 Uhr | 139,90 € (inkl. 150km) |\n| An Feiertagen | 59,90 € (inkl. 100km) |\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Mehrkilometer | 0,30 €|\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 €/Miete |\n| Rückgabe außerhalb der Zone  |  25€ + 0,49€/100m (max. 500 EUR) |\n| Grenzübertrittsgebühr | 7,50 € / Tag |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 10%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf) zu entnehmen.",

      "offline": "OFF",

      "offlineService.report.title": "Auftragsübersicht",

      "ok": "OK",

      "online": "ON",

      "open.directions.title": "Navigation starten",

      "open.email.gmail": "GMail öffnen",

      "open.email.outlook": "Outlook öffnen",

      "opennow": "Aktuell geöffnet",

      "openstoday": "Heute geöffnet",

      "openstomorrow": "Morgen geöffnet",

      "ops.damage.add.noImages.error": "Bitte stell sicher, dass du mindestens ein Bild hinzugefügt hast",

      "other": "Andere",

      "parking.description": "Gratis für 120 Min. Jede weitere kostet nur 5 Ct",

      "parking.hours": "Stunden",

      "parking.minutes": "Minuten",

      "parking.title": "Parkmodus",

      "partner.password.new.subtitle": "Bitte geben Sie Ihr aktuelles Passwort an, mit dem Sie sich in unserer (Web-)App einloggen.",

      "partner.password.new.title": "Passwort erforderlich",

      "passport.country.not.valid": "Für andere Länder ist keine Online-Dokumentenprüfung möglich. Haben Sie Fragen? Wenden Sie sich einfach an unseren Support.",

      "password.conditions.8.min.length": "mindestens 8 Zeichen",

      "password.conditions.lowercase.and.uppercase": "sowohl Klein- als auch Großbuchstaben",

      "password.conditions.number": "mindestens eine Zahl",

      "password.conditions.specialCharacter": "mindestens ein Sonderzeichen",

      "password.token.expired": "Dieser Zurücksetzen-Link ist abgelaufen. Bitte setzen Sie Ihr Passwort erneut zurück.",

      "payByLink.transaction.description": "Bitte wählen Sie Ihre Zahlungsmethode, um den offenen Betrag zu begleichen.",

      "payment.3ds.title": "Kreditkarte authentifizieren",

      "payment.add.description": "Zur Verifizierung Ihres Nutzerkontos. Es erfolgt keine Abbuchung. Die Anmeldung ist und bleibt gratis.",

      "payment.add.error": "Fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren unser Service Team.",

      "payment.bank.comdirekt": "Comdirekt",

      "payment.bank.commerzbank": "Commerzbank",

      "payment.bank.deutschebank": "Deutsche Bank",

      "payment.bank.dkb": "DKB",

      "payment.bank.header": "Oder Bank wählen",

      "payment.bank.ing": "ING Bank",

      "payment.bank.owner.consent": "Ich handele in eigenem Namen.",

      "payment.bank.postbank": "Postbank",

      "payment.bank.revolut": "Revolut",

      "payment.bank.santander": "Santander",

      "payment.bank.search": "Meine Bank suchen",

      "payment.bank.spardabank": "Spardabank",

      "payment.bank.sparkasse": "Sparkasse",

      "payment.bank.targobank": "Targobank",

      "payment.bank.volksbank": "Volksbank",

      "payment.billing.address.button": "Übernehmen",

      "payment.billing.address.company.contact": "Ansprechpartner",

      "payment.billing.address.company.name": "Firmenname",

      "payment.billing.address.description": "Lege fest, an wen die Rechnung adressiert werden soll.",

      "payment.billing.address.headline": "Adresse",

      "payment.billing.address.title": "Rechnungsdaten",

      "payment.billing.company.headline": "Firma",

      "payment.birthday.prefix": "geb. am",

      "payment.card.add.description": "Kredit-/Debitkarte hinzufügen und verifizieren",

      "payment.card.add.title": "Kredit-/Debitkarte hinzufügen",

      "payment.card.add.verifying": "Verifizierung läuft...",

      "payment.card.code.label": "Prüfziffern (CVC)",

      "payment.card.expiration.label": "Gültigkeit (mm/jj)",

      "payment.card.name.label": "Karteninhaber",

      "payment.card.number.label": "Kartennummer",

      "payment.firstname.placeholder": "Mein Vorname",

      "payment.footnote": "Mit der Auswahl des SEPA-Lastschriftverfahrens willige ich der Verarbeitung meiner Daten zur %s ein.",

      "payment.footnote.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "payment.footnote.url.text": "Prüfung der Zahlungswahrscheinlichkeit",

      "payment.googlePay.description": "Im nächsten Schritt können Sie Google Pay als Zahlungsmethode hinzufügen.",

      "payment.googlePay.title": "Google Pay hinzufügen",

      "payment.lastname.placeholder": "Mein Nachname",

      "payment.paypal.block.description": "Im nächsten Schritt werden Sie zu Paypal weitergeleitet, um Ihr Paypal-Konto als Zahlmethode zu hinterlegen.",

      "payment.paypal.block.title": "Paypal hinzufügen",

      "payment.paypal.block.yes": "Fortfahren",

      "payment.postingText": "Danke.",

      "payment.postingTextReference": "%s",

      "payment.profile.billing": "Alternative Rechnungsadresse",

      "payment.profile.billing.add": "Rechnungsadresse ändern",

      "payment.profile.billing.title": "RECHNUNGSDATEN",

      "payment.profile.company.add": "Firmeninformationen hinterlegen",

      "payment.profile.default": "Als Standard festlegen",

      "payment.profile.delete": "Zahlungsprofil entfernen",

      "payment.profile.option.business": "Business",

      "payment.profile.option.personal": "Privat",

      "payment.profile.reset": "Rechnungsdaten zurücksetzen",

      "payment.profile.title": "Zahlungsprofil",

      "payment.profile.type": "Art des Profils",

      "payment.secured.success": "Authentifizierung erfolgreich bestanden, danke!",

      "payment.sepa.description": "SEPA-Lastschrift",

      "payment.singleLineItem.accountDeposit": "Einlagenkonto: %@",

      "payment.singleLineItem.ibanVerification": "IBAN-Überprüfung: %@",

      "payment.singleLineItem.invoice": "Rechnung: %@",

      "payment.singleLineItem.tripDeposit": "Anzahlung: %@",

      "paypal.desc": "Fügen Sie eine unserer sicheren und beliebten Zahlungsmittel hinzu.",

      "paypal.placeholder": "Paypal-Konto",

      "paypal.title": "Paypal hinzufügen",

      "per.calday": "/Kal.Tag",

      "per.km": "je km",

      "permission.settings.button": "ERLAUBEN",

      "personal": "privat",

      "pfofile.wizard.continue": "Registrierung fortsetzen",

      "phone.pairing.message": "Klicken Sie hier, um dieses Handy zu verifizieren.",

      "phone.resend.code": "Erneut senden",

      "phone.search": "Suchen",

      "phone.verification.resend.success": "Bestätigungscode ist erneut versendet worden.",

      "phone.verify.code.apply": "CODE ÜBERNEHMEN",

      "phone.verify.code.desc": "Wir haben Ihnen soeben einen 4-stelligen Code per SMS an %s geschickt. Bitte tragen Sie ihn jetzt ein.",

      "phone.verify.code.title": "SMS-Code eingeben",

      "phone.verify.desc": "Tragen Sie Ihre Handy-Nr ein. Sie erhalten im Anschluss einen Bestätigungscode per SMS.",

      "phone.verify.mobile.phone.text": "Handy-Nummer",

      "phone.verify.send.button": "Bestätigen",

      "phone.verify.send.code": "SMS-Code anfordern",

      "phone.verify.sms": "{{code}} lautet Ihr GETAWAY Bestätigungscode.",

      "phone.verify.title": "Handy-Nr hinzufügen",

      "phone.wrong.format.error": "Bitte geben Sie die richtige Telefonnummer ein",

      "phoneNumberVerification.authy.custom_message": "{{code}} lautet Ihr GETAWAY Bestätigungscode.",

      "phonenumber.verification.error": "Diese Handynummer ist ungültig oder bereits einem aktivem Nutzerkonto hinterlegt. Bitte verwende eine andere oder melde dich mit dem bestehenden Nutzerkonto an.",

      "photo": "Foto",

      "photo.continue": "FORTFAHREN",

      "photo.library": "Fotos",

      "photo.source.dialog.title": "Fotos hochladen via",

      "photos": "Fotos",

      "photos.add": "Fotos vom Auto",

      "photos.add.button": "Foto hinzufügen",

      "photos.add.description": "Von Vorne, von der Seite und vom Innenraum. Je ansprechender, desto mehr Mieteinnahmen 🤩",

      "photos.desc": "Ein Foto sagt mehr als Tausend Wort. Fügen Sie jetzt mindestens eins hinzu.",

      "photos.permission": "Bitte erlauben Sie GETAWAY Zugriff auf Ihre Fotos in Ihren Einstellungen.",

      "photos.permission.details": "Um fortzufahren und Fotos hochzuladen, erlauben Sie GETAWAY jetzt Zugang zu Ihren Fotos.",

      "photos.permission.no": "Nicht jetzt",

      "photos.permission.title": "Zugang zu Fotos",

      "photos.permission.yes": "Erlauben",

      "photos.photo": "Foto",

      "photos.photo.reached.max": "Sie haben die Maximalanzahl an Fotos erreicht.",

      "photos.skip.no.photos": "Sie können Fotos jederzeit ergänzen.",

      "photos.skip.photos": "Sie haben mindestens ein Foto hochgeladen.",

      "picker.placeholder": "Wählen Sie aus ...",

      "pin.button": "Übernehmen",

      "pin.footnote.md": "Vergib hier deine persönliche Karten-PIN. Die PIN benötigst du, um das gebuchte Fahrzeug zu entriegeln.\n\n\n⚠️ <b>Achtung</b>: PIN ist ausschließlich für persönlichen Zugang zum Fahrzeug zu gebrauchen. Offenlegung oder Weitergabe an Dritte kann u.a. Vertragsstrafe zur Folge haben.",

      "pin.header": "Zugang zum Fahrzeug",

      "portal.area.count": "%s Fzg.",

      "portal.area.filter": "Standorte filtern",

      "portal.area.title": "Abholung & Rückgabe",

      "portal.car.cta": "Weiter",

      "portal.car.details": "Fahrzeugdetails anzeigen",

      "portal.car.insurance.fallback": "Schutz",

      "portal.card.lessAbout": "Weniger anzeigen",

      "portal.card.moreAbout": "Mehr zum Fahrzeug",

      "portal.card.orSimilar": "oder ähnlich",

      "portal.card.pricePrefix": "Gesamt ab",

      "portal.card.seats": "Sitze",

      "portal.card.select": "Wählen",

      "portal.card.selected": "Ausgewählt",

      "portal.checkout.billing": "Abweichende Rechnungsadresse",

      "portal.checkout.consent": "Mit Klick auf „Jetzt buchen\" akzeptieren Sie die",

      "portal.checkout.consent.link": "AGB",

      "portal.checkout.cta": "Jetzt buchen",

      "portal.checkout.cta.hint": "Wird aktiv, sobald Ihre Fahrerdaten vollständig sind.",

      "portal.checkout.cta.hint.payment": "Wird aktiv, sobald eine Zahlungsart hinterlegt ist.",

      "portal.checkout.cta.payment": "Zahlungsmittel wählen",

      "portal.checkout.cta.reserve": "Kostenpflichtig reservieren",

      "portal.checkout.cta.signin": "Anmelden und fortfahren",

      "portal.checkout.deposit.note": "Bei der Reservierung werden %s als Kaution auf Ihrer Karte geblockt – nicht abgebucht. Der Betrag wird nach der Rückgabe automatisch freigegeben.",

      "portal.checkout.deposit.sub": "wird nach Rückgabe freigegeben",

      "portal.checkout.deposit.title": "Jetzt geblockt (Kaution)",

      "portal.checkout.details": "Details ›",

      "portal.checkout.driver.title": "Wer fährt?",

      "portal.checkout.payment.title": "Wie möchten Sie bezahlen?",

      "portal.checkout.signin.hint": "Melden Sie sich an, um Ihre Buchung abzuschließen.",

      "portal.checkout.signin.link": "Bereits Kunde? Anmelden",

      "portal.checkout.signout": "Nicht Sie? Abmelden",

      "portal.checkout.signup.link": "Noch kein Konto? Jetzt auf unserer Website registrieren",

      "portal.checkout.title": "Wer fährt und zahlt?",

      "portal.checkout.total.sub": "Miete inkl. gewählter Optionen",

      "portal.checkout.total.title": "Gesamtpreis",

      "portal.date.apply": "Übernehmen",

      "portal.date.title": "Zeitraum wählen",

      "portal.desktop.change": "Ändern",

      "portal.desktop.cta.bookHint": "Die Kaution wird nur geblockt, nicht abgebucht",

      "portal.desktop.cta.nextHint": "Noch keine Zahlung fällig",

      "portal.desktop.cta.pickHint": "Wähle links ein Fahrzeug",

      "portal.desktop.day": "%s Tag",

      "portal.desktop.days": "%s Tage",

      "portal.desktop.empty.text": "Wählen Sie links ein Fahrzeug – Preis und Optionen erscheinen dann hier.",

      "portal.desktop.empty.title": "Noch kein Fahrzeug gewählt",

      "portal.desktop.location": "Abholung & Rückgabe",

      "portal.desktop.lock.options": "Erst Optionen wählen",

      "portal.desktop.lock.vehicle": "Wählen Sie zunächst ein Fahrzeug aus",

      "portal.desktop.options.title": "Buchungsoptionen und Versicherung",

      "portal.desktop.period": "Zeitraum",

      "portal.desktop.summary.title": "Ihre Buchung",

      "portal.desktop.total": "Gesamtpreis",

      "portal.desktop.trust.cancel": "Kostenlose Stornierung (je nach Option)",

      "portal.desktop.trust.fees": "Keine versteckten Gebühren",

      "portal.desktop.trust.support": "Support per Chat und Telefon",

      "portal.desktop.vehicle": "Fahrzeug",

      "portal.done.booking.cta": "Buchung öffnen",

      "portal.done.booking.md": "Ihre Buchung ist bestätigt.\nFalls sich kein neues Browserfenster geöffnet hat, klicken Sie auf „Buchung öffnen\".\nAlternativ können Sie den Link manuell in die Adresszeile Ihres Browsers kopieren.",

      "portal.done.presignup.cta": "Buchung fortsetzen",

      "portal.done.presignup.md": "Ihre Auswahl ist gespeichert.\n\nFalls sich kein neues Browserfenster geöffnet hat, klicken Sie auf den Button “Buchung fortsetzen”.\n\nAlternativ können Sie den Link manuell in die Adresszeile Ihres Browsers kopieren.",

      "portal.footer.priceDetails": "Preisdetails",

      "portal.footer.total": "gesamt",

      "portal.insurance.heading": "Reduzieren Sie Ihr Risiko",

      "portal.insurance.sub": "Schäden werden schnell teuer. Begrenzen Sie Ihre Haftung mit einer reduzierten Selbstbeteiligung.",

      "portal.insurance.title": "Versicherungsschutz",

      "portal.results.nearby": "Weitere Standorte in der Nähe",

      "portal.results.seeAvailability": "Verfügbarkeit ansehen ›",

      "portal.results.title": "Fahrzeug wählen",

      "portal.results.unavailable": "Derzeit nicht verfügbar",

      "portal.results.vehicles": "Fahrzeuge",

      "portal.resume.carGone": "Dieses Fahrzeug ist für Ihren Wunschzeitraum nicht mehr verfügbar – bitte wählen Sie ein anderes aus.",

      "portal.resume.datesMoved": "Ihre Termine lagen in der Vergangenheit – wir haben sie auf den nächstmöglichen Termin verschoben.",

      "portal.resume.insuranceReset": "Die von Ihnen gewählte Versicherungsoption wird nicht mehr angeboten – wir haben die Standardeinstellung wiederhergestellt.",

      "portal.search.area.error": "Bitte wählen Sie einen Standort",

      "portal.search.area.label": "Abholung & Rückgabe",

      "portal.search.area.placeholder": "Bitte wählen",

      "portal.search.cta": "Fahrzeuge anzeigen",

      "portal.search.from": "Von",

      "portal.search.title": "Fahrzeug mieten",

      "portal.search.until": "Bis",

      "portal.sort.priceAsc": "Preis aufsteigend",

      "portal.sort.priceDesc": "Preis absteigend",

      "portal.sort.title": "Sortieren nach",

      "price": "Preis",

      "price.day.short": "Tag",

      "price.details.footnote": "*Fahranfänger ist, wer seine Fahrerlaubnis vor weniger als 24 Monaten erhalten hat. Die vollständige Aufstellung aller Entgelte sind der %s zu entnehmen.",

      "price.details.footnote.url.text": "aktuellen Preisliste",

      "price.distance.100.prefix": "bis 100 km:",

      "price.distance.101.prefix": "ab 101. km:",

      "price.distance.headline": "Fahrtstrecke",

      "price.duration.headline": "Mietdauer",

      "price.duration.headline.mo-fr": "Mietdauer (Mo-Fri)",

      "price.duration.headline.mo-sa": "Mietdauer",

      "price.duration.headline.sa-mo": "Sa, 18:00 - Mo, 08:00",

      "price.duration.headline.sa-so": "Mietdauer (Sa-So)",

      "price.duration.holiday": "Feiertags: %s/Kal.Tag (inkl. 100km)",

      "price.duration.holiday.headline": "Feiertag",

      "price.duration.mo-fr.night.prefix": "21 - 9:30 Uhr:  ",

      "price.duration.mo-fr.prefix": "9:30 - 21 Uhr: %s",

      "price.duration.mo-sa.daily": "Mo-Sa, 8-18 Uhr: %s/Kal.Tag (inkl. 100 km)        ",

      "price.duration.mo-sa.hourly": "Mo-Sa 8 - 20:  %s/Std (inkl. 20 km/Std), max. %s/Kal.Tag (inkl. 100 km)",

      "price.duration.mo-sa.night": "Mo-Sa, außerhalb der Öffnungszeiten: %s (inkl. 100km)",

      "price.duration.sa-mo": "Sa, 18 Uhr - Mo, 8 Uhr: %s (inkl. 150 km)",

      "price.duration.sa-so.night.prefix": "Sa, 18 - Mo, 9:30 Uhr:  ",

      "price.duration.sa-so.prefix": "Sa, 9:30 - 18 Uhr:  %s  (1. Std. gratis)",

      "price.extraKm.short": "Extra Km",

      "price.hour.short": "hr",

      "price.insurance.150.prefix": "max. 150€:",

      "price.insurance.1500.prefix": "max. 1.500€: Inkl.",

      "price.insurance.15000.prefix": "max. 15.000€:  inkl.",

      "price.insurance.151.prefix": "max. 150€:",

      "price.insurance.500.prefix": "max. 500€:",

      "price.insurance.501.prefix": "max. 500€:",

      "price.insurance.650.prefix": "max. 650€:  inkl.",

      "price.insurance.750.prefix": "max. 750€:  inkl.",

      "price.insurance.headline": "Selbstbeteiligung (je Schadensfall)",

      "price.insurance.young.headline": "Selbstbeteiligung (Fahranfänger*)",

      "price.km.short": "km",

      "price.return.service.headline": "Rückhol-Service (bei Rückgabe)",

      "price.tank.10.prefix": "Tankstand <10%:",

      "price.tank.25.prefix": "Tankstand <25%: ",

      "price.tank.headline": "Tank-Service (bei Rückgabe)",

      "price.weekend.surcharge.prefix": "Wochenendzuschlag (Fr-So):",

      "pricedetails.basic.title": "Zahlen Sie nur, was Sie verfahren",

      "pricedetails.distancePackages.remaining": "Ab %@. Kilometer",

      "pricedetails.example.day": "Ein Tag (24 Std.)",

      "pricedetails.example.description": "inkl. %s km* und Kraftstoff",

      "pricedetails.example.hour": "Eine Stunde",

      "pricedetails.example.kilometer": "Ein Kilometer",

      "pricedetails.example.kilometer.description": "Inkl. Kraftstoff",

      "pricedetails.example.month": "Ein Monat (28 Tage)",

      "pricedetails.example.title": "Preisbeispiele (inkl. Kraftstoff & Versicherung)",

      "pricedetails.example.value.description": "entspricht %s je Min.",

      "pricedetails.example.value.description.day": "Ø %s €/Kal.Tag",

      "pricedetails.example.value.description.owner": "Sie verdienen %s",

      "pricedetails.example.week": "Eine Woche",

      "pricedetails.longterm.description.oneday": "inkl. 80 km je 24 Std.*",

      "pricedetails.longterm.footnote": "*Jeder weitere Kilometer bzw. weitere Standzeit wird nutzungsgenau abgerechnet.\n\nIhnen wird automatisch das günstigste Angebot berechnet. Eine Übersicht aller Entgelte finden Sie %@.",

      "pricedetails.longterm.footnote.url": "https://get-a-way.com/agb/entgelte-und-gebuehren/",

      "pricedetails.longterm.footnote.url.text": "hier",

      "pricedetails.longterm.tier1.description": "inkl. 80 km* und Kraftstoff",

      "pricedetails.longterm.tier1.title": "Ab dem 1. Tag",

      "pricedetails.longterm.tier1.value.description": "je 24 Std.",

      "pricedetails.longterm.tier2.description": "inkl. 40 km* und Kraftstoff",

      "pricedetails.longterm.tier2.title": "Ab dem 4. Tag",

      "pricedetails.longterm.tier2.value.description": "je 24 Std.",

      "pricedetails.longterm.tier3.description": "inkl. 20 km* und Kraftstoff",

      "pricedetails.longterm.tier3.title": "Ab dem 8. Tag",

      "pricedetails.longterm.tier3.value.description": "je 24 Std.",

      "pricedetails.longterm.title": "Ab %s.",

      "pricedetails.longterm.value.description": "je %s",

      "pricedetails.parking.freeminutes": "%s Min. gratis je km",

      "pricedetails.parking.title": "Standzeit",

      "pricedetails.parking.value": "danach %s je Min.",

      "pricedetails.pricePerKm.title": "Gefahrene Strecke",

      "pricedetails.pricePerKm.value": "%s je km",

      "pricedetails.specialoffers.title": "TAGESRABATTE",

      "pricedetails.title": "Preisinfo",

      "pricing.CharterlinePricing.url": "https://api.get-a-way.com/pricing/5d170e35f892b13d8468f283/pdf",

      "pricing.HagebauMarktPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/58944_Preisliste+Ubeeqo_Hagebaumarkt_A4_v02.pdf",

      "pricing.HeyOBIPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.IkeaInnsbruck.duration.after_first_n_hours": "9:30 - 21:00 Uhr (ab 5. Std): %s/Std",

      "pricing.IkeaInnsbruck.duration.first_n_hours": "9:30 - 21:00 Uhr (1. bis 4. Std): %s/Std",

      "pricing.IkeaInnsbruck.duration.hourly": "9:30 Uhr - 21:00 Uhr: %s/Std",

      "pricing.IkeaInnsbruck.duration.night": "21:00 Uhr - 9:30 Uhr: %s",

      "pricing.IkeaInnsbruck.duration.weekday": "Mietdauer (Mo-Fri)",

      "pricing.IkeaInnsbruck.duration.weekend": "Mietdauer (Sa-So)",

      "pricing.IkeaInnsbruck.duration.weekend.sat": "Sa, 9:30 Uhr - 18:00 Uhr : %s",

      "pricing.IkeaInnsbruck.duration.weekend.sat.after_first_n_hours": "Sa, 9:30 - 18:00 Uhr (ab 5. Std): %s/Std",

      "pricing.IkeaInnsbruck.duration.weekend.sat.first_n_hours": "Sa, 9:30 - 18:00 Uhr (1. bis 4. Std): %s/Std ",

      "pricing.IkeaInnsbruck.duration.weekend.so": "Sa, 18 - Mo, 9:30 Uhr: %s",

      "pricing.IkeaInnsbruckPricing.url": "https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7cf/pdf",

      "pricing.IkeaMainPricing.url": "https://api.get-a-way.com/pricing/5d8f8cbba3dd8910deb5d7ce/pdf",

      "pricing.MISSmartPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.MISSmartSpainPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.MISTransporterPricing.url": "https://api.get-a-way.com/pricing/61cb2b425071913188afebcf/pdf",

      "pricing.OBIEmployeesPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_OBI_Employees.pdf",

      "pricing.OBIPublicUsersPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.OBIUsersPricing.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.bubPassenger.distance.101": "ab dem 101. km: %s/km",

      "pricing.bubPassenger.duration.fromDay4": "ab dem 4. Tag: %s €/Tag",

      "pricing.bubPassenger.duration.hourly": "%s/Std (max. %s/Kal.Tag)",

      "pricing.bubPassenger.duration.weekend": "Fr-So: +%s €/Std (max. %s €/Kal.Tag)",

      "pricing.bubTransporter.duration.hourly": "%s/Std (max. %s/Kal.Tag)",

      "pricing.bubTransporter.duration.weekend": "Fr-So: +%s €/Std (max. %s €/Kal.Tag)",

      "pricing.charterline.distance.100": "bis 100km: %s/km",

      "pricing.charterline.distance.101": "ab dem 101. km: %s/km",

      "pricing.charterline.duration.hourly": "%s/Std (max. %s/Kal.Tag)",

      "pricing.charterline.duration.weekend": "Fr-So: +2,00 €/Std (max. 12,00 €/Kal.Tag)",

      "pricing.degressive.distance": "${format:euro(price.driversPricePerKm)}/km (ab dem ${price.firstDiscountedKm}. km nur ${format:euro(price.firstDiscountedPrice)})",

      "pricing.degressive.parking": "${price.freeParkingMinutesPerKm} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.distance": "Fahrtstrecke (inkl. Kraftstoff)",

      "pricing.distance.details": "%s/km",

      "pricing.distance.excess": "Fahrtstrecke (je Mehrkilometer)",

      "pricing.distance.noFuel": "Fahrtstrecke",

      "pricing.duration": "Mietdauer",

      "pricing.duration.hourly": "%s/Std",

      "pricing.expert.distance": "%s/km",

      "pricing.expert.duration": "%s/Std",

      "pricing.expert.duration.hourly": "Mo-Fr 9-19 Uhr, Sa 9-16 Uhr: %s/Std, max. %s/Kal.Tag",

      "pricing.expert.duration.night": "Mo-Sa, 19 Uhr - 9 Uhr: %s",

      "pricing.expert.duration.weekend": "Sa 16:00 Uhr - Mo 09:00 Uhr: %s",

      "pricing.fee.crossBorder": "Auslandsfahrten",

      "pricing.fee.crossBorder.details": "%s pro Tag für erlaubte Länder, max. %s pro Miete",

      "pricing.fee.driver.injury.protection": "Insassenschutz: %s",

      "pricing.fee.driver.protection": "Zusatzleistungen",

      "pricing.fee.noShow": "Stornierungsgebühr",

      "pricing.fee.noShow.details": "Bis zu %s (abhängig von der geplanten Mietdauer)",

      "pricing.fee.return": "Rückbring-Service (bei Rückgabe)",

      "pricing.fee.return.details": "%s + %s/100m",

      "pricing.fee.tank": "Tank-Service (bei Rückgabe)",

      "pricing.fee.tank.fuel.consumption": "geringerer Tankstand: %s je Liter",

      "pricing.fee.tank.low.10": "Tankstand <10%:",

      "pricing.fee.tank.low.25": "Tankstand <25%:",

      "pricing.heyOBI.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.ikea.duration.after_first_n_hours": "ab 5. Stunde: %s/Std",

      "pricing.ikea.duration.first_n_hours": "1. bis 4. Stunde: %s/Std",

      "pricing.insurance": "Selbstbeteiligung (je Schadensfall)",

      "pricing.insurance.table": "max. %s€: %s€/Kal.Tag",

      "pricing.insurance.table.daily": "max. %s€: %s€/KalTag",

      "pricing.insurance.table.free": "max. %s€: inklusive",

      "pricing.insurance.young": "Selbstbehalt (Young Driver)",

      "pricing.longterm.distance": "${format:euro(price.driversPricePerKm)}/km",

      "pricing.longterm.parking": "${price.freeParkingMinutesPerKm} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.longtermanddistance.distance": "${format:euro(price.driversPricePerKm)}/km (ab dem ${price.firstDiscountedKm + 1}. km nur ${format:euro(price.firstDiscountedPrice)})",

      "pricing.longtermanddistance.parking": "${price.freeParkingMinutesPerKm} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.mba.duration": "Mietdauer (Stündlich)",

      "pricing.mba.duration.package": "Mietdauer (Pakete)",

      "pricing.mba.duration.transporter.1day": "1 Tag: %s",

      "pricing.mba.duration.transporter.3days": "3 Tage: %s",

      "pricing.mba.duration.transporter.3days.per_day": "3 Tage: %s/Tag	",

      "pricing.mba.duration.transporter.6hours": "6 Stunden: %s",

      "pricing.mba.duration.transporter.extra_hours": "%s/zusätzliche Stunde",

      "pricing.mba.duration.transporter.hourly": "%s/Stunde",

      "pricing.mba.duration.transporter.hourly_weekend": "+%s/Std (max. %s/Tag)",

      "pricing.mba.duration.weekend": "Wochenendzuschlag (Fr-So):	",

      "pricing.mba.passenger.duration.after.30": "Mietdauer (30 Tage und mehr)",

      "pricing.mba.passenger.duration.before.30": "Mietdauer (Bis 30 Tage)",

      "pricing.mba.passenger.duration.daily": "Tag 1 bis 3: %s/Tag",

      "pricing.mba.passenger.duration.daily.plus3": "Ab Tag 4: %s/Tag",

      "pricing.mba.passenger.duration.daily.plus30": "ab Tag 1: %s/Tag",

      "pricing.mba.passenger.included_distance": "Inklusiv-km: %s km/Tag (%s/Extra-km)",

      "pricing.mba.transporter.distance": "%s/km",

      "pricing.mba.transporter.extra_distance": "Extra-km: %s/km",

      "pricing.mba.transporter.included_distance": "Inklusiv-km: %s km/Std (max. %s km/Tag)",

      "pricing.mis.distance": "inklusive 50 km/24Std. (%s/Mehr-Km)",

      "pricing.mis.duration.after.30": "Mietdauer (mehr 30 Tage)",

      "pricing.mis.duration.before.30": "Mietdauer (von Tag 1 - 30)",

      "pricing.mis.duration.daily": "Tag 1 bis 3:  %s/24Std.",

      "pricing.mis.duration.daily.plus3": "Ab dem 4. Tag: %s/24Std.",

      "pricing.mis.duration.daily.plus30": "ab Tag 1: %s/24Std.",

      "pricing.mis.duration.transporter.hourly": "ab der 4. Stunde:  %s/Std. (max. %s/24Std.)",

      "pricing.mis.duration.transporter.hourly.lt3h": "bis zu 3 Stunden: %s",

      "pricing.mis.spain.duration.daily": "erste 24Std %s",

      "pricing.mis.transporter.distance": "inklusive 50 km/24Std. (%s/Mehr-Km)",

      "pricing.obi.distance": "%s/ Mehr-Km",

      "pricing.obi.duration.holiday": "An Feiertagen: %s (inkl. 100km)",

      "pricing.obi.duration.hourly": "Mo-Sa, 8-20 Uhr: %s/Std (inkl. 20 km/Std), max. %s/Kal.Tag (inkl. 100 km)",

      "pricing.obi.duration.night": "Mo-Sa, 20 Uhr - 8 Uhr: %s (inkl. 100km)",

      "pricing.obi.duration.weekend": "Sa 20:00 Uhr - Mo 08:00 Uhr: %s (inkl. 150km)",

      "pricing.obiEmployees.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_OBI_Employees.pdf",

      "pricing.obiPublicUsers.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.obiUsers.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_charterline/CHA_UBQ_OBI_v211118_4_Preisliste_endCustomer.pdf",

      "pricing.serviceTrip.distance": ".",

      "pricing.serviceTrip.parking": ".",

      "pricing.spp.duration.firstNHours": "Bis 4 Stunden: %s/Std.",

      "pricing.spp.duration.hourly": "Ab 5. Stunde: %s/Std.",

      "pricing.spp.duration.night": "21 Uhr - 9:30 Uhr: %s/Nacht",

      "pricing.spp.duration.weekend": "Sa, 18 Uhr - Mo, 9:30 Uhr: %s",

      "pricing.static.distance": "${price.driversPricePerKm}/km",

      "pricing.static.parking": "${price.freeParkingMinutes} Freiminuten/km, danach ${format:cents(price.pricePerParkingMinute)} Ct/Min.",

      "pricing.title": "Preisangaben",

      "privacy.text": "IHRE DATEN SIND PRIVAT & GESCHÜTZT",

      "privacy.url": "https://get-a-way.com/datenschutz?utm_source=app",

      "profile-account-warning-title": "Nutzerkonto deaktiviert",

      "profile-deposit.warning.btn": "Kaution hinterlegen",

      "profile-deposit.warning.desc": "Um diese Zahlungsmethode freizuschalten, hinterlegen Sie bitte jetzt eine einmalige Kaution.",

      "profile.blocked.button.login": "Jetzt anmelden",

      "profile.blocked.msg.cC": "Die Freischaltung Ihrer Zahlungsmethode ist fehlgeschlagen. Leider können wir Ihnen derzeit keine Alternative anbieten, um die Registrierung abzuschließen.",

      "profile.blocked.msg.creditCheck": "Die Freischaltung Ihrer Zahlungsmethode ist fehlgeschlagen. Die Bonitätsprüfung ergab keine Übereinstimmung. Leider können wir Ihnen derzeit keine Alternative anbieten, um die Registrierung abzuschließen.\n\nWir bitten, von weiteren Registrierungsversuchen abzusehen.",

      "profile.blocked.msg.d": "Jeder Nutzer darf nur ein Nutzerkonto haben.\n \nBitte melden Sie sich mit Ihrem initialen Nutzerkonto an. Falls Sie Ihr Passwort vergessen haben, können Sie es in der Anmeldemaske zurücksetzen.",

      "profile.blocked.msg.duplicate": "Jeder Nutzer darf nur ein Nutzerkonto haben.\nBitte löschen Sie die doppelten Nutzerkonten und kontaktieren uns im Anschluss.",

      "profile.blocked.msg.f": "Dieses Nutzerkonto ist temporär deaktiviert. Bei Rückfragen kontaktieren Sie bitte unser Service Team.",

      "profile.blocked.msg.fraud": "Jeder Nutzer darf nur ein Nutzerkonto haben. Nach interner Prüfung können wir Ihnen den Abschluss Ihrer Registrierung leider nicht ermöglichen.\n\nWir bitten, von weiteren Registrierungsversuchen abzusehen.\nFalls die Deaktiverung fälschlicherweise vorgenommen wurde, kontaktieren Sie bitte unser Service Team.",

      "profile.blocked.msg.manualApproval": "Ihr Nutzerkonto wird gerade von unserem Team geprüft. Wir melden uns, sobald es freigegeben ist.",

      "profile.blocked.msg.manualApprovalFailed": "Wir konnten Ihr Nutzerkonto nicht freischalten. Bitte wenden Sie sich an unseren Kundendienst.",

      "profile.blocked.msg.originalactive": "Jeder Nutzer darf nur ein Nutzerkonto haben.\n\nBitte melden Sie sich mit Ihrem initialen Nutzerkonto an. Falls Sie Ihr Passwort vergessen haben, können Sie es in der Anmeldemaske zurücksetzen.",

      "profile.blocked.msg.pDe": "Die Freischaltung dieser Zahlungsmethode ist fehlgeschlagen. Leider können wir Ihnen derzeit keine Alternative anbieten, um die Registrierung abzuschließen.\n\nWir bitten, von weiteren Versuchen der Registrierung abzusehen.",

      "profile.blocked.msg.pDr": "Leider können wir Ihnen derzeit keine Alternative zum Abschluss der Registrierung anbieten.\n\nWir bitten Sie, von weiteren Versuchen der Registrierung abzusehen.",

      "profile.blocked.msg.spam": "Dieses Nutzerkonto ist temporär deaktiviert. Bitte kontaktieren Sie für Rückfragen unser Service Team",

      "profile.blocked.title.d": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.duplicate": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.f": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.fraud": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.manualApproval": "Nutzerkonto wird geprüft",

      "profile.blocked.title.manualApprovalFailed": "Verifizierung abgelehnt",

      "profile.blocked.title.o": "Benutzerkonto deaktiviert",

      "profile.blocked.title.originalactive": "Nutzerkonto temporär deaktiviert. ",

      "profile.blocked.title.spam": "Nutzerkonto deaktiviert",

      "profile.blocked.title.undefined": "Nutzerkonto deaktiviert",

      "profile.completed.msg": "Schauen Sie unter \"Log-in Daten\", wo Sie sich mit welchen Daten anmelden können.",

      "profile.completed.org.msg": "Schauen Sie unter \"Log-in Daten\", wo Sie sich mit welchen Daten anmelden können.",

      "profile.completed.org.title": "Registrierung abgeschlossen",

      "profile.completed.title": "Registrierung abgeschlossen",

      "profile.deposit.missing": "Um fortzufahren, hinterlegen Sie bitte zunächst eine Kaution.",

      "profile.gdpr.dialog.more": "Mehr zum Datenschutz",

      "profile.gdpr.dialog.msg": "Sie können hier Ihre personenbezogenen Daten herunterladen.\n\nZum Schutz Ihrer Privatsphäre werden Sie zunächst gebeten, Ihre Anfrage zu bestätigen, indem Sie einen Bestätigungscode eingeben, der Ihnen per E-Mail geschickt wird. Im Anschluss wird der Download gestartet.\n\nBitte beachten Sie, dass es sich um die personenbezogenen Daten im Zusammenhang mit der Nutzung von %s handelt. Etwaige Datenverarbeitungen im Zusammenhang mit anderen Services, sind auf der Datenschutzseite von %s in Erfahrung zu bringen.",

      "profile.gdpr.dialog.request": "Jetzt anfordern",

      "profile.gdpr.dialog.title": "DSGVO-Rechte nach Auskunft und Übertragbarkeit wahrnehmen",

      "profile.gdpr.resend": "Der eingegebene Code ist nicht korrekt.",

      "profile.gdpr.saved": "Datei wurde in Downloads gespeichert.",

      "profile.no.available.tariffs.desc": "Wir können dir keinen passenden Tarif anbieten. Für weitere Fragen wende dich bitte an unseren Support.",

      "profile.no.available.tariffs.title": "Kein Tarif verfügbar",

      "profile.payment.missing": "Um fortzufahren, hinterlegen Sie bitte zuerst ein Zahlungsmittel.",

      "profile.payment.type.business": "Business",

      "profile.payment.type.personal": "Privat",

      "profile.schufa.missing": "Um fortzufahren, bitte hinterlegen Sie zuerst Ihre Meldeadresse.",

      "profile.tab.account": "Meine Daten",

      "profile.tab.services": "Log-in-Daten",

      "profile.tx.open.pay": "Betrag begleichen",

      "profile.tx.open.title": "Ausstehende Beträge",

      "profile.under.age.desc": "Für Ihr aktuelles Alter steht derzeit kein passender Tarif zur Auswahl. Bitte versuchen Sie es erneut, sobald Sie 22 Jahre alt werden.",

      "profile.under.age.title": "Young Driver",

      "profile.verify.email.sent": "Bestätigungsmail wurde versendet",

      "profile.wizard.continue": "Registrierung fortsetzen",

      "push.permission": "Bitte aktivieren Sie jetzt App-Mitteilungen",

      "push.permission.details": "Erlauben Sie GETAWAY Ihnen App-Mitteilungen zu senden, um Sie über den aktuellen Status Ihres Autos bzw. Ihrer Miete informieren zu können.",

      "push.permission.no": "Später",

      "push.permission.title": "Erlauben Sie Mitteilungen",

      "push.permission.yes": "Erlauben",

      "qrCamera.title": "QR-Code scannen",

      "recaptcha.branding": "Diese Website ist durch reCAPTCHA geschützt.",

      "referFriend.code.error": "Bitte tragen Sie einen gültigen Einladungscode ein",

      "refuel": "Betankung",

      "refuel.payment.subTitle": "Bezahlung",

      "refuel.payment.title": "Kreditkarten PIN",

      "refuel.subTitle": "Bitte nehmen Sie die GETAWAY-Tankkarte aus dem Handschuhfach und nutzen Sie die angezeigte PIN. Die Quittung brauchen Sie nicht aufzuheben.",

      "refuel.title": "Tanken Sie gratis",

      "remove.cancel.dialog.message": "Bist du sicher, dass du das Fahrzeug deinstallieren willst?",

      "remove.cancel.dialog.title": "Fahrzeug-Deinstallation!",

      "remove.cancel.dialog.yes": "Deinstallieren",

      "remove.view.btn.txt": "Bestätigen",

      "remove.view.description": "Bitte prüfen Sie die Fahrzeugdaten, bevor Sie die Deinstallation bestätigen.",

      "remove.view.title": "Fahrzeugprüfung",

      "rent.car.driver.gear.restricted": "Sie können dieses Auto nicht mieten, da Ihre Fahrerlaubnis nur für Automatikgetriebe gilt.",

      "rent.car.driver.license.baned": "Sie haben ein Fahrverbot",

      "rent.car.driver.license.open": "Deine Fahrerlaubnis ist nicht geprüft",

      "rental": "Miete",

      "rental.action.damages": "Schaden melden",

      "rental.action.finish": "Miete beenden",

      "rental.action.fuel": "Tanken",

      "rental.add.damage.wizard.description": "Protokollieren Sie alle aktuellen Mängel, um eventuelle Neuschäden besser identifizieren zu können.",

      "rental.allaround.add": "Rundum-Fotos aufnehmen",

      "rental.allarouund.add": "Rundum-Fotos aufnehmen",

      "rental.backby.button": "Übernehmen",

      "rental.backby.update": "Ändern",

      "rental.backby.update.desc": "Aktuell: %s ",

      "rental.backby.update.other": "anzeigen",

      "rental.backby.update.title": "Rückgabezeit ändern",

      "rental.backby.update.until": "Verfügbar bis",

      "rental.cancel": "Abbrechen",

      "rental.cancel.handover.ok": "Mietvorgang beenden",

      "rental.cancel.handover.title": "Sie sind dabei, den aktuellen Vorgang abzubrechen.",

      "rental.carCheck.button": "Fortfahren",

      "rental.carCheck.cancel": "Beenden",

      "rental.carCheck.footnote": "Dies schützt Sie im Schadensfalle vor zu hohen Kosten und ist nötig, um den Motor starten zu können.",

      "rental.carCheck.header.desc": "Nehmen Sie jetzt je ein Foto aus vier verschiedenen Perspektiven auf, um den Motor starten zu können.",

      "rental.carCheck.header.title": "Rundum-Check",

      "rental.checkBelongings.finish.message": "Bitte achten Sie auf Ihre persönlichen Sachen, bevor Sie fortfahren.",

      "rental.checkBelongings.finish.messege": "Bitte achten Sie auf Ihre persönlichen Sachen, bevor Sie fortfahren.",

      "rental.checkBelongings.finish.title": "Nichts vergessen?",

      "rental.damage.added": "Der Schaden/Mangel ist um %@ erfolgreich protokolliert worden.",

      "rental.damages.support.ubq.footNote": "Melden Sie einen neuen Schaden, informieren Sie bitte im Anschluss den Vermieter %@",

      "rental.damages.ubq.helpdesk.text": "telefonisch",

      "rental.dialog.service.error": "Bitte wählen Sie den durchgeführten Service und mindestens ein Foto aus.",

      "rental.dongle.end.title": "Miete beenden",

      "rental.dongle.handover.description": "Bitte gehe nun die Checkliste durch, um den Mietvorgang zu beenden",

      "rental.dongle.key.return.description": "Bitte übergeben Sie Fahrzeugschlüssel und -papiere (inkl. der Tankkarte) am Ende Ihrer Miete einem Stationsmitarbeiter am Express-Schalter. Alternativ werfen Sie diese in den entsprechend ausgeschilderten Nachteinwurf der Station.",

      "rental.dongle.key.return.title": "Schlüssel & Papiere zurückgeben",

      "rental.driving.backBy": "Rückgabezeit",

      "rental.driving.damages.add": "Melden",

      "rental.driving.greeting": "Gute Fahrt!",

      "rental.driving.tank": "Tankstand",

      "rental.extra.F0105.title": "Zusatzfahrer",

      "rental.extra.F3023.title": "Insassenschutz: 10,00 €",

      "rental.finish.button": "Beenden & verriegeln",

      "rental.finish.success": "Ihr Mietvorgang ist erfolgreich beendet worden. Haben Sie einen schönen Tag!",

      "rental.fuelScreen.title": "Bargeldlos Tanken",

      "rental.fuelScreen.title.adblue": "AdBlue bargeldlos nachfüllen",

      "rental.fuelSettings.desc": "Tanken Sie bequem & bargeldlos mit der Tankkarte aus dem Handschuhfach an allen Partnertankstellen.",

      "rental.fuelSettings.desc.adblue": "Füllen Sie AdBlue bequem & bargeldlos mit der Tankkarte aus dem Handschuhfach an allen Partnertankstellen nach.",

      "rental.fuelSettings.fuelCard": "Tankkarte: ",

      "rental.fuelSettings.fuelNote": "Keine Premium-Kraftstoffe tanken. Andernfalls können Entgelte fällig werden.",

      "rental.fuelSettings.fuelPin": "PIN:  ",

      "rental.fuelSettings.gasStation.desc": "Bitte vergewissern Sie sich vor dem Tankvorgang, dass die Tankstelle die Tankkarte akzeptiert.",

      "rental.fuelSettings.gasStation.desc.adblue": "Bitte vergewisseren Sie sich vor dem Nachfüllen, dass die Tankstelle die Tankkarte akzeptiert und AdBlue an der Zapfsäule oder als Kanister anbietet.",

      "rental.fuelSettings.instruction": "Die Quittung muss nicht aufbewahrt werden.\nIm Anschluss legen Sie bitte die Tankkarte in die dafür vorgesehene Halterung im Handschuhfach zurück.",

      "rental.fuelSettings.navigate": "Karte",

      "rental.fuelSettings.stepOne": "1. Partnertankstelle anfahren",

      "rental.fuelSettings.stepOne.adblue": "1. Partnertankstelle mit AdBlue anfahren",

      "rental.fuelSettings.stepThree": "3. Mit Tankkarte bezahlen",

      "rental.fuelSettings.stepTwo": "2. Kraftstoff tanken (keine Premiumsorte)",

      "rental.fuelSettings.stepTwo.adblue": "2. AdBlue nachfüllen (blauer Deckel neben dem Tankstutzen)",

      "rental.fuelSettings.title": "Kostenlos Tanken",

      "rental.fuelSettings.where": "Wo?",

      "rental.fuelling.amount": "Gesamtkosten",

      "rental.fuelling.chargedToDriver": "Ihnen berechnet",

      "rental.fuelling.paidByBrand": "Von uns bezahlt – Ihnen nicht berechnet",

      "rental.fuelling.quantity": "Menge",

      "rental.fuelling.station": "Tankstelle",

      "rental.fuelling.title": "Tankvorgang",

      "rental.fuelstation": "Tankestelle",

      "rental.handover.description": "Verriegeln Sie Fahrzeug von außen mit Ihrem Handy, um die Miete zu beenden.",

      "rental.handover.header": "Danke,",

      "rental.handover.lock.title": "Miete beenden",

      "rental.handover.title": "Miete beenden",

      "rental.history.header": "Miete",

      "rental.history.invoice": "Rechnung zur Miete anzeigen",

      "rental.immobilizer.allaround.msg": "Die Motorsperre wird deaktiviert, sobald die Rundum-Fotos aufgenommen und hochgeladen wurden.",

      "rental.immobilizer.blocked": "Gesperrt",

      "rental.immobilizer.payment.msg": "Dies ist keine Panne. Die Motorsperre ist aufgrund eines Zahlungsproblems aktiviert. Bitte hinterlegen Sie eine belastbare Zahlungsmethode und kontaktieren Sie unser Service Team, um den Motor wieder zu entsperren.",

      "rental.immobilizer.title": "Motor-/Wegfahrsperre",

      "rental.insurance.change.error": "Für diese Fahrt ist keine Versicherungsoption verfügbar.",

      "rental.insurance.dialog.button": "VERSICHERUNG ANRUFEN",

      "rental.insurance.dialog.description": "Für unmittelbare Hilfe rufen Sie jetzt bitte unseren Versicherungspartner \"Gothaer Versicherung\" an und beziehen Sie sich auf folgende Versicherungsschein-Nummer:",

      "rental.insurance.dialog.footer": "24/7 Schadenservicecenter unter der Festnetznummer +49 30 5508 81508",

      "rental.insurance.dialog.number": "02.925.777 777",

      "rental.insurance.dialog.number.description": "Versicherungsschein-Nr",

      "rental.insurance.dialog.phone.number": "+4930550881508",

      "rental.insurance.dialog.title": "Soforthilfe",

      "rental.insurance.gothaer.dialog.description": "Für unmittelbare Hilfe rufen Sie jetzt bitte unseren Versicherungspartner \"Gothaer Versicherung\" an und beziehen Sie sich auf folgende Versicherungsschein-Nummer:",

      "rental.insurance.gothaer.dialog.footer": "24/7 Schadenservicecenter unter der Festnetznummer +49 30 5508 81508",

      "rental.insurance.label": "Selbstbeteiligung",

      "rental.insurance.settings.footnote": "Im Schadensfall kann es schnell teuer werden. Begrenzen Sie Ihr Haftungsrisiko und wählen eine %s",

      "rental.insurance.settings.more.url.text": "Selbstbeteiligung",

      "rental.insurances.info.url": "https://getaway.app/insurance",

      "rental.internet.disconnected.message": "Es kann keine Verbindung hergestellt werden. Bitte stellen Sie sicher, dass Sie online sind. Bei Schwierigkeiten kontaktieren Sie bitte unser Service Team.",

      "rental.internet.disconnected.title": "Keine Internetverbindung",

      "rental.keyOut.button.title": "Ich habe den Autoschlüssel",

      "rental.keyless.engine.dialog.message": "Stellen Sie den Motor ab, um das Fahrzeug zu ver- oder entriegeln.",

      "rental.keyless.engine.dialog.title": "Motor läuft",

      "rental.keyless.key.dialog.message": "Dieses Fahrzeug benötigt keinen Schlüssel. Öffnen und Schließen funktioniert über die App, die Zündung über den Start-Stopp-Button.",

      "rental.keyless.lock": "Verriegeln",

      "rental.keyless.offline.body": "Ohne Internet steuern Sie die Zentralverriegelung per Bluetooth. Dafür müssen folgende Punkte erfüllt sein. Infos zum Telefon-Support finden Sie am Ende dieser Liste.",

      "rental.keyless.offline.connected": "Alle Voraussetzungen sind erfüllt. Sie können das Fahrzeug über Bluetooth steuern:",

      "rental.keyless.offline.finish.message": "Aktivieren Sie Ihre Internetverbindung oder kontaktieren Sie den Support um Ihre Miete zu beenden.",

      "rental.keyless.offline.pin": "PIN",

      "rental.keyless.offline.step.connected.hint": "Gehen Sie näher an das Fahrzeug (max. 5 m), damit sich die App verbinden kann.",

      "rental.keyless.offline.step.connected.title": "Verbindung zum Fahrzeug hergestellt",

      "rental.keyless.offline.step.enabled.hint": "Aktivieren Sie Bluetooth in den Systemeinstellungen oder im Kontrollzentrum.",

      "rental.keyless.offline.step.enabled.title": "Bluetooth auf dem Handy aktiviert",

      "rental.keyless.offline.step.permission.hint": "Öffnen Sie **Einstellungen › Bluetooth** und erlauben Sie den Zugriff.",

      "rental.keyless.offline.step.permission.title": "Bluetooth für diese App freigegeben",

      "rental.keyless.offline.support": "Support",

      "rental.keyless.offline.title": "Kein-Internet-Modus",

      "rental.keyless.unlock": "Entriegeln",

      "rental.opened.damages.title": "Schadenprotokoll",

      "rental.opened.dongle.continue": "Weiter",

      "rental.opened.header.desc": "Wenn das Fahrzeug keine neuen Schäden aufweist, dann starten Sie bitte jetzt den Motor.",

      "rental.opened.header.title": "Starten Sie den Motor",

      "rental.opened.instruction": "Bitte den Schlüssel der Halterung entnehmen.",

      "rental.opened.key.option": "Wo finde ich den Fzg-Schlüssel?",

      "rental.opened.troubleshoot.door": "Türen verschlossen?",

      "rental.opened.troubleshoot.engine": "Motor startet nicht?",

      "rental.opened.troubleshoot.key": "Wo finde ich den Schlüssel?",

      "rental.opened.troubleshoot.options": "Optionen",

      "rental.opened.troubleshoot.title": "Können wir helfen?",

      "rental.opened.troubleshoot.unblock": "Freischalten",

      "rental.opened.troubleshoot.unlock": "Entriegeln",

      "rental.opened.video.description": "Die Schlüsselhalterung befindet sich im Handschuhfach.",

      "rental.opened.video.title": "Entnehmen Sie den Schlüssel",

      "rental.parking.findCar": "Finde mein Auto",

      "rental.prompty.end": "Miete beenden",

      "rental.rate.negative": "NEIN",

      "rental.rate.positive": "JA",

      "rental.rate.title": "Hat Ihnen das Auto gefallen?",

      "rental.refuel.warning": "Vor Rückgabe bitte mit bereitgestellter Tankkarte tanken. Andernfalls können Gebühren anfallen.",

      "rental.reserved.desc.connected": "Mit dem Entriegeln starten Sie den kostenpflichtigen Mietvorgang.",

      "rental.reserved.desc.disabled": "Aktivieren Sie Bluetooth, um das Fahrzeug mit Ihrem Handy zu entriegeln.",

      "rental.reserved.desc.searching": "Gehen Sie jetzt zum Fahrzeug, um es mit Ihrem Handy zu entriegeln.",

      "rental.reserved.header.connected": "Bitte entriegeln",

      "rental.reserved.header.disabled": "Aktiviere Bluetooth",

      "rental.reserved.header.searching": "Verringern Sie die Distanz ",

      "rental.reserved.location.enable": "Erlaube Zugriff auf Standort",

      "rental.returnlocation": "Rückgabeort",

      "rental.returntime.late": "%@ zu spät",

      "rental.review.negative.notification": "Vielen Dank für Ihr Feedback...",

      "rental.section.booked": "Gebucht",

      "rental.section.locked": "Verriegelt",

      "rental.section.reserved": "Reserviert",

      "rental.section.return": "Rückgabe",

      "rental.section.unlocked": "Entriegelt",

      "rental.service.note": "Zusätzlicher Hinweis (optional)",

      "rental.service.report.button": "Servicebericht absenden",

      "rental.service.report.submit.success": "Ihr Bericht wurde übermittelt",

      "rental.service.report.title": "Servicebericht",

      "rental.settings.insurance.more": "Mehr Infos zur Selbstbeteiligung",

      "rental.settings.insurance.title": "Reduzieren Sie Ihre Selbstbeteiligung!",

      "rental.settings.title": "Mieteinstellung",

      "rental.slider.lock": "Verriegeln & beenden",

      "rental.slider.unlock": "Miete starten",

      "rental.startEngine.decr": "Sofern das Auto keine neuen Schäden (siehe Schadensprotokoll) aufweist, starten Sie bitte jetzt den Motor. Haben Sie eine sichere Fahrt!",

      "rental.startEngine.title": "Starten Sie jetzt den Motor!",

      "rental.status": "Status",

      "rental.title": "Miete %s",

      "rental.vehicle.booking.link": "Verfügbarkeit",

      "rental.vehicle.booking.prelink": "Nächste Buchung in %s ,",

      "rental.walkthrough.button": "Ok",

      "rental.walkthrough.page1.description": "Im Schadensfall kann es schnell teuer werden. Wählen Sie Ihre gewünschte Haftungsbegrenzung (Selbstbeteiligung) bevor Sie das Fahrzeug mit Ihrem Handy entriegeln.",

      "rental.walkthrough.page1.title": "Reduzieren Sie Ihre Selbstbeteiligung",

      "rental.walkthrough.page2.description": "Bringen Sie das Fahrzeug in die farblich hervorgehobene Rückgabezone mit einem Tankstand von mind. 25% zurück und verriegeln Sie es mit Ihrem Handy.\n\nNeu: Möchten Sie, dass wir das Fahrzeug zurückzubringen? Dann wählen Sie am Ende der Miete einfach den bequemen  Rückbring-Service iHv. nur 10€ + 0,49€ je 100m.",

      "rental.walkthrough.page2.title": "Zurückbringen und Miete beenden",

      "rental.walkthrough.page3.description": "In unseren Fahrzeugen ist das Rauchen und Vapen u.a. zum Schutz nachfolgender Nutzer untersagt. Um die Einhaltung des Rauchverbots sicherzustellen und Verstöße auch mittels Vertragsstrafen zu ahnden, sind die Fahrzeuge mit Rauchsensoren ausgestattet.",

      "rental.walkthrough.page3.title": "Rauchen und Vapen verboten",

      "rental.warning.carvaloo.button": "Zustand erfassen",

      "rental.warning.carvaloo.msg": "Bitte erfassen Sie den Zustand des Fahrzeugs. Bitte beachten Sie, dass ohne Mitwirkung der Versicherungsschutz riskiert wird.",

      "rental.warning.carvaloo.title": "Schadensereignis erkannt",

      "required": "Bitte ausfüllen.",

      "resend": "Erneut senden",

      "reserve.btn.blocked": "in Wartung",

      "reserve.btn.unavailable": "Bereits gebucht",

      "reset": "Zurücksetzen",

      "reset.password.button.title": "Aktualisieren",

      "reset.password.desc": "Bitte geben Sie die E-Mail-Adresse an, mit der Sie sich registriert haben. Wir senden Ihnen im Anschluss eine E-Mail zum Zurücksetzen Ihres Passworts.",

      "reset.password.placeholder": "Neues Passwort",

      "reset.password.title": "Passwort ändern",

      "reset.password.updated": "Dein Passwort wurde aktualisiert.",

      "returncar.apply": "JETZT FREIGEBEN",

      "returncar.cancel": "Auto jetzt nicht freigeben",

      "returncar.title": ", wann möchten Sie Ihr Auto wieder?",

      "review": "Bewertung",

      "review.dialog.later": "Nicht jetzt 😒",

      "review.dialog.message": "Wenn Ihnen unsere App gefällt, schreiben Sie uns bitte eine Bewertung.\n\nDamit helfen Sie, mehr Nutzer für nachhaltige Mobilität zu begeistern 🙏",

      "review.dialog.no": "Feedback",

      "review.dialog.title": "⭐⭐⭐⭐⭐",

      "review.dialog.yes": "Ja, gefällt mir 😃",

      "route.dialog.applemaps": "Apple Maps",

      "route.dialog.copy": "Adresse kopieren",

      "route.dialog.googlemaps": "Google Maps",

      "salutation": "Anrede",

      "save": "Speichern",

      "schufa.address": "ADRESSE",

      "schufa.button.title": "Übernehmen",

      "schufa.dateOfBirth.dateFormat": "Tag / Monat / Jahr",

      "schufa.dateOfBirth.label": "Mein Geburtstag (TT/MM/JJJJ)",

      "schufa.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4> \n\n<hr style=\"border: 0.5px solid #0000001f;\"> \n\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWas ist das SEPA-Lastschriftverfahren?</summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nDas SEPA-Lastschriftverfahren ist ein sicheres und bequemes Zahlungsverfahren, bei dem Rechnungsbeträge direkt von Ihrem Bankkonto abgebucht werden. Es wird als besonders verbraucherfreundlich eingestuft, da Sie einer autorisierten SEPA-Lastschrift innerhalb von acht Wochen nach Belastung widersprechen können und Ihr Geld zurückerhalten.\n</p>\n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> \n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWarum kann ich kein anderes Land auswählen? </summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nUm die Registrierung abzuschließen, muss Ihre aktuelle Meldeadresse in dem Land liegen, das in der Länderauswahl aufgelistet ist. Sind Sie derzeit in einem anderen Land gemeldet, können Sie die Registrierung nicht fortführen. </p> \n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> \n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWie wird die Zahlungswahrscheinlichkeit geprüft? </summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nUm das SEPA-Lastschriftverfahren als Zahlungsmethode freizuschalten, muss im Vorfeld einer Bonitätsprüfung zugestimmt werden. Hierzu findet ein Abgleich mit der Datenbank der SCHUFA statt. Sie können der Einwilligung jederzeit mit Wirkung für die Zukunft widersprechen. </p> \n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> ",

      "schufa.instruction": "Geben Sie bitte Ihre aktuelle Meldeadresse an, um das Lastschriftverfahren freizuschalten.",

      "schufa.notification.message": "😥 Unser Zahlungsmittelanbieter kann leider kein SEPA-Mandat für dich einrichten. Bitte wähle eine alternative Zahlungsmethode. Wir arbeiten bereits an weiteren Alternativen.",

      "schufa.notification.title": "Zahlungsmethode freischalten",

      "schufa.personalInfo": "PERSÖNLICHE INFORMATIONEN",

      "schufa.title": "Ihre Meldeadresse",

      "schufaCheck.dialog.message": "😥 Unser Zahlungsmittelanbieter kann leider kein SEPA-Mandat für dich einrichten. Bitte wähle eine alternative Zahlungsmethode. Wir arbeiten bereits an weiteren Alternativen.",

      "schufaCheck.dialog.title": "Zahlungsmittel-Freigabe",

      "schufaCheck.dialog.yes": "OK",

      "screen.damage.image": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/assets/claimTypeCockpit_compressed.png",

      "screen.damage.option1": "Orange",

      "screen.damage.option2": "Rot",

      "screen.damage.option3": "Ich weiß es nicht",

      "screen.damage.picker.holder": "Farbe",

      "screen.damage.title": "Kontrollleuchte melden",

      "seconds.short": "Sek.",

      "select.bank.card.desc": "IBAN nicht im Kopf? Hinterlegen Sie Ihre Bankdaten einfach und sicher über Ihr Online-Banking.",

      "select.bank.card.title": "Bank aus Liste wählen",

      "select.bank.faq": "<h4 style=\"font-weight: 600;\">FAQ</h4>\n\n<hr style=\"border: 0.5px solid #0000001f;\">\n\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\">\n<summary>\nWas ist das SEPA-Lastschriftverfahren?\n </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nDas SEPA-Lastschriftverfahren ist ein sicheres und bequemes Zahlungsverfahren, bei dem Rechnungsbeträge direkt von Ihrem Bankkonto abgebucht werden. Es wird als besonders verbraucherfreundlich eingestuft, da Sie einer autorisierten SEPA-Lastschrift innerhalb von acht Wochen nach Belastung widersprechen können und Ihr Geld zurückerhalten. </p>\n</details><hr style=\"border: 0.5px solid #0000001f;\">\n<details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> \n<summary> \nWarum sollte ich mich über mein Online-Banking anmelden?</summary>\n<p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\">\nMit der Online-Banking-Methode schützen wir Ihr Konto vor Missbrauch und erleichtern es Ihnen, Ihre Bankverbindung für das Lastschriftverfahren zu hinterlegen.<br><br>So einfach geht's:<br>\n1. Klicken Sie auf \"Meine Bank wählen\"<br>\n2. Wählen Sie Ihre Bank aus der Liste und melden Sie sich an<br>\n3. Erlauben Sie, dass Ihre Bankverbindung geteilt wird<br><br>\nMit Ihrer Erlaubnis werden ausschließlich Ihre IBAN und BIC, der Kontoinhaber und der Umstand, dass Sie sich erfolgreich authentifiziert haben, geteilt.\n</p> \n</details>\n<hr style=\"border: 0.5px solid #0000001f;\"> ",

      "select.bank.footnote": "Wird Ihre Bank nicht aufgeführt, können Sie alternativ Ihre %s",

      "select.bank.footnote.url": "https://www.google.com/",

      "select.bank.footnote.url.text": "IBAN manuell eingeben",

      "select.bank.manual.desc": "Geben Sie Ihre IBAN manuell ein, um das Lastschriftverfahren einzurichten.",

      "select.bank.manual.title": "Manuell hinterlegen",

      "selectPayment.desr": "Hinterlegen Sie Ihr gewünschtes Zahlungsmittel, um Ihre Registrierung abzuschließen. ",

      "selectPayment.sepaCard.text": "Lastschrift hinzufügen",

      "selectPayment.title": "Zahlungsmittel hinzufügen",

      "selectPayment.visaCard.text": "Visa oder MasterCard hinzufügen",

      "selfie.add.button": "Video (3 Sekunden) aufnehmen",

      "sepaIbanMismatch.desc": "Wir haben die Verifizierungszahlung von einem anderen Bankkonto erhalten. Sollen wir Ihre Bankverbindung entsprechend aktualisieren?",

      "sepaIbanMismatch.retry.desc": "Führen Sie die Verifizierungszahlung von diesem Bankkonto aus, um es zu bestätigen",

      "sepaIbanMismatch.retry.title": "Beibehalten und Verifizierungszahlung wiederholen",

      "sepaIbanMismatch.title": "Wählen Sie Ihre Bankverbindung",

      "sepaIbanMismatch.use.title": "Meine Bankverbindung aktualisieren",

      "sepaVerification.bankTransfer.cta": "Fertig",

      "sepaVerification.bankTransfer.unavailable": "Banküberweisung ist derzeit nicht verfügbar, bitte zahlen Sie online.",

      "sepaVerification.bankTransfer.verified": "Bankkonto verifiziert",

      "sepaVerification.card.desc.md": "Bitte führe eine 1-Euro-Testüberweisung von dem oben genannten Bankkonto durch. Der Betrag wird umgehend wieder erstattet.",

      "sepaVerification.card.title": "1-Euro-Verifizierung",

      "sepaVerification.cta": "Zur 1-Euro-Überweisung",

      "sepaVerification.desc": "Um Ihr Bankkonto zu bestätigen, führen Sie bitte eine 1-Euro-Zahlung von dem angegebenen Bankkonto durch. Der Betrag wird sofort erstattet.",

      "sepaVerification.faq": "<h4 style=\"font-weight: 600;\">Häufig gestellte Fragen</h4> <hr style=\"border: 0.5px solid #0000001f;\"> <details style=\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"> <summary> Warum muss ich eine Verifizierungszahlung vornehmen? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Wir möchten Ihre Bankdaten schützen. Deshalb sollten Sie Bankdaten nur für Lastschriftvorgänge speichern können, für die der Zugriff überprüft wurde. Stimmt die IBAN überein, kann sie verwendet werden. </p> </details><hr style=\"border: 0,5px solid #0000001f;\"> <details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Wird der Betrag zurückerstattet? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Ja, der zur Bestätigung Ihres Bankkontos überwiesene Betrag wird umgehend zurückerstattet. </p> </details> <hr style=\"border: 0,5px solid #0000001f;\">\n<details style=\"\"font-family: AvenirNext-Medium; margin-top: 10px; margin-bottom: 10px;\"\"> <summary> Was passiert, wenn die IBAN nicht übereinstimmt? </summary> <p style=\"margin-top: 20px;font-family: AvenirNext-Regular;\"> Wenn verifizierte Bankdaten erforderlich sind, muss die hinterlegte IBAN mit der IBAN des Kontos übereinstimmen, von dem aus die Verifizierungszahlung getätigt wurde. </p> </details> <hr style=\"border: 0.5px solid #0000001f;\">\n",

      "sepaVerification.footnote.secure.text": "Verifizieren Sie Ihr Bankkonto sicher und sofort, um einen reibungsloseren und zuverlässigeren Zahlungsprozess zu gewährleisten.",

      "sepaVerification.method.bankTransfer.desc": "Zahlen Sie den voll erstattungsfähigen Betrag von %s per SEPA-Überweisung.",

      "sepaVerification.method.bankTransfer.title": "Verifizierung innerhalb von 1–2 Werktagen",

      "sepaVerification.method.header": "Bitte wählen Sie eine Verifizierungsmethode",

      "sepaVerification.method.link.badge": "Empfohlen",

      "sepaVerification.method.link.desc": "Zahlen Sie den voll erstattungsfähigen Betrag von %s über Trustly oder Klarna.",

      "sepaVerification.method.link.title": "Sofort verifizieren",

      "sepaVerification.title": "Bankverbindung bestätigen",

      "service.TIL.desc": "teilAuto ist mit über 2.500 Fahrzeugen in 30 Städten das bedeutendste Carsharing-Angebot für Sachsen, Sachsen-Anhalt und Thüringen.",

      "service.TIL.provider": "teilAuto eG",

      "service.TIL.title": "teilAuto",

      "service.account": "Kundenkonto",

      "service.agb": "AGB",

      "service.bnd.org.note": "Sobald alle geforderten Daten eingetragen und geprüft wurden, werden Sie nach erfolgreicher Freischaltung per E-Mail benachrichtigt.",

      "service.button.text": "Auftrag annehmen",

      "service.ctf.desc": "cityflitzer ist mit über 150 Fahrzeugen der erste Freefloating-Carsharer in Leipzig für spontane Fahrten von A nach B. Logge dich nach erfolgter Freischaltung einfach mit deiner Kundennummer und dem bei der Registrierung gewählten Passwort ein.",

      "service.ctf.provider": "Mobility Center GmbH",

      "service.ctf.title": "cityflitzer",

      "service.customer.number": "Kundennummer",

      "service.customer.pin": "PIN (Entriegeln)",

      "service.data": "Datenschutzerklärung",

      "service.email": "E-Mail",

      "service.imprint": "Impressum",

      "service.info": "Anbieterinformationen",

      "service.info.desc": "Beschreibung",

      "service.info.provider": "Anbieter",

      "service.login": "Log-in",

      "service.login.section": "Zugangsdaten",

      "service.map.filter.apply": "Auf Karte anzeigen",

      "service.mobi": "Zurück zu MOBIcar",

      "service.payment": "Zahlungsprofil",

      "service.report.accomplished": "Ich habe Services durchgeführt",

      "service.report.image.note": "Auf mindestens einem Foto muss das Kennzeichen zu erkennen sein.",

      "service.report.noService.note": "Zusätzliche Notizen",

      "service.reserved.services.title": "Angefragte Aufträge",

      "service.start.button": "Auftrag starten",

      "service.started.finish.button": "Auftrag abschließen",

      "service.started.services.title": "Angefragte Aufträge",

      "service.status": "Status",

      "service.status.locked": "Nicht freigeschaltet",

      "service.status.locked.note": "Entweder fehlen noch Daten für eine erfolgreiche Freischaltung oder es besteht bereits ein Nutzerkonto.",

      "service.tab.all": "Alle",

      "service.tab.thisWeek": "Woche",

      "service.tab.thisweek": "Woche",

      "service.tab.today": "Heute",

      "service.tab.tomorrow": "Morgen",

      "service.tariff": "Tarif",

      "service.tariff.mainPartnerTerminated": "Freischaltung fehlgeschlagen. Bitte kontaktieren Sie den einladenden Inhaber des Hauptkontos.",

      "service.tariff.maxPartnersExceeded": "Es können keine weiteren Tarifpartner erstellt werden.\nBitte kontaktieren Sie den Support für weitere Informationen.",

      "service.title": "Service-Fahrt",

      "service.type.basicBranding": "Autosticker",

      "service.type.basicCarPhotos": "Fotos für Autoprofil",

      "service.type.basicDamageRecords": "Schadensakte",

      "service.type.batteryChangeOpening": "Batteriewechsel (mit Notfallöffnung)",

      "service.type.batteryChangeSimple": "Batteriewechsel (einfach)",

      "service.type.batteryCharge": "Batterie laden",

      "service.type.cleanOutsideDry": "Außenreinigung (trocken)",

      "service.type.comboPremium": "comboPremium",

      "service.type.comboPro": "Paket \"Komplettpflege\"",

      "service.type.comboRefuelWashInside": "Paket \"Tanken & Innenreinigung\"",

      "service.type.comboRefuelWashOutside": "Package \"Refuel & Clean outside\"",

      "service.type.comboRefuelWashTotal": "Package \"Refuel & Total Clean\"",

      "service.type.dashboardCleaning": "Lüftungsschlitze und Ablagen intensiv reinigen",

      "service.type.desinfektion": "Desinfektion",

      "service.type.exchangeFuelCard": "Tankkarte wechseln",

      "service.type.extra10min": "Sonderreinigungszeit, je 10 Min",

      "service.type.grillCleaning": "Kühlergrill-Reinigung",

      "service.type.highGlossFinish": "Hochglanz-Finish mit Lackversiegelung",

      "service.type.noService": "Ich habe keinen Service durchgeführt",

      "service.type.otherBasicService": "Sonstiger Service",

      "service.type.refuel": "Betankung",

      "service.type.relocate": "Verlegungsfahrt",

      "service.type.relocation": "Verlegungsfahrt",

      "service.type.rimsCleaning": "Felgen-Intensivpflege",

      "service.type.safetyCheck": "Safety-Check",

      "service.type.tirePressure": "Reifendruck",

      "service.type.vacuumCleaning": "Kofferraum und Fußmatten intensiv saugen",

      "service.type.washInside": "Innenreinigung",

      "service.type.washOutside": "Außenreinigung (nass)",

      "service.type.windshieldFluidRefill": "Auffüllen des Scheibenwischwassers",

      "services.item.subTitle": "Wasch-Mein-Auto Serviceauftrag",

      "services.map.filter.apply": "Auf Karte anzeigen",

      "settings": "Einstellungen",

      "settings.addPaymentMethod.googlePay": "Google Pay",

      "settings.addPaymentMethod.payIn": "Vorkasse freischalten",

      "settings.addPaymentMethod.paypal": "PayPal hinzufügen",

      "settings.addPaymentMethod.sepa": "Lastschrift",

      "settings.addPaymentMethod.sepa.disabled": "Aktuell nicht verfügbar",

      "settings.addPaymentMethod.visa": "Kredit-/Debitkarte hinzufügen",

      "settings.address.footnote": "Mit dem Bearbeiten meiner Adressangaben stimme ich einer etwaigen %s zur Identitätsprüfung zu.",

      "settings.address.footnote.url": "https://getaway-docs.s3.eu-central-1.amazonaws.com/de-DE/Getaway_DataPrivacy-SchufaChecks-de.pdf",

      "settings.address.footnote.url.text": "Datenprüfung",

      "settings.address.org.text": "Geschäftsadresse hinzufügen",

      "settings.circles.data": "EXKLUSIVE NUTZERKREISE",

      "settings.circles.data.add": "Nutzerkreis beitreten",

      "settings.consents": "Einwilligungen",

      "settings.email.update.success": "Danke, Ihre E-Mail-Adresse ist aktualisiert worden.",

      "settings.gdpr": "Meine Daten anfordern",

      "settings.login.data": "KONTODATEN",

      "settings.login.data.driverslicense": "FAHRERLAUBNIS",

      "settings.login.data.email.edit": "Tippen Sie, um Ihre E-Mail-Adresse zu ändern",

      "settings.login.data.email.facebook": "Verbinden Sie Ihren Facebook-Account",

      "settings.login.data.facebook.dest": "Verbinden Sie Ihren Facebook-Account und nutzen der 1-Klick Login. Wir posten nichts auf Facebook ohne Ihren ausdrücklichen Wunsch!",

      "settings.login.data.moreactions": "WEITERE EINSTELLUNGEN",

      "settings.login.data.notifications": "Benachrichtigungen",

      "settings.login.data.notifications.change": "Verwalten Sie Ihre Benachrichtigungen",

      "settings.login.data.password": "Passwort zurücksetzen",

      "settings.login.data.password.edit": "Tippen Sie, um Ihr Passwort zu ändern",

      "settings.login.data.pin": "PIN (Entriegeln)",

      "settings.login.data.terminate": "Konto entfernen",

      "settings.login.data.touchId": "Touch/Face ID",

      "settings.login.data.touchId.edit": "Login mit Touch/Face ID",

      "settings.login.data.user.add.address.text": "Meldeadresse hinzufügen",

      "settings.login.data.user.add.phone.text": "Handy-Nummer hinzufügen",

      "settings.login.data.user.address.disabled.text": "Für Änderungen kontaktieren Sie bitte unser Service Team",

      "settings.login.data.user.address.text": "Tippen Sie, um Ihre Adresse zu ändern",

      "settings.login.data.user.info.text": "Für Änderungen kontaktieren Sie bitte unser Service Team",

      "settings.login.data.user.phone.text": "Tippen Sie, um Ihre Handy-Nummer zu ändern",

      "settings.logout": "Abmelden",

      "settings.notification": "Benachrichtigung",

      "settings.org.data": "GESCHÄFTSDATEN",

      "settings.org.personal.data": "PERSÖNLICHE DATEN",

      "settings.payIn.open": "Diese Zahlungsart kann nicht genutzt werden, bis die Identitätsprüfung abgeschlossen ist. Bitte kontaktieren Sie unseren Support.",

      "settings.payIn.status.open.message": "Bitte fügen Sie Ihren Personalausweis hinzu, um Zahlung per Vorkasse nutzen zu können.",

      "settings.payment.data": "ZAHLUNGSPROFILE",

      "settings.payment.data.add": "Zahlungsmittel hinzufügen",

      "settings.payment.footnote": "Mit der Auswahl des SEPA-Lastschriftverfahrens willige ich der Verarbeitung meiner Daten zur %s ein.",

      "settings.payment.footnote.url": "https://getaway-b2b.s3.eu-central-1.amazonaws.com/b2b_smp/WL_DataPrivacy-DATA_Checks-de+02_2024.pdf",

      "settings.payment.footnote.url.text": "Prüfung der Zahlungswahrscheinlichkeit",

      "settings.payment.payIn.title": "Zahlung per Vorkasse",

      "settings.payment.paypal.title": "PayPal hinzufügen",

      "settings.payment.profile.add": "Zahlungsprofil hinzufügen",

      "settings.payment.sepa.title": "Lastschrift hinzufügen",

      "settings.payment.sepa.url": "https://google.com",

      "settings.permission": "Berechtigung erforderlich",

      "settings.personal.data": "PERSÖNLICHE DATEN",

      "settings.select.tariff": "Tarif wählen",

      "settings.selectedPayment.payIn.title": "Vorkasse",

      "settings.tariff": "Tarif %s",

      "settings.tariff.6654adffda9d82661df73dcb.name": "cityflitzer",

      "settings.tariff.66574cfe7dfac60795ffa1bc.name": "cityflitzer",

      "settings.terminate.info": "Bitte kontaktieren Sie unser Service Team, um Ihr Konto löschen zu lassen.",

      "settings.terminate.no": "Abbrechen",

      "settings.terminate.yes": "Kontakt",

      "settings.title": "EINSTELLUNGEN",

      "settings.upload.camera": "Foto aufnehmen",

      "settings.upload.file": "Datei auswählen",

      "settings.upload.title": "Dokument zur Prüfung hochladen",

      "settings.uploadDoc": "Dokument hochladen",

      "settled": "Beglichen",

      "share.car.message": "Schauen Sie sich dieses Auto bei GETAWAY an: %@ %@, ab %@/km bzw. %@/Tag inkl. Versicherung und Benzin https://applink.get-a-way.com/map?id=%@",

      "share.car.subject": "Ich habe ein Auto für Sie gefunden",

      "share.panel.description": "Teilen Sie Ihren Einladungslink",

      "share.panel.title": "Sie wollen mehr Autos?",

      "shortcut.release": "Mein Auto freigeben",

      "shortcut.release4hours": "Mein Auto für 4 Std. freigeben",

      "signup.booking.invitation.footnote": "Nehmen Sie die Einladung an, wird Ihre E-Mail-Adresse und das Datum der Freischaltung mit dem Einladenden geteilt.",

      "signup.booking.invitation.prefix": "Sie wurden als Zusatzfahrer eingeladen von",

      "signup.button.title": "Jetzt gratis registrieren",

      "signup.card.org.desc": "zB. GmbH, AG, e.V., Gmbh & Co KG, KG, OHG",

      "signup.card.org.title": "Als Organisation",

      "signup.company.name.placeholder": "Firmenname (ohne Rechtsform)",

      "signup.country.label": "Land",

      "signup.desc": "Melden Sie sich jetzt gratis an und starten Sie Ihre erste Miete in wenigen Minuten.",

      "signup.desc.noBonus": "Melde dich jetzt gratis an und starte deine erste Miete.",

      "signup.description": "melden Sie sich jetzt gratis bei GETAWAY an und erhalten Sie %@.",

      "signup.description.highlight": " 5€ Startguthaben ",

      "signup.dialog.ownsACar.message": "Die Info hilft uns, unsere Services für Sie zu verbessern.",

      "signup.dialog.ownsACar.title": "Haben Sie ein Auto?",

      "signup.domain.dialog.confirm": "Bestätigen",

      "signup.domain.dialog.message": "Bitte prüfen Sie Ihre E-Mail-Adresse.",

      "signup.email.org.placeholder": "E-Mail (dienstlich)",

      "signup.email.placeholder": "E-Mail",

      "signup.facebook.complete.placeholder": "VERVOLLSTÄNDIGEN",

      "signup.facebook.dateofbirth.placeholder": "Geburtstag",

      "signup.facebook.email.placeholder": "E-Mail",

      "signup.facebook.firstname.placeholder": "Vorname",

      "signup.facebook.lastname.placeholder": "Nachname",

      "signup.facebook.picker.mr": "Herr",

      "signup.facebook.picker.mrs": "Frau",

      "signup.facebook.picker.ms": "Frau",

      "signup.facebook.title": "VIA FACEBOOK ANMELDEN",

      "signup.facebook.title.placeholder": "Anrede",

      "signup.fees.text": "Entgelte & Gebühren",

      "signup.footnote.login.action": "Login",

      "signup.footnote.login.text": "Sie haben ein Nutzerkonto?",

      "signup.footnote.secure.text": "Sichere und verschlüsselte Datenübertragung",

      "signup.header": "Jetzt registrieren",

      "signup.individual.dialog.btn": "» Zur Registrierung als Einzelperson",

      "signup.individual.dialog.msg": "Bitte nutzen Sie in diesem Falle die Registrierung als Einzelperson.",

      "signup.individual.org.desc": "zB. Einzelunternehmer, GbR, eK, UG",

      "signup.individual.org.title": "Als Einzelunternehmer oder Mitglied einer GbR",

      "signup.invitation.footnote": "Nehmen Sie die Einladung an, wird Ihre E-Mail-Adresse und das Datum der Freischaltung mit dem Einladenden geteilt.",

      "signup.invitation.header": "Registrieren Sie sich als Tarifpartner",

      "signup.invitation.prefix": "Sie wurden eingeladen von",

      "signup.invitation.remove.cancel": "Abbrechen",

      "signup.invitation.remove.confirm": "Bestätigen",

      "signup.invitation.remove.message": "Nachricht entfernen",

      "signup.invitation.remove.title": "Entfernen",

      "signup.invite.circleCard.text": "Schließen Sie sich einem unserer exklusiven Nutzerkreise an und erhalten Sie besonderen Zugang zu Fahrzeugen und Preisen!",

      "signup.invite.code.seleted.text": "Erhalten Sie jetzt Ihr %@ Startguthaben von %@ !",

      "signup.invite.title": "Ich bin eingeladen worden (optional)",

      "signup.legal.other.placeholder": "Andere",

      "signup.legal.type.placeholder": "Rechtsform",

      "signup.md.widget.success": "Bitte fahren Sie mit Ihrer Registrierung fort.\n\nFalls sich kein neues Browser-Fenster geöffnet hat, klicken Sie auf \"Registrieren fortfahren\".\n\nAlternativ können Sie den Link manuell in die Adresszeile Ihres Browsers kopieren.",

      "signup.name.placeholder": "Vorname",

      "signup.name.policy.text": "Datenschutzerklärung",

      "signup.name.terms.text": "Mit Ihrer Registrierung akzeptiere ich die AGB und Datenschutzerklärung von GETAWAY.",

      "signup.name.termsservice.text": "AGB",

      "signup.org.desc": " ",

      "signup.org.director.header": "Und nun zu Ihrer Person. Bitte wählen:",

      "signup.org.header": "Als Geschäftskunde registrieren",

      "signup.org.info": "Angaben zu Ihrer Organisation",

      "signup.org.manual.link": "» Nicht dabei? Manuell eingeben",

      "signup.org.search.button": "Suchen",

      "signup.org.search.header": "Ok, lassen Sie uns Ihre Organisation finden",

      "signup.org.search.placeholder": "Firmenname inkl. Rechtsform (zB. Firma GmbH)",

      "signup.org.type.header": "Welche Rechtsform hat Ihre Organisation?",

      "signup.password.placeholder": "Passwort",

      "signup.personal.section": "Angaben zu Ihrer Person",

      "signup.policy.cancel": "Abbrechen",

      "signup.register.location.placeholder": "Registergericht",

      "signup.register.nr.placeholder": "Register-Nr",

      "signup.terms.text": "Ich akzeptiere die %s und %s von %s.",

      "signup.terms.url": "https://getaway.app/terms",

      "signup.terms.url.text": "AGB",

      "signup.title": "Hi,",

      "signup.type.company": "Als Geschäftskunde registrieren",

      "signup.type.dialog.bnd": "book-n-drive",

      "signup.type.dialog.bnd.link": "https://web.book-n-drive.de/registration/pid/575",

      "signup.type.dialog.cf": "cityFlitzer",

      "signup.type.dialog.cf.link": "https://de1.cantamen.de/pub/okw/form?orgnr=125&package=&authKey=77f2663b-3e06-84d7-9dfb-a521724124f4&product=firm-jp-wok",

      "signup.type.dialog.title": "Als Geschäftskunde registrieren",

      "signup.type.org": "Als Geschäftskunde registrieren",

      "signup.type.private": "Als Einzelperson registrieren",

      "signup.update.placeholder": "Neue E-Mail Adresse",

      "signup.widget.success.cta": "Registrierung fortfahren",

      "signup.widget.success.reset": "Formular zurücksetzen",

      "signup.zipcode.placeholder": "Wie lautet Ihre Postleitzahl?",

      "sort.byDistance": "Sortieren (Distanz)",

      "sort.byDistance.label": "Nach Distanz sortieren",

      "sort.byDue": "Sortieren (Fälligkeit)",

      "sort.byDue.label": "Nach Fälligkeit sortieren",

      "sppStandard.SPPKunde.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | ~~6,90~~ 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n *Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 15 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.",

      "sppStandard.SPPMitarbeiter.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | ~~6,90~~ 0 €/Std*|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachtarif | 20 €|\n| Wochenendtarif | 79 €|\n\n*Der Rabatt auf die ersten vier Stunden ist nur einmalig einlösbar.<br/>\n\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 1.500€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.",

      "sppStandard.ubeeqo.pricing": "| Mietdauer    |  |\n| :-------- | -------: |\n| Stunde 1 bis 4 | 6,90 €/Std|\n| Ab 5. Stunde | 8,90 €/Std|\n| Nachttarif | 20 €|\n| Wochenendtarif | 79 €|\n\n| Fahrtstrecke (inkl. Kraftstoff)   |  |\n| :-------- | -------: |\n| Je Kilometer | 0,30 € / km |\n\n\n| Selbstbeteiligung (je Schadensfall)    |  |\n| :-------- | -------: |\n| max. 750€ | 0 € (inklusive) |\n| max. 500€ | 11 €/Kal.Tag |\n| max. 150€ | 19 €/Kal.Tag |\n\n| Zusatzleistungen    |  |\n| :-------- | -------: |\n| Insassenschutz  | 10 € |\n\n| Tank-Service (bei Rückgabe)    |  |\n| :-------- | -------: |\n| Tankstand < 25%  | 5 € |\n| Tankstand < 5%  | 50 € |\n\n> Die vollständige Aufstellung aller Entgelte sind der [aktuellen Preisliste](https://api.get-a-way.com/pricing/64b800ea1c6567078806a254/pdf) zu entnehmen.",

      "start.engine.description": "Bitte entnehmen Sie den Schlüssel aus dem Handschuhfach.",

      "start.engine.title": "Starten Sie den Motor und gute Fahrt!",

      "station.booking.button": "Schlüsselübergabe",

      "station.booking.cancel": "Reservierung stornieren",

      "station.booking.category": "Fahrzeugkategorie",

      "station.booking.code": "Reservierungscode",

      "station.booking.confirm.button": "Jetzt reservieren",

      "station.booking.confirm.category": "Fahrzeugkategorie",

      "station.booking.confirm.dates": "Reservierungsdaten",

      "station.booking.confirm.description": "Überprüfe deine Reservierungsdaten und schließe die Reservierung ab",

      "station.booking.confirm.from": "Von",

      "station.booking.confirm.group": "Abholung",

      "station.booking.confirm.title": "Prüfen Sie Ihre Reservierung",

      "station.booking.confirm.to": "Bis",

      "station.booking.confirm.where": "Wo?",

      "station.booking.description": "Sobald deine Reservierung beginnt, hast du 30 Minuten Zeit, das Fahrzeug am Express-Schalter der Station abzuholen.",

      "station.booking.from": "Von",

      "station.booking.group": "Abholung",

      "station.booking.key.category": "Kategorie",

      "station.booking.key.code": "Reservierungscode",

      "station.booking.key.description": "Zeige diese Ansicht einem Mitarbeiter an der Station. Nach erfolgreicher Schlüsselübergabe beginnt dein Mietvorgang automatisch.",

      "station.booking.key.from": "Von",

      "station.booking.key.insurance": "Selbstbeteiligung",

      "station.booking.key.insurance.default": "SB500",

      "station.booking.key.item": "Fahrzeug",

      "station.booking.key.title": "Schlüsselübergabe",

      "station.booking.key.to": "Bis",

      "station.booking.later.than": "Zu starten bis",

      "station.booking.later.value": "Schlüsselübergabe",

      "station.booking.merchant.waiting": "wird abgerufen",

      "station.booking.reservation": "Reserviert",

      "station.booking.title": "Deine Reservierung",

      "station.booking.to": "Bis",

      "station.booking.where": "Wo?",

      "storage.permission.details": "Bitte gewähren Sie GETAWAY Zugriff auf Ihren Speicher um die angefragten Dateien abzuspeichern.",

      "storage.permission.title": "Zugriffsanfrage gewähren",

      "storage.permission.yes": "Erlauben",

      "submit": "Übernehmen",

      "submt": "Übernehmen",

      "support.call": "Service Team anrufen",

      "support.cancel": "Abbrechen",

      "support.chat": "LiveChat",

      "support.email": "E-Mail",

      "support.phone.number": "+493012088089",

      "support.whatsapp": "LiveChat",

      "tariff.Firmentarif": "Firmentarif",

      "tariff.Firmentarif.desc": "✓ inklusive Selbstbeteiligung <s>1500€</s>  750€\n\n✓ inklusive Kraftstoffkosten\n\n✓ bis zu 50% auf den Zeitpreis sparen\n\n✓ Über 4.000 Fahrzeuge deutschlandweit im stationsbasierten und -flexiblen Carsharing",

      "tariff.Firmentarif.price": "<div style=\"display: flex;\">einmalig <s style=\"margin-left: 3px; margin-right: 3px;\"> 19€ </s> <strong style=\"color: #749600;\"> gratis</strong>・monatlich 0€</div>",

      "tariff.Rahmentarif.desc.new": "✓ 16% Rabatt im Vergleich zum Starttarif <br>\n✓ 4 Tarifpartner inklusive<br>\n\nBahnCard, ÖPNV-Abo oder Student? Sparen Sie mit dem %s\"",

      "tariff.button.text": "Tarif übernehmen",

      "tariff.coupon": "Gutschein einlösen",

      "tariff.coupon.desc": "Sofern der Gutscheincode gültig ist, wird dieser im\nAnschluss an die Freischaltung angewendet.",

      "tariff.coupon.number": "Gutscheincode eingeben",

      "tariff.desc": "Wählen Sie Ihren passenden Tarif und optional die Reduzierung der Selbstbeteiligung.",

      "tariff.discount.selected.header": "Bitte Nachweis hinterlegen",

      "tariff.discount.selected.proof": "Nachweis",

      "tariff.discounts": "Ermäßigung anwenden",

      "tariff.discounts.header": "Partnerrabbat wählen",

      "tariff.grf.coupon.desc": "Sofern der Gutscheincode gültig ist, wird dieser im Anschluss an die Freischaltung angewendet.",

      "tariff.header.desc": "Bestätigen Sie jetzt den passenden Tarif.",

      "tariff.org.consent": "Der Kundenvertrag wird vorbehaltlich einer positiven Bonitätsauskunft abgeschlossen und kann bei negativer Auskunft widerrufen werden.",

      "tariff.partner.desc": " ",

      "tariff.partner.link.footnote.md": "Wer sich mit dem Einladungslink erfolgreich registriert, wird automatisch Ihrem Haupt-Account als Tarifpartner hinzugefügt. Beim Teilen des Einladungslinks werden auch Daten des Einladenden geteilt. ",

      "tariff.partner.link.prefix": "Einladungslink",

      "tariff.partner.link.share": "Einladungslink teilen",

      "tariff.partner.share.text": "Schließen Sie sich Ihrem Partner an %@",

      "tariff.partner.share.title": "Teilen",

      "tariff.partner.switch.title": "Einladungslink erlauben",

      "tariff.partner.title": "Tarifpartner",

      "tariff.title": "Tarif wählen",

      "tariff.upselling.SB.header": "Sicherheitspaket",

      "tariff.upselling.free.header": "Kein Extra-Schutz",

      "tariff.upselling.free.price": "0€ (inklusive)",

      "tariff.upselling.title": "Service-Paket",

      "tba": "tba",

      "terms.url": "https://get-a-way.com/agb?utm_source=app",

      "textkey": "de-DE",

      "time": "Zeitpunkt",

      "tirePressure": "Reifendruck",

      "today": "Heute",

      "toggle.or": "ODER",

      "tomorrow": "Morgen",

      "tonne.short": "t",

      "touchId.password.dialog.message": "Bitte geben Sie jetzt Ihr GETAWAY Passwort ein, um Touch ID zu aktivieren.",

      "touchId.password.dialog.title": "Mit Passwort bestätigen",

      "touchid.enable.message": "Melden Sie sich ab sofort noch einfacher bei GETAWAY per Touch ID an.",

      "touchid.login.message": "Nutzen Sie Touch ID, um sich noch einfacher bei GETAWAY anzumelden.",

      "transaction.open.button": "Jetzt bezahlen",

      "transaction.open.description": "Bitte zahlen Sie die offene Rechnung ",

      "transaction.open.title": "Offene Zahlung",

      "transactions.bonus.description": "[{0}]",

      "transactions.bonus.title": "Gutschrift",

      "transactions.cancel.description": "Storno [{0}]",

      "transactions.cancel.title": "Rückerstattung",

      "transactions.chargeback.description": "{0} {1}",

      "transactions.chargeback.title": "Rücklastschrft",

      "transactions.fee.description": "{0} {1}",

      "transactions.fee.title": "Entgelt #{0}",

      "transactions.firststepsbonus.description": "🎉 Willkommensbonus",

      "transactions.goodwillbonus.description": "Kulanz-Gutschrift [{0}]",

      "transactions.payment.deposit.description": "Rechnung [{0}]",

      "transactions.payment.deposit.title": "Kaution Einzahlung",

      "transactions.payment.title": "(An-)Zahlung [{0}]",

      "transactions.payout.title": "Auszahlung",

      "transactions.refuel.description": "{0} am {1} Uhr",

      "transactions.refuel.title": "Tankvorgang",

      "transactions.refuelbonus.description": "🙏 Danke für's Tanken",

      "transactions.refund.deposit.description": "Mietvorgang [{0}]",

      "transactions.refund.deposit.title": "Rückzahlung Kaution",

      "transactions.refund.title": "Auszahlung",

      "transactions.rental.description": "{0} | {1}km am {2} Uhr",

      "transactions.rental.title": "Rechnung [{0}]",

      "transactions.type.bonus": "Gutschrift",

      "transactions.type.bonus.description": "Erste Schritte wurden gemeistert",

      "transactions.type.fee": "Gebühr",

      "transactions.type.payment": "Zahlung",

      "transactions.type.payment.reason": "Grund",

      "transactions.type.referrerBonus": "Gutschrift",

      "transactions.type.referrerBonus.description": "Für Ihre Empfehlung an Ihre Freunde",

      "trip.adult.desc": "ab 15 Jahre",

      "trip.adult.placeholder": "Passagiere (Regeltarif)",

      "trip.cancel.confirm.msg": "Möchten Sie die Fahrt tatsächlich stornieren? Bitte beachten Sie, dass Stornierungsgebühren anfallen können.",

      "trip.cancel.confirm.title": "Fahrt stornieren",

      "trip.cancel.dialog.title": "Möchten Sie die Fahrt tatsächlich stornieren? Bitte beachten Sie, dass Stornierungsgebühren anfallen können.",

      "trip.cancel.no": "Abbrechen",

      "trip.cancel.yes": "Jetzt stornieren",

      "trip.children.desc": "0 - 14 Jahre",

      "trip.children.placeholder": "Passagiere (ermäßigt)",

      "trip.damage.report": "Schaden melden",

      "trip.driving.refuel": "Jetzt tanken",

      "trip.force.finish": "Fahrt vorzeitig beenden",

      "trip.force.finish.msg": "Möchten Sie die Fahrt auf eigenes Risiko jetzt vorzeitig beenden?",

      "trip.force.finish.title": "Fahrt vorzeitig beenden",

      "trip.force.no": "Verwerfen",

      "trip.force.yes": "Jetzt beenden",

      "trip.opened.stepOne": "Ich bin angeschnallt",

      "trip.opened.stepTwo": "Die Fahrzeugtür ist wieder verschlossen",

      "trip.order.arrived": "Rufbus ist da: Jetzt Seitentür öffnen",

      "trip.order.brake": "Notbremse",

      "trip.order.driving": "Gute Fahrt!",

      "trip.order.finished.submit": "Fahrt beenden",

      "trip.order.opened": "Bitte einsteigen",

      "trip.order.parking": "Bitte aussteigen",

      "trip.order.parking.submit": "Fahrt beenden",

      "trip.order.start": "Los geht’s",

      "trip.order.stop": "Zwischenhalt: nicht Ihr Ausstieg.",

      "trip.order.transit": "Zwischenhalt: nicht Ihr Ausstieg.",

      "trip.order.unlock": "Tür ist geöffnet",

      "trip.order.waiting": "Rufbus ist auf dem Weg",

      "trip.parking.stepOne": "Ich bin ausgestiegen",

      "trip.parking.stepThree": "Fahrzeugtür ist wieder verschlossen",

      "trip.parking.stepTwo": "Ich habe nichts vergessen",

      "trip.payByLink.description": "Kaution für Mietvorgang %@",

      "trip.search.confirm": "Bestellen",

      "trip.search.enter.destination": "Zieladresse übernehmen",

      "trip.search.enter.start": "Ziel eingeben",

      "trip.search.enter.start.location": "Startadresse übernehmen",

      "trip.service.type.refuel": "Refueling",

      "trip.service.type.relocate": "Relocating",

      "trip.service.type.relocateAndRelease": "Relocate And Release",

      "trip.service.type.title": "Welcher Service wurde durchgeführt?",

      "trip.start.location.placeholder": "Start-Adresse eingeben",

      "trip.stop.confirm.msg": "Möchten Sie die Notbremse tatsächlich auslösen? Bitte beachten Sie, dass ein Missbrauch strafbar ist.",

      "trip.stop.confirm.title": "Notbremse",

      "trip.stop.item": "Haltestelle %s",

      "trip.stop.no": "Abbrechen",

      "trip.stop.yes": "Notbremse auslösen",

      "trip.stops.title": "%s Haltestellen",

      "trip.support": "Service kontaktieren",

      "trip.wheelchair.desc": "1 Rollstuhl je Fzg möglich",

      "trip.wheelchair.placeholder": "Rollstuhlbedarf",

      "tripHistory.complain": "Beschwerde einreichen",

      "tripHistory.end": "Rückgabe",

      "tripHistory.fee": "Mietvorgang",

      "tripHistory.revenue": "Mieteinnahmen",

      "tripHistory.services": "Durchgeführte(r) Service(s)",

      "tripHistory.start": "Übernahme",

      "tutorial.listcar.button": "AUTO GRATIS CHECKEN",

      "tutorial.listcar.step1.message": "Ihr Auto steht täglich 23 Std. still. Geben Sie es in Standzeiten minutenweise zum Vermieten frei und verdienen Sie bis zu 100€ pro Woche und mehr.",

      "tutorial.listcar.step1.title": "Parken Sie\nnoch oder \nverdienen Sie\nschon?",

      "tutorial.listcar.step2.message": "Bestimmen Sie spontan die Verfügbarkeit und Ihren Verdienst pro Kilometer. Erhalten Sie Einnahmen automatisch gutgeschrieben.",

      "tutorial.listcar.step2.title": "Sie\nbehalten\ndie \nKontrolle",

      "tutorial.listcar.step3.message": "Wir prüfen jeden Mieter, behalten Ihr Auto mit modernster Technologie im Blick und lassen es rundum über „Die Gothaer“ versichern.",

      "tutorial.listcar.step3.title": "Damit\nSie gelassen\nbleiben\nkönnen",

      "tutorial.listcar.step4.message": "Bestehende Ressourcen effizienter nutzen: Entlasten Sie die Umwelt ganz nebenbei, ohne auf Ihre Freiheit eines Autos zu verzichten.",

      "tutorial.listcar.step4.title": "Gut für’s \nGewissen. \nGut für die \nUmwelt.",

      "tutorial.listcar.step5.message": "Lassen Sie Ihr Auto jetzt gratis und unverbindlich von uns prüfen und erfahren, wie viel Ihr Auto für Sie verdienen kann.",

      "tutorial.listcar.step5.title": "Wie viel\nkann Ihr\nAuto \nverdienen?",

      "tutorial.map.listCar.button": "JETZT CHECKEN",

      "tutorial.map.listCar.message": "Lassen Sie jetzt gratis und unverbindlich prüfen, wie viel Ihr Auto für Sie verdienen kann.",

      "tutorial.map.listCar.title": "Wie viel verdient \nIhr Auto?",

      "tutorial.map.step1.message": "Für Hilfe, Feedback oder Anregungen ist unser Team stets nur einen Klick entfernt.",

      "tutorial.map.step1.title": "Stets an\nIhrer Seite",

      "tutorial.map.step2.message": "Über das Nutzer-Symbol gelangen Sie zu Ihren persönlichen Einstellungen.",

      "tutorial.map.step2.title": "Alles\nim Blick",

      "tutorial.map.step3.message": "Geben Sie Ihren Wunschzeitraum an und verfügbare Autos werden automatisch gefiltert.",

      "tutorial.map.step3.title": "Spontan\nein Auto?",

      "tutorial.map.step4.button": "LOS GEHT’S",

      "tutorial.map.step4.message": "Schließen Sie die ersten Schritte ab und sichern Sie sich Ihr Startguthaben. Es dauert nur 2 Minuten.",

      "tutorial.map.step4.title": "Erobern Sie\ndie Straße",

      "tutorial.signup.button": "LOS GEHT’S",

      "tutorial.signup.extraAction": "Ich habe ein Nutzerkonto »",

      "tutorial.signup.step1.message": "Öffnen & mieten Sie Privatautos in Ihrer Nähe sofort per Handy\n",

      "tutorial.signup.step1.title": "AUTOS\nVON\nNEBENAN",

      "tutorial.signup.step2.message": "Preise je Kilometer machen Kosten planbar und Sie im Stau entspannt.",

      "tutorial.signup.step2.title": "STRESSEN\nSIE SICH\nNICHT",

      "tutorial.signup.step3.message": "Vermieten Sie Ihr Auto spontan, während Sie es selbst nicht benötigen.",

      "tutorial.signup.step3.title": "SIE\nHABEN\nEIN\nAUTO?",

      "tutorial.signup.step4.message": "Geben Sie Ihr Auto beim Parken mit nur einem Klick zum Vermieten frei",

      "tutorial.signup.step4.title": "MIT\nNUR\nEINEM\nKLICK",

      "unavailablecar.request": "Start Booking",

      "until": "Bis",

      "upcoming.booking.event.description": "Ihre Buchung finden Sie hier",

      "upcoming.booking.event.title": "Reservierung Mietwagen",

      "update.address.add": "HINZUFÜGEN",

      "update.address.city": "Stadt",

      "update.address.country": "Land",

      "update.address.desc": "Bitte beachten Sie, dass es sich hierbei um Ihre offizielle Meldeadresse handeln muss.",

      "update.address.germany": "Deutschland",

      "update.address.location.error": "GETAWAY ist noch nicht in Ihrem Land verfügbar.",

      "update.address.number": "Nr",

      "update.address.search": "Adresse suchen",

      "update.address.street": "Straße",

      "update.address.success": "Danke, Ihre Adresse ist erfolgreich aktualisiert worden.",

      "update.address.update": "AKTUALISIEREN",

      "update.address.zip": "Plz",

      "update.email.desc": "Ihre aktuelle E-Mail-Adresse lautet %@. Bitte geben Sie Ihre neue E-Mail ein und bestätigen dies mit Ihrem Passwort.",

      "update.email.new": "Neue E-Mail-Adresse",

      "update.email.title": "E-Mail-Adresse aktualisieren",

      "update.email.update": "AKTUALISIEREN",

      "update.email.wrong.pass": "Falsches Passwort",

      "update.notifications.channels": "KANÄLE",

      "update.notifications.email": "Per E-Mail",

      "update.notifications.email.desc": "Erlaubnis, Sie per E-Mail zu kontaktieren.",

      "update.notifications.mail": "Per Post",

      "update.notifications.mail.desc": "Erlaubnis, Sie per Post zu kontaktieren.",

      "update.notifications.push": "Per Push-Nachricht",

      "update.notifications.push.desc": "Erlaubnis, Sie per App-Mitteilung zu kontaktieren.",

      "update.notifications.push.wizard.button": "ZU DEN EINSTELLUNGEN",

      "update.notifications.push.wizard.desc": "Aktivieren Sie Push-Nachrichten",

      "update.notifications.push.wizard.latter": "NICHT JETZT",

      "update.notifications.push.wizard.latter.error": "Push-Nachricht sind deaktiviert",

      "update.notifications.push.wizard.title": "Push-Nachrichten aktivieren",

      "update.notifications.sms": "Per SMS",

      "update.notifications.sms.desc": "Erlaubnis, Sie per SMS zu kontaktieren.",

      "update.notifications.title": "BENACHRICHTIGUNGEN",

      "update.notifications.topics.name.bookings.description": "Wir halten Sie über Ihre Buchungen auf dem Laufenden.",

      "update.notifications.topics.name.bookings.title": "Buchungen",

      "update.notifications.topics.name.monthlyOverview.description": "Behalten Sie Fahrten und Ihr Guthaben im Blick",

      "update.notifications.topics.name.monthlyOverview.title": "Monatliche Übersicht",

      "update.password.forgot.error": "Bitte geben Sie Ihre E-Mail-Adresse an und tippen erneut auf \"Vergessen\". Wir senden Ihnen im Anschluss ein Link zum Zurücksetzen Ihres Passworts.",

      "update.password.text": "Sofern die E-Mail-Adresse registriert ist, ist soeben ein Link zum Zurücksetzen des Passworts an %@ gesendet worden.",

      "update.password.wizard.desc": "Bitte geben Sie ein neues Passwort ein",

      "update.password.wizard.newpassword": "Neues Passwort",

      "update.password.wizard.title": "Passwort aktualisieren",

      "update.password.wizard.update": "AKTUALISIEREN",

      "upselling.dialog.message": "Möchten Sie dieses Paket buchen?",

      "upselling.dialog.noAction": "Weiter ohne Extra-Schutz",

      "upselling.dialog.title": "Kein Extra-Schutz?",

      "upselling.dialog.yesAction": "Ja",

      "upsellings.button.text": "Übernehmen",

      "upsellings.header.desc": " Im Schadenfall kann es schnell teuer werden. Beschränken Sie Ihr Haftungsrisiko.",

      "upsellings.title": "Selbstbeteiligung",

      "user-duplicate.phone.cancel": "ABBRECHEN",

      "user.DL.completed.message": "Um deine Fahrerlaubnisdaten (Fahrverbot oder neuer Führerschein) zu aktualisieren, wende dich bitte an unser Service Team.",

      "user.DL.inProgress.message": "Bitte haben Sie noch etwas Geduld. Ihre Fahrerlaubnis wird gerade verifiziert.",

      "user.DL.resubmission.message": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktiere unser Service Team.",

      "user.ID.completed.message": "Um eine Änderung vorzunehmen, kontaktieren Sie bitte unser Service Team.",

      "user.ID.inProgress.message": "Dein Ausweisdokument wird verifiziert. Wir bitten um Geduld.",

      "user.ID.resubmission.message": "Um ein Ausweis-Dokument hochzuladen, kontaktieren Sie bitte unser Service-Team.",

      "user.action.support.text": "Service Team kontaktieren",

      "user.add_to_circle.brand_not_matches": "Nutzerkreis und Anbieter stimmen nicht überein, Nutzerkreis kann daher nicht hinzugefügt werden.",

      "user.address.completed.message": "Um Ihre Adresse zu ändern, wenden Sie sich bitte an unser Service Team.",

      "user.address.inProgress.message": "Bitte haben Sie noch etwas Geduld. Ihre Adresse wird gerade verifiziert.",

      "user.car.selector.listed": "%@ (vom %@)",

      "user.car.selector.release_ready": "%@ (Nicht freigegeben)",

      "user.car.selector.released": "%@ (Freigegeben)",

      "user.car.selector.rented": "%@ (In Miete)",

      "user.car.selector.submitted": "Neues Auto (vom %@)",

      "user.car.selector.title": "Wählen Sie Ihr Auto",

      "user.circle.description": "Wollen Sie diesen Nutzerkreis wirklich verlassen?",

      "user.circle.leave": "Nutzerkreis verlassen",

      "user.circle.leave.description": "Wenn Sie diesen Nutzerkreis verlassen, haben Sie keinen Zugang mehr zu dessen Fahrzeugen und Angeboten. Sind Sie sicher, dass Sie fortfahren möchten?",

      "user.circle.switchAccess": "Nutzerkreis wechseln",

      "user.deletePayment.dialog.message": "Sind Sie sicher?",

      "user.deletePayment.dialog.no": "Abbrechen",

      "user.deletePayment.dialog.title": "Zahlungsprofil entfernen",

      "user.deletePayment.dialog.yes": "Entfernen",

      "user.deposit.dialog.msg": "Die Rechnung zur hinterlegten Kaution können Sie hier nach Abschluss Ihrer Registrierung herunterladen.\n\nFalls Sie eine Erstattung wünschen, erhalten Sie diese automatisch, sobald Sie Ihre Registrierung abbrechen und Ihr Nutzerkonto entfernen.",

      "user.deposit.dialog.no": "Jetzt nicht",

      "user.deposit.dialog.yes": "LiveChat öffnen",

      "user.document.resubmitInstruction.BAD_QUALITY_IMAGE": "Schlecht lesbar: Bitte laden Sie ein Dokument in ausreichender Qualität ein.",

      "user.document.resubmitInstruction.BLURRED": "Schlecht lesbar: Bitte laden Sie ein Dokument in ausreichender Schärfe ein.",

      "user.document.resubmitInstruction.CAR_DRIVING_PERMISSION_IS_NO": "Fehlende Infos: Bitte reichen Sie einen Führerschein ein, auf dem die nötige Fahrerlaubnis eindeutig erkennbar ist.",

      "user.document.resubmitInstruction.COUNTRY_NOT_ALLOWED": "Das von Ihnen eingereichte Dokument kann aufgrund des Ausstellungslands nicht verarbeitet werden. Bitte reichen Sie ein Dokument mit einem anderen Ausstellungsland ein.",

      "user.document.resubmitInstruction.DAMAGED_DOCUMENT": "Bitte reichen Sie ein unbeschädigtes/ungelochtes Dokument ein.",

      "user.document.resubmitInstruction.EXPIRED_DOCUMENT": "Dokument Abgelaufen: Bitte reichen Sie ein gültiges Dokument ein.",

      "user.document.resubmitInstruction.GLARE": "Schlecht lesbar: Bitte reichen Sie Ihr Dokument ohne Reflexionen ein. Ggf. hilft es, den Blitz auszuschalten",

      "user.document.resubmitInstruction.IDENTITY_MISMATCH_APPROVED_USER_IDENTITY": "Fehlende Übereinstimmung: Bitte reichen Sie ein Dokument ein, dass mit Ihren Nutzerangaben übereinstimmt.",

      "user.document.resubmitInstruction.INCOMPLETE_DATA": "Fehlende Angaben: Bitte achten Sie beim nächsten Versuch darauf, dass alle Angaben auf dem Dokument gut lesbar sind.",

      "user.document.resubmitInstruction.LIVENESS_FAILED": "Kameraausrichtung: Bitte achten Sie beim nächsten Versuch darauf, die Aufnahmen im Porträtmodus (hochkant) zu machen.",

      "user.document.resubmitInstruction.MANIPULATED_DOCUMENT": "Dokument kann aufgrund von Änderungen am Dokument nicht verarbeitet werden. Bitte reichen Sie ein anderes Dokument ein.",

      "user.document.resubmitInstruction.MISSING_PAGE": "Fehlende Infos: Bitte achten Sie darauf, dass Vorder- und Rückseite hochgeladen werden.",

      "user.document.resubmitInstruction.MISSING_SIGNATURE": "Fehlende Unterschrift: Bitte reichen Sie ein gültiges Dokument mit allen Sicherheitsmerkmalen ein.",

      "user.document.resubmitInstruction.NO_ID_UPLOADED": "Falls Sie Schwierigkeiten haben, versuchen Sie es bitte in einem anderen Browser.",

      "user.document.resubmitInstruction.NO_MATCH": "Fehlende Übereinstimmung: Bitte reichen Sie ein Dokument ein, dass auf Sie persönlich ausgestellt wurde.",

      "user.document.resubmitInstruction.PART_OF_DOCUMENT_MISSING": "Bitte reichen Sie Ihr Dokument so ein, sodass es vollständig einsehbar ist.",

      "user.document.resubmitInstruction.PHOTOCOPY": "Bitte scannen Sie das geforderte Dokument ausschließlich vom Original ab.",

      "user.document.resubmitInstruction.PUNCHED": "Bitte reichen Sie ein unbeschädigtes/ungelochtes Dokument ein.",

      "user.document.resubmitInstruction.WRONG_DOCUMENT_TYPE": "Falsches Dokument: Bitte achten Sie bei diesem Versuch darauf, ob hierbei ein Führerschein oder ob ein Ausweisdokument gefordert ist.",

      "user.duplicate.api_error.org.duplicate.cancel": "ABBRECHEN",

      "user.duplicate.api_error.org.duplicate.msg": "Diese Firma ist bereits hinterlegt.\nMöchten Sie Ihr Passwort zurücksetzen?",

      "user.duplicate.api_error.org.duplicate.yes": "ZURÜCKSETZEN",

      "user.duplicate.email.cancel": "ABBRECHEN",

      "user.duplicate.email.msg": "Eine E-Mail darf nur einmal verwendet werden.\nBitte melden Sie sich mit Ihrem ursprünglichen Nutzerkonto an. Sollten Sie Ihr Passwort vergessen haben, können Sie es über die Anmeldemaske zurücksetzen.",

      "user.duplicate.email.yes": "JETZT ANMELDEN",

      "user.duplicate.iban.cancel": "ABBRECHEN",

      "user.duplicate.iban.msg": "Eine IBAN darf nur einmal verwendet werden.\n\nBitte melden Sie sich mit Ihrem ursprünglichen Nutzerkonto an.\n \nSollten Sie Ihr Passwort vergessen haben, können Sie es über die Anmeldemaske zurücksetzen.",

      "user.duplicate.iban.yes": "JETZT ANMELDEN",

      "user.duplicate.phone.cancel": "ABBRECHEN",

      "user.duplicate.phone.msg": "Die Handynummer kann nur einmal verwendet werden.\n\nBitte melden Sie sich mit Ihrem ursprünglichen Benutzerkonto an. Wenn Sie Ihr Passwort vergessen haben, können Sie es auf dem Anmeldebildschirm zurücksetzen.",

      "user.duplicate.phone.yes": "JETZT ANMELDEN",

      "user.email.completed.message": "Um Ihre E-Mail-Adresse zu ändern, wenden Sie sich bitte an unser Service Team.",

      "user.id.not.required": "Dieser Schritt ist nicht mehr erforderlich",

      "user.logout.cancelReservation.message": "Bitte stornieren Sie die Reservierung, bevor Sie fortfahren.",

      "user.logout.cancelReservation.ok": "Ok",

      "user.logout.dialog.message": "Sind Sie sicher?",

      "user.logout.dialog.no": "Abbrechen",

      "user.logout.dialog.title": "Abmelden",

      "user.logout.dialog.yes": "Abmelden",

      "user.noPayment.action": "Zahlungsmittel hinzufügen",

      "user.noPayment.message": "Bitte hinterlege zuerst ein gültiges Zahlungsmittel",

      "user.notNow": "Jetzt nicht",

      "user.notification.terminate.message": "Ihr Antrag zur Kontolöschung wird derzeit bearbeitet.",

      "user.org.signupCertificate.events.signedUp.description": "Das Nutzerkonto ist als organisatorisches Konto unter dem Namen %s, mit der Rechtsform %s, der Register-Nr %s am Registergericht %s durch %s %s mit der E-Mail-Adresse %s registriert und den/r zu diesem Zeitpunkt gültigen/r AGB und Datenschutzerklärung ist zugestimmt worden.",

      "user.payment.not.added": "Es wurde bisher keine Zahlungsmethode hinterlegt. Bitte holen Sie dies zuerst nach.",

      "user.paymentLink.iban_verification.description": "Um zu bestätigen, dass Sie Zugriff auf das Konto mit der angegebenen IBAN haben, ist eine Zahlung eines kleinen Betrags erforderlich. Der Betrag wird Ihnen nach Abschluss der Überprüfung vollständig zurückerstattet.",

      "user.phone.completed.message": "Um Ihre Handynummer zu ändern, wenden Sie sich bitte an unser Service Team.",

      "user.phone.edit.desc": "Um Ihre Telefonnummer zu aktualisieren, senden wir einen Bestätigungscode an Ihre E-Mail- Adresse.",

      "user.pin.completed.message": "Um eine Änderung vorzunehmen, kontaktiere bitte unser Service Team.",

      "user.profile.payment.org.pending": "Die Zahlungsmethode wird nach erfolgreicher Prüfung durch das Service Team freigegeben.",

      "user.profile.payment.pending": "Die Zahlungsmethode wird verifiziert, sobald Ausweis und Führerschein hinzugefügt wurden.",

      "user.scan.attempts.out": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktieren Sie unser Service Team.",

      "user.selectPayment.noCC": "Ich habe keine Kredit-/Debitkarte",

      "user.signupCertificate.accountHistory": "Nutzerkonto-Verlauf",

      "user.signupCertificate.createdBy": "Erstellt von",

      "user.signupCertificate.createdBy.at": "am",

      "user.signupCertificate.deviceUuid": "UUID",

      "user.signupCertificate.documentId": "ID (Dokument)",

      "user.signupCertificate.events.addressVerified.description": "Dem Nutzerkonto ist die Meldeadresse %s hinzugefügt worden.",

      "user.signupCertificate.events.creditCheck.description": "Der Verarbeitung der Daten zur Prüfung der Zahlungswahrscheinlichkeit ist eingewilligt worden. Der Abgleich ergab eine Übereinstimmung und einen Score und die Adresse %s.",

      "user.signupCertificate.events.creditCheck.manualapproval.description": "Die Daten zur Prüfung der Zahlungswahrscheinlichkeit wurden manuell bestätigt.",

      "user.signupCertificate.events.creditCheck.plusAddress.description": "Der Verarbeitung der Daten zur Prüfung der Zahlungswahrscheinlichkeit ist eingewilligt worden. Der Abgleich ergab eine Übereinstimmung, einen Score und die Adresse %s.",

      "user.signupCertificate.events.idVerified.description": "Dem Nutzerkonto ist das Ausweisdokument (Typ: %s) mit der Nummer %s hinzugefügt worden.",

      "user.signupCertificate.events.idVerified.plusAddress.description": "Dem Nutzerkonto ist das Ausweisdokument (%s) mit der Dokumenten-Nummer %s und Adresse %s hinzugefügt worden",

      "user.signupCertificate.events.licenseVerified.description": "Dem Nutzerkonto ist der Führerschein mit der Nummer %s hinzugefügt worden.",

      "user.signupCertificate.events.marketingConsentGiven.description": "Die Einwilligung \"Newsletter\" ist erteilt worden.",

      "user.signupCertificate.events.marketingConsentRevoked.description": "Die Einwilligung \"Newsletter\" ist entzogen worden.",

      "user.signupCertificate.events.merchantReferenceAssigned.description": "Dem Nutzerkonto ist im Zuge der Freischaltung die Kunden-Nr %s hinzugefügt worden.",

      "user.signupCertificate.events.phoneVerified.description": "Dem Nutzerkonto ist die Handynummer %s hinzugefügt worden.",

      "user.signupCertificate.events.sepaAdded.description": "Dem Nutzerkonto ist die Zahlungsmethode SEPA %s hinzugefügt und dem Lastschriftmandat zugestimmt worden.",

      "user.signupCertificate.events.sepaAddedWithTrueLayer.description": "Dem Nutzerkonto ist die Zahlungsmethode SEPA-Lastschrift hinzugefügt und dem Lastschriftmandat ist zugestimmt worden. Die Authentifizierung per Online-Banking-Login ergab die IBAN %s, die BIC %s und den/die KontoinhaberIn %s.",

      "user.signupCertificate.events.sepaVerifiedWithBankTransfer.description": "Die Zahlungsart „SEPA-Lastschrift“ mit der IBAN %s, dem BIC %s und dem Kontoinhaber %s wurde per Banküberweisung überprüft.",

      "user.signupCertificate.events.signedUp.description": "Das Nutzerkonto ist als %s %s mit der E-Mail-Adresse %s registriert und den/r zu diesem Zeitpunkt gültigen/r AGB, Datenschutzerklärung und Anmeldegebühr ist zugestimmt worden.",

      "user.signupCertificate.events.tariffSelected.description": "Dem Nutzerkonto ist der Tarif \"%s\" (ohne Reduzierung der Selbstbeteiligung) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelected.descriptionWithServicePackage": "Dem Nutzerkonto ist der Tarif \"%s\" (mit Service-Paket) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelected.descriptionWithUpsellings": "Dem Nutzerkonto ist der Tarif \"%s\" (mit Reduzierung der Selbstbeteiligung) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelected.descriptionWithoutServicePackage": "Dem Nutzerkonto ist der Tarif \"%s\" (ohne Service-Paket) hinzugefügt worden.",

      "user.signupCertificate.events.tariffSelectedFromPartner.description": "Dem Nutzerkonto ist der Tarif \"%s\" (ohne Sicherheitspaket) über das Hauptkonto (Kunden-Nr. %s) zugewiesen.",

      "user.signupCertificate.id.DRIVING_LICENSE": "Führerschein",

      "user.signupCertificate.id.ID_CARD": "Personalausweis",

      "user.signupCertificate.id.PASSPORT": "Reisepass",

      "user.signupCertificate.id.UNSUPPORTED": "Unbekannt",

      "user.signupCertificate.id.VISA": "Aufenthaltstitel",

      "user.signupCertificate.ip": "IP",

      "user.signupCertificate.page": "Seite",

      "user.signupCertificate.pageOf": "von",

      "user.signupCertificate.status": "Status",

      "user.signupCertificate.status.active": "Aktiv",

      "user.signupCertificate.title": "Titel",

      "user.signupCertificate.titleValue": "Nutzerkonto Registrierungsprotokoll",

      "user.signupCertificate.userId": "ID (Nutzer)",

      "user.signupCertificate.userIdentity": "Nutzer-Identität",

      "user.terminate.dialog.message": "Bitte beachten Sie:\n\n1. Die Entfernung Ihres Nutzerkontos kann nicht rückgängig gemacht werden.\n\n2. Sie werden bis auf Weiteres kein neues Nutzerkonto einrichten können. Sollten Sie Unterstützung brauchen, Ihre bestehende Registrierung abzuschließen, kontaktieren Sie uns bitte über das Service-Symbol. Wir helfen gerne weiter!",

      "user.terminate.dialog.no": "Abbrechen",

      "user.terminate.dialog.title": "Nutzerkonto entfernen",

      "user.terminate.dialog.yes": "Jetzt endgültig entfernen",

      "user.transaction.settled.success": "Zahlung wurde erfolgreich abgeschlossen.",

      "usercar.fillprofile.footnote": "Die besten Tipps, um Ihre Mieteinnahmen zu erhöhen, finden Sie in unserem %@.",

      "usercar.fillprofile.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto#mein-autoprofil",

      "usercar.fillprofile.footnote.url.text": "HilfeCenter",

      "usercar.item.blocked.title": "Ihr Auto kann nicht freigegeben werden. Bitte kontaktieren Sie unser Service Team für mehr Infos.",

      "usercar.item.eligible.title": "In Warteschlange",

      "usercar.item.equipment_ready.title": "Installation in Kürze",

      "usercar.item.equipped.title": "Ihr Auto ist ausgerüstet.",

      "usercar.item.listed.title": "Ihr Auto steht auf der Warteliste.",

      "usercar.item.release_ready.title": "Nicht freigegeben",

      "usercar.item.released.title": "Freigegeben bis",

      "usercar.item.selected.title": "Ihr Auto wird in Kürze ausgerüstet.",

      "usercar.item.submitted.description": "Übermittelt am",

      "usercar.item.submitted.title": "Ihr Auto wird geprüft.",

      "usercar.item.terminated.description": "Entfernt am",

      "usercar.item.terminated.title": "Ihr Autoprofil wird entfernt.",

      "usercar.photo.description": "Machen Sie am besten ein Foto von vorne, von der Seite und vom Innenraum.",

      "usercar.profile.blocked.status": "BLOCKIERT",

      "usercar.profile.blocked.title": "Dieses Auto ist aktuell geblockt.",

      "usercar.profile.eligible.description": "Es ist nun in der Warteschlange, um in den Fuhrpark aufgenommen zu werden. Je mehr sich aus Ihrer Nähe anmelden, desto schneller sind Sie dabei. Teilen Sie jetzt Ihren persönlichen Einladungscode mit Ihren Freunden und Nachbarn.",

      "usercar.profile.eligible.status": "IN WARTESCHLANGE",

      "usercar.profile.eligible.title": "Prima %@, Ihr Auto hat alle Tests bestanden 💪",

      "usercar.profile.equipment_ready.description": "Unser Techniker kommt zum vereinbarten Wunschtermin zu der von Ihnen gewählten Adresse. Er wird Sie ca. 30 Minuten vor Terminbeginn anrufen, um den exakten Treffpunkt beim Auto abzusprechen. Bitte haben Sie Ihren Autoschlüssel und Kfz-Schein parat.\n\nBitte gib uns mind. 48 Stunden vorab Bescheid, solltest du den Termin nicht wahrnehmen können, um etwaige Gebühren zu vermeiden.",

      "usercar.profile.equipment_ready.status": "INSTALLATION",

      "usercar.profile.equipment_ready.title": "%@, der Einbautermin für Ihr Auto steht bevor",

      "usercar.profile.equipped.description": "Bitte haben Sie einen Moment Geduld. Sobald die letzten Funktions- und Sicherheitschecks abgeschlossen sind, wird Ihr Auto freigeschaltet.",

      "usercar.profile.equipped.status": "WIRD FREIGESCHALTET",

      "usercar.profile.equipped.title": "%@, in Installation ist abgeschlossen",

      "usercar.profile.firssteps.description": "Um Vermieter zu werden, schließen Sie jetzt bitte die Ersten Schritte ab.",

      "usercar.profile.firssteps.title": "Bitte vervollständigen Sie jetzt Ihre Nutzerangaben",

      "usercar.profile.firststeps.description": "Im Anschluss können wir prüfen, was Ihr Auto für Sie verdienen könnte.",

      "usercar.profile.firststeps.title": "%@, bitte vervollständigen Sie jetzt Ihre https://applink.get-a-way.com/user-challenges-firststeps",

      "usercar.profile.firststeps.title.url": "https://applink.get-a-way.com/user-challenges-firststeps",

      "usercar.profile.firststeps.title.url.text": "Nutzerangaben",

      "usercar.profile.listed.description": "Legen Sie hier fest, wie Mietern Ihr Auto angeboten werden soll. Sie können diese Infos jederzeit anpassen.",

      "usercar.profile.listed.status": "IN PRÜFUNG",

      "usercar.profile.listed.title": "%@, vervollständigen Sie jetzt Ihr Autoprofil",

      "usercar.profile.release.availableuntil": "Jetzt freigeben bis",

      "usercar.profile.release_ready.status": "PRIVAT",

      "usercar.profile.released.availableuntil": "Freigegeben bis",

      "usercar.profile.released.status": "FREIGEGEBEN",

      "usercar.profile.rented.status": "VERMIETET",

      "usercar.profile.selected.description": "Um einfachste Mietabläufe zu gewährleisten und Acht auf Ihr Auto geben zu können, wenn es vermietet wird, rüsten wir es einmalig mit unserem SafetyKit aus. Unser Techniker-Team wird Sie zeitnah kontaktieren, um einen individuellen Einbautermin zu vereinbaren.",

      "usercar.profile.selected.status": "AUSGEWÄHLT",

      "usercar.profile.selected.title": "%@, Ihr Auto kann ausgerüstet werden 🙌",

      "usercar.profile.service.status": "IM SERVICE",

      "usercar.profile.submit.action": "Jetzt prüfen lassen",

      "usercar.profile.submit.description": "Hunderte sind bereits dabei. Lassen Sie jetzt gratis & unverbindlich prüfen, wie viel Ihr Auto für Sie verdienen könnte.",

      "usercar.profile.submit.left": "MEIN AUTO",

      "usercar.profile.submit.status": " ",

      "usercar.profile.submit.title": "erfahren Sie, was Ihr Auto für Sie verdienen könnte!",

      "usercar.profile.submitted.description": "Legen Sie hier fest, wie Mietern Ihr Auto angeboten werden soll. Sie können diese Infos jederzeit anpassen.",

      "usercar.profile.submitted.status": "IN PRÜFUNG",

      "usercar.profile.submitted.title": "%@, vervollständigen Sie jetzt Ihr Autoprofil",

      "usercar.profile.terminated.status": "TERMINATED",

      "usercar.profile.title": "Mein Auto",

      "usercar.review.novalue": "✨ Neues Auto",

      "usercar.troubleshoot": "Störungsbehebung",

      "usercar.troubleshoot.dialog.message": "Als Autobesitzer können Sie jetzt Ihr Auto entriegeln und die Motorsperre aufheben. Ihr Auto ist im Anschluss nicht mehr über GETAWAY gesichert. Wir empfehlen dringend, nur fortzufahren, sofern Sie sich unmittelbar an Ihrem Auto befinden.",

      "usercar.troubleshoot.dialog.title": "Störungsbehebung",

      "usercar.troubleshoot.dialog.unlock": "Auto- und Motorsperre deaktivieren",

      "usercarprofile.example.title": "Was ein Mieter zahlen würde",

      "usercarprofile.price.details.footnote": "Weitere Infos, wie Sie den idealen Preis festlegen, finden Sie in unserem %@.",

      "usercarprofile.price.details.footnote.url": "https://service.get-a-way.com/wie-vermiete-ich-mein-auto/mein-autoprofil/so-legst-du-den-idealen-preis-fur-dein-auto-fest",

      "usercarprofile.price.details.footnote.url.text": "Hilfe-Center",

      "usercarprofile.price.indicator.title": "Sie verdienen",

      "usercarprofile.price.slider.aboveaverage": "überdurchschnittlich",

      "usercarprofile.submit.status": " ",

      "users.merchantSystem.sync": "Sync",

      "validation.accountholder.invalid": "Bitte geben Sie einen gültigen Kontoinhaber an",

      "validation.address.street.invalid": "Bitte gültigen Straßennamen eintragen",

      "validation.address.streetnumber.invalid": "Bitte gültige Hausnummer eintragen",

      "validation.address.zip.invalid": "Bitte gültige Postleitzahl eintragen",

      "validation.email.invalid": "Bitte gültige E-Mail-Adresse eintragen",

      "validation.iban.invalid": "Bitte eine gültige IBAN eintragen",

      "validation.name.invalid": "Mind. zwei Buchstaben",

      "validation.password.invalid": "Mind. 8 Zeichen (inkl. Groß-/ Kleinbuchst./ Ziff./ Sonderz.)",

      "validation.phone.invalid": "Diese Handy-Nummer kann nicht bestätigt werden. Bitte nutzen Sie eine andere.",

      "validation.required": "Bitte ausfüllen.",

      "validation.required.empty": "Dieses Feld darf nicht leer bleiben",

      "validator.name.error": "Ihr Name muss mindestens zwei Buchstaben enthalten.",

      "validator.password.error": "Passwort muss mind. aus 6 Zeichen inklusive einer Ziffer bestehen.",

      "validator.streetNumber.error": "Bitte geben Sie eine gültige Hausnummer an",

      "verify.phone.failed": "Falscher Code",

      "verify.phone.passwordView.description": "Ihre aktuelle Handy-Nummer lautet %@. Bitte geben Sie Ihr Passwort ein.",

      "verify.phone.passwordView.title": "Handy-Nummer ändern",

      "verify.phone.resend.success": "Sie werden in Kürze einen Bestätigungscode per SMS erhalten",

      "verify.phone.success": "Danke, Ihre Handy-Nummer ist erfolgreich aktualisiert worden.",

      "video": "Video",

      "violation.adyenPayByLinkRequest.noError.hasError.assertFalse": "Die Erstellung des Zahlungslinks ist fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support",

      "violation.adyenPaymentProvider.responseValidator.authorized.assertTrue": "Diese Karte kann nicht hinzugefügt werden. Bitte nutzen Sie eine andere Kreditkarte.",

      "violation.adyenPaymentProvider.responseValidator.cvcDeclined.assertFalse": "Ungültige Prüfziffer. Bitte überprüfen Sie Ihre Angaben und versuchen es erneut.",

      "violation.adyenPaymentProvider.responseValidator.noResponse.assertFalse": "Verbindung fehlgeschlagen. Bitte probieren Sie es in wenigen Momenten erneut.",

      "violation.adyenPaymentProvider.responseValidator.notificationSuccess.assertTrue": "Diese Karte kann nicht hinzugefügt werden. Bitte nutzen Sie eine andere Kreditkarte.",

      "violation.apiVersionCheck.version.min": "Ihre App-Version wird nicht mehr unterstützt, bitte updaten Sie diese über den App Store.",

      "violation.booking.bookingPayInAllowedValidator.payInAllowed.assertTrue": "Zahlung per Vorkasse kann nicht verwendet werden, da Sie ein Guthaben auf Ihrem Konto haben. Bitte wenden Sie sich an den Kundendienst, um eine Rückerstattung zu beantragen oder verwenden Sie eine andere Zahlungsmethode.",

      "violation.booking.bookingPaymentValidator.adyenRequestRejected.assertFalse": "Zahlungsanfrage wurde abgelehnt.",

      "violation.booking.bookingPaymentValidator.adyenRequestTimedOut.assertFalse": "Zahlungsanfrage ausgelaufen.",

      "violation.booking.bookingPaymentValidator.blockedPaymentNotNeededOrConfirmed.assertTrue": "Leider wurde die Autorisierung des Sicherheitsbetrages von Ihrer Bank abgelehnt. Bitte versuchen Sie es mit einer anderen Zahlungsmethode.",

      "violation.booking.bookingRequestValidator.canBook.assertTrue": "Leider kannst du dieses Fahrzeug nicht buchen, da du bereits eine Reservierung für diesen Zeitraum hast. Siehe dazu deine Mietvorgänge.",

      "violation.booking.bookingRequestValidator.confirmedCarValid.assertTrue": "Dieses Fahrzeug ist für den gewählten Mietzeitraum leider nicht verfügbar.",

      "violation.booking.bookingRequestValidator.watchlistCheckPassed.assertTrue": "Bitte stellen SIe sicher, dass Ihr Nutzerkonto vollständig ist. Falls Sie Hilfe benötigen, wendes Sie sich bitte an den Kundenservice.",

      "violation.booking.bookingRequestValidator.withinOpeningHours.assertTrue": "Buchung nicht möglich. Abholung und Rückgabe des Fahrzeug sind nur innerhalb der Öffnungszeiten möglich. Die Start- und/oder Endzeit der Buchungsanfrage liegen außerhalb.\n\nBitte versuchen Sie es erneut mit geänderter Start- und/oder Endzeit. Die Zugangszeiten sind dem Fahrzeugprofil unter \"Info\" zu entnehmen.",

      "violation.booking.bookingRequestValidator.youngDriver.assertFalse": "Wir bitten um Geduld. Um Autos bei GETAWAY mieten zu können, muss Ihnen die Führerscheinklasse B vor mehr als zwei Jahren erteilt worden sein. Sie werden bei Erreichen der Frist automatisch freigeschaltet und benachrichtigt.",

      "violation.booking.offerConfirmationValidator.creditworthinessApproved.assertTrue": "Sie haben aktuell keine gültige oder aktive Zahlungsmethode hinterlegt. Bitte prüfen Sie Ihr Nutzerkonto.",

      "violation.booking.offerConfirmationValidator.watchlistCheckPassed.assertTrue": "Ihre Nutzerdaten sind unvollständig. Bitte kontaktieren Sie unser Service Team.",

      "violation.car.chassisNumberUniqueValidator.chassisNumber.assertTrue": "Fahrgestellnummer bereits im System",

      "violation.car.damages.characteristics.notNull": "Bitte spezifizieren Sie die Art des Schadens.",

      "violation.car.damages.component.notNull": "Bitte wählen Sie eine Schadenkomponente aus.",

      "violation.car.damages.where.notNull": "Bitte spezifizieren Sie den Ort des Schadens am Auto.",

      "violation.car.generateOwnerAccessToken.rented.assertFalse": "Das Auto kann während eines laufenden Mietvorgangs nicht geöffnet werden.",

      "violation.car.onlineCheck.online.assertTrue": "Das Auto scheint sich in einem Funkloch zu befinden. Bitte probieren Sie es an einer anderen Position erneut oder kontaktieren unser Service Team.",

      "violation.car.owner.notNull": "Das Auto muss einem Besitzer zugeordnet sein.",

      "violation.car.plateUniqueValidator.plate.assertTrue": "Autokennzeichen bereits im System",

      "violation.car.registrationCertificate.plate.pattern": "Bitte geben Sie ein gültiges Kfz-Kennzeichen an.",

      "violation.car.registrationCertificate.plate.plateRegion": "Die Region des eingegebenen Kfz-Kennzeichens ist unbekannt.",

      "violation.car.releaseCheck.availableUntil.assertTrue": "Zu kurz. Bitte wählen Sie einen Freigabezeitraum von mindestens 90 Minuten.",

      "violation.car.releaseCheck.basicPrice.notNull": "Um Ihr Auto freizugeben, legen Sie jetzt Ihren Verdienst pro Kilometer fest.",

      "violation.car.releaseCheck.doorsClosed.assertTrue": "Bitte verschließen Sie alle Türen, um fortzufahren.",

      "violation.car.releaseCheck.fuelCardIn.assertTrue": "Bitte legen Sie die Tankkarte in das dafür vorgesehene Fach, um fortzufahren.",

      "violation.car.releaseCheck.fuelLevel.min": "Der Tankstand muss mindestens 25% betragen, um das Auto freigeben zu können.",

      "violation.car.releaseCheck.ignitionOff.assertTrue": "Bitte schalten Sie die Zündung aus, um fortzufahren.",

      "violation.car.releaseCheck.keyFobIn.assertTrue": "Bitte legen Sie den Schlüssel in das dafür vorgesehene Fach, um fortzufahren.",

      "violation.car.releaseCheck.online.assertTrue": "Das Auto scheint sich in einem Funkloch zu befinden. Bitte probieren Sie es an einer anderen Position erneut oder kontaktieren unser Service Team.",

      "violation.car.releaseCheck.paymentMethodExists.assertTrue": "Bitte hinterlegen Sie eine gültige Zahlungsmethode.",

      "violation.car.releaseCheck.windowsClosed.assertTrue": "Bitte verschließen Sie alle Fenster, um fortzufahren.",

      "violation.clientVersionCheck.version.min": "Ihre App-Version wird nicht mehr unterstützt, bitte updaten Sie diese über den App Store.",

      "violation.device.alreadyPairedValidator.device.assertTrue": "Ihr Nutzerkonto ist nicht mit diesem Smartphone verbunden. Bitte kontaktieren Sie unser Service Team, um fortzufahren.",

      "violation.driversLicenseTokenData.validation.validToken.assertTrue": "Ihre Sitzung ist ungültig bzw. abgelaufen. Bitte versuchen Sie es erneut.",

      "violation.fleetAdmin.validPasswordValidator.password.assertTrue": "Bitte tragen Sie ein gültiges Passwort ein (mind. 6 Zeichen, inkl. mind. einer Ziffer)",

      "violation.forgotPasswordResource.resetPasswordCheck.validToken.assertTrue": "Dieser Link ist nicht mehr aktuell. Bitte kontaktieren Sie unser Service Team für weitere Infos.",

      "violation.installation.mechanic.notNull": "Die Installation muss einem registrierten Techniker zugeordnet werden.",

      "violation.paymentMethod.existingPaymentMethod.isBlocked.assertFalse": "Das Zahlungsmittel kann nicht hinzugefügt werden. Bitte verwenden Sie ein anderes Zahlungsmittel.",

      "violation.paymentResource.paymentMethodTypeCheck.paymentMethodNotAllowed.assertFalse": "Das Zahlungsmittel kann nicht hinzugefügt werden. Bitte verwenden Sie ein anderes Zahlungsmittel.",

      "violation.paymentResource.paymentMethodTypeCheck.tariffMissing.assertFalse": "Sie müssen einen Tarif auswählen bevor Sie eine Zahlungsmethode hinzufügen können.",

      "violation.phoneNumber.noNewNumberWhenPairedValidator.phoneNumber.assertTrue": "Nicht möglich. Dein Nutzerkonto ist mit diesem Smartphone verbunden. Bitte kontaktiere unser Service Team, um fortzufahren.",

      "violation.phoneNumber.userPhoneNumberUniqueValidator.phoneNumber.assertTrue": "Diese Handynummer ist ungültig oder bereits einem aktivem Nutzerkonto hinterlegt. Bitte verwende eine andere oder melde dich mit dem bestehenden Nutzerkonto an.	",

      "violation.phoneNumber.userPhoneNumberUniqueValidator.phoneNumberInactive.assertTrue": "Diese Handynummer wurde bereits einem Nutzerkonto zugeordnet. Bitte wende Sie sich an den Support, um fortzufahren.",

      "violation.phoneNumber.validPhoneNumberValidator.phoneNumber.assertTrue": "Ungültiger Code! Bitte stellen Sie sicher, dass Sie die richtige Handynummer angegeben haben oder fordern Sie einen neuen Code an.",

      "violation.phoneNumber.validPhoneNumberValidator.smsLimitExceeded.assertFalse": "Telefon-Verifizierungsversuche überschritten.",

      "violation.phoneNumber.validVerificationCodeValidator.phoneNumber.assertTrue": "Bitte geben Sie den richtigen Bestätigungscode ein",

      "violation.rentalResource.serviceTripCheck.userUnauthorized.assertFalse": "Tut mir leid, du darfst leider keinen ServiceTrip durchführen. Bitte starte eine reguläre Miete.",

      "violation.sepa.ibanValidator.sepa.assertTrue": "Bitte geben Sie eine gültige IBAN ein.",

      "violation.serviceCircle.serviceCircleValidator.pricingEmpty.assertTrue": "Die Änderung von Preisen für Service UserGroups wird nicht unterstützt",

      "violation.trip.cancellation.reserved.assertTrue": "Nur gültige Reservierungen können zurückgenommen werden.",

      "violation.trip.driverQualificationValidator.addressVerified.assertTrue": "Bitte hinterlegen Sie Ihre Meldeadresse, um fortzufahren.",

      "violation.trip.driverQualificationValidator.creditCheck.assertTrue": "Ihre Nutzerdaten sind unvollständig. Bitte kontaktieren Sie unser Service Team.",

      "violation.trip.driverQualificationValidator.identityChecked.assertTrue": "Ihre Nutzerdaten sind unvollständig. Bitte kontaktieren Sie unser Service Team.",

      "violation.trip.driverQualificationValidator.paymentMethodExists.assertTrue": "Bitte hinterlegen Sie eine gültige Zahlungsmethode, um fortzufahren.",

      "violation.trip.driverQualificationValidator.phoneNumberVerified.assertTrue": "Bitte verifizieren Sie Ihre Handy-Nummer auf diesem Gerät, um fortzufahren.",

      "violation.trip.driverQualificationValidator.positiveBalance.assertTrue": "Bitte stellen Sie sicher, dass Ihr Guthaben positiv ist, um fortzufahren.",

      "violation.trip.driverQualificationValidator.validLicence.assertTrue": "Um Autos zu mieten, muss Ihr Führerschein verifiziert worden sein. Den aktuellen Status können Sie in Ihrem Nutzerprofil einsehen.",

      "violation.trip.finishCheck.bitLessFuelOnReturn.assertFalse": "Tank-Service (2,80 €/Liter) wählen",

      "violation.trip.finishCheck.correctLocation.assertTrue": "Bitte beenden Sie die Miete im Umkreis des angegebenen Rückgabeorts. Andernfalls können Gebühren anfallen.",

      "violation.trip.finishCheck.endCheckImagesUploaded.assertTrue": "Ihre Rundumfotos sind noch nicht bei uns eingegangen. Bitte überprüfen Sie Ihre Verbindung und wischen Sie erneut, um den Vorgang abzuschließen.",

      "violation.trip.finishCheck.extremelyLowFuelLevel.assertFalse": "Ich wähle den Tank-Service  <10% (50,- €)",

      "violation.trip.finishCheck.finishLocationAllowed.assertTrue": "Ich habe das Fahrzeug zurückgebracht",

      "violation.trip.finishCheck.fuelLevel.min": "Ich wähle den Tank-Service (5 €)",

      "violation.trip.finishCheck.fuelLevelOBI.min": "Ich wähle den Tank-Service (15 €)",

      "violation.trip.finishCheck.initialUnlockIsSet.assertTrue": "Das Auto muss initial geöffnet worden sein, um den Mietvorgang beenden zu können.",

      "violation.trip.finishCheck.insideArea.assertTrue": "Ich wähle den Rückbringservice (10€ + 4.9€/km)",

      "violation.trip.finishCheck.keyFobIn.assertTrue": "Die Miete kann nur beendet werden, wenn der Schlüssel korrekt in der Halterung im Handschuhfach hinterlegt ist (neben der Tankkarte). Bitte prüfe dies und versuche es dann erneut.",

      "violation.trip.finishCheck.online.assertTrue": "Es konnte leider keine Verbindung zum Fahrzeug hergestellt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support.",

      "violation.trip.finishCheck.openDamageReport.assertFalse": "Sie haben einen offenen Schaden. Bitte prüfen Sie Ihre SMS, um den Schadensbericht auszufüllen.",

      "violation.trip.finishCheck.payAsReserved.assertFalse": "Ich beende meine Miete vorzeitig.",

      "violation.trip.postReservation.accessToken.assertTrue": "Das Fahrzeug kann zum jetzigen Zeitpunkt nicht reserviert werden.",

      "violation.trip.postReservation.accessToken.notNull": "Ups..etwas ist schief gelaufen. Bitte probieren Sie es gleich noch einmal.",

      "violation.trip.postReservation.adyenRequestRejected.assertFalse": "Zahlungsanfrage wurde abgelehnt.",

      "violation.trip.postReservation.adyenRequestTimedOut.assertFalse": "Zahlungsanfrage ausgelaufen.",

      "violation.trip.postReservation.blockedPaymentConfirmed.assertTrue": "Ihre Bank hat diese Transaktion abgelehnt. Bitte kontaktieren Sie Ihre Bank für weitere Informationen oder versuchen Sie es mit einem anderen Zahlungsmittel.",

      "violation.trip.rating.onlyFinished": "Der Mietvorgang muss erfolgreich beendet worden sein, um diesen bewerten zu können.",

      "violation.trip.rentalReservationValidator.addressVerified.assertTrue": "Bitte hinterlegen Sie Ihre Meldeadresse, um fortzufahren.",

      "violation.trip.rentalReservationValidator.backByConflictsWithBooking.assertFalse": "Dieses Fahrzeug ist für den gewählten Zeitraum bereits reserviert. Bitte wähle ein anderes Fahrzeug oder eine andere Zeit.",

      "violation.trip.rentalReservationValidator.blockedByUpcomingBooking.assertFalse": "Dieses Fahrzeug ist bereits reserviert, bitte wähle ein anderes.",

      "violation.trip.rentalReservationValidator.carAvailable.assertTrue": "Dieses Auto ist nicht mehr verfügbar. Bitte wählen Sie ein anderes.",

      "violation.trip.rentalReservationValidator.carStatusReleased.assertTrue": "Dieses Auto ist nicht mehr verfügbar. Bitte wählen Sie ein anderes.",

      "violation.trip.rentalReservationValidator.creditworthinessApproved.assertTrue": "Ihre Nutzerdaten sind unvollständig. Bitte kontaktieren Sie unser Service Team.",

      "violation.trip.rentalReservationValidator.identityChecked.assertTrue": "Ihre Angaben zu Name, Geburtsdatum und Meldeadresse konnten nicht bestätigt werden. Bitte kontaktieren Sie uns über das LiveChat-Symbol oben rechts, um Ihre Verifizierung abzuschließen.",

      "violation.trip.rentalReservationValidator.online.assertTrue": "Das Fahrzeug ist aktuell nicht verfügbar und kann daher nicht gemietet werden.",

      "violation.trip.rentalReservationValidator.paymentMethodExists.assertTrue": "Bitte hinterlegen Sie eine gültige Zahlungsmethode, um fortzufahren.",

      "violation.trip.rentalReservationValidator.phoneNumberVerified.assertTrue": "Es kann keine Reservierung angelegt werden, solange keine Telefonnummer verifiziert ist. Bitte hinterlege eine Telefonnummer in deinem Nutzerkonto und versuche es erneut.",

      "violation.trip.rentalReservationValidator.positiveBalance.assertTrue": "Bitte stellen Sie sicher, dass Ihr Guthaben positiv ist, um fortzufahren.",

      "violation.trip.rentalReservationValidator.serviceTripAllowed.assertTrue": "Dieses Fahrzeug kann mit Ihrem Nuterkonto nicht für Service-Fahrten gemietet werden.",

      "violation.trip.rentalReservationValidator.userMarkedForFraud.assertFalse": "😐 Leider ist diese Aktion momentan nicht möglich. Für weitere Informationen kontaktieren Sie bitte unser Service Team.",

      "violation.trip.rentalReservationValidator.userMarkedForFraud.assertTrue": "😐 Leider ist diese Aktion momentan nicht möglich. Für weitere Informationen kontaktieren Sie bitte unser ServiceTeam.",

      "violation.trip.rentalReservationValidator.validLicence.assertTrue": "Um Autos zu mieten, muss Ihr Führerschein verifiziert worden sein. Den aktuellen Status können Sie in Ihrem Nutzerprofil einsehen.",

      "violation.trip.rentalReservationValidator.watchlistCheckPassed": "Bitte stellen Sie sicher, dass Ihr Nutzerkonto vollständig ist. Wenn Sie Hilfe benötigen, kontaktieren Sie gern unseren Kundenservice.",

      "violation.trip.rentalReservationValidator.withinOpeningHours.assertTrue": "Miete nicht möglich. Start- und/oder Endzeit der Buchungsfrage liegen außerhalb der Öffnungszeiten.",

      "violation.trip.rentalReservationValidator.youngDriver.assertFalse": "Wir bitten um Geduld. Um Autos bei GETAWAY mieten zu können, muss Ihnen die Führerscheinklasse B vor mehr als zwei Jahren erteilt worden sein. Sie werden bei Erreichen der Frist automatisch freigeschaltet und benachrichtigt.",

      "violation.trip.reservationValidator.manualGearRestricted.assertFalse": "Ihre Fahrerlaubnis erstreckt sich nicht für Autos mit manueller Schaltung! Bitte wählen Sie ein anderes.",

      "violation.user.account.paymentMethods.sepa.ibanValid": "Bitte geben Sie eine gültige IBAN ein.",

      "violation.user.archiveCheck.hasOpenBookingRequests.assertFalse": "Es scheint als hätten Sie noch offene Rechnungen bei uns. Bitte kontaktieren Sie einmal unser Service Team für weitere Informationen und um fortzufahren.",

      "violation.user.archiveCheck.hasOpenTransactions.assertFalse": "Kann nicht fortgesetzt werden, da entweder eine offene oder eine nicht beglichene Rechnung vorliegt. Bitte versuchen Sie es später erneut, da dies von der Bestätigung der Zahlung durch die Bank abhängig ist.",

      "violation.user.dateOfBirth.min": "Um ein Fahrzeug mieten zu können, müssen Sie mindestens 2 Jahre lang im Besitz eines gültigen Führerscheins der Klasse B sein.",

      "violation.user.device.alreadyPaired": "Ihr Nutzerkonto ist nicht mit diesem Smartphone verbunden. Bitte kontaktieren Sie unser Service Team, um fortzufahren.",

      "violation.user.email.notNull": "Bitte hinterlegen Sie in Ihrem Nutzerkonto eine gültige E-Mail Adresse.",

      "violation.user.email.pattern": "Bitte hinterlegen Sie in Ihrem Nutzerkonto eine gültige E-Mail Adresse.",

      "violation.user.email.userEmail.Unique": "Es scheint, als sei Ihre E-Mail Adresse bereits hinterlegt. Möchten Sie Ihr Passwort zurücksetzen?",

      "violation.user.email.userEmailUnique": "Es scheint, als sei Ihre E-Mail Adresse bereits hinterlegt. Möchten Sie Ihr Passwort zurücksetzen?",

      "violation.user.emailVerificationCheck.codeNotMatches.assertFalse": "Verifizierungs-Code stimmt nicht überein",

      "violation.user.emailVerificationCheck.codeWasNotGenerated.assertFalse": "Derzeit keine ausstehende E-Mail-Verifizierung.",

      "violation.user.emailVerificationCheck.maxVerificationAttemptsPassed.assertFalse": "Maximale Anzahl an Versuchen überschritten. Bitte kontaktieren Sie unser Service Team.",

      "violation.user.firstName.notNull": "Bitte hinterlegen Sie in Ihrem Nutzerkonto einen gültigen Vornamen.",

      "violation.user.firstName.size": "Bitte hinterlegen Sie in Ihrem Nutzerkonto einen gültigen Vornamen.",

      "violation.user.lastName.size": "Ihr Nachname muss aus mind. 2 Buchstaben bestehen.",

      "violation.user.password.validPassword": "Bitte tragen Sie ein gültiges Passwort ein (mind. 6 Zeichen, inkl. mind. einer Ziffer)",

      "violation.user.phoneNumber.phoneNumber.noNewNumberWhenPaired": "Nicht möglich. Ihr Nutzerkonto ist mit diesem Smartphone verbunden. Bitte kontaktieren Sie unser Service Team, um fortzufahren.",

      "violation.user.phoneNumber.phoneNumber.validVerificationCode": "Ungültiger Code! Bitte stellen Sie sicher, dass Sie die richtige Handynummer angegeben haben oder fordern Sie einen neuen Code an.",

      "violation.user.phoneNumber.userPhoneNumberUnique": "Diese Handynummer kann nicht hinterlegt werden. Bitte probieren Sie eine andere.",

      "violation.user.phoneNumber.validPhoneNumber": "Bitte hinterlegen Sie in Ihrem Nutzerkonto eine gültige Handynummer.",

      "violation.user.phoneNumber.validVerificationCode": "Dieser Bestätigungscode ist ungültig. Bitte fordern Sie einen neuen an.",

      "violation.user.referredBy.referralCodeExists": "Dieser Einladungscode ist ungültig.",

      "violation.user.requireDevice.hasPairedDevice.assertTrue": "Bitte verifizieren Sie Ihre Handynummer auf diesem Smartphone, um fortzufahren.",

      "violation.user.requireDevice.isCorrectDevice.assertTrue": "Dieses Handy ist nicht autorisiert für diese Interaktion. Bitte kontaktieren Sie unser Service Team.",

      "violation.user.sendVerificationCodeCheck.smsLimitExceeded.assertFalse": "Telefon-Verifizierungsversuche überschritten.",

      "violation.user.userEmailUniqueValidator.email.assertTrue": "Es scheint, als sei Ihre E-Mail Adresse bereits hinterlegt. Möchten Sie Ihr Passwort zurücksetzen?",

      "violation.user.userEmailUniqueValidator.emailInactive.assertTrue": "Diese E-Mail wurde bereits einem Nutzerkonto zugeordnet. Bitte wende dich an den Support, um fortzufahren.",

      "violation.user.validPasswordValidator.password.assertTrue": "Bitte tragen Sie ein gültiges Passwort ein (mind. 6 Zeichen, inkl. mind. einer Ziffer)",

      "violation.validatePaymentMethods.haveBlockedPaymentIfPayInOnly": "bitte wählest du den Zeitrahmen für die Reservierung.",

      "violation.validatePaymentMethods.haveBlockedPaymentIfPayInOnly.assertTrue": "bitte wählest du den Zeitrahmen für die Reservierung.",

      "wait": "Einen Augenblick bitte..",

      "web.copy": "kopieren",

      "web.edit": "ändern",

      "web.external.browser.title": "Bitte fahren Sie in einem (anderen) Web-Browser fort.",

      "web.external.button.section": "Klicken Sie auf folgenden Button",

      "web.external.button.title": "Registrierung im Browser fortfahren",

      "web.external.email.section": "Schauen Sie bitte in Ihr E-Mail-Postfach",

      "web.external.email.section.desc": "Klicken Sie auf den Button in der E-Mail, die wir Ihnen soeben an diese Adresse gesendet haben:",

      "web.external.ignore.link": "Ignorieren & fortfahren",

      "web.external.link.section": "Oder",

      "web.external.link.section.desc": "Kopieren Sie folgenden Link und öffnen diesen in einem (anderen) Web-Browser.",

      "whatsapp": "LiveChat (Whatsapp)",

      "wj.copy.no": "Abbrechen",

      "wj.copy.title": "In Zwischenablage speichern",

      "wj.copy.yes": "Kopieren",

      "wj.email.code.placeholder": "4-stelligen Code eingeben",

      "wj.email.verify.desc": "Geben Sie den Code ein, den wir soeben an diese E-Mail-Adresse gesendet haben:",

      "wj.email.verify.title": "E-Mail bestätigen",

      "wj.link.copied": "In die Zwischenablage kopiert",

      "wj.map.filter.violation.duration": "Zeitraum muss min. 1 Stunde betragen.",

      "wj.map.filter.violation.min": "Stellen Sie sicher, dass die angegebenen Daten korrekt sind.",

      "wj.map.filter.violation.order": "Stelle sicher, dass die angegebenen Daten korrekt sind.",

      "wj.map.filter.violation.period": "Buchung muss kürzer sein",

      "wj.phone.code.placeholder": "4-stelligen SMS-Code eingeben",

      "wj.phone.verify.code.desc": "Geben Sie den Code ein, den wir soeben per SMS an diese Handy-Nr gesendet haben:",

      "wj.phone.verify.code.title": "SMS-Code eingeben",

      "wj.pin.desc": " ",

      "wj.pin.placeholder": "4-stelligen PIN eingeben",

      "wj.pin.title": "Zugangsdaten",

      "wj.schufa.birthday.violation.max": "Prüfen Sie, ob das Datum korrekt ist.",

      "wj.schufa.birthday.violation.min": "Prüfen Sie, ob das Datum korrekt ist.",

      "wj.upload": "Bild hochladen",

      "wj.value.copied": "In die Zwischenablage kopiert: %s",

      "wma.trackingPage.extendedArea.name": "Anfahrt, erweitertes Gebiet",

      "yes": "Ja",

      "yesterday": "gestern",

    },
};